// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.uil = bgl.uil || {};

bgl.uil.tabs = (function() {
    let buttons = [];
    let content = [];

    function init(element) {
        const tabs = document.getElementById(element);

        buttons = [...tabs.querySelectorAll('[data-tab-button]')];
        content = [...tabs.querySelectorAll('[data-tab-content]')];

        buttons.forEach((button) => {
            button.addEventListener('click', (event) => {
                clickTab(event);
            });
        });
    }

    function clickTab(event) {
        buttons.forEach((button) => {
            button.setAttribute('aria-selected', 'false');
        });

        event.currentTarget.setAttribute('aria-selected', 'true');

        content.forEach((contentItem) => {
            if (contentItem.hasAttribute('aria-hidden')) {
                contentItem.setAttribute('aria-hidden', 'true');
            } else {
                contentItem.classList.add('hide--desktop-only');
            }
        });

        const currentTargetId = `${event.currentTarget.getAttribute('aria-controls')}`;
        const selectedContent = document.getElementById(currentTargetId);

        if (selectedContent.hasAttribute('aria-hidden')) {
            selectedContent.setAttribute('aria-hidden', 'false');
        } else {
            selectedContent.classList.remove('hide--desktop-only');
        }
    }

    return {
        init: init,
        clickTab: clickTab,
    };
})();
// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.uil = bgl.uil || {};

bgl.uil.table = (() => {
    let table;
    let buttons;
    let checkboxes;
    let isAnnual = false;
    let isAnyCheckboxChecked = false;
    let buildYourOwnAnnual = 0.00;
    let buildYourOwnDeposit = 0.00;
    let buildYourOwnInstalment = 0.00;
    let buildYourOwnTotalPayable = 0.00;

    function init() {
        table = document.querySelector('[data-uil-table]');
        buttons = table.querySelectorAll('[data-tier-select-btn]');
        checkboxes = [...table.querySelectorAll('[data-checkbox]')];
        isAnnual = document.getElementById('IsAnnual').value == 'True';
        const includedAsStandardTier = table.querySelector('[data-included]');

        if (sessionStorage.getItem('IsBuildYourOwn') === null) {
            sessionStorage.setItem('IsBuildYourOwn', 'false');
        }

        checkboxes.forEach((checkbox) => {
            const checkboxId = checkbox.id;
            const checkLabel = document.querySelector(`[data-label="${checkboxId}"]`);

            if (checkbox.checked) {
                sessionStorage.setItem('IsBuildYourOwn', 'true');
                isAnyCheckboxChecked = true;
            }

            checkbox.addEventListener('change', () => {
                if (!document.querySelector('[data-build-table-add-product]').classList.contains('hide')) {
                    document.querySelector('[data-build-table-add-product]').classList.add('hide');
                    document.querySelector('[data-build-table-pricing]').classList.remove('hide');
                };

                if (checkbox.checked) {
                    sessionStorage.setItem('IsBuildYourOwn', 'true');
                    setSessionStorageList(checkbox);
                    checkLabel.innerText = 'Remove';

                    if (!document.querySelector('[data-tier="Build"]').hasAttribute('data-active-col')) {
                        deselectAll();
                    }
                    selectTier(checkbox.getAttribute('data-tier'));

                    document.querySelector('[data-build-table-add-product]').classList.add('hide');
                    document.querySelector('[data-build-table-pricing]').classList.remove('hide');

                    if (isAnnual) {
                        buildYourOwnAnnual += parseFloat(checkbox.getAttribute('data-annual-amount'));

                        document.querySelector('[data-build-table-annual-price]')
                            .innerText = `${buildYourOwnAnnual.toFixed(2)} /year`;
                    } else {
                        buildYourOwnDeposit += parseFloat(
                            checkbox.getAttribute('data-monthly-deposit-amount'));
                        buildYourOwnInstalment += parseFloat(
                            checkbox.getAttribute('data-monthly-instalment-amount'));
                        buildYourOwnTotalPayable += parseFloat(
                            checkbox.getAttribute('data-monthly-total-payable-amount'));

                        updateBuildYourOwnTotalsContent(checkbox);
                    }
                } else {
                    checkLabel.innerText = 'Add';
                    removeFromSessionStorage(checkbox);
                    if (!isCheckboxChecked()) {
                        deselectAll();
                        checkLabel.innerText = 'Add';

                        if (includedAsStandardTier.getAttribute('data-included').toLowerCase() === 'true') {
                            selectTier(includedAsStandardTier.getAttribute('data-tier'));
                        }

                        sessionStorage.setItem('IsBuildYourOwn', 'false');
                    }

                    if (isAnnual) {
                        const annualAmount = parseFloat(checkbox.getAttribute('data-annual-amount'));
                        buildYourOwnAnnual -= annualAmount;

                        document.querySelector('[data-build-table-annual-price]')
                            .innerText = `${buildYourOwnAnnual.toFixed(2)} /year`;
                    } else {
                        buildYourOwnDeposit -= parseFloat(
                            checkbox.getAttribute('data-monthly-deposit-amount'));
                        buildYourOwnInstalment -= parseFloat(
                            checkbox.getAttribute('data-monthly-instalment-amount'));
                        buildYourOwnTotalPayable -= parseFloat(
                            checkbox.getAttribute('data-monthly-total-payable-amount'));

                        updateBuildYourOwnTotalsContent(checkbox);
                    }
                }
            });
        });

        buttons.forEach((button) => {
            button.addEventListener('click', () => {
                if (button.hasAttribute('data-active-button')) {
                    const includedAsStandardTier = document.querySelector('[data-included]');

                    deselectAll();

                    if (includedAsStandardTier.getAttribute('data-included').toLowerCase() === 'true') {
                        selectTier(includedAsStandardTier.getAttribute('data-tier'));
                    }
                } else {
                    deselectAll();

                    selectTier(button.getAttribute('data-tier'));
                    buildYourOwnAnnual = buildYourOwnDeposit = buildYourOwnInstalment = buildYourOwnTotalPayable = 0.00;
                }
            });
        });

        if (isAnyCheckboxChecked) {
            const checkedCheckboxes = checkboxes.filter((checkbox) => checkbox.checked);

            checkedCheckboxes.forEach((checkbox) => {
                if (isAnnual) {
                    buildYourOwnAnnual += parseFloat(checkbox.getAttribute('data-annual-amount'));

                    document.querySelector('[data-build-table-annual-price]')
                        .innerText = `${buildYourOwnAnnual.toFixed(2)} /year`;
                } else {
                    buildYourOwnDeposit = parseFloat(
                        checkbox.getAttribute('data-monthly-deposit-amount'));
                    buildYourOwnInstalment = parseFloat(
                        checkbox.getAttribute('data-monthly-instalment-amount'));
                    buildYourOwnTotalPayable = parseFloat(
                        checkbox.getAttribute('data-monthly-total-payable-amount'));

                    updateBuildYourOwnTotalsContent(checkbox);
                }
            });
        } else {
            sessionStorage.setItem('IsBuildYourOwn', 'false');
            const activeCol = table.querySelectorAll('[data-active-col][data-tier="Build"]');
            removeActiveCol(activeCol);
            setDefaultBuildYourOwnPricingHeaderContent();

            const activeElements = table.querySelectorAll('[data-active-col]');
            if (activeElements.length == 0 &&
                includedAsStandardTier.getAttribute('data-included').toLowerCase() === 'true') {
                deselectAll();
                selectTier(includedAsStandardTier.getAttribute('data-tier'));
            }
        }
    }

    function isCheckboxChecked() {
        for (let i = 0; i < checkboxes.length; i++) {
            const checkbox = checkboxes[i];
            if (checkbox.checked) {
                return true;
            }
        }
        return false;
    }

    function deselectAll() {
        const activeCol = table.querySelectorAll('[data-active-col]');
        const activeButton = table.querySelector('[data-active-button]');
        const activeBuildYourOwn = document.querySelector('[data-tier="Build"]').hasAttribute('data-active-col');

        checkboxes.forEach((checkbox) => {
            if (checkbox.checked && activeBuildYourOwn) {
                const checkboxId = checkbox.id;
                const checkLabel = document.querySelector(`[data-label="${checkboxId}"]`);
                checkbox.checked = false;
                if (sessionStorage.getItem('buildYourOwnList') != null) {
                    removeFromSessionStorage(checkbox);
                }
                sessionStorage.setItem('IsBuildYourOwn', 'false');
                checkLabel.innerText = 'Add';
            }
        });
        if (activeButton != null) {
            removeActiveButton(activeButton);
        }

        if (activeCol != null) {
            removeActiveCol(activeCol);
        }

        setDefaultBuildYourOwnPricingHeaderContent();
    }

    function setDefaultBuildYourOwnPricingHeaderContent() {
        document.querySelector('[data-build-table-add-product]').classList.remove('hide');
        document.querySelector('[data-build-table-pricing]').classList.add('hide');
    }

    function removeActiveCol(activeCol) {
        activeCol.forEach((column) => {
            column.removeAttribute('data-active-col');
            column.classList.remove('uil-table__head--active');
            column.classList.remove('uil-table__data--active');
            column.classList.remove('uil-table__foot--active');
            column.classList.remove('uil-table__heading--active');
        });
    }

    function removeActiveButton(activeButton) {
        const activeButtonIcon = activeButton.querySelector('[data-button-icon]');
        const activeButtonText = activeButton.querySelector('[data-button-text]');

        activeButton.removeAttribute('data-active-button');
        activeButtonIcon.classList.add('hide');
        activeButtonText.innerText = 'Select';
    }

    function selectTier(dataTier) {
        const correctTiers = table.querySelectorAll(`[data-tier="${dataTier}"]`);
        correctTiers.forEach((element) => {
            switch (element.tagName.toLowerCase()) {
            case 'th':
                element.classList.add('uil-table__head--active');
                element.setAttribute('data-active-col', '');
                break;
            case 'td':
                if (element.getAttribute('data-id') === 'tableFooter') {
                    element.classList.add('uil-table__foot--active');
                    element.setAttribute('data-active-col', '');
                } else {
                    element.classList.add('uil-table__data--active');
                    element.setAttribute('data-active-col', '');
                }
                break;
            case 'button':
                element.querySelector('.uil-btn__icon').classList.remove('hide');
                element.querySelector('[data-button-text]').innerText = 'Remove';
                element.setAttribute('data-active-button', '');
                break;
            case 'h3':
                element.classList.add('uil-table__heading--active');
                element.setAttribute('data-active-col', '');
                break;
            default:
                break;
            }
        });
    }

    function setSessionStorageList(checkbox) {
        if (sessionStorage.getItem('buildYourOwnList') === null) {
            sessionStorage.setItem('buildYourOwnList', JSON.stringify([checkbox.id]));
        } else {
            const listOfAddons = JSON.parse(sessionStorage.getItem('buildYourOwnList'));
            if (!isThisInBuildYourOwn(checkbox.id)) {
                listOfAddons.push(checkbox.id);
                sessionStorage.setItem('buildYourOwnList', JSON.stringify(listOfAddons));
            }
        }
    }

    function removeFromSessionStorage(checkbox) {
        const listOfAddons = JSON.parse(sessionStorage.getItem('buildYourOwnList'));
        const index = listOfAddons.indexOf(checkbox.id);
        listOfAddons.splice(index, 1);
        sessionStorage.setItem('buildYourOwnList', JSON.stringify(listOfAddons));
    }

    function isThisInBuildYourOwn(checkboxId) {
        const listOfAddons = JSON.parse(sessionStorage.getItem('buildYourOwnList'));

        return listOfAddons.includes(checkboxId);
    }

    function updateBuildYourOwnTotalsContent(checkbox) {
        const numberOfInstalments = checkbox.getAttribute('data-monthly-number-of-instalments');
        document.querySelector('[data-build-deposit]')
            .innerText = `${buildYourOwnDeposit.toFixed(2)}`;
        document.querySelector('[data-build-instalment-amount]')
            .innerText = `${buildYourOwnInstalment.toFixed(2)}`;
        document.querySelector('[data-build-number-of-instalments]')
            .innerText = `x ${numberOfInstalments} months`;
        document.querySelector('[data-build-total-payable]')
            .innerText = `${buildYourOwnTotalPayable.toFixed(2)}`;
    }

    return {
        init: init,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.common = bgl.common || {};

bgl.uil.imageslideshow = (function() {
    document.addEventListener('DOMContentLoaded', () => {
        const slides = document.querySelectorAll('.slider__slide');
        const dots = document.querySelectorAll('.slider__dot');
        const pauseToggle = document.getElementById('pause');

        let currentSlide = 0;
        let intervalId = null;

        const goToSlide = (index) => {
            slides.forEach((slide, i) => {
                slide.classList.toggle('is-active', i === index);
            });

            dots.forEach((dot, i) => {
                dot.classList.toggle('active', i === index);
                dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
            });

            currentSlide = index;
        };

        const nextSlide = () => {
            const nextIndex = (currentSlide + 1) % slides.length;
            goToSlide(nextIndex);
        };

        const startAutoplay = () => {
            if (!intervalId) {
                intervalId = setInterval(nextSlide, 5000);
            }
        };

        const stopAutoplay = () => {
            clearInterval(intervalId);
            intervalId = null;
        };

        if (pauseToggle) {
            pauseToggle.addEventListener('change', () => {
                if (pauseToggle.checked) {
                    stopAutoplay();
                } else {
                    startAutoplay();
                }
            });
        }

        dots.forEach((dot, index) => {
            dot.addEventListener('click', (e) => {
                e.preventDefault();
                stopAutoplay();
                pauseToggle.checked = true;
                goToSlide(index);
            });
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') {
                stopAutoplay();
                pauseToggle.checked = true;
                goToSlide((currentSlide + 1) % slides.length);
            } else if (e.key === 'ArrowLeft') {
                stopAutoplay();
                pauseToggle.checked = true;
                goToSlide((currentSlide - 1 + slides.length) % slides.length);
            }
        });

        goToSlide(0);
        startAutoplay();
    });
})();
// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.uil = bgl.uil || {};

bgl.uil.datepicker = (() => {
    function init() {
        const datepicker = document.querySelector('[data-datepicker]');

        datepicker.addEventListener('blur', () => {
            if (!datepicker.checkValidity()) {
                datepicker.classList.add('error');
            } else {
                datepicker.classList.remove('error');
            }
        });
    };

    return {
        init: init,
    };
})();
// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.uil = bgl.uil || {};

bgl.uil.carousel = (() => {
    let carousel;
    let buttons;
    let navIsClicked = false;

    function init() {
        carousel = document.querySelector('[data-uil-carousel]');
        const carouselNavItems = document.querySelector('[data-uil-carousel-nav-items]');
        buttons = carousel.querySelectorAll('[data-tier-select-btn]');

        buttons.forEach((button) => {
            button.addEventListener('click', (event) => {
                deselectAll(carousel);

                if (!button.hasAttribute('data-active-button')) {
                    selectTier(carousel, button.getAttribute('data-tier'));
                }
            });
        });

        const activeElements = carousel.querySelectorAll('[data-active]');
        if (activeElements.length == 0) {
            deselectAll(carousel);
        }

        setCarouselNavScrolling();
        checkSwipe(carousel, carouselNavItems);
        displayActiveTierInViewport(carousel);
    }

    function displayActiveTierInViewport(carousel) {
        const activeTierCard = carousel.querySelector('[data-active]');

        if (activeTierCard != null) {
            carousel.scrollTo(activeTierCard.offsetLeft, 0);
        }
    }

    function deselectAll(carousel) {
        const activeElement = carousel.querySelectorAll('[data-active]');
        const activeButton = carousel.querySelector('[data-active-button]');

        if (activeButton != null) {
            removeActiveButton(activeButton);
        }

        if (activeElement != null) {
            removeActive(activeElement);
        }
    }

    function removeActive(activeElement) {
        activeElement.forEach((element) => {
            element.removeAttribute('data-active');
            element.classList.remove('uil-carousel__card--active');
            element.classList.remove('uil-carousel__heading--active');
            element.classList.remove('active');
        });
    }

    function removeActiveButton(activeButton) {
        activeButton.removeAttribute('data-active-button');
        activeButton.querySelector('[data-button-text-active]').classList.add('hide');
        activeButton.querySelector('[data-button-text-inactive]').classList.remove('hide');
        activeButton.querySelector('[data-button-icon]').classList.add('hide');
        activeButton.querySelector('[data-tier-select-input]').removeAttribute('checked');
    }

    function selectTier(carousel, dataTier) {
        const correctTiers = carousel.querySelectorAll(`[data-tier="${dataTier}"]`);

        correctTiers.forEach((element) => {
            switch (true) {
            case element.hasAttribute('data-uil-carousel-card'):
                element.classList.add('uil-carousel__card--active');
                element.setAttribute('data-active', '');
                break;
            case element.hasAttribute('data-uil-carousel-heading'):
                element.classList.add('uil-carousel__heading--active');
                element.setAttribute('data-active', '');
                break;
            case element.hasAttribute('data-tier-select-btn'):
                element.querySelector('[data-button-text-active]').classList.remove('hide');
                element.querySelector('[data-button-text-inactive]').classList.add('hide');
                element.querySelector('[data-button-icon]').classList.remove('hide');
                element.querySelector('[data-tier-select-input]').setAttribute('checked', 'checked');
                element.setAttribute('data-active-button', '');
            default:
                break;
            }
        });
    }

    function setCarouselNavScrolling() {
        const navItems = document.querySelectorAll('[data-uil-carousel-nav-item]');

        navItems.forEach((item) => {
            item.addEventListener('click', (event) => {
                event.preventDefault();

                navIsClicked = true;
                const controlId = item.getAttribute('aria-controls');
                const tierCard = carousel.querySelector('#' + controlId);

                navItems.forEach((navItem) => {
                    navItem.classList
                        .remove('uil-carousel-wrapper__btn');
                });
                item.classList.add('uil-carousel-wrapper__btn');
                carousel.scrollTo(tierCard.offsetLeft, 0);

                setTimeout(() => {
                    navIsClicked = false;
                }, 500);
            });
        });
    }

    function checkSwipe(carousel, carouselNav) {
        carousel.addEventListener('scroll', () => {
            if (!navIsClicked) {
                const scrollLeft = carousel.scrollLeft;

                const carouselNavItems = carouselNav.querySelectorAll('[data-uil-carousel-nav-item]');
                carouselNavItems.forEach((navItem, index) => {
                    const controlId = navItem.getAttribute('aria-controls');
                    const tierCard = carousel.querySelector('#' + controlId);

                    const offsetLeft = tierCard.offsetLeft;
                    const itemWidth = tierCard.offsetWidth;

                    if (scrollLeft + itemWidth >= offsetLeft && scrollLeft <= offsetLeft + itemWidth) {
                        carouselNavItems
                            .forEach((item) => item.classList
                                .remove('uil-carousel-wrapper__btn'));
                        navItem.classList
                            .add('uil-carousel-wrapper__btn');
                    }
                });
            }
        });
    }

    return {
        init,
        deselectAll,
        selectTier,
        displayActiveTierInViewport,
    };
})();
// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.uil = bgl.uil || {};

bgl.uil.basetabs = (function() {
    let buttons = [];
    let content = [];

    function init(idName) {
        const tabs = document.getElementById(idName);

        getButtonsAndContent(tabs, idName);

        buttons.forEach((button) => {
            button.addEventListener('click', (event) => {
                clickTab(event, idName);
            });
        });
    }

    function clickTab(event, idName) {
        const tabs = document.getElementById(idName);

        getButtonsAndContent(tabs, idName);

        buttons.forEach((button) => {
            button.setAttribute('aria-selected', 'false');
        });

        event.currentTarget.setAttribute('aria-selected', 'true');

        content.forEach((contentItem) => {
            if (contentItem.hasAttribute('aria-hidden')) {
                contentItem.setAttribute('aria-hidden', 'true');
            } else {
                contentItem.classList.add('hide');
            }
        });

        const currentTargetId = `${event.currentTarget.getAttribute('aria-controls')}`;
        const selectedContent = document.getElementById(currentTargetId);

        if (selectedContent.hasAttribute('aria-hidden')) {
            selectedContent.setAttribute('aria-hidden', 'false');
        } else {
            selectedContent.classList.remove('hide');
        }
    }

    function getButtonsAndContent(tabs, idName) {
        buttons = [...tabs.querySelectorAll(`[data-tab-button-${idName}]`)];
        content = [...tabs.querySelectorAll(`[data-tab-content-${idName}]`)];
    }

    return {
        init: init,
        clickTab: clickTab,
    };
})();
// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.uil = bgl.uil || {};

bgl.uil.accordion = (function() {
    function init(elementId) {
        if (document.querySelector('[data-accordion]')) {
            const accordions = document.querySelectorAll('[data-accordion]');

            accordions.forEach((accordion) => {
                const triggers = accordion.querySelectorAll('[data-accordion-button]');
                triggers.forEach((trigger) => trigger.addEventListener(
                    'click',
                    (event) => {
                        clickAccordion(event.currentTarget);
                    },
                ));
            });
        } else {
            const accordion = document.getElementById(elementId);
            const triggers = accordion.querySelectorAll('[data-accordion-button]');
            triggers.forEach((trigger) => trigger.addEventListener(
                'click',
                (event) => {
                    clickAccordion(event.currentTarget);
                },
            ));
        }
    }

    function clickAccordion(currentTarget) {
        const isAriaExpanded = currentTarget.getAttribute('aria-expanded');
        const currentTargetId = `${currentTarget.getAttribute('aria-controls')}`;
        const selectedContent = document.getElementById(currentTargetId);

        if (isAriaExpanded !== 'true') {
            const accordion = currentTarget.closest('[data-accordion]');
            if (accordion.getAttribute('data-accordion-type') === 'radio') {
                collapseAllAccordionContent(accordion);
            }
        }

        currentTarget.setAttribute(
            'aria-expanded',
            isAriaExpanded === 'true' ? 'false' : 'true');

        selectedContent.classList.toggle('hide');
        selectedContent.setAttribute(
            'aria-hidden',
            isAriaExpanded === 'true' ? 'true' : 'false');
    }

    function collapseAllAccordionContent(accordion) {
        const buttons = accordion.querySelectorAll('[data-accordion-button]');
        buttons.forEach((button) => button.setAttribute('aria-expanded', 'false'));

        const contents = accordion.querySelectorAll('[data-accordion-content]');
        contents.forEach((content) => content.classList.add('hide'));
    }

    function expandAccordion(accordionButton) {
        setAccordionExpanded(accordionButton, true);
    }

    function collapseAccordion(accordionButton) {
        setAccordionExpanded(accordionButton, false);
    }

    function setAccordionExpanded(accordionButton, value) {
        accordionButton.setAttribute('aria-expanded', value ? 'true' : 'false');

        const accordionContent = document.getElementById(accordionButton.getAttribute('aria-controls'));
        if (value === true) {
            accordionContent.classList.remove('hide');
        } else {
            accordionContent.classList.add('hide');
        }
    }

    function enableAccordion(accordionButton) {
        setAccordionEnabled(accordionButton, true);
    }

    function disableAccordion(accordionButton) {
        setAccordionEnabled(accordionButton, false);
    }

    function setAccordionEnabled(accordionButton, value) {
        if (value === true) {
            accordionButton.classList.remove('uil-accordion__button--disabled');
        } else {
            accordionButton.classList.add('uil-accordion__button--disabled');
        }
    }

    return {
        init: init,
        clickAccordion: clickAccordion,
        expandAccordion: expandAccordion,
        collapseAccordion: collapseAccordion,
        enableAccordion: enableAccordion,
        disableAccordion: disableAccordion,
    };
})();

// eslint-disable-next-line no-var
var bgl = window.bgl || {};

bgl.policyoverviewlink = (function() {
    function init(elementId) {
        const policyOverviewLink = document.getElementById(elementId);

        if (policyOverviewLink) {
            policyOverviewLink.addEventListener('click', function() {
                bgl.common.utilities.redirectToUrl(sessionStorage.getItem('policyHomeUrl'));
            });
        }
    }

    return {
        init: init,
    };
})();
// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.introtour = bgl.introtour || {};

bgl.introtour.steps = (function() {
    const storageKey = 'introTourInviteSeen';
    let inviteSeen = localStorage.getItem(storageKey);
    let tourDriver = null;
    let stepsInvite = [];
    const handleResize = debounce(() => {
        if (tourDriver.isActive()) {
            stepsConfiguration.steps = getVisibleSteps();
            tourDriver.setConfig(stepsConfiguration);
            tourDriver.refresh();
        }
    }, 250);

    const stepsConfiguration = {
        popoverClass: 'driverjs-theme',
        showProgress: true,
        progressText: 'Step {{current}}/{{total}}',
        showButtons: ['next', 'previous', 'close'],
        nextBtnText: 'Next',
        prevBtnText: 'Back',
        doneBtnText: 'Done',
        onHighlighted: (element, step, options) => {
            onHighlighted(options);
        },
        onCloseClick: () => {
            tourDriver.destroy();
        },
        onDestroyStarted: () => {
            tourDriver.destroy();
        },
    };

    function init(resourceBasePath, introTourDriver) {
        tourDriver = introTourDriver;
        const welcomeMessage = document
            .querySelector('h1[data-testid="PolicyOverviewHeaderMessage__header-message"] > span')
            .innerText;
        stepsInvite = [{
            popover: {
                title: ''.concat(welcomeMessage),
                description: '\n <p>We would love to show you around your account area.</p>' +
                    '\n <img src="' + resourceBasePath + '/intro-tour-welcome.png"/>' +
                    '\n <div class="driver-popover-footer invite">\n <div class="driver-popover-navigation-btns">' +
                    '\n <button id="showMeAround" class="driver-popover-start-btn">Show me around</button>\n <p>' +
                    '\n <a id="exploreMyself" href="#" data-testid="PolicyOverview__explore-myself-button">' +
                    'I\'ll explore on my own</a></p>\n </div>\n </div>',
            },
        }];

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                if (tourDriver.isActive()) {
                    tourDriver.destroy();
                }
            }
        });

        const startTourButton = document.querySelector('[data-tour="show-me-around"]');
        startTourButton.addEventListener('click', (event) => {
            if (tourDriver.isActive()) {
                tourDriver.destroy();
                tourDriver.drive();
            } else {
                launchTour();
            }
        });

        setupTourLinkClickEvents();

        inviteSeen = localStorage.getItem(storageKey);
        if (inviteSeen === null) {
            launchWelcome();
        }
    }

    function launchWelcome() {
        tourDriver.setConfig({
            animate: true,
            overlayColor: 'black',
            overlayOpacity: 0.25,
            stagePadding: 16,
            stageRadius: 8,
            popoverClass: 'driverjs-theme driverjs-theme-invite',
            allowClose: true,
            showButtons: ['close'],
            onCloseClick: () => {
                tourDriver.destroy();
            },
            onHighlighted: () => {
                localStorage.setItem(storageKey, true);
                const showMeAroundButton = document.getElementById('showMeAround');
                if (showMeAroundButton) {
                    showMeAroundButton.addEventListener('click', () => {
                        tourDriver.destroy();
                        launchTour();
                    });
                }

                const exploreMyselfButton = document.getElementById('exploreMyself');
                if (exploreMyselfButton) {
                    exploreMyselfButton.addEventListener('click', () => {
                        tourDriver.destroy();
                    });
                }
            },
            steps: stepsInvite,
        });
        setTimeout(() => {
            tourDriver.drive();
        }, 1000);
    }

    function setupTourLinkClickEvents() {
        const tourLinks = document
            .querySelectorAll('#takeMeThere_Policy, #takeMeThere_MTA, #takeMeThere_Claims');
        tourLinks.forEach((element) => {
            element.addEventListener('click', () => {
                tourDriver.destroy();
            });
        });

        const helpLink = document.getElementById('takeMeThere_Help');
        if (helpLink) {
            helpLink.addEventListener('click', () => {
                tourDriver.destroy();
                document.getElementById('houstonButton').click();
            });
        }
    }

    function launchTour() {
        stepsConfiguration.steps = getVisibleSteps();
        tourDriver.setConfig(stepsConfiguration);
        tourDriver.drive();
        window.addEventListener('resize', handleResize);
    }

    function onHighlighted(options) {
        const activeStep = options.state.activeIndex + 1;
        const total = options.config.steps.length;
        updateProgressBar(activeStep, total);
        setupTourLinkClickEvents();
        if (activeStep === total) {
            changeProgressLink();
        }
    }

    function getVisibleSteps() {
        return stepsAll.filter((step) => {
            return !step.element || isElementVisible(step.element);
        });
    }

    function changeProgressLink() {
        const progressText = document.querySelector('.driver-popover-progress-text');
        progressText.innerHTML = '<a href="#" id="startAgain">Start again</a>';
        const startAgainLink = document.getElementById('startAgain');
        if (startAgainLink) {
            startAgainLink.addEventListener('click', () => {
                tourDriver.drive();
            });
        }
    }

    function updateProgressBar(active, total) {
        getProgessBar().style.width = active / total * 100 + '%';
    }

    function getProgessBar() {
        const progressBarId = 'intro-tour-progress-bar';
        let progressBar = document.querySelector('#' + progressBarId);
        if (!progressBar) {
            const footer = document.querySelector('.driver-popover-footer');
            const progress = document.createElement('span');
            progress.id = progressBarId;
            progress.classList.add('progress');
            footer.prepend(progress);
            progressBar = document.querySelector('#' + progressBarId);
        }

        return progressBar;
    }

    const stepsAll = [{
        popover: {
            title: 'Policy Overview',
            description: '<p>This is your dashboard, where you can quickly view your policy details, ' +
                'upcoming payments, and any notifications.</p><p><a href="#" id="takeMeThere_Policy">' +
                'Take me there</a></p>',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '[data-desktop-tourid="Make a Change"]',
        popover: {
            title: 'Managing your policy',
            description: '<p>Head over to the \'Make a change\' section. It\'s easy and only takes a few clicks.' +
                '</p><p><a href="/MyAccount/changingyourpolicy/makechanges" id="takeMeThere_MTA">Take me there' +
                '</a></p>',
            side: 'bottom',
            align: 'end',
        },
    }, {
        element: '[data-mobile-tourid="Make Changes"]',
        popover: {
            title: 'Managing your policy',
            description: '<p>Head over to the \'Make Changes\' section. It\'s easy and only ' +
                'takes a few clicks.</p><p><a href="/MyAccount/changingyourpolicy/makechanges" ' +
                'id="takeMeThere_MTA">Take me there</a></p>',
            side: 'top',
            align: 'end',
        },
    }, {
        element: '[data-desktop-tourid="Claims"]',
        popover: {
            title: 'Claims',
            description: '<p>Need to make a claim or track an active claim? ' +
                'Here is where you will find all this information.</p>' +
                '<p><a href="/MyAccount/claims" id="takeMeThere_Claims">Take me there</a></p>',
            side: 'bottom',
            align: 'end',
        },
    }, {
        element: '[data-mobile-tourid="Claims"]',
        popover: {
            title: 'Claims',
            description: '<p>Need to make a claim or track an active claim? ' +
                'Here is where you will find all this information.</p>' +
                '<p><a href="/MyAccount/claims" id="takeMeThere_Claims">Take me there</a></p>',
            side: 'top',
            align: 'end',
        },
    }, {
        element: '#HoustonContainer',
        popover: {
            title: 'Support',
            description: '<p>Our helpful assistant is here to serve. Our web chat team are here too.' +
                '</p><p><a href="#" id="takeMeThere_Help">Ask for help</a></p>',
            side: 'left',
            align: 'end',
        },
    },
    {
        element: '[data-tourid="quickLinks"]',
        popover: {
            title: 'Quick access links',
            description: '<p>We have added some popular links for quick access such as making ' +
                'changes and accessing documents or payments.</p>',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        popover: {
            title: 'All done',
            description: '<p>Dive in and explore what MyAccount can do for you. ' +
                'We\'re here to help every step of the way.</p>',
        },
    }];

    function isElementVisible(selector) {
        const element = document.querySelector(selector);
        if (!element) {
            return false;
        }

        const style = window.getComputedStyle(element);
        if (element.offsetParent == null && style.position != 'fixed') {
            return false;
        }

        if (style.display == 'none' || style.visibility == 'hidden') {
            return false;
        }

        return true;
    }

    function debounce(func, wait) {
        let timeout;
        return () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                func.apply(this);
            }, wait);
        };
    }

    return {
        init: init,
        onHighlighted: onHighlighted,
    };
})();
// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.hiddensubmit = bgl.hiddensubmit || {};

bgl.hiddensubmit = (() => {
    let initiallySelectedRadioButton;
    let confirmDialogue;

    function init() {
        const form = document.querySelector('[data-hidden-submit-form]');

        if (form) {
            const fieldset = document.querySelector('[data-hidden-submit-fieldset]');
            confirmDialogue = document.querySelector('[data-hidden-submit-confirm]');

            if (fieldset) {
                const radioButtons = [...fieldset.querySelectorAll('input[type="radio"]')];

                radioButtons.forEach((radioButton) => {
                    radioButton.addEventListener('click', handleRadioButtonClick);

                    if (radioButton.checked) {
                        initiallySelectedRadioButton = radioButton;
                    }
                });
            }
        }
    }

    const handleRadioButtonClick = (event) => {
        if (event.target === initiallySelectedRadioButton) {
            confirmDialogue.classList.add('hide');
        } else {
            confirmDialogue.classList.remove('hide');
        }
    };

    return {
        init,
    };
})();
// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.common = bgl.common || {};

bgl.common.pubsub = (function() {
    let events = {};

    function on(eventName, fn) {
        events[eventName] = events[eventName] || [];
        events[eventName].push(fn);
    }

    function off(eventName, fn) {
        if (events[eventName]) {
            for (let i = 0; i < events[eventName].length; i++) {
                if (events[eventName][i] === fn) {
                    events[eventName].splice(i, 1);
                    break;
                }
            }
        }
    }

    function emit(eventName, data) {
        if (events[eventName]) {
            events[eventName].forEach(function(fn) {
                fn(data);
            });
        }
    }

    function getEventCount(eventName) {
        return events[eventName].length;
    }

    function clearEvents() {
        events = {};
    }

    return {
        on: on,
        off: off,
        emit: emit,
        clear: clearEvents,
        getEventCount: getEventCount,
    };
})();

bgl.common.loader = (function() {
    function makeAjaxCall(options) {
        $.ajax({
            url: options.componentUrl,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(options.componentConfiguration),
            success: function(data, textStatus, request) {
                if (
                    request.getResponseHeader('Content-Type') ===
                'application/json; charset=utf-8'
                ) {
                    if (data.isSuccess && data.redirectUrl) {
                        if (typeof options.beforePageRedirectCallback === 'function') {
                            options.beforePageRedirectCallback();
                        }

                        bgl.common.utilities.redirectToUrl(data.redirectUrl);
                    } else if (!data.isSuccess) {
                        bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                    }
                } else {
                    const htmlChangingFunction = options.htmlChangingFunction;

                    htmlChangingFunction.call($('#' + options.containerElementId), data);

                    if (typeof options.callback === 'function') {
                        options.callback();
                    }
                }
            },
            error: function(error) {
                console.log(error);
            },
        });
    }

    function logToGA(componentConfiguration, componentUrl) {
        let subCall;
        let sliderGTMPageURL;
        let sliderGTMPageTitle;

        if ($(componentConfiguration)[0].CurrentStep) {
            subCall = '/' + $(componentConfiguration)[0].CurrentStep;
        } else if ($(componentConfiguration)[0].currentStep) {
            subCall = '/' + $(componentConfiguration)[0].currentStep;
        } else if ($(componentConfiguration)[0].EditActionKey) {
            subCall = '/' + $(componentConfiguration)[0].EditActionKey;
        } else {
            subCall = '';
        }

        if (componentUrl && window.dataLayer) {
            sliderGTMPageURL =
        window.location.pathname.replace(/\/$/, '') +
        '/' +
        componentUrl.split('/').pop() +
        subCall;
            sliderGTMPageTitle = componentUrl.split('/').pop() + subCall;

            dataLayer.push({
                event: 'MAVirtualPageView',
                virtualPageURL: sliderGTMPageURL,
                virtualPageTitle: sliderGTMPageTitle,
            });
        }
    }

    function load(
        componentConfiguration,
        componentUrl,
        containerElementId,
        callback,
        beforePageRedirectCallback,
    ) {
        const options = {
            componentConfiguration: componentConfiguration,
            componentUrl: componentUrl,
            containerElementId: containerElementId,
            callback: callback,
            htmlChangingFunction: $.fn.html,
            beforePageRedirectCallback: beforePageRedirectCallback,
        };

        logToGA(componentConfiguration, componentUrl);
        makeAjaxCall(options);
    }

    function loadAndReplace(
        componentConfiguration,
        componentUrl,
        containerElementId,
        callback,
        beforePageRedirectCallback,
    ) {
        const options = {
            componentConfiguration: componentConfiguration,
            componentUrl: componentUrl,
            containerElementId: containerElementId,
            callback: callback,
            htmlChangingFunction: $.fn.replaceWith,
            beforePageRedirectCallback: beforePageRedirectCallback,
        };

        makeAjaxCall(options);
    }

    return {
        load: load,
        loadAndReplace: loadAndReplace,
    };
})();

bgl.common.modal = (function() {
    // Public Functions
    function show(el, event) {
        el.addClass('show');
        el.attr('aria-hidden', false);
        $(document.body).addClass('modal-open');
        showBackdrop();
        event.stopPropagation();
    }

    function hide(el) {
        el.removeClass('show');
        el.attr('aria-hidden', true);
        $(document.body).removeClass('modal-open');
        $('.modal').off('click');
        removeBackdrop();
    }

    function showBackdrop() {
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        $(backdrop).appendTo(document.body);

        $('.modal').on('click', function(e) {
            if (e.target !== e.currentTarget) {
                return;
            }
            hide($('.modal'), e);
        });
    }

    function removeBackdrop() {
        $('.modal-backdrop').remove();
        $('.modal').off('click');
    }

    function loadModalContent(url, $popupContainer, popupConfiguration) {
        let requestData = '';
        if (popupConfiguration) {
            requestData = JSON.stringify(popupConfiguration);
        }

        $.ajax({
            url: url,
            type: 'POST',
            contentType: 'application/json',
            data: requestData,
            success: function(data) {
                $popupContainer.html(data);
            },
            error: function(error) {
                console.error(error);
            },
        });
    }

    // Event Handlers
    $(document).on('click', '[data-toggle="modal"]', function(event) {
        event.preventDefault();
        const url = $(this).data('url');
        const popupConfiguration = $(this).data('configuration');

        bgl.common.utilities.invoke(
            $(this).data('togglePreModal'),
            $(this).data('togglePreModalParams'),
        );

        const $relatedTarget = $($(this).data('target'));
        show($relatedTarget, event);

        if (url) {
            loadModalContent(
                url,
                $relatedTarget.find('.modal-body'),
                popupConfiguration,
            );
        }
    });

    $(document).on('click', '[data-dismiss="modal"]', function(event) {
        event.preventDefault();
        const $relatedTarget = $(this).closest('.modal');
        hide($relatedTarget, event);
    });
})();

bgl.common.validator = (function() {
    let validator;
    const options = {
        errorClass: 'error',
        hasSubmit: true,
    };

    const enterKeyCode = 13;
    const escKeyCode = 27;
    const tabKeyCode = 9;
    const backspaceKeyCode = 8;
    const deleteKeyCode = 46;
    const endKeyCode = 35;
    const downArrowKeyCode = 40;
    const numpadZeroKeyCode = 96;
    const numpadNineKeyCode = 105;
    const zeroKeyCode = 48;
    const nineKeyCode = 57;
    const letterAInLowerKeyCode = 65;

    function initFormValidator(form, optionsParameters) {
        form = $(form);
        optionsParameters = optionsParameters || {};

        $.extend(options, optionsParameters);

        // if jQuery validation is switched on
        if ($.validator) {
            setupCustomValidationRules(form);

            $.validator.unobtrusive.parse(form);

            validator = $(form).validate();

            if (validator) {
                validator.settings.onsubmit = options.onsubmit || false;
                validator.settings.onkeyup = options.onkeyup || false;
                validator.settings.onfocusout = options.onfocusout || false;
                validator.settings.onfocusin = options.onfocusin || false;
                validator.settings.onclick = options.onclick || false;
                validator.settings.focusInvalid = options.focusInvalid || false;
                validator.settings.cleanUp = options.cleanUp || false;
                validator.settings.errorClass = options.errorClass || 'error';
                validator.settings.highlight =
            options.highlight ||
            function(element) {
                highlightElement(element);
            };
                validator.settings.unhighlight =
            options.unhighlight ||
            function(element) {
                unhighlighElement(element);
            };
                validator.settings.ignore =
            options.ignore !== undefined ?
                options.ignore :
                validator.settings.ignore;
            }
        }

        return validator;
    }

    function setupCustomValidationRules(form) {
        if (form.find('[data-val-requirefromgroup]')) {
            setRequireAtLeastOneOfGroupValidation();
        }

        if (form.find('[data-val-dateformat]')) {
            setValidationOfDateToFormat();
        }

        if (form.find('[data-val-requiredif]')) {
            setRequiredIfValidation();
        }
    }

    function validateForm(configuration, form) {
        form = $(form);
        const isValidForm = isFormValid(form);

        /* client side validation is passed
    or skipped if jQuery validation is switched off */
        if (isValidForm) {
            submitComponentForm(form, configuration);
        }

        return isValidForm;
    }

    function isFormValid(form) {
        form = $(form);
        let isValidForm = true;
        validator = getFormValidator(form);

        // try to validate the form using jQuery validation
        if (validator) {
            isValidForm = $(form).valid() && options.hasSubmit;
        }

        if (!isValidForm) {
            scrollToTheFirstInvalidInput();
            getValidationMessages();
        }

        /* client side validation is passed
    or skipped if jQuery validation is switched off */
        return isValidForm;
    }

    function getValidationMessages() {
        if ($('.form-row').hasClass('error')) {
            const data = {
                form_section: getFormSectionName($(this)),
                error_details: [],
            };

            $('.error').find('.form-row__validation-text').each(function() {
                const errorDetail = {
                    error_field: $(this).attr('data-valmsg-for'),
                    error_message: $(this).text(),
                };

                data.error_details.push(errorDetail);
            });

            bgl.common.pubsub.emit('formValidationFailed', data);
        }
    }

    function getFormSectionName() {
        const formRow = '.form-row__validation-text';

        if ($(formRow)
            .parents()
            .find('.step-form__section-title')
            .text()
            .length === 0) {
            return $(formRow).closest('form').find('h1').text();
        } else {
            return $(formRow)
                .closest('form')
                .find('.step-form__section-title')
                .text();
        }
    }

    function enableMaxLength() {
        $('input[data-val-length-max]').each(function(index, element) {
            const maxLength = $(element).data('val-length-max');

            $(element).attr('maxlength', maxLength);
        });
    }

    function getFormValidator(form) {
        form = form || {};

        if (validator) {
            return validator;
        }

        if ($.validator) {
            $.validator.unobtrusive.parse(form);

            validator = $(form).validate({
                ignore: '.hide',
            });

            $.extend(options, validator.settings);
        }

        return validator;
    }

    function highlightElement(element) {
        element = element || $();
        const parentRow = $(element).closest('div.form-row') || $();

        if (parentRow.length > 0) {
            $(parentRow).addClass(options.errorClass);
        } else {
            $(element).addClass(options.errorClass);
        }
    }

    function unhighlighElement(element) {
        element = element || $();
        const parentRow = $(element).closest('div.form-row') || $();

        if (parentRow.length > 0) {
            $(parentRow).removeClass(options.errorClass);
        } else {
            $(element).removeClass(options.errorClass);
        }

        cleanAriaDescribedbyAttribute(element);
    }

    function cleanAriaDescribedbyAttribute(element) {
        if (!$(element).attr('aria-describedby')) {
            return;
        }

        const currentAriaDescribedBy = $(element)
            .attr('aria-describedBy')
            .split(' ');
        const newAriaDescribedBy = [];

        $(currentAriaDescribedBy).each(function(i, elementID) {
            elementID = elementID.trim();
            if ($('#' + elementID).length) {
                newAriaDescribedBy.push(elementID);
            }
        });

        if (newAriaDescribedBy.length) {
            $(element).attr('aria-describedby', newAriaDescribedBy.join(' '));
        } else {
            $(element).removeAttr('aria-describedby');
        }
    }

    function submitComponentForm(form, configuration, requestBodyData) {
        form = $(form);
        const disabled = $('form [data-disable-submit][disabled]').length > 0;

        if (!disabled) {
            $('form [data-disable-submit]').attr('disabled', 'disabled');

            bgl.common.pubsub.emit('formSubmit',
                form.attr('id') ||
          form.attr('action') ||
          'unknown');

            const dataToPost =
        requestBodyData ||
        $(form).serialize() +
          '&' +
          $.param({ComponentConfiguration: configuration});

            $.ajax({
                url: $(form).attr('action'),
                type: $(form).attr('method'),
                data: dataToPost,
                success: function(data) {
                    onSuccess(form, configuration, data);
                },
                error: function(error) {
                    onError(form, configuration, error.responseText);
                },
            });
        }
    }

    function onSuccess(form, configuration, data) {
        if (data !== undefined && data !== null) {
            if (data.isSuccess === true) {
                callFormEvent($(form), 'onSuccess', configuration, data);
            } else {
                if (data.errorRedirectUrl !== undefined) {
                    bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                } else {
                    onError(form, configuration, data);
                }
            }
        }
    }

    function onError(form, configuration, error) {
        form = form || $();

        const $error = $(error);
        const $component = $('div[data-component-id="' + configuration.Id + '"]');

        if ($error.length && $component.length) {
            $component.replaceWith($error);
        }

        const $invalidForm = $error.find('#' + form.attr('id'));
        const invalidInputs = {};

        $error.find('input, select').each(function(index, element) {
            unhighlighElement($(element));
            const inputName = $(element).attr('name');
            const message = $('[data-valmsg-for="' + inputName + '"]').text();

            if (message !== '') {
                const htmlMessage = $.parseHTML(message);

                $('[data-valmsg-for="' + inputName + '"]').html(htmlMessage);
                invalidInputs[inputName] = htmlMessage;
            }
        });

        callFormEvent($invalidForm, 'onError', configuration, error);

        validator = getFormValidator($invalidForm);

        // if jQuery validation is switched on
        if (validator) {
            validator.showErrors(invalidInputs);
        } else {
            // highlight errors if jQuery validation is switched off
            showErrors(invalidInputs);
        }

        scrollToTheFirstInvalidInput();
    }

    function callFormEvent(form, event, configuration, data) {
        const onEventName = form.data(event);
        const callback = eval(onEventName);

        if (typeof callback === 'function') {
            callback(configuration, data);
        }
    }

    function showErrors(invalidInputs) {
        $.each(invalidInputs, function(key) {
            highlightElement($('[name="' + key + '"]'));
        });
    }

    function addRequireAtLeastOneOfGroupMethod(value, element, params) {
        const controlsWithValue = $(
            'input[data-val-requirefromgroup-selector="' +
        params['selector'] + '"]',
        ).filter(function() {
            const controlType = $(this).attr('type');

            return controlType === 'checkbox' || controlType === 'radio' ?
                $(this).prop('checked') === true :
                $(this).val() !== '';
        });

        return controlsWithValue.length >= params['number'];
    }

    function setRequireAtLeastOneOfGroupValidation() {
        $.validator.addMethod(
            'require_from_group',
            addRequireAtLeastOneOfGroupMethod,
            '',
        );

        $.validator.unobtrusive.adapters.add(
            'requirefromgroup',
            ['number', 'selector'],
            function(options) {
                options.rules['require_from_group'] = {
                    number: options.params.number,
                    selector: options.params.selector,
                };
                options.messages['require_from_group'] = options.message;
            },
        );
    }

    function addRequiredIfValidationMethod(value, element, parameters) {
        const id =
        '[data-dependent-property=\'' + parameters['dependentproperty'] + '\']';

        // get the target value (as a string,
        // as that's what actual value will be)
        let targetValue = parameters['targetvalue'];
        targetValue = (targetValue === null ? '' : targetValue).toString();

        // get the actual value of the target control
        // note - this probably needs to cater for more
        // control types, e.g. radios
        const control = $(id);
        const controlType = control.attr('type');
        let actualValue =
        controlType === 'checkbox' || controlType === 'radio' ?
            control.filter(':checked').val() :
            control.val();

        actualValue =
        actualValue !== undefined && actualValue !== null ?
            actualValue.toLowerCase() :
            actualValue;

        // if the condition is true, reuse the existing
        // required field validator functionality
        if (
            $.trim(targetValue.toLowerCase()) === $.trim(actualValue) ||
        ($.trim(targetValue) === '*' && $.trim(actualValue) !== '')
        ) {
            return $.validator.methods.required.call(
                this,
                value,
                element,
                parameters,
            );
        }

        return true;
    }

    function setRequiredIfValidation() {
        $.validator.addMethod('requiredif', addRequiredIfValidationMethod);

        $.validator.unobtrusive.adapters.add(
            'requiredif',
            ['dependentproperty', 'targetvalue'],
            function(options) {
                options.rules['requiredif'] = {
                    dependentproperty: options.params['dependentproperty'],
                    targetvalue: options.params['targetvalue'],
                };
                options.messages['requiredif'] = options.message;
            },
        );
    }

    function setValidationOfDateToFormat() {
        $.validator.addMethod('dateformat', validateDateFormat);

        $.validator.unobtrusive.adapters.add(
            'dateformat',
            ['regex', 'separator'],
            function(options) {
                options.rules['dateformat'] = {
                    regex: options.params['regex'],
                    separator: options.params['separator'],
                };
                options.messages['dateformat'] = options.message;
            },
        );
    }

    function validateDateFormat(value, element, parameters) {
        const separator = parameters['separator'];

        const regex = new RegExp(parameters['regex']);

        if (regex.test(value)) {
            const adata = value.split(separator);

            const day = parseInt(adata[0], 10);
            const month = parseInt(adata[1], 10) - 1;
            const year = parseInt(adata[2], 10);

            const xdata = new Date(year, month, day);

            if (
                xdata.getFullYear() === year &&
        xdata.getMonth() === month &&
        xdata.getDate() === day
            ) {
                return true;
            }
        }

        return false;
    }

    function initAutocompleteSearchInputs(form) {
        form = $(form);
        const autocompleteSearchInputs = form.find('[autocompletesearch]');

        $.each(autocompleteSearchInputs, function(index, element) {
            const input = $(element);

            $.validator.addMethod(
                input.attr('name'),
                validateAutocompleteSearchInputs,
                input.data('val-required'),
            );
        });
    }

    function resetValidationState(input) {
        unhighlighElement(input);
    }

    function validateAutocompleteSearchInputs(value, element) {
        const hiddenItemInputId = $(element).attr('id') + 'Id';
        const valueId = $('#' + hiddenItemInputId).val();

        return valueId.length !== 0;
    }

    function scrollToTheFirstInvalidInput() {
        let headerHeight;
        const invalidInput = $('.error, .error-messagebox').first();

        if (invalidInput.length) {
            let header;
            let selector;
            let inputTopPosition = invalidInput.offset().top;

            const slidePanelId = bgl.common.contentpanel.getSlidePanelId();
            const isInputInSlidePanel = invalidInput
                .closest('#' + slidePanelId)
                .length;

            if (isInputInSlidePanel) {
                header = $('header.panel-header');
                selector = $('#' + slidePanelId);

                const slidePanelContentTopPosition = $(
                    '#' + bgl.common.contentpanel.getSlidePanelContentId(),
                ).offset().top;
                inputTopPosition -= slidePanelContentTopPosition;
            } else {
                header = $('header.page-header, header.page-headerv2');
                selector = $(window);
            }

            headerHeight = header.height() || 0;

            if (header.css('position') === 'fixed') {
                headerHeight *= -1;
            }

            selector.scrollTop(inputTopPosition + headerHeight);
            const invalidInputElem = invalidInput.find('input, select, textarea')[0];
            if (invalidInputElem !== undefined) {
                invalidInputElem.focus();
            }
        }
    }

    function initNumberInputField(component, maxLength) {
        const isZeroAvailable = component.data('val-range-min') === 0;

        $(component)
            .off('keydown')
            .on('keydown', function(e) {
                if (
                    $.inArray(e.keyCode, [
                        deleteKeyCode,
                        backspaceKeyCode,
                        tabKeyCode,
                        escKeyCode,
                        enterKeyCode,
                    ]) !== -1 ||
            (e.keyCode === letterAInLowerKeyCode &&
            (e.ctrlKey === true || e.metaKey === true)) ||
            (e.keyCode >= endKeyCode && e.keyCode <= downArrowKeyCode)
                ) {
                    return;
                }
                if (
                    ((e.shiftKey ||
            e.keyCode < zeroKeyCode ||
            e.keyCode > nineKeyCode) &&
            (e.keyCode < numpadZeroKeyCode || e.keyCode > numpadNineKeyCode)) ||
            $(this).val().length === maxLength ||
            (!isZeroAvailable &&
            e.keyCode === numpadZeroKeyCode &&
            $(this).val().length === 0)
                ) {
                    e.preventDefault();
                }
            });

        $(component)
            .off('keyup')
            .on('keyup', function() {
                let val = $(this).val();
                while (val.substring(0, 1) === '0') {
                    if (isZeroAvailable && val.length === 1) {
                        break;
                    }
                    val = val.substring(1);
                }
                $(this).val(val);
            });
    }

    function validatePage(buttonId) {
        $('#' + buttonId)
            .off('click')
            .on('click', function(e) {
                e.preventDefault();

                const components = $('[data-component-state=\'partialerror\']');

                if (components !== undefined && components.length > 0) {
                    $.each(components, function(index, value) {
                        highlightElement($(value));
                    });

                    scrollToTheFirstInvalidInput();
                } else {
                    bgl.common.utilities.redirectToUrl($(this).attr('href'));
                }
            });
    }

    return {
        init: initFormValidator,
        validate: validateForm,
        isFormValid: isFormValid,
        getValidationMessages: getValidationMessages,
        enableMaxLength: enableMaxLength,
        initAutocompleteSearchInputs: initAutocompleteSearchInputs,
        resetValidationState: resetValidationState,
        submitForm: submitComponentForm,
        initNumberInputField: initNumberInputField,
        validatePage: validatePage,
    };
})();

bgl.common.utilities = (function() {
    let globalIdentifier = this;

    function invoke(funcName, funcParams) {
        if (funcName !== undefined && funcName !== null && funcName !== '') {
            const params =
        funcParams !== undefined && funcParams !== null ?
            funcParams.split(',') :
            [];

            const object = funcName.split('.');
            let fn = globalIdentifier;

            for (let i = 0, len = object.length; i < len && fn; i++) {
                fn = fn[object[i]];
            }

            if (typeof fn === 'function') {
                fn(...params);
            } else {
                console.error(funcName + ' is not a function.');
            }
        }
    }

    function setIdentifier(indentifier) {
        if (indentifier !== undefined && indentifier !== null) {
            globalIdentifier = indentifier;
        }
    }

    function startUnderwritingPolling() {
        bgl.common.pubsub.emit('PollBasket');
    }

    function getWindowLocation() {
        return window.location;
    }

    function getUrlHashValue() {
        return window.location.hash.substring(1);
    }

    function setUrlHashValue(hash) {
        window.location.hash = hash;
    }

    function errorRedirect(errorRedirectUrl) {
        errorRedirectUrl = errorRedirectUrl.replace(/\?returnUrl=.*$/i, '');
        bgl.common.utilities.redirectToUrl(errorRedirectUrl);
    }

    function redirectToUrl(url) {
        window.location.href = url;
    }

    function refreshPage() {
        window.location.reload(true);
    }

    function toBase64(str) {
        return window.btoa(unescape(encodeURIComponent(str)));
    }

    function fromBase64(str) {
        return decodeURIComponent(escape(window.atob(str)));
    }

    function getUrlQueryString(parameterName) {
        parameterName = parameterName.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        const regex = new RegExp('[\\?&]' + parameterName + '=([^&#]*)');
        const results = regex.exec(location.search);
        return results === null ?
            '' :
            decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    return {
        invoke: invoke,
        setIdentifier: setIdentifier,
        startUnderwritingPolling: startUnderwritingPolling,
        getWindowLocation: getWindowLocation,
        getUrlHashValue: getUrlHashValue,
        setUrlHashValue: setUrlHashValue,
        redirectToUrl: redirectToUrl,
        errorRedirect: errorRedirect,
        refreshPage: refreshPage,
        toBase64: toBase64,
        fromBase64: fromBase64,
        getUrlQueryString: getUrlQueryString,
    };
})();

bgl.common.cookie = (function() {
    function getCookie(name) {
        const matches = document.cookie.match(
            new RegExp(
                '(?:^|; )' +
                name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
                '=([^;]*)',
            ),
        );

        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    function setCookie(name, value, options) {
        options = options || {};

        let expires = options.expires;

        if (typeof expires === 'number' && expires) {
            const d = new Date();
            d.setTime(d.getTime() + expires * 1000);
            expires = options.expires = d;
        }

        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString();
        }

        value = encodeURIComponent(value);

        let updatedCookie = name + '=' + value;

        for (const propName in options) {
            updatedCookie += '; ' + propName;
            const propValue = options[propName];

            if (propValue !== true) {
                updatedCookie += '=' + propValue;
            }
        }

        document.cookie = updatedCookie + '; path=/';
    }

    function getUrlForCookieAsync(componentUrl) {
        const regex = /\/((\w+)|(\w+\/))$/gi;

        const url = componentUrl.replace(regex, '/UpdateCookie');

        return url;
    }

    function setCookieAsync(
        cookieKey,
        cookieValue,
        updateCookieUrl,
        onSuccess,
        onFailure,
    ) {
        $.ajax({
            url: updateCookieUrl,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({cookieKey: cookieKey, cookieValue: cookieValue}),
            success: function(data) {
                if (data && data.isSuccess) {
                    if (typeof onSuccess === 'function') {
                        onSuccess();
                    }
                }
            },
            error: function(error) {
                if (typeof onFailure === 'function') {
                    onFailure();
                }
                console.log(error);
            },
        });
    }

    function deleteCookie(name) {
        deleteCookieByNameAndPath(name, '/');
    }

    function deleteCookieByNameAndPath(name, path) {
        setCookie(name, '', {expires: -1, path: path});
    }

    return {
        getCookie: getCookie,
        setCookie: setCookie,
        deleteCookie: deleteCookie,
        deleteCookieByNameAndPath: deleteCookieByNameAndPath,
        setCookieAsync: setCookieAsync,
        getUrlForCookieAsync: getUrlForCookieAsync,
    };
})();

bgl.common.carousel = (function() {
    let carousel; let tabs; let slides; let options;

    function createCarouselBlock() {
        carousel = options.element;
        slides = carousel.find('.carousel__slide');
        tabs = carousel.find('.carousel__navigation-tab');

        const ctrls = $('<ul>')
            .addClass('carousel__controls')
            .html(
                `<li class="carousel__controls-section 
                        carousel__controls-section--left">
            <button type="button" 
                    class="carousel__button carousel__button--left"> 
            <img class="carousel__button-image" 
            src="${options.basePath}icon-arrow-left.svg" 
            alt="Previous Item"></button></li> 
            <li class="carousel__controls-section
                    carousel__controls-section--right">
            <button type="button" 
            class="carousel__button carousel__button--right">
            <img class="carousel__button-image" 
            src="${options.basePath}icon-arrow-right.svg" 
            alt="Next Item"></button></li>`,
            );

        carousel.append(ctrls);
    }

    function changeSlide(direction) {
        slides = carousel.find('.carousel__slide');

        const slidesCount = slides.length;
        let activeSlideNumber = parseInt(
            carousel.find('.carousel__slide.active').data('slide'),
        );

        if (direction === 'left') {
            if (activeSlideNumber > 1) {
                activeSlideNumber--;
            } else if (activeSlideNumber === 1) {
                activeSlideNumber = slidesCount;
            }
        } else if (direction === 'right') {
            if (activeSlideNumber < slidesCount) {
                activeSlideNumber++;
            } else if (activeSlideNumber === slidesCount) {
                activeSlideNumber = 1;
            }
        }

        const tab = carousel.find(
            '.carousel__navigation-tab[data-slide=\'' + activeSlideNumber + '\']',
        );
        const slide = carousel.find(
            '.carousel__slide[data-slide=\'' + activeSlideNumber + '\']',
        );

        $.merge(tabs, slides).removeClass('active');
        $.merge(tab, slide).addClass('active');
    }

    function carouselEvents() {
        carousel.find('.carousel__button--left').on('click', function() {
            changeSlide('left');
        });

        carousel.find('.carousel__button--right').on('click', function() {
            changeSlide('right');
        });
    }

    function carouselTabsSetup() {
        $.each(tabs, function() {
            const tab = $(this);
            const slide = $('.carousel__slide[data-slide=\'' +
            tab.data('slide') + '\']');

            tab.on('click', function() {
                $.merge(tabs, slides).removeClass('active');
                $.merge(tab, slide).addClass('active');
            });
        });
    }

    function carouselTouchScrollSetup() {
        carousel.on('touchstart', function(e) {
            const swipe = e.originalEvent.touches;
            const start = swipe[0].pageX;
            let distance = 0;

            $(this)
                .on('touchmove', function(e) {
                    const contact = e.originalEvent.touches;
                    const end = contact[0].pageX;

                    distance = end - start;
                })
                .one('touchend', function() {
                    if (distance < -30) {
                        changeSlide('right');
                    }
                    if (distance > 30) {
                        changeSlide('left');
                    }
                    $(this).off('touchmove touchend');
                });
        });
    }

    function init(opt) {
        options = opt;
        createCarouselBlock();
        carouselEvents();
        carouselTabsSetup();
        carouselTouchScrollSetup();
    }

    return {
        init: init,
    };
})();

bgl.common.spinner = (function() {
    function getSpinnerBody(titleText, bodyText) {
        const htmlEncodedTitle = $('<span>').text(titleText).html();
        const htmlEncodedBody = $('<span>').text(bodyText).html();

        return (
            '<main>' +
        '<div class="page-section">' +
        '<div class="page-section--inner">' +
        '<div class="spinner">' +
        '<div class="spinner__ring"></div>' +
        '<h2 class="spinner__heading">' +
        htmlEncodedTitle +
        '</h2>' +
        '<p class="spinner__text">' +
        htmlEncodedBody +
        '</p>' +
        '<div class="spinner__divider"></div>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</main>'
        );
    }

    return {
        getSpinnerBody: getSpinnerBody,
    };
})();

bgl.common.accordions = (function() {
    let $accordionButtons;

    function getAccordionBody($element) {
        return $element
            .closest('.accordion__section')
            .find('.accordion__body-wrapper');
    }

    function hideAccordionsOnLoad() {
        $accordionButtons = $('.accordion__heading-button');
        $.each($accordionButtons, function() {
            const $accordionButton = $(this);
            const isVisible = isAccordionExpanded($accordionButton);

            if (isVisible === 'false') {
                const $accordionBody = getAccordionBody($accordionButton);

                $accordionBody.hide();
            }

            $accordionButton.attr('aria-expanded', isVisible);
        });
    }

    function subscribeForEvents() {
        const accordions = document.querySelectorAll('.accordion__heading-button');

        for (let i = 0; i < accordions.length; i++) {
            if (!accordions[i].onclick) {
                accordions[i].onclick = accordionClickHandler;
            }
        }
    }

    function accordionClickHandler() {
        const $accordionButton = $(this);
        const $accordionBody = getAccordionBody($accordionButton);
        const isExpanded = isAccordionExpanded($accordionButton) === 'true';
        if ($accordionButton.data('accordion-key')) {
            sessionStorage.setItem($accordionButton.data('accordion-key'),
                !isExpanded);
        }

        $accordionButton.attr('aria-expanded', !isExpanded);

        isExpanded ? $accordionBody.hide() : $accordionBody.show();
    }

    function isAccordionExpanded($accordionButton) {
        return (
            ($accordionButton.data('accordion-key') &&
            sessionStorage.getItem($accordionButton.data('accordion-key'))) ||
            $accordionButton.attr('aria-expanded')
        );
    }

    function init() {
        hideAccordionsOnLoad();
        subscribeForEvents();
    }

    return {
        init: init,
    };
})();

bgl.common.contentpanel = (function() {
    const slidePanelContentObserver = new MutationObserver(setFocus);
    let slidePanelElement;

    function show(el, event) {
        subscribeToEvents();

        el.removeClass('hide-panel').addClass('active');

        $(document.body).addClass('slide-panel-open');
        showBackdrop(el.attr('data-confirmation'));

        const slidePanelContent = document.getElementById(getSlidePanelContentId());
        if (slidePanelContent) {
            slidePanelContentObserver.observe(slidePanelContent, {
                childList: true,
                subtree: true,
            });
        }
        slidePanelElement = $('#' + getSlidePanelId());

        setFocus();

        if (event) {
            event.stopPropagation();
        }
    }

    function subscribeToEvents() {
        bgl.common.pubsub.on('CancelMTAComplete', function() {
            if (sessionStorage.getItem('reload') === null) {
                $('#' + getSlidePanelId()).removeAttr('data-confirmation');
                hide($('#SlidePanel'));
            } else {
                sessionStorage.removeItem('reload');
                window.location.reload();
            }
        });
    }

    function hide(el, event) {
        el.removeClass('active').addClass('hide-panel');
        $(document.body).removeClass('slide-panel-open');
        $('#' + getSlidePanelContentId()).empty();
        slidePanelContentObserver.disconnect();

        if (event) {
            event.stopPropagation();
        }

        removeBackdrop();
        setTimeout(bgl.common.focusHolder.setFocusToElementById, 100);
    }

    function setFocus() {
        if (slidePanelElement.find(':focus').first().length === 0) {
            const autoFocusElement = slidePanelElement.find('[autofocus]').first();
            if (autoFocusElement.length) {
                autoFocusElement.focus();
            } else {
                document.getElementById('SlidePanel').focus();
            }
        }
    }

    function showBackdrop(confirmation) {
        if ($('#overlay-pane').length > 0) {
            return;
        }

        $('<div>')
            .attr('id', 'overlay-pane')
            .addClass('overlay show')
            .appendTo(document.body);

        if ($('#mta-always-open-slider')[0]) {
            $('#overlay-pane').on('click', function() {
                const startPage = sessionStorage.getItem('MTAStartPage');
                const options = {
                    redirectUrl: startPage,
                };
                bgl.common.pubsub.emit('CancelMTA', options);
            });
        } else if (confirmation) {
            $('#overlay-pane').on('click', function() {
                bgl.common.pubsub.emit('CancelMTA');
            });
        } else {
            $('#overlay-pane').on('click', function(e) {
                if (e.target !== e.currentTarget) {
                    return;
                }

                hide($('#SlidePanel'), e);
            });
        }
    }

    function removeBackdrop() {
        $('#overlay-pane').remove();
    }

    function hideSlidePanel(event) {
        if (event) {
            event.preventDefault();
        }

        const $relatedTarget = $('#SlidePanel');
        hide($relatedTarget, event);
        $relatedTarget.off();
    }

    $(document).on('click', '[data-toggle="slide-panel"]', function(event) {
        event.preventDefault();
        bgl.common.focusHolder.setFocusedElementId($(this));
        const $relatedTarget = $($(this).data('target'));
        $relatedTarget.find('.slide-panel-content').empty();

        if ($(this).data('confirmation')) {
            $relatedTarget.attr('data-confirmation', true);
        }

        show($relatedTarget, event);
    });

    $(document).on('click', '[data-dismiss="slide-panel"]', function(event) {
        if ($('#' + getSlidePanelId()).attr('data-confirmation') == 'true') {
            bgl.common.pubsub.emit('CancelMTA');
            return;
        }
        hideSlidePanel(event);
    });

    $(document).on('keyup', function(event) {
        if (event.key === 'Escape' &&
    ($('.slide-panel').hasClass('active') ||
      $('#mta-always-open-slider')[0])) {
            if ($('#mta-always-open-slider')[0]) {
                const startPage = sessionStorage.getItem('MTAStartPage');
                const options = {
                    redirectUrl: startPage,
                };
                bgl.common.pubsub.emit('CancelMTA', options);
                return;
            } else if ($('#' +
        getSlidePanelId()).attr('data-confirmation') == 'true') {
                bgl.common.pubsub.emit('CancelMTA');
                return;
            }
            hideSlidePanel(event);
        }
    });

    $(document).on('keydown', function(event) {
        const tabKeyCode = 9;

        if ($('.slide-panel').hasClass('active')) {
            if (event.which === tabKeyCode || event.keyCode === tabKeyCode) {
                const firstTabbable = getFirstTabbableElement($('.slide-panel.active'));
                const lastTabbable = getLastTabbableElement($('.slide-panel.active'));

                if (!event.shiftKey) {
                    if (lastTabbable.is(':focus') || focusIsWithinLastRadioGroup(lastTabbable)) {
                        event.preventDefault();
                        firstTabbable.focus();
                    }
                } else if (event.shiftKey) {
                    if (firstTabbable.is(':focus')) {
                        event.preventDefault();
                        lastTabbable.focus();
                    }
                }
            }
        }
    });

    function focusIsWithinLastRadioGroup(lastTabbable) {
        return (
            $(':focus').is('[type = "radio"]') &&
      lastTabbable.is('[type = "radio"]') &&
      $(':focus').attr('name') === lastTabbable.attr('name')
        );
    }

    function getSlidePanelId() {
        return 'SlidePanel';
    }

    function getSlidePanelContentId() {
        return 'SlidePanelContent';
    }

    function getFirstTabbableElement(el) {
        return el.find(':tabbable').first();
    }

    function getLastTabbableElement(el) {
        return el.find(':tabbable').last();
    }

    function openPanelByAction(linkId, url, options, containerId) {
        options = options || {};

        containerId =
      containerId || bgl.common.contentpanel.getSlidePanelContentId();

        $(document).ready(function() {
            $('#' + linkId)
                .off('click')
                .on('click', function(event) {
                    event.preventDefault();

                    bgl.common.loader.load(options, url, containerId);
                });
        });
    }

    function openPanelByClick(linkId) {
        const link = $('#' + linkId);

        openPanelByAction(
            linkId,
            link.data('action-url'),
            null,
            link.data('container'),
        );
    }

    function loadAndDisplaySidePanel(options, url, callback) {
        bgl.common.loader.load(options, url, getSlidePanelContentId(), callback);
        show($('#' + getSlidePanelId()));
    }

    return {
        getSlidePanelId: getSlidePanelId,
        getSlidePanelContentId: getSlidePanelContentId,
        getFirstTabbableElement: getFirstTabbableElement,
        getLastTabbableElement: getLastTabbableElement,
        openPanelByAction: openPanelByAction,
        openPanelByClick: openPanelByClick,
        loadAndDisplaySidePanel: loadAndDisplaySidePanel,
        hideSlidePanel: hideSlidePanel,
    };
})();

bgl.common.autocompletesearch = (function() {
    let autocompleteMinLength;
    const TAB_KEYCODE = 9;
    const ENTER_KEYCODE = 13;
    const ARROW_UP_KEYCODE = 38;
    const ARROW_DOWN_KEYCODE = 40;
    const activeClass = 'ui-menu-item-active';

    function init(symbolsCountToTriggerSearch) {
        autocompleteMinLength = symbolsCountToTriggerSearch || 1;

        const inputs = $(document.body).find('[autocompletesearch]');

        $.each(inputs, function(index, element) {
            const input = $(element);
            prepareDOM(input);

            input.on('keyup', inputKeyUpHandler).autocomplete({
                minLength: symbolsCountToTriggerSearch,
                appendTo: '#' + input.parent().attr('id'),
                source: function(request, response) {
                    makeAjaxRequest(input, response);
                },
                response: function(event, ui) {
                    const len = ui.content.length;
                    $('#span-autocomplete').html(
                        len +
                        ' results are available, use up and down arrow keys to navigate.',
                    );
                },
                focus: function(event, ui) {
                    selectOption(input, ui.item);

                    unhighlight($(this));
                    highlightActiveElement($(this));

                    event.preventDefault();
                },
                select: function(event, ui) {
                    selectOption(input, ui.item);

                    unhighlight($(this));

                    event.preventDefault();
                },
            });

            overrideItemsDrawing(input);
        });
    }

    function highlightActiveElement(input) {
        const activeItem = input.data('ui-autocomplete').menu.active;
        activeItem.addClass(activeClass);
    }

    function unhighlight(input) {
        input.parent().find('ul li').removeClass(activeClass);
    }

    function prepareDOM(input) {
        const inputId = input.attr('id');
        const parentElement = input.parent();
        /* Add an identifier for the parent element,
    if necessary, to know for what block we need to draw list
    We will have DOM structure:
    <div>
    <input />
    <ul></ul>
    </div>
    */
        const span = $('<span />')
            .attr({'role': 'status',
                'aria-live': 'polite',
                'id': 'span-autocomplete'})
            .addClass('visually-hidden');
        if (!parentElement.attr('id')) {
            parentElement.attr('id', inputId + 'ParentElement');
        }
        parentElement.append(span);
    }

    function inputKeyUpHandler(event) {
        const code = event.charCode || event.keyCode;

        const codesForOptionSelecting = [
            ENTER_KEYCODE,
            ARROW_UP_KEYCODE,
            ARROW_DOWN_KEYCODE,
            TAB_KEYCODE,
        ];

        if (code && codesForOptionSelecting.indexOf(code) !== -1) {
            event.preventDefault();

            /* Set value in autocomplete input control and
      item id into hidden field for it*/
            const selectedItem = $(this).autocomplete('instance').selectedItem;
            if (selectedItem) {
                selectOption($(this), selectedItem);
            }
        } else {
            // Reset selected item id if we have this field on DOM
            const hiddenFieldForItemId = getHiddenFieldForItemId($(this));
            if (hiddenFieldForItemId.length) {
                hiddenFieldForItemId.val('');
            }

            if ($(this).val().length >= autocompleteMinLength) {
                // Remove validation message for input
                bgl.common.validator.resetValidationState($(this));
            }
        }
    }

    function getHiddenFieldForItemId(input) {
        return $('#' + input.attr('id') + 'Id');
    }

    function selectOption(input, item) {
        input.val(item.label);

        const hiddenFieldForItemId = getHiddenFieldForItemId(input);
        if (hiddenFieldForItemId.length) {
            hiddenFieldForItemId.val(item.value);
            hiddenFieldForItemId.trigger('focusout');
        }
    }

    function overrideItemsDrawing(input) {
        input.data('ui-autocomplete')._renderItem = function(ul, item) {
            ul.attr('role', 'listbox');
            return $('<li role="option">').append(item.label).appendTo(ul);
        };
    }

    function makeAjaxRequest(input, response) {
        $.ajax({
            url: input.attr('autocompletesearch'),
            data: {enteredData: input.val().trim()},
            type: 'GET',
            success: function(data) {
                if (data.isSuccess) {
                    response(
                        $.map((data.searchOptionItems), function(item) {
                            return {label: item.Value, value: item.Key};
                        }),
                    );
                } else {
                    bgl.common.utilities.errorRedirect((data.errorRedirectUrl));
                }
            },
        });
    }

    return {
        init: init,
    };
})();

bgl.common.datastore = (function() {
    const dataStoreAttributeName = 'data-store';
    const dropdownTextSuffix = 'Text';
    const dropdownValueSuffix = 'Val';

    function setupReadAndWrite() {
        setupRead();
        setupWrite();
    }

    function setupRead() {
        $('[data-store]').each(function() {
            const element = $(this);
            const dataStoreItem = readDataStoreValue(element);
            if (element.is('input, textarea')) {
                if (dataStoreItem) {
                    if (isRadioButton(element)) {
                        if (element[0].defaultValue === dataStoreItem) {
                            element.prop('checked', true);
                        }
                    } else {
                        element.val(dataStoreItem);
                        if (!isDatePicker(element)) {
                            element.focus().focusout();
                        }
                    }
                } else if (isDatePicker(element)) {
                    element.datepicker('setDate', '0');
                    writeDataStoreValue(element);
                }
            } else if (element.is('select')) {
                setDropDownToStoredValue(element);
            } else if (element.is('span')) {
                element.html(dataStoreItem);
            } else if (element.is('strong')) {
                element.html(dataStoreItem);
            }
        });
    }

    function setupWrite() {
        $('select[data-store]').change(function() {
            writeDataStoreDropDownValue($(this));
        });

        $('input[data-store]').on('focusout', function() {
            writeDataStoreValue($(this));
        });
        $('input[data-store-keyup]').on('keyup', function() {
            writeDataStoreValue($(this));
        });
        $('input[data-store][type=text], textarea[data-store]').on(
            'keyup',
            function() {
                writeDataStoreValue($(this));
            },
        );
        $('input[data-store][type=number]').on('change', function() {
            writeDataStoreValue($(this));
        });

        $('input[data-store][type=number]').on('keyup', function() {
            writeDataStoreValue($(this));
        });

        $('input[data-store][type=tel]').on('change', function() {
            writeDataStoreValue($(this));
        });

        $('input[data-store][type=tel]').on('keyup', function() {
            writeDataStoreValue($(this));
        });
        $('input[data-store][type=radio]').on('change', function() {
            $(this).focusout();
        });

        $('input[data-store][type=hidden]').each(function() {
            writeDataStoreValue($(this));
        });
    }

    function readDataStoreValue($element, suffix) {
        const journeyKey = getJourneyKey($element);

        let elementValue;
        let keyOfValue = $element.attr(dataStoreAttributeName);

        if (suffix) {
            keyOfValue += suffix;
        }

        if (journeyKey) {
            const journeyData = JSON.parse(sessionStorage.getItem(journeyKey)) || {};
            elementValue = journeyData[keyOfValue];
        } else {
            elementValue = sessionStorage.getItem(keyOfValue);
        }

        return elementValue;
    }

    function writeDataStoreValue($element) {
        const journeyKey = getJourneyKey($element);
        const key = $element.attr(dataStoreAttributeName);
        const elementValue = $element.val();

        if (journeyKey) {
            const journeyData = JSON.parse(sessionStorage.getItem(journeyKey)) || {};

            journeyData[key] = elementValue;
            sessionStorage.setItem(journeyKey, JSON.stringify(journeyData));
        } else {
            sessionStorage.setItem(key, elementValue);
        }
    }

    function writeDataStoreDropDownValue($dropdown) {
        const journeyKey = getJourneyKey($dropdown);
        const key = $dropdown.attr(dataStoreAttributeName);
        const textKey = $dropdown.attr(dataStoreAttributeName) + dropdownTextSuffix;
        const valueKey = $dropdown.attr(dataStoreAttributeName) +
    dropdownValueSuffix;

        const dropdownText = $dropdown.find(':selected').text();
        const dropdownValue = $dropdown.find(':selected').val();

        if (journeyKey) {
            const journeyData = JSON.parse(sessionStorage.getItem(journeyKey)) || {};

            journeyData[textKey] = dropdownText;
            journeyData[valueKey] = dropdownValue;
            journeyData[key] = dropdownValue;
            sessionStorage.setItem(journeyKey, JSON.stringify(journeyData));
        } else {
            sessionStorage.setItem(textKey, dropdownText);
            sessionStorage.setItem(valueKey, dropdownValue);
            sessionStorage.setItem(key, dropdownValue);
        }
    }

    function getJourneyKey($element) {
        return $element.closest('[data-store-key]').attr('data-store-key');
    }

    function isDatePicker(element) {
        return element.hasClass('form-row__input--datepicker');
    }

    function isRadioButton(element) {
        return element.is('[type=radio]');
    }

    function setDropDownToStoredValue($dropdown) {
        const dataStoreVal = readDataStoreValue($dropdown, dropdownValueSuffix);

        if (dataStoreVal) {
            $dropdown.val(dataStoreVal);
        } else {
            writeDataStoreDropDownValue($dropdown);
        }
    }

    function getFormKey(selector) {
        if (typeof selector === 'object' && selector !== null) {
            return selector.data('store-key');
        }

        return selector;
    }

    function init(form, needToResetDirtyFlag, mergeFormsByKey) {
        form = $(form);
        if (needToResetDirtyFlag === undefined || needToResetDirtyFlag === true) {
            resetDirtyFlag(form);
        }

        const key = getFormKey(form);

        if (key !== undefined && key !== null) {
            if (mergeFormsByKey) {
                let collectedData = JSON.parse(sessionStorage.getItem(key));
                if (!collectedData) {
                    collectedData = {isFormDirty: false};
                    sessionStorage.setItem(key, JSON.stringify(collectedData));
                }
            } else {
                sessionStorage.setItem(key, buildJson(form));
            }

            subscribeForChange(form);
        }
    }

    function removeSessionStorage(form) {
        if (!(form instanceof jQuery) &&
    !(typeof form === 'string' ||
    form instanceof String)) {
            form = $(form);
        }
        const key = getFormKey(form);
        sessionStorage.removeItem(key);
    }

    function getModelFromSessionStorage(key) {
        return JSON.parse(sessionStorage.getItem(key));
    }

    function buildJson(form, isDirty) {
        const key = getFormKey(form);
        const data = getModelFromSessionStorage(key) || {};

        if (data.hasOwnProperty('isFormDirty') !== true) {
            data.isFormDirty = false;
        }

        if (isDirty !== undefined) {
            data.isFormDirty = isDirty;
        }

        expandDataWithHiddenFields(form, data);

        return JSON.stringify(data);
    }

    function isHiddenFieldsChanged(sessionStorageData, form) {
        const formHiddenData = {};
        expandDataWithHiddenFields(form, formHiddenData);

        for (const key in formHiddenData) {
            if (formHiddenData.hasOwnProperty(key)) {
                if (formHiddenData[key] !== sessionStorageData[key]) {
                    return true;
                }
            }
        }
        return false;
    }

    function expandDataWithHiddenFields(form, formData) {
        form
            .find('input[type=hidden]')
            .not('input[name="__RequestVerificationToken"]')
            .not('input[data-store-skip]')
            .each(function() {
                const input = $(this);
                formData[input.attr('name')] = input.val();
            });
    }

    function isDataChanged(form) {
        form = $(form);
        const key = getFormKey(form);

        if (key === undefined || key === null) {
            return false;
        }

        const data = getModelFromSessionStorage(key);

        return data.isFormDirty || isHiddenFieldsChanged(data, form);
    }

    function subscribeForChange(form) {
        const key = getFormKey(form);

        form.off('change').on('change', function() {
            sessionStorage.setItem(key, buildJson(form, true));
        });
    }

    function resetDirtyFlag(form) {
        form = $(form);
        const key = getFormKey(form);

        if (key !== undefined && key !== null) {
            sessionStorage.setItem(key, buildJson(form, false));
        }
    }

    function extendCollectedData(selector, data) {
        const key = getFormKey(selector);

        if (key) {
            let formData = JSON.parse(sessionStorage.getItem(key));
            formData = $.extend(formData, data);
            sessionStorage.setItem(key, JSON.stringify(formData));
        }
    }

    function deleteFields(selector, fieldNameList) {
        if (!(selector instanceof jQuery) &&
    !(typeof selector === 'string' ||
      selector instanceof String)) {
            selector = $(selector);
        }
        const key = getFormKey(selector);

        if (key) {
            const formData = JSON.parse(sessionStorage.getItem(key));
            if (formData) {
                $.each(fieldNameList, function(key, value) {
                    delete formData[value];
                });
            }
            sessionStorage.setItem(key, JSON.stringify(formData));
        }
    }

    function getData(selector) {
        if (!(selector instanceof jQuery) &&
    !(typeof selector === 'string' ||
      selector instanceof String)) {
            selector = $(selector);
        }
        const key = getFormKey(selector);

        if (key !== undefined && key !== null) {
            return getModelFromSessionStorage(key);
        }

        return {};
    }

    return {
        setupRead: setupRead,
        setupWrite: setupWrite,
        setupReadAndWrite: setupReadAndWrite,
        init: init,
        removeSessionStorage: removeSessionStorage,
        isDataChanged: isDataChanged,
        resetDirtyFlag: resetDirtyFlag,
        extendCollectedData: extendCollectedData,
        deleteFields: deleteFields,
        getData: getData,
    };
})();

bgl.common.overlay = (function() {
    const overlayId = 'overlay';
    function show(showSpinner = true) {
        if ($(document.body).find(`#${overlayId}`).length == 0) {
            const overlay = getOverlay(showSpinner);
            $(document.body).append(overlay);
        }
    }

    function hide() {
        $(document.body).find(`#${overlayId}`).remove();
    }

    function getOverlay(showSpinner) {
        let overlayHTML = `<div id="${overlayId}" class="addonOverlay show"></div>`;

        if (showSpinner) {
            overlayHTML = `<div id="${overlayId}" class="addonOverlay show">`;
            return (
                overlayHTML +
                `<div class="spinner-wrapper">` +
                '<div class="spinner">' +
                '<div class="addon-spinner"></div>' +
                '</div></div></div>'
            );
        } else {
            return overlayHTML;
        }
    }
    return {
        show: show,
        hide: hide,
        getOverlay: getOverlay,
    };
})();

bgl.common.focusHolder = (function() {
    const focusKey = 'focusedElement';

    function setFocusedElement(focusedElement) {
        sessionStorage.setItem(focusKey, focusedElement);
    }

    function setFocusedElementId(focusedElement) {
        const id = $(focusedElement).prop('id');

        sessionStorage.setItem(focusKey, id);
    }

    function setFocusToElement(focusOveride) {
        let lastFocusedOn;

        if (focusOveride) {
            $(focusOveride).focus();
        } else {
            lastFocusedOn = sessionStorage.getItem(focusKey);
            if (lastFocusedOn !== null && lastFocusedOn !== 'undefined') {
                $('[data-focusid="' + lastFocusedOn + '"]').focus();
                removeFocused();
            } else {
                $('#header-focus').focus();
            }
        }
    }

    function setFocusToElementById() {
        const lastFocusedOn = sessionStorage.getItem(focusKey);

        if (lastFocusedOn) {
            const element = document.getElementById(lastFocusedOn);
            if (element) {
                element.focus();
            }
            removeFocused();
        }
    }

    function removeFocused() {
        sessionStorage.removeItem(focusKey);
    }

    return {
        setFocusedElement: setFocusedElement,
        setFocusToElement: setFocusToElement,
        setFocusToElementById: setFocusToElementById,
        setFocusedElementId: setFocusedElementId,
        removeFocused: removeFocused,
    };
})();

bgl.common.tabulation = (function() {
    $(document).keydown(function(e) {
        if (e.shiftKey && e.which === 9) {
            $(':focusable').focus(function() {
                const elem = $(this);
                const headerHeight = $('#fixed-header').height();

                if (isElementUnderHeader(elem, headerHeight)) {
                    const scrollY = elem.offset().top - headerHeight * 2;

                    $(window).scrollTop(scrollY);
                }
            });
        }
    });

    function isElementUnderHeader(element, headerHeight) {
        const headerTop = $(window).scrollTop() + headerHeight;
        const elemTop = element.offset().top - headerHeight;

        return elemTop <= headerTop;
    }
})();

bgl.common.helptext = (function() {
    $(document).on('click', '[data-open-close-help-text]', function(event) {
        event.preventDefault();
        $(this).toggleClass('active');
        $('.help-text').fadeToggle();
    });
})();

bgl.common.date = (function() {
    const BglDateFormat = function(value) {
        this.formattedDate = value;
    };

    BglDateFormat.prototype.removeAllCharactersApartFromDigitsAndForwardSlashes =
    function() {
        this.formattedDate = this.formattedDate.replace(/[^\d\/]/g, '');
        return this;
    };

    BglDateFormat.prototype.addFowardSlashBetweenDayAndMonth = function() {
        this.formattedDate = this.formattedDate.replace(
            /^(\d\d)(\d{1,2})$/g,
            '$1/$2',
        );
        return this;
    };

    BglDateFormat.prototype.appendSingleDigitDayWithZero = function() {
        this.formattedDate = this.formattedDate.replace(/^(\d)\/$/g, '0$1/');
        return this;
    };

    BglDateFormat.prototype.appendSingleDigitMonthWithZero = function() {
        this.formattedDate = this.formattedDate.replace(
            /^(\d\d)\/(\d)\/$/g,
            '$1/0$2/',
        );
        return this;
    };

    BglDateFormat.prototype.addForwardSlashBetweenMonthAndYear = function() {
        this.formattedDate = this.formattedDate.replace(
            /^(\d\d\/\d\d)(\d+)$/g,
            '$1/$2',
        );
        return this;
    };

    BglDateFormat.prototype.preventMoreThanFourYearDigits = function() {
        this.formattedDate = this.formattedDate.replace(
            /^(\d\d\/\d\d\/\d\d\d\d)(\d+)$/g,
            '$1',
        );
        return this;
    };

    BglDateFormat.prototype.generateFormattedDate = function() {
        this.removeAllCharactersApartFromDigitsAndForwardSlashes()
            .addFowardSlashBetweenDayAndMonth()
            .appendSingleDigitDayWithZero()
            .appendSingleDigitMonthWithZero()
            .addForwardSlashBetweenMonthAndYear()
            .preventMoreThanFourYearDigits();
        return this.formattedDate;
    };

    function initDateFormat($input) {
        $input.on('keyup', function() {
            const date = new BglDateFormat($(this).val());
            $(this).val(date.generateFormattedDate());
        });
    }

    return {
        initDateFormat: initDateFormat,
    };
})();

bgl.common.customselect = (function() {
    const DOWN_ARROW_KEY_CODE = 40;
    const UP_ARROW_KEY_CODE = 38;
    const TAB_KEY_CODE = 9;

    function toggleOptions(control, callback) {
        const container = control.find('[data-custom-select-container]');

        if (container.hasClass('active')) {
            closeOptions(control, callback);
        } else {
            openOptions(control, callback);
        }
    }

    function openOptions(control, callback) {
        const container = control.find('[data-custom-select-container]');

        if (!container.hasClass('active')) {
            container.addClass('active');
            container.attr('aria-expanded', true);

            const selected = getSelectedItem(control);

            if (selected) {
                selected.focus();
            } else {
                getItems(control)[0].focus();
            }

            typeof callback === 'function' && callback();
        }
    }

    function closeOptions(control, callback) {
        const container = control.find('[data-custom-select-container]');

        if (container.hasClass('active')) {
            control.find('[data-custom-select-button]').focus();

            container.removeClass('active');
            container.attr('aria-expanded', false);

            typeof callback === 'function' && callback();
        }
    }

    function navigate(event, control, closeCallback) {
        const activeElement = $(event.target);

        switch (event.keyCode) {
        case DOWN_ARROW_KEY_CODE:
            event.preventDefault();
            moveToNextItem(activeElement);
            return;

        case UP_ARROW_KEY_CODE:
            event.preventDefault();
            moveToPrevItem(activeElement);
            return;

        case TAB_KEY_CODE:
            event.preventDefault();
            closeOptions(control, closeCallback);

            if (!event.shiftKey) {
                focusNextElement(control);
            }
            return;

        default:
            return;
        }
    }

    function moveToNextItem(activeElement) {
        const listItems = activeElement
            .siblings('[data-custom-select-item]')
            .addBack();
        const itemIndex = listItems.index(activeElement);

        if (itemIndex !== listItems.length - 1) {
            listItems[itemIndex + 1].focus();
        }
    }

    function moveToPrevItem(activeElement) {
        const listItems = activeElement
            .siblings('[data-custom-select-item]')
            .addBack();
        const itemIndex = listItems.index(activeElement);

        if (itemIndex > 0) {
            listItems[itemIndex - 1].focus();
        }
    }

    function focusNextElement(control) {
        const focusableElements = $(':tabbable');
        const button = control.find('[data-custom-select-button]');
        let index = focusableElements.index(button);
        index = index += 1;

        if (index < focusableElements.length) {
            focusableElements[index].focus();
        } else {
            focusableElements[0].focus();
        }
    }

    function selectItem(activeElement, callback) {
        const listItems = activeElement.siblings('[data-custom-select-item]');
        const list = activeElement.closest('[data-custom-select-list]');

        list.attr('aria-activedescendant', activeElement.attr('id'));

        listItems.each(function(i, el) {
            $(el).removeClass('selected');
            $(el).removeAttr('aria-selected');
        });

        activeElement.addClass('selected');
        activeElement.attr('aria-selected', true);

        typeof callback === 'function' && callback();
    }

    function getSelectedItem(control) {
        return control.find('[data-custom-select-item].selected');
    }

    function getButton(control) {
        return control.find('[data-custom-select-button]');
    }

    function getContainer(control) {
        return control.find('[data-custom-select-container]');
    }

    function getItems(control) {
        return control.find('[data-custom-select-item]');
    }

    function isOpen(control) {
        const modal = control.find('[data-custom-select-container]');
        return modal.hasClass('active');
    }

    return {
        toggleOptions: toggleOptions,
        openOptions: openOptions,
        closeOptions: closeOptions,
        navigate: navigate,
        selectItem: selectItem,
        getSelectedItem: getSelectedItem,
        getButton: getButton,
        getContainer: getContainer,
        getItems: getItems,
        isOpen: isOpen,
    };
})();

bgl.common.tabs = (function() {
    $(document).on('click', '[data-tab] button', function(event) {
        event.stopImmediatePropagation();
        selectTab($(this));
        this.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
        });
        event.preventDefault();
    });

    $(document).on('click', '#left-arrow', function(event) {
        event.stopImmediatePropagation();

        const tabItems = $('.tabs-nav__item');
        for (let i = 0; i < tabItems.length; i++) {
            if (tabItems[i].classList.contains('active')) {
                const tabItem = $('#tab-' + (i - 1));
                selectTab(tabItem);
                tabItem[0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'start',
                });
                break;
            }
        }
    });

    $(document).on('click', '#right-arrow', function(event) {
        event.stopImmediatePropagation();

        const tabItems = $('.tabs-nav__item');
        for (let i = 0; i < tabItems.length; i++) {
            if (tabItems[i].classList.contains('active')) {
                const tabItem = $('#tab-' + (i + 1));
                selectTab(tabItem);
                tabItem[0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'start',
                });
                break;
            }
        }
    });

    function showHideArrows() {
        const navTabs = $('.tabs-nav__item');
        const leftArrow = $('#left-arrow');
        const rightArrow = $('#right-arrow');
        if (navTabs[0].classList.contains('active')) {
            leftArrow.addClass('hide');
            leftArrow.attr('aria-hidden', 'true');
            rightArrow.removeClass('hide');
            rightArrow.attr('aria-hidden', 'false');
        } else if (navTabs[navTabs.length - 1].classList.contains('active')) {
            rightArrow.addClass('hide');
            rightArrow.attr('aria-hidden', 'true');
            leftArrow.removeClass('hide');
            leftArrow.attr('aria-hidden', 'false');
        } else {
            rightArrow.removeClass('hide');
            rightArrow.attr('aria-hidden', 'false');
            leftArrow.removeClass('hide');
            leftArrow.attr('aria-hidden', 'false');
        }
    }

    function selectTab(element) {
        const tabContainer = element.closest('[data-tab-container]');
        const selectedTab = element.parent('[data-tab]');
        const selectedTabContent = tabContainer.find(
            '[data-tab-content=' + selectedTab.data('tab') + ']',
        );
        const tabs = tabContainer.find('[data-tab]');
        const tabButtons = tabContainer.find('[data-tab] button');
        const tabContent = tabContainer.find('[data-tab-content]');

        tabs.removeClass('active');
        tabButtons.attr('aria-selected', 'false');
        tabContent.removeClass('active').attr('aria-hidden', 'true');

        selectedTab.addClass('active');
        element.attr('aria-selected', 'true');
        selectedTabContent.addClass('active').attr('aria-hidden', 'false');

        showHideArrows();
    }
})();

bgl.common.keyboardAccessibility = (function() {
    const SPACE_KEYCODE = 32;
    const ENTER_KEYCODE = 13;

    function generateClickOnKeypress(event) {
        const code = event.charCode || event.keyCode;

        if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
            const forAttr = $(event.target).attr('for');

            if (forAttr !== null) {
                $('#' + forAttr).click();
            } else {
                $(this).click();
            }
        }
    }

    return {
        generateClickOnKeypress: generateClickOnKeypress,
    };
})();

bgl.common.timeoutCounter = (() => {
    let timer;
    let sessionTimeoutRedirectUrl;
    const customerPromptButtonSelector = '[data-timeout-modal-button]';
    const customerPromptId = 'timeoutModal';
    const hiddenAttribute = 'hidden';
    const lastActionTimeKey = 'lastActionTime';
    const tenSeconds = 10000;
    const keepAlivePath = 'api/KeepAlive';
    let fullKeepAlivePath;
    let modalPopup;
    let sessionDuration;

    function init(timeoutDurationMins, sessionTimeoutRedirect, applicationPath) {
        setupVariables(
            document.getElementById(customerPromptId),
            applicationPath,
            sessionTimeoutRedirect,
            timeoutDurationMins);
        setupButtonClick(document.querySelectorAll(customerPromptButtonSelector));
        hideCustomerPrompt(modalPopup);
        startCountdown();
    }

    function setupVariables(
        popup,
        applicationPath,
        sessionTimeoutRedirect,
        timeoutDurationMins) {
        fullKeepAlivePath = applicationPath + keepAlivePath;
        modalPopup = popup;
        sessionTimeoutRedirectUrl = sessionTimeoutRedirect;
        sessionDuration = timeoutDurationMins * 60;
    }

    function setupButtonClick(buttons) {
        buttons.forEach((element) => {
            element.addEventListener(
                'click',
                bgl.common.timeoutCounter.extendSession);
        });
    }

    function extendSession() {
        fetch(fullKeepAlivePath).then(() => {
            hideCustomerPrompt(modalPopup);
            startCountdown();
        }).catch(() => {
            bgl.common.telemetry.logTrace('extend session failed', '', 'Information');
            bgl.common.utilities.redirectToUrl(sessionTimeoutRedirectUrl);
        });
    }

    function checkRemaningDuration() {
        const lastActionTime = localStorage[lastActionTimeKey];
        const currentTime = (new Date()).getTime() / 1000;
        const remainingDuration = lastActionTime - (currentTime - sessionDuration);

        if (remainingDuration <= 0) {
            sessionHasExpired();
            return;
        }

        if (remainingDuration <= 60) {
            showCustomerPrompt(modalPopup);
        } else if (!modalPopup.hasAttribute(hiddenAttribute)) {
            // if the popup is clicked on the other tab, this tab should close it too
            hideCustomerPrompt(modalPopup);
        }
    }

    function startCountdown() {
        clearInterval(timer);
        localStorage[lastActionTimeKey] = (new Date()).getTime() / 1000;
        timer = setInterval(checkRemaningDuration, tenSeconds);
    }

    function sessionHasExpired() {
        clearInterval(timer);
        bgl.common.telemetry.logTrace('session has expired', '', 'Information');
        bgl.common.utilities.redirectToUrl(sessionTimeoutRedirectUrl);
    }

    function showCustomerPrompt(modal) {
        modal.removeAttribute(hiddenAttribute);
    }

    function hideCustomerPrompt(modal) {
        modal.setAttribute(hiddenAttribute, true);
    }

    return {
        init: init,
        setupVariables: setupVariables,
        setupButtonClick: setupButtonClick,
        startCountdown: startCountdown,
        extendSession: extendSession,
    };
})();

bgl.common.headers = (function() {
    document.addEventListener('DOMContentLoaded', function() {
        const nav = document.getElementById('header-breadcrumbs');
        const scrollThreshold = 550;

        window.addEventListener('scroll', function() {
            const currentScrollY = window.scrollY;

            if (nav) {
                if (currentScrollY > scrollThreshold) {
                    nav.classList.add('page-header-agg__section--hidden');
                } else {
                    nav.classList.remove('page-header-agg__section--hidden');
                }
            }
        });
    });

    function init(scrollLimit) {
        window.addEventListener('scroll', () => {
            const dynamicHeader = document.getElementById('dynamic-page-header');
            const dynamicHeaderExpanded = document.getElementById('dynamic-page-header-expanded');

            if (window.scrollY > scrollLimit) {
                if (dynamicHeader) {
                    dynamicHeader.classList.remove('absolute');
                }
                if (dynamicHeaderExpanded) {
                    dynamicHeaderExpanded.classList.add('hide');
                }
            } else {
                if (dynamicHeader) {
                    dynamicHeader.classList.add('absolute');
                }
                if (dynamicHeaderExpanded) {
                    dynamicHeaderExpanded.classList.remove('hide');
                }
            }
        });
    }

    return {
        init: init,
    };
})();

bgl.common.tooltip = (function() {
    function init() {
        subscribeToEvents();
    }

    function subscribeToEvents() {
        const tooltips = [...document.querySelectorAll('[data-tooltip]')];
        if (tooltips) {
            tooltips.forEach((tooltip) => {
                tooltip.querySelector('[data-tooltip-open]')
                    .addEventListener('click', (event) => {
                        tooltip.querySelector('[data-tooltip-wrapper]')
                            .classList.remove('hide');
                        tooltip.querySelector('[data-tooltip-wrapper]')
                            .focus();
                    });
                tooltip.querySelector('[data-tooltip-close]')
                    .addEventListener('click', (event) => {
                        tooltip.querySelector('[data-tooltip-wrapper]')
                            .classList.add('hide');
                        tooltip.querySelector('[data-tooltip-open]').focus();
                    });
            });
        }
    }

    return {
        init: init,
    };
})();

bgl.common.fetch = (() => {
    function configureBaseOptions(options) {
        if (!options.headers) {
            options.headers = {
                'X-Requested-With': 'XMLHttpRequest',
            };
        }
        options.headers['X-Requested-With'] = 'XMLHttpRequest';

        return options;
    }

    function configureFormPostOptions(options) {
        options = configureBaseOptions(options);

        if (!options.headers['Content-Type']) {
            options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        }

        if (!options.body || options.body === {}) {
            throw new Error('Body cannot be empty / undefined');
        }

        options.method = 'POST';

        return options;
    }

    function formPost(action, options) {
        try {
            return fetch(action, configureFormPostOptions(options));
        } catch (exception) {
            return new Promise((resolve, reject) => {
                resolve(new Response(null, {status: 500, statusText: exception.message}));
            });
        }
    }

    return {
        formPost,
    };
})();

bgl.common.telemetry = (() => {
    function logEvent(message, customData) {
        if (!window.appInsights) {
            return;
        }
        window.appInsights.trackEvent({
            name: message,
            properties: customData,
        });
        window.appInsights.flush();
    }

    function logTrace(message, customData, severityLevel) {
        if (!window.appInsights) {
            return;
        }
        window.appInsights.trackTrace({
            message: message,
            properties: customData,
            severityLevel: severityLevel,
        });
        window.appInsights.flush();
    }

    function logException(exception) {
        if (!window.appInsights) {
            return;
        }
        window.appInsights.trackException({
            exception: exception,
        });
        window.appInsights.flush();
    }

    return {
        logEvent,
        logTrace,
        logException,
    };
})();

bgl.common.modalOverlay = (() => {
    function openOverlay(overlayId) {
        const overlay = document.getElementById(overlayId);
        if (overlay) {
            overlay.classList.remove('hide');
            document.body.classList.add('modal-open');
            bgl.common.pubsub.emit('modalOverlay:opened', {overlayId});
        }
    }

    function closeOverlay(overlayId) {
        const overlay = document.getElementById(overlayId);
        if (overlay) {
            overlay.classList.add('hide');
            document.body.classList.remove('modal-open');
            bgl.common.pubsub.emit('modalOverlay:closed', {overlayId});
        }
    }

    function initializeTriggers() {
        // Open overlay triggers
        const triggerButtons = document.querySelectorAll('[data-overlay-trigger]');
        triggerButtons.forEach(function(button) {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                const overlayId = this.getAttribute('data-overlay-id');
                openOverlay(overlayId);
            });
        });

        // Close overlay triggers
        const closeButtons = document.querySelectorAll('[data-overlay-close]');
        closeButtons.forEach(function(button) {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                const overlayId = this.getAttribute('data-overlay-id');
                closeOverlay(overlayId);
            });
        });

        // Close when clicking outside the overlay content
        const overlays = document.querySelectorAll('.overlay');
        overlays.forEach(function(overlay) {
            overlay.addEventListener('click', function(e) {
                if (e.target === this) {
                    closeOverlay(this.id);
                }
            });
        });
    }

    function init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initializeTriggers);
        } else {
            initializeTriggers();
        }
    }

    return {
        init,
        open: openOverlay,
        close: closeOverlay,
        initializeTriggers,
    };
})();

bgl.common.scrollDownBanner = (() => {
    function init(bannerId, amountToScrollBeforeHiding) {
        document.addEventListener('scroll', function() {
            const heightOfPage = document.body.scrollHeight;
            const heightOfWindow = window.innerHeight;
            const amountWeScrolled = window.scrollY;

            const weScrolledEnoughToHide = amountWeScrolled > amountToScrollBeforeHiding;
            const weGotToTheBottom = amountWeScrolled >= heightOfPage - heightOfWindow;

            if (weScrolledEnoughToHide || weGotToTheBottom) {
                const banner = document.querySelector('#' + bannerId);
                if (banner) {
                    banner.classList.add('disappear');
                }
            }
        });
    }

    return {
        init,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};

bgl.components.welcomequotepaymentoptions = (function() {
    let configuration;
    let welcomeQuoteSchedule;
    let creditAgreementContainer;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;

        if (configuration.UseRadioPaymentOptions) {
            initComponentWithRadioOptions();
        } else {
            creditAgreementContainer = document.getElementById(configuration.Id + '__credit-agreement-section');

            [...creditAgreementContainer.querySelectorAll('[data-pay-schedule]')].map((el) => {
                el.addEventListener('click', function(e) {
                    e.preventDefault();
                    selectPaymentOption.call(this, e);
                });
            });
        }
    }

    function selectPaymentOption(event) {
        welcomeQuoteSchedule = this.dataset.paySchedule;
        const switchId = event.currentTarget.value;
        const paymentOptionContainer = document.getElementById(configuration.Id + '__payment-options_container');

        event.preventDefault();

        const dataToPost = {
            __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val(),
            paymentSwitchId: switchId,
        };

        $.ajax({
            url: configuration.TenantConfiguration.ApplicationPath + 'WelcomeQuoteComponent/PaymentSwitch',
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (result.isSuccess === true) {
                    const isMonthly = welcomeQuoteSchedule === 'monthly';

                    [
                        ...paymentOptionContainer
                            .querySelectorAll('.' + configuration.Id + '__payment-options-monthly'),
                    ].map((x) => x.classList.toggle('hide', !isMonthly));

                    [
                        ...paymentOptionContainer
                            .querySelectorAll('.' + configuration.Id + '__payment-options-annually'),
                    ].map((x) => x.classList.toggle('hide', isMonthly));

                    creditAgreementContainer
                        .querySelector('#' + configuration.Id + '__credit-agreement-monthly-section')
                        .classList
                        .toggle('hide', !isMonthly);

                    creditAgreementContainer
                        .querySelector('#' + configuration.Id + '__credit-agreement-annually-section')
                        .classList
                        .toggle('hide', isMonthly);
                    onSuccess();
                } else {
                    if (result.errorRedirectUrl != null) {
                        bgl.common.utilities.errorRedirect(result.errorRedirectUrl);
                        return;
                    }
                }
            },
        });
    }

    function initComponentWithRadioOptions() {
        const form = document.getElementById(configuration.Id + '__PaymentTypeForm');

        if (!form) {
            return;
        }

        [...form.querySelectorAll('[data-pay-schedule]')].map((radio) => {
            radio.addEventListener('change', selectPaymentWithRadioOptions);
        });
    }

    function selectPaymentWithRadioOptions(event) {
        welcomeQuoteSchedule = this.dataset.paySchedule;
        const creditAgreementContainer = document.getElementById(configuration.Id + '__credit-agreement-container');

        if (welcomeQuoteSchedule === 'monthly') {
            [
                ...creditAgreementContainer.querySelectorAll(
                    '[data-subtext="data-subtext-monthly"]',
                ),
            ].map((x) => x.classList.remove('hide'));
            creditAgreementContainer
                .querySelector('[data-subtext="data-subtext-annual"]')
                .classList.add('hide');
        } else if (welcomeQuoteSchedule === 'annually') {
            [
                ...creditAgreementContainer.querySelectorAll(
                    '[data-subtext="data-subtext-monthly"]',
                ),
            ].map((x) => x.classList.add('hide'));
            creditAgreementContainer
                .querySelector('[data-subtext="data-subtext-annual"]')
                .classList.remove('hide');
        }

        event.preventDefault();
        bgl.common.validator.submitForm($('#' + configuration.Id + '__PaymentTypeForm'), configuration);
    }

    function onSuccess() {
        bgl.common.focusHolder.setFocusedElement('quote_selector_option');
        bgl.common.pubsub.emit(
            'switchPaymentType',
            welcomeQuoteSchedule === 'monthly',
        );
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.welcomequotepaymentoptions;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};

bgl.components.virtualassistant = (function() {
    let applicationPath = '/';
    let notificationTimeout;
    let configuration;
    let autoCleared = true;
    let ujet;
    const defaultNotificationSettings = {
        autoClose: true,
        timeout: 10000,
    };

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
            });
    }

    async function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        applicationPath = componentConfiguration.TenantConfiguration.ApplicationPath;

        eventListener();
        await setUpVirtualAssistant();

        $(document.body).on('click', '[data-type="notification-button"], #notificationButton', function() {
            $('.notification-container').hide();
            autoCleared = false;
            resetFocus();
        });

        $(document).ready(function() {
            registerVirtualAssistant();
        });

        addVirtualAssistant();
    }

    function registerVirtualAssistant() {
        document.body.addEventListener('click', function(event) {
            if (event.target.id === 'chat-with-us-btn') {
                $('.notification-container').hide();
                bgl.common.pubsub.emit('OpenWebchat');
            }
        });
    }

    function getFormattedNotification(url) {
        $.get(url,
            function(data) {
                if (data.errorRedirectUrl) {
                    bgl.common.utilities.redirectToUrl(data.errorRedirectUrl);
                } else {
                    bgl.components.virtualassistant.showFormattedNotification(data, {autoClose: false});
                }
            });
    }

    function eventListener() {
        bgl.common.pubsub.on('showNotification', function(data) {
            bgl.components.virtualassistant.showNotification(data);
        });

        bgl.common.pubsub.on('showContactDataNotification', function() {
            getFormattedNotification(configuration.ContactDataUrl);
        });

        bgl.common.pubsub.on('showContactInformationNotification', function() {
            getFormattedNotification(configuration.ContactInformationUrl);
        });

        bgl.common.pubsub.on('refreshHoustonContext', function(callback) {
            refreshContext(callback);
        });

        bgl.common.pubsub.on('PaymentComplete', function() {
            clearSession();
        });

        bgl.common.pubsub.on('OpenWebchat', () => {
            ujet.show();
        });

        bgl.common.pubsub.on('CancelMTA', function(data) {
            $('#houstonConfirmation').removeClass('hide');

            $('#houstonConfirmation #continueButton').off().on('click',
                function() {
                    $('#houstonConfirmation').addClass('hide');
                });

            $('#houstonConfirmation #abandonButton').focus();
            $('#houstonConfirmation #abandonButton').off().on('click',
                function() {
                    if (bgl.common.utilities.getWindowLocation().href.toLowerCase().includes('changingyourpolicy') &&
                        !bgl.common.utilities.getWindowLocation().href.toLowerCase().includes('makechanges')) {
                        bgl.common.telemetry.logEvent('MTA Cancelled', {component: configuration.Id});
                    }

                    deleteBasket(data ? data.redirectUrl : null);
                });
        });
    }

    function stopNotificationTimeout() {
        if (notificationTimeout !== undefined) {
            clearTimeout(notificationTimeout);
        }
    }

    async function resolveChatHistory() {
        const lastUsed = localStorage.getItem('va:lastUsed');
        if (lastUsed?.toLowerCase() === 'quoteagent') {
            localStorage.removeItem('ujet:chat');
            localStorage.removeItem('va:lastUsed');
        }
    }

    async function setUpVirtualAssistant() {
        await resolveChatHistory();
        const signedData = await getSignedCustomData();
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        configuration.requestUrl = urlObj.pathname.replace(/^\//, '');

        const unsignedData = await getUnsignedCustomData(
            configuration.Brand,
            configuration.Application,
            configuration.requestUrl);

        // eslint-disable-next-line no-undef
        ujet = new UJET({
            companyId: configuration.CompanyId,
            host: configuration.HostUrl,
            authenticate: getAuthToken,
        });

        ujet.client.lang = 'en-GB';
        ujet.mount('#chat-widget');

        ujet.config({
            name: configuration.TenantConfiguration.Name,
            menuKey: getMenuKey(unsignedData.Product.value, unsignedData.ProductVariant.value),
            logo: configuration.LogoUrl,
            disableAttachment: true,
            signedCustomData: signedData,
            customData: unsignedData,
            messages: {
                en: {
                    event: {
                        escalationStarted: 'A representative will be with you shortly.',
                        memberLeft: configuration.Brand + ' virtual assistant just left the conversation',
                    },
                    menu: {
                        queueMessage: '',
                        greeting: '',
                    },
                    chat: {
                        startMessage: '',
                    },
                },
            },
        });

        preventRepositioningOfWebChatLaunchIcon();

        const chatWidgetElement = document.querySelector('#chat-widget');
        const widgetLauncher = chatWidgetElement.shadowRoot.querySelector('div div #widget-launcher');
        if (widgetLauncher) {
            widgetLauncher.addEventListener('click', (function(e) {
                bgl.common.pubsub.emit('WebchatOpened');
            }
            ));
        }
    }

    function addVirtualAssistant() {
        document.body.addEventListener('click', function(event) {
            if (event.target.hasAttribute('data-va-invocation-point')) {
                if (event.target.id === 'houstonButton') {
                    return;
                }

                $('.notification-container').hide();
                event.preventDefault();
                ujet.show();
            }
        });
    }

    function getMenuKey(product, productVariant) {
        if (product.toLowerCase() === 'home') {
            return configuration.HomeMenuKey;
        } else if (productVariant.toLowerCase().includes('online') &&
            configuration.OnlineOnlyMenuKey) {
            return configuration.OnlineOnlyMenuKey;
        }

        return configuration.MotorMenuKey;
    }

    function showNotification(message, notificationContext) {
        stopNotificationTimeout();

        if (message) {
            if (notificationContext) {
                if (typeof message === 'object') {
                    if (notificationContext.IsMonthly) {
                        message = message.monthly;
                    } else {
                        message = message.annual;
                    }
                }
            }

            const context = getContextData();
            const notificationMessage = buildNotificationMessage(message, context);

            $('.notification-message').text(notificationMessage);
            showNotificationTimeout();
        }
    }

    function showFormattedNotification(html, notificationSettings) {
        stopNotificationTimeout();
        if (html) {
            $('.notification-message').html(html);
            showNotificationTimeout(notificationSettings);
        }
    }

    function showNotificationTimeout(notificationSettings) {
        const settings = $.extend({}, defaultNotificationSettings, notificationSettings);
        autoCleared = true;
        $('.notification-container').show(0).focus();
        $('.notification-container').attr('aria-live', 'polite');
        $('[data-type="notification-button"]').focus();
        if (settings.autoClose) {
            notificationTimeout = setTimeout(function() {
                $('.notification-container').hide(0);
                setFocusToElement();
            }, settings.timeout);
        }
    }

    function buildNotificationMessage(msg, contextData) {
        const contextDataReplacer = createContextDataReplacer(contextData);
        msg = replaceAll(msg, contextDataReplacer);
        return msg;
    }

    function createContextDataReplacer(contextData) {
        const contextDataReplacer = [
            {
                search: '##PRICE##',
                replacement: contextData.Price,
            },
            {
                search: '##FIRSTNAME##',
                replacement: toTitleCase(contextData.FirstName),
            }, {
                search: '##EMAIL##',
                replacement: contextData.Email,
            },
            {
                search: '##UNDERWRITER##',
                replacement: contextData.Underwriter,
            },
            {
                search: '##DEPOSIT##',
                replacement: contextData.Deposit,
            },
        ];
        return contextDataReplacer;
    }

    function toTitleCase(str) {
        try {
            const splitName = str.split('-');
            let titleCaseName = '';
            for (let i = 0; i < splitName.length; i++) {
                titleCaseName =
                    titleCaseName + splitName[i].charAt(0).toUpperCase() + splitName[i].substr(1).toLowerCase() + '-';
            }
            return titleCaseName.substring(0, titleCaseName.length - 1);
        } catch (ex) {
            return str;
        }
    }

    function replaceAll(input, contextDataReplacer) {
        for (let i = 0; i < contextDataReplacer.length; i++) {
            input = input.replace(new RegExp(contextDataReplacer[i].search, 'g'), contextDataReplacer[i].replacement);
        }
        return input;
    }

    function getContextData() {
        const context = $('#houstoncontextdata').attr('data-context');
        if (context) {
            return JSON.parse(context);
        }

        return {};
    }

    function setFocusToElement() {
        const notificationButtonIsFocused = $('[data-type="notification-button"]').is(':focus');

        if (autoCleared && notificationButtonIsFocused) {
            resetFocus();
        }
    }

    function resetFocus() {
        bgl.common.focusHolder.setFocusToElement();
        bgl.common.focusHolder.removeFocused();
    }

    function refreshContext(callback) {
        const url = applicationPath + 'VirtualAssistantComponent/Context';

        $.ajax({
            url: url,
            type: 'POST',
            data: configuration,
            success: function(data) {
                $('#houstoncontextdata').attr('data-context', JSON.stringify(data));

                if (typeof callback === 'function') {
                    callback();
                }
            },
        });
    }

    function deleteBasket(redirectUrl) {
        const token = $('input[name="__RequestVerificationToken"]').val();
        $.ajax({
            url: applicationPath + 'VirtualAssistantComponent/DeleteBasket',
            type: 'POST',
            data: {
                __RequestVerificationToken: token,
            },
            success: function(data) {
                if (data.isSuccess) {
                    clearSession();

                    if (redirectUrl) {
                        sessionStorage.removeItem('MTAStartPage');
                        window.location = redirectUrl;
                    } else {
                        $('#houstonConfirmation button').removeAttr('tabindex');
                        $('#houstonConfirmation').addClass('hide');
                        bgl.common.pubsub.emit('CancelMTAComplete');
                    }
                } else {
                    window.location = applicationPath + 'Error';
                }
            },
            error: function() {
                window.location = applicationPath + 'Error';
            },
        });
    }

    function clearSession() {
        sessionStorage.removeItem('cancellationReasons');
        sessionStorage.removeItem('cancellationReasonsOther');
        sessionStorage.removeItem('cancellationWhen');
        sessionStorage.removeItem('cancellationDate');
        sessionStorage.removeItem('cancellationBackWhen');
        sessionStorage.removeItem('cancellationBackDatePicker');
    }

    function getAuthToken() {
        const formData = new FormData();
        formData.append(
            '__RequestVerificationToken',
            document.querySelector('[name="__RequestVerificationToken"]').value);

        const dataToPost = new URLSearchParams(formData).toString();
        const url = `${applicationPath}virtualassistantcomponent/getvirtualassistantauthtoken`;

        return bgl.common.fetch
            .formPost(url, {body: dataToPost})
            .then(function(resp) {
                if (!resp.ok) {
                    throw new Error('Network response was not ok ' + resp.statusText);
                }
                return resp.json();
            })
            .catch(function(error) {
                console.error('There was a problem with the fetch operation:', error);
            });
    };

    function getSignedCustomData() {
        const formData = new FormData();
        formData.append(
            '__RequestVerificationToken',
            document.querySelector('[name="__RequestVerificationToken"]').value);

        const dataToPost = new URLSearchParams(formData).toString();
        const url = `${applicationPath}virtualassistantcomponent/getvirtualassistantsignedcustomdata`;

        return bgl.common.fetch
            .formPost(url, {body: dataToPost})
            .then(function(resp) {
                if (!resp.ok) {
                    throw new Error('Network response was not ok ' + resp.statusText);
                }
                return resp.json();
            })
            .catch(function(error) {
                console.error('There was a problem with the fetch operation:', error);
            });
    };

    function getUnsignedCustomData(brand, application, requestUrl) {
        const formData = new FormData();
        formData.append(
            '__RequestVerificationToken',
            document.querySelector('[name="__RequestVerificationToken"]').value);
        formData.append('Brand', brand);
        formData.append('Application', application);
        formData.append('RequestUrl', requestUrl);

        const dataToPost = new URLSearchParams(formData).toString();
        const url = `${applicationPath}virtualassistantcomponent/getvirtualassistantunsignedcustomdata`;

        return bgl.common.fetch
            .formPost(url, {body: dataToPost})
            .then(function(resp) {
                if (!resp.ok) {
                    throw new Error('Network response was not ok ' + resp.statusText);
                }
                return resp.json();
            })
            .catch(function(error) {
                console.error('There was a problem with the fetch operation:', error);
            });
    };

    function preventRepositioningOfWebChatLaunchIcon() {
        const chatWidgetElement = document.querySelector('#chat-widget');
        if (chatWidgetElement) {
            const desktopElementToAdjust = chatWidgetElement.shadowRoot.querySelector('div div');
            if (desktopElementToAdjust) {
                desktopElementToAdjust.setAttribute('style', 'position:unset');
            }

            const mobileElementToAdjust = chatWidgetElement.shadowRoot.querySelector('div div div');
            if (mobileElementToAdjust) {
                mobileElementToAdjust.setAttribute('style', 'position:unset');
            }
        }
    }

    return {
        init: initComponent,
        load: loadComponent,
        showNotification,
        showFormattedNotification,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.virtualassistant;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.vehicledetails = bgl.components.vehicledetails || {};

bgl.components.vehicledetails.vehiclebodytype = (function() {
    let doneButton;
    let radioButtons;
    let configuration;
    let form;
    let containerId;

    function loadComponent(model, componentUrl, containerElementId) {
        configuration = model.ComponentConfiguration;
        containerId = containerElementId;

        bgl.common.loader.load(model,
            componentUrl,
            containerElementId,
            function() {
                bgl.components.vehicledetails.vehiclebodytype.init(configuration);
            });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#vehicle_edit_body-type_form');
        doneButton = $('#vehicle-body_type_done-button');
        radioButtons = $('input[type=\'radio\']');

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();
        bgl.common.validator.init(form);
        subscribeToDoneEvents();
        subscribeToRadioButtonEvents();
        subscribeToBackButtonEvents();
    }

    function subscribeToRadioButtonEvents() {
        const hasValue = radioButtons.is(':checked');

        if (!hasValue) {
            doneButton.addClass('hide');
        } else {
            doneButton.removeClass('hide');
        }

        $.each(radioButtons,
            function(key, item) {
                const button = $(item);

                button.on('change',
                    function(event) {
                        event.preventDefault();
                        if (!hasValue) {
                            form.submit();
                        }
                    });
            });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function subscribeToDoneEvents() {
        form.off('submit').on('submit',
            function(event) {
                event.preventDefault();

                if (bgl.common.validator.isFormValid($(this))) {
                    $('#HasChanged').val(bgl.common.datastore.isDataChanged($(this)));

                    bgl.common.validator.submitForm($(this), configuration);
                }
            });
    }

    function subscribeToBackButtonEvents() {
        $('#back-button').off('click').on('click',
            function(event) {
                event.preventDefault();

                const link = $(event.currentTarget);

                if (configuration.JourneyType.toString() === bgl.components.journeyTypesVehicleDetails.MultiStepEdit) {
                    bgl.common.utilities.redirectToUrl(link.data('action-url'));
                } else {
                    const containerSelector = link.data('container');

                    const onEventName = link.data('init-event');
                    const callback = eval(onEventName);

                    const model = bgl.common.datastore.getData(form);
                    model.ComponentConfiguration = configuration;

                    if (typeof callback === 'function') {
                        bgl.common.loader.load(model,
                            link.data('action-url'),
                            containerSelector,
                            function() {
                                callback(configuration);
                            });
                    }
                }
            });
    }

    function onSuccess(configuration, data) {
        if (data.journeyType.toString() === bgl.components.journeyTypesVehicleDetails.LookupEdit) {
            const model = bgl.common.datastore.getData(form);
            model.ComponentConfiguration = configuration;

            bgl.components.vehicledetails.numberofseats.load(model,
                data.componentUrl,
                containerId);
        } else if (data.journeyType.toString() === bgl.components.journeyTypesVehicleDetails.MultiStepEdit) {
            bgl.common.utilities.redirectToUrl(data.componentUrl);
        } else {
            if (data.hasChanges === true) {
                bgl.common.pubsub.emit('PollBasket');
            }
            bgl.common.datastore.removeSessionStorage(form);
        }
    }


    function onError() {
        bgl.components.vehicledetails.vehiclebodytype.init(configuration);
    }

    return {
        load: loadComponent,
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.vehicledetails = bgl.components.vehicledetails || {};

bgl.components.vehicledetails.value = (function() {
    let containerId;
    let configuration;
    let form;

    function loadComponent(model, componentUrl, containerElementId) {
        configuration = model.ComponentConfiguration;
        containerId = containerElementId;

        bgl.common.loader.load(model,
            componentUrl,
            containerElementId,
            function() {
                bgl.components.vehicledetails.value.init(configuration);
            });
    }

    function initComponent(configuration) {
        subscribeToEvents(configuration);
    }

    function subscribeToEvents(configuration) {
        form = $('[data-component-id=\'' + configuration.Id + '\'] form');

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        bgl.common.validator.init(form);

        bgl.common.validator.initNumberInputField(
            $('#Vehicle-Value'),
            $('#Vehicle-Value').data('valRangeMax').toString().length,
        );

        form.off('submit').on('submit',
            function(e) {
                e.preventDefault();

                if (bgl.common.validator.isFormValid($(this))) {
                    $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)));

                    storeVehicleChangesForTagManager();

                    bgl.common.validator.submitForm($(this), configuration);
                }
            });

        function storeVehicleChangesForTagManager() {
            const data = bgl.components.vehicledetails.common.getPreviouslyStoredChangedVehicleData();
            const vehicleDetails = getCurrentVehicleChanges();
            const changesInSessionStorage = sessionStorage.getItem('VehicleLookupJourney');
            const currentVehicleChanges = JSON.parse(changesInSessionStorage);

            if (vehicleDetails !== null) {
                data.push(['CustomerVehicleValue', currentVehicleChanges.VehicleValue]);
                bgl.components.vehicledetails.common.setPreviouslyStoredChangedVehicleData(data);
            }
        }

        function getCurrentVehicleChanges() {
            const changesInSessionStorage = sessionStorage.getItem('VehicleLookupJourney');

            if (changesInSessionStorage !== null) {
                const currentVehicleChanges = JSON.parse(changesInSessionStorage);

                return {
                    VehicleValue: currentVehicleChanges.VehicleValue,
                };
            } else {
                return null;
            }
        }

        if ($('#JourneyType').val() !== bgl.components.journeyTypesVehicleDetails.MultiStepEdit) {
            $('[data-step-type=\'previous-step\']').on('click',
                function(e) {
                    e.preventDefault();

                    const model = bgl.common.datastore.getData(form);

                    model.ComponentConfiguration = configuration;

                    const url = $(e.target).attr('href');

                    bgl.components.vehicledetails.purchasedate.load(model, url, containerId);
                });
        }
    }

    function onSuccess(configuration, data) {
        if (data.journeyType.toString() === bgl.components.journeyTypesVehicleDetails.SingleEdit) {
            if (data.hasChanges === true) {
                bgl.common.pubsub.emit('PollBasket');
            }
            bgl.common.datastore.removeSessionStorage(form);
            return;
        }

        if (data.hasChanges === true) {
            bgl.components.vehicledetails.lookup.postVehicle(form, data.redirectUrl);
            return;
        }

        if (data.journeyType.toString() === bgl.components.journeyTypesVehicleDetails.MultiStepEdit) {
            bgl.common.utilities.redirectToUrl(data.redirectUrl);
        }
    }

    function onError(configuration) {
        subscribeToEvents(configuration);
    }

    return {
        load: loadComponent,
        init: initComponent,
        subscribe: subscribeToEvents,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.vehicledetails;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.vehicledetails = bgl.components.vehicledetails || {};

const slidePanelContentKey = 'SlidePanelContent';

bgl.components.vehicledetails.journeyTypes = {
    SingleEdit: '0',
    LookupEdit: '1',
    MultiStepEdit: '2',
};

bgl.components.vehicledetails.searching = (function() {
    let containerId;
    let configuration;
    let form;

    function loadComponent(model, componentUrl, containerElementId) {
        configuration = model.ComponentConfiguration;
        containerId = containerElementId;

        bgl.common.loader.load(model,
            componentUrl,
            containerElementId,
            function() {
                bgl.components.vehicledetails.searching.init(configuration);
            });
    }

    function initComponent(componentConfiguration) {
        if (configuration == undefined) {
            configuration = componentConfiguration;
        }

        form = $('[data-component-id=\'' + configuration.Id + '\'] form');

        bgl.common.validator.init(form);

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        subscribeToEvents(configuration);
    }

    function subscribeToEvents(configuration) {
        form.off('submit').on('submit',
            function(e) {
                e.preventDefault();

                const inputField = $('#registration-number');
                inputField.val(inputField.val().replace(/\s+/gi, ''));

                $(this).find('input[type=\'submit\']').prop('disabled', true);
                if (bgl.common.validator.validate(configuration, $(this)) === false) {
                    $(this).find('input[type=\'submit\']').prop('disabled', false);
                }
            });

        $('#registration-number').on('input',
            function() {
                const start = this.selectionStart;
                const end = this.selectionEnd;

                this.value = this.value.toUpperCase();

                this.setSelectionRange(start, end);
            });

        if (containerId === undefined) {
            containerId = slidePanelContentKey;
        }

        const vehicleObj = bgl.common.datastore.getData(form);
        const vehicleId = $('#VehicleId').val();

        if (vehicleObj.VehicleId === undefined && vehicleId) {
            bgl.common.datastore.extendCollectedData(form, {VehicleId: vehicleId});
        }

        bgl.components.vehicledetails.stepbuilder.init(configuration, containerId);
    }

    function onSuccess(componentConfiguration, data) {
        if (componentConfiguration.JourneyType.toString() !==
            bgl.components.vehicledetails.journeyTypes.MultiStepEdit) {
            bgl.components.vehicledetails.summary.load(data.searchingResult,
                data.componentUrl,
                containerId,
                true);
        } else {
            delete data.searchingResult.ComponentConfiguration;

            data.searchingResult.isFormDirty = true;

            bgl.components.vehicledetails.summary.resetSearchedData(
                data.searchingResult,
                componentConfiguration.DataStoreKey,
            );

            bgl.common.datastore.extendCollectedData(componentConfiguration.DataStoreKey, data.searchingResult);

            bgl.common.utilities.redirectToUrl(data.componentUrl);
        }
    }

    function onError(componentConfiguration, error) {
        bgl.components.vehicledetails.searching.init(componentConfiguration, containerId);

        form.find('input[type=\'submit\']').prop('disabled', false);
    }

    return {
        load: loadComponent,
        init: initComponent,
        subscribe: subscribeToEvents,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

bgl.components.vehicledetails.summary = (function() {
    let containerId;
    let configuration;
    let form;

    function loadComponent(componentContent, componentUrl, containerElementId, needToResetSearchedData) {
        containerId = containerElementId;
        configuration = componentContent.ComponentConfiguration;

        if (needToResetSearchedData === true) {
            const dataStoreKey = configuration.DataStoreKey !== undefined && configuration.DataStoreKey !== null ?
                configuration.DataStoreKey :
                'VehicleLookupJourney';

            resetSearchedData(componentContent, dataStoreKey);
        }

        bgl.common.loader.load(componentContent,
            componentUrl,
            containerElementId,
            function() {
                bgl.components.vehicledetails.summary.init(configuration);
            });
    }

    function resetSearchedData(foundData, dataStoreKey) {
        let formData = bgl.common.datastore.getData(dataStoreKey);

        const registrationYear = (foundData.Registration.length > 4 ?
            foundData.Registration.substr(0, 4) :
            foundData.Registration) -
            0;

        const selectedPurchasedYear = (formData.Year === undefined ? '' : formData.Year) - 0;

        if (registrationYear > selectedPurchasedYear) {
            formData = deleteFieldsFromModel(formData, 'Year');
        }

        if (foundData.RegistrationNumber === '') {
            formData = deleteFieldsFromModel(formData, 'RegistrationNumber');
        }

        if (foundData.SecurityDeviceCode !== formData.SecurityDeviceCode) {
            formData = deleteFieldsFromModel(formData, 'SecurityDeviceCode');
        }

        if (foundData.HasRightHandDrive !== formData.HasRightHandDrive) {
            formData = deleteFieldsFromModel(formData, 'HasRightHandDrive');
        }

        if (foundData.HasTrackingDevice !== formData.HasTrackingDevice) {
            formData = deleteFieldsFromModel(formData, 'HasTrackingDevice');
        }

        if (foundData.Value !== formData.Value) {
            formData = deleteFieldsFromModel(formData, 'Value');
        }

        formData.isFormDirty = true;

        sessionStorage.setItem(dataStoreKey, JSON.stringify(formData));
    }

    function deleteFieldsFromModel(formData, searchingCriteria) {
        $.each(Object.keys(formData),
            function(key, value) {
                if (value.substring(0, searchingCriteria.length) === searchingCriteria) {
                    delete formData[value];
                }
            });
        return formData;
    }

    function commonInit() {
        saveVehicleLookupJourney();
        const assumedDataSummaryLink = $('#assumedDataSummary');

        assumedDataSummaryLink.off('click').on('click',
            function(event) {
                event.preventDefault();

                const assumedDataSection = $('#assumedDataSection');
                const assumedDataSummarySection = $('#assumedDataSummarySection');

                assumedDataSection.toggleClass('hide');
                assumedDataSummarySection.toggleClass('hide');
            });

        bgl.common.validator.init(form);

        form.off('submit').on('submit',
            function(e) {
                e.preventDefault();

                bgl.common.validator.validate(configuration, $(this));
            });
    }

    function initComponent(componentConfiguration) {
        if (configuration == undefined) {
            configuration = componentConfiguration;
        }

        commonInit();

        if (configuration.JourneyType.toString() !== bgl.components.vehicledetails.journeyTypes.MultiStepEdit) {
            const linkButton = $('#vehicle-search-button');

            linkButton.off('click').on('click',
                function(event) {
                    event.preventDefault();

                    const link = $(event.currentTarget);
                    const containerSelector = link.data('container');

                    const onEventName = link.data('init-event');
                    const callback = eval(onEventName);
                    const vehicleId = link.data('vehicle-id') || bgl.common.datastore.getData(form).VehicleId;

                    const model = {
                        ComponentConfiguration: configuration,
                        vehicleId: vehicleId,
                    };

                    if (typeof callback === 'function') {
                        bgl.common.loader.load(model,
                            link.data('action-url'),
                            containerSelector,
                            function() {
                                callback(configuration);
                            });
                    }
                });
        }

        bgl.components.vehicledetails.stepbuilder.init(configuration, containerId);
    }

    function saveVehicleLookupJourney() {
        form = $('[data-component-id=\'' + configuration.Id + '\'] form');

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        const vehicleObject = bgl.common.datastore.getData(form);

        form.find('input[type=\'radio\']:checked').trigger('change');

        bgl.common.datastore.extendCollectedData(form, {isFormDirty: vehicleObject.isFormDirty});
    }

    function onSuccess(componentConfiguration, data) {
        const vehicleObject = bgl.common.datastore.getData(form);

        const model = data.modifications;

        model.ComponentConfiguration = componentConfiguration;
        model.VehicleId = vehicleObject.VehicleId;
        model.JourneyType = vehicleObject.JourneyType;
        model.Modifications = vehicleObject['SelectedModifications'] || [];
        model.Model = vehicleObject.Model;
        model.Manufacturer = vehicleObject.Manufacturer;

        if (componentConfiguration.JourneyType.toString() !==
            bgl.components.vehicledetails.journeyTypes.MultiStepEdit) {
            if (model.VehicleType === 'van') {
                bgl.components.vehicledetails.vehiclebodytype.load(model,
                    data.componentUrl,
                    containerId);
            } else if (componentConfiguration.IsService) {
                bgl.components.vehicledetails.importantinformation.load(model,
                    data.componentUrl,
                    containerId);
            } else {
                bgl.components.vehicledetails.modifications.load(model,
                    data.componentUrl,
                    containerId);
            }
        } else {
            bgl.common.utilities.redirectToUrl(data.componentUrl);
        }
    }

    function onError(componentConfiguration, error) {
        if (componentConfiguration.JourneyType.toString() !==
            bgl.components.vehicledetails.journeyTypes.MultiStepEdit) {
            initComponent(componentConfiguration);
        }

        const assumedDataSummaryLink = $('#assumedDataSummary');
        assumedDataSummaryLink.trigger('click');
    }

    return {
        load: loadComponent,
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
        resetSearchedData: resetSearchedData,
    };
})();

bgl.components.vehicledetails.stepbuilder = (function() {
    let configuration;
    let needToRefreshPage;

    function getData(stepType) {
        const vehicleDataContainer = $('.data-container');
        let currentStep = vehicleDataContainer.data('currentStep');
        const vehicleBuilderValues = vehicleDataContainer.data('vehicleBuilderValues');
        let isBackButtonClicked = false;
        const quoteType = getQuoteType();

        if (stepType === 'previous-step') {
            isBackButtonClicked = true;
            --currentStep;
        } else if (stepType === 'next-step') {
            ++currentStep;
        }

        return {
            componentConfiguration: configuration,
            currentStep: currentStep,
            vehicleBuilderValues: vehicleBuilderValues,
            isBackButtonClicked: isBackButtonClicked,
            quoteType: quoteType,
        };
    }

    function getQuoteType() {
        const dataContainerQuoteType = $('.data-container').data('quoteType');
        const vehicleConfirmationQuoteType = $('a[data-quote-type]').data('quoteType');

        return dataContainerQuoteType || vehicleConfirmationQuoteType;
    }

    function scrollToTop() {
        $('#' + configuration.Id + '__SlidePanel').scrollTop(1);
    }

    function subscribeDropdownOnChange() {
        const dropdown = $('#builder-dropdown');
        const confirmButton = $('#builder-dropdown-confirm-button');

        dropdown.off('change')
            .off('keypress')
            .on('change',
                function() {
                    const value = $(this).find(':selected').attr('value');

                    confirmButton.prop('disabled', !value);
                })
            .on('keypress',
                function(event) {
                    if (event.keyCode === 13) {
                        $(this).click();
                    }
                });

        confirmButton.on('click',
            function(event) {
                event.preventDefault();
                const selectedId = dropdown.find(':selected').attr('value');
                const value = dropdown.find(':selected').text();
                changeStep('next-step', {Id: selectedId, Value: value}, $(this).data('redirect-url'));
            });
    }

    function subscribe() {
        subscribeDropdownOnChange();

        const editButton = $('#vehicle-edit-button');
        if (editButton && editButton.length > 0) {
            needToRefreshPage = editButton.data('refreshPage') === true;
        }

        $('.vehicle-builder-button, .vehicle-builder-back-button').off('click').on('click',
            function(event) {
                event.preventDefault();

                const stepType = $(this).data('stepType');

                const stepOptionItem = {
                    Id: $(this).data('itemId'),
                    Value: $(this).text(),
                };

                const redirectUrl = $(this).is('a') ?
                    $(this).attr('href') :
                    $(this).data('redirect-url');

                changeStep(stepType, stepOptionItem, redirectUrl);
            });

        $('.vehicle-lookup__breadcrumb-link').off('click').on('click',
            function(event) {
                event.preventDefault();

                const data = getData('next-step');

                data.currentStep = $(this).data('vehicleBuilderStep');

                data.StepOptionItem = {
                    Id: $(this).data('itemId'),
                    Value: $(this).text(),
                };

                data.isBreadcrumbLinkClicked = true;

                bgl.common.loader.load(data,
                    $(this).data('redirect-url'),
                    slidePanelContentKey,
                    onInit);
            });

        $('.vehicle-lookup__radio-input, .vehicle-lookup__vehicle-radio').off('click').on('click',
            function() {
                const button = $('#builder-confirm-button');

                if (button.is(':disabled')) {
                    button.prop('disabled', false);
                }
            });

        $('#builder-confirm-button').off('click').on('click',
            function(event) {
                event.preventDefault();

                const foundData = $('.vehicle-lookup__radio-input:checked').data('specificationModel');
                const url = $(this).data('redirect-url');

                resetData();

                foundData.RegistrationNumber = '';

                if (configuration.JourneyType.toString() === bgl.components.vehicledetails.journeyTypes.MultiStepEdit) {
                    $('[data-dismiss=\'slide-panel\']').click();

                    delete foundData.ComponentConfiguration;

                    bgl.components.vehicledetails.summary.resetSearchedData(foundData, configuration.DataStoreKey);

                    bgl.common.datastore.extendCollectedData(configuration.DataStoreKey, foundData);

                    if (needToRefreshPage === true) {
                        bgl.common.utilities.refreshPage();
                    } else {
                        bgl.common.utilities.redirectToUrl(configuration.ComponentUrl + '#summary');
                    }
                } else {
                    foundData.ComponentConfiguration = configuration;

                    bgl.components.vehicledetails.summary.load(foundData, url, slidePanelContentKey, true);
                }
            });

        $('.vehicle-lookup__other-button').off('click').on('click', subscribeDropdownOnChange);

        $('.vehicle-lookup__other-button, .vehicle-lookup__vehicle-radio').off('keypress').on('keypress',
            function(event) {
                if (event.keyCode === 13 || event.keyCode === 32) {
                    $(this).click()
                        .focus();
                }
            });
    }

    function changeStep(stepType, selectedItem, href) {
        if (stepType === 'next-step' && bgl.common.pubsub !== 'undefined') {
            let legendText = $('[data-item-id="' + selectedItem.Id + '"]').parent().children('legend').text();
            if (legendText === '') {
                legendText = $('option[value=' + selectedItem.Id + ']').parent().parent().children('legend').text();
            }
            bgl.common.pubsub.emit('fakeFormSubmit', legendText);
        }
        const data = getData(stepType);
        data.StepOptionItem = selectedItem;
        const currentContainerId = 'SlidePanelContent';
        bgl.common.loader.load(data,
            href,
            currentContainerId,
            onInit);
    }

    function resetData() {
        const vehicleDataContainer = $('.data-container');

        if (vehicleDataContainer && vehicleDataContainer.length > 0) {
            $('.data-container').removeData('vehicleBuilderValues');
            $('.data-container').removeAttr('data-vehicle-builder-values');
            $('.data-container').removeData('currentStep');
            $('.data-container').removeAttr('data-current-step');
        }
    }

    function onInit() {
        scrollToTop();
        subscribe();
    }

    function init(config, containerSelector) {
        configuration = config;
        needToRefreshPage = false;
        onInit();
    }

    return {
        subscribe: subscribe,
        init: init,
    };
})();

bgl.components.vehicledetails.importantinformation = (function() {
    let configuration;
    let form;
    let containerId;

    function loadComponent(model, componentUrl, containerElementId) {
        configuration = model.ComponentConfiguration;
        containerId = containerElementId;

        bgl.common.loader.load(model,
            componentUrl,
            containerElementId,
            function() {
                bgl.components.vehicledetails.importantinformation.init(configuration);
            });
    }

    function init(componentConfiguration) {
        configuration = componentConfiguration;

        form = $('[data-component-id=\'' + configuration.Id + '\'] form');

        bgl.common.validator.init(form);

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        subscribeForEvents();
    }

    function subscribeForEvents() {
        form.off('submit').on('submit',
            function(e) {
                e.preventDefault();

                if (!$('#agreement-checkbox').prop('checked')) {
                    $('#agreement-container').addClass('error');
                } else {
                    if (bgl.common.validator.isFormValid($(this))) {
                        $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)));

                        bgl.common.validator.submitForm($(this), configuration);
                    }
                }
            });


        $('#back-button').off('click').on('click',
            function(event) {
                event.preventDefault();

                const link = $(event.currentTarget);
                const containerSelector = link.data('container');

                const onEventName = link.data('init-event');
                const callback = eval(onEventName);

                const model = bgl.common.datastore.getData(form);
                model.ComponentConfiguration = configuration;

                if (typeof callback === 'function') {
                    bgl.common.loader.load(model,
                        link.data('action-url'),
                        containerSelector,
                        function() {
                            callback(configuration);
                        });
                }
            });
    }

    function onSuccess(componentConfiguration, data) {
        const vehicleObject = bgl.common.datastore.getData(form);

        const model = {
            ComponentConfiguration: componentConfiguration,
            VehicleId: vehicleObject.VehicleId,
            JourneyType: vehicleObject.JourneyType,
            Registration: vehicleObject.Registration,
            HasValue: vehicleObject.HasValue,
        };

        bgl.components.vehicledetails.purchasedate.load(model,
            data.componentUrl,
            containerId);
    }

    function onError(componentConfiguration, error) {

    }

    return {
        load: loadComponent,
        init: init,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.vehicledetails;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.vehicledetails = bgl.components.vehicledetails || {};

bgl.components.journeyTypesVehicleDetails = {
    SingleEdit: '0',
    LookupEdit: '1',
    MultiStepEdit: '2',
};

bgl.components.vehicledetails.purchasedate = (function() {
    let purchaseDateDropdowns;
    let configuration;
    let containerId;
    const HIDE_CLASS = 'hide';
    let form;
    let hasPreselectedValues;
    let monthDropdown;
    let yearDropdown;
    let fullYearMonthOptions;
    let currentYearMonthOptions;

    function loadComponent(model, componentUrl, containerElementId) {
        configuration = model.ComponentConfiguration;
        containerId = containerElementId;

        bgl.common.loader.load(model,
            componentUrl,
            containerElementId, function() {
                bgl.components.vehicledetails.purchasedate.init(configuration);
            });
    }

    function init(componentConfiguration) {
        configuration = componentConfiguration;

        initializeVariables(componentConfiguration);
        form = $('[data-component-id=\'' + configuration.Id + '\'] form');

        bgl.common.validator.init(form);

        const singleEdit = bgl.components.journeyTypesVehicleDetails.SingleEdit;
        const isSingleJourneyType = form.find('#JourneyType').val() === singleEdit;

        if (isSingleJourneyType) {
            hasPreselectedValues = true;
            bgl.common.datastore.init(form);
        } else {
            bgl.common.datastore.init(form, false, true);
            bgl.common.datastore.setupReadAndWrite();

            const hasValue = $('#HasValue').val() === 'True';

            hasPreselectedValues = form.find('input[type=radio]:checked').length !== 0 || hasValue;
        }

        subscribeForEvents();
    }

    function subscribeForEvents() {
        if (hasPreselectedValues === true) {
            showSubmitButton();

            if (form.find('input[type=radio]:checked').length !== 0) {
                const selectedButton = $(form.find('input[type=radio]:checked')[0]);
                switch (selectedButton.val().toLowerCase()) {
                case 'true':
                    if (purchaseDateDropdowns.hasClass(HIDE_CLASS)) {
                        purchaseDateDropdowns.removeClass(HIDE_CLASS);
                    }
                    break;
                }
            }
        }

        $('#vehicle-purchased-yes').on('click',
            function() {
                $(this).prop('checked', true);
                $(this).trigger('change');

                hasPreselectedValues = true;
                showSubmitButton();
                if (purchaseDateDropdowns.hasClass(HIDE_CLASS)) {
                    purchaseDateDropdowns.removeClass(HIDE_CLASS);
                }
            });

        $('#vehicle-purchased-no').on('click',
            function() {
                $(this).prop('checked', true);
                $(this).trigger('change');

                if (hasPreselectedValues === false) {
                    form.submit();
                    return;
                }

                if (!purchaseDateDropdowns.hasClass(HIDE_CLASS)) {
                    purchaseDateDropdowns.addClass(HIDE_CLASS);
                }
            });

        form.off('submit').on('submit',
            function(e) {
                e.preventDefault();
                if (bgl.common.validator.isFormValid($(this))) {
                    const submitButton = form.find('button[type=\'submit\']');
                    submitButton.attr('disabled', true);
                    $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)));
                    storeVehicleChangesForTagManager();

                    if (configuration.IsService) {
                        const mtaSuffix = bgl.common.utilities.getWindowLocation()
                            .href.toLowerCase().includes('makechanges') ?
                            'start' :
                            'additional change';

                        bgl.common.telemetry.logEvent(`MTA ${mtaSuffix}`,
                            {mta_type: 'Vehicle change', component: configuration.Id});
                    }

                    bgl.common.validator.submitForm($(this), configuration);
                }
            });

        function storeVehicleChangesForTagManager() {
            const data = bgl.components.vehicledetails.common.getPreviouslyStoredChangedVehicleData();
            const vehicleDetails = getCurrentVehicleChanges();
            const changesInSessionStorage = sessionStorage.getItem('VehicleLookupJourney');
            const currentVehicleChanges = JSON.parse(changesInSessionStorage);

            if (vehicleDetails !== null) {
                data.push(['Manufacturer', currentVehicleChanges.Manufacturer]);
                data.push(['Model', currentVehicleChanges.Model]);
                data.push(['Age', getVehicleAge(currentVehicleChanges.Registration)]);
                bgl.components.vehicledetails.common.setPreviouslyStoredChangedVehicleData(data);
            }
        }

        function getCurrentVehicleChanges() {
            const changesInSessionStorage = sessionStorage.getItem('VehicleLookupJourney');

            if (changesInSessionStorage !== null) {
                const currentVehicleChanges = JSON.parse(changesInSessionStorage);

                return {
                    Manufacturer: currentVehicleChanges.Manufacturer,
                    Model: currentVehicleChanges.Model,
                    Age: getVehicleAge(currentVehicleChanges.Registration),
                };
            } else {
                return null;
            }
        }

        function getVehicleAge(registration) {
            if (registration) {
                const year = registration.substring(0, 4);
                const age = new Date().getFullYear() - parseInt(year);
                return age;
            } else {
                return 0;
            }
        }

        if (form.find('#JourneyType').val() === bgl.components.journeyTypesVehicleDetails.LookupEdit) {
            $('a[data-step-type=\'previous-step\']').off('click').one('click',
                function(event) {
                    event.preventDefault();

                    $(this).hide();

                    const backUrl = $(this).attr('href');

                    const vehicleObject = bgl.common.datastore.getData(form);

                    const model = {
                        ComponentConfiguration: configuration,
                        Modifications: vehicleObject['SelectedModifications'] || [],
                        Model: vehicleObject.Model,
                        Manufacturer: vehicleObject.Manufacturer,
                        VehicleId: vehicleObject.VehicleId,
                        JourneyType: form.find('#JourneyType').val(),
                    };

                    if (configuration.IsService) {
                        bgl.components.vehicledetails.importantinformation.load(model, backUrl, containerId);
                    } else {
                        bgl.components.vehicledetails.modifications.load(model, backUrl, containerId);
                    }
                });
        }

        const currentMonth = $('#CurrentMonth').val() - 0;

        monthDropdown = form.find('#Purchased-Month');
        yearDropdown = form.find('#Purchased-Year');

        fullYearMonthOptions = monthDropdown.find('option');
        currentYearMonthOptions = fullYearMonthOptions.slice(0, currentMonth + 1);

        updateMonthDropdown();

        yearDropdown.on('change', updateMonthDropdown);
    }

    function showSubmitButton() {
        const submitButton = form.find('button[type=\'submit\']');
        submitButton.removeClass(HIDE_CLASS);
    }

    function initializeVariables(componentConfiguration) {
        purchaseDateDropdowns = $('.purchase-date-dropdowns');
        configuration = componentConfiguration;
    }

    function onSuccess(configuration, data) {
        const singleEdit = bgl.components.journeyTypesVehicleDetails.SingleEdit;
        if (data.content && data.content.JourneyType && data.content.JourneyType.toString() !== singleEdit) {
            if (data.content.IsVehiclePurchased === false) {
                bgl.common.datastore.deleteFields(data.content.DataStoreKey,
                    ['Month', 'MonthVal', 'MonthText', 'Year', 'YearVal', 'YearText']);
            }

            if (data.content.HasValue === true) {
                bgl.components.vehicledetails.lookup.postVehicle(form, data.nextStepUrl);
            } else {
                if (data.content.JourneyType.toString() === bgl.components.journeyTypesVehicleDetails.LookupEdit) {
                    const model = bgl.common.datastore.getData(form);
                    model.ComponentConfiguration = configuration;

                    bgl.components.vehicledetails.value.load(data.content,
                        data.nextStepUrl,
                        containerId);
                } else {
                    bgl.common.utilities.redirectToUrl(data.nextStepUrl);
                }
            }
        } else {
            if (data.hasChanges === true) {
                bgl.common.pubsub.emit('PollBasket');
            }
            bgl.common.datastore.removeSessionStorage(form);
        }
    }

    function onError(configuration) {
        bgl.components.vehicledetails.purchasedate.init(configuration);
    }

    function updateMonthDropdown() {
        const months = monthDropdown;
        const selectedMonthValue = months.val();
        const currentYear = $(yearDropdown).find('option:eq(1)').val();

        switch (yearDropdown.val()) {
        case currentYear:
            months.html(currentYearMonthOptions);
            break;
        default:
            months.html(fullYearMonthOptions);
            break;
        };

        months.val(selectedMonthValue);

        // select first value if value is not selected
        if (!months.val()) {
            months.find('option:eq(0)').prop('selected', true);
        }
    }

    return {
        load: loadComponent,
        init: init,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.vehicledetails;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.vehicledetails = bgl.components.vehicledetails || {};

bgl.components.vehicledetails.overnightparking = (function() {
    let doneButton;
    let radioButtons;
    let configuration;
    let form;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('[data-component-id=\'' + configuration.Id + '\'] form');
        doneButton = $('#vehicle-overnight_done-button');
        radioButtons = $('input[type=\'radio\']');

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        subscribeToDoneEvents();
        subscribeToRadioButtonEvents();
    }

    function subscribeToRadioButtonEvents() {
        const hasValue = radioButtons.is(':checked');

        if (!hasValue) {
            doneButton.addClass('hide');
        } else {
            doneButton.removeClass('hide');
        }

        $.each(radioButtons,
            function(key, item) {
                const button = $(item);

                button.on('change',
                    function(event) {
                        event.preventDefault();
                        if (!hasValue) {
                            form.submit();
                        }
                    });
            });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function subscribeToDoneEvents() {
        form.off('submit').on('submit',
            function(event) {
                event.preventDefault();

                if (bgl.common.validator.isFormValid($(this))) {
                    $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)));

                    bgl.common.validator.submitForm($(this), configuration);
                }
            });
    }

    function onSuccess() {
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: false});

        goToNextStep();
    }

    function goToNextStep() {
        bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
    }

    function onError() {
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});

        bgl.components.vehicledetails.overnightparking.init(configuration);
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.vehicledetails = bgl.components.vehicledetails || {};

bgl.components.vehicledetails.numberofseats = (function() {
    let doneButton;
    let radioButtons;
    let configuration;
    let containerId;
    let form;

    function loadComponent(model, componentUrl, containerElementId) {
        configuration = model.ComponentConfiguration;
        containerId = containerElementId;

        bgl.common.loader.load(model,
            componentUrl,
            containerElementId,
            function() {
                bgl.components.vehicledetails.numberofseats.init(configuration);
            });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#vehicle_edit_seats');
        doneButton = $('#vehicle-numberofseats_done-button');
        radioButtons = $('input[type=\'radio\']');

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();
        subscribeToBackButtonEvents();
        subscribeToDoneEvents();
        subscribeToRadioButtonEvents();
    }

    function subscribeToRadioButtonEvents() {
        const isChecked = radioButtons.is(':checked');

        if (!isChecked) {
            doneButton.addClass('hide');
        } else {
            doneButton.removeClass('hide');
        }

        $.each(radioButtons,
            function(key, item) {
                const button = $(item);

                button.on('change',
                    function(event) {
                        event.preventDefault();
                        if (!isChecked) {
                            form.submit();
                        }
                    });
            });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function subscribeToDoneEvents() {
        form.off('submit').on('submit',
            function(event) {
                event.preventDefault();

                if (bgl.common.validator.isFormValid($(this))) {
                    $('#HasChanged').val(bgl.common.datastore.isDataChanged($(this)));

                    bgl.common.validator.submitForm($(this), configuration);
                }
            });
    }

    function subscribeToBackButtonEvents() {
        $('#back-button').off('click').on('click',
            function(event) {
                event.preventDefault();

                const link = $(event.currentTarget);

                if (configuration.JourneyType.toString() === bgl.components.journeyTypesVehicleDetails.MultiStepEdit) {
                    bgl.common.utilities.redirectToUrl(link.data('action-url'));
                } else {
                    const containerSelector = link.data('container');

                    const onEventName = link.data('init-event');
                    const callback = eval(onEventName);

                    if (typeof callback === 'function') {
                        const model = bgl.common.datastore.getData(form); ;
                        model.ComponentConfiguration = configuration;

                        bgl.common.loader.load(model,
                            link.data('action-url'),
                            containerSelector,
                            function() {
                                callback(configuration);
                            });
                    }
                }
            });
    }

    function onSuccess(configuration, data) {
        if (data.journeyType.toString() === bgl.components.journeyTypesVehicleDetails.LookupEdit) {
            const model = bgl.common.datastore.getData(form);
            model.ComponentConfiguration = configuration;

            if (configuration.IsService) {
                bgl.components.vehicledetails.importantinformation.load(model,
                    data.componentUrl,
                    containerId);
            } else {
                bgl.components.vehicledetails.modifications.load(model,
                    data.componentUrl,
                    containerId);
            }
        } else if (data.journeyType.toString() === bgl.components.journeyTypesVehicleDetails.MultiStepEdit) {
            bgl.common.utilities.redirectToUrl(data.componentUrl);
        } else {
            if (data.hasChanges === true) {
                bgl.common.pubsub.emit('PollBasket');
            }
            bgl.common.datastore.removeSessionStorage(form);
        }
    }

    function onError() {
        bgl.components.vehicledetails.numberofseats.init(configuration);
    }

    return {
        load: loadComponent,
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.vehicledetails = bgl.components.vehicledetails || {};

bgl.components.journeyTypesVehicleDetails = {
    SingleEdit: '0',
    LookupEdit: '1',
    MultiStepEdit: '2',
};

bgl.components.vehicledetails.modifications = (function() {
    let containerId;
    let configuration;
    let modificationCheckButton;
    let isChanged = false;
    let form;

    function loadComponent(model, componentUrl, containerElementId) {
        containerId = containerElementId;
        configuration = model.ComponentConfiguration;

        bgl.common.loader.load(model,
            componentUrl,
            containerElementId,
            initComponent);
    }

    function initComponent(componentConfiguration) {
        if (configuration == undefined) {
            configuration = componentConfiguration;
        }

        unSubscribeToEventDismissVehicleModificationsPanel();

        initializeVariables();
        subscribeToEvents();

        initializeLookupEdit();
    }

    function initializeVariables() {
        form = $('#vehicle-modifications-form');

        modificationCheckButton = getModificationButtonCheckedState();
    }

    function subscribeToEvents() {
        subscribeToEventShowModification();

        subscribeToEventAddModification();

        subscribeToEventRemoveAllModifications();

        subscribeToEventDeleteModification();

        if (form.find('#JourneyType').val() !== bgl.components.journeyTypesVehicleDetails.MultiStepEdit) {
            subscribeBackButton();
            subscribeToEventDismissVehicleModificationsPanel();
        }
    }

    function initializeLookupEdit() {
        if ($('#JourneyType').val() !== bgl.components.journeyTypesVehicleDetails.SingleEdit) {
            bgl.common.datastore.init(form, false, true);

            bgl.common.datastore.setupReadAndWrite();

            if (getModificationCount() !== 0) {
                $('#Modification-Yes').prop('checked', true);
            } else {
                const vehicleObject = bgl.common.datastore.getData(form);

                if (vehicleObject != null && vehicleObject['IsModified'] === 'No') {
                    $('#Modification-No').prop('checked', true);
                    $('#vehicle-modification_continue-button').removeClass('hide');
                }
            }
        }
    }

    function getModificationCount() {
        return $('#Vehicle-Modification-List .step-form__summary-item').length;
    }

    function subscribeToEventDismissVehicleModificationsPanel() {
        $(document).on('click.modifications', '[data-dismiss="slide-panel"]', function() {
            unSubscribeToEventDismissVehicleModificationsPanel();
            dismissSlidePanelHandler(isChanged);
        });

        $(document).on('keyup.modifications', function(event) {
            if (event.key === 'Escape') {
                unSubscribeToEventDismissVehicleModificationsPanel();
                dismissSlidePanelHandler(isChanged);
            }
        });

        $('.overlay').on('click.modifications', function() {
            unSubscribeToEventDismissVehicleModificationsPanel();
            dismissSlidePanelHandler(isChanged);
        });
    }

    function unSubscribeToEventDismissVehicleModificationsPanel() {
        $(document).off('click.modifications', '[data-dismiss="slide-panel"]');
        $(document).off('keyup.modifications');
        $('.overlay').off('click.modifications');
    }

    function dismissSlidePanelHandler(flag) {
        if (modificationCheckButton !== getModificationButtonCheckedState() || flag) {
            const journeyType = $('input[name=\'JourneyType\']').val();

            if (journeyType === bgl.components.journeyTypesVehicleDetails.SingleEdit) {
                bgl.common.utilities.startUnderwritingPolling();
            }

            if (journeyType === bgl.components.journeyTypesVehicleDetails.MultiStepEdit) {
                bgl.common.utilities.refreshPage();
            }
        }
    }

    function subscribeBackButton() {
        $('.vehicle-modification-back-button')
            .off('click')
            .on('click',
                function(event) {
                    event.preventDefault();

                    $(this).hide();

                    const link = $(event.currentTarget);
                    const productType = link.data('product-type');

                    const model = bgl.common.datastore.getData(form);
                    const url = $(this).attr('href');

                    model.ComponentConfiguration = configuration;

                    if (productType === 'van') {
                        bgl.components.vehicledetails.numberofseats.load(model,
                            url,
                            containerId);
                    } else {
                        bgl.components.vehicledetails.summary.load(model, url, containerId);
                    }
                });
    }

    function subscribeToEventShowModification() {
        const radioButtons = $('input[type=\'radio\']');

        $.each(radioButtons,
            function(key, item) {
                const button = $(item);

                button.on('change',
                    function(event) {
                        event.preventDefault();

                        const listContainer = $('#Vehicle-Modification-List');
                        switch ($(this).val()) {
                        case 'Yes':
                            const items = $('.step-form__summary-item');
                            if (items.length === 0) {
                                loadAddModification($(event.target).data('url'));
                            } else {
                                listContainer.show();
                            }
                            break;
                        case 'No':
                            listContainer.hide();

                            const continueButton = $('#vehicle-modification_continue-button');
                            if (continueButton.hasClass('hide')) {
                                continueButton.click();
                            }
                            break;
                        }
                    });
            });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function subscribeToEventAddModification() {
        const addModificationButton = $('#add-vehicle-modifications');

        addModificationButton.off('click').on('click',
            function(event) {
                event.preventDefault();

                const object = $(event.target);

                loadAddModification(object.data('url'));
            });
    }

    function subscribeToEventRemoveAllModifications() {
        const removeAllButton = $('#remove-all-vehicle-modifications');
        const noButton = $('#Modification-No');

        removeAllButton.off('click');
        removeAllButton.on('click',
            function(event) {
                event.preventDefault();

                noButton.click();
            });


        const doneButton = $('button[data-remove-all-url]');

        let clickHandler;

        const journeyType = $('input[name=\'JourneyType\']').val();

        if (journeyType === bgl.components.journeyTypesVehicleDetails.SingleEdit) {
            clickHandler = function(event) {
                event.preventDefault();

                unSubscribeToEventDismissVehicleModificationsPanel();

                const isModified = $(this).data('ismodified').toString().toLowerCase() === 'true';
                const isNoButtonChecked = noButton.is(':checked');

                if (isModified && isNoButtonChecked) {
                    const url = $(this).data('remove-all-url');
                    const data = {
                        __RequestVerificationToken: $('input[name=\'__RequestVerificationToken\']').val(),
                        vehicleId: $('#VehicleId').val(),
                    };

                    $.ajax({
                        url: url,
                        type: 'POST',
                        data: data,
                        success: function(data) {
                            if (!data.isSuccess && data.errorRedirectUrl !== null) {
                                bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                            } else if (data.isSuccess) {
                                bgl.common.utilities.startUnderwritingPolling();
                            }
                        },
                    });
                } else if (modificationCheckButton !== getModificationButtonCheckedState() || isChanged) {
                    bgl.common.utilities.startUnderwritingPolling();
                }

                isChanged = false;
            };
        } else {
            clickHandler = function(event) {
                event.preventDefault();

                const vehicleObject = bgl.common.datastore.getData(form);

                if ($('#Modification-No').is(':checked')) {
                    // remove modifications from session storage
                    const key = form.data('store-key');
                    delete vehicleObject['SelectedModifications'];
                    sessionStorage.setItem(key, JSON.stringify(vehicleObject));
                }

                if (journeyType === bgl.components.journeyTypesVehicleDetails.LookupEdit) {
                    const url = $(this).data('next-step-url');
                    const vehicleId = $('#VehicleId').val();
                    const registration = vehicleObject.Registration;
                    const hasValue = vehicleObject.HasValue;

                    const model = {
                        ComponentConfiguration: configuration,
                        HasValue: hasValue,
                        VehicleId: vehicleId,
                        Registration: registration,
                        JourneyType: journeyType,
                    };

                    bgl.components.vehicledetails.purchasedate.load(model, url, containerId);
                } else {
                    if (bgl.common.pubsub !== 'undefined') {
                        bgl.common.pubsub.emit('fakeFormSubmit', form.attr('id') || form.attr('action') || 'unknown');
                    }
                    bgl.common.utilities.redirectToUrl(configuration.ComponentUrl + '#purchasedate');
                }
            };
        }

        doneButton.one('click', clickHandler);
    }

    function subscribeToEventDeleteModification() {
        const deleteModificationButtons = $('[data-role=\'delete\']');

        $.each(deleteModificationButtons,
            function(key, item) {
                $(item).off('click').on('click',
                    function(event) {
                        event.preventDefault();

                        const target = $(event.target);

                        const object = target.is('a, button') ? target : target.parent();

                        const journeyType = $('input[name=\'JourneyType\']').val();
                        let modifications = {};

                        if (journeyType !== bgl.components.journeyTypesVehicleDetails.SingleEdit) {
                            const key = $('#vehicle-modifications-form').data('store-key');
                            const vehicleObject = JSON.parse(sessionStorage.getItem(key)) || {};
                            modifications = vehicleObject['SelectedModifications'] || [];

                            const modificationCode = object.data('modification-code');
                            const modificationTypeCode = object.data('modification-type-code');

                            modifications = modifications.filter(function(modification) {
                                return modification.SelectedModificationCode !== modificationCode &&
                  modification.SelectedModificationTypeCode !== modificationTypeCode;
                            });

                            if (modifications.length === 0) {
                                vehicleObject['IsModified'] = 'No';
                            }

                            vehicleObject['SelectedModifications'] = modifications;
                            sessionStorage.setItem(key, JSON.stringify(vehicleObject));

                            isChanged = true;

                            if (journeyType === bgl.components.journeyTypesVehicleDetails.MultiStepEdit) {
                                bgl.common.utilities.refreshPage();
                                return;
                            }

                            bgl.components.vehicledetails.modifications.load(generateInputModel(configuration),
                                $('#VehicleModificationsUrl').val(),
                                containerId);
                        } else {
                            const token = $('input[name=\'__RequestVerificationToken\']').val();
                            const patchUrl = object.data('url');
                            const vehicleId = $('#VehicleId').val();

                            const dataToPost = {
                                __RequestVerificationToken: token,
                                vehicleId: vehicleId,
                                modificationId: object.data('value'),
                                journeyType: journeyType,
                                modifications: modifications,
                            };

                            const model = generateInputModel(configuration);

                            $.ajax({
                                url: patchUrl,
                                type: 'POST',
                                data: dataToPost,
                                success: function(data, textStatus, request) {
                                    if (request.getResponseHeader('Content-Type') ===
                    'application/json; charset=utf-8') {
                                        if (!data.isSuccess) {
                                            bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                                        } else {
                                            isChanged = true;
                                            bgl.components.vehicledetails.modifications.load(model,
                                                data.redirectUrl,
                                                containerId);
                                        }
                                    }
                                },
                            });
                        }
                    });
            });
    }

    function generateInputModel(configuration) {
        const model = {
            ComponentConfiguration: configuration,
        };

        model.VehicleId = $('#VehicleId').val();
        model.JourneyType = $('#JourneyType').val();

        if (model.JourneyType !== bgl.components.journeyTypesVehicleDetails.SingleEdit) {
            const vehicleObject = bgl.common.datastore.getData(form);
            model.Modifications = vehicleObject['SelectedModifications'] || [];
            model.Model = vehicleObject.Model;
            model.Manufacturer = vehicleObject.Manufacturer;
        } else {
            model.EditActionKey = bgl.components.vehicledetails.list.vehicleDetailsKeys.vehicleModifications;
        }

        return model;
    }

    function loadAddModification(url) {
        isChanged = true;

        $('#add-vehicle-modifications-div').click();

        let currentContainerId = containerId;

        const journeyType = $('#JourneyType').val();

        if (journeyType.toString() === bgl.components.journeyTypesVehicleDetails.MultiStepEdit) {
            currentContainerId = 'SlidePanelContent';
            subscribeToEventDismissVehicleModificationsPanel();
        }

        bgl.components.vehicledetails.addmodification.load({
            ComponentConfiguration: configuration,
            VehicleId: $('#VehicleId').val(),
            JourneyType: journeyType,
        },
        url,
        currentContainerId);
    }

    function getModificationButtonCheckedState() {
        return $('#Modification-Yes').prop('checked');
    }

    return {
        load: loadComponent,
        init: initComponent,
    };
})();

bgl.components.vehicledetails.addmodification = (function() {
    let componentModel;
    let componentId;
    let configuration;
    let form;

    function loadComponent(model, componentUrl, containerElementId) {
        componentModel = model;
        componentId = containerElementId;
        configuration = model.ComponentConfiguration;

        bgl.common.loader.load(model,
            componentUrl,
            containerElementId,
            function() {
                bgl.components.vehicledetails.addmodification.init(configuration);
            });
    }

    function initComponent(componentConfiguration) {
        form = $('#' + componentConfiguration.Id + '_form-add-modification');
        bgl.common.validator.init(form);
        subscribeToEvents();
    }

    function subscribeToEvents() {
        subscribeModificationTypeButtons();
        subscribeBreadcrumbButton();
        subscribeSaveButton();
        subscribeBackButton();
    }

    function subscribeModificationTypeButtons() {
        const modificationButtons = $('[data-button-name="modificationTypeCode"]');
        $.each(modificationButtons,
            function(key, button) {
                $(button).off('click');
                $(button).on('click',
                    function(event) {
                        event.preventDefault();
                        if (typeof bgl.common.pubsub !== 'undefined') {
                            bgl.common.pubsub.emit(
                                'fakeFormSubmit',
                                this.parentElement.parentElement.getElementsByTagName('h2')[0].innerText,
                            );
                        }

                        const object = $(event.target)[0];
                        componentModel.SelectedModificationTypeCode = $(object).data('value');
                        componentModel.HasValue = $('input[name=\'HasValue\']').val();
                        componentModel.JourneyType = $('input[name=\'JourneyType\']').val();

                        bgl.components.vehicledetails.addmodification.load(componentModel,
                            $(object).data('url'), componentId,
                        );
                    });
            });
    }

    function subscribeBreadcrumbButton() {
        const breadcrumbButtons = $('#back-to-modification-type');

        if (breadcrumbButtons !== undefined && breadcrumbButtons !== null) {
            breadcrumbButtons.off('click');
            breadcrumbButtons.on('click',
                function(event) {
                    event.preventDefault();

                    const object = $(event.target)[0];

                    loadModificationTypeView($(object).data('url'));
                });
        }
    }

    function subscribeSaveButton() {
        const saveButton = $('#save-vehicle-modification');

        if (saveButton !== undefined && saveButton !== null) {
            saveButton.off('click');
            saveButton.on('click',
                function(event) {
                    event.preventDefault();
                    saveButton.attr('disabled', 'disabled');

                    if (!bgl.common.validator.isFormValid(form)) {
                        saveButton.removeAttr('disabled');
                    } else {
                        const checkedButton = $('#' + componentId).find('input[type=\'radio\']:checked');

                        if (checkedButton.length === 1) {
                            componentModel.SelectedModificationTypeDescription = $('#back-to-modification-type').text();

                            componentModel.SelectedModificationCode = checkedButton.val();

                            const journeyType = $('#JourneyType').val();

                            if (journeyType !== bgl.components.journeyTypesVehicleDetails.SingleEdit) {
                                const key = $('#DataStoreKey').val();
                                const vehicleObject = bgl.common.datastore.getData(key) || {};
                                const modifications = vehicleObject['SelectedModifications'] || [];
                                let hasDuplicate = false;

                                modifications.forEach(function(mod) {
                                    if (mod.SelectedModificationCode === componentModel.SelectedModificationCode &&
                    mod.SelectedModificationTypeCode ===
                    componentModel.SelectedModificationTypeCode) {
                                        hasDuplicate = true;
                                        return;
                                    }
                                });

                                if (hasDuplicate) {
                                    $('#modification-list, #save-vehicle-modification').addClass('hide');
                                    $('#modification-error').removeClass('hide');

                                    return;
                                }

                                modifications.push({
                                    SelectedModificationCode: componentModel.SelectedModificationCode,
                                    SelectedModificationCodeDescription: checkedButton.data('description').trim(),
                                    SelectedModificationTypeCode: componentModel.SelectedModificationTypeCode,
                                    SelectedModificationTypeDescription: componentModel
                                        .SelectedModificationTypeDescription.trim(),
                                });
                                vehicleObject['SelectedModifications'] = modifications;
                                sessionStorage.setItem(key, JSON.stringify(vehicleObject));

                                if (journeyType === bgl.components.journeyTypesVehicleDetails.LookupEdit) {
                                    loadModificationView($('#VehicleModificationsUrl').val());
                                } else {
                                    $('[data-dismiss=\'slide-panel\']').click();
                                    bgl.common.utilities.refreshPage();
                                }
                            } else {
                                const token = $('input[name=\'__RequestVerificationToken\']').val();

                                const dataToPost = {
                                    __RequestVerificationToken: token,
                                    model: componentModel,
                                };

                                bgl.common.validator.submitForm(form, configuration, dataToPost);
                            }
                        }
                    }
                });
        }
    }

    function subscribeBackButton() {
        const backButton = $('[data-step-type=\'previous-step\']');

        if (backButton.length !== 0) {
            backButton.off('click').on('click',
                function(event) {
                    $(this).hide();

                    const url = $(event.target).data('url');

                    switch ($(event.target).data('back-option')) {
                    case 'modificationType':
                        loadModificationTypeView(url);
                        break;
                    case 'modification':
                        loadModificationView(url);
                        break;
                    }
                });
        }
    }

    function loadModificationTypeView(url) {
        componentModel.SelectedModificationTypeCode = null;
        componentModel.SelectedModificationCode = null;

        bgl.components.vehicledetails.addmodification.load(componentModel, url, componentId);
    }

    function loadModificationView(url) {
        const model = {
            ComponentConfiguration: componentModel.ComponentConfiguration,
        };

        model.VehicleId = $('#VehicleId').val();
        model.JourneyType = $('input[name=\'JourneyType\']').val();
        model.EditActionKey = bgl.components.vehicledetails.list.vehicleDetailsKeys.vehicleModifications;

        if (model.JourneyType === bgl.components.journeyTypesVehicleDetails.LookupEdit) {
            const key = $('#DataStoreKey').val();
            const vehicleObject = JSON.parse(sessionStorage.getItem(key)) || {};
            model.Modifications = vehicleObject['SelectedModifications'] || [];
            model.Model = vehicleObject.Model;
            model.Manufacturer = vehicleObject.Manufacturer;
        }

        if (model.JourneyType !== bgl.components.journeyTypesVehicleDetails.MultiStepEdit) {
            bgl.components.vehicledetails.modifications.load(model,
                url,
                componentId);
        } else {
            $('[data-dismiss=\'slide-panel\']').click();
            bgl.common.utilities.refreshPage();
        }
    }

    function onSuccess(configuration, data) {
        loadModificationView(data.redirectUrl);
    }

    function onError() {
        bgl.components.vehicledetails.addmodification.init(configuration);
    }

    return {
        load: loadComponent,
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.vehicledetails;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.vehicledetails = bgl.components.vehicledetails || {};

bgl.components.journeyTypesVehicleDetails = {
    SingleEdit: '0',
    LookupEdit: '1',
    MultiStepEdit: '2',
};

bgl.components.vehicledetails.lookup = (function() {
    let configuration;
    let globalContainerId;

    function initComponent(componentConfiguration, containerElementId) {
        configuration = componentConfiguration;

        const editButton = $('#vehicle-lookup_edit-button');

        editButton.on('click',
            function(event) {
                const link = $(event.currentTarget);
                const containerSelector = link.data('container');
                const storeKey = link.data('store-key');

                sessionStorage.removeItem(storeKey);

                bgl.components.vehicledetails.searching.load({
                    ComponentConfiguration: configuration,
                    VehicleId: link.data('vehicle-id'),
                },
                link.data('action-url'),
                containerSelector);

                event.preventDefault();
            });
    }

    function initPage(componentConfiguration, pageContainerId) {
        if (configuration === undefined) {
            configuration = componentConfiguration;
        }

        if (pageContainerId !== undefined) {
            globalContainerId = pageContainerId;
        }

        $(window).off('hashchange').on('hashchange', loadVehicleContent);
        $(document).ready(loadVehicleContent);
    }

    function loadVehicleContent() {
        const hash = bgl.common.utilities.getUrlHashValue() || '';

        const vehicleObject = bgl.common.datastore.getData(configuration.DataStoreKey) || {};

        vehicleObject.ComponentConfiguration = configuration;
        vehicleObject.DataStoreKey = configuration.DataStoreKey;
        vehicleObject.JourneyType = configuration.JourneyType;

        if (hash.toLowerCase() === 'value' &&
            vehicleObject.HasValue &&
            vehicleObject.HasValue.toLowerCase() === 'true') {
            bgl.common.utilities.setUrlHashValue('purchasedate');
            return;
        }

        switch (hash.toLowerCase()) {
        case 'purchasedate':
            bgl.components.vehicledetails.purchasedate.load(vehicleObject,
                configuration.PurchasedDateUrl,
                globalContainerId);
            break;
        case 'numberofseats':
            bgl.components.vehicledetails.numberofseats.load(vehicleObject,
                configuration.NumberOfSeatsUrl,
                globalContainerId);
            break;
        case 'vehiclebodytype':
            bgl.components.vehicledetails.vehiclebodytype.load(vehicleObject,
                configuration.VehicleBodyTypeUrl,
                globalContainerId);
            break;
        case 'modifications':
            vehicleObject.Modifications = vehicleObject['SelectedModifications'] || [];

            bgl.components.vehicledetails.modifications.load(vehicleObject,
                configuration.ModificationsUrl,
                globalContainerId);
            break;
        case 'value':
            bgl.components.vehicledetails.value.load(vehicleObject,
                configuration.EditValueUrl,
                globalContainerId);
            break;
        case 'main-content':
            scrollToMainContentOfPage();
            break;
        default:
            bgl.components.vehicledetails.summary.load(vehicleObject,
                configuration.SearchSummaryUrl,
                globalContainerId);
            break;
        }
    }

    // form is passed from vehicledetails.lookup.purchasedate/value- files not converted from jquery to JS yet
    function postVehicle(form, url) {
        const data = getData(form);

        data.HasChanges = data.isFormDirty;

        $.post(url, data, function(response) {
            if (!response.isSuccess && response.errorRedirectUrl) {
                bgl.common.utilities.errorRedirect(response.errorRedirectUrl);
            } else if (response.isSuccess) {
                if (response.journeyType.toString() === bgl.components.journeyTypesVehicleDetails.MultiStepEdit) {
                    if (response.hasRegistrationNumber === false) {
                        bgl.common.datastore.extendCollectedData(
                            configuration.DataStoreKey,
                            {VehicleRegistrationNumber: ''},
                        );
                    }

                    bgl.common.datastore.extendCollectedData(configuration.DataStoreKey, {isFormDirty: false});
                    bgl.common.utilities.redirectToUrl(response.redirectUrl);
                    return;
                }

                bgl.common.datastore.removeSessionStorage(form);

                if (configuration && configuration.IsService) {
                    if (data.HasChanges) {
                        mtaChange(configuration.IsInitialChange);
                    } else {
                        document.querySelector('[data-dismiss="slide-panel"]').click();
                    }
                } else {
                    bgl.common.pubsub.emit('PollBasket');
                    document.querySelector('[data-dismiss="slide-panel"]').click();
                }
            }
        });
    }

    function getData(form) {
        const token = form.find('input[name="__RequestVerificationToken"]').val();
        const data = bgl.common.datastore.getData(form) || {};

        data.__RequestVerificationToken = token;
        data.ComponentConfiguration = configuration;

        return data;
    }

    function scrollToMainContentOfPage() {
        const requiredField = $('#main-content');
        $('html,body').animate({scrollTop: requiredField.offset().top}, 0);
    }

    function mtaChange(isInitialChange) {
        bgl.common.pubsub.emit('PollBasket', getParams(isInitialChange));
    }

    function getParams(isInitialChange) {
        return isInitialChange ?
            {callback: () => bgl.common.utilities.redirectToUrl(configuration.NextStepUrl)} :
            null;
    }

    return {
        init: initComponent,
        initPage: initPage,
        postVehicle: postVehicle,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.vehicledetails;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.vehicledetails = bgl.components.vehicledetails || {};

bgl.components.journeyTypesVehicleDetails = {
    SingleEdit: '0',
    LookupEdit: '1',
    MultiStepEdit: '2',
};

bgl.components.vehicledetails.common = (function() {
    function getPreviouslyStoredChangedVehicleData() {
        let data = [];

        if (sessionStorage.getItem('ChangedVehicleData') !== null) {
            data = JSON.parse(sessionStorage.getItem('ChangedVehicleData'));
        }

        return data;
    }

    function setPreviouslyStoredChangedVehicleData(data) {
        sessionStorage.setItem('ChangedVehicleData', JSON.stringify(data));
    }

    return {
        getPreviouslyStoredChangedVehicleData: getPreviouslyStoredChangedVehicleData,
        setPreviouslyStoredChangedVehicleData: setPreviouslyStoredChangedVehicleData,
    };
})();

bgl.components.vehicledetails.list = (function() {
    let configuration;

    const vehicleDetailsKeys = {
        vehicleModifications: 'add-vehicle-modifications',
        overnightParking: 'overnightParking',
        dateOfPurchase: 'purchaseDate',
        assumedData: 'assumedData',
        vehicleSpecification: 'vehicleSpecification',
        registrationNumber: 'registrationNumber',
        vanBodyType: 'vanBodyType',
        numberOfSeats: 'numberOfSeats',
        vehicleValue: 'value',
    };

    function initComponent(componentConfiguration, containerElementId) {
        const ENTER_KEYCODE = 13;
        const SPACE_KEYCODE = 32;

        configuration = componentConfiguration;

        const editButton = $('.vehicle-details_edit-button');
        const yesButton = $('#Modification-Yes');
        const noButton = $('#Modification-No');
        const section = $('#Vehicle-Modification-List');

        bgl.common.accordions.init();

        editButton.off()
            .on({
                'keyup': function(event) {
                    const code = event.charCode || event.keyCode;
                    const link = $(this);

                    if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
                        link.click();
                    }
                },
                'click': function(event) {
                    event.preventDefault();

                    const link = $(this);
                    const actionUrl = link.data('action-url');

                    if (componentConfiguration.IsService && componentConfiguration.LoadEditAsARedirect) {
                        bgl.common.utilities.redirectToUrl(actionUrl);
                    } else {
                        const containerSelector = link.data('container');
                        const editActionKey = link.data('edit-action-key');
                        const vehicleId = link.data('vehicle-id');
                        const vehicleType = link.data('vehicle-type');
                        const storeKey = link.data('store-key');
                        const data = {
                            ComponentConfiguration: configuration,
                            EditActionKey: editActionKey,
                            VehicleId: vehicleId,
                            VehicleType: vehicleType,
                        };

                        loadComponentByActionKey(data, containerSelector, actionUrl, storeKey);
                    }
                },
            });

        noButton.on('click', function() {
            section.hide();
        });

        yesButton.on('click', function() {
            section.show();
        });

        const triggerKey = 'VehicleDetails__VehicleDetails__ClickEditVehicle';
        const trigger = sessionStorage.getItem(triggerKey);
        if (trigger === 'true') {
            sessionStorage.removeItem(triggerKey);
            $('#' + configuration.Id + '_vehicleSpecification__edit-button').click();
        }
    }

    function loadComponentByActionKey(data, selector, actionUrl, storeKey) {
        switch (data.EditActionKey) {
        case vehicleDetailsKeys.vehicleSpecification:
            sessionStorage.removeItem(storeKey);

            bgl.components.vehicledetails.searching.load(data,
                actionUrl,
                selector,
            );
            break;

        case vehicleDetailsKeys.dateOfPurchase:
            bgl.components.vehicledetails.purchasedate.load(
                data,
                actionUrl,
                selector);
            break;

        case vehicleDetailsKeys.vehicleModifications:
            bgl.components.vehicledetails.modifications.load(
                data,
                actionUrl,
                selector);
            break;

        case vehicleDetailsKeys.assumedData:
            bgl.components.vehicledetails.editassumeddata.load(
                data,
                actionUrl,
                selector);
            break;

        case vehicleDetailsKeys.overnightParking:
            bgl.components.overnightparking.load(
                data,
                actionUrl,
                selector);
            break;

        case vehicleDetailsKeys.registrationNumber:
            bgl.components.vehicledetails.registrationnumber.load(
                data,
                actionUrl,
                selector);
            break;

        case vehicleDetailsKeys.vanBodyType:
            bgl.components.vehicledetails.vehiclebodytype.load(
                data,
                actionUrl,
                selector);
            break;

        case vehicleDetailsKeys.numberOfSeats:
            bgl.components.vehicledetails.numberofseats.load(
                data,
                actionUrl,
                selector);
            break;

        case vehicleDetailsKeys.vehicleValue:
            bgl.components.vehicledetails.value.load(
                data,
                actionUrl,
                selector);
            break;

        default:
            $('#' + selector).empty();
            break;
        }
    }

    return {
        init: initComponent,
        vehicleDetailsKeys: vehicleDetailsKeys,
    };
})();

bgl.components.overnightparking = (function() {
    let configuration;
    let form;

    function loadComponent(model, componentUrl, containerElementId) {
        configuration = model.ComponentConfiguration;

        bgl.common.loader.load(model,
            componentUrl,
            containerElementId,
            function() {
                bgl.components.overnightparking.init(configuration);
            });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;

        form = $('[data-component-id=\'' + configuration.Id + '\'] form');

        bgl.common.validator.init(form);

        bgl.common.datastore.init(form);

        subscribeToEvents();
    }

    function subscribeToEvents() {
        form.off('submit').on('submit',
            function(event) {
                event.preventDefault();

                if (bgl.common.validator.isFormValid($(this))) {
                    $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)));

                    storeVehicleChangesForTagManager();

                    bgl.common.validator.submitForm($(this), configuration);

                    if (configuration.IsService) {
                        const mtaSuffix = bgl.common.utilities.getWindowLocation()
                            .href.toLowerCase().includes('makechanges') ?
                            'start' :
                            'additional change';

                        bgl.common.telemetry.logEvent(`MTA ${mtaSuffix}`,
                            {mta_type: 'Overnight parking', component: configuration.Id});
                    }
                }
            });
        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function storeVehicleChangesForTagManager() {
        const data = bgl.components.vehicledetails.common.getPreviouslyStoredChangedVehicleData();
        const vehicleOvernightParking = getSelectedOvernightParkingValue();

        if (vehicleOvernightParking) {
            data.push(['VehicleOvernightParking', vehicleOvernightParking]);
            bgl.components.vehicledetails.common.setPreviouslyStoredChangedVehicleData(data);
        }
    }

    function getSelectedOvernightParkingValue() {
        const checkedRadioButtonId = $('input[name=OvernightParkingCode]:checked').attr('id');
        const valueForCheckedOvernightParkingRadioButton = $(`label[for="${checkedRadioButtonId}"]`).html();

        return valueForCheckedOvernightParkingRadioButton;
    }

    function onSuccess(configuration, data) {
        bgl.common.datastore.removeSessionStorage(form);

        if (configuration && configuration.IsService) {
            if (data.hasChanges) {
                mtaChange(configuration.IsInitialChange);
            } else {
                document.querySelector('[data-dismiss="slide-panel"]').click();
            }
        } else {
            bgl.common.pubsub.emit('PollBasket');
            document.querySelector('[data-dismiss="slide-panel"]').click();
        }
    }

    function onError(configuration) {
        bgl.components.overnightparking.init(configuration);
    }

    function mtaChange(isInitialChange) {
        bgl.common.pubsub.emit('PollBasket', getParams(isInitialChange));
    }

    function getParams(isInitialChange) {
        return isInitialChange ?
            {callback: () => bgl.common.utilities.redirectToUrl(configuration.NextStepUrl)} :
            null;
    }

    return {
        load: loadComponent,
        init: initComponent,
        onSuccess: onSuccess,
        storeVehicleChangesForTagManager: storeVehicleChangesForTagManager,
        getSelectedOvernightParkingValue: getSelectedOvernightParkingValue,
        onError: onError,
    };
})();

bgl.components.vehicledetails.registrationnumber = (function() {
    let configuration;
    let form;
    let containerId;

    function loadComponent(model, componentUrl, containerElementId) {
        configuration = model.ComponentConfiguration;
        containerId = containerElementId;

        bgl.common.loader.load(model,
            componentUrl,
            containerElementId,
            function() {
                bgl.components.vehicledetails.registrationnumber.init(configuration);
            });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;

        form = $('[data-component-id=\'' + configuration.Id + '\'] form');

        bgl.common.validator.init(form);

        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();

        subscribeToEvents();
    }

    function subscribeToEvents() {
        form.off('submit').on('submit',
            function(event) {
                event.preventDefault();

                const inputField = $('#registration-number');
                inputField.val(inputField.val().replace(/\s+/gi, ''));

                if (bgl.common.validator.isFormValid($(this))) {
                    $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)));

                    const currentData = bgl.common.datastore.getData($(this));
                    const dataForValidate = $(form).serialize() +
                        '&' +
                        $.param(currentData) +
                        '&' +
                        $.param({ComponentConfiguration: configuration});

                    bgl.common.validator.submitForm(form, configuration, dataForValidate);
                }
            });

        $('a[data-load-change-vehicle]').one('click',
            function(event) {
                event.preventDefault();

                const link = $(event.currentTarget);
                const containerSelector = link.data('container');

                const onEventName = link.data('init-event');
                const callback = eval(onEventName);
                const vehicleId = link.data('vehicle-id') || bgl.common.datastore.getData(form).VehicleId;

                const model = {
                    ComponentConfiguration: configuration,
                    vehicleId: vehicleId,
                };

                if (typeof callback === 'function') {
                    bgl.common.loader.load(model,
                        link.data('action-url'),
                        containerSelector,
                        function() {
                            callback(configuration);
                        });
                }
            });

        $('#registration-number').on('input',
            function() {
                const start = this.selectionStart;
                const end = this.selectionEnd;

                this.value = this.value.toUpperCase();

                this.setSelectionRange(start, end);
            });
    }

    function onSuccess(configuration, data) {
        const model = data.content;
        model.ComponentConfiguration = configuration;

        if (model.IsRegistrationNumberChange) {
            bgl.components.vehicledetails.registrationnumberinformation.load(
                model,
                data.componentUrl,
                containerId);
        } else {
            bgl.components.vehicledetails.searching.load(
                model,
                data.componentUrl,
                containerId);
        }
    }

    function onError(configuration) {
        bgl.components.vehicledetails.registrationnumber.init(configuration);
    }

    return {
        load: loadComponent,
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

bgl.components.vehicledetails.registrationnumberinformation = (function() {
    let configuration;
    let form;

    function loadComponent(model, componentUrl, containerElementId) {
        configuration = model.ComponentConfiguration;

        bgl.common.loader.load(model,
            componentUrl,
            containerElementId,
            function() {
                bgl.components.vehicledetails.registrationnumberinformation.init(configuration);
            });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;

        form = document.querySelector(`[data-component-id=${configuration.Id}] form`);

        bgl.common.datastore.init(form);
        bgl.common.validator.init(form);

        subscribeToEvents();
    }

    function subscribeToEvents() {
        form.addEventListener('submit',
            function(event) {
                event.preventDefault();

                if (!(document.getElementById('agreement-checkbox').checked)) {
                    document.getElementById('agreement-container').classList.add('error');
                } else {
                    if (bgl.common.validator.isFormValid(form)) {
                        document.getElementById('HasChanges').value = bgl.common.datastore.isDataChanged(form);

                        bgl.common.validator.submitForm(form, configuration);
                    }
                }
            });

        $('a[data-step-type=\'previous-step\']').off('click').one('click',
            function(event) {
                event.preventDefault();

                const link = $(event.currentTarget);
                const containerSelector = link.data('container');
                const url = link.data('action-url');

                const data = bgl.common.datastore.getData(form);

                const model = {
                    ComponentConfiguration: configuration,
                    VehicleId: link.data('vehicle-id'),
                    RegistrationNumber: data.RegistrationNumber,
                };

                bgl.components.vehicledetails.registrationnumber.load(model, url, containerSelector);
            });
    }

    function onSuccess(configuration, data) {
        bgl.common.datastore.removeSessionStorage(form);

        if (configuration.IsService && data.hasChanges) {
            mtaChange(configuration.IsInitialChange);
        } else {
            document.querySelector('[data-dismiss="slide-panel"]').click();
        }
    }

    function onError(configuration) {
        bgl.components.vehicledetails.registrationnumberinformation.init(configuration);
    }

    function mtaChange(isInitialChange) {
        const mtaSuffix = isInitialChange ? 'start' : 'additional change';

        bgl.common.telemetry.logEvent(`MTA ${mtaSuffix}`, {mta_type: 'Vehicle change', component: configuration.Id});

        bgl.common.pubsub.emit('PollBasket', getParams(isInitialChange));
    }

    function getParams(isInitialChange) {
        return isInitialChange ?
            {
                callback: () => {
                    bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
                },
            } :
            null;
    }

    return {
        load: loadComponent,
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.vehicledetails;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.vehicledetails = bgl.components.vehicledetails || {};

bgl.components.journeyTypesVehicleDetails = {
    SingleEdit: '0',
    LookupEdit: '1',
    MultiStepEdit: '2',
};

bgl.components.vehicledetails.editassumeddata = (function() {
    let containerId;
    let configuration;
    let immobilizer;
    let trackingDevice;
    let rightHandDrive;
    let form;

    function loadComponent(model, componentUrl, containerElementId) {
        bgl.common.loader.load(model,
            componentUrl,
            containerElementId,
            function() {
                bgl.components.vehicledetails.editassumeddata.init(model.ComponentConfiguration, containerElementId);
            });
    }

    function init(componentConfiguration, containerElementId) {
        configuration = componentConfiguration;
        containerId = containerElementId;
        immobilizer = getImmobilizerValue();
        trackingDevice = getTrackingDeviceCheckedState();
        rightHandDrive = getRightHandDriveCheckedState();

        form = $('[data-component-id=\'' + configuration.Id + '\'] form');
        bgl.common.datastore.init(form);

        form.each(function() {
            bgl.common.validator.init($(this));
        });

        form.on('submit',
            function(e) {
                e.preventDefault();

                if (bgl.common.validator.isFormValid($(this))) {
                    if (!bgl.common.datastore.isDataChanged(form)) {
                        bgl.common.datastore.removeSessionStorage(form);
                        $('[data-dismiss="slide-panel"]').click();
                        return;
                    }

                    bgl.common.validator.submitForm($(this), componentConfiguration);
                }
            });
    }

    function onSuccess() {
        if (immobilizer !== getImmobilizerValue() ||
            trackingDevice !== getTrackingDeviceCheckedState() ||
            rightHandDrive !== getRightHandDriveCheckedState()) {
            bgl.common.utilities.startUnderwritingPolling();
            bgl.common.datastore.removeSessionStorage(form);
        }

        $('[data-dismiss="slide-panel"]').click();
    }

    function onError() {
        bgl.components.vehicledetails.editassumeddata.init(configuration, containerId);
    }

    function getImmobilizerValue() {
        return $('#SecurityDeviceCode').val();
    }

    function getTrackingDeviceCheckedState() {
        return $('#Tracking-Device-Yes').prop('checked');
    }

    function getRightHandDriveCheckedState() {
        return $('#Right-Hand-Drive-Yes').prop('checked');
    }

    return {
        load: loadComponent,
        init: init,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.vehicledetails;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.thirdpartymarketingpreferences = bgl.components.thirdpartymarketingpreferences || {};

bgl.components.thirdpartymarketingpreferences.thirdpartyupdatepolicy = (function() {
    function initComponent(componentConfiguration) {
        subscribeToEvents(componentConfiguration);
    }

    function subscribeToEvents(configuration) {
        const componentEndpoint = 'ThirdPartyMarketingPreferencesComponent/UpdateThirdPartyMarketingPreferences';
        const componentUrl = configuration.TenantConfiguration.ApplicationPath + componentEndpoint;
        const containerId = 'SlidePanelContent';

        document.getElementById('marketing-preference-open-slider-button').addEventListener('click', (event) => {
            event.preventDefault();
            bgl.common.loader.load(configuration, componentUrl, containerId, () => {
                bgl.components.thirdpartymarketingpreferences.thirdpartyupdate.init(configuration);
            });
        });
    }

    return {
        init: initComponent,
    };
})();
// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.thirdpartymarketingpreferences = bgl.components.thirdpartymarketingpreferences || {};

bgl.components.thirdpartymarketingpreferences.thirdpartyupdate = (function() {
    let configuration; let initialSelection; let validationTriggered;
    const questions = ['email', 'post', 'devicemessaging', 'textmessages', 'phone'];

    function initComponent(componentConfiguration) {
        validationTriggered = false;
        configuration = componentConfiguration;

        setInitialPreferencesSelection(configuration.Id);
        generateClickOnKeyPressForLabels(configuration.Id);
        document.body.querySelector('#ThirdPartyMarketingPreferencesNextButton').addEventListener('click', (event) => {
            event.preventDefault();
            onNextClick(configuration);
        });

        const allLabels = document.body.querySelectorAll('[data-type="marketing-preference-radio-label"]');
        for (let i = 0; i < allLabels.length; i++) {
            allLabels[i].addEventListener('click',
                function(event) {
                    event.preventDefault();
                    const elementFor = this.getAttribute('for');
                    document.body.querySelector('#' + elementFor).checked = true;
                    if (validationTriggered) {
                        showValidation(configuration.Id);
                    }
                });
        }
    }

    function generateClickOnKeyPressForLabels(componentId) {
        const selector = document.body.querySelectorAll('[data-testid="' + componentId + '-page-section"] label');
        for (let i = 0; i < selector.length; i++) {
            selector[i].addEventListener('keydown', function(event) {
                const SPACE_KEYCODE = 32;
                const ENTER_KEYCODE = 13;
                const code = event.charCode || event.keyCode;
                if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
                    event.preventDefault();
                    event.currentTarget.click();
                }
            });
        }
    }

    function onNextClick(configuration) {
        const preferencesToSubmit = getMarketingPreferencesConsent(configuration.Id);

        if (dataHasChanged(preferencesToSubmit)) {
            if (areAllQuestionsAnswered(configuration.Id)) {
                submitPreferences(configuration, preferencesToSubmit);
            } else {
                showValidation(configuration.Id);
                scrollToListItemWithError();
            }
        } else {
            document.body.querySelector('[data-dismiss="slide-panel"]').click();
        }
    }

    function showValidation(componentId) {
        validationTriggered = true;
        for (let i = 0; i < questions.length; i++) {
            if (!isRadioButtonChecked(`#${componentId}-${questions[i]}-yes`) &&
            !isRadioButtonChecked(`#${componentId}-${questions[i]}-no`)) {
                addClassToElementIfItExists(`#${componentId}-${questions[i]}-fieldset-container`, 'error');
                addClassToElementIfItExists(`#${componentId}-${questions[i]}-heading`, 'error-text__heading');
                addClassToElementIfItExists(`#${componentId}-${questions[i]}-list-item`, 'error');
                addClassToElementIfItExists(`#${componentId}-${questions[i]}-heading-text`, 'error');
            } else {
                removeClassFromElementIfItExists(`#${componentId}-${questions[i]}-fieldset-container`, 'error');
                removeClassFromElementIfItExists(`#${componentId}-${questions[i]}-heading`, 'error-text__heading');
                removeClassFromElementIfItExists(`#${componentId}-${questions[i]}-list-item`, 'error');
                removeClassFromElementIfItExists(`#${componentId}-${questions[i]}-heading-text`, 'error');
            }
        }
    }

    function scrollToListItemWithError() {
        const listItemsInErrorState = document.body.querySelectorAll(
            '[data-type="marketing-preference-list-item"].error',
        );

        if (listItemsInErrorState.length > 0) {
            listItemsInErrorState[0].scrollIntoView(true);
            const headerHeight = document.body.querySelector('header').offsetHeight;
            const currentYPosition = window.scrollY;
            if (currentYPosition) {
                window.scroll(0, currentYPosition - headerHeight);
            }
        }
    }

    function addClassToElementIfItExists(elementSelector, className) {
        const element = document.body.querySelector(elementSelector);
        if (element != null) {
            element.classList.add(className);
        }
    }

    function removeClassFromElementIfItExists(elementSelector, className) {
        const element = document.body.querySelector(elementSelector);
        if (element != null) {
            element.classList.remove(className);
        }
    }

    function submitPreferences(configuration, preferencesToSubmit) {
        const methodPath = configuration.TenantConfiguration.ApplicationPath +
            'ThirdPartyMarketingPreferencesComponent/';
        let nextPageUrl = methodPath + 'ErrorThirdPartyMarketingPreferences';
        const dataToPost = buildDataToPost(configuration, preferencesToSubmit);

        $.ajax({
            url: methodPath + 'SubmitThirdPartyMarketingPreferences',
            type: 'POST',
            dataType: 'json',
            data: dataToPost,
            success: function(response) {
                if (response.isSuccess) {
                    nextPageUrl = methodPath + 'AllDoneThirdPartyMarketingPreferences';
                }
            },
            complete: function() {
                bgl.common.loader.load({}, nextPageUrl, 'SlidePanelContent');
            },
        });
    }

    function dataHasChanged(preferencesToSubmit) {
        return JSON.stringify(initialSelection) !== JSON.stringify(preferencesToSubmit);
    }

    function buildDataToPost(configuration, preferencesToSubmit) {
        return {
            __RequestVerificationToken: document.body.querySelector('input[name="__RequestVerificationToken"]').value,
            MarketingPreferences: preferencesToSubmit,
            BrandCode: configuration.BrandCode,
            IsService: configuration.IsService,
        };
    }

    function areAllQuestionsAnswered(componentId) {
        for (let i = 0; i < questions.length; i++) {
            if (!isRadioButtonChecked('#' + componentId + '-' + questions[i] + '-yes') &&
        !isRadioButtonChecked('#' + componentId + '-' + questions[i] + '-no')) {
                return false;
            }
        }
        return true;
    }

    function isRadioButtonChecked(radioButtonSelector) {
        return document.body.querySelector(radioButtonSelector).checked;
    }

    function setInitialPreferencesSelection(componentId) {
        initialSelection = getMarketingPreferencesConsent(componentId);
    }

    function getMarketingPreferencesConsent(componentId) {
        return {
            Post: getConsent(componentId, 'post'),
            Email: getConsent(componentId, 'email'),
            Sms: getConsent(componentId, 'textmessages'),
            DeviceMessaging: getConsent(componentId, 'devicemessaging'),
            Telephone: getConsent(componentId, 'phone'),
        };
    }

    function getConsent(componentId, marketingPreference) {
        if (isRadioButtonChecked('#' + componentId + '-' + marketingPreference + '-yes')) {
            return true;
        } else if (isRadioButtonChecked('#' + componentId + '-' + marketingPreference + '-no')) {
            return false;
        } else {
            return null;
        }
    }

    return {
        init: initComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.termsandconds = bgl.components.termsandconds || {};

bgl.components.termsandconds.legalmodal = (function() {
    let modal; let overlay; let isRead; let modalContent;

    function initComponent(componentConfiguration) {
        modal = $('#legal-modal');
        modalContent = $('#legal-model-content');
        overlay = $('#overlay');
        isRead = false;
        setUpEventBindings();
        if (!termsAndConditionsHaveBeenAccepted()) {
            showModal();
        }
    }

    function setUpEventBindings() {
        accordionEventBindings();
        dismissalEventBindings();
        scrollEventBindings();
    }

    function scrollEventBindings() {
        const modalContent = modal.find('.modal-body');

        modalContent.on('scroll',
            function() {
                if (isElementScrolledToBottom($(this))) {
                    isRead = true;
                    enableContinueButton();
                    hideErrorMessage();
                }
            });
    }

    function isElementScrolledToBottom(element) {
        const heightOfTheScrollingContent = element[0].scrollHeight;
        const heightOfTheElementContainingScrollingContent = element.innerHeight();
        const amountToScroll = heightOfTheScrollingContent - heightOfTheElementContainingScrollingContent;
        const amountCurrentlyScrolled = element.scrollTop();

        const distanceFromBottom = amountToScroll - amountCurrentlyScrolled;

        return distanceFromBottom < 25;
    }

    function accordionEventBindings() {
        const accordions = $('.legal-accordion__heading-button');

        accordions.on('click', function() {
            toggleAccordion($(this));
        });
    }

    function toggleAccordion(accordionButton) {
        const accordionSection = accordionButton.closest('.accordion__section');
        const accordionContent = accordionSection.find('.accordion__body-wrapper');

        if (accordionContent.hasClass('hide')) {
            accordionContent.removeClass('hide');
        } else {
            accordionContent.addClass('hide');
        }
    }

    function dismissalEventBindings() {
        const continueButton = $('#close-modal');

        $(continueButton).on('click',
            function() {
                dismissOrShowError();
            });

        $('body').on('click',
            function(event) {
                const wasModalClicked = $(event.target).closest('#legal-model-content').is(modalContent);

                if (!wasModalClicked) {
                    dismissOrShowError();
                }
            });
    }

    function dismissOrShowError() {
        if (isRead) {
            addTermsAndConditionsAcceptedInSessionStorage();
            dismissModal();
        } else {
            showErrorMessage();
        }
    }

    function showErrorMessage() {
        const modalFooter = $('.modal-footer');
        const errorText = modalFooter.find('p.error');
        modalFooter.addClass('modal-footer--error');
        errorText.addClass('show');
    }

    function hideErrorMessage() {
        const modalFooter = $('.modal-footer');
        const errorText = modalFooter.find('p.error');
        errorText.removeClass('show');
        modalFooter.removeClass('modal-footer--error');
    }

    function enableContinueButton() {
        const closeButton = $('#close-modal');
        closeButton.removeClass('button--disabled');
        closeButton.addClass('button--primary');
    }

    function showModal() {
        overlay.addClass('show');
        overlay.removeClass('hide');
        modal.addClass('show');
        disableScrolling();
    }

    function dismissModal() {
        modal.fadeOut(800);
        overlay.fadeOut(800);
        modal.removeClass('show');
        overlay.removeClass('show');
        enableScrolling();
    }

    function disableScrolling() {
        $('body').addClass('modal-open');
    }

    function enableScrolling() {
        $('body').removeClass('modal-open');
    }

    function addTermsAndConditionsAcceptedInSessionStorage() {
        sessionStorage.setItem('T&CAccepted', true);
    }

    function termsAndConditionsHaveBeenAccepted() {
        const sessionStorageValue = sessionStorage.getItem('T&CAccepted');

        return sessionStorageValue == 'true';
    }

    return {
        init: initComponent,
    };
})();

﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};


bgl.components.takepayment.updatepaymentmethodcomplete = (function() {
    let configuration;
    const slidePanelContainer = 'SlidePanelContent';
    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(componentConfiguration, componentUrl, containerElementId, function() {
            initComponent(componentConfiguration);
        });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        onBackButtonClick();
        onClickDoneButton();
        onClickConfirmPaymentMethod();
    }

    function onBackButtonClick() {
        $('#BackPaymentMethod').on('click', function() {
            const linkId = this.id;
            const linkButton = $('#' + linkId);
            const actionUrl = linkButton.data('action-url');
            let dataActionUrl = actionUrl;
            if (configuration.LayoutOption === 'PageAsSlider') {
                dataActionUrl = '/TakePaymentComponent/AddPaymentMethodConfirmation';
            }
            const containerSelector = slidePanelContainer;
            const requestBodyData = {componentConfiguration: configuration};
            bgl.common.loader.load(requestBodyData,
                dataActionUrl,
                containerSelector,
                function() {
                    if (configuration.LayoutOption === 'PageAsSlider') {
                        bgl.components.takepayment.addpaymentmethodconfirmation.init(configuration);
                    } else {
                        bgl.components.takepayment.paymentmethods.init(configuration);
                    }
                });
        });
    }

    function onClickConfirmPaymentMethod() {
        $('#ConfirmPaymentMethod').on('click', function() {
            bgl.common.utilities.redirectToUrl(configuration.PaymentMethodAllDoneUrl);
        });
    }

    function onClickDoneButton() {
        $('#Done-button').on('click', function() {
            clearSomeKeysFromSessionStorage();
            bgl.common.utilities.redirectToUrl(configuration.RedirectUrl);
        });
    }

    function clearSomeKeysFromSessionStorage() {
        const keysToRemove = [
            '3dSecureTimeoutId',
            'ActiveTab',
            'AddPaymentCardCaptureUri',
            'AddPaymentCreditCardSelectedPersonId',
            'AddPaymentCreditCardSelectedPersonIdText',
            'AddPaymentCreditCardSelectedPersonIdVal',
            'AddPaymentDirectDebitAccountNumber',
            'AddPaymentDirectDebitSelectedPersonId',
            'AddPaymentDirectDebitSelectedPersonIdText',
            'AddPaymentDirectDebitSelectedPersonIdVal',
            'AddPaymentDirectDebitSortCodePart1',
            'AddPaymentDirectDebitSortCodePart2',
            'AddPaymentDirectDebitSortCodePart3',
            'AddPaymentDirectDebitAuthorise',
            'AddPaymentMethodCardCaptureUri',
            'AddPaymentMethodSecureSessionId',
            'AddPaymentSecureSessionId',
            'AnnualCardCaptureUri',
            'AnnualSecureSessionId',
            'AnnualSelectedPersonIdText',
            'ContinuousPaymentCardCaptureUri',
            'ContinuousPaymentCardEdit',
            'ContinuousPaymentCardSecureSessionId',
            'credit-information',
            'MonthlyDepositSelectedPersonIdText',
            'MTAStartPage',
            'OneOffPaymentSelectedPersonIdText',
            'OneOffPaymentCardCaptureUri',
            'OneOffPaymentSecureSessionId',
            'OneOffPaymentSelectedPersonIdVal',
            'OneOffPaymentSelectedPersonId',
            'PaymentProcessedPolicyId',
            'PaymentProcessedRedirectUrl',
            'UseMonthlyInstalmentCard',
        ];

        keysToRemove.forEach(function(key) {
            window.sessionStorage.removeItem(key);
        });
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.paymentstatus;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.refundsummary = (function() {
    let componentConfig;
    let requestVerificationToken;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        componentConfig = componentConfiguration;

        bgl.components.takepayment.cancellations.init(componentConfiguration);

        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent();
            });
    }

    function initComponent() {
        const confirmButton = $('[data-refund-confirm-button]');
        const cancellationConfirmationCheckbox = $('#cancellation-confirmation-checkbox');

        confirmButton.on('click',
            function() {
                commitRefund();
            });

        cancellationConfirmationCheckbox.on('click',
            function() {
                const isChecked = cancellationConfirmationCheckbox.is(':checked');

                if (isChecked) {
                    confirmButton.removeAttr('disabled');
                } else {
                    confirmButton.attr('disabled', 'disabled');
                }
            });
    }

    function commitRefund() {
        requestVerificationToken = $('input[name="__RequestVerificationToken"]').val();

        const dataToPost = {
            __RequestVerificationToken: requestVerificationToken,
            configuration: componentConfig,
        };

        $('body').html(bgl.common.spinner.getSpinnerBody('Processing your refund!',
            'Please do not hit the back button or refresh the page'));

        const urlPrefix = componentConfig.TenantConfiguration.ApplicationPath !== null ?
            componentConfig.TenantConfiguration.ApplicationPath :
            '/';

        $.ajax({
            url: urlPrefix + 'TakePaymentComponent/CommitRefund',
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (result.isSuccess === false) {
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                    return;
                }
                bgl.common.utilities.redirectToUrl(result.RedirectUrl);
            },
        });
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.policycreationpending = (function() {
    let componentConfig;

    function initComponent(componentConfiguration) {
        componentConfig = componentConfiguration;
        getPolicyNumber();
        callAuthenticationSignOut();
    }

    function getPolicyNumber() {
        const policyNumber = sessionStorage.getItem('PaymentProcessedPolicyId');
        $('#policy-number').text(policyNumber);
    }

    function callAuthenticationSignOut() {
        const signOutData = {
            RequestVerificationToken: document.querySelector('input[name="__RequestVerificationToken"]').value,
            ApplicationPath: componentConfig.TenantConfiguration.ApplicationPath,
        };
        bgl.common.pubsub.emit('CallAuthenticationSignOutInTakePayment', signOutData);
    }

    return {
        init: initComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.policycreationpending;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.policychangedate = (function() {
    let configuration;

    function init(componentConfiguration) {
        configuration = componentConfiguration;

        $('#' + configuration.Id + '_ChangePaymentDate').on('click', function(event) {
            event.preventDefault();

            const container = this.dataset.container;
            const url = this.dataset.actionUrl;

            bgl.common.loader.load(configuration,
                url,
                container,
                function() {
                    bgl.components.takepayment.policychangedate.initSlidePanel();
                });
        });

        const triggerKey = 'TakePayment__PolicyChangeDate__ClickChangePaymentDate';
        const trigger = sessionStorage.getItem(triggerKey);
        if (trigger === 'true') {
            sessionStorage.removeItem(triggerKey);
            $('#' + configuration.Id + '_ChangePaymentDate').click();
        }
    }

    function initSlidePanel() {
        const datePicker = document.body.querySelector('[data-date-picker]');
        const minDate = datePicker.dataset.earliestDate;
        const maxDate = datePicker.dataset.latestDate;
        const defaultDate = datePicker.dataset.selectedDate;

        $(datePicker).datepicker({
            selectOtherMonths: false,
            dateFormat: 'dd-mm-yy',
            minDate: minDate,
            maxDate: maxDate,
            defaultDate: defaultDate,
            showOtherMonths: false,
            onChangeMonthYear: function(year, month, inst) {
                setTimeout(function() {
                    $('.ui-datepicker-prev:not(.ui-state-disabled), .ui-datepicker-next:not(.ui-state-disabled)')
                        .attr('href', '#');
                    $('.ui-datepicker-calendar tbody a').first().focus();
                    $('.ui-datepicker-calendar tbody a').each(function() {
                        $(this).attr('aria-label', toOrdinalString(parseInt(this.text)) + ' ' + getMonth(month));
                    });
                });
            },
            onSelect: function(date, inst) {
                inst.inline = false;

                const nominatedDate = this.value;
                const nominatedDateField = document.getElementById('NominatedDate');
                nominatedDateField.value = nominatedDate;

                document.body.querySelector('[data-dispaly-selected-date]')
                    .textContent = nominatedDate.substr(0, 2);
                document.body.querySelector('[data-day-of-month-display]')
                    .textContent = toOrdinalString(parseInt(nominatedDate.substr(0, 2)));

                if (nominatedDateField.value !== document.getElementById('OriginalNominatedDate').value) {
                    document.getElementById('SameDateValidationError')
                        .classList.remove('error');
                    $('.ui-datepicker-calendar .ui-datepicker-current-day a').removeAttr('aria-describedby');
                    document.body.querySelector('[data-change-date-next]').disabled = false;
                }

                $('.ui-datepicker-calendar .ui-datepicker-current-day a').removeAttr('aria-current');
                $('.ui-datepicker-calendar .ui-datepicker-current-day')
                    .removeClass('ui-datepicker-current-day')
                    .children()
                    .removeClass('ui-state-active');
                $('.ui-datepicker-calendar tbody a').each(function() {
                    if ($(this).text() == inst.selectedDay) {
                        $(this).addClass('ui-state-active');
                        $(this).parent().addClass('ui-datepicker-current-day');
                        $(this).attr('aria-current', 'date');
                    }
                });
            },
        });

        $('.ui-datepicker-calendar tbody a').each(function() {
            $(this).attr('aria-label',
                toOrdinalString(parseInt(this.text)) + ' ' + getMonth(defaultDate.substring(3, 5)));
        });
        $('.ui-datepicker-calendar .ui-datepicker-current-day a').attr('aria-current', 'date');
        $('.ui-datepicker-prev:not(.ui-state-disabled), .ui-datepicker-next:not(.ui-state-disabled)').attr('href', '#');

        document.body.querySelector('[data-change-date-next]')
            .addEventListener('click', function() {
                const nominatedDate = document.getElementById('NominatedDate').value;
                const originalNominatedDate = document.getElementById('OriginalNominatedDate').value;
                if (nominatedDate === originalNominatedDate) {
                    this.disabled = true;
                    document.getElementById('SameDateValidationError')
                        .classList.add('error');
                    $('.ui-datepicker-calendar .ui-datepicker-current-day a')
                        .attr('aria-describedby', 'SameDateValidationErrorMessage')
                        .first().focus();
                } else {
                    document.body
                        .querySelector('[data-change-date-calendar-section]')
                        .classList.add('hide');
                    document.body
                        .querySelector('[data-change-date-review-section]')
                        .classList.remove('hide');
                }
            });

        const backElements = document.body.querySelectorAll('[data-change-date-back]');

        for (let i = 0, backElement; backElement = backElements[i]; i++) {
            backElement.addEventListener('click',
                function() {
                    document.body
                        .querySelector('[data-change-date-review-section]')
                        .classList.add('hide');
                    document.body
                        .querySelector('[data-change-date-calendar-section]')
                        .classList.remove('hide');
                });
        }

        const form = document.getElementById(configuration.Id + '_PolicyChangeDateForm');
        const $form = $(form);
        bgl.common.datastore.init($form);
        bgl.common.validator.init($form);

        form.addEventListener('submit', function(event) {
            event.preventDefault();
            if (bgl.common.datastore.isDataChanged($form)) {
                bgl.common.validator.submitForm($form, configuration);
            } else {
                bgl.common.datastore.removeSessionStorage($form);
                onSuccess();
            }
        });
    }
    function onSuccess(config, data) {
        if (data) {
            if (data.UpdatePaymentDateState === 2) {
                document.body
                    .querySelector('[data-invalid-date-review-section]')
                    .classList.remove('hide');
                return;
            }
        }
        document.body
            .querySelector('[data-change-date-review-section]')
            .classList.add('hide');
        document.body
            .querySelector('[data-change-date-done-section]')
            .classList.remove('hide');

        const dismissElements = document.body.querySelectorAll('[data-dismiss="slide-panel"]');

        for (let i = 0, dismissElement; dismissElement = dismissElements[i]; i++) {
            dismissElement.addEventListener('click', refreshPage);
        }
    }

    function refreshPage() {
        window.location.reload();
    }

    function toOrdinalString(n) {
        return n + (['st', 'nd', 'rd'][((n + 90) % 100 - 10) % 10 - 1] || 'th');
    }

    function getMonth(intMonth) {
        return [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December',
        ][parseInt(intMonth) - 1];
    }

    return {
        init: init,
        initSlidePanel: initSlidePanel,
        onSuccess: onSuccess,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.policychangedate;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.paymenttransactions = (function() {
    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent();
            });
    }

    function initComponent(componentConfiguration) {
        $('[data-content=\'tab-button\']').each(function() {
            $(this).click(
                function() {
                    if ($(this.parentNode).hasClass('active')) {
                        return;
                    }

                    $('[data-content=\'tab-button\']').each(function() {
                        this.parentNode.classList.toggle('active');
                        $(this.parentNode).hasClass('active') ?
                            $(this).attr('aria-selected', 'true') :
                            $(this).attr('aria-selected', 'false');
                    });
                    $('[data-content=\'tab-payment-activity\']').each(function() {
                        this.classList.toggle('active');
                    });
                },
            );
        });

        $('[data-action=\'toggle-transactions\']').click(
            function(e) {
                $('[data-content=\'all-transactions\']').each(function() {
                    this.classList.toggle('hide');
                });
                e.target.innerHTML === 'View all transactions' ?
                    e.target.innerHTML = 'Hide transactions' :
                    e.target.innerHTML = 'View all transactions';
            });
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.paymenttransactions;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.paymentsummarywithpurchaseinformation = (function() {
    let configuration;
    let paymentType;
    let switchForm;

    function initComponent(componentConfiguration) {
        switchForm = $('#PaymentSummaryPaymentSwitchForm');
        configuration = componentConfiguration;
        const monthlyAnnualRadioButtons = $('input[type=radio].payment-option__radio');

        preventFormSubmission(switchForm);
        setPaymentTypeWhenPaymentTypeChanges(monthlyAnnualRadioButtons);
        postPaymentTypeWhenPaymentTypeChanges(monthlyAnnualRadioButtons);
        changeToAnnualWhenAnnualButtonClicked();
        changeToMonthlyWhenMonthlyButtonClicked();

        setupPaymentSummaryForm(configuration);
    }

    function setupPaymentSummaryForm(configuration) {
        bgl.common.validator.enableMaxLength();
        bgl.common.validator.init($('#PaymentSummaryForm'), {
            onfocusout: function(element) {
                $(element).valid();
            },
            hasSubmit: false,
        });
        bgl.components.takepayment.documentloader.init(configuration);
        $('#PaymentSummaryForm').submit(
            function(e) {
                e.preventDefault();

                if (!$(this).valid()) {
                    return;
                }

                $.ajax({
                    url: $(this).attr('action'),
                    type: $(this).attr('method'),
                    data: $(this).serialize(),
                    success: function(data) {
                        if (data.isSuccess) {
                            window.location = data.redirectUrl;
                        } else {
                            window.location = data.errorRedirectUrl;
                        }
                    },
                });
            });
    }

    function preventFormSubmission(form) {
        form.on('submit', function(event) {
            event.preventDefault();
        });
    }

    function changeToAnnualWhenAnnualButtonClicked() {
        $('#annual-price-label').on('click',
            function() {
                $('#monthly-price-label').removeClass('payment-switch__label--selected');
                $('#annual-price').click();
                $('#annual-price-label').addClass('payment-switch__label--selected');
            });
    }

    function changeToMonthlyWhenMonthlyButtonClicked() {
        $('#monthly-price-label').on('click',
            function() {
                $('#annual-price-label').removeClass('payment-switch__label--selected');
                $('#monthly-price').click();
                $('#monthly-price-label').addClass('payment-switch__label--selected');
            });
    }

    function setPaymentTypeWhenPaymentTypeChanges(radioButtons) {
        radioButtons.on('change', function() {
            setPaymentOption($(this));
        });
    }

    function setPaymentOption(selected) {
        paymentType = selected.data('paySchedule');
    }

    function postPaymentTypeWhenPaymentTypeChanges(radioButtons) {
        radioButtons.on('change', function() {
            bgl.common.validator.submitForm(switchForm, configuration);
        });
    }

    function onSuccess() {
        const isMonthly = paymentType === 'monthly';
        bgl.common.pubsub.emit('switchPaymentType', isMonthly);
        switchCostBreakdownContent(isMonthly);
        switchPolicyFeaturesContent(isMonthly);
        showHoustonNotification();
    }

    function switchCostBreakdownContent(isMonthly) {
        if (isMonthly) {
            $('.cost-breakdown__annual').addClass('hide');
            $('.cost-breakdown__monthly').removeClass('hide');
            $('#IsMonthlyPayment').val('true');
            // bgl.common.pubsub.emit("showNotification", $("#monthly-notification-message").val());
        } else {
            $('.cost-breakdown__monthly').addClass('hide');
            $('.cost-breakdown__annual').removeClass('hide');
            $('#IsMonthlyPayment').val('false');
            // bgl.common.pubsub.emit("showNotification", $("#annual-notification-message").val());
        }
    }

    function switchPolicyFeaturesContent(isMonthly) {
        if (isMonthly) {
            $('.payment-policy-features-annual').addClass('hide');
            $('.payment-policy-features-monthly').removeClass('hide');
        } else {
            $('.payment-policy-features-monthly').addClass('hide');
            $('.payment-policy-features-annual').removeClass('hide');
        }
    }

    function showHoustonNotification() {
        const notification = $('#' + paymentType + '-paymentSummary-notification-message').val();

        bgl.common.pubsub.emit('showNotification', notification);
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.paymentsummarywithpurchaseinformation;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.paymentsummarycondensed = (() => {
    let componentConfig;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent();
            });
    }

    function initComponent(componentConfiguration) {
        const hasEdittedFieldsOnAdditionalDetails = 'HasEdittedFieldsOnAdditionalDetails';
        bgl.common.validator.enableMaxLength();
        componentConfig = componentConfiguration;
        if (sessionStorage.getItem(hasEdittedFieldsOnAdditionalDetails) === 'true') {
            showHoustonNotification();
            sessionStorage.removeItem(hasEdittedFieldsOnAdditionalDetails);
        }
        bgl.components.takepayment.documentloader.init(componentConfig);
        if (document.getElementById('IsMonthlyPayment').value === 'True') {
            bgl.components.takepayment.monthlyinstalment.init(componentConfig);
            addMicroCopy();
        } else {
            bgl.components.takepayment.annual.init(componentConfig);
            addMicroCopy();
        }

        document.getElementsByClassName('payment-switch-link')[0].addEventListener('click',
            function() {
                submitForm();
            });

        const trustpilotWidget = document.getElementById('trustpilot-widget');
        if (trustpilotWidget != null) {
            try {
                window.Trustpilot.loadFromElement(trustpilotWidget);
            } catch {
                onError(null, 'Failed to load trustpilot', 'Fail to load from element', null);
            }
        }
    }

    async function submitForm() {
        const paymentSwitchLinkId = document.getElementsByClassName('payment-switch-link')[0]
            .getAttribute('id');
        const data = {
            __RequestVerificationToken: document.querySelector('input[name="__RequestVerificationToken"]').value,
            paymentSwitchId: document.getElementsByClassName('payment-switch-link')[0]
                .getAttribute('data-payment-switch-id'),
        };
        const dataToPost = new URLSearchParams(data).toString();
        return bgl.common.fetch.formPost(componentConfig.TenantConfiguration.ApplicationPath +
            'TakePaymentComponent/PaymentSwitch', {
            body: dataToPost,
        }).then(async (response) => {
            const responseBody = await response.json();
            if (!response.ok || responseBody.responseCode > 299) {
                onError(responseBody, responseBody, response.statusText, dataToPost);
            } else {
                const result = responseBody;
                bgl.common.pubsub.emit('switchPaymentType',
                    paymentSwitchLinkId === 'monthly-switch-link');
                if (paymentSwitchLinkId === 'monthly-switch-link') {
                    bgl.common.pubsub.emit('showNotification',
                        document.getElementById('monthly-notification-message').value);
                    window.location.reload(true);
                } else if (paymentSwitchLinkId === 'annual-switch-link') {
                    bgl.common.pubsub.emit('showNotification',
                        document.getElementById('annual-notification-message').value);
                    window.location.reload(true);
                }
                return result;
            }
        }).catch((error) =>
            onError(null, error, error.statusText, dataToPost),
        );
    }

    function onError(responseBody, responseError, responseStatusText, dataPosted) {
        if (window.appInsights) {
            bgl.common.telemetry.logEvent(
                'PaymentSummaryCondensed bgl.components.takePayment.responseBody',
                {
                    status: responseStatusText,
                    errorThrown: responseError,
                    dataPosted: dataPosted,
                    responseData: responseBody,
                },
            );
        }
    }

    function showHoustonNotification() {
        const isMonthlyPayment = document.getElementById('IsMonthlyPayment').value;
        if (isMonthlyPayment === 'True') {
            bgl.common.pubsub.emit(
                'showNotification',
                `OK ##FIRSTNAME##, your new price is £##PRICE## a month with a deposit of £##DEPOSIT##. 
                The underwriter for your policy is ##UNDERWRITER##.`,
            );
        } else {
            bgl.common.pubsub.emit(
                'showNotification',
                'OK ##FIRSTNAME##, your new price is £##PRICE##. The underwriter for your policy is ##UNDERWRITER##.',
            );
        }
    }

    function addMicroCopy() {
        document.getElementsByClassName('basket__content')[0].classList.add('basket__content--micro-copy');
        document.getElementsByClassName('button-container')[0].classList.add('button-container--micro-copy');
        document.getElementsByClassName('houston-container')[0].classList.add('houston-container--micro-copy');
    }

    return {
        init: initComponent,
        load: loadComponent,
        onError: onError,
        submitForm,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.paymentsummarycondensed;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.paymentsummary = (function() {
    let componentConfig;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent();
            });
    }

    function initComponent(componentConfiguration) {
        const HasEdittedFieldsOnAdditionalDetails = 'HasEdittedFieldsOnAdditionalDetails';

        bgl.common.validator.enableMaxLength();

        componentConfig = componentConfiguration;

        bgl.common.validator.init($('#PaymentSummaryForm'), {
            onfocusout: function(element) {
                $(element).valid();
                if ($('.form-row__validation-text').hasClass('field-validation-error')) {
                    $('#Email').focus();
                }
            },
            hasSubmit: false,
        });

        if (sessionStorage.getItem(HasEdittedFieldsOnAdditionalDetails) === 'true') {
            showHoustonNotification();
            sessionStorage.removeItem(HasEdittedFieldsOnAdditionalDetails);
        }

        bgl.components.takepayment.documentloader.init(componentConfig);

        $('#PaymentSummaryForm').submit(
            function(e) {
                e.preventDefault();

                if (!$(this).valid()) {
                    return;
                }
                if (typeof bgl.common.pubsub !== 'undefined') {
                    bgl.common.pubsub.emit('fakeFormSubmit', $(this).attr('id') || $(this).attr('action') || 'unknown');
                }

                $.ajax({
                    url: $(this).attr('action'),
                    type: $(this).attr('method'),
                    data: $(this).serialize(),
                    success: function(data) {
                        if (data.isSuccess) {
                            bgl.common.utilities.redirectToUrl(data.redirectUrl);
                        } else {
                            bgl.common.utilities.redirectToUrl(data.errorRedirectUrl);
                        }
                    },
                });
            });

        $('.payment-switch-link').on('click',
            function() {
                const paymentSwitchLinkId = $(this).attr('id');
                bgl.common.focusHolder.setFocusedElement($(this).data('focusid'));
                const dataToPost = {
                    __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val(),
                    paymentSwitchId: $(this).attr('data-payment-switch-id'),
                };

                $.ajax({
                    url: componentConfig.TenantConfiguration.ApplicationPath + 'TakePaymentComponent/PaymentSwitch',
                    type: 'POST',
                    cache: false,
                    dataType: 'json',
                    data: dataToPost,
                    success: function(result) {
                        if (result.isSuccess === true) {
                            bgl.common.pubsub.emit('switchPaymentType', paymentSwitchLinkId === 'monthly-switch-link');
                            if (paymentSwitchLinkId === 'monthly-switch-link') {
                                $('#monthly-section').removeClass('hide');
                                $('#annual-section').addClass('hide');
                                $('#IsMonthlyPayment').val('true');
                                bgl.common.pubsub.emit('showNotification', $('#monthly-notification-message').val());
                            } else if (paymentSwitchLinkId === 'annual-switch-link') {
                                $('#monthly-section').addClass('hide');
                                $('#annual-section').removeClass('hide');
                                $('#IsMonthlyPayment').val('false');
                                bgl.common.pubsub.emit('showNotification', $('#annual-notification-message').val());
                            }
                        } else {
                            window.location.href = result.errorRedirectUrl;
                            return;
                        }
                    },
                });
            });
    }

    function showHoustonNotification() {
        const isMonthlyPayment = document.getElementById('IsMonthlyPayment').value;
        if (isMonthlyPayment === 'True') {
            bgl.common.pubsub.emit(
                'showNotification',
                `OK ##FIRSTNAME##, your new price is £##PRICE## a month with a deposit of £##DEPOSIT##. 
                The underwriter for your policy is ##UNDERWRITER##.`,
            );
        } else {
            bgl.common.pubsub.emit(
                'showNotification',
                'OK ##FIRSTNAME##, your new price is £##PRICE##. The underwriter for your policy is ##UNDERWRITER##.',
            );
        }
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.paymentsummary;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.paymentsuccessful = (function() {
    let componentConfig; let requestVerificationToken;

    function initComponent(componentConfiguration) {
        componentConfig = componentConfiguration;
        requestVerificationToken = document.querySelector('input[name="__RequestVerificationToken"]').value;
        const policyId = sessionStorage.getItem('PaymentProcessedPolicyId');
        const authorization = sessionStorage.getItem('Authorization');
        const redirectUrl = sessionStorage.getItem('PaymentProcessedRedirectUrl');

        $('body').html(bgl.common.spinner.getSpinnerBody('Creating your policy',
            'Please do not hit the back button or refresh the page'));

        emitGTMUpdate(policyId);
        waitForPolicyToBeCreated(policyId, redirectUrl, authorization);
    }

    function emitGTMUpdate(policyId) {
        bgl.common.pubsub.emit('UpdateGTMPolicyId', policyId);
    }

    function waitForPolicyToBeCreated(policyId, redirectUrl, authorization) {
        const interval = 500;
        const timeoutDuration = 30000;
        const pollUrl = 'TakePaymentComponent/IsPolicyCreated';
        const tickCount = new Date().getTime();
        const timeout = tickCount + timeoutDuration;
        const applicationPath = componentConfig.TenantConfiguration.ApplicationPath;
        poll(timeout, interval, pollUrl, applicationPath, policyId, redirectUrl, authorization);
    }

    function poll(timeout, interval, pollUrl, applicationPath, policyId, redirectUrl, authorization) {
        const dataToPost = {
            __RequestVerificationToken: requestVerificationToken,
            PolicyId: policyId,
            BrandCode: componentConfig.BrandCode,
            Authorization: authorization,
        };
        const manageSessionData = {
            RequestVerificationToken: requestVerificationToken,
            BrandCode: componentConfig.BrandCode,
            PolicyId: policyId,
            ApplicationPath: applicationPath,
            Authorization: authorization,
            PolicyCreated: true,
        };

        $.ajax({
            url: applicationPath + pollUrl,
            type: 'Post',
            cache: false,
            data: dataToPost,
            dataType: 'json',
            success: (response) => {
                if (response.Status === 'Processing') {
                    if (timeout >= new Date().getTime()) {
                        setTimeout(() => {
                            poll(timeout, interval, pollUrl, applicationPath, policyId, redirectUrl, authorization);
                        },
                        interval);
                    } else {
                        manageSessionData.PolicyCreated = false;
                        emitManageSessionStorageOnPaymentSuccessful(
                            manageSessionData,
                            componentConfig.PolicyCreationPendingUrl,
                        );
                    }
                } else if (response.Status === 'Created') {
                    emitManageSessionStorageOnPaymentSuccessful(manageSessionData, redirectUrl);
                } else {
                    emitManageSessionStorageOnPaymentSuccessful(manageSessionData, response.ErrorRedirectUrl);
                }
            },
        });
    }

    function emitManageSessionStorageOnPaymentSuccessful(manageSessionData, redirectUrl) {
        manageSessionData.RedirectUrl = redirectUrl;
        bgl.common.pubsub.emit('ManageSessionStorageOnPaymentSuccessful', manageSessionData);
    }

    return {
        init: initComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.paymentsuccessful;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.paymentmethods = (function() {
    let configuration;
    let requestVerificationToken;
    let newPaymentMethodType;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(componentConfiguration, componentUrl, containerElementId, function() {
            initComponent(componentConfiguration);
        });
    }

    function initComponent(componentConfiguration) {
        requestVerificationToken = $('input[name="__RequestVerificationToken"]').val();
        configuration = componentConfiguration;
        onRadioButtonChange();
        onUpdatingPaymentMethod();
        onClickAddNewPaymentMethod();
    }

    function onUpdatingPaymentMethod() {
        $('#updatePaymentMethod').on('click', function() {
            const linkId = this.id;
            const linkButton = $('#' + linkId);
            const actionUrl = linkButton.data('action-url');

            commitAndUpdatePaymentMethod(actionUrl);
        });
    }

    function commitAndUpdatePaymentMethod(actionUrl) {
        const dataToPost = {
            __RequestVerificationToken: requestVerificationToken,
            nominatedAccountId: $('[data-type=payment-methods]:checked').val(),
        };
        newPaymentMethodType = $('[data-type=payment-methods]:checked').attr('data-payment-method-type');

        $.ajax({
            url: actionUrl,
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (!result.isSuccess) {
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                } else {
                    logPaymentMethodChange();
                    if (result.viewOptions === 'PaymentStatus') {
                        window.location.href = configuration.TenantConfiguration.ApplicationPath +
                            configuration.PaymentStatusUrl;
                    } else if (result.viewOptions === 'PaymentMethodAllDone') {
                        window.location.href = configuration.TenantConfiguration.ApplicationPath +
                            configuration.PaymentMethodAllDoneUrl;
                    }
                }
            },
        });
    }

    function logPaymentMethodChange() {
        sessionStorage.setItem('PaymentUpdated', newPaymentMethodType === 'Bank Account' ? 'Direct Debit': 'Card');
    }

    function onClickAddNewPaymentMethod() {
        $('#addNewPaymentMethod').on('click',
            function() {
                $(document.body).removeClass('slide-panel-open');
            });
    }

    function onRadioButtonChange() {
        $('[data-type=payment-methods]').each(function(index, value) {
            $(value).off('change').on('change',
                function() {
                    if ($('#updatePaymentMethod').hasClass('hide')) {
                        $('#updatePaymentMethod').removeClass('hide');
                    }
                });
        });
    };

    function onError() {
    }

    return {
        init: initComponent,
        load: loadComponent,
        onError: onError,
        newPaymentMethodType: newPaymentMethodType,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.paymentmethods;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.paymentemail = (function() {
    let configuration;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        const form = $('#PaymentEmailForm');

        bgl.common.validator.init(form);
        bgl.common.datastore.init(form);

        form.off('submit').on('submit',
            function(e) {
                e.preventDefault();

                if (!bgl.common.validator.isFormValid(form)) {
                    return;
                }

                if (!bgl.common.datastore.isDataChanged(form)) {
                    onSuccess(configuration);
                    return;
                }

                bgl.common.validator.submitForm(form, configuration);
            });
    }

    function onSuccess(componentConfiguration, data) {
        bgl.common.utilities.redirectToUrl(componentConfiguration.NextStepUrl);
    }

    function onError(componentConfiguration) {
        initComponent(componentConfiguration);
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.paymentsummary;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.paymentdetailsdisplay = (function() {
    const slidePanelContainer = 'SlidePanelContent';
    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
            });
    }

    function initComponent(componentConfiguration) {
        const configuration = componentConfiguration;

        $('#ChangePaymentMethod').on('click', function() {
            const linkId = this.id;
            const linkButton = $('#' + linkId);
            const actionUrl = linkButton.data('action-url');
            const containerSelector = slidePanelContainer;
            bgl.common.loader.load(configuration,
                actionUrl,
                containerSelector,
                function() {
                    bgl.components.takepayment.paymentmethods.init(componentConfiguration);
                });
        });
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.paymentdetailsdisplay;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.paymentdeclined = (function() {
    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent();
            });
    }

    function initComponent() {
        clearSession();
    }

    function clearSession() {
        clearAnnualSessionData();
        clearMonthlyDepositSessionData();
        clearMonthlyInstalmentSessionData();
        clearOneOffPaymentSessionData();
        amendSinglePagePaymentSessionData();
    }

    function clearAnnualSessionData() {
        sessionStorage.removeItem('AnnualSelectedPersonIdText');
        sessionStorage.removeItem('AnnualCardCaptureUri');
        sessionStorage.removeItem('AnnualSecureSessionId');
        sessionStorage.removeItem('AnnualSelectedPersonIdVal');
    }

    function clearMonthlyDepositSessionData() {
        sessionStorage.removeItem('MonthlyDepositSelectedPersonIdText');
        sessionStorage.removeItem('MonthlyDepositCardCaptureUri');
        sessionStorage.removeItem('MonthlyDepositSecureSessionId');
        sessionStorage.removeItem('MonthlyDepositSelectedPersonIdVal');
    }

    function clearMonthlyInstalmentSessionData() {
        sessionStorage.removeItem('MonthlyInstalmentCardSelectedPersonIdText');
        sessionStorage.removeItem('MonthlyInstalmentCardCaptureUri');
        sessionStorage.removeItem('MonthlyInstalmentSecureSessionId');
        sessionStorage.removeItem('MonthlyInstalmentCardSelectedPersonIdVal');
    }

    function clearOneOffPaymentSessionData() {
        sessionStorage.removeItem('OneOffPaymentSelectedPersonIdText');
        sessionStorage.removeItem('OneOffPaymentCardCaptureUri');
        sessionStorage.removeItem('OneOffPaymentSecureSessionId');
        sessionStorage.removeItem('OneOffPaymentSelectedPersonIdVal');
    }

    function amendSinglePagePaymentSessionData() {
        const isMonthlyPayment = sessionStorage.getItem('IsMonthlyPayment');

        if (isMonthlyPayment) {
            sessionStorage.removeItem('TakePaymentSinglePagePaymentCompletedExpandingPanelStep');
        }

        if (sessionStorage.getItem('CardDetailsAlreadyEnteredMonthly')) {
            sessionStorage.removeItem('CardDetailsAlreadyEnteredMonthly');
        }

        if (sessionStorage.getItem('CardDetailsAlreadyEnteredAnnual')) {
            sessionStorage.removeItem('CardDetailsAlreadyEnteredAnnual');
        }
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.paymentdeclined;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.oneoffpaymentsummary = (function() {
    let componentConfig;
    let requestVerificationToken;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        componentConfiguration.CardSessionData = getSecureSessionData();
        componentConfig = componentConfiguration;
        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
            });
    }

    function initComponent(componentConfiguration) {
        bgl.components.takepayment.cancellations.init(componentConfiguration);

        subscribeToEvents();
    }

    function subscribeToEvents() {
        const payNowButton = $('#One-Off-Pay-Now-Button');
        const cancellationConfirmationCheckbox = $('#cancellation-confirmation-checkbox');

        payNowButton.on('click',
            function() {
                commitOneOffPayment();
            });

        cancellationConfirmationCheckbox.on('click',
            function() {
                const isChecked = cancellationConfirmationCheckbox.is(':checked');

                if (isChecked) {
                    payNowButton.removeAttr('disabled');
                } else {
                    payNowButton.attr('disabled', 'disabled');
                }
            });
    }

    function getSecureSessionData() {
        return {
            'Name': sessionStorage.getItem('OneOffPaymentSelectedPersonIdText'),
            'CardCaptureUri': sessionStorage.getItem('OneOffPaymentCardCaptureUri'),
            'SecureSessionId': sessionStorage.getItem('OneOffPaymentSecureSessionId'),
        };
    }

    function commitOneOffPayment() {
        requestVerificationToken = $('input[name="__RequestVerificationToken"]').val();

        const dataToPost = {
            __RequestVerificationToken: requestVerificationToken,
            commitData: {
                ComponentConfiguration: componentConfig,
                CommitCardData: {
                    SecureSessionId: sessionStorage.getItem('OneOffPaymentSecureSessionId'),
                    SelectedPersonIdVal: sessionStorage.getItem('OneOffPaymentSelectedPersonIdVal'),
                    SelectedPersonIdText: sessionStorage.getItem('OneOffPaymentSelectedPersonIdText'),
                },
            },
        };

        $('body').html(bgl.common.spinner.getSpinnerBody('Processing your payment!',
            'Please do not hit the back button or refresh the page'));

        const urlPrefix = componentConfig.TenantConfiguration.ApplicationPath !== null ?
            componentConfig.TenantConfiguration.ApplicationPath :
            '/';

        $.ajax({
            url: urlPrefix + 'TakePaymentComponent/CommitOneOffPayment',
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (result.isSuccess === false) {
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                    return;
                }
                bgl.common.utilities.redirectToUrl(result.RedirectUrl);
            },
        });
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.oneoffpaymentalldone = (function() {
    function initComponent() {
        clearOneOffPaymentSessionData();
        updateSessionDataForCancellationTracking();
        bgl.common.pubsub.emit('PaymentComplete');
        bgl.components.takepayment.cancellations.init();
    }

    function clearOneOffPaymentSessionData() {
        sessionStorage.removeItem('OneOffPaymentSelectedPersonIdText');
        sessionStorage.removeItem('OneOffPaymentCardCaptureUri');
        sessionStorage.removeItem('OneOffPaymentSecureSessionId');
        sessionStorage.removeItem('OneOffPaymentSelectedPersonIdVal');
        sessionStorage.removeItem('OneOffPaymentSelectedPersonId');
    }

    function updateSessionDataForCancellationTracking() {
        sessionStorage.setItem('TagManager.CancellationReason', sessionStorage.getItem('Cancellation.Reason'));
        sessionStorage.removeItem('Cancellation.Reason');
        sessionStorage.setItem('TagManager.CancellationDate', sessionStorage.getItem('Cancellation.Date'));
        sessionStorage.removeItem('Cancellation.Date');
    }

    return {
        init: initComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.oneoffpayment = (function() {
    let componentConfiguration;
    let hideElementsWhen3DSecureIsDisplayedTimeout;

    function loadComponent(componentConfiguration, componentUrl, containerElementId, callback) {
        componentConfiguration.CardSessionData = getSecureSessionData();

        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);

                if (typeof callback === 'function') {
                    callback();
                }
            });
    }

    function initComponent(configuration) {
        componentConfiguration = configuration;

        bgl.common.datastore.setupReadAndWrite();

        loadIframe();

        setVisibilityOfCardholderNameOther();

        bgl.components.takepayment.cancellations.init(componentConfiguration);

        bgl.common.validator.enableMaxLength();

        $('#OneOffPaymentForm').off('submit').on('submit',
            function(e) {
                e.preventDefault();
            });

        bgl.common.validator.init($('#OneOffPaymentForm'),
            {
                onkeyup: function(element) {
                    validateElementAndToggleIframe(element);
                },
                hasSubmit: false,
            });

        $('#Card-Capture-Iframe').on('load', function() {
            hideElementsWhen3DSecureIsDisplayed();
        });

        $('#PersonListData_SelectedPersonId').change(
            function() {
                if ($('#PersonListData_SelectedPersonId').find(':selected').text() === 'Other') {
                    $('#CardholderNameRow').removeClass('hide');
                    $('#Card-Capture-Iframe').addClass('hide');
                    sessionStorage.setItem('OneOffPaymentSelectedPersonIdText', '');
                    $('#CardholderName').val('');
                    $('#CardholderName').focus();
                } else {
                    $('#CardholderNameRow').addClass('hide');
                    $('#Card-Capture-Iframe').removeClass('hide');
                }

                initCardCapture();
            });

        if ($('#PersonListData_SelectedPersonId').find(':selected').text() === 'Other') {
            validateElementAndToggleIframe($('#OneOffPaymentForm'));
        }
    }

    function initCardCapture() {
        sessionStorage.removeItem('OneOffPaymentCardCaptureUri');
        sessionStorage.removeItem('OneOffPaymentSecureSessionId');
        sessionStorage.removeItem('OneOffPaymentThreeDSecureUri');

        if (hideElementsWhen3DSecureIsDisplayedTimeout) {
            clearTimeout(hideElementsWhen3DSecureIsDisplayedTimeout);
        }

        bgl.components.takepayment.cardcaptureiframe.clearIframe();

        componentConfiguration.CardSessionData = {'SelectedPersonId': $('#PersonListData_SelectedPersonId').val()};

        const dataToPost = {
            __RequestVerificationToken: $('input[name=\'__RequestVerificationToken\']').val(),
            configuration: componentConfiguration,
        };

        $.ajax({
            url: componentConfiguration.TenantConfiguration.ApplicationPath +
                'TakePaymentComponent/InitialiseOneOffPaymentCardCapture',
            type: 'POST',
            data: dataToPost,
            success: function(data) {
                sessionStorage.setItem('OneOffPaymentCardCaptureUri', data.cardCaptureUri);
                sessionStorage.setItem('OneOffPaymentSecureSessionId', data.secureSessionId);
                sessionStorage.setItem('OneOffPaymentThreeDSecureUri', data.threeDSecureUri);

                loadIframe();
            },
        });
    }

    function loadIframe() {
        const cardSessionData = getSecureSessionData();
        bgl.components.takepayment.cardcaptureiframe.loadIframe(
            'Card-Capture-Iframe',
            cardSessionData.CardCaptureUri,
            cardSessionData.SecureSessionId,
            cardSessionData.ThreeDSecureUri);
    }

    function validateElementAndToggleIframe(element) {
        const valid = $(element).valid();
        if (valid === true) {
            $('#Card-Capture-Iframe').removeClass('hide');
        } else {
            $('#Card-Capture-Iframe').addClass('hide');
        }
    }

    function getSecureSessionData() {
        return {
            'Name': sessionStorage.getItem('OneOffPaymentSelectedPersonIdText'),
            'CardCaptureUri': sessionStorage.getItem('OneOffPaymentCardCaptureUri'),
            'SecureSessionId': sessionStorage.getItem('OneOffPaymentSecureSessionId'),
            'SelectedPersonId': sessionStorage.getItem('OneOffPaymentSelectedPersonIdVal'),
            'ThreeDSecureUri': sessionStorage.getItem('OneOffPaymentThreeDSecureUri'),
        };
    }

    function setVisibilityOfCardholderNameOther() {
        if ($('#PersonListData_SelectedPersonId').find(':selected').text() === 'Other') {
            $('#CardholderNameRow').removeClass('hide');
            $('#CardholderName').focus();
        }
    }

    function hideElementsWhen3DSecureIsDisplayed() {
        if ($('#Card-Capture-Iframe').contents().find('#continue').length === 0) {
            $('#OneOffPaymentCardholderNameFormRow').hide();
            $('#CardholderNameRow').hide();
            scrollToCardPayment();
            return;
        }
        hideElementsWhen3DSecureIsDisplayedTimeout = setTimeout(function() {
            hideElementsWhen3DSecureIsDisplayed();
        }, 1000);
    }

    function scrollToCardPayment() {
        const requiredField = $('.card-payment');
        $('html,body').animate({scrollTop: requiredField.offset().top}, 0);
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.mtatakepayment = (function() {
    let configuration;
    let takePaymentForm;
    let additionalDetailsForm;
    let monthDropdown;
    let yearDropdown;
    let fullYearMonthOptions;
    let currentYearMonthOptions;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;

        takePaymentForm = document.querySelector(
            `[data-component-id='${configuration.Id}'] form#${configuration.Id}_mta-take-payment`,
        );
        additionalDetailsForm = document.querySelector(
            `[data-component-id='${configuration.Id}'] form#${configuration.Id}_mta-additional-details`,
        );

        if (takePaymentForm != null) {
            bgl.common.validator.init(takePaymentForm);
        } else {
            bgl.common.validator.init(additionalDetailsForm);

            const currentMonth = document.getElementById('CurrentMonth').value - 0;

            monthDropdown = document.getElementById('Purchased-Month');
            yearDropdown = document.getElementById('Purchased-Year');

            if (monthDropdown) {
                fullYearMonthOptions = Array.from(monthDropdown.options);
                currentYearMonthOptions = fullYearMonthOptions.slice(0, currentMonth + 1);
            }
        }

        subscribeToEvents();
    }

    function subscribeToEvents() {
        if (takePaymentForm != null) {
            takePaymentForm.addEventListener('submit',
                (event) => {
                    event.preventDefault();
                    agreementCheckboxTicked();
                });
        } else {
            const regField = document.getElementById('registration-number');

            additionalDetailsForm.addEventListener('submit',
                (event) => {
                    event.preventDefault();

                    if (regField != null) {
                        regField.value = regField.value.replace(/\s+/gi, '');
                    }

                    if (bgl.common.validator.isFormValid(event.target)) {
                        bgl.common.validator.submitForm(event.target, configuration);
                    }
                });

            if (yearDropdown) {
                const monthDropdownHtml = monthDropdown.innerHTML;
                yearDropdown.addEventListener('change', () => {
                    const months = monthDropdown;
                    const selectedMonthValue = months.value;
                    const currentYear = yearDropdown.options[1].value;

                    switch (yearDropdown.value) {
                    case currentYear:
                        months.innerHTML = '';
                        currentYearMonthOptions.forEach((option) => {
                            months.innerHTML += option.outerHTML;
                        });
                        break;
                    default:
                        months.innerHTML = monthDropdownHtml;
                        break;
                    };

                    months.value = selectedMonthValue;

                    if (months.value == '') {
                        monthDropdown[0]['selected'] = true;
                    }

                    if (regField != null) {
                        document.getElementById('registration-number').addEventListener('input', (event) => {
                            const start = event.target.selectionStart;
                            const end = event.target.selectionEnd;

                            event.target.value = event.target.value.toUpperCase();

                            event.target.setSelectionRange(start, end);
                        });
                    }
                });
            }
        }
    }

    function onSuccess(configuration, data) {
        if (data.redirectUrl) {
            bgl.common.utilities.redirectToUrl(data.redirectUrl);
        } else {
            bgl.common.utilities.redirectToUrl(configuration.PaymentAllDoneUrl);
        }
    }

    function onError(configuration) {
        bgl.common.utilities.redirectToUrl(configuration.PaymentDeclinedUrl);
    }

    function onAdditionalDetailsSuccess() {
        const options = {
            hideNotification: true,
        };
        bgl.common.pubsub.emit('PollBasket', options);
    }

    function onAdditionalDetailsError() {
        initComponent(configuration);
    }

    function agreementCheckboxTicked() {
        const agreementCheckbox = document.getElementById('agreement-checkbox');
        if (!agreementCheckbox['checked']) {
            document.getElementById('agreement-container').classList.add('error');
            agreementCheckbox.focus({preventScroll: true});
            agreementCheckbox.scrollIntoView({behavior: 'smooth', block: 'start'});
        } else {
            bgl.common.validator.submitForm(event.target, configuration);
        }
    };

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
        onAdditionalDetailsSuccess: onAdditionalDetailsSuccess,
        onAdditionalDetailsError: onAdditionalDetailsError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.mtaquote = (function() {
    function initComponent() {
        $('#toggle-payment-breakdown-table').on('click', function(event) {
            event.preventDefault();
            if ($('[data-payment-breakdown-table]').hasClass('hide')) {
                $('[data-payment-breakdown-table]').attr('class', 'flex');
                $(this).text('Hide new monthly payment plan');
            } else {
                $('[data-payment-breakdown-table]').attr('class', 'hide');
                $(this).text('View new monthly payment plan');
            }
        });
    }

    return {
        init: initComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.monthlyinstalmentsummary = (function() {
    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        componentConfiguration.CardSessionData = getSecureSessionData();
        componentConfiguration.CreditInformationUrl = sessionStorage.getItem('credit-information');
        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent();
            });
    }

    function initComponent() {
        bgl.common.datastore.setupReadAndWrite();

        $(`#importantInfo-payments-instalment-summary,
            #importantInfo-bottom,
            #intermediary-services-contract-summary-slider-link`).off('click').on('click', function(event) {
            event.preventDefault();
            const link = $(this);
            bgl.common.loader.load({}, link.data('action-url'), link.data('container'));
        });
    }

    function getSecureSessionData() {
        return {
            'Name': sessionStorage.getItem('MonthlyInstalmentCardSelectedPersonIdText'),
            'CardCaptureUri': sessionStorage.getItem('MonthlyInstalmentCardCaptureUri'),
            'SecureSessionId': sessionStorage.getItem('MonthlyInstalmentSecureSessionId'),
        };
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.monthlyinstalment = (function() {
    let componentConfig;
    function loadComponent(componentConfiguration, componentUrl, containerElementId, callback) {
        componentConfiguration.CardSessionData = getSecureSessionData();
        componentConfiguration.CreditInformationUrl = sessionStorage.getItem('credit-information');
        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
                if (typeof callback === 'function') {
                    callback();
                }
            });
    }

    function initComponent(componentConfiguration) {
        componentConfig = componentConfiguration;
        sortCodeAutoTab();
        initDirectDebit();
        populateBankAccountDetails();
        initCommon(componentConfiguration);

        $('#Card-Capture-Iframe').on('load', function() {
            hideElementsWhen3DSecureIsDisplayed();
        });

        $('#direct-debit-details').on('click', function() {
            waitForSlidePanelToLoad();
        });

        $(`#importantInfo-payments-instalments,
            #importantInfo-bottom, 
            #intermediary-services-contract-summary-slider-link, 
            #intermediary-services-contract-summary-slider-link-read-confirm`).off('click').on('click', (event) => {
            event.preventDefault();
            const link = $(event.currentTarget);
            bgl.common.loader.load({}, link.data('action-url'), link.data('container'));
        });
    }

    function waitForSlidePanelToLoad() {
        window.setTimeout(function() {
            if ($('#SlidePanel').hasClass('active')) {
                const directDebitDetails = $('#direct-debit-info').html();
                $('#SlidePanelContent').html(directDebitDetails);
            } else {
                waitForSlidePanelToLoad();
            }
        }, 100);
    }

    function initCommon(componentConfiguration) {
        const accessible = componentConfiguration.ViewOptions.MonthlyInstalment === 2;
        if (accessible) {
            setupAriaLabeltoDates();
            postInstalmentDate();
        }
        setupDatePicker();
        bgl.common.datastore.setupReadAndWrite();
        loadIframe();
        forceMonthlyPaymentMethodStoreAndSetPaymentDate();
    }

    function loadIframe() {
        const cardSessionData = getSecureSessionData();
        bgl.components.takepayment.cardcaptureiframe.loadIframe(
            'Card-Capture-Iframe',
            cardSessionData.CardCaptureUri,
            cardSessionData.SecureSessionId,
            cardSessionData.ThreeDSecureUri);
    }

    function initDirectDebit() {
        bgl.common.validator.enableMaxLength();
        bgl.common.validator.init($('#Direct-Debit-Form'),
            {
                onfocusout: function(element) {
                    checkSortcodeValidation(element);
                    checkAccountNumberValidation(element);
                },
                hasSubmit: false,
            });

        $('#Direct-Debit-Authorise-Row label').on('click',
            function() {
                $('#' + $(this).attr('for')).click().focusout();
            });

        $('#Direct-Debit-Continue-Button').on('click',
            function() {
                const formIsValid = $('#Direct-Debit-Form').valid();
                if (formIsValid) {
                    validateBankAccountAndSortCode(saveDataToSessionStorage);
                } else {
                    checkSortcodeValidation($('#SortCodePart1'));
                    getValidationMessages();
                    scrollToFirstFieldWithErrorAndFocus();
                }

                return formIsValid;
            });

        $('input[type=radio][name=monthly-payment]').on('change', function() {
            if (this.value == 'DirectDebit') {
                $('#Direct-Debit-Continue-Button').removeClass('hide');
            } else {
                $('#Direct-Debit-Continue-Button').addClass('hide');
            }
        });
    }

    function getValidationMessages() {
        if ($('.form-row').hasClass('error')) {
            const data = {
                form_section: getFormSectionName($(this)),
                error_details: [],
            };

            $('.error').find('.form-row__validation-text').each(function() {
                addError(data, $(this).attr('data-valmsg-for'), $(this).text().trim());
            });

            const sortcodeValiationElement = $('#sortcode-validation-text');
            if (sortcodeValiationElement.length == 1 && !sortcodeValiationElement.hasClass('hide')) {
                addError(
                    data,
                    $('#form-row-sortcode1 fieldset legend').text().trim(),
                    $('#sortcode-validation-text').text().trim(),
                );
            }

            const sortcodeApiValidationElement = $('#sortcode-api-validation-message');
            if (sortcodeApiValidationElement.length == 1 && !sortcodeApiValidationElement.hasClass('hide')) {
                addError(
                    data,
                    $('#form-row-sortcode1 fieldset legend').text().trim(),
                    $('#sortcode-api-validation-message').text().trim(),
                );
            }

            bgl.common.pubsub.emit('formValidationFailed', data);
        }
    }

    function addError(data, field, message) {
        const errorDetail = {
            error_field: field,
            error_message: message,
        };
        data.error_details.push(errorDetail);
    }

    function getFormSectionName() {
        const formRow = '.form-row__validation-text';
        if ($(formRow).parents().find('.step-form__section-title').text().length === 0) {
            return $(formRow).closest('form').find('h1').text();
        } else {
            return $(formRow).closest('form').find('.step-form__section-title').text();
        }
    }

    function scrollToFirstFieldWithErrorAndFocus() {
        const firstRequiredField = $('.error,.sort-code__input--error').first();
        $('html,body').animate({scrollTop: firstRequiredField.offset().top}, 'slow');

        if (firstRequiredField.length) {
            const invalidInputElem = firstRequiredField.find('input, select, textarea')
                .addBack('input, select, textarea')[0];
            if (invalidInputElem !== undefined) {
                invalidInputElem.focus();
            }
        }
    }

    function scrollToCardPayment() {
        const requiredField = $('.card-payment');
        $('html,body').animate({scrollTop: requiredField.offset().top}, 0);
    }

    function hideElementsWhen3DSecureIsDisplayed() {
        if ($('#Card-Capture-Iframe').contents().find('#continue').length === 0) {
            $('#Cardholder-Name-Form-Row').hide();
            $('#Monthly-Card-Payment-Date-Form-Row').hide();
            $('#Monthly-Payment-DD-Label').hide();
            $('#Monthly-Payment-Card-Label').hide();
            $('#Monthly-Payment-DD').hide();
            $('#Monthly-Payment-Card').hide();
            scrollToCardPayment();
            return;
        }

        const timeoutId = setTimeout(function() {
            hideElementsWhen3DSecureIsDisplayed();
        }, 1000);

        sessionStorage.setItem('3dSecureTimeoutId', timeoutId);
    }

    function checkAccountNumberValidation(element) {
        let isValid = false;

        if ($(element).hasClass('form-row__input account-number sort-code__input--error')) {
            $('#account-number-validation-message').addClass('hide');
        }
        if ($(element).hasClass('form-row__input account-number')) {
            isValid = $('#direct-debit-account-number').valid();
        }
        if (isValid) {
            removeAccountErrorStyle();
        }
    }

    function checkSortcodeValidation(element) {
        removeApiValidationErrorMessage(element);
        validateIndividualSortCodeInput(element);
        clearValidationErrorStylingWhenAllSortCodeInputsAreValid();
    }

    function removeApiValidationErrorMessage(element) {
        if ($(element).hasClass('form-row__input--sort-code') &&
        !$('#sortcode-api-validation-message').hasClass('hide')) {
            removeSortCodeErrorStyle();
        }
    }

    function validateIndividualSortCodeInput(element) {
        if ($(element).valid()) {
            removeIndividualSortCodeErrorStyle(element);
        } else {
            addIndividualSortCodeErrorStyle(element);
        }
        $('#form-row-sortcode1').removeClass('error');
    }

    function clearValidationErrorStylingWhenAllSortCodeInputsAreValid() {
        const allSortCodeInputsValid = checkAllSortCodeInputsAreValid();
        if (allSortCodeInputsValid) {
            $('#SortCodeLabel').removeClass('sort-code__label--error');
            $('#sortcode-validation-text').addClass('hide');
        }
    }

    function checkAllSortCodeInputsAreValid() {
        let allSortCodeInputsValid = true;

        $('.form-row__input--sort-code').each(function() {
            if ($(this).hasClass('sort-code__input--error')) {
                allSortCodeInputsValid = false;
            }
        });

        return allSortCodeInputsValid;
    }

    function setupAriaLabeltoDates() {
        const selectList = document.getElementById('Direct-Debit-Payment-Date-Label');
        const selectCreditCardList = document.getElementById('Credit-Card-Payment-Date-Label');
        selectList.setAttribute('aria-label', 'Please Select preferred first installment date from given list');
        selectCreditCardList.setAttribute(
            'aria-label',
            'Please Select preferred first installment date from given list',
        );
    }

    function postInstalmentDate() {
        $(document).ready(function() {
            $(document).on('change', '#Direct-Debit-Payment-Date-List', (function() {
                const nominatedDate = $(this).val();
                postChangePaymentDateToApi(nominatedDate);
            }));

            $(document).on('change', '#Credit-Card-Payment-Date-List', (function() {
                const nominatedDate = $(this).val();
                postChangePaymentDateToApi(nominatedDate);
            }));
        });
    }

    function setupDatePicker() {
        $.extend($.datepicker, {
            _doKeyDown: function(event) {
                if (event.shiftKey) {
                    if (event.keyCode === 9) {
                        $.datepicker._hideDatepicker();
                    }
                } else {
                    event.preventDefault();
                    dayTripper();
                    $('.ui-datepicker-calendar').keyup(function(event) {
                        if (event.keyCode === 13) {
                            $.datepicker._hideDatepicker();
                            $('#Direct-Debit-Selected-Person-Id').focus();
                        }
                    });
                }
            },
        });

        $('.form-row__input--datepicker').datepicker({
            selectOtherMonths: true,
            minDate: $('#FirstPaymentDate').val(),
            maxDate: $('#MaxPaymentDate').val(),
            dateFormat: 'dd-mm-yy',
            showOtherMonths: false,
            dayNamesShort: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            beforeShow: function(input, inst) {
                $(inst.dpDiv).addClass('monthly-payment-date-widget');
            },
            onSelect: function() {
                const nominatedDate = $(this).val();
                postChangePaymentDateToApi(nominatedDate);
            },
        });

        $('Direct-Debit-Payment-Date').attr('aria-describedby', 'Date Input dd-mm-yy');
    }

    function positionDateCursorToFirstSelectableDate() {
        const cursorStart = getFirstSelectablePositionForMonth();
        $(`.ui-datepicker-calendar tr:nth-child('${cursorStart.rowStart}') td:nth-child('${cursorStart.columnStart}')`)
            .find('a')
            .focus();
    }

    function getFirstSelectablePositionForMonth() {
        let rowStart = 0;
        let columnStart = 0;
        let foundColumnStart = false;

        $('.ui-datepicker-calendar tr').each(function(rowIndex) {
            const $tds = $(this).find('td');
            $($tds).each(function(index) {
                const value = $(this).text();
                if ($.isNumeric(value) && (!$(this).hasClass('ui-datepicker-unselectable'))) {
                    columnStart = index + 1;
                    foundColumnStart = true;
                    return false;
                }
            });
            if (foundColumnStart) {
                rowStart = rowIndex;
                return false;
            }
        });
        return {
            rowStart: rowStart,
            columnStart: columnStart,
        };
    }

    function sortCodeKeyUpEvent(event, currentSortCodePart, nextSortCodePart) {
        const TAB_KEYCODE = 9;
        const SHIFT_KEYCODE = 16;
        const LEFT_ARROW_KEYCODE = 37;
        const UP_ARROW_KEYCODE = 38;
        const RIGHT_ARROW_KEYCODE = 39;
        const DOWN_ARROW_KEYCODE = 40;

        const currentLength = $(currentSortCodePart).val().length;
        if (currentLength === 2 &&
            event.which !== TAB_KEYCODE &&
            event.which !== SHIFT_KEYCODE &&
            event.which !== LEFT_ARROW_KEYCODE &&
            event.which !== UP_ARROW_KEYCODE &&
            event.which !== RIGHT_ARROW_KEYCODE &&
            event.which !== DOWN_ARROW_KEYCODE) {
            $(nextSortCodePart).focus().select();
        }
    }

    function sortCodeAutoTab() {
        const container1 = document.getElementById('SortCodePart1');
        const container2 = document.getElementById('SortCodePart2');

        container1.onkeyup = function(e) {
            sortCodeKeyUpEvent(e, '#SortCodePart1', '#SortCodePart2');
        };

        container2.onkeyup = function(e) {
            sortCodeKeyUpEvent(e, '#SortCodePart2', '#SortCodePart3');
        };
    }

    function postChangePaymentDateToApi(nominatedDate) {
        const dataToPost = {
            __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val(),
            nominatedDate: nominatedDate,
        };

        $.ajax({
            url: componentConfig.TenantConfiguration.ApplicationPath + 'TakePaymentComponent/ChangePaymentDate',
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (result.isSuccess === false) {
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                    return true;
                }
                return true;
            },
        });
    }

    function forceMonthlyPaymentMethodStoreAndSetPaymentDate() {
        $('.monthly-radio__label').on('click',
            function() {
                $('#' + $(this).attr('for')).click().focusout();
                $('#Direct-Debit-Payment-Date, #Credit-Card-Payment-Date')
                    .val(sessionStorage.getItem('MonthlyInstalmentPaymentDate'));
            });
    }


    function getSecureSessionData() {
        return {
            'Name': sessionStorage.getItem('MonthlyInstalmentCardSelectedPersonIdText'),
            'CardCaptureUri': sessionStorage.getItem('MonthlyInstalmentCardCaptureUri'),
            'SecureSessionId': sessionStorage.getItem('MonthlyInstalmentSecureSessionId'),
            'SelectedPersonId': sessionStorage.getItem('MonthlyInstalmentCardSelectedPersonIdVal'),
            'ThreeDSecureUri': sessionStorage.getItem('MonthlyInstalmentThreeDSecureUri'),
        };
    }

    function saveDataToSessionStorage() {
        const model = {
            sortCode: document.getElementById('SortCodePart1').value +
                document.getElementById('SortCodePart2').value +
                document.getElementById('SortCodePart3').value,
            accountNumber: document.getElementById('direct-debit-account-number').value,
        };

        const dataToPost = {
            __RequestVerificationToken: document.querySelector('input[name="__RequestVerificationToken"]').value,
            BankAccountAndSortCodeModel: model,
            encryptData: true,
        };

        $.ajax({
            url: componentConfig.TenantConfiguration.ApplicationPath +
                'TakePaymentComponent/AccountDetailsCryptography',
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (!result.isSuccess) {
                    bgl.common.telemetry.logEvent('MonthlyInstalmentDetails', {'Status': result.message});
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                    return false;
                }
                sessionStorage.setItem('MonthlyInstalmentDetails1', result.accountNumber);
                sessionStorage.setItem('MonthlyInstalmentDetails2', result.sortCode);
                bgl.common.utilities.redirectToUrl(componentConfig.MonthlyDepositUrl);
                return true;
            },
        });
    }

    function populateBankAccountDetails() {
        const bankAccountNumberEn = sessionStorage.getItem('MonthlyInstalmentDetails1');
        const sortCodeEn = sessionStorage.getItem('MonthlyInstalmentDetails2');
        if (bankAccountNumberEn != null || sortCodeEn != null) {
            const model = {
                sortCode: sortCodeEn,
                accountNumber: bankAccountNumberEn,
            };
            const dataToPost = {
                __RequestVerificationToken: document.querySelector('input[name="__RequestVerificationToken"]').value,
                BankAccountAndSortCodeModel: model,
                encryptData: false,
            };

            $.ajax({
                url: componentConfig.TenantConfiguration.ApplicationPath +
                    'TakePaymentComponent/AccountDetailsCryptography',
                type: 'POST',
                cache: false,
                dataType: 'json',
                data: dataToPost,
                success: function(result) {
                    if (!result.isSuccess) {
                        bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                        return false;
                    }
                    document.getElementById('direct-debit-account-number').value = result.accountNumber;
                    const sortCode = result.sortCode;
                    document.getElementById('SortCodePart1').value = sortCode.substring(0, 2);
                    document.getElementById('SortCodePart2').value = sortCode.substring(2, 4);
                    document.getElementById('SortCodePart3').value = sortCode.substring(4, 6);
                    return true;
                },
            });
        }
        return false;
    }

    function validateBankAccountAndSortCode(saveDataToSessionStorageCallBack) {
        const dataToPost = {
            __RequestVerificationToken: document.querySelector('input[name="__RequestVerificationToken"]').value,
            sortCode: document.getElementById('SortCodePart1').value +
                document.getElementById('SortCodePart2').value +
                document.getElementById('SortCodePart3').value,
            accountNumber: document.getElementById('direct-debit-account-number').value,
        };
        $.ajax({
            url: componentConfig.TenantConfiguration.ApplicationPath +
                'TakePaymentComponent/PostAccountNumberAndSortCode',
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (!result.isSuccess) {
                    bgl.common.telemetry.logEvent('MonthlyInstallmentDetailsStatus', {'message': result.message});
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                    return false;
                }

                switch (result.Result) {
                case 'Validated':
                    if (typeof bgl.common.pubsub !== 'undefined') {
                        bgl.common.pubsub.emit(
                            'fakeFormSubmit',
                            $('#Direct-Debit-Form').attr('id') ||
                            $('#Direct-Debit-Form').attr('action') ||
                            'unknown',
                        );
                    }
                    removeSortCodeErrorStyle();
                    removeAccountErrorStyle();
                    saveDataToSessionStorageCallBack();
                    return true;
                case 'no values submitted':
                case 'sort code or account number invalid':
                    addAccountErrorStyle();
                    addSortCodeErrorStyle();
                    break;
                case 'sortCode invalid':
                    addSortCodeErrorStyle();
                    break;
                case 'accountNumber invalid':
                    addAccountErrorStyle();
                    break;
                }

                scrollToFirstFieldWithErrorAndFocus();
                return false;
            },
        });
    }

    function removeSortCodeErrorStyle() {
        $('#sortcode-api-validation-message').addClass('hide');
        $('#SortCodeLabel').removeClass('sort-code__label--error');
        $('#sortcode-api-validation-message').removeClass('sort-code__span--error');
        $('#SortCodePart1,#SortCodePart2,#SortCodePart3').removeClass('sort-code__input--error');
        $('#sort-code-input-1, #sort-code-input-2, #sort-code-input-3').removeClass('error');
        cleanAriaDescribedBy('#sort-code-input-1');
    }

    function addSortCodeErrorStyle() {
        $('#sortcode-api-validation-message').removeClass('hide');
        $('#SortCodeLabel').addClass('sort-code__label--error');
        $('#sortcode-api-validation-message').addClass('sort-code__span--error');
        $('#SortCodePart1,#SortCodePart2,#SortCodePart3').addClass('sort-code__input--error');
        $('#sort-code-input-1, #sort-code-input-2, #sort-code-input-3').addClass('error');

        cleanAriaDescribedBy($('#SortCodePart1,#SortCodePart2,#SortCodePart3'));
        $('#SortCodePart1,#SortCodePart2,#SortCodePart3').attr('aria-describedby', 'sortcode-api-validation-message');
    }

    function removeIndividualSortCodeErrorStyle(element) {
        $(element).removeClass('sort-code__input--error');
        cleanAriaDescribedBy(element);
    }

    function addIndividualSortCodeErrorStyle(element) {
        $('#SortCodeLabel').addClass('sort-code__label--error');
        $('#sortcode-validation-text').removeClass('hide');
        $(element).addClass('sort-code__input--error');

        cleanAriaDescribedBy(element);

        if ($(element).hasClass('form-row__input account-number sort-code__input--error')) {
            element.setAttribute('aria-describedby', 'direct-debit-account-number-error');
        } else if ($(element)
            .hasClass('form-row__input form-row__input--radio form-row__input--hidden sort-code__input--error')) {
            element.setAttribute('aria-describedby', 'DirectDebitData.CanAuthorise-error');
        } else {
            $(element).attr('aria-describedby', 'sortcode-validation-text');
        }
    }

    function addAccountErrorStyle() {
        $('#account-number-validation-message').removeClass('hide');
        $('#AccountNumberLabel').addClass('sort-code__label--error');
        $('#account-number-validation-message').addClass('sort-code__span--error');
        $('#direct-debit-account-number').addClass('sort-code__input--error');
        $('#account-number-input').addClass('error');

        cleanAriaDescribedBy($('#account-number-input'));
        $('#direct-debit-account-number').attr('aria-describedby', 'account-number-validation-message');
    }

    function removeAccountErrorStyle() {
        $('#account-number-validation-message').addClass('hide');
        $('#AccountNumberLabel').removeClass('sort-code__label--error');
        $('#account-number-validation-message').removeClass('sort-code__span--error');
        $('#direct-debit-account-number').removeClass('sort-code__input--error');
        $('#account-number-input').removeClass('error');
        cleanAriaDescribedBy('#account-number-input');
    }

    function cleanAriaDescribedBy(element) {
        if ($(element).attr('aria-describedby')) {
            $(element).removeAttr('aria-describedby');
        }
    }

    function dayTripper() {
        setTimeout(function() {
            let today = $('.ui-datepicker-today a')[0];

            if (!today) {
                today = $('.ui-state-active')[0] ||
                    $('.ui-state-default')[0];
            }
            $('main').attr('id', 'dp-container');
            $('#dp-container').attr('aria-hidden', 'true');
            $('#skipnav').attr('aria-hidden', 'true');

            $('.ui-datepicker-current').hide();

            today.focus();
            datePickHandler();
            $(document).on('click', '#ui-datepicker-div .ui-datepicker-close', function() {
                closeCalendar();
            });
        }, 0);
    }

    function datePickHandler() {
        const container = document.getElementById('ui-datepicker-div');
        const input = document.getElementById('Direct-Debit-Payment-Date');

        if (!container || !input) {
            return;
        }

        $(container).find('table').first().attr('role', 'grid');

        container.setAttribute('role', 'application');
        container.setAttribute('aria-label', 'Calendar view date-picker');
        const prev = $('.ui-datepicker-prev', container)[0];
        const next = $('.ui-datepicker-next', container)[0];


        next.href = 'javascript:void(0)';
        prev.href = 'javascript:void(0)';

        next.setAttribute('role', 'button');
        next.removeAttribute('title');
        prev.setAttribute('role', 'button');
        prev.removeAttribute('title');

        appendOffscreenMonthText(next);
        appendOffscreenMonthText(prev);

        $(next).on('click', handleNextClicks);
        $(prev).on('click', handlePrevClicks);

        monthDayYearText();

        $(container).on('keydown', function calendarKeyboardListener(keyVent) {
            const which = keyVent.which;
            const target = keyVent.target;
            let dateCurrent = getCurrentDate(container);

            if (!dateCurrent) {
                dateCurrent = $('a.ui-state-default')[0];
                setHighlightState(dateCurrent, container);
            }

            if (27 === which) {
                keyVent.stopPropagation();
                return closeCalendar();
            } else if (which === 9 && keyVent.shiftKey) {
                keyVent.preventDefault();
                if ($(target).hasClass('ui-state-default')) {
                    $('.ui-datepicker-prev')[0].focus();
                } else if ($(target).hasClass('ui-datepicker-prev')) {
                    $('.ui-datepicker-next')[0].focus();
                } else if ($(target).hasClass('ui-datepicker-next')) {
                    positionDateCursorToFirstSelectableDate();
                }
            } else if (which === 9) { // TAB
                keyVent.preventDefault();
                if ($(target).hasClass('ui-datepicker-prev')) {
                    positionDateCursorToFirstSelectableDate();
                } else if ($(target).hasClass('ui-state-default')) {
                    $('.ui-datepicker-next')[0].focus();
                } else if ($(target).hasClass('ui-datepicker-next')) {
                    $('.ui-datepicker-prev')[0].focus();
                }
            } else if (which === 37) {
                if (!$(target).hasClass('ui-datepicker-close') && $(target).hasClass('ui-state-default')) {
                    keyVent.preventDefault();
                    previousDay(target);
                }
            } else if (which === 39) {
                if (!$(target).hasClass('ui-datepicker-close') && $(target).hasClass('ui-state-default')) {
                    keyVent.preventDefault();
                    nextDay(target);
                }
            } else if (which === 38) {
                if (!$(target).hasClass('ui-datepicker-close') && $(target).hasClass('ui-state-default')) {
                    keyVent.preventDefault();
                    upHandler(target, container, prev);
                }
            } else if (which === 40) {
                if (!$(target).hasClass('ui-datepicker-close') && $(target).hasClass('ui-state-default')) {
                    keyVent.preventDefault();
                    downHandler(target, container, next);
                }
            } else if (which === 13) {
                if ($(target).hasClass('ui-state-default')) {
                    setTimeout(function() {
                        closeCalendar();
                    }, 100);
                } else if ($(target).hasClass('ui-datepicker-prev')) {
                    handlePrevClicks();
                } else if ($(target).hasClass('ui-datepicker-next')) {
                    handleNextClicks();
                }
            } else if (32 === which) {
                if ($(target).hasClass('ui-datepicker-prev') || $(target).hasClass('ui-datepicker-next')) {
                    target.click();
                }
            } else if (33 === which) {
                moveOneMonth(target, 'prev');
            } else if (34 === which) {
                moveOneMonth(target, 'next');
            } else if (36 === which) {
                const firstOfMonth = $(target).closest('tbody').find('.ui-state-default')[0];
                if (firstOfMonth) {
                    firstOfMonth.focus();
                    setHighlightState(firstOfMonth, $('#ui-datepicker-div')[0]);
                }
            } else if (35 === which) {
                const $daysOfMonth = $(target).closest('tbody').find('.ui-state-default');
                const lastDay = $daysOfMonth[$daysOfMonth.length - 1];
                if (lastDay) {
                    lastDay.focus();
                    setHighlightState(lastDay, $('#ui-datepicker-div')[0]);
                }
            }
            $('.ui-datepicker-current').hide();
        });
    }

    function closeCalendar() {
        const container = $('#ui-datepicker-div');
        $(container).off('keydown');
        const input = $('#datepicker')[0];
        $(input).datepicker('hide');

        input.focus();
    }

    function moveOneMonth(currentDate, dir) {
        const button = (dir === 'next') ?
            $('.ui-datepicker-next')[0] :
            $('.ui-datepicker-prev')[0];

        if (!button) {
            return;
        }

        const ENABLED_SELECTOR = '#ui-datepicker-div tbody td:not(.ui-state-disabled)';
        const $currentCells = $(ENABLED_SELECTOR);
        let currentIdx = $.inArray(currentDate.parentNode, $currentCells);

        button.click();
        setTimeout(function() {
            updateHeaderElements();

            const $newCells = $(ENABLED_SELECTOR);
            let newTd = $newCells[currentIdx];
            let newAnchor = newTd && $(newTd).find('a')[0];

            while (!newAnchor) {
                currentIdx--;
                newTd = $newCells[currentIdx];
                newAnchor = newTd && $(newTd).find('a')[0];
            }

            setHighlightState(newAnchor, $('#ui-datepicker-div')[0]);
            newAnchor.focus();
        }, 0);
    }

    function handleNextClicks() {
        setTimeout(function() {
            updateHeaderElements();
            prepHighlightState();
            $('.ui-datepicker-next').focus();
            $('.ui-datepicker-current').hide();
        }, 0);
    }

    function handlePrevClicks() {
        setTimeout(function() {
            updateHeaderElements();
            prepHighlightState();
            $('.ui-datepicker-prev').focus();
            $('.ui-datepicker-current').hide();
        }, 0);
    }

    function previousDay(dateLink) {
        const container = document.getElementById('ui-datepicker-div');
        if (!dateLink) {
            return;
        }
        const td = $(dateLink).closest('td');
        if (!td) {
            return;
        }

        const prevTd = $(td).prev();
        const prevDateLink = $('a.ui-state-default', prevTd)[0];

        if (prevTd && prevDateLink) {
            setHighlightState(prevDateLink, container);
            prevDateLink.focus();
        } else {
            handlePrevious(dateLink);
        }
    }


    function handlePrevious(target) {
        const container = document.getElementById('ui-datepicker-div');
        if (!target) {
            return;
        }
        const currentRow = $(target).closest('tr');
        if (!currentRow) {
            return;
        }
        const previousRow = $(currentRow).prev();

        if (!previousRow || previousRow.length === 0) {
            previousMonth();
        } else {
            const prevRowDates = $('td a.ui-state-default', previousRow);
            const prevRowDate = prevRowDates[prevRowDates.length - 1];

            if (prevRowDate) {
                setTimeout(function() {
                    setHighlightState(prevRowDate, container);
                    prevRowDate.focus();
                }, 0);
            }
        }
    }

    function previousMonth() {
        const prevLink = $('.ui-datepicker-prev')[0];
        const container = document.getElementById('ui-datepicker-div');
        prevLink.click();
        setTimeout(function() {
            const trs = $('tr', container);
            const lastRowTdLinks = $('td a.ui-state-default', trs[trs.length - 1]);
            const lastDate = lastRowTdLinks[lastRowTdLinks.length - 1];

            updateHeaderElements();
            setHighlightState(lastDate, container);
            lastDate.focus();
        }, 0);
    }

    function nextDay(dateLink) {
        const container = document.getElementById('ui-datepicker-div');
        if (!dateLink) {
            return;
        }
        const td = $(dateLink).closest('td');
        if (!td) {
            return;
        }
        const nextTd = $(td).next();
        const nextDateLink = $('a.ui-state-default', nextTd)[0];

        if (nextTd && nextDateLink) {
            setHighlightState(nextDateLink, container);
            nextDateLink.focus();
        } else {
            handleNext(dateLink);
        }
    }

    function handleNext(target) {
        const container = document.getElementById('ui-datepicker-div');
        if (!target) {
            return;
        }
        const currentRow = $(target).closest('tr');
        const nextRow = $(currentRow).next();

        if (!nextRow || nextRow.length === 0) {
            nextMonth();
        } else {
            const nextRowFirstDate = $('a.ui-state-default', nextRow)[0];
            if (nextRowFirstDate) {
                setHighlightState(nextRowFirstDate, container);
                nextRowFirstDate.focus();
            }
        }
    }

    function nextMonth() {
        const nextMon = $('.ui-datepicker-next')[0];
        const container = document.getElementById('ui-datepicker-div');
        nextMon.click();
        setTimeout(function() {
            updateHeaderElements();
            const firstDate = $('a.ui-state-default', container)[0];
            setHighlightState(firstDate, container);
            firstDate.focus();
        }, 0);
    }

    function upHandler(target, cont, prevLink) {
        prevLink = $('.ui-datepicker-prev')[0];
        const rowContext = $(target).closest('tr');
        if (!rowContext) {
            return;
        }
        const rowTds = $('td', rowContext);
        const rowLinks = $('a.ui-state-default', rowContext);
        const targetIndex = $.inArray(target, rowLinks);
        const prevRow = $(rowContext).prev();
        const prevRowTds = $('td', prevRow);
        const parallel = prevRowTds[targetIndex];
        const linkCheck = $('a.ui-state-default', parallel)[0];

        if (prevRow && parallel && linkCheck) {
            setHighlightState(linkCheck, cont);
            linkCheck.focus();
        } else {
            prevLink.click();
            setTimeout(function() {
                updateHeaderElements();
                const newRows = $('tr', cont);
                const lastRow = newRows[newRows.length - 1];
                const lastRowTds = $('td', lastRow);
                const tdParallelIndex = $.inArray(target.parentNode, rowTds);
                const newParallel = lastRowTds[tdParallelIndex];
                const newCheck = $('a.ui-state-default', newParallel)[0];

                if (lastRow && newParallel && newCheck) {
                    setHighlightState(newCheck, cont);
                    newCheck.focus();
                } else {
                    const secondLastRow = newRows[newRows.length - 2];
                    const secondTds = $('td', secondLastRow);
                    const targetTd = secondTds[tdParallelIndex];
                    const linkCheck = $('a.ui-state-default', targetTd)[0];

                    if (linkCheck) {
                        setHighlightState(linkCheck, cont);
                        linkCheck.focus();
                    }
                }
            }, 0);
        }
    }

    function downHandler(target, cont, nextLink) {
        nextLink = $('.ui-datepicker-next')[0];
        const targetRow = $(target).closest('tr');
        if (!targetRow) {
            return;
        }
        const targetCells = $('td', targetRow);
        const cellIndex = $.inArray(target.parentNode, targetCells);
        const nextRow = $(targetRow).next();
        const nextRowCells = $('td', nextRow);
        const nextWeekTd = nextRowCells[cellIndex];
        const nextWeekCheck = $('a.ui-state-default', nextWeekTd)[0];

        if (nextRow && nextWeekTd && nextWeekCheck) {
            setHighlightState(nextWeekCheck, cont);
            nextWeekCheck.focus();
        } else {
            nextLink.click();

            setTimeout(function() {
                updateHeaderElements();

                const nextMonthTrs = $('tbody tr', cont);
                const firstTds = $('td', nextMonthTrs[0]);
                const firstParallel = firstTds[cellIndex];
                const firstCheck = $('a.ui-state-default', firstParallel)[0];

                if (firstParallel && firstCheck) {
                    setHighlightState(firstCheck, cont);
                    firstCheck.focus();
                } else {
                    const secondRow = nextMonthTrs[1];
                    const secondTds = $('td', secondRow);
                    const secondRowTd = secondTds[cellIndex];
                    const secondCheck = $('a.ui-state-default', secondRowTd)[0];

                    if (secondRow && secondCheck) {
                        setHighlightState(secondCheck, cont);
                        secondCheck.focus();
                    }
                }
            }, 0);
        }
    }

    function monthDayYearText() {
        const cleanUps = $('.amaze-date');
        $(cleanUps).each(function(clean) {
            clean.parentNode.removeChild(clean);
        });

        const datePickDiv = document.getElementById('ui-datepicker-div');
        if (!datePickDiv) {
            return;
        }

        const dates = $('a.ui-state-default', datePickDiv);
        $(dates).attr('role', 'button').on('keydown', function(e) {
            if (e.which === 32) {
                e.preventDefault();
                e.target.click();
                setTimeout(function() {
                    closeCalendar();
                }, 100);
            }
        });
        $(dates).each(function(index, date) {
            const currentRow = $(date).closest('tr');
            const currentTds = $('td', currentRow);
            const currentIndex = $.inArray(date.parentNode, currentTds);
            const headThs = $('thead tr th', datePickDiv);
            const dayIndex = headThs[currentIndex];
            const daySpan = $('span', dayIndex)[0];
            const monthName = $('.ui-datepicker-month', datePickDiv)[0].innerHTML;
            const year = $('.ui-datepicker-year', datePickDiv)[0].innerHTML;
            const number = date.innerHTML;

            if (!daySpan || !monthName || !number || !year) {
                return;
            }

            const dateText = date.innerHTML + ' ' + monthName + ' ' + year + ' ' + daySpan.title;
            date.setAttribute('aria-label', dateText);
        });
    }

    function updateHeaderElements() {
        const context = document.getElementById('ui-datepicker-div');
        if (!context) {
            return;
        }

        $(context).find('table').first().attr('role', 'grid');

        const prev = $('.ui-datepicker-prev', context)[0];
        const next = $('.ui-datepicker-next', context)[0];

        next.href = 'javascript:void(0)';
        prev.href = 'javascript:void(0)';

        next.setAttribute('role', 'button');
        prev.setAttribute('role', 'button');
        appendOffscreenMonthText(next);
        appendOffscreenMonthText(prev);

        $(next).on('click', handleNextClicks);
        $(prev).on('click', handlePrevClicks);

        monthDayYearText();
    }


    function prepHighlightState() {
        const cage = document.getElementById('ui-datepicker-div');
        const highlight = $('.ui-state-highlight', cage)[0] ||
            $('.ui-state-default', cage)[0];
        if (highlight && cage) {
            setHighlightState(highlight, cage);
        }
    }

    function setHighlightState(newHighlight, container) {
        const prevHighlight = getCurrentDate(container);
        $(prevHighlight).removeClass('ui-state-highlight');
        $(newHighlight).addClass('ui-state-highlight');
    }


    function getCurrentDate(container) {
        const currentDate = $('.ui-state-highlight', container)[0];
        return currentDate;
    }

    function appendOffscreenMonthText(button) {
        const isNext = $(button).hasClass('ui-datepicker-next');
        const months = [
            'january',
            'february',
            'march',
            'april',
            'may',
            'june',
            'july',
            'august',
            'september',
            'october',
            'november',
            'december',
        ];

        const currentMonth = $('.ui-datepicker-title .ui-datepicker-month').text().toLowerCase();
        const monthIndex = $.inArray(currentMonth.toLowerCase(), months);
        let currentYear = $('.ui-datepicker-title .ui-datepicker-year').text().toLowerCase();
        let adjacentIndex = (isNext) ? monthIndex + 1 : monthIndex - 1;

        if (isNext && currentMonth === 'december') {
            currentYear = parseInt(currentYear, 10) + 1;
            adjacentIndex = 0;
        } else if (!isNext && currentMonth === 'january') {
            currentYear = parseInt(currentYear, 10) - 1;
            adjacentIndex = months.length - 1;
        }

        const buttonText = (isNext) ?
            'Next Month, ' + firstToCap(months[adjacentIndex]) + ' ' + currentYear :
            'Previous Month, ' + firstToCap(months[adjacentIndex]) + ' ' + currentYear;

        $(button).find('.ui-icon').html(buttonText);
    }

    function firstToCap(s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
    }

    return {
        init: initComponent,
        load: loadComponent,
        getValidationMessages: getValidationMessages,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.monthlydepositsummary = (function() {
    let componentConfig;
    let redirectInterval;
    let redirectTick = 0;
    const maxRedirectWait = 25;
    let requestVerificationToken;
    let isPaymentSuccessful = false;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        componentConfiguration.CardSessionData = getSecureSessionData();
        componentConfiguration.CreditInformationUrl = sessionStorage.getItem('credit-information');
        componentConfig = componentConfiguration;
        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent();
            });
    }

    function initComponent() {
        setupTimeline();
        setupImportantInformation();

        $('#Monthly-Pay-Now-Button').on('click',
            function() {
                if (!$('#Read-Confirm-Checkbox').prop('checked')) {
                    $('#Read-Confirm-Container').addClass('error');
                } else {
                    commitInstalmentAndDepositPaymentsAndBasket();
                }
            });

        $('#Read-Confirm-Checkbox').on('click',
            function() {
                if ($('#Read-Confirm-Checkbox').prop('checked')) {
                    $('#Read-Confirm-Container').removeClass('error');
                }
            });

        bgl.common.scrollDownBanner.init('scroll-prompt', 350);
    }

    function setupTimeline() {
        $('.schedule-bar__item').each(function(i, el) {
            const itemWidth = $(el).data('width');
            $(el).css('width', itemWidth + '%');
        });

        $('.schedule-bar__item.active').prevAll('.schedule-bar__item').each(function(i, el) {
            $(el).addClass('active');
        });
    }

    function getSecureSessionData() {
        if (sessionStorage.getItem('UseMonthlyInstalmentCard') === 'true') {
            return {
                'Name': sessionStorage.getItem('MonthlyInstalmentCardSelectedPersonIdText'),
                'CardCaptureUri': sessionStorage.getItem('MonthlyInstalmentCardCaptureUri'),
                'SecureSessionId': sessionStorage.getItem('MonthlyInstalmentSecureSessionId'),
            };
        }
        return {
            'Name': sessionStorage.getItem('MonthlyDepositSelectedPersonIdText'),
            'CardCaptureUri': sessionStorage.getItem('MonthlyDepositCardCaptureUri'),
            'SecureSessionId': sessionStorage.getItem('MonthlyDepositSecureSessionId'),
        };
    }

    function commitInstalmentAndDepositPaymentsAndBasket() {
        requestVerificationToken = $('input[name="__RequestVerificationToken"]').val();

        const dataToPost = {
            __RequestVerificationToken: requestVerificationToken,
            commitData: getCommitCardData(),
        };

        $('body').html(bgl.common.spinner.getSpinnerBody('Processing your payment!',
            'Please do not hit the back button or refresh the page'));

        const urlPrefix = componentConfig.TenantConfiguration.ApplicationPath !== null ?
            componentConfig.TenantConfiguration.ApplicationPath :
            '/';

        $.ajax({
            url: urlPrefix + 'TakePaymentComponent/CommitMultiplePaymentBasket',
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (result.isSuccess === false) {
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                    return;
                }
                if (result.PaymentSuccessful === true) {
                    if (typeof bgl.common.pubsub !== 'undefined') {
                        bgl.common.pubsub.emit('fakeFormSubmit', 'PaymentSuccessful');
                    }
                    dataLayerPushPaymentSuccessful();
                    bgl.common.telemetry.logEvent(
                        'PaymentSuccessful',
                        {'PolicyId': result.PolicyId});
                    isPaymentSuccessful = true;
                }
                bgl.common.telemetry.logEvent(
                    'IsPaymentSucessful',
                    {'isPaymentSuccessful': result.PaymentSuccessful},
                );
                sessionStorage.setItem('PaymentProcessedRedirectUrl', result.RedirectUrl);
                if (result.PolicyId) {
                    const stringValue = result.PolicyId + '';
                    let length = stringValue.indexOf('-');
                    length = length > 0 ? length : stringValue.length;
                    sessionStorage.setItem('PaymentProcessedPolicyId', stringValue.substring(0, length));
                    sessionStorage.setItem('Authorization', result.Authorization);
                }
            },
            complete: function() {
                redirectInterval = setInterval(checkAiComplete, 200);
            },
        });
    }

    function checkAiComplete() {
        if (sessionStorage.getItem('AI_sentBuffer') === '[]' || redirectTick >= maxRedirectWait) {
            clearInterval(redirectInterval);
            if (isPaymentSuccessful) {
                bgl.common.utilities.redirectToUrl(componentConfig.PaymentSuccessfulUrl);
            } else {
                bgl.common.utilities.redirectToUrl(sessionStorage.getItem('PaymentProcessedRedirectUrl'));
                bgl.common.telemetry.logEvent(
                    'RedirectUrlAfterFailedPayment',
                    {'RedirectUrlAfterFailedPayment': sessionStorage.getItem('PaymentProcessedRedirectUrl')},
                );
            }
        }
        redirectTick += 1;
    }

    function getCommitCardData() {
        const model = {};
        const directDebitNumber = sessionStorage.getItem('MonthlyInstalmentDetails1');
        const directDebitCode = sessionStorage.getItem('MonthlyInstalmentDetails2');
        model.TodaysPaymentCard = getDepositCardData();
        model.ContinuousPaymentCard = getInstalmentCardData();
        model.ContinuousPaymentDirectDebit = getInstalmentDirectDebitData();
        model.PaymentType = sessionStorage.getItem('MonthlyInstalmentPaymentType');
        model.UseContinuousPaymentCardForTodaysPayment = sessionStorage.getItem('UseMonthlyInstalmentCard');
        if (!directDebitNumber && !directDebitCode) {
            bgl.common.telemetry.logEvent('MonthlyInstallmentDetails', {'Status': 'Not available'});
        } else {
            model.DirectDebitNumber = directDebitNumber;
            model.DirectDebitCode = directDebitCode;
        }
        model.PaymentDeclinedUrl = componentConfig.PaymentDeclinedUrl;
        model.ComponentConfiguration = componentConfig;
        return model;
    }

    function getDepositCardData() {
        const model = {};
        model.SelectedPersonIdText = sessionStorage.getItem('MonthlyDepositSelectedPersonIdText');
        model.CardCaptureUri = sessionStorage.getItem('MonthlyDepositCardCaptureUri');
        model.SecureSessionId = sessionStorage.getItem('MonthlyDepositSecureSessionId');
        model.SelectedPersonIdVal = sessionStorage.getItem('MonthlyDepositSelectedPersonIdVal');
        return model;
    }

    function getInstalmentCardData() {
        const model = {};
        model.SelectedPersonIdText = sessionStorage.getItem('MonthlyInstalmentCardSelectedPersonIdText');
        model.CardCaptureUri = sessionStorage.getItem('MonthlyInstalmentCardCaptureUri');
        model.SecureSessionId = sessionStorage.getItem('MonthlyInstalmentSecureSessionId');
        model.SelectedPersonIdVal = sessionStorage.getItem('MonthlyInstalmentCardSelectedPersonIdVal');
        return model;
    }

    function getInstalmentDirectDebitData() {
        const model = {};
        model.SelectedPersonIdText = sessionStorage.getItem('MonthlyInstalmentDirectDebitSelectedPersonIdText');
        model.SelectedPersonIdVal = sessionStorage.getItem('MonthlyInstalmentDirectDebitSelectedPersonIdVal');
        return model;
    }

    function dataLayerPushPaymentSuccessful() {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                'event': 'TEVirtualPageview',
                'virtualPageURL': 'Payment/Successful',
                'virtualPageTitle': 'Payment Successful',
            });
        }
    }

    function setupImportantInformation() {
        $('#moreInfo-payments').off('click').on('click',
            function(event) {
                event.preventDefault();
                const link = $(this);
                bgl.common.loader.load({}, link.data('action-url'), link.data('container'));
            });
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.monthlydeposit = (function() {
    let componentConfiguration;
    let hideElementsWhen3DSecureIsDisplayedTimeout;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        componentConfiguration.CardSessionData = getSecureSessionData();
        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
            });
    }

    function initComponent(configuration) {
        componentConfiguration = configuration;
        bgl.common.datastore.setupReadAndWrite();

        loadIframe();

        setVisibilityOfCardholderNameOther();

        setCardInformation();

        bgl.common.validator.enableMaxLength();

        bgl.common.validator.init($('#MonthlyDepositPaymentForm'),
            {
                onkeyup: function(element) {
                    validateElementAndToggleIframe(element);
                },
                hasSubmit: false,
            });

        $('#PersonListData_SelectedPersonId').change(
            function() {
                if ($('#PersonListData_SelectedPersonId').find(':selected').text() === 'Other') {
                    $('#CardholderNameRow').removeClass('hide');
                    $('#Card-Capture-Iframe').addClass('hide');
                    sessionStorage.setItem('MonthlyDepositSelectedPersonIdText', '');
                    $('#CardholderName').val('');
                    $('#CardholderName').focus();
                } else {
                    $('#CardholderNameRow').addClass('hide');
                    $('#Card-Capture-Iframe').removeClass('hide');
                }

                initCardCapture();
            });

        if ($('#PersonListData_SelectedPersonId').find(':selected').text() === 'Other') {
            validateElementAndToggleIframe($('#MonthlyDepositPaymentForm'));
        }

        setupHowToPayButtons();

        $('#Card-Capture-Iframe').on('load', function() {
            hideElementsWhen3DSecureIsDisplayed();
        });
    }


    function initCardCapture() {
        sessionStorage.removeItem('MonthlyDepositCardCaptureUri');
        sessionStorage.removeItem('MonthlyDepositSecureSessionId');
        sessionStorage.removeItem('MonthlyDepositThreeDSecureUri');

        if (hideElementsWhen3DSecureIsDisplayedTimeout) {
            clearTimeout(hideElementsWhen3DSecureIsDisplayedTimeout);
        }

        bgl.components.takepayment.cardcaptureiframe.clearIframe();

        componentConfiguration.CardSessionData = {'SelectedPersonId': $('#PersonListData_SelectedPersonId').val()};

        const dataToPost = {
            __RequestVerificationToken: $('input[name=\'__RequestVerificationToken\']').val(),
            configuration: componentConfiguration,
        };

        $.ajax({
            url: componentConfiguration.TenantConfiguration.ApplicationPath +
                'TakePaymentComponent/InitialiseMonthlyCardCapture',
            type: 'POST',
            data: dataToPost,
            success: function(data) {
                sessionStorage.setItem('MonthlyDepositCardCaptureUri', data.cardCaptureUri);
                sessionStorage.setItem('MonthlyDepositSecureSessionId', data.secureSessionId);
                sessionStorage.setItem('MonthlyDepositThreeDSecureUri', data.threeDSecureUri);

                loadIframe();
            },
        });
    }

    function loadIframe() {
        const cardSessionData = getSecureSessionData();
        bgl.components.takepayment.cardcaptureiframe.loadIframe(
            'Card-Capture-Iframe',
            cardSessionData.CardCaptureUri,
            cardSessionData.SecureSessionId,
            cardSessionData.ThreeDSecureUri);
    }

    function validateElementAndToggleIframe(element) {
        const valid = $(element).valid();
        if (valid === true) {
            $('#Card-Capture-Iframe').removeClass('hide');
        } else {
            $('#Card-Capture-Iframe').addClass('hide');
        }
    }

    function hideElementsWhen3DSecureIsDisplayed() {
        if ($('#Card-Capture-Iframe').contents().find('#continue').length === 0) {
            $('#Cardholder-Name-Form-Row').hide();
            $('#CardholderNameRow').hide();
            $('#today-payment-section').hide();
            scrollToCardPayment();
            return;
        }

        hideElementsWhen3DSecureIsDisplayedTimeout = setTimeout(function() {
            hideElementsWhen3DSecureIsDisplayed();
        }, 1000);
    }

    function scrollToCardPayment() {
        const requiredField = $('.card-payment');
        $('html,body').animate({scrollTop: requiredField.offset().top}, 0);
    }

    function setupHowToPayButtons() {
        setUseMonthlyInstalmentCard('false');

        $('#deposit-new-card').on('click',
            function() {
                $('#deposit-iframe-section').removeClass('hide');
                if ($('#PersonListData_SelectedPersonId').find(':selected').text() === 'Other') {
                    validateElementAndToggleIframe($('#MonthlyDepositPaymentForm'));
                }
            });

        $('#deposit-instalment-card, #deposit-card-icons-instalment-card').on('click',
            function() {
                setUseMonthlyInstalmentCard('true');
                const actionUrl = $(this).data('action-url');
                bgl.common.utilities.redirectToUrl(actionUrl);
            });

        addCardTypeClassToCardBox();

        addCardTypeForCardIconsClassToCardBox();

        if (instalmentsPaidByDirectDebit()) {
            $('#today-payment-section, #deposit-new-card').addClass('hide');
            $('#deposit-iframe-section').removeClass('hide');
        }
    }

    function setUseMonthlyInstalmentCard(value) {
        sessionStorage.setItem('UseMonthlyInstalmentCard', value);
    }

    function addCardTypeClassToCardBox() {
        $('#deposit-instalment-card').addClass('payment-card--' + sessionStorage.getItem('MonthlyInstalmentCardType'));
    }

    function addCardTypeForCardIconsClassToCardBox() {
        $('#deposit-card-icons-instalment-card')
            .find('.payment-card__type')
            .addClass('payment-card-new--' + sessionStorage.getItem('MonthlyInstalmentCardType'));
    }

    function instalmentsPaidByDirectDebit() {
        return sessionStorage.getItem('MonthlyInstalmentPaymentType') === 'DirectDebit';
    }

    function getSecureSessionData() {
        return {
            'Name': sessionStorage.getItem('MonthlyDepositSelectedPersonIdText'),
            'CardCaptureUri': sessionStorage.getItem('MonthlyDepositCardCaptureUri'),
            'SecureSessionId': sessionStorage.getItem('MonthlyDepositSecureSessionId'),
            'SelectedPersonId': sessionStorage.getItem('MonthlyDepositSelectedPersonIdVal'),
            'ThreeDSecureUri': sessionStorage.getItem('MonthlyDepositThreeDSecureUri'),
        };
    }

    function setVisibilityOfCardholderNameOther() {
        if ($('#PersonListData_SelectedPersonId').find(':selected').text() === 'Other') {
            $('#CardholderNameRow').removeClass('hide');
            $('#CardholderName').focus();
        }
    }

    function setCardInformation() {
        $('#card-info-date').text('Expires: ' + sessionStorage.getItem('MonthlyInstalmentCardExpiry'));
        $('#card-info-name').text(sessionStorage.getItem('MonthlyDepositSelectedPersonIdText'));
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.mergedpaymentsummary = (function() {
    let componentConfig;

    function initComponent(componentConfiguration) {
        componentConfig = componentConfiguration;

        $('.payment-switch-link').off('click').on('click',
            function() {
                clearTimeout(sessionStorage.getItem('3dSecureTimeoutId'));

                const paymentSwitchLinkId = $(this).attr('id');
                bgl.common.focusHolder.setFocusedElement($(this).data('focusid'));

                const dataToPost = {
                    __RequestVerificationToken: $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]')
                        .val(),
                    paymentSwitchId: $(this).data('payment-switch-id'),
                };
                const url = $(this).data('url');
                const paymentContentUrl = $(this).data('payment-content-url');

                $.ajax({
                    url: url,
                    type: 'POST',
                    cache: false,
                    dataType: 'json',
                    data: dataToPost,
                    success: function(result) {
                        if (result.isSuccess === true) {
                            $('#merged-payment-content').empty();
                            const isMonthly = paymentSwitchLinkId === 'monthly-switch-link';

                            $('#IsMonthlyPayment').val(isMonthly);
                            if (isMonthly) {
                                bgl.components.takepayment.monthlyinstalment.load(componentConfig,
                                    paymentContentUrl,
                                    'merged-payment-content',
                                    function() {
                                        $('#monthly-section').removeClass('hide');
                                        $('#annual-section').addClass('hide');

                                        bgl.common.pubsub.emit(
                                            'showNotification',
                                            $('#monthly-notification-message').val(),
                                        );
                                    });
                            } else {
                                bgl.components.takepayment.annual.load(componentConfig,
                                    paymentContentUrl,
                                    'merged-payment-content',
                                    function() {
                                        $('#monthly-section').addClass('hide');
                                        $('#annual-section').removeClass('hide');

                                        bgl.common.pubsub.emit(
                                            'showNotification',
                                            $('#annual-notification-message').val(),
                                        );
                                    });
                            }

                            bgl.common.pubsub.emit('switchPaymentType', isMonthly);
                        } else {
                            window.location.href = result.errorRedirectUrl;
                        }
                    },
                });
            });
    }

    return {
        init: initComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.mergedpaymentsummary;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.documentloader = (function() {
    let configuration;
    function initComponent(config) {
        configuration = config;
        $(document).ready(function() {
            getDocumentUrl();
        });
    }

    function getDocumentUrl() {
        $.get(configuration.TenantConfiguration.ApplicationPath + 'TakePaymentComponent/DocumentLoader',
            {name: 'credit-information'},
            function(result) {
                if (result.url) {
                    window.sessionStorage.setItem('credit-information', result.url);
                }
            });
    }

    return {
        init: initComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.documentloader;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.creditagreementacceptanceservice = (function() {
    function init(configuration) {
        const form = document.querySelector('[data-credit-agreement-acceptance-service-form]');

        if (form) {
            form.addEventListener('submit', function(e) {
                e.preventDefault();

                if (bgl.common.validator.isFormValid(e.target)) {
                    bgl.common.validator.submitForm(e.target, configuration);
                }
            });

            bgl.common.validator.init(form);
        }
    }

    function onSuccess() {
        bgl.common.utilities.refreshPage();
    }

    return {
        init: init,
        onSuccess: onSuccess,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.cardcaptureiframe = (function() {
    function loadIframe(iframeName, cardCaptureUri, secureSessionId, threeDSecureUri) {
        if ($('#Card-Capture-Iframe').length) {
            bgl.common.telemetry.logEvent('CardCaptureIframe exists');

            const form = $(`<form name="iFrameSecureSessionForm" 
                id="iFrameSecureSessionForm" 
                target="${iframeName}" 
                method="post" action="${cardCaptureUri}">
                    <input type="hidden" name="Id" id="Id" value="${secureSessionId}" />
                    <input type="hidden" name="ThreeDSecureUri" id="ThreeDSecureUri" value="${threeDSecureUri}" />
                </form>`);

            form.appendTo('body');

            const timeoutId = setTimeout(function() {
                bgl.common.telemetry.logException(new Error('iFrame took longer than 30 seconds to load'));
            }, 30000);

            const iframe = document.getElementById('Card-Capture-Iframe');

            iframe.onload = function() {
                bgl.common.telemetry.logEvent('Iframe loaded successfully');
                clearTimeout(timeoutId);
            };

            iframe.onerror = function() {
                bgl.common.telemetry.logException(new Error('Error loading iframe'));
            };

            form.submit();
            form.remove();
        } else {
            bgl.common.telemetry.logEvent('Card-Capture-Iframe does not exist. Iframe not loaded');
        }
    }

    function clearIframe() {
        $('#Card-Capture-Iframe').contents().find('body').empty();
    }

    return {
        loadIframe: loadIframe,
        clearIframe: clearIframe,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.cancellations = (function() {
    function init(componentConfiguration) {
        if (componentConfiguration) {
            if (componentConfiguration.MTACancelUrl) {
                sessionStorage.setItem('MTAStartPage', componentConfiguration.MTACancelUrl);
            }
        }
    }

    return {
        init: init,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.authenticationsignout = (function() {
    function initComponent() {
        subscribeToSignOutEvent();
    }

    function subscribeToSignOutEvent() {
        bgl.common.pubsub.on('CallAuthenticationSignOutInTakePayment', (signOutData) => {
            const signOutUrl = 'TakePaymentComponent/AuthenticationSignOut';
            const dataToPost = {
                __RequestVerificationToken: signOutData.RequestVerificationToken,
            };

            $.ajax({
                url: signOutData.ApplicationPath + signOutUrl,
                type: 'Post',
                data: dataToPost,
                dataType: 'json',
                success: () => {
                    if (signOutData.RedirectUrl) {
                        navigateWhenReadyTo(signOutData.RedirectUrl);
                    }
                },
            });
        });
    }

    function navigateWhenReadyTo(nextPage) {
        const twoSeconds = 2000;
        navigateTo(nextPage, theTimeRightNow() + twoSeconds);
    }

    function navigateTo(nextPage, timeoutTime) {
        if (hasTimeoutOccured(timeoutTime) || hasTagProcessingCompleted()) {
            window.location.href = nextPage;
        } else {
            setTimeout(navigateTo, 100, nextPage, timeoutTime);
        }
    }

    function theTimeRightNow() {
        return new Date().getTime();
    }

    function hasTimeoutOccured(timeoutTime) {
        return timeoutTime <= theTimeRightNow();
    }

    function hasTagProcessingCompleted() {
        return tagProcessingDone;
    }

    return {
        init: initComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.authenticationsignout;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.annualsummary = (function() {
    let componentConfig;
    let redirectInterval;
    let redirectTick = 0;
    const maxRedirectWait = 25;
    let requestVerificationToken;
    let isPaymentSuccessful = false;
    let componentConfiguration;
    let hideElementsWhen3DSecureIsDisplayedTimeout;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        componentConfiguration.CardSessionData = getTodaysPaymentSessionData();
        componentConfiguration.ContinuousPaymentCardSessionData = getContinuousPaymentCardSecureSessionData();

        const continuousPaymentCardEdit = sessionStorage.getItem('ContinuousPaymentCardEdit');
        componentConfiguration.ContinuousPaymentCardEdit = continuousPaymentCardEdit !== null ?
            continuousPaymentCardEdit :
            false;
        sessionStorage.setItem('ContinuousPaymentCardEdit', false);

        componentConfig = componentConfiguration;
        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
            });
    }

    function initComponent(configuration) {
        componentConfiguration = configuration;
        bgl.common.datastore.setupReadAndWrite();
        loadIframe();
        setupConfirmCheckbox();
        setupImportantInformation();
        populateBankAccountDetails();
        requestVerificationToken = $('input[name="__RequestVerificationToken"]').val();

        $('#Card-Capture-Iframe').on('load', function() {
            hideElementsWhen3DSecureIsDisplayed();
        });

        if (isSecondPaymentMethodRequired()) {
            if ($('#Direct-Debit-Form').length > 0) {
                initDirectDebit();
            }

            if ($('#Pay-Now-Button').length > 0) {
                $('#Pay-Now-Button').on('click',
                    function() {
                        const continuousPaymentPaymentType = sessionStorage.getItem('ContinuousPaymentPaymentType');

                        if (!$('#Read-Confirm-Checkbox').prop('checked')) {
                            $('#Read-Confirm-Container').addClass('error');
                        } else if (continuousPaymentPaymentType === 'CreditCard') {
                            commitPaymentAndBasket(true);
                        } else {
                            directDebitIsSelectedAndValid(continuousPaymentPaymentType);
                        }
                    });
            }
            setupContinuousPaymentCardEditLink();
        } else {
            $('#Pay-Now-Button').on('click',
                () => {
                    if (!$('#Read-Confirm-Checkbox').prop('checked')) {
                        $('#Read-Confirm-Container').addClass('error');
                    } else {
                        commitPaymentAndBasket(false);
                    }
                });
        }

        bgl.common.scrollDownBanner.init('scroll-prompt', 350);

        $('#Credit-Card-Selected-Person-Id').change(
            function() {
                initCardCapture();
            });
    }

    function initCardCapture() {
        sessionStorage.removeItem('ContinuousPaymentCardCaptureUri');
        sessionStorage.removeItem('ContinuousPaymentCardSecureSessionId');
        sessionStorage.removeItem('ContinuousPaymentCardThreeDSecureUri');

        if (hideElementsWhen3DSecureIsDisplayedTimeout) {
            clearTimeout(hideElementsWhen3DSecureIsDisplayedTimeout);
        }

        bgl.components.takepayment.cardcaptureiframe.clearIframe();

        componentConfiguration.CardSessionData = getTodaysPaymentSessionData();
        componentConfiguration.ContinuousPaymentCardSessionData = {
            'SelectedPersonId': $('#Credit-Card-Selected-Person-Id').val(),
        };

        const dataToPost = {
            __RequestVerificationToken: $('input[name=\'__RequestVerificationToken\']').val(),
            configuration: componentConfiguration,
        };

        $.ajax({
            url: componentConfiguration.TenantConfiguration.ApplicationPath +
                'TakePaymentComponent/InitialiseAnnualSummaryCardCapture',
            type: 'POST',
            data: dataToPost,
            success: function(data) {
                sessionStorage.setItem('ContinuousPaymentCardCaptureUri', data.cardCaptureUri);
                sessionStorage.setItem('ContinuousPaymentCardSecureSessionId', data.secureSessionId);
                sessionStorage.setItem('ContinuousPaymentCardThreeDSecureUri', data.threeDSecureUri);

                loadIframe();
            },
        });
    }

    function loadIframe() {
        const cardSessionData = getContinuousPaymentCardSecureSessionData();
        bgl.components.takepayment.cardcaptureiframe.loadIframe(
            'Card-Capture-Iframe',
            cardSessionData.CardCaptureUri,
            cardSessionData.SecureSessionId,
            cardSessionData.ThreeDSecureUri);
    }

    function directDebitIsSelectedAndValid(continuousPaymentPaymentType) {
        if (continuousPaymentPaymentType === 'DirectDebit' && $('#Direct-Debit-Form').length > 0) {
            isDirectDebitFormValid();
        }
    }

    function hideElementsWhen3DSecureIsDisplayed() {
        if ($('#Card-Capture-Iframe').contents().find('#continue').length === 0) {
            $('#Cardholder-Name-Form-Row').hide();
            $('#Monthly-Payment-DD-Label').hide();
            $('#Monthly-Payment-Card-Label').hide();
            scrollToCardPayment();
            return;
        }
        hideElementsWhen3DSecureIsDisplayedTimeout = setTimeout(function() {
            hideElementsWhen3DSecureIsDisplayed();
        }, 1000);
    }

    function scrollToCardPayment() {
        const requiredField = $('.card-payment');
        $('html,body').animate({scrollTop: requiredField.offset().top}, 0);
    }

    function isSecondPaymentMethodRequired() {
        const isContinuousPaymentCard = sessionStorage.getItem('IsContinuousPaymentCard');
        if (isContinuousPaymentCard !== 'False') {
            return false;
        }
        return true;
    }

    function initDirectDebit() {
        sortCodeAutoTab();
        setupDirectDebitSlideInPanel();
        bgl.common.validator.enableMaxLength();
        setupDirectDebitFormValidation();
        setupTabOffAuthoriseDirectDebitButtons();
    }

    function setupTabOffAuthoriseDirectDebitButtons() {
        $('#Direct-Debit-Authorise-Row label').on('click',
            function() {
                $('#' + $(this).attr('for')).click().focusout();
            });
    }

    function setupDirectDebitSlideInPanel() {
        $('#direct-debit-details').on('click',
            function() {
                waitForSlidePanelToLoad();
            });
    }

    function setupDirectDebitFormValidation() {
        bgl.common.validator.init($('#Direct-Debit-Form'),
            {
                onfocusout: function(element) {
                    $(element).valid();
                    checkSortcodeValidation(element);
                    checkAccountNumberValidation(element);
                },
                hasSubmit: false,
            });
    }

    function isDirectDebitFormValid() {
        if (!$('#Direct-Debit-Form').valid()) {
            checkSortcodeValidation($('#SortCodePart1'));
        } else {
            validateBankAccountAndSortCode();
            saveDataToSessionStorage();
        }
    }

    function setupContinuousPaymentCardEditLink() {
        if ($('#Edit-Card-Link').length > 0) {
            $('#Edit-Card-Link').on('click',
                function() {
                    sessionStorage.setItem('ContinuousPaymentCardEdit', true);
                    location.reload();
                });
        }
    }

    function setupImportantInformation() {
        $(`#importantInfo-payments-annual, 
            #importantInfo-bottom, 
            #moreInfo-payments, 
            #intermediary-services-contract-summary-slider-link, 
            #intermediary-services-contract-summary-slider-link-read-confirm`).off('click').on('click',
            function(event) {
                event.preventDefault();
                const link = $(this);
                bgl.common.loader.load({}, link.data('action-url'), link.data('container'));
            });
    }

    function setupConfirmCheckbox() {
        $('#Read-Confirm-Checkbox').on('click',
            function() {
                if ($('#Read-Confirm-Checkbox').prop('checked')) {
                    $('#Read-Confirm-Container').removeClass('error');
                }
            });
    }

    function commitPaymentAndBasket(commitMultiplePayment) {
        const postMethod = commitMultiplePayment ? 'CommitMultiplePaymentBasket' : 'CommitSinglePaymentBasket';

        const dataToPost = {
            __RequestVerificationToken: requestVerificationToken,
            commitData: commitMultiplePayment ? getCommitMultiplePaymentData() : getCommitCardData(),
        };

        $('body').html(bgl.common.spinner.getSpinnerBody('Processing your payment!',
            'Please do not hit the back button or refresh the page'));

        const urlPrefix = componentConfig.TenantConfiguration.ApplicationPath !== null ?
            componentConfig.TenantConfiguration.ApplicationPath :
            '/';

        $.ajax({
            url: urlPrefix + 'TakePaymentComponent/' + postMethod,
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (result.isSuccess === false) {
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                    return;
                }
                if (result.PaymentSuccessful === true) {
                    if (typeof bgl.common.pubsub !== 'undefined') {
                        bgl.common.pubsub.emit('fakeFormSubmit', 'PaymentSuccessful');
                    }
                    dataLayerPushPaymentSuccessful();
                    bgl.common.telemetry.logEvent(
                        'PaymentSuccessful',
                        {'PolicyId': result.PolicyId});
                    isPaymentSuccessful = true;

                    if (result.PolicyId) {
                        const stringValue = result.PolicyId + '';
                        let length = stringValue.indexOf('-');
                        length = length > 0 ? length : stringValue.length;
                        sessionStorage.setItem('PaymentProcessedPolicyId', stringValue.substring(0, length));
                        sessionStorage.setItem('Authorization', result.Authorization);
                    }
                }

                bgl.common.telemetry.logEvent(
                    'IsPaymentSucessful',
                    {'isPaymentSuccessful': result.PaymentSuccessful},
                );

                sessionStorage.setItem('PaymentProcessedRedirectUrl', result.RedirectUrl);

                bgl.common.telemetry.logEvent(
                    'RedirectUrl',
                    {'RedirectUrl': result.RedirectUrl},
                );
            },
            complete: function() {
                redirectInterval = setInterval(checkAiComplete, 200);
            },
        });
    }

    function getCommitMultiplePaymentData() {
        const model = {};
        model.TodaysPaymentCard = getTodaysPaymentCardData();
        model.ContinuousPaymentCard = getContinuousPaymentCardData();
        model.ContinuousPaymentDirectDebit = getDirectDebitData();
        model.PaymentType = sessionStorage.getItem('ContinuousPaymentPaymentType');
        model.PaymentDeclinedUrl = componentConfig.PaymentDeclinedUrl;
        model.ComponentConfiguration = componentConfig;
        return model;
    }

    function getTodaysPaymentCardData() {
        const model = {};
        model.SelectedPersonIdText = sessionStorage.getItem('AnnualSelectedPersonIdText');
        model.CardCaptureUri = sessionStorage.getItem('AnnualCardCaptureUri');
        model.SecureSessionId = sessionStorage.getItem('AnnualSecureSessionId');
        model.SelectedPersonIdVal = sessionStorage.getItem('AnnualSelectedPersonIdVal');
        return model;
    }

    function getContinuousPaymentCardData() {
        const model = {};
        model.SelectedPersonIdText = sessionStorage.getItem('ContinuousPaymentCardSelectedPersonIdText');
        model.CardCaptureUri = sessionStorage.getItem('ContinuousPaymentCardCaptureUri');
        model.SecureSessionId = sessionStorage.getItem('ContinuousPaymentCardSecureSessionId');
        model.SelectedPersonIdVal = sessionStorage.getItem('ContinuousPaymentCardSelectedPersonIdVal');
        return model;
    }

    function getDirectDebitData() {
        const model = {};
        model.SelectedPersonIdText = sessionStorage.getItem('ContinuousPaymentDirectDebitSelectedPersonIdText');
        model.SelectedPersonIdVal = sessionStorage.getItem('ContinuousPaymentDirectDebitSelectedPersonIdVal');
        model.AccountNumber = sessionStorage.getItem('ContinuousPaymentDirectDebitAccountNumber');
        model.SortCode = buildSortCode();
        return model;
    }

    function buildSortCode() {
        if (sessionStorage.getItem('ContinuousPaymentDirectDebitSortCodePart1') !== null &&
      sessionStorage.getItem('ContinuousPaymentDirectDebitSortCodePart2') !== null &&
      sessionStorage.getItem('ContinuousPaymentDirectDebitSortCodePart3') !== null) {
            return sessionStorage.getItem('ContinuousPaymentDirectDebitSortCodePart1') +
        sessionStorage.getItem('ContinuousPaymentDirectDebitSortCodePart2') +
        sessionStorage.getItem('ContinuousPaymentDirectDebitSortCodePart3');
        }
        return null;
    }

    function checkAiComplete() {
        if (sessionStorage.getItem('AI_sentBuffer') === '[]' || redirectTick >= maxRedirectWait) {
            clearInterval(redirectInterval);
            if (isPaymentSuccessful) {
                bgl.common.utilities.redirectToUrl(componentConfig.PaymentSuccessfulUrl);
            } else {
                bgl.common.utilities.redirectToUrl(sessionStorage.getItem('PaymentProcessedRedirectUrl'));
                bgl.common.telemetry.logEvent(
                    'RedirectUrlAfterFailedPayment',
                    {'RedirectUrlAfterFailedPayment': sessionStorage.getItem('PaymentProcessedRedirectUrl')},
                );
            }
        }
        redirectTick += 1;
    }

    function getCommitCardData() {
        const model = {};
        model.TodaysPaymentCard = getTodaysPaymentCardData();
        model.PaymentDeclinedUrl = componentConfig.PaymentDeclinedUrl;
        model.ComponentConfiguration = componentConfig;
        return model;
    }

    function getTodaysPaymentSessionData() {
        return {
            'Name': sessionStorage.getItem('AnnualSelectedPersonIdText'),
            'CardCaptureUri': sessionStorage.getItem('AnnualCardCaptureUri'),
            'SecureSessionId': sessionStorage.getItem('AnnualSecureSessionId'),
            'SelectedPersonId': sessionStorage.getItem('AnnualSelectedPersonIdVal'),
            'ThreeDSecureUri': sessionStorage.getItem('AnnualThreeDSecureUri'),
        };
    }

    function getContinuousPaymentCardSecureSessionData() {
        return {
            'Name': sessionStorage.getItem('ContinuousPaymentCardSelectedPersonIdText'),
            'CardCaptureUri': sessionStorage.getItem('ContinuousPaymentCardCaptureUri'),
            'SecureSessionId': sessionStorage.getItem('ContinuousPaymentCardSecureSessionId'),
            'SelectedPersonId': sessionStorage.getItem('ContinuousPaymentCardSelectedPersonIdVal'),
            'ThreeDSecureUri': sessionStorage.getItem('ContinuousPaymentCardThreeDSecureUri'),
        };
    }

    function dataLayerPushPaymentSuccessful() {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                'event': 'TEVirtualPageview',
                'virtualPageURL': 'Payment/Successful',
                'virtualPageTitle': 'Payment Successful',
            });
        }
    }

    function checkSortcodeValidation(element) {
        removeApiValidationErrorMessage(element);
        validateIndividualSortCodeInput(element);
        clearValidationErrorStylingWhenAllSortCodeInputsAreValid();
    }

    function removeApiValidationErrorMessage(element) {
        if ($(element).hasClass('form-row__input--sort-code') &&
            !$('#sortcode-api-validation-message').hasClass('hide')) {
            removeSortCodeErrorStyle();
        }
    }

    function validateIndividualSortCodeInput(element) {
        if ($(element).valid()) {
            $(element).removeClass('sort-code__input--error');
        } else {
            addIndividualSortCodeErrorStyle(element);
        }
        $('#form-row-sortcode1').removeClass('error');
    }

    function clearValidationErrorStylingWhenAllSortCodeInputsAreValid() {
        const allSortCodeInputsValid = checkAllSortCodeInputsAreValid();
        if (allSortCodeInputsValid) {
            $('#SortCodeLabel').removeClass('sort-code__label--error');
            $('#sortcode-validation-text').addClass('hide');
        }
    }

    function checkAllSortCodeInputsAreValid() {
        let allSortCodeInputsValid = true;

        $('.form-row__input--sort-code').each(function() {
            if ($(this).hasClass('sort-code__input--error')) {
                allSortCodeInputsValid = false;
            }
        });

        return allSortCodeInputsValid;
    }

    function sortCodeKeyUpEvent(event, currentSortCodePart, nextSortCodePart) {
        const TAB_KEYCODE = 9;
        const SHIFT_KEYCODE = 16;
        const LEFT_ARROW_KEYCODE = 37;
        const UP_ARROW_KEYCODE = 38;
        const RIGHT_ARROW_KEYCODE = 39;
        const DOWN_ARROW_KEYCODE = 40;

        const currentLength = $(currentSortCodePart).val().length;
        if (currentLength === 2 &&
      event.which !== TAB_KEYCODE &&
      event.which !== SHIFT_KEYCODE &&
      event.which !== LEFT_ARROW_KEYCODE &&
      event.which !== UP_ARROW_KEYCODE &&
      event.which !== RIGHT_ARROW_KEYCODE &&
      event.which !== DOWN_ARROW_KEYCODE) {
            $(nextSortCodePart).focus().select();
        }
    }

    function sortCodeAutoTab() {
        const container1 = document.getElementById('SortCodePart1');
        const container2 = document.getElementById('SortCodePart2');

        container1.onkeyup = function(e) {
            sortCodeKeyUpEvent(e, '#SortCodePart1', '#SortCodePart2');
        };

        container2.onkeyup = function(e) {
            sortCodeKeyUpEvent(e, '#SortCodePart2', '#SortCodePart3');
        };
    }

    function waitForSlidePanelToLoad() {
        window.setTimeout(function() {
            if ($('#SlidePanel').hasClass('active')) {
                const directDebitDetails = $('#direct-debit-info').html();
                $('#SlidePanelContent').html(directDebitDetails);
            } else {
                waitForSlidePanelToLoad();
            }
        },
        100);
    }

    function saveDataToSessionStorage() {
        const model = {
            sortCode: document.getElementById('SortCodePart1').value +
                document.getElementById('SortCodePart2').value +
                document.getElementById('SortCodePart3').value,
            accountNumber: document.getElementById('direct-debit-account-number').value,
        };

        const dataToPost = {
            __RequestVerificationToken: document.querySelector('input[name="__RequestVerificationToken"]').value,
            BankAccountAndSortCodeModel: model,
            encryptData: true,
        };

        $.ajax({
            url: componentConfig.TenantConfiguration.ApplicationPath +
                'TakePaymentComponent/AccountDetailsCryptography',
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (!result.isSuccess) {
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                    return false;
                }
                sessionStorage.setItem('AnnualSummaryDetails1', result.accountNumber);
                sessionStorage.setItem('AnnualSummaryDetails2', result.sortCode);
                return true;
            },
        });
    }

    function populateBankAccountDetails() {
        const bankAccountNumberEn = sessionStorage.getItem('AnnualSummaryDetails1');
        const sortCodeEn = sessionStorage.getItem('AnnualSummaryDetails2');
        if (bankAccountNumberEn != null || sortCodeEn != null) {
            const model = {
                sortCode: sortCodeEn,
                accountNumber: bankAccountNumberEn,
            };
            const dataToPost = {
                __RequestVerificationToken: document.querySelector('input[name="__RequestVerificationToken"]').value,
                BankAccountAndSortCodeModel: model,
                encryptData: false,
            };

            $.ajax({
                url: componentConfig.TenantConfiguration.ApplicationPath +
                    'TakePaymentComponent/AccountDetailsCryptography',
                type: 'POST',
                cache: false,
                dataType: 'json',
                data: dataToPost,
                success: function(result) {
                    if (!result.isSuccess) {
                        bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                        return false;
                    }
                    document.getElementById('direct-debit-account-number').value = result.accountNumber;
                    const sortCode = result.sortCode;
                    document.getElementById('SortCodePart1').value = sortCode.substring(0, 2);
                    document.getElementById('SortCodePart2').value = sortCode.substring(2, 4);
                    document.getElementById('SortCodePart3').value = sortCode.substring(4, 6);
                    return true;
                },
            });
        }
        return false;
    }

    function validateBankAccountAndSortCode() {
        const dataToPost = {
            __RequestVerificationToken: document.querySelector('input[name="__RequestVerificationToken"]').value,
            sortCode: document.getElementById('SortCodePart1').value +
                document.getElementById('SortCodePart2').value +
                document.getElementById('SortCodePart3').value,
            accountNumber: document.getElementById('direct-debit-account-number').value,
        };
        $.ajax({
            url: componentConfig.TenantConfiguration.ApplicationPath +
                'TakePaymentComponent/PostAccountNumberAndSortCode',
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (!result.isSuccess) {
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                    return false;
                }

                switch (result.Result) {
                case 'Validated':
                    removeSortCodeErrorStyle();
                    removeAccountErrorStyle();
                    commitPaymentAndBasket(true);
                    return true;
                case 'no values submitted':
                case 'sort code or account number invalid':
                    addAccountErrorStyle();
                    addSortCodeErrorStyle();
                    break;
                case 'sortCode invalid':
                    addSortCodeErrorStyle();
                    break;
                case 'accountNumber invalid':
                    addAccountErrorStyle();
                    break;
                }

                return false;
            },
        });
    }

    function removeSortCodeErrorStyle() {
        $('#sortcode-api-validation-message').addClass('hide');
        $('#SortCodeLabel').removeClass('sort-code__label--error');
        $('#sortcode-api-validation-message').removeClass('sort-code__span--error');
        $('#SortCodePart1,#SortCodePart2,#SortCodePart3').removeClass('sort-code__input--error');
        cleanAriaDescribedBy('#SortCodePart1');
    }

    function addSortCodeErrorStyle() {
        $('#sortcode-api-validation-message').removeClass('hide');
        $('#SortCodeLabel').addClass('sort-code__label--error');
        $('#sortcode-api-validation-message').addClass('sort-code__span--error');
        $('#SortCodePart1,#SortCodePart2,#SortCodePart3').addClass('sort-code__input--error');
    }

    function addAccountErrorStyle() {
        $('#account-number-validation-message').removeClass('hide');
        $('#AccountNumberLabel').addClass('sort-code__label--error');
        $('#account-number-validation-message').addClass('sort-code__span--error');
        $('#direct-debit-account-number').addClass('sort-code__input--error');
    }

    function removeAccountErrorStyle() {
        $('#account-number-validation-message').addClass('hide');
        $('#AccountNumberLabel').removeClass('sort-code__label--error');
        $('#account-number-validation-message').removeClass('sort-code__span--error');
        $('#direct-debit-account-number').removeClass('sort-code__input--error');
        cleanAriaDescribedBy('#direct-debit-account-number');
    }

    function cleanAriaDescribedBy(element) {
        if ($(element).attr('aria-describedby')) {
            $(element).removeAttr('aria-describedby');
        }
    }

    function addIndividualSortCodeErrorStyle(element) {
        $('#SortCodeLabel').addClass('sort-code__label--error');
        $('#sortcode-validation-text').removeClass('hide');
        $(element).addClass('sort-code__input--error');
    }

    function checkAccountNumberValidation(element) {
        let isValid = false;

        if ($(element).hasClass('form-row__input account-number sort-code__input--error')) {
            $('#account-number-validation-message').addClass('hide');
        }

        if ($(element).hasClass('form-row__input account-number')) {
            isValid = $('#direct-debit-account-number').valid();
        }

        if (isValid) {
            removeAccountErrorStyle();
        }
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.annualsummary;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.annual = (function() {
    let componentConfiguration;
    let hideElementsWhen3DSecureIsDisplayedTimeout;

    function loadComponent(componentConfiguration, componentUrl, containerElementId, callback) {
        componentConfiguration.CardSessionData = getSecureSessionData();
        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);

                if (typeof callback === 'function') {
                    callback();
                }
            });
    }

    function initComponent(configuration) {
        componentConfiguration = configuration;

        bgl.common.datastore.setupReadAndWrite();

        loadIframe();

        setVisibilityOfCardholderNameOther();

        bgl.common.validator.enableMaxLength();

        $('#AnnualPaymentForm').off('submit').on('submit',
            function(e) {
                e.preventDefault();
            });

        bgl.common.validator.init($('#AnnualPaymentForm'),
            {
                onkeyup: function(element) {
                    validateElementAndToggleIframe(element);
                },
                hasSubmit: false,
            });

        $('#Card-Capture-Iframe').on('load',
            function() {
                hideElementsWhen3DSecureIsDisplayed();
            });

        $('#PersonListData_SelectedPersonId').change(
            function() {
                if (isOtherSelected()) {
                    $('#CardholderNameRow').removeClass('hide');
                    $('#Card-Capture-Iframe').addClass('hide');
                    sessionStorage.setItem('AnnualSelectedPersonIdText', '');
                    $('#CardholderName').val('');
                    $('#CardholderName').focus();
                } else {
                    $('#CardholderNameRow').addClass('hide');
                    $('#Card-Capture-Iframe').removeClass('hide');
                }

                initCardCapture();
            });

        if (isOtherSelected()) {
            validateElementAndToggleIframe($('#AnnualPaymentForm'));
        }
    }

    function initCardCapture() {
        sessionStorage.removeItem('AnnualCardCaptureUri');
        sessionStorage.removeItem('AnnualSecureSessionId');
        sessionStorage.removeItem('AnnualThreeDSecureUri');

        if (hideElementsWhen3DSecureIsDisplayedTimeout) {
            clearTimeout(hideElementsWhen3DSecureIsDisplayedTimeout);
        }

        bgl.components.takepayment.cardcaptureiframe.clearIframe();

        componentConfiguration.CardSessionData = {'SelectedPersonId': $('#PersonListData_SelectedPersonId').val()};

        const dataToPost = {
            __RequestVerificationToken: $('input[name=\'__RequestVerificationToken\']').val(),
            configuration: componentConfiguration,
        };

        $.ajax({
            url: componentConfiguration.TenantConfiguration.ApplicationPath +
                'TakePaymentComponent/InitialiseAnnualCardCapture',
            type: 'POST',
            data: dataToPost,
            success: function(data) {
                sessionStorage.setItem('AnnualCardCaptureUri', data.cardCaptureUri);
                sessionStorage.setItem('AnnualSecureSessionId', data.secureSessionId);
                sessionStorage.setItem('AnnualThreeDSecureUri', data.threeDSecureUri);

                loadIframe();
            },
        });
    }

    function loadIframe() {
        const cardSessionData = getSecureSessionData();
        bgl.components.takepayment.cardcaptureiframe.loadIframe(
            'Card-Capture-Iframe',
            cardSessionData.CardCaptureUri,
            cardSessionData.SecureSessionId,
            cardSessionData.ThreeDSecureUri);
    }

    function validateElementAndToggleIframe(element) {
        const valid = $(element).valid();
        if (valid === true) {
            $('#Card-Capture-Iframe').removeClass('hide');
        } else {
            $('#Card-Capture-Iframe').addClass('hide');
        }
    }

    function isOtherSelected() {
        return $('#PersonListData_SelectedPersonId').find(':selected').text() === 'Other';
    }

    function getSecureSessionData() {
        return {
            'Name': sessionStorage.getItem('AnnualSelectedPersonIdText'),
            'CardCaptureUri': sessionStorage.getItem('AnnualCardCaptureUri'),
            'SecureSessionId': sessionStorage.getItem('AnnualSecureSessionId'),
            'SelectedPersonId': sessionStorage.getItem('AnnualSelectedPersonIdVal'),
            'ThreeDSecureUri': sessionStorage.getItem('AnnualThreeDSecureUri'),
        };
    }

    function setVisibilityOfCardholderNameOther() {
        if ($('#PersonListData_SelectedPersonId').find(':selected').text() === 'Other') {
            $('#CardholderNameRow').removeClass('hide');
            $('#CardholderName').focus();
        }
    }

    function hideElementsWhen3DSecureIsDisplayed() {
        if ($('#Card-Capture-Iframe').contents().find('#continue').length === 0) {
            $('#AnnualCardholderNameFormRow').hide();
            $('#CardholderNameRow').hide();
            scrollToCardPayment();
            return;
        }

        hideElementsWhen3DSecureIsDisplayedTimeout = setTimeout(function() {
            hideElementsWhen3DSecureIsDisplayed();
        }, 1000);
    }

    function scrollToCardPayment() {
        const requiredField = $('.card-payment');
        $('html,body').animate({scrollTop: requiredField.offset().top}, 0);
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.alldone = (function() {
    function initComponent(policyFieldId) {
        const policyId = sessionStorage.getItem('PaymentProcessedPolicyId');

        $('#' + policyFieldId).text(policyId);

        clearSomeKeysFromSessionStorage();


        sessionStorage.removeItem('PaymentProcessedPolicyId');
    }

    function clearSomeKeysFromSessionStorage() {
        const keysToRemove = [
            '3dSecureTimeoutId',
            'ActiveTab',
            'AddPaymentCardCaptureUri',
            'AddPaymentCreditCardSelectedPersonId',
            'AddPaymentCreditCardSelectedPersonIdText',
            'AddPaymentCreditCardSelectedPersonIdVal',
            'AddPaymentDirectDebitAccountNumber',
            'AddPaymentDirectDebitSelectedPersonId',
            'AddPaymentDirectDebitSelectedPersonIdText',
            'AddPaymentDirectDebitSelectedPersonIdVal',
            'AddPaymentDirectDebitSortCodePart1',
            'AddPaymentDirectDebitSortCodePart2',
            'AddPaymentDirectDebitSortCodePart3',
            'AddPaymentDirectDebitAuthorise',
            'AddPaymentMethodCardCaptureUri',
            'AddPaymentMethodSecureSessionId',
            'AddPaymentSecureSessionId',
            'AnnualCardCaptureUri',
            'AnnualSecureSessionId',
            'AnnualSelectedPersonIdText',
            'ContinuousPaymentCardCaptureUri',
            'ContinuousPaymentCardEdit',
            'ContinuousPaymentCardSecureSessionId',
            'credit-information',
            'MonthlyDepositSelectedPersonIdText',
            'MTAStartPage',
            'OneOffPaymentSelectedPersonIdText',
            'OneOffPaymentCardCaptureUri',
            'OneOffPaymentSecureSessionId',
            'OneOffPaymentSelectedPersonIdVal',
            'OneOffPaymentSelectedPersonId',
            'PaymentProcessedPolicyId',
            'PaymentProcessedRedirectUrl',
            'UseMonthlyInstalmentCard',
        ];

        keysToRemove.forEach(function(key) {
            window.sessionStorage.removeItem(key);
        });
    }

    return {
        init: initComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.addpaymentmethodconfirmation = (function() {
    let componentConfig;
    let requestVerificationToken;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        componentConfiguration.CardSessionData = getTodaysPaymentSessionData();
        componentConfiguration.ContinuousPaymentCardSessionData = getContinuousPaymentCardSecureSessionData();

        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
            });
    }

    function initComponent(componentConfiguration) {
        requestVerificationToken = $('input[name="__RequestVerificationToken"]').val();
        componentConfig = componentConfiguration;
        bgl.common.datastore.setupReadAndWrite();
        if (window.sessionStorage.getItem('ActiveTab') === 'BankAccount') {
            populateBankAccountDetails();
        } else {
            const cardHolderName = sessionStorage.getItem('AddPaymentDirectDebitSelectedPersonIdText');
            $('#Account-Holder-Name strong').text(cardHolderName);
        }

        $('#Confirm-Direct-Debit-Details').off().on('click',
            function() {
                commitDirectDebitPayment();
            });
        $('#Confirm-Credit-Card-Details').off().on('click',
            function() {
                commitCreditCardPayment();
            });

        $('#Edit-Direct-Debit-Details,#Back-To-Edit-Direct-Debit-Details').on('click',
            function() {
                backToAddPaymentMethod();
            });
        bgl.common.pubsub.on('session:end', function() {
            cleanUpSessionStorage();
        });
    }

    function cleanUpSessionStorage() {
        const keysToRemove = ['AddPaymentDirectDebitAccountNumber',
            'AddPaymentDirectDebitSortCodePart1',
            'AddPaymentDirectDebitSortCodePart2',
            'AddPaymentDirectDebitSortCodePart3',
            'AddPaymentDirectDebitAuthorise',
            'OneOffPaymentSelectedPersonIdText',
            'OneOffPaymentCardCaptureUri',
            'OneOffPaymentSecureSessionId',
            'OneOffPaymentSelectedPersonIdVal',
            'OneOffPaymentSelectedPersonId',
        ];

        keysToRemove.forEach(function(key) {
            window.sessionStorage.removeItem(key);
        });
    }

    function populateBankAccountDetails() {
        const bankAccountNumberEn = sessionStorage.getItem('AddPaymentMethodDetails1');
        const sortCodeEn = sessionStorage.getItem('AddPaymentMethodDetails2');
        const accountHolderName = sessionStorage.getItem('AddPaymentDirectDebitSelectedPersonIdText');
        $('#Account-Holder-Name strong').text(accountHolderName);
        if (bankAccountNumberEn != null && sortCodeEn != null) {
            const model = {
                sortCode: sortCodeEn,
                accountNumber: bankAccountNumberEn,
            };
            const dataToPost = {
                __RequestVerificationToken: requestVerificationToken,
                BankAccountAndSortCodeModel: model,
                encryptData: false,
            };
            $.ajax({
                url: componentConfig.TenantConfiguration.ApplicationPath +
                    'TakePaymentComponent/AccountDetailsCryptography',
                type: 'POST',
                cache: false,
                dataType: 'json',
                data: dataToPost,
                success: function(result) {
                    if (result.isSuccess === false) {
                        bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                        return false;
                    }
                    const visibleAccountNumber = result.accountNumber;
                    $('#Sort-Code strong').text(result.sortCode);
                    $('#Account-Number').text(visibleAccountNumber);
                    return true;
                },
            });
        }
        return true;
    }

    function commitDirectDebitPayment() {
        const dataToPost = {
            __RequestVerificationToken: requestVerificationToken,
            addDirectDebitViewModel: getCommitDirectDebitData(),
        };

        $.ajax({
            url: componentConfig.TenantConfiguration.ApplicationPath +
                'TakePaymentComponent/CommitNewDirectDebitPaymentMethod',
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                cleanUpSessionStorage();
                if (result.isSuccess === false) {
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                    return false;
                }
                logPaymentMethodChange('Direct Debit');
                bgl.common.pubsub.emit('PollBasket',
                    {
                        hideNotification: true,
                        callback: function() {
                            bgl.components.takepayment.addpaymentmethodconfirmation
                                .commitBasketCallback(result.accountId);
                        },
                    });
                return true;
            },
        });
    }

    function commitCreditCardPayment() {
        const dataToPost = {
            __RequestVerificationToken: requestVerificationToken,
            commitCreditCardViewModel: getCommitCreditCardData(),
        };

        $.ajax({
            url: componentConfig.TenantConfiguration.ApplicationPath +
                'TakePaymentComponent/CommitNewCreditCardPaymentMethod',
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (result.isSuccess === false) {
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                    return false;
                }
                logPaymentMethodChange('Card');
                bgl.common.pubsub.emit('PollBasket',
                    {
                        hideNotification: true,

                        callback: function() {
                            bgl.components.takepayment.addpaymentmethodconfirmation
                                .commitBasketCallback(result.accountId);
                        },
                    });
                return true;
            },
        });
    }

    function commitBasketCallback(accountId) {
        const dataToPost = {
            __RequestVerificationToken: requestVerificationToken,
            nominatedAccountId: accountId,
        };

        $.ajax({
            url: componentConfig.TenantConfiguration.ApplicationPath +
                'TakePaymentComponent/CommitBasketUpdatedPaymentMethod',
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (result.isSuccess === false) {
                    window.location.href = result.errorRedirectUrl;
                    return false;
                }
                if (result.viewOptions === 'PaymentStatus') {
                    window.location.href = componentConfig.PaymentStatusUrl;
                } else if (result.viewOptions === 'PaymentMethodAllDone') {
                    window.location.href = componentConfig.PaymentMethodAllDoneUrl;
                }
                return true;
            },
        });
    }

    function logPaymentMethodChange(newPaymentMethod) {
        sessionStorage.setItem('PaymentUpdated', newPaymentMethod);
    }

    function backToAddPaymentMethod() {
        bgl.common.utilities.redirectToUrl(componentConfig.RedirectUrl);
    }

    function getCommitDirectDebitData() {
        const model = {};
        const commitDirectDebitData = {};
        commitDirectDebitData.SelectedPersonIdVal = sessionStorage.getItem('AddPaymentDirectDebitSelectedPersonIdVal');
        commitDirectDebitData.AccountNumber = $('#Account-Number').text();
        commitDirectDebitData.SortCode = $('#Sort-Code').text().replace(/ /g, '');
        model.ComponentConfiguration = componentConfig;
        model.CommitDirectDebitData = commitDirectDebitData;
        return model;
    }

    function getCommitCreditCardData() {
        const model = {};

        model.SecureSessionId = sessionStorage.getItem('AddPaymentMethodSecureSessionId');
        model.SelectedPersonIdText = sessionStorage.getItem('AddPaymentDirectDebitSelectedPersonIdText');
        model.SelectedPersonIdVal = sessionStorage.getItem('AddPaymentCreditCardSelectedPersonId');
        return model;
    }

    function getTodaysPaymentSessionData() {
        return {
            'Name': sessionStorage.getItem('AddPaymentSelectedPersonIdText'),
            'CardCaptureUri': sessionStorage.getItem('AddPaymentMethodCardCaptureUri'),
            'SecureSessionId': sessionStorage.getItem('AddPaymentMethodSecureSessionId'),

        };
    }

    function getContinuousPaymentCardSecureSessionData() {
        return {
            'Name': sessionStorage.getItem('ContinuousPaymentCardSelectedPersonIdText'),
            'CardCaptureUri': sessionStorage.getItem('AddPaymentMethodCardCaptureUri'),
            'SecureSessionId': sessionStorage.getItem('AddPaymentMethodSecureSessionId'),
        };
    }

    return {
        init: initComponent,
        load: loadComponent,
        commitBasketCallback: commitBasketCallback,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.addpaymentmethodconfirmation;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.addpaymentmethod = (function() {
    let componentConfiguration = {};

    function loadComponent(componentConfig, componentUrl, containerElementId) {
        componentConfig.CardSessionData = getTodaysPaymentSessionData();
        componentConfig.ContinuousPaymentCardSessionData = getContinuousPaymentCardSecureSessionData();

        bgl.common.loader.load(componentConfig,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfig);
            });
    }

    function initComponent(componentConfig) {
        componentConfiguration = componentConfig;
        sortCodeAutoTab();
        initDirectDebit();
        initCreditCard();
        onCreditCardTabClick();
        onDirectDebitTabClick();
        bgl.common.datastore.setupReadAndWrite();
        populateBankAccountDetails();
        loadIframe();

        window.sessionStorage.setItem('ActiveTab', 'BankAccount');

        bgl.common.pubsub.on('session:end',
            function() {
                const keysToRemove = [
                    'AddPaymentDirectDebitAccountNumber',
                    'AddPaymentDirectDebitSortCodePart1',
                    'AddPaymentDirectDebitSortCodePart2',
                    'AddPaymentDirectDebitSortCodePart3',
                    'AddPaymentDirectDebitAuthorise',
                    'OneOffPaymentSelectedPersonIdText',
                    'OneOffPaymentCardCaptureUri',
                    'OneOffPaymentSecureSessionId',
                    'OneOffPaymentSelectedPersonIdVal',
                    'OneOffPaymentSelectedPersonId',
                ];

                keysToRemove.forEach(function(key) {
                    window.sessionStorage.removeItem(key);
                });
            });
    }

    function initCardCapture() {
        sessionStorage.removeItem('AddPaymentMethodCardCaptureUri');
        sessionStorage.removeItem('AddPaymentMethodSecureSessionId');
        sessionStorage.removeItem('AddPaymentMethodThreeDSecureUri');

        bgl.components.takepayment.cardcaptureiframe.clearIframe();

        componentConfiguration.CardSessionData = {'SelectedPersonId': $('#Credit-Card-Selected-Person-Id').val()};

        const dataToPost = {
            __RequestVerificationToken: $('input[name=\'__RequestVerificationToken\']').val(),
            configuration: componentConfiguration,
        };

        $.ajax({
            url: componentConfiguration.TenantConfiguration.ApplicationPath +
                'TakePaymentComponent/InitialiseAddPaymentMethodCardCapture',
            type: 'POST',
            data: dataToPost,
            success: function(data) {
                sessionStorage.setItem('AddPaymentMethodCardCaptureUri', data.cardCaptureUri);
                sessionStorage.setItem('AddPaymentMethodSecureSessionId', data.secureSessionId);
                sessionStorage.setItem('AddPaymentMethodThreeDSecureUri', data.threeDSecureUri);

                loadIframe();
            },
        });
    }

    function loadIframe() {
        const cardSessionData = getTodaysPaymentSessionData();

        bgl.components.takepayment.cardcaptureiframe.loadIframe(
            'Card-Capture-Iframe',
            cardSessionData.CardCaptureUri,
            cardSessionData.SecureSessionId,
            cardSessionData.ThreeDSecureUri);
    }

    function onCreditCardTabClick() {
        $('#credit-card').on('click',
            function() {
                $('#section2').removeClass('hide')
                    .addClass('active')
                    .attr('display', 'none');

                $('#section1').removeClass('active')
                    .addClass('hide');

                $('#Credit-Card-Tab-Button').addClass('active');
                $('#Direct-Debit-Tab-Button').removeClass('active');
                window.sessionStorage.setItem('ActiveTab', 'Card');
            });
    }

    function onDirectDebitTabClick() {
        $('#direct-debit').on('click',
            function() {
                $('#section2').removeClass('active')
                    .addClass('hide')
                    .attr('display', 'block');

                $('#section1').removeClass('hide')
                    .addClass('active');

                $('#Credit-Card-Tab-Button').removeClass('active');
                $('#Direct-Debit-Tab-Button').addClass('active');
                window.sessionStorage.setItem('ActiveTab', 'BankAccount');
            });
    }

    function initCreditCard() {
        $('#Credit-Card-Selected-Person-Id').change(
            function() {
                initCardCapture();
            });
    }

    function initDirectDebit() {
        bgl.common.validator.enableMaxLength();

        bgl.common.validator.init($('#Direct-Debit-Form'),
            {
                onfocusout: function(element) {
                    checkSortcodeValidation(element);
                    checkAccountNumberValidation(element);
                },
                hasSubmit: false,
            });

        $('#Direct-Debit-Authorise-Row label').on('click',
            function() {
                $('#' + $(this).attr('for')).click().focusout();
            });

        $('#Direct-Debit-Continue-Button').off().on('click',
            function() {
                let isValid = true;
                if (!$('#Direct-Debit-Form').valid()) {
                    checkSortcodeValidation($('#SortCodePart1'));
                    isValid = false;
                }
                if (isValid) {
                    validateBankAccountAndSortCode();
                    saveDataToSessionStorage();
                } else {
                    getValidationMessages();
                    scrollToFirstFieldWithErrorAndFocus();
                }
                return isValid;
            });

        $('#Direct-Debit-Cancel-Button').off().on('click',
            function() {
                window.location.href =
                    componentConfiguration.TenantConfiguration.ApplicationPath +
                    componentConfiguration.PaymentMethodCancelUrl;
            });
    }

    function checkAccountNumberValidation(element) {
        let isValid = false;

        if ($(element).hasClass('form-row__input account-number sort-code__input--error')) {
            $('#account-number-validation-message').addClass('hide');
        }
        if ($(element).hasClass('form-row__input account-number')) {
            isValid = $('#direct-debit-account-number').valid();
        }
        if (isValid) {
            removeAccountErrorStyle();
        }
    }

    function checkSortcodeValidation(element) {
        removeApiValidationErrorMessage(element);
        validateIndividualSortCodeInput(element);
        clearValidationErrorStylingWhenAllSortCodeInputsAreValid();
    }

    function removeApiValidationErrorMessage(element) {
        if (element.classList &&
            element.classList.contains('form-row__input--sort-code') &&
            !document.getElementById('sortcode-api-validation-message').classList.contains('hide')) {
            removeSortCodeErrorStyle();
        }
    }

    function validateIndividualSortCodeInput(element) {
        if ($(element).valid()) {
            removeIndividualSortCodeErrorStyle(element);
        } else {
            addIndividualSortCodeErrorStyle(element);
        }
        $('#form-row-sortcode1').removeClass('error');
    }

    function clearValidationErrorStylingWhenAllSortCodeInputsAreValid() {
        const allSortCodeInputsValid = checkAllSortCodeInputsAreValid();

        if (allSortCodeInputsValid) {
            $('#SortCodeLabel').removeClass('sort-code__label--error');
            $('#sortcode-validation-text').addClass('hide');
        }
    }

    function checkAllSortCodeInputsAreValid() {
        let allSortCodeInputsValid = true;

        $('.form-row__input--sort-code').each(function() {
            if ($(this).hasClass('sort-code__input--error')) {
                allSortCodeInputsValid = false;
            }
        });

        return allSortCodeInputsValid;
    }

    function sortCodeKeyUpEvent(event, currentSortCodePart, nextSortCodePart) {
        const TAB_KEYCODE = 9;
        const SHIFT_KEYCODE = 16;
        const LEFT_ARROW_KEYCODE = 37;
        const UP_ARROW_KEYCODE = 38;
        const RIGHT_ARROW_KEYCODE = 39;
        const DOWN_ARROW_KEYCODE = 40;

        const currentLength = $(currentSortCodePart).val().length;
        if (currentLength === 2 &&
            event.which !== TAB_KEYCODE &&
            event.which !== SHIFT_KEYCODE &&
            event.which !== LEFT_ARROW_KEYCODE &&
            event.which !== UP_ARROW_KEYCODE &&
            event.which !== RIGHT_ARROW_KEYCODE &&
            event.which !== DOWN_ARROW_KEYCODE) {
            $(nextSortCodePart).focus().select();
        }
    }

    function sortCodeAutoTab() {
        const container1 = document.getElementById('SortCodePart1');
        const container2 = document.getElementById('SortCodePart2');

        container1.onkeyup = function(e) {
            sortCodeKeyUpEvent(e, '#SortCodePart1', '#SortCodePart2');
        };

        container2.onkeyup = function(e) {
            sortCodeKeyUpEvent(e, '#SortCodePart2', '#SortCodePart3');
        };
    }


    function saveDataToSessionStorage() {
        const model = {
            sortCode: document.getElementById('SortCodePart1').value +
                document.getElementById('SortCodePart2').value +
                document.getElementById('SortCodePart3').value,
            accountNumber: document.getElementById('direct-debit-account-number').value,
        };

        const dataToPost = {
            __RequestVerificationToken: document.querySelector('input[name="__RequestVerificationToken"]').value,
            BankAccountAndSortCodeModel: model,
            encryptData: true,
        };

        $.ajax({
            url: componentConfiguration.TenantConfiguration.ApplicationPath +
                'TakePaymentComponent/AccountDetailsCryptography',
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (!result.isSuccess) {
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                    return false;
                }
                sessionStorage.setItem('AddPaymentMethodDetails1', result.accountNumber);
                sessionStorage.setItem('AddPaymentMethodDetails2', result.sortCode);
                return true;
            },
        });
    }

    function populateBankAccountDetails() {
        const bankAccountNumberEn = sessionStorage.getItem('AddPaymentMethodDetails1');
        const sortCodeEn = sessionStorage.getItem('AddPaymentMethodDetails2');
        if (bankAccountNumberEn != null || sortCodeEn != null) {
            const model = {
                sortCode: sortCodeEn,
                accountNumber: bankAccountNumberEn,
            };
            const dataToPost = {
                __RequestVerificationToken: document.querySelector('input[name="__RequestVerificationToken"]').value,
                BankAccountAndSortCodeModel: model,
                encryptData: false,
            };

            $.ajax({
                url: componentConfiguration.TenantConfiguration.ApplicationPath +
                    'TakePaymentComponent/AccountDetailsCryptography',
                type: 'POST',
                cache: false,
                dataType: 'json',
                data: dataToPost,
                success: function(result) {
                    if (!result.isSuccess) {
                        bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                        return false;
                    }
                    document.getElementById('direct-debit-account-number').value = result.accountNumber;
                    const sortCode = result.sortCode;
                    document.getElementById('SortCodePart1').value = sortCode.substring(0, 2);
                    document.getElementById('SortCodePart2').value = sortCode.substring(2, 4);
                    document.getElementById('SortCodePart3').value = sortCode.substring(4, 6);
                    return true;
                },
            });
        }
        return false;
    }

    function validateBankAccountAndSortCode() {
        const dataToPost = {
            __RequestVerificationToken: document.querySelector('input[name="__RequestVerificationToken"]').value,
            sortCode: document.getElementById('SortCodePart1').value +
                document.getElementById('SortCodePart2').value +
                document.getElementById('SortCodePart3').value,
            accountNumber: document.getElementById('direct-debit-account-number').value,
        };
        $.ajax({
            url: componentConfiguration.TenantConfiguration.ApplicationPath +
                'TakePaymentComponent/PostAccountNumberAndSortCode',
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (!result.isSuccess) {
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                    return false;
                }

                switch (result.Result) {
                case 'Validated':
                    if (typeof bgl.common.pubsub !== 'undefined') {
                        bgl.common.pubsub.emit(
                            'fakeFormSubmit',
                            $('#Direct-Debit-Form').attr('id') ||
                            $('#Direct-Debit-Form').attr('action') ||
                            'unknown',
                        );
                    }
                    removeSortCodeErrorStyle();
                    removeAccountErrorStyle();
                    loadAddPaymentConfirmation();
                    return true;
                case 'no values submitted':
                case 'sort code or account number invalid':
                    addAccountErrorStyle();
                    addSortCodeErrorStyle();
                    break;
                case 'sortCode invalid':
                    addSortCodeErrorStyle();
                    break;
                case 'accountNumber invalid':
                    addAccountErrorStyle();
                    break;
                }

                getInvalidAccountNumberOrSortCodeMessages();
                return false;
            },
        });
    }

    function loadAddPaymentConfirmation() {
        bgl.common.utilities.redirectToUrl(componentConfiguration.RedirectUrl);
    }

    function removeSortCodeErrorStyle() {
        $('#sortcode-api-validation-message').addClass('hide');
        $('#SortCodeLabel').removeClass('sort-code__label--error');
        $('#sortcode-api-validation-message').removeClass('sort-code__span--error');
        $('#SortCodePart1,#SortCodePart2,#SortCodePart3').removeClass('sort-code__input--error');
        cleanAriaDescribedBy('#SortCodePart1,#SortCodePart2,#SortCodePart3');
    }

    function addSortCodeErrorStyle() {
        $('#sortcode-api-validation-message').removeClass('hide');
        $('#SortCodeLabel').addClass('sort-code__label--error');
        $('#sortcode-api-validation-message').addClass('sort-code__span--error');
        $('#SortCodePart1,#SortCodePart2,#SortCodePart3').addClass('sort-code__input--error')
            .attr('aria-describedby', 'sortcode-api-validation-message');
    }

    function removeIndividualSortCodeErrorStyle(element) {
        $(element).removeClass('sort-code__input--error');
        cleanAriaDescribedBy(element);
    }

    function addIndividualSortCodeErrorStyle(element) {
        $('#SortCodeLabel').addClass('sort-code__label--error');
        $('#sortcode-validation-text').removeClass('hide');
        $(element).addClass('sort-code__input--error')
            .attr('aria-describedby', 'sortcode-validation-text');
    }

    function addAccountErrorStyle() {
        $('#account-number-validation-message').removeClass('hide');
        $('#account-number-validation-message').addClass('sort-code__span--error');
        $('#direct-debit-account-number').addClass('sort-code__input--error');
    }

    function removeAccountErrorStyle() {
        $('#account-number-validation-message').addClass('hide');
        $('#account-number-validation-message').removeClass('sort-code__span--error');
        $('#direct-debit-account-number').removeClass('sort-code__input--error');
        $('#direct-debit-account-number').removeAttr('aria-describedby');
        cleanAriaDescribedBy('#direct-debit-account-number');
    }

    function cleanAriaDescribedBy(element) {
        if ($(element).attr('aria-describedby')) {
            $(element).removeAttr('aria-describedby');
        }
    }

    function getTodaysPaymentSessionData() {
        return {
            'Name': sessionStorage.getItem('AddPaymentSelectedPersonIdText'),
            'CardCaptureUri': sessionStorage.getItem('AddPaymentMethodCardCaptureUri'),
            'SecureSessionId': sessionStorage.getItem('AddPaymentMethodSecureSessionId'),
            'SelectedPersonId': sessionStorage.getItem('AddPaymentSelectedPersonIdVal'),
            'ThreeDSecureUri': sessionStorage.getItem('AddPaymentMethodThreeDSecureUri'),
        };
    }

    function getContinuousPaymentCardSecureSessionData() {
        return {
            'Name': sessionStorage.getItem('ContinuousPaymentCardSelectedPersonIdText'),
            'CardCaptureUri': sessionStorage.getItem('AddPaymentMethodCardCaptureUri'),
            'SecureSessionId': sessionStorage.getItem('AddPaymentMethodSecureSessionId'),
            'SelectedPersonId': sessionStorage.getItem('AddPaymentSelectedPersonIdVal'),
            'ThreeDSecureUri': sessionStorage.getItem('AddPaymentMethodThreeDSecureUri'),
        };
    }

    function scrollToFirstFieldWithErrorAndFocus() {
        const firstRequiredField = $('.error,.sort-code__input--error').first();
        $('html,body').animate({scrollTop: firstRequiredField.offset().top}, 'slow');

        if (firstRequiredField.length) {
            const invalidInputElem = firstRequiredField.find('input, select, textarea')
                .addBack('input, select, textarea')[0];

            if (invalidInputElem !== undefined) {
                invalidInputElem.focus();
            }
        }
    }

    function getValidationMessages() {
        if ($('.form-row').hasClass('error')) {
            const data = {
                form_section: $('h1').text().trim(),
                error_details: [],
            };

            $('.error').find('.form-row__validation-text').each(function() {
                addError(data, $(this).attr('data-valmsg-for'), $(this).text().trim());
            });

            const sortcodeValidationElement = $('#sortcode-validation-text');
            if (sortcodeValidationElement.length == 1 && !sortcodeValidationElement.hasClass('hide')) {
                addError(data, $('#SortCodeLabel').text().trim(), $('#sortcode-validation-text').text().trim());
            }

            const sortcodeApiValidationElement = $('#sortcode-api-validation-message');
            if (sortcodeApiValidationElement.length == 1 && !sortcodeApiValidationElement.hasClass('hide')) {
                addError(data, $('#SortCodeLabel').text().trim(), $('#sortcode-api-validation-message').text().trim());
            }

            bgl.common.pubsub.emit('formValidationFailed', data);
        }
    }

    function getInvalidAccountNumberOrSortCodeMessages() {
        const data = {error_details: []};

        const accountNumberValidationElement = document.getElementById('account-number-validation-message');
        if (accountNumberValidationElement && !accountNumberValidationElement.classList.contains('hide')) {
            addError(
                data,
                document.querySelector('label[for=\'direct-debit-account-number\']').textContent.trim(),
                document.getElementById('account-number-validation-message').textContent.trim(),
            );
        }

        const sortCodeApiValidationElement = document.getElementById('sortcode-api-validation-message');
        if (sortCodeApiValidationElement && !sortCodeApiValidationElement.classList.contains('hide')) {
            addError(
                data,
                document.getElementById('SortCodeLabel').textContent.trim(),
                document.getElementById('sortcode-api-validation-message').textContent.trim(),
            );
        }

        if (data.error_details.length > 0) {
            data.form_section = document.querySelector('h1').textContent.trim();
            bgl.common.pubsub.emit('formValidationFailed', data);
        }
    }

    function addError(data, field, message) {
        const errorDetail = {
            error_field: field,
            error_message: message,
        };
        data.error_details.push(errorDetail);
    }

    return {
        init: initComponent,
        load: loadComponent,
        getValidationMessages: getValidationMessages,
        getInvalidAccountNumberOrSortCodeMessages: getInvalidAccountNumberOrSortCodeMessages,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.addpaymentmethod;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};

// eslint-disable-next-line no-var
var digitalData = window.digitalData || {};
digitalData.page_data = digitalData.page_data || {};
digitalData.user_data = digitalData.user_data || {};
digitalData.journey_data = digitalData.journey_data || {};
digitalData.application_data = digitalData.application_data || {};
digitalData.application_data.insurance_data = digitalData.application_data.insurance_data || {};
digitalData.my_account = digitalData.my_account || {};
digitalData.my_account.policy_data = digitalData.my_account.policy_data || {};
digitalData.my_account.policy_data.policy_change = digitalData.my_account.policy_data.policy_change || {};
digitalData.my_account.policy_data.policy_cancellation_questions =
    digitalData.my_account.policy_data.policy_cancellation_questions || {};

bgl.components.tagmanager = (function() {
    function initComponent() {
        setPageProperties();
        setReferrerProperties();
        setTimestampProperty();
        setPageCategories();
        subscribeToRetrieveQuoteSuccess();
        setJavascriptErrorProperty();
        setUpdatedUserDetails();
        setUpdatedVehicleDetails();
        setUpdatedPaymentDetails();
        setCancellationDetails();
        subscribeToStatusesAndTimingEvents();
        checkStorageAndUpdateApplicationData();
        subscribeToErrorData();
        subscribeToItemsClickedEvent();
        setClickedItemsInDigitalData();
        logClicksForLinksAndButtons();
        subscribeToFormSubmitEvents();
        subscribeToMvtTracking();
        subscribeToWebChatOpen();
    }

    function subscribeToFormSubmitEvents() {
        const formLoadTime = new Date();
        bgl.common.pubsub.on('formSubmit', function(data) {
            logFormSubmission(data, formLoadTime);
        });
        bgl.common.pubsub.on('fakeFormSubmit', function(data) {
            logFormSubmission(data, formLoadTime);
        });
    }

    function logFormSubmission(data, formLoadTime) {
        const formData = {
            detail: {
                form_title: data,
                form_section: $('h1:visible:first').text().replace(/\s\s+/g, ' ').trim(),
                form_page: digitalData.page_data.page_title,
                page_url: digitalData.page_data.page_url,
                time_to_complete: calculateTimeTaken(formLoadTime, new Date()),
            },
        };
        pushFormSubmitDataLayerEvent(data);

        document.dispatchEvent(new CustomEvent('form_completed', formData));
    }
    function pushFormSubmitDataLayerEvent(data) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'aa_form_submit',
            aa: {
                form_name: data,
            },
        });
    }

    function setPageProperties() {
        digitalData.page_data.page_url = window.location.href;
        digitalData.page_data.page_title = document.title;
        digitalData.page_data.page_path = window.location.pathname;
    }

    function setReferrerProperties() {
        digitalData.page_data.page_previous_url = document.referrer;
        if (document.referrer.length > 0) {
            const newUrl = new URL(document.referrer);
            digitalData.page_data.page_previous_path = newUrl.pathname;
        }
    }

    function setTimestampProperty() {
        digitalData.page_data.timestamp = (new Date()).toString();
    }

    function setPageCategories() {
        const pathArray = window.location.pathname.split('/');
        pathArray.pop();
        digitalData.page_data.page_categories = pathArray;
    }

    function setJavascriptErrorProperty() {
        digitalData.page_data.javascript_errors = [];
        window.onerror = function(error, url, line) {
            digitalData.page_data.javascript_errors.push('ERR:' + error + ' URL:' + url + ' L:' + line);
        };
    }

    function logClicksForLinksAndButtons() {
        $('i[data-type="policy-overview-slide-panel-navigation"]').click(function(event) {
            const clickedLink = $(event.target).parent().attr('id');
            bgl.common.pubsub.emit('SlidePanelClicked', clickedLink);
        });

        $('a[data-type="policy-navigation"]').click(function(event) {
            let clickedLink = $(event.target).text().trim();
            if (clickedLink === '') {
                clickedLink = $(event.target).parent().text().trim();
            }
            bgl.common.pubsub.emit('NavigationBarClicked', clickedLink);
        });

        $('a[data-testid="footer__contact-us"], a[data-testid="footer__privacy-policy"]').click(function(event) {
            const clickedLink = $(event.target).text().trim();
            bgl.common.pubsub.emit('FooterClicked', clickedLink);
        });

        $('#ChangePaymentMethod, #PaymentSuccessful_ChangePaymentDate').click(function(event) {
            const clickedSlidePanel = $(event.target).attr('id');
            bgl.common.pubsub.emit('SlidePanelClicked', clickedSlidePanel);
        });

        $('i[data-type="slide-panel-navigation"]').on('click',
            function(event) {
                let clickedSlidePanel = $(event.target).parent().attr('data-edit-action-key');
                if (clickedSlidePanel === undefined) {
                    clickedSlidePanel = $(event.target).parent().attr('data-cover-key');
                    if (clickedSlidePanel === undefined) {
                        clickedSlidePanel = $(event.target).parent().attr('data-action');
                    }
                }
                bgl.common.pubsub.emit('SlidePanelClicked', clickedSlidePanel);
            });
    }

    function setUpdatedUserDetails() {
        digitalData.user_data.detail_updated = JSON.parse(sessionStorage.getItem('ChangedUserData'));
    }

    function setUpdatedVehicleDetails() {
        digitalData.my_account.policy_data.policy_change = digitalData.my_account.policy_data.policy_change || {};
        digitalData.my_account.policy_data.policy_change.vehicle_details =
            digitalData.my_account.policy_data.policy_change.vehicle_details || {};
        digitalData.application_data.insurance_data.quote_updated = JSON.parse(
            sessionStorage.getItem('ChangedVehicleData'),
        );
        getChangedPolicyData();

        if (jQuery.isEmptyObject(digitalData.my_account.policy_data.policy_change.vehicle_details) !== true) {
            digitalData.my_account.policy_data.policy_change.vehicle_changed = true;
        }
    }

    function setUpdatedPaymentDetails() {
        const paymentChange = sessionStorage.getItem('PaymentUpdated');
        if (paymentChange === null) {
            digitalData.my_account.policy_data.payment_method_changes = false;
        } else {
            digitalData.my_account.policy_data.payment_method_changes = true;
            digitalData.my_account.policy_data.payment_method_selected = paymentChange;
        }
    }

    function setCancellationDetails() {
        const cancellationReason = sessionStorage.getItem('TagManager.CancellationReason');
        const cancellationDate = sessionStorage.getItem('TagManager.CancellationDate');
        if (cancellationReason === null && cancellationDate === null) {
            digitalData.my_account.policy_data.policy_cancellation = false;
        } else {
            digitalData.my_account.policy_data.policy_cancellation = true;
            const why = {
                cancellation_question: 'Why',
                cancellation_answer: cancellationReason,
            };
            const when = {
                cancellation_question: 'When',
                cancellation_answer: cancellationDate,
            };
            digitalData.my_account.policy_data.policy_cancellation_questions = [why, when];
        }
    }

    function subscribeToItemsClickedEvent() {
        bgl.common.pubsub.on('NavigationBarClicked', function(clickedItem) {
            storeClicksInNavigationBarForTagManager(clickedItem);
        });

        bgl.common.pubsub.on('FooterClicked', function(clickedItem) {
            storeClicksInFooterForTagManager(clickedItem);
        });

        bgl.common.pubsub.on('SlidePanelClicked', function(clickedItem) {
            storeClicksOnSlidePanelForTagManager(clickedItem);
        });
    }

    function storeClicksInNavigationBarForTagManager(clickedItem) {
        const data = getPreviouslyStoredClickedItemsInHeader();
        if (clickedItem) {
            data.push(['HeaderItemClicked', clickedItem]);
            setPreviouslyStoredClickedItemsInHeader(data);
        }
    }

    function storeClicksInFooterForTagManager(clickedItem) {
        const data = getPreviouslyStoredClickedItemsInFooter();
        if (clickedItem) {
            data.push(['FooterItemClicked', clickedItem]);
            setPreviouslyStoredClickedItemsInFooter(data);
        }
    }

    function storeClicksOnSlidePanelForTagManager(clickedItem) {
        const data = getPreviouslyStoredClickedSlidePanels();
        if (clickedItem) {
            data.push(['SlidePanelClicked', clickedItem]);
            setPreviouslyStoredClickedSlidePanels(data);
        }
    }

    function setClickedItemsInDigitalData() {
        if (sessionStorage.getItem('NavigationBarClicked') !== null) {
            digitalData.journey_data.megamenu_clicked = true;
            digitalData.journey_data.megamenu_item_clicked =
                JSON.parse(sessionStorage.getItem('NavigationBarClicked'));
        }

        if (sessionStorage.getItem('FooterClicked') !== null) {
            digitalData.journey_data.footer_clicked = true;
            digitalData.journey_data.footer_item_clicked =
                JSON.parse(sessionStorage.getItem('FooterClicked'));
        }

        if (sessionStorage.getItem('SlidePanelClicked') !== null) {
            digitalData.journey_data.page_body_item_clicked =
                JSON.parse(sessionStorage.getItem('SlidePanelClicked'));
        }

        if (sessionStorage.getItem('PaperlessStatus') !== null) {
            digitalData.my_account.policy_data.paperless_status = sessionStorage.getItem('PaperlessStatus');
        }
    }

    function getPreviouslyStoredClickedItemsInHeader() {
        let data = [];

        if (sessionStorage.getItem('NavigationBarClicked') !== null) {
            data = JSON.parse(sessionStorage.getItem('NavigationBarClicked'));
        }

        return data;
    }

    function getPreviouslyStoredClickedItemsInFooter() {
        let data = [];

        if (sessionStorage.getItem('FooterClicked') !== null) {
            data = JSON.parse(sessionStorage.getItem('FooterClicked'));
        }

        return data;
    }

    function getPreviouslyStoredClickedSlidePanels() {
        let data = [];

        if (sessionStorage.getItem('SlidePanelClicked') !== null) {
            data = JSON.parse(sessionStorage.getItem('SlidePanelClicked'));
        }

        return data;
    }

    function setPreviouslyStoredClickedItemsInHeader(data) {
        sessionStorage.setItem('NavigationBarClicked', JSON.stringify(data));
    }

    function setPreviouslyStoredClickedItemsInFooter(data) {
        sessionStorage.setItem('FooterClicked', JSON.stringify(data));
    }

    function setPreviouslyStoredClickedSlidePanels(data) {
        sessionStorage.setItem('SlidePanelClicked', JSON.stringify(data));
    }

    function getChangedPolicyData() {
        const changedVehicleData = JSON.parse(sessionStorage.getItem('ChangedVehicleData'));

        if (changedVehicleData !== null) {
            for (let i = 0; i < changedVehicleData.length; i++) {
                setChangedVehicleDataItems(changedVehicleData[i]);
            }
        }
    }

    function setChangedVehicleDataItems(changedItemArray) {
        if (changedItemArray[0] === 'Manufacturer') {
            digitalData.my_account.policy_data.policy_change.vehicle_details.vehicle_make = changedItemArray[1];
        }

        if (changedItemArray[0] === 'Model') {
            digitalData.my_account.policy_data.policy_change.vehicle_details.vehicle_model = changedItemArray[1];
        }

        if (changedItemArray[0] === 'Age') {
            digitalData.my_account.policy_data.policy_change.vehicle_details.vehicle_age = changedItemArray[1];
        }

        if (changedItemArray[0] === 'VehicleOvernightParking') {
            digitalData.my_account.policy_data.policy_change.vehicle_details.vehicle_overnight_parking =
                changedItemArray[1];
        }

        if (changedItemArray[0] === 'CustomerVehicleValue') {
            digitalData.my_account.policy_data.policy_change.vehicle_details.vehicle_value = changedItemArray[1];
        }

        if (changedItemArray[0] === 'Age') {
            digitalData.my_account.policy_data.policy_change.vehicle_details.vehicle_age = changedItemArray[1];
        }
    }

    function checkStorageAndUpdateApplicationData() {
        checkForSessionAndClearStorageItems();
        checkForStartedTimeAndUpdateDigitalData();
        checkForQuoteSavedAndUpdateDigitalData();
        checkForQuoteRetrievedAndUpdateDigitalData();
        checkForPaymentSuccessfulAndUpdateDigitalData();
        checkForPaymentUnsuccessfulAndUpdateDigitalData();
        checkForApplicationOrderedTimeAndUpdateDigitalData();
        storeTimeTakenInDigitalData();
        checkForQuotedTimeAndUpdateDigitalData();
        checkForUnableToQuoteAndUpdateDigitalData();
        checkForOrderStartTimeAndUpdateDigitalData();
    }

    function subscribeToRetrieveQuoteSuccess() {
        bgl.common.pubsub.on('RetrieveQuoteSuccess',
            function() {
                localStorage.setItem('RetrieveQuoteSuccess', true);
            });
    }

    function checkForSessionAndClearStorageItems() {
        if (localStorage.getItem('Session') !== digitalData.user_data.user_id) {
            localStorage.setItem('ApplicationOrderedTime', '');
            localStorage.setItem('QuoteRetrieved', '');
            localStorage.setItem('ApplicationOrderStartTime', '');
            localStorage.setItem('ApplicationStartedTime', '');
            localStorage.setItem('QuoteSaved', '');
            localStorage.setItem('PaymentSuccessful', '');
            localStorage.setItem('PaymentUnsuccessful', '');
            localStorage.setItem('ApplicationQuotedTime', '');
            localStorage.setItem('UnableToQuote', '');

            localStorage.setItem('Session', digitalData.user_data.user_id);
        }
        if (localStorage.getItem('RetrieveQuoteSuccess') === true ||
                localStorage.getItem('RetrieveQuoteSuccess') === 'true') {
            localStorage.setItem('QuoteRetrieved', true);
            localStorage.removeItem('RetrieveQuoteSuccess');
        }
    }

    function subscribeToStatusesAndTimingEvents() {
        bgl.common.pubsub.on('ApplicationStarted', function(getAppStartTime) {
            storeApplicationStartedTIme(getAppStartTime);
            checkForStartedTimeAndUpdateDigitalData();
        });

        bgl.common.pubsub.on('ApplicationQuoted', function(getAppQuotedTime) {
            storeApplicationQuotedTimeAndOrderStartTime(getAppQuotedTime);
            checkForQuotedTimeAndUpdateDigitalData();
        });

        bgl.common.pubsub.on('UnableToQuote', function() {
            localStorage.setItem('UnableToQuote', true);
            checkForUnableToQuoteAndUpdateDigitalData();
        });

        bgl.common.pubsub.on('SavedQuote', function() {
            localStorage.setItem('QuoteSaved', true);
            checkForQuoteSavedAndUpdateDigitalData();
        });

        bgl.common.pubsub.on('QuoteRetrieved', function() {
            localStorage.setItem('QuoteRetrieved', true);
            checkForQuoteRetrievedAndUpdateDigitalData();
        });

        bgl.common.pubsub.on('PaymentSuccessful', function(applicationOrderedTime) {
            localStorage.setItem('PaymentSuccessful', true);
            storeApplicationOrderedTime(applicationOrderedTime);
            checkForPaymentSuccessfulAndUpdateDigitalData();
        });

        bgl.common.pubsub.on('PaymentUnsuccessful', function() {
            localStorage.setItem('PaymentUnsuccessful', true);
            checkForPaymentUnsuccessfulAndUpdateDigitalData();
        });
    }

    function checkForStartedTimeAndUpdateDigitalData() {
        if (localStorage.getItem('ApplicationStartedTime') !== '') {
            digitalData.application_data.application_started = true;
        }
    }

    function checkForOrderStartTimeAndUpdateDigitalData() {
        if (localStorage.getItem('ApplicationOrderStartTime') !== '') {
            digitalData.application_data.application_quoted = true;
        }
    }

    function checkForQuoteSavedAndUpdateDigitalData() {
        if (localStorage.getItem('QuoteSaved') !== '') {
            digitalData.application_data.application_saved = true;
        }
    }

    function checkForQuoteRetrievedAndUpdateDigitalData() {
        if (localStorage.getItem('QuoteRetrieved') !== '') {
            digitalData.application_data.retrieved_quote = true;
        }
    }

    function checkForPaymentSuccessfulAndUpdateDigitalData() {
        if (localStorage.getItem('PaymentSuccessful') !== '') {
            digitalData.application_data.application_ordered = true;
            checkForApplicationOrderedTimeAndUpdateDigitalData();
        }
    }

    function checkForPaymentUnsuccessfulAndUpdateDigitalData() {
        if (localStorage.getItem('PaymentUnsuccessful') !== '') {
            digitalData.application_data.application_failed_payment = true;
        }
    }

    function checkForApplicationOrderedTimeAndUpdateDigitalData() {
        if (localStorage.getItem('ApplicationOrderedTime') !== '') {
            const orderStartTime = Date.parse(localStorage.getItem('ApplicationOrderStartTime'));
            const orderEndTime = Date.parse(localStorage.getItem('ApplicationOrderedTime'));

            digitalData.application_data.application_time_to_order = calculateTimeTaken(orderStartTime, orderEndTime);
        }
    }

    function storeTimeTakenInDigitalData() {
        if (localStorage.getItem('ApplicationQuotedTime') !== '' &&
                localStorage.getItem('ApplicationStartedTime') !== '') {
            const quoteStartTime = Date.parse(localStorage.getItem('ApplicationStartedTime'));
            const quoteEndTime = Date.parse(localStorage.getItem('ApplicationQuotedTime'));
            digitalData.application_data.application_time_to_quote = calculateTimeTaken(quoteStartTime, quoteEndTime);
        }
    }

    function checkForQuotedTimeAndUpdateDigitalData() {
        if (localStorage.getItem('ApplicationQuotedTime') !== '') {
            digitalData.application_data.application_quoted = true;
        }
    }

    function checkForUnableToQuoteAndUpdateDigitalData() {
        if (localStorage.getItem('UnableToQuote') !== '' && digitalData.application_data.application_quoted === true) {
            digitalData.application_data.application_failed_order = true;
        } else if (localStorage.getItem('UnableToQuote') !== '' &&
                localStorage.getItem('Session') === digitalData.user_data.user_id) {
            digitalData.application_data.quote_failed = true;
        }
    }

    function storeApplicationStartedTIme(getAppStartTime) {
        if (localStorage.getItem('ApplicationStartedTime') === '') {
            localStorage.setItem('ApplicationStartedTime', getAppStartTime);
        }
    }

    function storeApplicationQuotedTimeAndOrderStartTime(getAppQuotedTime) {
        if (localStorage.getItem('ApplicationQuotedTime') === '') {
            localStorage.setItem('ApplicationQuotedTime', getAppQuotedTime);
            localStorage.setItem('ApplicationOrderStartTime', getAppQuotedTime);
            storeTimeTakenInDigitalData();
        }
    }

    function storeApplicationOrderedTime(applicationOrderedTime) {
        if (localStorage.getItem('PaymentSuccessful') !== '') {
            localStorage.setItem('ApplicationOrderedTime', applicationOrderedTime);
        }
    }
    function subscribeToWebChatOpen() {
        if (window.dataLayer) {
            bgl.common.pubsub.off('WebchatOpened', onWebchatOpened);
            bgl.common.pubsub.on('WebchatOpened', onWebchatOpened);
        }
    }

    function onWebchatOpened() {
        dataLayer.push({
            event: 'aa_live_chat',
        });

        bgl.common.pubsub.off('WebchatOpened', onWebchatOpened);
    }

    function calculateTimeTaken(startTime, endTime) {
        const duration = endTime - startTime;

        let seconds = Math.floor((duration / 1000) % 60);
        let minutes = Math.floor((duration / (1000 * 60)) % 60);
        let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

        hours = (hours < 10) ? '0' + hours : hours;
        minutes = (minutes < 10) ? '0' + minutes : minutes;
        seconds = (seconds < 10) ? '0' + seconds : seconds;

        const timeTakenToQuote = (hours + ':' + minutes + ':' + seconds);

        return timeTakenToQuote;
    }

    function subscribeToErrorData() {
        bgl.common.pubsub.on('formValidationFailed', function(data) {
            document.dispatchEvent(new CustomEvent('form_field_error', {
                detail: {
                    form_title: digitalData.page_data.page_path,
                    form_section: data.form_section,
                    form_page: digitalData.page_data.page_title,
                    page_url: digitalData.page_data.page_url,
                    error_details: [data.error_details],
                },
            }));
        });
    }

    function subscribeToMvtTracking() {
        bgl.common.pubsub.on('MvtRunning', function(testName, variation) {
            trackMvtRunning(testName, variation);
        });
    }

    function trackMvtRunning(testName, variation) {
        _satellite.track('targetClickTracking', {
            testType: 'MVT',
            testName: testName,
            variation: variation,
        });
    }

    return {
        init: initComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.tagmanager;
}
﻿var bgl = window.bgl || {};
bgl.components = bgl.components || {};

bgl.components.retrievequote = (function () {
    var configuration;

    function initComponent(componentConfiguration) {

        configuration = componentConfiguration;

        var form = $('#retrieve-quote-form');
        bgl.common.validator.init(form);
        bgl.common.date.initDateFormat($('#DateOfBirth'));

        $('#DontKnowQuoteButton').off('click').on('click',
            function (event) {
                event.preventDefault();
                bgl.common.pubsub.emit('showContactDataNotification');
            });

        form.off('submit')
            .on('submit',
                function (event) {
                    event.preventDefault();

                    var errorMessageBox = $('.error-messagebox');
                    var form = $(this);

                    if (errorMessageBox) {
                        errorMessageBox.hide();
                    }

                    if (bgl.common.validator.isFormValid(form)) {
                        bgl.components.recaptcha.populateToken(function () {
                            bgl.common.validator.submitForm(form, configuration);
                        });
                    }
                });
    }

    function onSuccess(configuration, data) {
        bgl.common.pubsub.emit('RetrieveQuoteSuccess');
        if (data.redirectUrl) {
            bgl.common.pubsub.emit('PollBasket',
            {
                callback: function () {
                    bgl.common.utilities.redirectToUrl(data.redirectUrl);
                },
                hideNotification: true
            });
        }
    }

    function onError() {
        bgl.components.retrievequote.init(configuration);
        bgl.components.recaptcha.addHiddenInputToForm();
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError
    };

})();﻿var bgl = window.bgl || {};
bgl.components = bgl.components || {};

bgl.components.recaptcha = (function () {
    var configuration, tokenInput;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;

        addHiddenInputToForm();
        addScriptToHead();
    }

    function addHiddenInputToForm() {
        var form = document.querySelector(configuration.formCssSelector);

        tokenInput = document.createElement('input');
        tokenInput.type = 'hidden';
        tokenInput.name = 'recaptchaToken';

        form.appendChild(tokenInput);
    }

    function addScriptToHead() {
        var scripts = [].slice.call(document.querySelectorAll('head script'));
        var indexOfExistingScript = scripts.map(function(x) {
            return x.src;
        }).indexOf("https://www.google.com/recaptcha/api.js?render=siteKey");

        if (indexOfExistingScript > -1) {
            return;
        }

        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://www.google.com/recaptcha/api.js?render=' + configuration.siteKey;
        head.appendChild(script);
    }

    function populateToken(callback) {
        grecaptcha.execute(configuration.siteKey, { action: configuration.Id })
            .then(function (token) {
                tokenInput.value = token;
                
                if (callback) {
                    callback(token);
                }
            });
    }

    return {
        init: initComponent,
        populateToken: populateToken,
        addHiddenInputToForm: addHiddenInputToForm
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.recaptcha;
}//  eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};

bgl.components.quoteagent = (function() {
    let applicationPath = '/';
    let configuration;
    let messageContainer = {};
    let messageList = {};
    let messageInput = {};
    let chatForm = {};
    let restartButton = {};
    let sendButton = {};
    let antiForgeryToken = '';
    const USER_TYPE_END_USER = 'end_user';
    const USER_TYPE_VIRTUAL_AGENT = 'virtual_agent';
    let componentContainer;
    let agentName;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
            });
    }

    async function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        applicationPath = componentConfiguration.TenantConfiguration.ApplicationPath;
        componentContainer = document.getElementById(configuration.Id);
        messageContainer = componentContainer.querySelector('#ca-message-container');
        messageList = componentContainer.querySelector('#ca-message-list');
        messageInput = componentContainer.querySelector('#ca-message-input');
        chatForm = componentContainer.querySelector('#ca-message-form');
        restartButton = componentContainer.querySelector('#ca-restart-chat');
        antiForgeryToken = document.querySelector('[name="__RequestVerificationToken"]').value;
        agentName = configuration.AgentName || 'ai.agent';
        sendButton = componentContainer.querySelector('#ca-send-btn');

        if (!restartButton ||
            !messageContainer ||
            !messageList ||
            !messageInput ||
            !chatForm ||
            !antiForgeryToken ||
            !sendButton) {
            const error = 'One or more DOM elements could not be found during initialization';
            await handleError(error);
            return;
        }

        restartButton.addEventListener('click', async () => {
            await restartChat();
        });

        chatForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            const message = messageInput.value;
            if (message.trim().length > 0) {
                let sessionId = sessionStorage.getItem('quote-agent-sessionId');
                if (!sessionId) {
                    sessionId = crypto.randomUUID();
                }
                await sendMessage(USER_TYPE_END_USER, message, sessionId);
                sessionStorage.setItem('quote-agent-sessionId', sessionId);
            }
        });

        messageInput.addEventListener('focus', function() {
            sendButton.classList.add('ca-quote__input-submit--active');
        });
        messageInput.addEventListener('blur', function() {
            sendButton.classList.remove('ca-quote__input-submit--active');
        });

        await setUpQuoteAgentClient();
    }

    async function setUpQuoteAgentClient() {
        messageInput.disabled = true;
        let sessionId = sessionStorage.getItem('quote-agent-sessionId');
        let message = 'Hello, where were we?';
        if (!sessionId) {
            sessionId = crypto.randomUUID();
            message = 'Hello';
        }
        await sendMessage(USER_TYPE_END_USER, message, sessionId, false);
        await handleConnected(sessionId);
    }

    async function handleConnected(sessionId) {
        localStorage.setItem('va:lastUsed', 'quoteAgent');
        const persistedSessionId = sessionStorage.getItem('quote-agent-sessionId');
        if (!persistedSessionId) {
            sessionStorage.setItem('quote-agent-sessionId', sessionId);
        }
    };

    async function sendMessage(userType, message, sessionId, addToChatHistory = true) {
        const existingButtons = messageList.querySelector('.ca-buttons-container');
        if (existingButtons) {
            existingButtons.remove();
        }
        messageInput.disabled = true;
        messageInput.value = '';

        if (addToChatHistory) {
            await updateUIWithNewMessage(userType, message);
        };

        showAiFeedback('processing...');

        try {
            const formData = new FormData();
            formData.append(
                '__RequestVerificationToken',
                document.querySelector('[name="__RequestVerificationToken"]').value);
            formData.append('message', message);
            formData.append('sessionId', sessionId);
            const dataToPost = new URLSearchParams(formData).toString();
            const url = `${applicationPath}virtualassistantcomponent/sendMessage`;
            const response = await bgl.common.fetch
                .formPost(url, {body: dataToPost});
            if (!response.ok) {
                const error = 'Network response was not ok when sending message to the agent' +
                    response.statusText;
                await handleError(error);
                return;
            }

            let responseMessages = [];
            try {
                responseMessages = await response.json();
            } catch {
                const text = await response.text();
                responseMessages = [text];
            }

            for (const responseMessage of responseMessages) {
                await updateUIWithNewMessage(USER_TYPE_VIRTUAL_AGENT, responseMessage);
                if (isNewLeadWorkflowNeeded(USER_TYPE_VIRTUAL_AGENT, responseMessage)) {
                    await handleNewLeadWorkflow();
                }
            }
        } catch (error) {
            await handleError(error);
        } finally {
            hideAiFeedback();
            messageInput.disabled = false;
            messageInput.focus();
        }
    };

    function tryParseJson(str) {
        if (typeof str !== 'string' || str.trimStart()[0] !== '{') {
            return null;
        }
        const parsed = JSON.parse(str);
        if (parsed && typeof parsed === 'object') {
            return parsed;
        }
        return null;
    }

    async function updateUIWithNewMessage(userType, content) {
        try {
            const parsed = tryParseJson(content);
            if (parsed && parsed.type === 'ui.buttons') {
                await renderButtons(parsed);
                return;
            }

            const formattedContent = typeof content === 'string' ?
                content.replace(/\r\n|\r|\n/g, '<br>') :
                content;

            if (userType === USER_TYPE_END_USER) {
                messageInput.placeholder = '';
                const groupEl = document.createElement('div');
                groupEl.className = 'ca-quote__user-group flex flex-direction-column align-items--end';
                groupEl.innerHTML = `<div class="ca-quote__bubble ca-quote__bubble--user">${formattedContent}</div>`;
                messageList.appendChild(groupEl);
            } else {
                renderAgentMessage(formattedContent);
            }

            messageContainer.scrollTop = messageContainer.scrollHeight;
        } catch (error) {
            await handleError(error);
        }
    }

    async function renderButtons(buttonData) {
        if (buttonData.prompt) {
            renderAgentMessage(buttonData.prompt);
        }

        const buttonsContainer = document.createElement('div');
        buttonsContainer.className = 'ca-buttons-container button-container flex flex-wrap';

        if (buttonData.disableInput) {
            messageInput.disabled = true;
        }

        buttonData.options.forEach(function(option) {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'button button--secondary button--sm m-none';
            btn.textContent = option.label;
            btn.setAttribute('data-value', option.value);
            btn.addEventListener('click', async function() {
                buttonsContainer.remove();
                messageInput.disabled = false;
                const sessionId = sessionStorage.getItem('quote-agent-sessionId');
                if (!sessionId) {
                    await restartChat();
                } else {
                    await sendMessage(USER_TYPE_END_USER, option.label, sessionId);
                }
            });
            buttonsContainer.appendChild(btn);
        });

        messageList.appendChild(buttonsContainer);
        messageContainer.scrollTop = messageContainer.scrollHeight;
    }

    function renderAgentMessage(formattedContent) {
        const timestamp = getFormattedTime();
        const groupEl = document.createElement('div');
        groupEl.className = 'ca-quote__agent-group flex flex-direction-column row-gap-micro';
        groupEl.innerHTML =
            '<div class="ca-quote__bubble ' +
            'ca-quote__bubble--agent">' +
            '<div class="ca-quote__sender">' +
            '<span class="ca-quote__ai-icon-inline"' +
            ' aria-hidden="true">' +
            '</span>' +
            '<span class="ca-quote__sender-name">' +
            agentName + '</span></div>' +
            '<span class="ca-quote__bubble-content">' +
            formattedContent + '</span>' +
            '<span class="ca-quote__timestamp">' +
            timestamp + '</span></div>';
        messageList.appendChild(groupEl);
    }

    function getFormattedTime() {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    }

    function isNewLeadWorkflowNeeded(userType, content) {
        if (
            userType === USER_TYPE_VIRTUAL_AGENT &&
            typeof content === 'string' &&
            content.includes('Ok updating our backend systems with these details')
        ) {
            return true;
        }
        return false;
    }

    async function handleNewLeadWorkflow() {
        const inputParamsResponse = await getNewLeadInputParameters();
        if (!inputParamsResponse) return;

        const leadDetails = await createLead(inputParamsResponse.agentData);
        if (!leadDetails) return;

        antiForgeryToken = await getNewCSRFToken();
        if (!antiForgeryToken) return;

        document.querySelector('[name="__RequestVerificationToken"]').value = antiForgeryToken;
        const agentOutputParamsResponse = await postDetailsToAgent(inputParamsResponse, leadDetails);
        if (!agentOutputParamsResponse) return;

        updateUIWithNewMessage('Agent', agentOutputParamsResponse);
    }

    async function getNewLeadInputParameters() {
        const sessionId = sessionStorage.getItem('quote-agent-sessionId');
        if (!sessionId) {
            const error = 'Empty sessionId when attempting to retrieve input params';
            await handleError(error);
            return;
        }
        const formData = new FormData();
        formData.append('__RequestVerificationToken', antiForgeryToken);
        formData.append('sessionId', sessionId);
        const dataToPost = new URLSearchParams(formData).toString();
        const url = `${applicationPath}virtualassistantcomponent/getdatafromAgent`;
        const response = await bgl.common.fetch
            .formPost(url, {body: dataToPost});
        if (!response.ok) {
            const error = 'Network response was not ok when getting new lead params' + response.statusText;
            await handleError(error);
            return;
        }
        return response.json();
    }

    async function createLead(inputParams) {
        const formData = new FormData();
        formData.append('HasChanges', 'False');
        formData.append('AddressId', '');
        formData.append('Line1', inputParams.address.line1);
        formData.append('Line2', inputParams.address.line2);
        formData.append('Line3', inputParams.address.line3);
        formData.append('PostCode', inputParams.address.postcode);
        formData.append('JourneyType', '2');
        formData.append('FirstName', inputParams.firstName);
        formData.append('LastName', inputParams.lastName);
        formData.append('Title', inputParams.title);
        formData.append('DateOfBirth', inputParams.dateOfBirth);
        formData.append('MaritalStatusCode', inputParams.maritalStatusCode);
        formData.append('__RequestVerificationToken', antiForgeryToken);
        const dataToPost = new URLSearchParams(formData).toString();
        const url = configuration.TenantConfiguration.ApplicationPath + 'Account/NewLeadEntry';

        const response = await bgl.common.fetch
            .formPost(url, {body: dataToPost});
        if (!response.ok) {
            const error = 'Network response was not ok when posting new lead' + response.statusText;
            await handleError(error);
            return;
        }
        return response.json();
    }

    async function postDetailsToAgent(inputParams, leadDetails) {
        if (!leadDetails?.redirectUrl) {
            const error = 'Failed to create a quote, missing redirectUrl';
            await handleError(error);
            return;
        };

        if (leadDetails.redirectUrl.toLowerCase().indexOf('error') >= 0) {
            const error = 'Failed to create a quote, redirectUrl contains error';
            await handleError(error);
            return;
        };

        const sessionId = sessionStorage.getItem('quote-agent-sessionId');
        if (!sessionId) {
            const error = 'Empty sessionId when attempting to retrieve input params';
            await handleError(error);
            return;
        }

        const formData = new FormData();
        formData.append('__RequestVerificationToken', antiForgeryToken);
        formData.append('sessionId', sessionId);
        formData.append('redirectUrl', leadDetails.redirectUrl);
        formData.append('tool', inputParams.agentData.tool);
        formData.append('action', inputParams.agentData.action);
        const dataToPost = new URLSearchParams(formData).toString();
        const url = `${applicationPath}virtualassistantcomponent/postdatatoagent`;
        const response = await bgl.common.fetch
            .formPost(url, {body: dataToPost});
        if (!response.ok) {
            const error = 'Network response was not ok when posting details back to agent' + response.statusText;
            await handleError(error);
            return;
        }
        return response.text();
    }

    async function getNewCSRFToken() {
        const url = `${applicationPath}antiforgery/token`;
        const response = await fetch(url);
        if (!response.ok) {
            const error = 'Network response was not ok when getting new CSRF token' + response.statusText;
            await handleError(error);
            return;
        }
        const data = await response.json();
        return data.token;
    }

    async function restartChat() {
        const sessionId = sessionStorage.getItem('quote-agent-sessionId');
        sessionStorage.removeItem('quote-agent-sessionId');
        await setUpQuoteAgentClient();
        bgl.common.telemetry.logEvent(
            'VA Quote Agent user restarted the chat', {'sessionId': sessionId});
    }

    async function handleError(error) {
        bgl.common.telemetry.logException(error);
        hideAiFeedback();
        updateUIWithNewMessage('System', 'Apologies an error has occurred.');
    }

    function showAiFeedback(text) {
        const feedbackEl = componentContainer.querySelector('#ca-ai-feedback');
        const feedbackTextEl = componentContainer.querySelector('#ca-ai-feedback-text');
        if (feedbackEl) {
            if (feedbackTextEl) {
                feedbackTextEl.textContent = text || 'processing...';
            }
            feedbackEl.classList.remove('hide');
            messageContainer.scrollTop = messageContainer.scrollHeight;
        }
    }

    function hideAiFeedback() {
        const feedbackEl = componentContainer.querySelector('#ca-ai-feedback');
        if (feedbackEl) {
            feedbackEl.classList.add('hide');
        }
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.quoteagent;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.pagereloader = bgl.components.pagereloader || {};

bgl.components.pagereloader.policydocumentinterim = (function() {
    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(
            componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
            });
    }

    function initComponent(componentConfiguration) {
        const downloadCookieName = 'PdfCreated';
        const documentUrlElement = document.body.querySelector('#documentUrl');
        const downloadingInProgressContent = document.body.querySelector('#spinner');
        const downloadCompleteContent = document.body.querySelector('#downloadedMessage');
        handleDocumentDownload(
            downloadCookieName,
            downloadingInProgressContent,
            downloadCompleteContent,
            documentUrlElement);
    }

    function handleDocumentDownload(
        downloadCookieName,
        downloadingInProgressContent,
        downloadCompleteContent,
        documentUrlElement) {
        bgl.common.cookie.deleteCookie(downloadCookieName);
        const checkForDownloadCompleted = setInterval(
            () => {
                showDownloadedContentIfDocumentDownloaded(
                    downloadCookieName,
                    downloadingInProgressContent,
                    downloadCompleteContent,
                    checkForDownloadCompleted);
            },
            500);
        bgl.common.utilities.redirectToUrl(documentUrlElement.value);
    }

    function showDownloadedContentIfDocumentDownloaded(
        cookieName,
        downloadingInProgressContent,
        downloadCompleteContent,
        checkForDownloadCompleted) {
        if (hasDocumentDownloaded(cookieName)) {
            clearInterval(checkForDownloadCompleted);
            downloadingInProgressContent.classList.add('hide');
            downloadCompleteContent.classList.remove('hide');
        }
    }

    function hasDocumentDownloaded(cookieName) {
        return bgl.common.cookie.getCookie(cookieName) != undefined;
    }

    return {
        init: initComponent,
        load: loadComponent,
        hasDocumentDownloaded: hasDocumentDownloaded,
        showDownloadedContentIfDocumentDownloaded: showDownloadedContentIfDocumentDownloaded,
        handleDocumentDownload: handleDocumentDownload,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.pagereloader;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.pagereloader = bgl.components.pagereloader || {};

bgl.components.pagereloader.loader = (function() {
    let applicationPath = '';

    function initComponent(componentConfiguration) {
        applicationPath = componentConfiguration.TenantConfiguration.ApplicationPath;
        bgl.common.pubsub.on('PollBasket', function(options) {
            pollBasket(options);
        });
    }

    function pollBasket(options) {
        const interval = 500;
        const timeoutDuration = 30000;
        const pollUrl = 'PageReloaderComponent/IsUnderwritingComplete';
        const tickCount = new Date().getTime();
        const timeout = tickCount + timeoutDuration;
        bgl.components.pagereloader.poller.poll(
            timeout,
            interval,
            false,
            pollUrl,
            applicationPath,
            options);
    }

    return {
        init: initComponent,
    };
})();

bgl.components.pagereloader.poller = (function() {
    const notificationObj = {
        cat: 'underwriting',
        msg: {
            annual:
                'OK ##FIRSTNAME##, your new price is £##PRICE##. The underwriter for your policy is ##UNDERWRITER##.',
            monthly:
                `OK ##FIRSTNAME##, your new price is £##PRICE## a month with a deposit of £##DEPOSIT##.
                The underwriter for your policy is ##UNDERWRITER##.`,
        },
    };

    function poll(timeout, interval, isSpinnerVisible, pollUrl, applicationPath, options) {
        options = options || {};

        if (options.hideSpinnerOnInitialAttempt || options.noSpinner) {
            options.hideSpinnerOnInitialAttempt = false;
        } else {
            bgl.components.pagereloader.poller.showSpinner(isSpinnerVisible, options.spinnerName);
            isSpinnerVisible = true;
        }

        $.ajax({
            url: applicationPath + pollUrl,
            type: 'Get',
            cache: false,
            dataType: 'json',
            success: function(response) {
                if (response.IsSuccess === true) {
                    if (response.statusCode === 202) {
                        if (timeout >= new Date().getTime()) {
                            setTimeout(
                                function() {
                                    bgl.components.pagereloader.poller.poll(
                                        timeout,
                                        interval,
                                        isSpinnerVisible,
                                        pollUrl,
                                        applicationPath,
                                        options);
                                },
                                interval);
                        } else {
                            bgl.components.pagereloader.poller
                                .goToUnderwritingTimeOutPage(applicationPath);
                        }
                    } else if (response.statusCode === 400) {
                        removeNotificationFromSessionStorage();
                        bgl.components.pagereloader.poller
                            .goToUnableToQuoteOnlinePage(applicationPath);
                    } else {
                        if (options.hideNotification) {
                            removeNotificationFromSessionStorage();
                        }
                        bgl.components.pagereloader.poller.reloadPage(
                            options.callback,
                            options.hideNotification,
                            options.redirectUrl,
                        );
                    }
                } else {
                    bgl.components.pagereloader.poller.goToErrorPage(applicationPath);
                }
            },
            error: function() {
                bgl.components.pagereloader.poller.goToErrorPage(applicationPath);
            },
        });
    }

    function showSpinner(isSpinnerVisible, spinnerName) {
        let spinnerHtml;

        if (isSpinnerVisible === false) {
            switch (spinnerName) {
            case 'addonSpinner':
                bgl.common.overlay.show();
                break;

            case 'serviceSpinner':
                spinnerHtml = bgl.common.spinner.getSpinnerBody(
                    'Working on it',
                    'We won\'t be a moment');
                document.getElementsByTagName('body')[0].innerHTML = '<div class="spinner-container"></div>';
                document.getElementsByClassName('spinner-container')[0].innerHTML = spinnerHtml;
                break;

            default:
                spinnerHtml = bgl.common.spinner.getSpinnerBody(
                    'Working on it',
                    'We won\'t be a moment');
                document.getElementsByTagName('body')[0].innerHTML = spinnerHtml;
                break;
            }
        }
    }

    function goToErrorPage(applicationPath) {
        bgl.common.utilities.redirectToUrl(applicationPath + 'Error');
    }

    function goToUnderwritingTimeOutPage(applicationPath) {
        bgl.common.utilities.redirectToUrl(applicationPath + 'Error/UnderwritingTimeOut');
    }

    function goToUnableToQuoteOnlinePage(applicationPath) {
        bgl.common.telemetry.logEvent(`No Quote`);
        bgl.common.utilities.redirectToUrl(applicationPath + 'Error/UnableToQuoteOnline');
    }

    function reloadPage(callback, hideNotification, redirectUrl) {
        if (typeof callback === 'function') {
            callback();
            return;
        }

        if (!hideNotification) {
            window.sessionStorage.setItem('notification', JSON.stringify(notificationObj));
        }

        if (redirectUrl) {
            bgl.common.utilities.redirectToUrl(redirectUrl);
        } else {
            bgl.common.utilities.refreshPage();
        }
    }

    function removeNotificationFromSessionStorage() {
        sessionStorage.removeItem('notification');
    }

    return {
        poll: poll,
        showSpinner: showSpinner,
        goToErrorPage: goToErrorPage,
        goToUnderwritingTimeOutPage: goToUnderwritingTimeOutPage,
        goToUnableToQuoteOnlinePage: goToUnableToQuoteOnlinePage,
        reloadPage: reloadPage,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.pagereloader.loader;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.pagereloader = bgl.components.pagereloader || {};

bgl.components.pagereloader.documentloader = (function() {
    let applicationPath = '';

    function initComponent(componentConfiguration) {
        applicationPath = componentConfiguration.TenantConfiguration.ApplicationPath;
        showSpinner();
        pollDocument();
    }

    function showSpinner() {
        const spinnerHtml = bgl.common.spinner.getSpinnerBody(
            'Working on it',
            'We won\'t be a moment');
        document.getElementById('spinner').innerHTML = spinnerHtml;
    }
    function showSpinnerDownloadCompletedMsg() {
        const downloadCompletedHtml =
            '<main>' +
            '<div class="page-section">' +
            '<div class="page-section--inner">' +
            '<div class="spinner">' +
            '<div class="spinner__tick"><\/div>' +
            '<h2 class="spinner__heading"><span>Document downloaded<\/span><\/h2>' +
            '<p class="spinner__text"><span>Please close this tab to continue your journey<\/span><\/p>' +
            '<\/div>' +
            '<\/div>' +
            '<\/div>' +
            '<\/main>';

        document.getElementById('spinner').innerHTML = downloadCompletedHtml;
    }

    function pollDocument() {
        const tickCount = new Date().getTime();
        const timeoutDuration = 120000;
        const timeout = tickCount + timeoutDuration;
        const interval = 1000;
        const pollUrl = 'PageReloaderComponent/IsDocumentReady';
        bgl.components.pagereloader.documentloader.poll(
            timeout,
            interval,
            pollUrl);
    }

    function poll(timeout, interval, pollUrl) {
        const token = document.querySelector('input[name="__RequestVerificationToken"]').value;
        $.ajax({
            url: applicationPath + pollUrl,
            type: 'Post',
            cache: false,
            dataType: 'json',
            data: {
                __RequestVerificationToken: token,
                url: document.getElementById('documentUrl').value,
            },
            success: function(response) {
                if (response.isDocumentReady === false) {
                    if (timeout >= new Date().getTime()) {
                        setTimeout(function() {
                            poll(timeout, interval, pollUrl);
                        }, interval);
                    } else {
                        goToErrorPage(applicationPath);
                    }
                } else if (response.isDocumentReady === true) {
                    downloadDocument();
                    showSpinnerDownloadCompletedMsg();
                } else {
                    goToErrorPage(applicationPath);
                }
            },
            error: function() {
                goToErrorPage(applicationPath);
            },
        });
    }
    function goToErrorPage(applicationPath) {
        bgl.common.utilities.redirectToUrl(applicationPath + 'Error');
    }

    function downloadDocument() {
        document.getElementById('__DocumentLoaderForm').submit();
    }
    return {
        init: initComponent,
        poll: poll,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.pagereloader;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.pagereloader = bgl.components.pagereloader || {};

bgl.components.pagereloader.deletebasket = (function() {
    let applicationPath = '';
    function initComponent(componentConfiguration) {
        applicationPath = componentConfiguration.TenantConfiguration.ApplicationPath;
        showSpinner();
        deleteBasket();
    }

    function showSpinner() {
        const spinnerHtml = bgl.common.spinner.getSpinnerBody(
            'Working on it',
            'We won\'t be a moment');
        document.getElementById('spinner').innerHTML(spinnerHtml);
    }

    function deleteBasket() {
        const token = document.querySelector('input[name="__RequestVerificationToken"]').value;
        $.ajax({
            url: applicationPath + 'PageReloaderComponent/DeleteBasket',
            type: 'POST',
            data: {__RequestVerificationToken: token},
            success: function() {
                goToSuccessPage();
            },
            error: function() {
                goToErrorPage();
            },
        });
    }

    function goToSuccessPage() {
        const attemptToContinue = getUrlParameter('startAgain');
        if (attemptToContinue && attemptToContinue.toLocaleLowerCase().trim() === 'true') {
            const startPage = sessionStorage.getItem('MTAStartPage');
            if (startPage) {
                bgl.common.utilities.redirectToUrl(startPage);
                return;
            }
        }
        bgl.common.utilities.redirectToUrl(applicationPath + 'PolicyOverview/Vehicle');
    }

    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        const results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    function goToErrorPage() {
        bgl.common.utilities.redirectToUrl(applicationPath + 'Error');
    }

    return {
        init: initComponent,
    };
})();
if (typeof module !== 'undefined') {
    module.exports = bgl.components.pagereloader;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.outofhours = bgl.components.outofhours || {};

bgl.components.outofhours = (function() {
    let configuration;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
            });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;

        const componentId = configuration.Id.toLowerCase();

        $(document).on('submit', '[data-component-id=\'' + configuration.Id + '\'] form',
            function(event) {
                event.preventDefault();

                bgl.common.validator.init($(this));
                bgl.common.validator.submitForm($(this), configuration);
            });

        $(document).on('input', 'textarea[data-id=\'' + componentId + '-message\']', function() {
            $('[data-id=\'' + componentId + '-charactersRemaining\']').html(300 - $(this).val().length);
        });

        $(document).on('click', 'a[data-id=\'' + componentId + '-close\']', function() {
            window.close();
        });

        $(document).on('click', 'a[data-id=\'' + componentId + '-cross\']', function() {
            window.close();
        });
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.outofhours;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};

bgl.components.optionalextras = (function() {
    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(componentConfiguration, componentUrl, containerElementId, function() {
            initComponent();
        });
    }

    function initComponent() {
        bgl.common.accordions.init();
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.optionalextras;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};

bgl.components.navigation = (function() {
    let configuration;

    let pagesWithAsyncComponents = [];

    let pagesWithoutBackAction = [];

    let pathName;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        configuration = componentConfiguration;

        bgl.common.loader.load(configuration, componentUrl, containerElementId, function() {
            bgl.components.navigation.init(configuration);
        });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        activateTabFromQuery();
    }

    function initBackButtonFromOopsPage(listOfPagesWithoutBackAction, listOfPagesWithAsyncComponents) {
        pagesWithAsyncComponents = listOfPagesWithAsyncComponents || [];

        pagesWithoutBackAction = listOfPagesWithoutBackAction || [];

        const location = bgl.common.utilities.getWindowLocation();

        pathName = location.pathname;

        const result = isPagesWithoutBackAction(pathName);

        if (result === true) {
            sessionStorage.setItem('hideBackButton', true);
        }

        $(document).ready(function() {
            sessionStorage.setItem('hideBackButton', isPagesWithoutBackAction(pathName));

            const index = jQuery.inArray(pathName, pagesWithAsyncComponents);

            if ((index > -1) === false) {
                sessionStorage.setItem('loaded_page', pathName);
            }
        });
    }

    function showBackButtonOnOopsPage(listOfPagesWithoutBackAction, failedAction) {
        pagesWithoutBackAction = listOfPagesWithoutBackAction || [];

        pathName = decodeURIComponent(failedAction);

        $(document).ready(function() {
            const backLink = $('a[data-role=\'back-button-from-error\']');

            const hideBackButtonValue = sessionStorage.getItem('hideBackButton');

            const hideBackButton = hideBackButtonValue === null ||
        hideBackButtonValue === 'true' ||
        isPagesWithoutBackAction(pathName);

            if (hideBackButton) {
                backLink.hide();
            } else {
                const pageAction = sessionStorage.getItem('loaded_page');
                backLink.attr('href', pageAction);
            }
        });
    }

    function isPagesWithoutBackAction(pathName) {
        const index = pagesWithoutBackAction.length > 0 ? jQuery.inArray(pathName, pagesWithoutBackAction) : -1;

        return (index > -1) === true;
    }

    function activateTabFromQuery() {
        const params = new URLSearchParams(window.location.search);
        const activeTab = params.get('tabName');

        if (!activeTab) {
            return;
        }

        setTimeout(() => {
            document.getElementById(`${activeTab}-tab`)?.click();
        }, 200);
    }

    return {
        init: initComponent,
        load: loadComponent,
        initBackButtonFromOopsPage: initBackButtonFromOopsPage,
        showBackButtonOnOopsPage: showBackButtonOnOopsPage,
        activateTabFromQuery: activateTabFromQuery,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.navigation;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.marketingpreferencesadd = bgl.components.marketingpreferencesadd || {};

bgl.components.marketingpreferencesadd.thirdparty = (function() {
    let validationTriggered = false;
    const questions = ['email', 'post', 'devicemessaging', 'textmessages', 'phone'];

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
    }

    function initComponent(componentConfiguration) {
        const configuration = componentConfiguration;

        populateFromSessionStorage(configuration.Id);
        generateClickOnKeyPressForLabels(configuration.Id);
        document.body.querySelector('#MarketingPreferencesNextButton').addEventListener('click', function(event) {
            event.preventDefault();
            onNextClick(configuration);
        });

        document.body.querySelector('#MarketingPreferencesBackButton').addEventListener('click', function(event) {
            event.preventDefault();
            onBackClick(configuration);
        });

        const allLabels = document.body.querySelectorAll('[data-type="marketing-preference-radio-label"]');
        for (let i = 0; i < allLabels.length; i++) {
            allLabels[i].addEventListener('click',
                function(event) {
                    event.preventDefault();
                    const elementFor = this.getAttribute('for');
                    document.body.querySelector('#' + elementFor).checked = true;
                    if (validationTriggered) {
                        showValidation(configuration.Id);
                    }
                });
        }
    }

    function generateClickOnKeyPressForLabels(componentId) {
        const selector = document.body.querySelectorAll('[data-testid="' + componentId + '-page-section"] label');
        for (let i = 0; i < selector.length; i++) {
            selector[i].addEventListener('keydown', function(event) {
                const SPACE_KEYCODE = 32;
                const ENTER_KEYCODE = 13;
                const code = event.charCode || event.keyCode;
                if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
                    event.preventDefault();
                    event.currentTarget.click();
                }
            });
        }
    }

    function onNextClick(configuration) {
        if (areAllQuestionsAnswered(configuration.Id)) {
            addMarketingPreferencesToSessionStorage(configuration.Id);
            navigateToNextPage(configuration);
        } else {
            showValidation(configuration.Id);
            scrollToListItemWithError(configuration.Id);
        }
    }

    function onBackClick(configuration) {
        addMarketingPreferencesToSessionStorage(configuration.Id);
        navigateToPreviousPage(configuration);
    }

    function showValidation(componentId) {
        validationTriggered = true;
        for (let i = 0; i < questions.length; i++) {
            if (!isRadioButtonChecked(`#${componentId}-${questions[i]}-yes`) &&
            !isRadioButtonChecked(`#${componentId}-${questions[i]}-no`)) {
                addClassToElementIfItExists(`#${componentId}-${questions[i]}-fieldset-container`, 'error');
                addClassToElementIfItExists(`#${componentId}-${questions[i]}-heading`, 'error-text__heading');
                addClassToElementIfItExists(`#${componentId}-${questions[i]}-list-item`, 'error');
                addClassToElementIfItExists(`#${componentId}-${questions[i]}-heading-text`, 'error');
            } else {
                removeClassFromElementIfItExists(`#${componentId}-${questions[i]}-fieldset-container`, 'error');
                removeClassFromElementIfItExists(`#${componentId}-${questions[i]}-heading`, 'error-text__heading');
                removeClassFromElementIfItExists(`#${componentId}-${questions[i]}-list-item`, 'error');
                removeClassFromElementIfItExists(`#${componentId}-${questions[i]}-heading-text`, 'error');
            }
        }
    }

    function scrollToListItemWithError(componentId) {
        const listItemsInErrorState = document.body.querySelectorAll(
            '[data-type="marketing-preference-list-item"].error',
        );

        if (listItemsInErrorState.length > 0) {
            listItemsInErrorState[0].scrollIntoView(true);
            const headerHeight = document.body.querySelector('header').offsetHeight;
            const currentYPosition = window.scrollY;
            if (currentYPosition) {
                window.scroll(0, currentYPosition - headerHeight);
            }
        }
    }

    function addClassToElementIfItExists(elementSelector, className) {
        const element = document.body.querySelector(elementSelector);
        if (element != null) {
            element.classList.add(className);
        }
    }

    function removeClassFromElementIfItExists(elementSelector, className) {
        const element = document.body.querySelector(elementSelector);
        if (element != null) {
            element.classList.remove(className);
        }
    }

    function navigateToNextPage(configuration) {
        bgl.common.utilities.redirectToUrl(configuration.NextPageLink);
    }

    function navigateToPreviousPage(configuration) {
        bgl.common.utilities.redirectToUrl(configuration.BackLink);
    }

    function areAllQuestionsAnswered(componentId) {
        for (let i = 0; i < questions.length; i++) {
            if (!isRadioButtonChecked('#' + componentId + '-' + questions[i] + '-yes') &&
        !isRadioButtonChecked('#' + componentId + '-' + questions[i] + '-no')) {
                return false;
            }
        }
        return true;
    }

    function addMarketingPreferencesToSessionStorage(componentId) {
        const preferences = {
            email: getPreferenceValue(componentId, 'email'),
            post: getPreferenceValue(componentId, 'post'),
            deviceMessaging: getPreferenceValue(componentId, 'devicemessaging'),
            sms: getPreferenceValue(componentId, 'textmessages'),
            telephone: getPreferenceValue(componentId, 'phone'),
        };
        sessionStorage.setItem('marketingPreferences', JSON.stringify(preferences));
    }

    function getPreferenceValue(componentId, preference) {
        if (isRadioButtonChecked('#' + componentId + '-' + preference + '-yes')) {
            return true;
        } else if (isRadioButtonChecked('#' + componentId + '-' + preference + '-no')) {
            return false;
        } else {
            return null;
        }
    }

    function populateFromSessionStorage(componentId) {
        const preferences = JSON.parse(sessionStorage.getItem('marketingPreferences'));
        if (preferences != null) {
            setPreference(componentId, 'email', preferences.email);
            setPreference(componentId, 'post', preferences.post);
            setPreference(componentId, 'devicemessaging', preferences.deviceMessaging);
            setPreference(componentId, 'textmessages', preferences.sms);
            setPreference(componentId, 'phone', preferences.telephone);
        }
    }

    function setPreference(componentId, name, value) {
        if (value === true) {
            document.body.querySelector('#' + componentId + '-' + name + '-yes').checked = true;
        } else if (value === false) {
            document.body.querySelector('#' + componentId + '-' + name + '-no').checked = true;
        }
    }

    function isRadioButtonChecked(radioButtonSelector) {
        return document.body.querySelector(radioButtonSelector).checked;
    }

    function initialiseMarketingPrefsEvent() {
        initSubmitThirdPartyMarketingPreferencesEvent();
    }

    function initSubmitThirdPartyMarketingPreferencesEvent() {
        bgl.common.pubsub.on('SubmitThirdPartyMarketingPreferences', (data) => {
            waitForPartnerIntegration(data);
        });
    }

    function waitForPartnerIntegration(data) {
        const interval = 500;
        const timeoutDuration = 5000;
        const pollUrl = 'ThirdPartyMarketingPreferencesComponent/IsCustomerIntegrated';
        const tickCount = new Date().getTime();
        const timeout = tickCount + timeoutDuration;

        poll(timeout, interval, pollUrl, data);
    }

    function poll(timeout, interval, pollUrl, data) {
        const dataToPost = {
            __RequestVerificationToken: data.RequestVerificationToken,
            CustomerAccountId: data.PolicyId,
            BrandCode: data.BrandCode,
            Authorization: data.Authorization,
        };

        $.ajax({
            url: data.ApplicationPath + pollUrl,
            type: 'Post',
            cache: false,
            data: dataToPost,
            dataType: 'json',
            success: (response) => {
                if (response.Status === 'Processing') {
                    if (timeout >= new Date().getTime()) {
                        setTimeout(() => {
                            poll(timeout, interval, pollUrl, data);
                        }, interval);
                    } else {
                        bgl.common.telemetry.logEvent(
                            'Partner integration timeout reached. Third party marketing preferences not submitted');
                        callAuthenticationSignOut(data);
                    }
                } else if (response.Status === 'Integrated') {
                    submitThirdPartyMarketingPreferences(data);
                } else {
                    callAuthenticationSignOut(data);
                }
            },
            error: () => {
                bgl.common.telemetry.logEvent(
                    'Error occured in partner integration poll. Third party marketing preferences not submitted');
                callAuthenticationSignOut(data);
            },
        });
    }

    function submitThirdPartyMarketingPreferences(data) {
        const dataToPost = {
            __RequestVerificationToken: data.RequestVerificationToken,
            MarketingPreferences: JSON.parse(data.MarketingPreferences),
            BrandCode: data.BrandCode,
            CustomerAccountId: data.PolicyId,
            Authorization: data.Authorization,
        };

        $.ajax({
            url: data.ApplicationPath + 'ThirdPartyMarketingPreferencesComponent/SubmitThirdPartyMarketingPreferences',
            type: 'POST',
            data: dataToPost,
            dataType: 'json',
            complete: () => {
                callAuthenticationSignOut(data);
            },
        });
    }

    function callAuthenticationSignOut(data) {
        const signOutData = {
            RequestVerificationToken: data.RequestVerificationToken,
            ApplicationPath: data.ApplicationPath,
            RedirectUrl: data.RedirectUrl,
        };
        bgl.common.pubsub.emit('CallAuthenticationSignOutInTakePayment', signOutData);
    }

    return {
        init: initComponent,
        load: loadComponent,
        initMarketingPrefsEvent: initialiseMarketingPrefsEvent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};

bgl.components.marketingpreferences = (function() {
    let component;
    let submitSaveInProgress = false;
    let skipPreferenceSaveOnce = false;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(componentConfiguration, componentUrl, containerElementId, function() {
            initComponent(componentConfiguration);
        });
    }

    function initComponent(componentConfiguration) {
        const SPACE_KEYCODE = 32;
        const ENTER_KEYCODE = 13;

        submitSaveInProgress = false;
        skipPreferenceSaveOnce = false;

        component = $('#' + componentConfiguration.Id);

        if (componentConfiguration.SaveOnSubmitSelector) {
            bindSubmitSave(componentConfiguration);
        }

        if (componentConfiguration.SaveOnChange || !componentConfiguration.SaveOnSubmitSelector) {
            component.find('input[type=\'checkbox\']').on('change', submitComponentForm);
        }

        component.find('a[data-id=optOutAll]').on('click', function(event) {
            event.preventDefault();

            submitOptOutAll();
        });

        $('.contact-tiles__tile').off('keypress').on('keypress',
            function(event) {
                const code = event.charCode || event.keyCode;

                if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
                    event.preventDefault();
                    $(this).click();
                    $(this).focus();
                }
            });
    }

    function bindSubmitSave(componentConfiguration) {
        $(componentConfiguration.SaveOnSubmitSelector).each(function() {
            const submitElement = this;

            if (submitElement.marketingPreferencesSubmitHandler) {
                submitElement.removeEventListener('click', submitElement.marketingPreferencesSubmitHandler, true);
            }

            $(submitElement).off('click.marketingPreferences');

            submitElement.marketingPreferencesSubmitHandler = function(event) {
                if (skipPreferenceSaveOnce) {
                    skipPreferenceSaveOnce = false;
                    return;
                }

                event.preventDefault();
                event.stopImmediatePropagation();

                if (submitSaveInProgress) {
                    return;
                }

                submitSaveInProgress = true;
                saveBeforeSubmit(submitElement);
            };

            $(submitElement).on('click.marketingPreferences', submitElement.marketingPreferencesSubmitHandler);
        });
    }

    function saveBeforeSubmit(submitElement) {
        function continueSubmit() {
            submitSaveInProgress = false;
            skipPreferenceSaveOnce = true;
            submitElement.click();
        }

        submitComponentForm(continueSubmit, continueSubmit, true);
    }

    function getData() {
        const token = component.find('input[name=\'__RequestVerificationToken\']').val();
        const radioButtonList = [];

        component.find('.contact-tiles__input[type=\'checkbox\']').each(function() {
            const element = $(this);
            radioButtonList.push({
                Id: element.data('preference-id'),
                IsContactTileSelected: element.is(':checked'),
            });
        });

        return {
            __RequestVerificationToken: token,
            variant: component.find('[data-id=variant]').val(),
            MarketingPreferences: radioButtonList,
        };
    }

    function submitComponentForm(onSuccess, onError, suppressErrorRedirect) {
        const form = component.find('form');
        if (typeof bgl.common.pubsub !== 'undefined') {
            bgl.common.pubsub.emit('fakeFormSubmit', form.attr('id') || form.attr('action') || 'unknown');
        }
        $.ajax({
            url: $(form).attr('action'),
            type: $(form).attr('method'),
            data: getData(),
            success: function(data) {
                if (!data.isSuccess && !suppressErrorRedirect) {
                    bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                }

                if (typeof onSuccess === 'function') {
                    onSuccess(data);
                }
            },
            error: function() {
                if (typeof onError === 'function') {
                    onError();
                }
            },
        });
    }

    function submitOptOutAll() {
        const form = component.find('form');
        if (typeof bgl.common.pubsub !== 'undefined') {
            bgl.common.pubsub.emit('fakeFormSubmit', form.attr('id') || form.attr('action') || 'unknown');
        }
        const token = component.find('input[name="__RequestVerificationToken"]').val();

        $.ajax({
            url: $(form).attr('action'),
            type: $(form).attr('method'),
            data: {__RequestVerificationToken: token},
            success: function(data) {
                if (data.isSuccess) {
                    $('[data-id=optOutAllConfirmation]').removeClass('hide');
                } else {
                    bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                }
            },
        });
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.marketingpreferences;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};

bgl.components.googletagmanager = (function() {
    let gtmContainerId;
    let gtmApplicationPath;

    function initComponent(containerId, applicationPath) {
        gtmContainerId = containerId;
        gtmApplicationPath = applicationPath;

        window.dataLayer = window.dataLayer || [];

        if (gtmContainerId) {
            // gtmStart(window, document, 'script', 'dataLayer', gtmContainerId);
            gtmStartWithOneTrust(
                window,
                document,
                'script',
                'dataLayer',
                gtmContainerId,
                'cdn-ukwest.onetrust.com',
                'Optanon',
            );
        }

        updateGTMPolicyId();
    }

    function gtmStartWithOneTrust(w, d, s, l, g, o1, o2) {
        w[l] = w[l] || []; w[l].push({
            'gtm.start':
                new Date().getTime(), 'event': 'gtm.js',
        });
        let f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        const dl = l !== 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + g + dl;
        for (let i = 0; i < d.getElementsByTagName(s).length; i++) {
            if (i > 0) f = d.getElementsByTagName(s)[i];
            if ((f.outerHTML.indexOf(o1) === -1) && (f.outerHTML.indexOf(o2) === -1)) {
                break;
            }
        }
        f.parentNode.insertBefore(j, f);
    }

    function updateGTMPolicyId() {
        bgl.common.pubsub.on('UpdateGTMPolicyId', function(policyId) {
            dataLayer.push({'policyNumber': policyId});

            const url = gtmApplicationPath + 'GoogleTagManagerComponent/GetECommerceDataLayer?policyId=' + policyId;

            $.ajax({
                url: url,
                type: 'GET',
                success: function(data) {
                    const eCommmerceData = JSON.parse(data);
                    dataLayer.push(eCommmerceData);
                },
            });
        });
    }

    return {
        init: initComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.googletagmanager;
}
/* global CookieControl */
// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.googletagmanager = bgl.components.googletagmanager || {};

bgl.components.googletagmanager.civiccookie = (function() {
    let configuration;
    let intervalId;
    let retries = 0;

    function initComponent(componentConfiguration, applicationPath) {
        configuration = componentConfiguration;
        intervalId = setInterval(loadCookie, 500);
        onloadDataLayer();
    }

    function onloadDataLayer() {
        window.dataLayer = window.dataLayer || [];

        window.gtag = window.gtag || function(...args) {
            window.dataLayer.push(args);
        };

        window.gtag('consent', 'default', {
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            analytics_storage: 'denied',
            functionality_storage: 'denied',
        });
    }
    function loadCivicCookie() {
        const cookieConfig = {
            apiKey: configuration.CivicConfiguration.ApiKey,
            product: 'CUSTOM',
            position: 'LEFT',
            initialState: 'OPEN',
            rejectButton: false,
            mode: 'gdpr',
            settingsStyle: 'button',
            notifyDismissButton: false,
            theme: 'dark',
            branding: {
                fontSizeTitle: '14px',
                fontSizeHeaders: '14px',
                fontSize: '14px',
                removeAbout: true,
            },
            consentCookieExpiry: 365,
            setInnerHTML: true,
            closeStyle: 'button',
            text: {
                closeLabel: 'Save settings',
                notifyTitle: 'Your choice regarding cookies on this site',
                notifyDescription:
                    'At ' + configuration.TenantConfiguration.Name + ' we use cookies to help us to deliver ' +
                    'the best experience for our ' +
                    'customers. Some cookies are essential for our websites to work correctly, but others ' +
                    'allow us to track their performance or help personalise content. Some third parties who ' +
                    'provide us with services may use their own cookies which we have no control over or ' +
                    'liability for. For more information please see our Cookie Policy.',
                accept: 'Accept all and continue',
                settings: 'Manage cookies',
                title: 'Cookie Preferences',
                intro:
                    'At ' + configuration.TenantConfiguration.Name + ' we use cookies to help us to deliver the ' +
                    'best experience for our ' +
                    'customers. Some cookies are essential for our websites to work correctly, but others allow us ' +
                    'to track their performance or help personalise content. Some third parties who provide us ' +
                    'with services may use their own cookies which we have no control over or liability for. For ' +
                    'more information please see our <a href=' + configuration.CivicConfiguration.PolicyUrl +
                    ' target="_blank" >Cookie Policy</a>.' +
                    '<p>\'Accept all\' will keep all the cookies active, or you can manage them below.</p>',
                acceptSettings: '<span>Accept all and continue</span>',
                necessaryTitle: 'Essential cookies',
                necessaryDescription:
                    'These are required for our websites to function and cannot be switched off. ' +
                    'If you block these cookies via your browser our website will not work properly.',
                on: '',
                off: '',
            },
            onLoad: function() {
                document.addEventListener('keydown', function(event) {
                    if (event.key === 'Escape') {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                });
                _disableScrollBody();
                document.addEventListener('click', function() {
                    _disableScrollBody();
                });
                const element = document.querySelector('#ccc');
                if (element) {
                    _handleToggleBtnStyle();
                    element.style.visibility = 'visible';
                    element.addEventListener('click', () => {
                        _handleToggleBtnStyle();
                    });
                }
                CookieControl.delete('cb-enabled');
            },
            necessaryCookies: [
                '.AspNetCore.Antiforgery', 'SwintonGoSessionCookie', 'SwintonGoAuth', 'ai_session', 'ai_user',
                '__cf_bm', 'ADVISOR_RESPONSE', 'OMG-662455', 'OMG-Channel-662455', 'OMGID', 'OMGSession',
                'AWSALB', 'AWSALBCORS',
            ],
            optionalCookies: [
                {
                    name: 'functions',
                    label: 'Functional cookies',
                    description:
                        'These help us to enhance the experience for our customers by storing information about ' +
                        'previous selections or preferences, so we can personalise the website.',
                    cookies: ['sf-trckngckie'],
                    onAccept: function() {
                        window.gtag('consent', 'update', {
                            functionality_storage: 'granted',
                        });
                        window.dataLayer.push({event: 'functional_consent_granted'});
                    },
                    onRevoke: function() {
                        window.gtag('consent', 'update', {
                            functionality_storage: 'denied',
                        });
                        window.dataLayer.push({event: 'functional_consent_denied'});
                    },
                },
                {
                    name: 'analytics',
                    label: 'Analytical Cookies',
                    description:
                        'These collect anonymous information about how visitors use our website, this helps ' +
                        'inform if we have the right content for our customers, if it is easy to find and what ' +
                        'we need to do to improve the experience.',
                    cookies: [
                        'FPLC', '_ga', '_gac_*', '_gid', '_gat_*', '__utma', '__utmb', '__utmc', '__utmt', '__utmz',
                        '__utmv', 'AMP_TOKEN', 'FPID', '_ga_*', '_dc_gtm_*', 'ce*', '_ce*', '_clsk', '_clck', 'CLID',
                        'MUID', 'ANONCHK', 'MR', 'SM', 'mbox', 'mboxEdgeCluster', 'at_check', 'AMCV*', 's_ecid',
                        's_cc', 's_sq', 's_vi', 's_fid', 's_ac', 'gpv*',
                    ],
                    onAccept: function() {
                        window.gtag('consent', 'update', {
                            analytics_storage: 'granted',
                        });
                        window.dataLayer.push({event: 'analytics_consent_granted'});
                    },
                    onRevoke: function() {
                        window.gtag('consent', 'update', {
                            analytics_storage: 'denied',
                        });
                        window.dataLayer.push({event: 'analytics_consent_denied'});
                    },
                },
                {
                    name: 'marketing',
                    label: 'Marketing cookies',
                    description:
                        'These help us better understand how you use our website, and allow us to provide ' +
                        'relevant advertising based on the pages you visit or the products you have viewed. These ' +
                        'ads may be displayed on our, or other, sites you visit.',
                    cookies: [
                        '__gsas', '__gpi', '__gpi_optout', 'NID', 'DSID', '__gads', 'GED_PLAYLIST_ACTIVITY',
                        'ACLK_DATA', 'receive-cookie-deprecation', 'FPAU', 'ANID*', 'AID*', 'ar_debug', 'IDE', 'TAID*',
                        'FPGCLDC', '_gcl_dc', '_gcl_au', 'FLC', 'RUL', 'FPGCLAW', 'FPGCLGB', 'FPGSID', '_gcl_gb',
                        '_gac_gb_<wpid>', '_gcl_aw', 'GCL_AW_P', '_gcl_gs', '_gcl_ag', '1P_JAR*', 'Conversion', 'YSC',
                        'VISITOR_INFO1_LIVE', 'VISITOR_INFO1_LIVE__k', 'VISITOR_INFO1_LIVE__default', '_fbc', '_fbp',
                        '_lcc', '_tmae', '_tmid', 'adcloud', 'ev_sync_*', 'everest_g_v2', 'everest_session_v2',
                        'id_adclou',
                    ],
                    onAccept: function() {
                        window.gtag('consent', 'update', {
                            ad_storage: 'granted',
                            ad_user_data: 'granted',
                            ad_personalization: 'granted',
                        });
                        window.dataLayer.push({event: 'marketing_consent_granted'});
                    },
                    onRevoke: function() {
                        window.gtag('consent', 'update', {
                            ad_storage: 'denied',
                            ad_user_data: 'denied',
                            ad_personalization: 'denied',
                        });
                        window.gtag('set', 'ads_data_redaction', true, {
                            wait_for_update: 100,
                        });
                        window.dataLayer.push({event: 'marketing_consent_denied'});
                    },
                },
            ],
        };

        if (CookieControl) {
            CookieControl.load(cookieConfig);
        }
    }

    function _disableScrollBody() {
        const el = document.getElementById('ccc-icon');
        const isShowCivicUk = el.getAttribute('aria-expanded');
        document
            .querySelector('html')
            .classList.toggle('disableScroll', isShowCivicUk === 'true');
    }

    function _handleToggleBtnStyle() {
        const elms = document.getElementsByClassName('checkbox-toggle-input');
        if (elms && elms.length > 0) {
            for (const element of elms) {
                const toggle = element.closest('.checkbox-toggle');
                if (toggle) {
                    toggle.classList.toggle('checkbox-toggle-checked', element.checked);
                }
            }
        }
    }

    function loadCookie() {
        if (typeof CookieControl !== 'undefined') {
            clearInterval(intervalId);
            loadCivicCookie();
        }

        retries++;
        if (retries <= 20) {
            console.log(`Retries: ${retries}`);
            clearInterval(intervalId);
        }
    }

    return {
        init: initComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.googletagmanager.civiccookie;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};

bgl.components.footer = (function() {
    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(componentConfiguration, componentUrl, containerElementId, function() {
            bgl.components.footer.init();
        });
    }

    function initComponent() {
        eventListener();
    }

    function eventListener() {
        bgl.common.pubsub.on('switchPaymentType', function(isMonthly) {
            switchPaymentType(isMonthly);
        });
    }

    function switchPaymentType(isMonthly) {
        const monthlyLink = document.getElementById('monthly-link');

        if (isMonthly) {
            monthlyLink.classList.remove('hide');
        } else {
            monthlyLink.classList.add('hide');
        }
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.footer;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.ukresidentfiveyears = (function() {
    let form;
    let configuration;
    let residencyStartDateDropdowns;
    let fullYearMonthOptions;
    let currentYearMonthOptions;
    let firstYearMonthOptions;
    let monthDropdown;
    let yearDropdown;
    const HIDE_CLASS = 'hide';
    let hasPreselectedValues = false;

    function initComponent(componentConfiguration) {
        initObject(componentConfiguration);

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        subscribeForEvents();

        updateMonthDropdown();
    }

    function initObject(componentConfiguration) {
        const currentMonth = $('#CurrentMonth').val() * 1;

        configuration = componentConfiguration;
        form = $('#uk-resident-five-years');
        residencyStartDateDropdowns = form.find('#residency-start-date-dropdowns');
        monthDropdown = form.find('#Resident-Since-Month');
        yearDropdown = form.find('#Resident-Since-Year');

        bgl.common.validator.init(form);

        fullYearMonthOptions = monthDropdown.find('option');
        currentYearMonthOptions = fullYearMonthOptions.slice(0, currentMonth + 1);
        firstYearMonthOptions = fullYearMonthOptions.slice(0);
        firstYearMonthOptions.splice(1, currentMonth - 1);
    }

    function subscribeForEvents() {
        hasPreselectedValues = form.find('input[type=radio]:checked').length !== 0;

        if (hasPreselectedValues) {
            showContinueButton();

            const selectedButton = $(form.find('input[type=radio]:checked')[0]);
            switch (selectedButton.val().toLowerCase()) {
            case 'false':
                if (residencyStartDateDropdowns.hasClass(HIDE_CLASS)) {
                    residencyStartDateDropdowns.removeClass(HIDE_CLASS);
                }
                break;
            }
        }

        form.find('input[type=radio]').off('click').on('click',
            function(event) {
                $(event.target).prop('checked', true);

                updateResidencyStartDateVisibility();

                if (hasPreselectedValues !== true) {
                    continueHandler(event);
                }
            });

        yearDropdown.on('change', updateMonthDropdown);

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(this))) {
                        $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)) === true);

                        bgl.common.validator.submitForm($(this), configuration);
                    }
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function updateResidencyStartDateVisibility() {
        const value = form.find('input[type=radio]:checked').val();

        if (value.toLowerCase() === 'false') {
            if (residencyStartDateDropdowns.hasClass(HIDE_CLASS)) {
                residencyStartDateDropdowns.removeClass(HIDE_CLASS);
            }

            hasPreselectedValues = true;
        } else {
            if (!residencyStartDateDropdowns.hasClass(HIDE_CLASS)) {
                residencyStartDateDropdowns.addClass(HIDE_CLASS);
            }
        }

        if (hasPreselectedValues === true) {
            showContinueButton();
        }
    }

    function showContinueButton() {
        const continueButton = $(form.find('[type=\'submit\']'));
        continueButton.removeClass('hide');
    }

    function continueHandler(event) {
        event.preventDefault();

        if ($(event.target).is(':checked')) {
            $(event.target).trigger('change');
        }

        form.submit();
    }

    function updateMonthDropdown() {
        const months = monthDropdown;
        const selectedMonthValue = months.val();
        const currentYear = $('#CurrentYear').val();
        const firstYear = (currentYear - 5).toString();

        switch (yearDropdown.val()) {
        case currentYear:
            months.html(currentYearMonthOptions);
            break;
        case firstYear:
            months.html(firstYearMonthOptions);
            break;
        default:
            months.html(fullYearMonthOptions);
            break;
        };

        months.val(selectedMonthValue);

        // select first value if value is not selected
        if (!months.val()) {
            months.find('option:eq(0)').prop('selected', true);
        }
    }

    function onSuccess(configuration, data) {
        if (data.isUkResident === true) {
            bgl.common.datastore.deleteFields(form,
                [
                    'UkResidentYear', 'UkResidentYearVal', 'UkResidentYearText',
                    'UkResidentMonth', 'UkResidentMonthVal', 'UkResidentMonthText',
                ]);
        }

        if (data.nextDtsPageUrl) {
            bgl.common.utilities.redirectToUrl(data.nextDtsPageUrl);
        }
    }

    function onError() {
        bgl.components.driverdetails.ukresidentfiveyears.init(configuration);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.typeoflicence = (function() {
    let form;
    let configuration;
    let licenceInputs;
    const internationalLabel = 'I';
    let hasPreselectedValues;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;

        form = $('#type-of-licence');

        licenceInputs = form.find('#licence-section [type=radio]');

        bgl.common.validator.init(form);

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        const person = bgl.common.datastore.getData(form);
        const selectedEmploymentStatus = person.EmploymentStatusId;

        const hasOccupation = configuration.StatusCodesToAskOccupation.filter(function(value) {
            return selectedEmploymentStatus.toLowerCase() === value.toLowerCase();
        }).length !== 0;

        if (hasOccupation) {
            document.getElementById(configuration.Id + '-back-button').
                setAttribute('href', configuration.PreviousBusinessTypePageUrl);
        }

        subscribeOnEvents();
    }

    function subscribeOnEvents() {
        hasPreselectedValues = form.find('input[type=radio]:checked').length !== 0;

        updateCountrySectionVisibility();

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(this))) {
                        $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)) === true);

                        bgl.common.validator.submitForm($(this), configuration);
                    }
                });

        licenceInputs.off('click').on('click',
            function(event) {
                updateCountrySectionVisibility();

                if (hasPreselectedValues !== true) {
                    continueHandler(event);
                }
            });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function showContinueButton() {
        const continueButton = $(form.find('[type=\'submit\']'));
        continueButton.removeClass('hide');
    }

    function updateCountrySectionVisibility() {
        const countriesSection = form.find('#licence-row');

        const checkedLicenceValue = findCheckedLicenceValue();

        if (checkedLicenceValue === internationalLabel) {
            hasPreselectedValues = true;
            countriesSection.removeClass('hide');
        } else {
            countriesSection.addClass('hide');
        }

        if (hasPreselectedValues === true) {
            showContinueButton();
        }
    }

    function continueHandler(event) {
        event.preventDefault();

        if ($(event.target).is(':checked')) {
            $(event.target).trigger('change');
        }

        form.submit();
    }

    function onSuccess(configuration, data) {
        if (data.isInternationalType === false) {
            bgl.common.datastore.deleteFields(form,
                [
                    'Country', 'CountryVal', 'CountryText',
                ]);
        }

        if (data.isInternationalType === true) {
            bgl.common.datastore.deleteFields(form,
                [
                    'HasDrivingLicenceNumber', 'DrivingLicenceNumber',
                ]);
        }

        location.href = data.nextDtsPageUrl;
    }

    function onError() {
        bgl.components.driverdetails.typeoflicence.init(configuration);

        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    function findCheckedLicenceValue() {
        return form.find('#licence-section [type=radio]:checked').val();
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.searchaddress = (function() {
    let configuration;
    let containerId;
    let form;
    const BACK_URL_STACK_KEY = 'backUrlStack';

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        configuration = componentConfiguration;
        containerId = document.getElementById(containerElementId).parentElement.getAttribute('id');

        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                bgl.components.driverdetails.searchaddress.init(configuration);
                setSessionStorageItems();
                sessionStorage.removeItem(BACK_URL_STACK_KEY);
            },
        );
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        containerId = document.getElementById(componentConfiguration.Id).parentElement.getAttribute('id');
        form = $('form');
        if (form.attr('data-step') === 'confirm') {
            bgl.common.datastore.setupReadAndWrite();
        } else {
            bgl.common.datastore.init(form);
            bgl.common.datastore.setupReadAndWrite();
        }

        bgl.common.validator.enableMaxLength();
        bgl.common.validator.init(form);

        initAjaxLink();
        initBackButtonLink();
        initPostcodeFieldTrim();

        setElementFocusIfIsOnPage('Line1'); // Manual entry
        setElementFocusIfIsOnPage('Home'); // Search entry

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();
                    if (bgl.common.validator.isFormValid(form)) {
                        const quoteId = $('#QuoteId').val();

                        if (form.attr('data-step') === 'confirm' && quoteId !== '') {
                            bgl.common.validator.submitForm(form, configuration);
                        } else if (form.attr('data-step') === 'confirm' && quoteId === '') {
                            const dataToPost = form.serialize();
                            $.ajax({
                                url: configuration.TenantConfiguration.ApplicationPath + 'Account/' + 'NewLeadEntry',
                                type: 'POST',
                                cache: false,
                                dataType: 'json',
                                data: dataToPost,
                                success: function(data) {
                                    if (data.isSuccess === false) {
                                        bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                                        return;
                                    }
                                    sessionStorage.setItem('CustomerFirstName', data.customerFirstName);
                                    sessionStorage.setItem('CustomerAccountId', data.customerAccountId);
                                    bgl.common.utilities.redirectToUrl(data.redirectUrl);
                                },
                            });
                        } else {
                            bgl.common.validator.submitForm(form, configuration);
                        }
                    }
                });
    }

    function setSessionStorageItems() {
        const addressId = $('[name="AddressId"]').val();
        const postcode = $('[name="PostCode"]').val();
        const home = $('[name="Home"]').val();

        sessionStorage.setItem('addressId', addressId);
        sessionStorage.setItem('postCode', postcode);
        sessionStorage.setItem('home', home);
    }

    function loadView(url) {
        const sessionStorageData = JSON.parse(sessionStorage.getItem(configuration.DataStoreKey));

        let data = {
            ComponentConfiguration: configuration,
            AddressId: sessionStorageData.AddressId,
        };

        if (url.indexOf('SearchAddress') !== -1) {
            sessionStorage.removeItem(BACK_URL_STACK_KEY);
            data = configuration;
        } else if (url.indexOf('SelectAddress') !== -1) {
            data.PostCode = sessionStorageData.PostCode;
            data.Home = sessionStorageData.Home;
        }

        bgl.common.loader.load(data,
            url,
            containerId,
            function() {
                initComponent(configuration);
            });
    }

    function initAjaxLink() {
        $('.ajax-address-link')
            .off('click')
            .on('click',
                function(e) {
                    e.preventDefault();
                    const url = $(this).attr('href');
                    const backButtonUrl = $(this).data('back-url');
                    pushBackButtonUrl(backButtonUrl);
                    loadView(url);
                });
    }

    function initBackButtonLink() {
        $('.back-button-link')
            .off('click')
            .on('click',
                function(e) {
                    e.preventDefault();
                    const url = getBackButtonUrlFromStack();
                    if (url) {
                        $(this).hide();
                        loadView(url);
                    } else {
                        location.href = configuration.PreviousStepUrl;
                    }
                });
    }

    function initPostcodeFieldTrim() {
        $('#PostCode')
            .on('blur',
                function(e) {
                    $(this).val($(this).val().trim());
                });
    }

    function setElementFocusIfIsOnPage(elementId) {
        const element = document.getElementById(elementId);

        if (element != null) {
            $(`#${elementId}`).focus().select();
        }
    }

    function onSuccess(configuration, data) {
        pushBackButtonUrl(data.backButtonUrl);
        bgl.common.loader.load(data.content, data.url, containerId, function() {
            bgl.components.driverdetails.searchaddress.init(configuration);
        });
    }

    function onSuccessConfirmation(configuration, data) {
        location.href = configuration.NextStepUrl;
    }

    function onError() {
        bgl.components.driverdetails.searchaddress.init(configuration);
    }

    function getBackButtonUrlFromStack() {
        const stack = JSON.parse(sessionStorage.getItem(BACK_URL_STACK_KEY));
        if (stack) {
            const url = stack.pop();
            sessionStorage.setItem(BACK_URL_STACK_KEY, JSON.stringify(stack));
            return url;
        }
    }

    function pushBackButtonUrl(url) {
        const stack = JSON.parse(sessionStorage.getItem(BACK_URL_STACK_KEY)) || [];
        stack.push(url);
        sessionStorage.setItem(BACK_URL_STACK_KEY, JSON.stringify(stack));
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
        onSuccessConfirmation: onSuccessConfirmation,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.scrolltoelement = (function() {
    function init() {
        subscribeScrollLink();
    }

    function subscribeScrollLink() {
        $('.scroll-to-link')
            .off('click')
            .on('click', function(e) {
                e.preventDefault();

                const $this = $(this);
                const time = parseInt($this.data('scrollTime'));
                const elementToScroll = $this.attr('href');
                const accordion = $this.data('accordion');

                if (accordion) {
                    openAccordion(accordion);
                }

                scrollTo(elementToScroll, time);
            });
    }

    function openAccordion(element) {
        const driverHeaderAccordionButton = $(element).find('.accordion__heading-button');
        const isExpanded = $(driverHeaderAccordionButton).attr('aria-expanded');

        if (isExpanded.toLowerCase() === 'false') {
            $(driverHeaderAccordionButton).click();
        }
    }

    function scrollTo(element, time) {
        $('html,body').animate({
            scrollTop: $(element).offset().top,
        }, time);
    }

    return {
        init: init,
        scrollTo: scrollTo,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.overnightparking = (function() {
    let doneButton;
    let radioButtons;
    let configuration;
    let containerId;
    const BACK_URL_STACK_KEY = 'backUrlStack';
    let form;

    function initComponent(componentConfiguration, containerRef) {
        configuration = componentConfiguration;
        containerId = containerRef;

        form = $('[data-component-id=\'' + configuration.Id + '\'] form');
        doneButton = $('#vehicle-overnight_done-button');
        radioButtons = $('input[type=\'radio\']');

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        initBackButtonLink();
        subscribeToDoneEvents();
        subscribeToRadioButtonEvents();

        bgl.common.datastore.extendCollectedData(
            form,
            {OvernightParkingCode: $('input[name=OvernightParkingCode]:checked').val()},
        );
    }

    function initBackButtonLink() {
        $('.back-button-link')
            .off('click')
            .on('click',
                function(e) {
                    e.preventDefault();
                    $(this).hide();
                    const url = getBackButtonUrl();
                    loadView(url);
                });
    }

    function loadView(url) {
        const data = bgl.common.datastore.getData('Address');

        data.ComponentConfiguration = configuration;


        bgl.common.loader.load(data,
            url,
            containerId,
            function() {
                bgl.components.editaddress.init(configuration, false);
            });
    }

    function pushBackButtonUrl(url) {
        const stack = JSON.parse(sessionStorage.getItem(BACK_URL_STACK_KEY)) || [];

        stack.push(url);

        sessionStorage.setItem(BACK_URL_STACK_KEY, JSON.stringify(stack));
    }

    function getBackButtonUrl() {
        const stack = JSON.parse(sessionStorage.getItem(BACK_URL_STACK_KEY));
        const url = stack.pop();

        sessionStorage.setItem(BACK_URL_STACK_KEY, JSON.stringify(stack));

        return url;
    }


    function subscribeToRadioButtonEvents() {
        const hasValue = radioButtons.is(':checked');

        if (hasValue) {
            doneButton.removeClass('hide');
        } else {
            doneButton.addClass('hide');
        }

        $.each(radioButtons,
            function(key, item) {
                const button = $(item);

                button.on('change',
                    function(event) {
                        event.preventDefault();
                        if (!hasValue) {
                            form.submit();
                        }
                    });
            });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function subscribeToDoneEvents() {
        form.off('submit').on('submit',
            function(event) {
                event.preventDefault();
                if (bgl.common.validator.isFormValid($(this))) {
                    $('#HasChanges').val(bgl.common.datastore.isDataChanged($(event.target)) === true);
                    bgl.common.validator.submitForm($(this), configuration);
                }
            });
    }

    function onSuccess(configuration, response) {
        bgl.common.datastore.extendCollectedData(
            form,
            {
                isFormDirty: response.hasChanges,
                HasChanges: response.hasChanges,
            },
        );
        pushBackButtonUrl(response.backUrl);
        bgl.common.loader.load(configuration, response.nextUrl, containerId, function(e) {
            bgl.components.driverdetails.annualmileage.init(configuration, containerId);
        });
    }

    function onError() {
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
        bgl.components.vehicledetails.overnightparking.init(configuration);
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

const hasConvictions = 'HasConvictions';

bgl.components.driverdetails.motorconvictions = (function() {
    let configuration;
    let form;
    let motorConvictionList;
    let noButton;
    let yesButton;
    let doneButton;
    let container;
    const HIDE_CLASS = 'hide';

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;

        form = $('div[id=' + configuration.Id + '-motor-convictions] form');
        noButton = $('#motor-convictions-radio-no');
        yesButton = $('#motor-convictions-radio-yes');
        motorConvictionList = $('#motor-convictions-list');
        doneButton = $('button[data-remove-all-url]');
        container = $('#' + configuration.Id + '-motor-convictions form');

        bgl.common.datastore.init(container, false, true);
        bgl.common.datastore.setupWrite();

        if (getMotorConvictions() === 0) {
            getConvictionsFromStorageAndSetNoButton();
        }

        subscribeForEvents();
    }

    function subscribeForEvents() {
        subscribeToEventShowMotorConvictions();
        subscribeToEventDeleteMotorConviction();
        subscribeToEventRemoveAllMotorConvictions();
        subscribeToEventAddMotorConviction();
        subscribeToEventDoneButtonMotorConvictions();
        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function subscribeToEventShowMotorConvictions() {
        const radioButtons = $('input[type=\'radio\']');
        if (!radioButtons.is(':checked')) {
            doneButton.addClass('hide');
        } else {
            doneButton.removeClass('hide');
        }

        $.each(radioButtons,
            function(key, item) {
                const button = $(item);

                button.off('change').on('change',
                    function(event) {
                        event.preventDefault();

                        switch ($(this).val()) {
                        case 'True':
                            if (getMotorConvictions() === 0) {
                                $('#motor-convictions-add-another').click();
                                $(this).prop('checked', false);
                            } else {
                                $('#motor-convictions-radio-no').attr('data-need-to-delete', 'false');
                                if (motorConvictionList.hasClass(HIDE_CLASS)) {
                                    motorConvictionList.removeClass(HIDE_CLASS);
                                }
                            }
                            break;
                        case 'False':
                            const isNeedToBeDeleted = getMotorConvictions() !== 0;
                            $('#motor-convictions-radio-no').attr('data-need-to-delete', isNeedToBeDeleted);

                            if (!isNeedToBeDeleted) {
                                setSessionStorageValue();
                                goToNextStep();
                            } else if (!motorConvictionList.hasClass(HIDE_CLASS)) {
                                motorConvictionList.addClass(HIDE_CLASS);
                            }
                            break;
                        }
                    });
            });
    }

    function subscribeToEventDeleteMotorConviction() {
        const deleteMotorConvictionButtons = $('button[data-role=\'delete\']');

        $.each(deleteMotorConvictionButtons,
            function(key, item) {
                $(item).off('click').on('click',
                    function(event) {
                        event.preventDefault();
                        $(item).attr('disabled', 'disabled');

                        const target = $(event.target);
                        const link = target.is('button') ? target : target.parent();

                        const token = $('input[name=\'__RequestVerificationToken\']').val();
                        const journeyType = $('#JourneyType').val();
                        const patchUrl = link.attr('href');

                        const dataToPost = {
                            __RequestVerificationToken: token,
                            motorConvictionId: link.data('conviction-id'),
                            journeyType: journeyType,
                        };

                        $.ajax({
                            url: patchUrl,
                            type: 'POST',
                            data: dataToPost,
                            success: function(data, textStatus, request) {
                                if (request.getResponseHeader('Content-Type') === 'application/json; charset=utf-8') {
                                    if (!data.isSuccess) {
                                        bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                                    }

                                    if (getMotorConvictions() === 1) {
                                        setSessionStorageValue();
                                    }

                                    bgl.common.utilities.refreshPage();
                                }
                            },
                        });
                    });
            });
    }

    function subscribeToEventRemoveAllMotorConvictions() {
        const removeAllButton = $('#remove-all-motor-convictions');

        removeAllButton.off('click').on('click',
            function(event) {
                event.preventDefault();
                noButton.click();
            });
    }

    function subscribeToEventAddMotorConviction() {
        $('#motor-convictions-add-another').off('click').on('click',
            function(event) {
                event.preventDefault();
                const url = $(event.target).attr('href');
                loadAddMotorConvictions(url);
            });
    }

    function subscribeToEventDoneButtonMotorConvictions() {
        doneButton.off('click').on('click',
            function() {
                const isNeededToDelete = noButton.attr('data-need-to-delete') === 'true';
                const isNoButtonChecked = noButton.is(':checked');
                const patchUrl = $(this).data('remove-all-url');

                if (isNeededToDelete && isNoButtonChecked) {
                    const dataToPost = $.param({
                        __RequestVerificationToken: $('input[name=\'__RequestVerificationToken\']').val(),
                        personId: $('#PersonId').val(),
                        JourneyType: $('#JourneyType').val(),
                    });

                    $.ajax({
                        url: patchUrl,
                        type: 'POST',
                        data: dataToPost,
                        success: function(data, textStatus, request) {
                            if (request.getResponseHeader('Content-Type') === 'application/json; charset=utf-8') {
                                if (!data.isSuccess && data.errorRedirectUrl !== null) {
                                    bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                                } else if (data.isSuccess) {
                                    goToNextStep();
                                }
                            }
                        },
                    });
                } else {
                    goToNextStep();
                }
            });
    }

    function goToNextStep() {
        if (typeof bgl.common.pubsub !== 'undefined') {
            bgl.common.pubsub.emit('fakeFormSubmit', form.attr('id') || form.attr('action') || 'unknown');
        }
        bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
    }

    function getMotorConvictions() {
        return $('.step-form__summary-item').length;
    }

    function setSessionStorageValue() {
        const key = container.data('store-key');
        const yourDetails = JSON.parse(sessionStorage.getItem(key));
        yourDetails[hasConvictions] = 'False';
        sessionStorage.setItem(key, JSON.stringify(yourDetails));
    }

    function loadAddMotorConvictions(url) {
        const model = {
            ComponentConfiguration: configuration,
            PersonId: $('#PersonId').val(),
            JourneyType: $('#JourneyType').val(),
        };

        bgl.common.loader.load(model,
            url,
            'SlidePanelContent',
            function() {
                bgl.components.driverdetails.motorconvictionsbuilder.init(configuration);
            });
    }

    function resetYesNoButtonHandler(flag) {
        if (!flag && getMotorConvictions() === 0) {
            yesButton.prop('checked', false);
            getConvictionsFromStorageAndSetNoButton();
        }
    }

    function getConvictionsFromStorageAndSetNoButton() {
        const model = bgl.common.datastore.getData(container);
        if (model && model.HasConvictions) {
            noButton.prop('checked', 'checked');
        }
    }

    return {
        init: initComponent,
        resetButtons: resetYesNoButtonHandler,
    };
})();

bgl.components.driverdetails.motorconvictionsbuilder = (function() {
    let form;
    let configuration;
    const HIDE_CLASS = 'hide';
    let haveMotorConvictionsBeenChanged = false;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#add-motor-conviction');

        if (form) {
            bgl.common.validator.init(form);
        }

        subscribeForEvents();
        subscribeToEventDismissMotorConvictionPannel();
    }

    function subscribeToEventDismissMotorConvictionPannel() {
        $(document).off('click.drivermotorconvictions', '[data-dismiss="slide-panel"]')
            .on('click.drivermotorconvictions', '[data-dismiss="slide-panel"]', function() {
                unSubscribeToEventDismissMotorConvictionPannel();
                bgl.components.driverdetails.motorconvictions.resetButtons(haveMotorConvictionsBeenChanged);
            });

        $(document).off('keyup.drivermotorconvictions').on('keyup.drivermotorconvictions', function(event) {
            if (event.key === 'Escape') {
                unSubscribeToEventDismissMotorConvictionPannel();
                bgl.components.driverdetails.motorconvictions.resetButtons(haveMotorConvictionsBeenChanged);
            }
        });

        $('.overlay').off('click.drivermotorconvictions').on('click.drivermotorconvictions', function() {
            unSubscribeToEventDismissMotorConvictionPannel();
            bgl.components.driverdetails.motorconvictions.resetButtons(haveMotorConvictionsBeenChanged);
        });
    }

    function unSubscribeToEventDismissMotorConvictionPannel() {
        $(document).off('click.drivermotorconvictions', '[data-dismiss="slide-panel"]');
        $(document).off('keyup.drivermotorconvictions');
        $('.overlay').off('click.drivermotorconvictions');
    }

    function subscribeForEvents() {
        $('.step-form__button, .form-row__breadcrumb-link').off('click').on('click',
            function(event) {
                stepClick(event, false);
            });

        $('[data-step-type="previous-step"]').off('click').on('click',
            function(event) {
                stepClick(event, true);
            });

        function stepClick(event, isBackButtonClicked) {
            event.preventDefault();
            const link = $(event.currentTarget);
            selectNextStep(link, isBackButtonClicked);
        }

        const banLengthRow = $('#ban-length-row');

        $('#conviction-has-ban-no').on('click',
            function() {
                if (!banLengthRow.hasClass(HIDE_CLASS)) {
                    banLengthRow.addClass(HIDE_CLASS);
                }
                $('#Months-Ban').val('');
            });

        $('#conviction-has-ban-yes').on('click',
            function() {
                if (banLengthRow.hasClass(HIDE_CLASS)) {
                    banLengthRow.removeClass(HIDE_CLASS);
                }
            });

        bgl.common.validator.initNumberInputField($('#Months-Ban'), 2);
        bgl.common.validator.initNumberInputField($('#Fine-Amount'), 5);

        if (form) {
            form.off('submit').on('submit',
                function(event) {
                    event.preventDefault();
                    event.stopPropagation();

                    const submit = $(this).find(':submit');
                    submit.attr('disabled', 'disabled');

                    if (bgl.common.validator.validate(configuration, form) === false) {
                        submit.removeAttr('disabled');
                    }
                });
        }
    }

    function selectNextStep(link, isBack) {
        const nextStep = link.data('next-step');
        const currentStep = $('#motor-conviction-tiles').data('current-step');
        const journeyType = $('#JourneyType').val();
        if (typeof bgl.common.pubsub !== 'undefined' && !isBack) {
            bgl.common.pubsub.emit('fakeFormSubmit', $('#motor-conviction-current-step').val());
        }

        let currentValue = {
            Code: link.data('code'),
            Value: $.trim(link.text()),
            BuilderStep: currentStep,
        };

        const model = {
            ComponentConfiguration: configuration,
            PersonId: $('#PersonId').val(),
            JourneyType: journeyType,
            CurrentStep: nextStep,
        };

        if (isBack) {
            currentValue = undefined;
            model.IsBackButtonClicked = true;
        }

        model.SelectedValues = getSelectedValues(currentValue);

        const url = link.attr('href');
        if (link.data('current-step') === 'Type' && isBack === true) {
            $('[data-dismiss]').click();
            return;
        }

        bgl.common.loader.load(model,
            url,
            'SlidePanelContent',
            function() {
                bgl.components.driverdetails.motorconvictionsbuilder.init(configuration);
            });
    }

    function getSelectedValues(currentValue) {
        const result = [];
        const breadcrumbLinks = $('.form-row__breadcrumb-link') || [];

        $.each(breadcrumbLinks,
            function(idx, element) {
                const value = {
                    Code: $(element).data('code'),
                    Value: $.trim($(element).text()),
                    BuilderStep: $(element).data('next-step'),
                };

                result.push(value);
            });

        if (currentValue !== undefined) {
            result.push(currentValue);
        }

        return result;
    }

    function onSuccess(configuration, data) {
        if (data.lastStep === true) {
            haveMotorConvictionsBeenChanged = true;
            $('[data-dismiss]').click();
            bgl.common.utilities.refreshPage();
        } else {
            const newModel = JSON.parse(data.content);

            configuration = newModel.ComponentConfiguration;

            bgl.common.loader.load(newModel,
                data.redirectUrl,
                'SlidePanelContent',
                function() {
                    bgl.components.driverdetails.motorconvictionsbuilder.init(configuration);
                });
        }
    }

    function onError() {
        bgl.components.driverdetails.motorconvictionsbuilder.init(configuration);
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

const hasClaims = 'HasClaims';

bgl.components.driverdetails.motorclaims = (function() {
    let configuration;
    let motorClaimList;
    let form;
    let doneButton;
    let radioButtons;
    const HIDE_CLASS = 'hide';
    let addNewClaim;

    function initComponent(componentConfiguration) {
        form = $('#' + componentConfiguration.Id + '-motor-claims-form');
        doneButton = $('button[data-remove-all-url]');
        radioButtons = $('input[type=\'radio\']');
        configuration = componentConfiguration;
        motorClaimList = $('#motor-claims-list');

        addNewClaim = $('#add-new-motor-claim');

        subscribeForEvents();

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupWrite();

        const noButton = $('#driver-has-claims-no');
        const isAnyClaims = $('.step-form__summary-item').length > 0;

        if (!isAnyClaims) {
            const model = bgl.common.datastore.getData(form);
            if (model && model.HasClaims) {
                noButton.prop('checked', 'checked');
            }
        }

        if (!radioButtons.is(':checked')) {
            doneButton.addClass('hide');
        } else {
            doneButton.removeClass('hide');
        }
    }

    function subscribeForEvents() {
        subscribeToEventShowMotorClaims();
        subscribeToEventDeleteMotorClaim();
        subscribeToEventRemoveAllMotorClaims();
        subscribeToEventAddMotorClaim();
        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function subscribeToEventShowMotorClaims() {
        $.each(radioButtons,
            function(key, item) {
                const button = $(item);
                button.off('change').on('change',
                    function(event) {
                        event.preventDefault();

                        switch ($(this).val()) {
                        case 'True':
                            if (getMotorClaims() === 0) {
                                addNewClaim.click();
                            } else {
                                $('#driver-has-claims-no').attr('data-need-to-delete', 'false');
                                if (motorClaimList.hasClass(HIDE_CLASS)) {
                                    motorClaimList.removeClass(HIDE_CLASS);
                                }
                            }
                            break;
                        case 'False':
                            const isNeededToBeDelete = getMotorClaims() !== 0;
                            $('#driver-has-claims-no').attr('data-need-to-delete', isNeededToBeDelete);

                            if (!motorClaimList.hasClass(HIDE_CLASS)) {
                                motorClaimList.addClass(HIDE_CLASS);
                            }

                            if (getMotorClaims() === 0) {
                                if (typeof bgl.common.pubsub !== 'undefined') {
                                    bgl.common.pubsub.emit(
                                        'fakeFormSubmit',
                                        form.attr('id') || form.attr('action') || 'unknown',
                                    );
                                }
                                bgl.common.utilities.redirectToUrl(doneButton.data('next-step-url'));
                            }
                            break;
                        }
                    });
            });
    }

    function subscribeToEventAddMotorClaim() {
        addNewClaim.off('click').on('click',
            function(event) {
                event.preventDefault();
                const url = $(this).attr('href');
                loadAddMotorClaims(url);
            });
    }

    function subscribeToEventRemoveAllMotorClaims() {
        const removeAllButton = $('#remove-all-motor-claims');
        const noButton = $('#driver-has-claims-no');

        removeAllButton.off('click');
        removeAllButton.on('click',
            function(event) {
                event.preventDefault();
                noButton.click();
            });

        doneButton.off('click').on('click',
            function() {
                if (typeof bgl.common.pubsub !== 'undefined') {
                    bgl.common.pubsub.emit('fakeFormSubmit', form.attr('id') || form.attr('action') || 'unknown');
                }
                const isNeededToDelete = noButton.attr('data-need-to-delete') === 'true';
                const isNoButtonChecked = noButton.is(':checked');
                const patchUrl = $(this).data('remove-all-url');

                if (isNeededToDelete && isNoButtonChecked) {
                    const dataToPost = $.param({
                        __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val(),
                        personId: $('#PersonId').val(),
                    });

                    $.ajax({
                        url: patchUrl,
                        type: 'POST',
                        data: dataToPost,
                        success: function(data, textStatus, request) {
                            if (request.getResponseHeader('Content-Type') === 'application/json; charset=utf-8') {
                                if (!data.isSuccess && data.errorRedirectUrl !== null) {
                                    bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                                } else if (data.isSuccess) {
                                    bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
                                }
                            }
                        },
                    });
                } else {
                    bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
                }
            });
    }

    function subscribeToEventDeleteMotorClaim() {
        const deleteMotorClaimButtons = $('button[data-role=\'delete\']');

        $.each(deleteMotorClaimButtons,
            function(key, item) {
                $(item).off('click');
                $(item).on('click', function(event) {
                    event.preventDefault();
                    $(item).attr('disabled', 'disabled');

                    const target = $(event.target);
                    const link = target.is('button') ? target : target.parent();
                    const token = $('input[name=\'__RequestVerificationToken\']').val();
                    const patchUrl = link.attr('href');
                    const journeyType = $('#JourneyType').val();
                    const dataToPost = $.param({
                        __RequestVerificationToken: token,
                        motorclaimId: link.data('claim-id'),
                        journeyType: journeyType,
                    });

                    $.ajax({
                        url: patchUrl,
                        type: 'POST',
                        data: dataToPost,
                        success: function(data, textStatus, request) {
                            if (request.getResponseHeader('Content-Type') === 'application/json; charset=utf-8') {
                                if (!data.isSuccess) {
                                    bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                                }

                                if (getMotorClaims() === 1) {
                                    const key = form.data('store-key');
                                    const yourDetails = JSON.parse(sessionStorage.getItem(key)) || {};
                                    yourDetails[hasClaims] = 'False';
                                    sessionStorage.setItem(key, JSON.stringify(yourDetails));
                                }

                                bgl.common.utilities.refreshPage();
                            }
                        },
                    });
                });
            });
    }

    function getMotorClaims() {
        return $('.step-form__summary-item').length;
    }

    function loadAddMotorClaims(url) {
        const model = {
            ComponentConfiguration: configuration,
            PersonId: $('#PersonId').val(),
            JourneyType: $('#JourneyType').val(),
        };

        bgl.common.loader.load(model,
            url,
            'SlidePanelContent',
            function() {
                bgl.components.driverdetails.motorclaimbuilder.init(configuration);
            });
    }

    return {
        init: initComponent,
    };
})();

bgl.components.driverdetails.motorclaimbuilder = (function() {
    let form;
    let configuration;
    const HIDE_CLASS = 'hide';

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#add-motor-claim');
        if (form) {
            bgl.common.validator.init(form);
            bgl.common.validator.initNumberInputField($('#Claim-Amount'), 5);
        }

        subscribeForEvents();
        subscribeToEventDismissMotorClaimsPanel();
        groupSpanAndButton();
    }

    function groupSpanAndButton() {
        $('.form-row__label.step-form__question-label').append('<span id="tile-container"></span>');
        $('.form-row__label.step-form__question-label #questionmark').prev().appendTo('#tile-container');
        $('.form-row__label.step-form__question-label #questionmark').appendTo('#tile-container');
    }

    function subscribeForEvents() {
        $('.step-form__button').off('click').on('click',
            function(event) {
                event.preventDefault();
                const link = $(event.target);
                selectNextStep(link);
            });

        $('.form-row__breadcrumb-link').off('click').on('click',
            function(event) {
                event.preventDefault();
                gotoBack($(event.target));
            });

        $('[data-step-type="previous-step"]').off('click').on('click',
            function(event) {
                event.preventDefault();
                gotoBack($(event.target));
            });

        const claimAmountRow = $('#claim-amount-row');

        $('#claim-has-amount-no').on('click',
            function() {
                if (!claimAmountRow.hasClass(HIDE_CLASS)) {
                    claimAmountRow.addClass(HIDE_CLASS);
                }
            });

        $('#claim-has-amount-yes').on('click',
            function() {
                if (claimAmountRow.hasClass(HIDE_CLASS)) {
                    claimAmountRow.removeClass(HIDE_CLASS);
                }
            });

        if (form) {
            form.off('submit').on('submit',
                function(event) {
                    event.preventDefault();
                    event.stopPropagation();

                    const submit = $(this).find(':submit');
                    submit.attr('disabled', 'disabled');

                    if (bgl.common.validator.validate(configuration, form) === false) {
                        submit.removeAttr('disabled');
                    }
                });
        }
    }

    function subscribeToEventDismissMotorClaimsPanel() {
        $(document).off('click.motorclaims', '[data-dismiss="slide-panel"]')
            .on('click.motorclaims', '[data-dismiss="slide-panel"]', function() {
                unSubscribeToEventDismissMotorClaimsPanel();
                dismissSlidePanelHandler();
            });

        $(document).off('keyup.motorclaims').on('keyup.motorclaims', function(event) {
            if (event.key === 'Escape') {
                unSubscribeToEventDismissMotorClaimsPanel();
                dismissSlidePanelHandler();
            }
        });

        $('.overlay').off('click.motorclaims').on('click.motorclaims', function() {
            unSubscribeToEventDismissMotorClaimsPanel();
            dismissSlidePanelHandler();
        });
    }

    function unSubscribeToEventDismissMotorClaimsPanel() {
        $(document).off('click.motorclaims', '[data-dismiss="slide-panel"]');
        $(document).off('keyup.motorclaims');
        $('.overlay').off('click.motorclaims');
    }

    function dismissSlidePanelHandler() {
        bgl.common.utilities.refreshPage();
    }

    function gotoBack(link) {
        selectNextStep(link, true);
    }

    function selectNextStep(link, isBack) {
        const nextStep = link.data('next-step');
        const currentStep = $('#motor-claim-tiles').data('current-step');
        const url = link.attr('href');

        if (currentStep === 'Year' && isBack === true) {
            bgl.common.utilities.refreshPage();
            return;
        }

        let currentValue = {
            Code: link.data('code'),
            Value: $.trim(link.text()),
            BuilderStep: currentStep,
        };

        const model = {
            ComponentConfiguration: configuration,
            PersonId: $('#PersonId').val(),
            CurrentStep: nextStep,
            JourneyType: $('#JourneyType').val(),
            FirstName: $('#FirstName').val(),
        };

        if (isBack) {
            currentValue = undefined;
            model.IsBackButtonClicked = true;
        }

        if (typeof bgl.common.pubsub !== 'undefined' && !isBack) {
            bgl.common.pubsub.emit('fakeFormSubmit', $('#motor-claim-tiles-legend').text());
        }

        model.SelectedValues = getSelectedValues(currentValue);

        bgl.common.loader.load(model,
            url,
            'SlidePanelContent',
            function() {
                bgl.components.driverdetails.motorclaimbuilder.init(configuration);
            });
    }

    function getSelectedValues(currentValue) {
        const result = [];
        const breadcrumbLinks = $('.form-row__breadcrumb-link') || [];

        $.each(breadcrumbLinks,
            function(idx, element) {
                const value = {
                    Code: $(element).data('code'),
                    Value: $.trim($(element).text()),
                    BuilderStep: $(element).data('next-step'),
                };
                result.push(value);
            });

        if (currentValue !== undefined) {
            result.push(currentValue);
        }

        return result;
    }

    function onSuccess() {
        bgl.common.utilities.refreshPage();
    }

    function onError() {
        bgl.components.driverdetails.motorclaimbuilder.init(configuration);
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.medicalconditiondvlanotified = (function() {
    let form; let configuration;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;

        form = $('#medical-condition-dvla-notified');

        bgl.common.validator.init(form);

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        subscribeForEvents();
    }

    function subscribeForEvents() {
        if (form.find('input[type=radio]:checked').length === 0) {
            form.find('input[type=radio]')
                .off('keypress', generateClickOnKeypress)
                .on('keypress', generateClickOnKeypress)
                .off('click', continueHandler)
                .on('click', continueHandler);
        } else {
            const continueButton = $(form.find('[type=\'submit\']'));
            continueButton.removeClass('hide');
        }

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(this))) {
                        $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)) === true);

                        const currentData = bgl.common.datastore.getData($(this));
                        const dataForValidate = $(form).serialize() +
                        '&' +
                        $.param(currentData) +
                        '&' +
                        $.param({ComponentConfiguration: configuration});

                        bgl.common.validator.submitForm(form, configuration, dataForValidate);
                    }
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function generateClickOnKeypress(event) {
        const SPACE_KEYCODE = 32;
        const ENTER_KEYCODE = 13;
        const code = event.charCode || event.keyCode;

        if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
            $(event.target).prop('checked', 'checked');
            $(event.target).click();
        }
    }

    function continueHandler(event) {
        event.preventDefault();

        if ($(event.target).is(':checked')) {
            $(event.target).trigger('change');
        }

        form.find('input[type=radio]').off();
        form.submit();
    }

    function onSuccess(configuration, data) {
        if (data.nextDtsPageUrl) {
            location.href = data.nextDtsPageUrl;
        }
    }

    function onError() {
        bgl.components.driverdetails.medicalconditiondvlanotified.init(configuration);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.medicalcondition = (function() {
    let form;
    let configuration;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;

        initialiseVariables();

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        subscribeForEvents();
    }

    function initialiseVariables() {
        form = $('#medical-condition');

        bgl.common.validator.init(form, configuration);
    }

    function subscribeForEvents() {
        const person = bgl.common.datastore.getData(form);
        const isLicenceInternational = person.Licence === 'I';

        if (isLicenceInternational) {
            $('#' + configuration.Id + '-back-button').attr('href', configuration.LicenceDatePageUrl);
        }

        if (form.find('input[type=radio]:checked').length === 0) {
            form.find('input[type=radio]')
                .off('keypress', generateClickOnKeypress)
                .on('keypress', generateClickOnKeypress)
                .off('click', continueHandler)
                .on('click', continueHandler);
        } else {
            const continueButton = $(form.find('[type=\'submit\']'));
            continueButton.removeClass('hide');
        }

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(this))) {
                        $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)) === true);

                        bgl.common.validator.submitForm(form, configuration);
                    }
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function generateClickOnKeypress(event) {
        const SPACE_KEYCODE = 32;
        const ENTER_KEYCODE = 13;
        const code = event.charCode || event.keyCode;

        if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
            $(event.target).prop('checked', 'checked');
            $(event.target).click();
        }
    }

    function continueHandler(event) {
        event.preventDefault();

        if ($(event.target).is(':checked')) {
            $(event.target).trigger('change');
        }

        form.find('input[type=radio]').off();
        form.submit();
    }

    function onSuccess(configuration, data) {
        if (data.hasDvlaNotified === false) {
            bgl.common.datastore.deleteFields(form, ['MedicalConditionDvlaNotified']);
        }

        if (data.nextDtsPageUrl) {
            location.href = data.nextDtsPageUrl;
        }
    }

    function onError() {
        bgl.components.driverdetails.medicalcondition.init(configuration);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.maritalstatus = (function() {
    let form;
    let configuration;
    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(componentConfiguration, componentUrl, containerElementId, function() {
            initComponent(componentConfiguration);
        });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#marital-status-form');

        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();

        if (form.find('input[type=radio]:checked').length === 0) {
            form.find('input[type=radio]')
                .off('keypress', generateClickOnKeypress)
                .on('keypress', generateClickOnKeypress)
                .off('click', continueHandler)
                .on('click', function(event) {
                    $(this).focusout();
                    continueHandler(event);
                });
        } else {
            const continueButton = $(form.find('[type=\'submit\']'));
            continueButton.removeClass('hide');
            continueButton.off('click').on('click', continueHandler);
        }

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function generateClickOnKeypress(event) {
        const code = event.charCode || event.keyCode;
        if (code === 13 || code === 32) {
            $(this).click();
        }
    }

    function continueHandler(event, element) {
        if (typeof bgl.common.pubsub !== 'undefined') {
            bgl.common.pubsub.emit('fakeFormSubmit', form.attr('id') || form.attr('action') || 'unknown');
        }
        event.preventDefault();
        form.find('input[type=radio]').off();
        location.href = configuration.NextStepUrl;
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();

﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.licenceheldsince = (function() {
    let form;
    let configuration;
    let monthDropdown;
    let yearDropdown;
    let yearsOfLicence;
    let fullYearMonthOptions;
    let fullYearOptions;
    let isSyncingFromHeldSinceYear;
    let isSyncingFromDateDropdowns;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#licence-held-since');
        isSyncingFromHeldSinceYear = false;
        isSyncingFromDateDropdowns = false;

        bgl.common.validator.init(form);

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        subscribeOnEvents();

        updateMonthDropdown();
        isSyncingFromDateDropdowns = true;
        updateDateObtained();
        isSyncingFromDateDropdowns = false;
    }

    function subscribeOnEvents() {
        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(this))) {
                        $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)) === true);

                        const currentData = bgl.common.datastore.getData($(this));
                        currentData.FirstName = null;
                        const dataForValidate = $(form).serialize() +
                        '&' +
                        $.param(currentData) +
                        '&' +
                        $.param({ComponentConfiguration: configuration});

                        bgl.common.validator.submitForm($(this), configuration, dataForValidate);
                    }
                });

        monthDropdown = form.find('#Since-Month');
        yearDropdown = form.find('#Since-Year');
        yearsOfLicence = form.find('#Held-Since-Year');

        fullYearMonthOptions = monthDropdown.find('option');
        fullYearOptions = yearDropdown.find('option').clone();

        monthDropdown.on('change', updateYearsOfLicenceFromDate);
        yearDropdown.on('change', onYearChanged);
        yearsOfLicence.on('change', updateDateObtained);
    }

    function onYearChanged() {
        updateMonthDropdown();
        updateYearsOfLicenceFromDate();
    }

    function updateMonthDropdown() {
        const months = monthDropdown;
        const selectedMonthValue = months.val();

        const currentYear = $('#CurrentYear').val() * 1;
        const currentMonth = $('#CurrentMonth').val() * 1;

        const selectedYear = yearDropdown.val() * 1;

        const personBirthYear = $('#PersonBirthYear').val() * 1;
        const personBirthMonth = $('#PersonBirthMonth').val() * 1;

        const adulthood = personBirthYear + 17;

        if (selectedYear === currentYear) {
            months.html(fullYearMonthOptions.slice(0, currentMonth + 1));
        } else if (selectedYear === adulthood) {
            // merge months after birth month and please select...
            const dropdownOptions = fullYearMonthOptions.slice(personBirthMonth);
            months.html($.merge([fullYearMonthOptions[0]], dropdownOptions));
        } else {
            months.html(fullYearMonthOptions);
        }
        months.val(selectedMonthValue);

        // select first value if value is not selected
        if (!months.val()) {
            months.find('option:eq(0)').prop('selected', true);
        }
    }

    function updateYearsOfLicenceFromDate() {
        if (isSyncingFromHeldSinceYear) {
            return;
        }

        const selectedMonth = monthDropdown.val() * 1;
        const selectedYear = yearDropdown.val() * 1;

        if (selectedMonth <= 0 || selectedYear <= 0) {
            return;
        }

        const currentYear = $('#CurrentYear').val() * 1;
        const currentMonth = $('#CurrentMonth').val() * 1;

        let yearsOfLicenceValue = currentYear - selectedYear;

        if (selectedMonth > currentMonth) {
            yearsOfLicenceValue--;
        }

        const yearsOfLicence = form.find('#Held-Since-Year');
        const yearsOfLicenceOption = yearsOfLicence.find(`option[value="${yearsOfLicenceValue}"]`);

        if (yearsOfLicenceOption.length > 0) {
            isSyncingFromDateDropdowns = true;
            yearsOfLicence.val(yearsOfLicenceValue.toString()).trigger('change');
            isSyncingFromDateDropdowns = false;
        }
    }

    function shouldShowDateObtained(yearsOfLicenceValue) {
        return yearsOfLicenceValue !== null &&
               yearsOfLicenceValue !== '' &&
               Number(yearsOfLicenceValue) <= 4;
    }

    function resetDateObtainedData() {
        yearDropdown.val('');
        monthDropdown.val('');
        bgl.common.datastore.deleteFields(form, [
            'LicenceDateMonth',
            'LicenceDateYear',
            'LicenceDateMonthVal',
            'LicenceDateYearVal',
            'LicenceDateYearText',
            'LicenceDateMonthText',

        ]);
        bgl.common.datastore.extendCollectedData(form, {
            LicenceDateMonth: '',
            LicenceDateYear: '',
            LicenceDateMonthVal: '',
            LicenceDateYearVal: '',
            LicenceDateYearText: '',
            LicenceDateMonthText: '',
        });
    }

    function updateYearDropdownOptions(yearsOfLicenceValue) {
        const currentYear = $('#CurrentYear').val() * 1;

        if (yearsOfLicenceValue === '0') {
            const lastTwoYearsOptions = fullYearOptions.filter(function() {
                return this.value === '' || this.value * 1 >= currentYear - 1;
            });
            yearDropdown.html(lastTwoYearsOptions.clone().removeAttr('selected'));
            return;
        }

        const lastFiveYearsOptions = fullYearOptions.filter(function() {
            return this.value === '' || this.value * 1 >= currentYear - 5;
        });
        yearDropdown.html(lastFiveYearsOptions.clone().removeAttr('selected'));
    }

    function syncDateDropdownsFromYears(selectedYearsOfLicence) {
        if (selectedYearsOfLicence <= 4) {
            return;
        }

        isSyncingFromHeldSinceYear = true;

        const currentYear = $('#CurrentYear').val() * 1;
        const currentMonth = $('#CurrentMonth').val() * 1;

        const targetYear = (currentYear - selectedYearsOfLicence).toString();
        const targetMonth = currentMonth.toString();

        yearDropdown.val(targetYear);
        if (yearDropdown.val() !== targetYear) {
            yearDropdown.val(getOldestAvailableYearValue());
        }

        yearDropdown.trigger('change');

        monthDropdown.val(targetMonth);
        if (monthDropdown.val() !== targetMonth) {
            monthDropdown.find('option:eq(1)').prop('selected', true);
        }

        monthDropdown.trigger('change');
        isSyncingFromHeldSinceYear = false;
    }

    function updateDateObtained() {
        const yearsOfLicenceValue = yearsOfLicence.val();
        const selectedYearsOfLicence = yearsOfLicenceValue * 1;
        const dateLicenceObtained = form.find('#date-licence-obtained');
        const showDateObtained = shouldShowDateObtained(yearsOfLicenceValue);
        const savedYearValue = yearDropdown.val();
        const savedMonthValue = monthDropdown.val();

        form.find('[name="ShowDateObtained"]').val(showDateObtained.toString());

        if (showDateObtained) {
            dateLicenceObtained.removeClass('hide');

            if (!isSyncingFromDateDropdowns) {
                resetDateObtainedData();
            }

            updateYearDropdownOptions(yearsOfLicenceValue);

            if (isSyncingFromDateDropdowns) {
                yearDropdown.val(savedYearValue);
                monthDropdown.val(savedMonthValue);
            }
        } else {
            dateLicenceObtained.addClass('hide');
            yearDropdown.html(fullYearOptions.clone().removeAttr('selected'));
        }

        syncDateDropdownsFromYears(selectedYearsOfLicence);
    }

    function getOldestAvailableYearValue() {
        const yearOptions = yearDropdown.find('option').filter(function() {
            return this.value;
        });

        if (yearOptions.length === 0) {
            return '';
        }

        return yearOptions.last().val();
    }

    function onSuccess(configuration, data) {
        if (data.needUpdatePerson === true) {
            form.attr('action', data.patchUrl);

            $('#HasChanges').val(bgl.common.datastore.isDataChanged(form) === true);

            const currentData = bgl.common.datastore.getData(form);

            const dataForValidate = $(form).serialize() +
                '&' + $.param(currentData) +
                '&' + $.param({ComponentConfiguration: configuration, ViewName: 'LicenceHeldSince'});

            bgl.common.datastore.extendCollectedData(form, {isFormDirty: false});

            bgl.common.validator.submitForm(form, configuration, dataForValidate);
            return;
        }

        location.href = data.nextDtsPageUrl;
    }

    function onError() {
        bgl.components.driverdetails.licenceheldsince.init(configuration);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.informationsource = (function() {
    let form;
    let configuration;
    let informationSourceSelectedResponse;
    const brandCodeNames = [
        'BRANCH',
        'KIOSK',
        'PROMO',
        'COLLEA',
    ];

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#' + configuration.Id).find('#information-source-form');
        informationSourceSelectedResponse = form.find('#InformationSourceQuestion_SelectedResponse');

        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();
        bgl.common.validator.init(form);
        subscribeForEvents();

        toggleBrandCodeSection(informationSourceSelectedResponse.val());
    }

    function subscribeForEvents() {
        informationSourceSelectedResponse.on('change',
            function() {
                const currentValue = $(this).val();
                toggleBrandCodeSection(currentValue);
            });

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();
                    if (!bgl.common.validator.isFormValid(form)) {
                        return;
                    }

                    if (!bgl.common.datastore.isDataChanged(form)) {
                        onSuccess();
                        return;
                    };

                    bgl.common.validator.submitForm(form, configuration);
                });
    }

    function toggleBrandCodeSection(currentValue) {
        const brandCodeSection = $('#Branch-Code-Section');

        for (let i = 0; i < brandCodeNames.length; i++) {
            if (endsWith(currentValue, brandCodeNames[i])) {
                brandCodeSection.removeClass('hide');
                return;
            }
        }

        brandCodeSection.addClass('hide');
        form.find('#BranchCodeQuestion_SelectedResponse').val('').trigger('focusout');
    }

    function endsWith(originalString, searchString) {
        let position = originalString.length;
        position -= searchString.length;

        const lastIndex = originalString.indexOf(searchString, position);

        return lastIndex !== -1 && lastIndex === position;
    }

    function onSuccess() {
        bgl.common.datastore.removeSessionStorage(form);
        bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
    }

    function onError() {
        initComponent(configuration);
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.homeowner = (function() {
    let form;
    let configuration;
    let continueButton;
    let homeOwnerYes;
    let homeOwnerNo;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#home-owner');
        continueButton = form.find('[type=\'submit\']');
        homeOwnerYes = form.find('#home-owner-yes');
        homeOwnerNo = form.find('#home-owner-no');

        bgl.common.validator.init(form);
        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        if (!configuration.MarketingQuestion) {
            subscribeForRadioButtonsClick();
        } else {
            subscribeForRadioButtonsClickWithHomeInsuranceDueOptions();
        }

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function generateClickOnKeypress(event) {
        const SPACE_KEYCODE = 32;
        const ENTER_KEYCODE = 13;
        const code = event.charCode || event.keyCode;

        if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
            $(event.target).prop('checked', 'checked');
            $(event.target).click();
        }
    }

    function continueHandler(event) {
        if (typeof bgl.common.pubsub !== 'undefined') {
            bgl.common.pubsub.emit('fakeFormSubmit', form.attr('id') || form.attr('action') || 'unknown');
        }
        event.preventDefault();

        if ($(event.target).is(':checked')) {
            $(event.target).trigger('change');
        }

        bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
    }

    function subscribeForRadioButtonsClick() {
        if (form.find('input[type=radio]:checked').length === 0) {
            form.find('input[type=radio]')
                .off('keypress', generateClickOnKeypress)
                .on('keypress', generateClickOnKeypress)
                .off('click', continueHandler)
                .on('click', continueHandler);
        } else {
            const continueButton = $(form.find('[type=\'submit\']'));
            continueButton.removeClass('hide');
            continueButton.off('click').on('click', continueHandler);
        }
    }

    function showDropDown() {
        form.find('#home-insurance-due-dropdowns').removeClass('hide');
        showContinue();
    }

    function showContinue() {
        continueButton.removeClass('hide');
        continueButton.off('click').on('click', continueHandlerWithHomeInsuranceDueRemoval);
        homeOwnerNo.off('click', continueHandlerWithHomeInsuranceDueRemoval).on('click', hideDropdown);
    }

    function hideDropdown() {
        form.find('#home-insurance-due-dropdowns').addClass('hide');
    }

    function continueHandlerWithHomeInsuranceDueRemoval(event) {
        event.preventDefault();

        if ($(event.target).is(':checked')) {
            $(event.target).trigger('change');
        }

        continueButton.attr('disabled', 'disabled');

        if (homeOwnerNo.prop('checked')) {
            $('#Home-Insurance-Due-Month').val('');
        }

        if ($('#SelectedResponse').val() !== $('#Home-Insurance-Due-Month').val()) {
            bgl.common.validator.submitForm(form, configuration);
        } else {
            continueButton.removeAttr('disabled');
            bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
        }
    }

    function subscribeForRadioButtonsClickWithHomeInsuranceDueOptions() {
        homeOwnerYes.off('click').on('click', showDropDown);

        if (form.find('input[type=radio]:checked').length === 0) {
            form.find('input[type=radio]')
                .off('keypress', generateClickOnKeypress)
                .on('keypress', generateClickOnKeypress);

            homeOwnerNo.off('click').on('click', continueHandlerWithHomeInsuranceDueRemoval);
        } else if (homeOwnerNo.prop('checked')) {
            showContinue();
        } else {
            showDropDown();
        }
    }

    function onSuccess() {
        if (homeOwnerNo.prop('checked')) {
            bgl.common.datastore.deleteFields(
                form,
                ['HomeInsuranceDueQuestion.SelectedResponseText',
                    'HomeInsuranceDueQuestion.SelectedResponseVal',
                    'HomeInsuranceDueQuestion.SelectedResponse'],
            );
        }
        bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
    }

    function onError() {
        bgl.components.driverdetails.homeowner.init(configuration);
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.employmentstatus = (function() {
    let configuration;
    let form;
    let hasPreselectedValues;

    function init(componentConfiguration) {
        configuration = componentConfiguration;

        form = $('[data-component-id=\'' + configuration.Id + '\'] form');

        bgl.common.validator.init(form);
        bgl.common.validator.initAutocompleteSearchInputs(form);

        bgl.common.autocompletesearch.init(3);

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        hasPreselectedValues = form.find('input[type=radio]:checked').length !== 0;

        if (hasPreselectedValues) {
            showContinueButton();
        }

        if ($('#PersonOccupationStep').val() === 'PartTime') {
            const person = bgl.common.datastore.getData(form);
            const selectedEmploymentStatus = person.EmploymentStatusId;

            const hasOccupation = $.grep(configuration.StatusCodesToAskOccupation,
                function(value) {
                    return selectedEmploymentStatus.toLowerCase() === value.toLowerCase();
                }).length !== 0;

            if (hasOccupation) {
                $('#' + configuration.Id + '-back-button').attr('href', configuration.PreviousBusinessTypePageUrl);
            }
        }

        if (hasPreselectedValues === false) {
            form.find('input[type=radio]')
                .off('click')
                .on('click', continueHandler);
        }

        if (hasPreselectedValues === true) {
            form.find('input[type=radio]')
                .off('change.occupation')
                .on('change.occupation', function() {
                    const stepType = $('#PersonOccupationStep').val() === 'PartTime' ? 1 : 0;
                    resetOccupationInfo(stepType, form);
                });
        }

        form.off('submit').on('submit',
            function(e) {
                e.preventDefault();

                if (bgl.common.validator.isFormValid($(this))) {
                    $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)) === true);

                    const elementsArray = $(this).serializeArray();
                    const formData = {};

                    $.map(elementsArray, function(item, i) {
                        formData[item['name']] = item['value'];
                    });

                    let currentData = bgl.common.datastore.getData($(this));

                    currentData = $.extend(currentData, formData);

                    const dataForValidate = $.param(currentData) +
                    '&' +
                    $.param({ComponentConfiguration: configuration});

                    bgl.common.validator.submitForm($(this), configuration, dataForValidate);
                }
            });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function continueHandler(event) {
        event.preventDefault();

        const controlType = $(event.target).attr('type');
        if (controlType === 'checkbox' || controlType === 'radio') {
            $(event.target).trigger('change');
        }

        form.submit();
    }

    function showContinueButton() {
        const continueButton = $(form.find('[type=\'submit\']'));
        continueButton.removeClass('hide');
    }

    function onSuccess(configuration, data) {
        if (data.needDeleteOccupation === true) {
            resetOccupationInfo(data.occupationStep, form);
        }

        if (data.isDataProvided) {
            bgl.common.datastore.extendCollectedData(form, {isFormDirty: false});
        }

        if (data.nextDtsPageUrl) {
            location.href = data.nextDtsPageUrl;
        }
    }

    function resetOccupationInfo(stepType, form) {
        switch (stepType) {
        case 1:
            bgl.common.datastore.deleteFields(form,
                [
                    'PartTimeOccupationId', 'PartTimeOccupation',
                    'PartTimeBusinessCategoryId', 'PartTimeBusinessCategory',
                ]);
            break;
        default:
            bgl.common.datastore.deleteFields(form,
                [
                    'OccupationId', 'Occupation',
                    'BusinessCategoryId', 'BusinessCategory',
                ]);
            break;
        }
    }

    function onError() {
        bgl.components.driverdetails.employmentstatus.init(configuration);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        init: init,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.drivinglicencenumber = (function() {
    let configuration; let form;
    let hasPreselectedValues;

    function initComponent(componentConfiguration) {
        initObject(componentConfiguration);

        bgl.common.datastore.init(form, false, true);
    }

    function initObject(componentConfiguration) {
        configuration = componentConfiguration;

        form = $('[data-component-id=\'' + configuration.Id + '\'] form');

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        bgl.common.validator.init(form);

        initRadioButtons();

        form.off('submit').on('submit',
            function(e) {
                e.preventDefault();
                e.stopPropagation();

                if (bgl.common.validator.isFormValid($(this))) {
                    $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)) === true);

                    bgl.common.validator.submitForm($(this), configuration);
                }
            });
    }

    function initRadioButtons() {
        hasPreselectedValues = form.find('input[type=radio]:checked').length !== 0;

        if (hasPreselectedValues === true) {
            showContinueButton();
            setDrivingLicenceRowVisibility(form.find('input[type=\'radio\']:checked').val().toLowerCase() === 'true');
        }

        $('#has-driving-licence-number-yes').on('click',
            function() {
                setDrivingLicenceRowVisibility(true);

                hasPreselectedValues = true;
                showContinueButton();
            });

        $('#has-driving-licence-number-no').on('click',
            function(event) {
                setDrivingLicenceRowVisibility(false);

                if (hasPreselectedValues === false) {
                    $(event.target).prop('checked', 'checked');
                    continueHandler(event);
                }
            });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function showContinueButton() {
        const continueButton = $(form.find('[type=\'submit\']'));
        continueButton.removeClass('hide');
    }

    function setDrivingLicenceRowVisibility(needToShow) {
        const drivingLicenceRow = form.find('#driving-licence-number-row');

        if (needToShow === true) {
            drivingLicenceRow.removeClass('hide');
        } else {
            drivingLicenceRow.addClass('hide');
        }
    }

    function continueHandler(event) {
        event.preventDefault();

        if ($(event.target).is(':checked')) {
            $(event.target).trigger('change');
        }

        form.submit();
    }

    function onSuccess(configuration, data) {
        if (data.hasDrivingLicenceNumber === false) {
            bgl.common.datastore.deleteFields(form, ['DrivingLicenceNumber']);
        }

        if (data.needUpdatePerson === true) {
            form.attr('action', data.patchUrl);

            $('#HasChanges').val(bgl.common.datastore.isDataChanged(form) === true);

            const currentData = bgl.common.datastore.getData(form);

            const dataForValidate = $(form).serialize() +
                '&' + $.param(currentData) +
                '&' + $.param({ComponentConfiguration: configuration, ViewName: 'DrivingLicenceNumber'});

            bgl.common.datastore.extendCollectedData(form, {isFormDirty: false});

            bgl.common.validator.submitForm(form, configuration, dataForValidate);
            return;
        }

        location.href = data.nextDtsPageUrl;
    }

    function onError() {
        bgl.components.driverdetails.drivinglicencenumber.init(configuration);

        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.driverbubbles = (function() {
    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(componentConfiguration, componentUrl, containerElementId, function() {
            bgl.components.driverdetails.common.init(componentConfiguration);
        });
    }

    function initComponent(componentConfiguration) {
        subscribeAddDriverButton(componentConfiguration);
        subscribeMainDriver(componentConfiguration);
        subscribeNamedDrivers(componentConfiguration);

        const tabIndex = localStorage.getItem('driverDetailsTabIndex');

        if (tabIndex !== null) {
            $('#tab-' + tabIndex).click();
            localStorage.removeItem('driverDetailsTabIndex');
        }

        bgl.components.driverdetails.scrolltoelement.init();
    }

    function subscribeAddDriverButton(componentConfiguration) {
        $('#AddDriver')
            .off('click')
            .on('click', function(event) {
                event.preventDefault();

                const actionUrl = $(this).data('action-url');

                if (componentConfiguration.IsService) {
                    bgl.common.utilities.redirectToUrl(actionUrl);
                } else {
                    const requestBodyData = {
                        ComponentConfiguration: componentConfiguration,
                        JourneyType: 1,
                    };

                    bgl.common.loader.load(requestBodyData,
                        actionUrl,
                        'SlidePanelContent',
                        function() {
                            bgl.components.additionaldriver.init(componentConfiguration);
                        },
                    );
                }
            });
    }

    function subscribeMainDriver(componentConfiguration) {
        subscribeDriver(componentConfiguration, 'ViewMainDriver', 0);
    }

    function subscribeNamedDrivers(componentConfiguration) {
        subscribeDriver(componentConfiguration, 'ViewNamedDrivers', 1);
    }

    function subscribeDriver(componentConfiguration, tabName, tabIndex) {
        $('#' + tabName)
            .off('keypress', generateClickOnKeypress)
            .on('keypress', generateClickOnKeypress)
            .off('click')
            .on('click',
                function(event) {
                    event.preventDefault();

                    if (componentConfiguration &&
                        componentConfiguration.RedirectUrl &&
                        componentConfiguration.RedirectUrl.length > 0) {
                        localStorage.setItem('driverDetailsTabIndex', tabIndex);
                        window.location = componentConfiguration.RedirectUrl;
                    } else {
                        if (document.getElementById('DriverDetails')) {
                            openAccordion($('#DriverDetails'));
                        }

                        $('#tab-' + tabIndex).click();
                        $('#tab-' + tabIndex).focus();
                    }
                });
    }

    function openAccordion(element) {
        const driverHeaderAccordionButton = $(element).find('.accordion__heading-button');
        const isExpanded = $(driverHeaderAccordionButton).attr('aria-expanded');

        if (isExpanded.toLowerCase() === 'false') {
            $(driverHeaderAccordionButton).click();
        }

        bgl.components.driverdetails.scrolltoelement.scrollTo(element, 400);
    }

    function generateClickOnKeypress(event) {
        const code = event.charCode || event.keyCode;
        if (code === 13 || code === 32) {
            $(this).click();
        }
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.driverdetails.common;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};

bgl.components.deletefrequentdriver = (function() {
    let configuration;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;

        subscribeDeleteFrequentDriver();
    }
    function subscribeDeleteFrequentDriver() {
        $(document).off('click', 'button[data-delete-driver]')
            .on('click', 'button[data-delete-driver]', function(event) {
                event.preventDefault();
                const $this = $(this);
                const url = $this.data('delete-url');
                const driverId = $this.data('driverId');
                const disabled = $this.data('disabled');
                const requestVerificationToken = $('input[name=\'__RequestVerificationToken\']').val();

                if (!disabled) {
                    $this.attr('data-disabled', 'true');
                    deleteFrequentDriver(url, driverId, requestVerificationToken);
                }
            });
    }

    function deleteFrequentDriver(url, driverId, requestVerificationToken) {
        const data = {
            driverId: driverId,
            __RequestVerificationToken: requestVerificationToken,
        };

        $.post(url, data, function(data) {
            if (!data.isSuccess && data.errorRedirectUrl) {
                bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                return;
            }

            if (configuration.IsService) {
                const options = {
                    callback: function() {
                        bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
                    },
                };

                const mtaSuffix = bgl.common.utilities.getWindowLocation()
                    .href.toLowerCase().includes('makechanges') ?
                    'start' :
                    'additional change';

                bgl.common.telemetry.logEvent(`MTA ${mtaSuffix}`,
                    {mta_type: 'Delete Frequent Driver', component: configuration.Id});

                bgl.common.pubsub.emit('PollBasket', options);
            } else {
                $('[data-dismiss="slide-panel"]').click();

                bgl.common.utilities.setUrlHashValue('main');
                bgl.common.pubsub.emit('PollBasket');
            }
        });
    }

    return {
        init: initComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.declinedinsurance = (function() {
    let form;
    let configuration;

    function ctor(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#declined-insurance');

        bgl.common.validator.init(form);
    }

    function initComponent(componentConfiguration) {
        ctor(componentConfiguration);

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        const person = bgl.common.datastore.getData(form);
        const hasMedicalCondition = person.MedicalCondition.toLowerCase() === 'true';

        if (hasMedicalCondition) {
            $('#' + configuration.Id + '-back-button').attr('href', configuration.DvlaNotifiedPageUrl);
        }

        subscribeToEvents();
    }

    function subscribeToEvents() {
        if (form.find('input[type=radio]:checked').length === 0) {
            form.find('input[type=radio]')
                .off('keypress', generateClickOnKeypress)
                .on('keypress', generateClickOnKeypress)
                .off('click', continueHandler)
                .on('click', continueHandler);
        } else {
            const continueButton = $(form.find('[type=\'submit\']'));
            continueButton.removeClass('hide');
        }

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(this))) {
                        $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)) === true);

                        const currentData = bgl.common.datastore.getData($(this));
                        const dataForValidate = $(form).serialize() +
                            '&' +
                            $.param(currentData) +
                            '&' +
                            $.param({ComponentConfiguration: configuration});

                        bgl.common.validator.submitForm(form, configuration, dataForValidate);
                    }
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function generateClickOnKeypress(event) {
        const SPACE_KEYCODE = 32;
        const ENTER_KEYCODE = 13;
        const code = event.charCode || event.keyCode;

        if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
            $(event.target).prop('checked', true);
            $(event.target).click();
        }
    }

    function continueHandler(event) {
        event.preventDefault();

        if ($(event.target).is(':checked')) {
            $(event.target).trigger('change');
        }

        form.find('input[type=radio]').off();
        form.submit();
    }

    function onSuccess(configuration, data) {
        if (data.needUpdatePerson === true) {
            form.attr('action', data.patchUrl);

            $('#HasChanges').val(bgl.common.datastore.isDataChanged(form) === true);

            const currentData = bgl.common.datastore.getData(form);

            const dataForValidate = $(form).serialize() +
                '&' + $.param(currentData) +
                '&' + $.param({ComponentConfiguration: configuration, ViewName: 'DeclinedInsurance'});

            bgl.common.datastore.extendCollectedData(form, {isFormDirty: false});

            bgl.common.validator.submitForm(form, configuration, dataForValidate);
            return;
        }

        if (data.nextDtsPageUrl) {
            location.href = data.nextDtsPageUrl;
        }
    }

    function onError() {
        bgl.components.driverdetails.declinedinsurance.init(configuration);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.criminalconvictions = (function() {
    let form;
    let configuration;
    let criminalConvictionsContainer;
    let criminalConvictionAddAnotherButton;
    let criminalConvictionRemoveAllButton;
    let doneButton;
    let noButton;
    let yesButton;
    let fullYearMonthOptions;
    let monthDropdown;
    let yearDropdown;
    let isChanged = false;
    const HIDE_CLASS = 'hide';
    const journeyType = 2;

    function initComponent(componentConfiguration, isChangedComponent) {
        configuration = componentConfiguration;
        isChanged = isChangedComponent;

        form = $('#criminal-convictions');
        criminalConvictionsContainer = $('#criminal-convictions-container');
        criminalConvictionAddAnotherButton = criminalConvictionsContainer.find('#criminal-conviction-add-another');
        criminalConvictionRemoveAllButton = criminalConvictionsContainer.find('#remove-all-criminal-convictions');

        doneButton = $('#criminal-conviction_done-button');
        noButton = $('#has-criminal-convictions-no');
        yesButton = $('#has-criminal-convictions-yes');

        subscribeForEvents();

        bgl.common.validator.init(form);

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupWrite();

        const isAnyCriminalConvictions = criminalConvictionsCount() > 0;

        if (!isAnyCriminalConvictions) {
            const model = bgl.common.datastore.getData(form);

            if (model && model.HasCriminalConvictions) {
                noButton.prop('checked', 'checked');
            }
        }

        if (yesButton.is(':checked') || noButton.is(':checked')) {
            if (doneButton.hasClass(HIDE_CLASS)) {
                doneButton.removeClass(HIDE_CLASS);
            }
        }
    }

    function generateClickOnKeypress(event) {
        const SPACE_KEYCODE = 32;
        const ENTER_KEYCODE = 13;
        const code = event.charCode || event.keyCode;

        if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
            const forAttr = $(event.target).attr('for');

            if (forAttr !== null) {
                $('#' + forAttr).click();
            } else {
                $(this).click();
            }
        }
    }

    function subscribeForEvents() {
        yesButton.off('click').on('click',
            function() {
                const hasCriminalConviction = criminalConvictionsCount() > 0;
                if (!hasCriminalConviction) {
                    criminalConvictionAddAnotherButton.click();
                } else if (criminalConvictionsContainer.hasClass(HIDE_CLASS)) {
                    criminalConvictionsContainer.removeClass(HIDE_CLASS);
                }
            });

        noButton.off('click').on('click',
            function() {
                if (criminalConvictionsCount() === 0) {
                    onSuccess();
                }

                if (!criminalConvictionsContainer.hasClass(HIDE_CLASS)) {
                    criminalConvictionsContainer.addClass(HIDE_CLASS);
                }
            });

        $('button[data-role=\'delete\']').off('click').on('click',
            function(event) {
                event.preventDefault();
                $(this).attr('disabled', 'disabled');

                const target = $(event.target);

                const object = target.is('button') ? target : target.parent();

                const token = $('input[name=\'__RequestVerificationToken\']').val();
                const patchUrl = object.data('url');

                const dataToPost = {
                    __RequestVerificationToken: token,
                    motorCriminalConvictionId: object.data('value'),
                    journeyType: journeyType,
                };

                $.ajax({
                    url: patchUrl,
                    type: 'POST',
                    data: dataToPost,
                    success: function(data) {
                        if (!data.isSuccess) {
                            bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                        } else {
                            isChanged = true;
                            if (criminalConvictionsCount() === 1) {
                                const key = form.data('store-key');
                                const yourDetails = JSON.parse(sessionStorage.getItem(key)) || {};
                                yourDetails['HasCriminalConvictions'] = 'False';
                                sessionStorage.setItem(key, JSON.stringify(yourDetails));
                            }
                            bgl.common.utilities.refreshPage();
                        }
                    },
                });
            }).off('keypress').on('keypress', generateClickOnKeypress);

        criminalConvictionAddAnotherButton.off('click').on('click', function(event) {
            event.preventDefault();

            bgl.components.driverdetails.criminalconvictions.goToWizardStep(1);
        }).off('keypress').on('keypress', generateClickOnKeypress);

        criminalConvictionRemoveAllButton.off('click').on('click', function(event) {
            event.preventDefault();
            noButton.click();
        }).off('keypress').on('keypress', generateClickOnKeypress);

        doneButton.off('click').on('click',
            function() {
                const isNoButtonChecked = noButton.is(':checked');
                const hasCriminalConviction = criminalConvictionsCount() > 0;

                if (isNoButtonChecked && hasCriminalConviction) {
                    isChanged = true;

                    bgl.common.validator.validate(configuration, form);
                } else {
                    onSuccess();
                }
            }).off('keypress').on('keypress', generateClickOnKeypress);

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function subscribeToEventDismissCriminalConvictionsPanel() {
        yesButton.prop('checked', false);
        $(document).on('click.criminalconvictions', '[data-dismiss="slide-panel"]', function() {
            unSubscribeToEventDismissCriminalConvictionsPanel();
            dismissSlidePanelHandler(isChanged);
        });

        $(document).on('keyup.criminalconvictions', function(event) {
            if (event.key === 'Escape') {
                unSubscribeToEventDismissCriminalConvictionsPanel();
                dismissSlidePanelHandler(isChanged);
            }
        });

        $('.overlay').on('click.criminalconvictions', function() {
            unSubscribeToEventDismissCriminalConvictionsPanel();
            dismissSlidePanelHandler(isChanged);
        });
    }

    function unSubscribeToEventDismissCriminalConvictionsPanel() {
        $(document).off('click.criminalconvictions', '[data-dismiss="slide-panel"]');
        $(document).off('keyup.criminalconvictions');
        $('.overlay').off('click');
    }

    function dismissSlidePanelHandler(flag) {
        if (flag === true) {
            bgl.common.utilities.refreshPage();
        }
    }

    function subscribeForEventsWizardStep1() {
        const formstep1 = $('#criminal-convictions-addanother-step1');
        bgl.common.validator.init(formstep1);

        formstep1.off('submit').on('submit', function(event) {
            event.preventDefault();

            $('#MonthText').val($('#Criminal-Conviction-Month option:selected').text());

            bgl.common.validator.validate(configuration, formstep1);
        });

        monthDropdown = formstep1.find('#Criminal-Conviction-Month');
        yearDropdown = formstep1.find('#Criminal-Conviction-Year');

        fullYearMonthOptions = monthDropdown.find('option');

        yearDropdown.on('change', updateMonthDropdown);

        $('a[data-step-type=\'previous-step\']').one('click', function(event) {
            event.preventDefault();
            bgl.common.utilities.refreshPage();
        });
    }

    function subscribeForEventsWizardStep2() {
        const formStep2 = $('#criminal-convictions-addanother-step2');

        bgl.common.validator.init(formStep2);

        formStep2.off('submit').on('submit', function(event) {
            event.preventDefault();

            $('#ConvictionsTypeText').val($('#Conviction-type option:selected').text());

            bgl.common.validator.validate(configuration, formStep2);
        });

        subscribeBreadcrumbs();
    }

    function subscribeForEventsWizardStep3() {
        const formStep3 = $('#criminal-convictions-addanother-step3');

        bgl.common.validator.init(formStep3);

        formStep3.off('submit').on('submit', function(event) {
            event.preventDefault();
            const submit = $(this).find(':submit');
            submit.attr('disabled', 'disabled');

            if (bgl.common.validator.validate(configuration, formStep3) === false) {
                submit.removeAttr('disabled');
            }
        });

        subscribeBreadcrumbs();
    }

    function subscribeBreadcrumbs() {
        $('.criminal-conviction-back-to-first-step').off('click').on('click', function(event) {
            event.preventDefault();

            bgl.components.driverdetails.criminalconvictions.goToWizardStep(1);
        });

        $('.criminal-conviction-back-to-second-step').off('click').on('click', function(event) {
            event.preventDefault();

            bgl.components.driverdetails.criminalconvictions.goToWizardStep(
                2,
                {
                    Year: $('#Year').val(),
                    Month: $('#Month').val(),
                    MonthText: $('#MonthText').val(),
                },
            );
        });
    }

    function goToWizardStep(step, data) {
        const href = $('#UrlToWizard').val();

        const defaultData = getDefaultData(step);

        if (data !== null) {
            $.extend(defaultData, data);
        }

        isChanged = true;

        $.ajax({
            url: href,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(defaultData),
            success: function(data) {
                if (step === 1) {
                    subscribeToEventDismissCriminalConvictionsPanel();
                }

                if (typeof data.isSuccess === 'undefined') {
                    bgl.components.driverdetails.criminalconvictions.updateSlidePanel(data);
                } else if (data.isSuccess === true) {
                    bgl.components.driverdetails.criminalconvictions.updateSlidePanel(data.html);
                } else {
                    bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                }

                switch (step) {
                case 1:
                    bgl.components.driverdetails.criminalconvictions.subscribeForEventsWizardStep1();
                    break;

                case 2:
                    bgl.components.driverdetails.criminalconvictions.subscribeForEventsWizardStep2();
                    break;

                case 3:
                    bgl.components.driverdetails.criminalconvictions.subscribeForEventsWizardStep3();
                    break;
                }
            },
        });
    }

    function getDefaultData(step) {
        const personId = $('#PersonId').val();
        const firstName = $('#FirstName').val();

        const data = {
            ComponentConfiguration: configuration,
            PersonId: personId,
            CriminalConvictionStep: step,
            JourneyType: 2,
        };

        if (firstName) {
            data.FirstName = firstName;
        }

        return data;
    }

    function onSuccess() {
        if (typeof bgl.common.pubsub !== 'undefined') {
            bgl.common.pubsub.emit('fakeFormSubmit', form.attr('id') || form.attr('action') || 'unknown');
        }
        bgl.common.utilities.redirectToUrl(doneButton.data('nextStepUrl'));
    }

    function onError() {
        bgl.components.driverdetails.criminalconvictions.init(configuration);
    }

    function updateMonthDropdown() {
        const months = monthDropdown;
        const selectedMonthValue = months.val();
        const currentYear = $('#CurrentYear').val() * 1;
        const currentMonth = $('#CurrentMonth').val() * 1;
        const selectedYear = yearDropdown.val() * 1;
        const personBirthYear = $('#PersonBirthYear').val() * 1;
        const personBirthMonth = $('#PersonBirthMonth').val() * 1;

        if (selectedYear === currentYear) {
            months.html(fullYearMonthOptions.slice(0, currentMonth + 1));
        } else if (selectedYear === personBirthYear) {
            // merge months after birth month and please select...
            const dropdownOptions = fullYearMonthOptions.slice(personBirthMonth + 1);
            months.html($.merge([fullYearMonthOptions[0]], dropdownOptions));
        } else {
            months.html(fullYearMonthOptions);
        }
        months.val(selectedMonthValue);

        // select first value if value is not selected
        if (!months.val()) {
            months.find('option:eq(0)').prop('selected', true);
        }
    }

    function criminalconvictionsDateOnSuccess(configuration, data) {
        bgl.components.driverdetails.criminalconvictions.updateSlidePanel(data.html);
        bgl.components.driverdetails.criminalconvictions.subscribeForEventsWizardStep2();
    }

    function criminalconvictionsDateOnError() {
        bgl.components.driverdetails.criminalconvictions.subscribeForEventsWizardStep1();
    }

    function criminalconvictionsConvictionTypeOnSuccess(configuration, data) {
        bgl.components.driverdetails.criminalconvictions.updateSlidePanel(data.html);
        bgl.components.driverdetails.criminalconvictions.subscribeForEventsWizardStep3();
    }

    function criminalconvictionsConvictionTypeOnError() {
        bgl.components.driverdetails.criminalconvictions.subscribeForEventsWizardStep2();
    }

    function criminalconvictionsSentenceTypeOnSuccess() {
        unSubscribeToEventDismissCriminalConvictionsPanel();
        $('[data-dismiss="slide-panel"]').click();
        bgl.common.utilities.refreshPage();
    }

    function criminalconvictionsSentenceTypeOnError() {
        bgl.components.driverdetails.criminalconvictions.subscribeForEventsWizardStep3();
    }

    function updateSlidePanel(html) {
        $('#SlidePanelContent').html(html);
    }

    function criminalConvictionsCount() {
        return $('#Criminal-Convictions-List .step-form__summary-item').length;
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
        goToWizardStep: goToWizardStep,
        updateSlidePanel: updateSlidePanel,
        criminalconvictionsDateOnSuccess: criminalconvictionsDateOnSuccess,
        criminalconvictionsDateOnError: criminalconvictionsDateOnError,
        criminalconvictionsConvictionTypeOnError: criminalconvictionsConvictionTypeOnError,
        criminalconvictionsConvictionTypeOnSuccess: criminalconvictionsConvictionTypeOnSuccess,
        criminalconvictionsSentenceTypeOnSuccess: criminalconvictionsSentenceTypeOnSuccess,
        criminalconvictionsSentenceTypeOnError: criminalconvictionsSentenceTypeOnError,
        subscribeForEventsWizardStep1: subscribeForEventsWizardStep1,
        subscribeForEventsWizardStep2: subscribeForEventsWizardStep2,
        subscribeForEventsWizardStep3: subscribeForEventsWizardStep3,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

const journeyTypes = {
    singleEdit: 0,
    additionalDriver: 1,
    multiStepEdit: 2,
};

bgl.components.driverdetails.common = (function() {
    let component;
    const actions = {
        aboutYou: 'AboutYou',
        employmentStatus: 'EmploymentStatus',
        existencePartTimeOccupation: 'ExistencePartTimeOccupation',
        address: 'SearchAddress',
        ukResidentFiveYears: 'UkResidentFiveYears',
        drivingLicenceNumber: 'DrivingLicenceNumber',
        homeOwner: 'HomeOwner',
        typeOfLicence: 'TypeOfLicence',
        licenceHeldSince: 'LicenceHeldSince',
        motorClaims: 'MotorClaims',
        declinedInsurance: 'DeclinedInsurance',
        criminalConvictions: 'CriminalConvictions',
        medicalCondition: 'MedicalCondition',
        medicalConditionDvlaNotified: 'MedicalConditionDvlaNotified',
        contactInformation: 'ContactInformation',
        contactInformationPolicy: 'ContactInformationPolicy',
        motorConvictions: 'MotorConvictions',
        useOfOtherVehicles: 'UseOfOtherVehicles',
        maritalStatus: 'MaritalStatus',
        deleterFrequentDriver: 'DeleteFrequentDriverSlider',
    };

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(componentConfiguration, componentUrl, containerElementId, function() {
            bgl.components.driverdetails.common.init(componentConfiguration);
        });
    }

    function initComponent(componentConfiguration) {
        component = $('#' + componentConfiguration.Id);
        bgl.common.accordions.init();
        setupChangeTelephoneEventBinder(componentConfiguration);
        subscribeForEvents(componentConfiguration);
    }

    function getPreviouslyStoredChangedUserData() {
        let data = [];

        if (sessionStorage.getItem('ChangedUserData') !== null) {
            data = JSON.parse(sessionStorage.getItem('ChangedUserData'));
        }

        return data;
    }

    function setPreviouslyStoredChangedUserData(data) {
        sessionStorage.setItem('ChangedUserData', JSON.stringify(data));
    }

    function getAmountOfYears(dateEntered) {
        if (dateEntered) {
            const formattedDate = dateEntered.split('/').reverse().join('/');
            const dateToday = new Date();
            const fullDateEntered = new Date(formattedDate);
            let year = dateToday.getFullYear() - fullDateEntered.getFullYear();
            const month = dateToday.getMonth() - fullDateEntered.getMonth();
            if (month < 0 || (month === 0 && dateToday.getDate() < fullDateEntered.getDate())) {
                year--;
            }
            return year;
        } else {
            return 0;
        }
    }

    function subscribeForEvents(componentConfiguration) {
        subscribeEditLinks(componentConfiguration);
        subscribeDriverCarousel(componentConfiguration);
    }

    function subscribeDriverCarousel(componentConfiguration) {
        bgl.components.drivertabs.init();

        const selectedDriver = bgl.common.utilities.getUrlHashValue();
        if (selectedDriver !== '') {
            bgl.components.drivertabs.setActiveDriver(selectedDriver);
        }

        $('.named-driver-tab').off('click.driverdetails').on('click.driverdetails', function() {
            bgl.common.utilities.setUrlHashValue(bgl.components.drivertabs.getActiveDriver($(this)));
        });

        $(`[data-accordion-key=${componentConfiguration.Id}-driver-details-accordion]`)
            .off('click.driver-details-accordion')
            .on('click.driver-details-accordion', function() {
                if ($(this).attr('aria-expanded') === 'true') {
                    bgl.components.drivertabs.showArrow();
                }
            });
    }

    function setupChangeTelephoneEventBinder(componentConfiguration) {
        bgl.common.pubsub.on('ChangeTelephoneEventBinder', function(link) {
            const containerSelector = 'SlidePanelContent';
            const actionUrl = link.data('action-url');
            const personId = link.data('personId');
            const policyHolderId = link.data('policyHolderId');
            const source = link.data('source');
            const requestBodyData = {
                componentConfiguration: componentConfiguration,
                personId: personId,
                source: source,
            };
            requestBodyData.personId = policyHolderId;
            bgl.common.loader.load(requestBodyData,
                actionUrl,
                containerSelector,
                function() {
                    bgl.components.contactinformationpolicy.init(componentConfiguration);
                });
        });
    }

    function subscribeEditLinks(componentConfiguration) {
        const SPACE_KEYCODE = 32;
        const ENTER_KEYCODE = 13;
        const editLinks = component.find('[data-action-url]');

        editLinks.off()
            .on({
                'keyup': function(event) {
                    const code = event.charCode || event.keyCode;

                    if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
                        $(this).click();
                    }
                },
                'click': function(event) {
                    event.preventDefault();

                    const link = $(this);

                    const containerSelector = 'SlidePanelContent';
                    const actionUrl = link.data('action-url');
                    const action = link.data('action');
                    const personId = link.data('personId');
                    const policyHolderId = link.data('policyHolderId');
                    const firstName = link.data('driverFirstName');
                    const isPolicyHolder = link.data('isPolicyHolder');

                    const source = link.data('source');
                    const requestBodyData = {
                        componentConfiguration: componentConfiguration,
                        personId: personId,
                        source: source,
                    };

                    if (isPolicyHolder !== 'True') {
                        requestBodyData.FirstName = firstName;
                    }

                    requestBodyData.isPolicyHolder = isPolicyHolder === 'True';

                    switch (action) {
                    case actions.aboutYou:
                        requestBodyData.JourneyType = journeyTypes.singleEdit;
                        bgl.common.loader.load(requestBodyData,
                            actionUrl,
                            containerSelector,
                            function() {
                                bgl.components.aboutyoudriverdetails.init(componentConfiguration);
                            });
                        break;

                    case actions.employmentStatus:
                    case actions.existencePartTimeOccupation:
                        bgl.common.loader.load(requestBodyData,
                            actionUrl,
                            containerSelector,
                            function() {
                                bgl.components.employmentstatusbuilder.init(componentConfiguration, containerSelector);
                            });
                        break;

                    case actions.address:
                        bgl.components.editaddress.load(componentConfiguration,
                            actionUrl,
                            containerSelector);
                        return;

                    case actions.drivingLicenceNumber:
                        bgl.common.loader.load(requestBodyData,
                            actionUrl,
                            containerSelector, function() {
                                bgl.components.drivinglicencenumber.init(componentConfiguration);
                            });
                        break;

                    case actions.homeOwner:
                        requestBodyData.personId = policyHolderId;

                        bgl.common.loader.load(requestBodyData,
                            actionUrl,
                            containerSelector,
                            function() {
                                bgl.components.homeowner.init(componentConfiguration);
                            });
                        break;

                    case actions.ukResidentFiveYears:
                        bgl.common.loader.load(requestBodyData,
                            actionUrl,
                            containerSelector,
                            function() {
                                bgl.components.ukresidentfiveyears.init(componentConfiguration);
                            });
                        break;

                    case actions.typeOfLicence:
                        requestBodyData.firstStep = actions.typeOfLicence;
                        bgl.common.loader.load(requestBodyData,
                            actionUrl,
                            containerSelector,
                            function() {
                                bgl.components.typeoflicence.init(componentConfiguration);
                            });
                        break;

                    case actions.licenceHeldSince:
                        requestBodyData.firstStep = actions.licenceHeldSince;
                        bgl.common.loader.load(requestBodyData,
                            actionUrl,
                            containerSelector,
                            function() {
                                bgl.components.licenceheldsince.init(componentConfiguration);
                            });
                        break;

                    case actions.motorClaims:
                        bgl.common.loader.load(requestBodyData,
                            actionUrl,
                            containerSelector,
                            function() {
                                bgl.components.motorclaims.init(componentConfiguration);
                            });
                        break;

                    case actions.declinedInsurance:
                        bgl.common.loader.load(requestBodyData,
                            actionUrl,
                            containerSelector,
                            function() {
                                bgl.components.declinedinsurance.init(componentConfiguration);
                            });
                        break;

                    case actions.medicalCondition:
                        bgl.common.loader.load(requestBodyData,
                            actionUrl,
                            containerSelector,
                            function() {
                                bgl.components.medicalcondition.init(componentConfiguration);
                            });
                        break;

                    case actions.medicalConditionDvlaNotified:
                        bgl.common.loader.load(requestBodyData,
                            actionUrl,
                            containerSelector,
                            function() {
                                bgl.components.medicalconditiondvlanotified.init(componentConfiguration);
                            });
                        break;

                    case actions.contactInformation:
                        requestBodyData.personId = policyHolderId;
                        bgl.common.loader.load(requestBodyData,
                            actionUrl,
                            containerSelector,
                            function() {
                                bgl.components.contactinformation.init(componentConfiguration);
                            });
                        break;

                    case actions.contactInformationPolicy:
                        requestBodyData.personId = policyHolderId;
                        bgl.common.loader.load(requestBodyData,
                            actionUrl,
                            containerSelector,
                            function() {
                                bgl.components.contactinformationpolicy.init(componentConfiguration);
                            });
                        break;

                    case actions.motorConvictions:
                        bgl.common.loader.load(requestBodyData,
                            actionUrl,
                            containerSelector,
                            function() {
                                bgl.components.motorconvictions.init(componentConfiguration);
                            });
                        break;

                    case actions.criminalConvictions:
                        bgl.common.loader.load(requestBodyData,
                            actionUrl,
                            containerSelector,
                            function() {
                                bgl.components.criminalconvictions.init(componentConfiguration, false);
                            });
                        break;

                    case actions.useOfOtherVehicles:
                        bgl.common.loader.load(requestBodyData,
                            actionUrl,
                            containerSelector,
                            function() {
                                bgl.components.useofothervehicles.init(componentConfiguration);
                            });
                        break;

                    case actions.maritalStatus:
                        bgl.common.loader.load(requestBodyData,
                            actionUrl,
                            containerSelector,
                            function() {
                                bgl.components.maritalstatus.init(componentConfiguration, containerSelector);
                            });
                        break;

                    case actions.deleterFrequentDriver:
                        if (componentConfiguration.IsService && componentConfiguration.LoadEditAsARedirect) {
                            bgl.common.utilities.redirectToUrl(actionUrl);
                        } else {
                            bgl.common.loader.load({
                                componentConfiguration: componentConfiguration,
                                driverId: link.data('driverId'),
                                firstName: link.data('driverFirstName'),
                                lastName: link.data('driverLastName'),
                            },
                            actionUrl,
                            containerSelector,
                            function() {
                                bgl.components.deletefrequentdriver.init(componentConfiguration);
                            });
                        }
                        break;
                    }
                },
            });
    }

    return {
        init: initComponent,
        load: loadComponent,
        getPreviouslyStoredChangedUserData: getPreviouslyStoredChangedUserData,
        setPreviouslyStoredChangedUserData: setPreviouslyStoredChangedUserData,
        getAmountOfYears: getAmountOfYears,
    };
})();

bgl.components.aboutyoudriverdetails = (function() {
    let form;
    let configuration;

    function initComponent(componentConfiguration) {
        initObject(componentConfiguration);

        bgl.common.datastore.init(form);
    }

    function initJourney(componentConfiguration) {
        initObject(componentConfiguration);

        bgl.components.additionaldriver.initJourneyStep();

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();
    }

    function initObject(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#about-you-form');

        bgl.common.validator.enableMaxLength();
        bgl.common.validator.init(form);

        bgl.common.date.initDateFormat($('#DateOfBirth'));

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(event.target))) {
                        $('#HasChanges').val(bgl.common.datastore.isDataChanged($(event.target)) === true);
                        storeUserChangesForTagManager();
                        bgl.common.validator.submitForm($(event.target), configuration);
                    }
                });
    }

    function storeUserChangesForTagManager() {
        const data = bgl.components.driverdetails.common.getPreviouslyStoredChangedUserData();
        if ($('#IsPolicyHolder').val() === 'True') {
            const newDateOfBirth = $('#DateOfBirth').val();
            data.push(['UserAge', bgl.components.driverdetails.common.getAmountOfYears(newDateOfBirth)]);
            bgl.components.driverdetails.common.setPreviouslyStoredChangedUserData(data);
        } else {
            return data;
        }
    }

    function updateNotification(houstonMessage) {
        const notification = JSON.stringify({
            cat: 'pricechange',
            msg: houstonMessage,
        });

        sessionStorage.setItem('notification', notification);

        window.location.reload(true);
    }

    function onSuccess(configuration, data) {
        if (data.nextStepUrl) {
            bgl.components.additionaldriver.nextStep(configuration, data, form);
        } else {
            if (data.hasChanges === true) {
                if (data.houstonMessage) {
                    const params = {
                        callback: function() {
                            updateNotification(data.houstonMessage);
                        },
                    };

                    bgl.common.pubsub.emit('PollBasket', params);
                } else {
                    bgl.common.pubsub.emit('PollBasket');
                }
            }

            bgl.common.datastore.removeSessionStorage(form);
            $('[data-dismiss="slide-panel"]').click();
        }
    }

    function onError() {
        const journeyType = $('#JourneyType').val() - 0;

        switch (journeyType) {
        case 1:
            bgl.components.aboutyoudriverdetails.initJourney(configuration);
            break;
        default:
            bgl.components.aboutyoudriverdetails.init(configuration);
            break;
        }
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        init: initComponent,
        initJourney: initJourney,
        storeUserChangesForTagManager: storeUserChangesForTagManager,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

bgl.components.employmentstatusbuilder = (function() {
    let containerId;
    let configuration;
    let form;
    let hasPreselectedValues;

    function init(componentConfiguration, containerElementId, resetDirtyForm) {
        initObject(componentConfiguration, containerElementId);

        bgl.common.datastore.init(form, resetDirtyForm);
    }

    function initJourney(componentConfiguration, containerElementId) {
        initObject(componentConfiguration, containerElementId);

        bgl.components.additionaldriver.initJourneyStep();

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        hasPreselectedValues = form.find('input[type=radio]:checked').length !== 0;

        if (hasPreselectedValues === true) {
            showContinueButton();
        }

        if (hasPreselectedValues === false) {
            form.find('input[type=radio]')
                .off('click')
                .on('click', continueHandler);
        }
    }

    function initObject(componentConfiguration, containerElementId) {
        configuration = componentConfiguration;
        containerId = containerElementId;

        form = $('[data-component-id=\'' + configuration.Id + '\'] form');

        bgl.common.validator.init(form);
        bgl.common.validator.initAutocompleteSearchInputs(form);

        bgl.common.autocompletesearch.init(3);

        $('a[data-step-type=\'previous-step\']').one('click', function(event) {
            event.preventDefault();

            const backUrl = $(this).attr('href');

            const elementsArray = form.serializeArray();

            const model = {
                componentConfiguration: configuration,
            };

            $.map(elementsArray, function(item, i) {
                model[item['name']] = item['value'];
            });

            loadViewPage(model, backUrl);
        });

        form.off('submit').on('submit',
            function(event) {
                event.preventDefault();

                if (bgl.common.validator.isFormValid($(event.target))) {
                    $('#HasChanges').val(bgl.common.datastore.isDataChanged($(event.target)) === true);

                    if (configuration.IsService) {
                        const mtaSuffix = bgl.common.utilities.getWindowLocation()
                            .href.toLowerCase().includes('makechanges') ?
                            'start' :
                            'additional change';

                        bgl.common.telemetry.logEvent(`MTA ${mtaSuffix}`,
                            {mta_type: 'Employment status', component: configuration.Id});
                    }

                    bgl.common.validator.submitForm($(event.target), configuration);
                }
            });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function continueHandler(event) {
        event.preventDefault();

        if ($(event.target).is(':checked')) {
            $(event.target).trigger('change');
        }

        form.submit();
    }

    function showContinueButton() {
        const continueButton = $(form.find('[type=\'submit\']'));
        continueButton.removeClass('hide');
    }

    function onSuccess(configuration, data) {
        if (data.needDeleteOccupation === true) {
            resetOccupationInfo(data.occupationStep, data.hasChanges, form);
        }

        if (data.hasChanges === true) {
            bgl.common.datastore.extendCollectedData(form, {isFormDirty: false});
        }

        if (data.nextStepUrl) {
            bgl.components.additionaldriver.nextStep(configuration, data, form);
            return;
        }

        if (data.componentUrl) {
            loadViewPage(data.content, data.componentUrl);
            return;
        }

        bgl.common.datastore.removeSessionStorage(form);

        if (configuration && configuration.IsService) {
            if (configuration.IsInitialChange) {
                if (data.hasChanges) {
                    const params = {
                        callback: function() {
                            bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
                        },
                    };
                    bgl.common.pubsub.emit('PollBasket', params);
                } else {
                    bgl.common.contentpanel.hideSlidePanel();
                }
            } else if (data.hasChanges) {
                bgl.common.pubsub.emit('PollBasket');
            } else {
                bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
            }
        } else {
            if (data.hasChanges) {
                bgl.common.pubsub.emit('PollBasket');
            }
            $('[data-dismiss="slide-panel"]').click();
        }
    }

    function loadViewPage(model, url) {
        const initFunc = getInitByJourneyType((model.journeyType || model.JourneyType) - 0);

        bgl.common.loader.load(model, url, containerId,
            function() {
                initFunc(configuration, containerId, false);
            });
    }

    function resetOccupationInfo(stepType, hasChanges, form) {
        if (hasChanges === true) {
            switch (stepType) {
            case 1:
                bgl.common.datastore.deleteFields(form,
                    [
                        'PartTimeOccupationId', 'PartTimeOccupation',
                        'PartTimeBusinessCategoryId', 'PartTimeBusinessCategory',
                    ]);
                break;
            default:
                bgl.common.datastore.deleteFields(form,
                    [
                        'OccupationId', 'Occupation',
                        'BusinessCategoryId', 'BusinessCategory',
                    ]);
                break;
            }
        }
    }

    function onError() {
        const initFunc = getInitByJourneyType($('#JourneyType').val() - 0);

        initFunc(configuration, containerId);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    function getInitByJourneyType(journeyType) {
        switch (journeyType) {
        case 1:
            return bgl.components.employmentstatusbuilder.initJourney;
        default:
            return bgl.components.employmentstatusbuilder.init;
        }
    }

    return {
        init: init,
        initJourney: initJourney,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

bgl.components.editaddress = (function() {
    let configuration;
    let containerId;
    let form;
    const BACK_URL_STACK_KEY = 'backUrlStack';
    const mileageForm = 'AnnualMileage';
    const overnightParkingForm = 'OvernightParking';

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        configuration = componentConfiguration;
        containerId = containerElementId;

        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                bgl.components.editaddress.init(configuration);
                sessionStorage.removeItem(BACK_URL_STACK_KEY);
            },
        );
    }

    function initComponent(componentConfiguration, resetDirtyFlag) {
        configuration = componentConfiguration;

        initValidation(resetDirtyFlag);

        initAjaxLink();

        initBackButtonLink();

        initPostcodeFieldTrim();
    }

    function initValidation(resetDirtyFlag) {
        form = $('[data-component-id=\'' + configuration.Id + '\'] form');

        bgl.common.validator.init(form);
        bgl.common.validator.enableMaxLength();

        bgl.common.datastore.init(form, resetDirtyFlag, true);
        bgl.common.datastore.setupReadAndWrite();

        form.off('submit').on('submit',
            function(e) {
                e.preventDefault();

                form.find('.error-messagebox').removeClass('show');

                if (bgl.common.validator.isFormValid($(this))) {
                    const hasChanges = bgl.common.datastore.isDataChanged($(this)) === true;
                    $('#HasChanges').val(hasChanges);
                    bgl.common.validator.submitForm($(this), configuration);
                }
            });

        subscribeToEventDismissAddressPanel();
    }

    function initAjaxLink() {
        $('.ajax-address-link')
            .off('click')
            .on('click',
                function(e) {
                    e.preventDefault();

                    const url = $(this).attr('href');
                    const backButtonUrl = $(this).data('back-url');

                    pushBackButtonUrl(backButtonUrl);
                    loadView(url);
                });
    }

    function initBackButtonLink() {
        $('.back-button-link')
            .off('click')
            .on('click',
                function(e) {
                    e.preventDefault();
                    $(this).hide();
                    const url = getBackButtonUrl();
                    loadView(url);
                });
    }

    function initPostcodeFieldTrim() {
        $('#PostCode')
            .on('blur',
                function(e) {
                    $(this).val($(this).val().trim());
                });
    }

    function subscribeToEventDismissAddressPanel() {
        $(document).off('click.address', '[data-dismiss="slide-panel"]').on('click.address',
            '[data-dismiss="slide-panel"]',
            function() {
                unSubscribeToEventDismissAddressPanel();
                dismissSlidePanelHandler();
            });

        $(document).off('keyup.address').on('keyup.address',
            function(event) {
                if (event.key === 'Escape') {
                    unSubscribeToEventDismissAddressPanel();
                    dismissSlidePanelHandler();
                }
            });

        $('.overlay').off('click.address').on('click.address',
            function() {
                unSubscribeToEventDismissAddressPanel();
                dismissSlidePanelHandler();
            });
    }

    function unSubscribeToEventDismissAddressPanel() {
        $(document).off('click.address', '[data-dismiss="slide-panel"]');
        $(document).off('keyup.address');
        $('.overlay').off('click.address');
    }

    function dismissSlidePanelHandler() {
        cleanUp(null, {needRaisingEvent: false});
    }


    function getBackButtonUrl() {
        const stack = JSON.parse(sessionStorage.getItem(BACK_URL_STACK_KEY));
        const url = stack.pop();

        sessionStorage.setItem(BACK_URL_STACK_KEY, JSON.stringify(stack));

        return url;
    }

    function pushBackButtonUrl(url) {
        const stack = JSON.parse(sessionStorage.getItem(BACK_URL_STACK_KEY)) || [];

        stack.push(url);

        sessionStorage.setItem(BACK_URL_STACK_KEY, JSON.stringify(stack));
    }

    function loadView(url) {
        let data = bgl.common.datastore.getData(form);

        data.ComponentConfiguration = configuration;

        const resetDirtyFlag = false;

        if (url.indexOf('SearchAddress') !== -1) {
            sessionStorage.removeItem(BACK_URL_STACK_KEY);
            data = configuration;
        } else if (url.indexOf('SelectAddress') === -1) {
            delete data.PostCode;
            delete data.Home;
        }

        bgl.common.loader.load(data,
            url,
            containerId,
            function() {
                initComponent(configuration, resetDirtyFlag);
            });
    }

    function onSuccess(configuration, data) {
        pushBackButtonUrl(data.backButtonUrl);

        bgl.common.loader.load(data.content, data.url, containerId, function() {
            bgl.components.editaddress.init(configuration, data.resetDirtyFlag);
        });
    }

    function cleanUp() {
        bgl.common.datastore.removeSessionStorage(form);
        unSubscribeToEventDismissAddressPanel();
        bgl.common.datastore.removeSessionStorage(BACK_URL_STACK_KEY);

        bgl.common.datastore.removeSessionStorage(mileageForm);
        bgl.common.datastore.removeSessionStorage(overnightParkingForm);
        $('[data-dismiss="slide-panel"]').click();
    }

    function onSuccessConfirmation(configuration, responsePayload) {
        const newSessionObject = $.extend(
            responsePayload.address,
            {
                isFormDirty: responsePayload.hasChanges,
                HasChanges: responsePayload.hasChanges,
            },
        );
        bgl.common.datastore.extendCollectedData(form, newSessionObject);
        pushBackButtonUrl(responsePayload.backButtonUrl);
        bgl.common.loader.load(configuration, responsePayload.url, containerId, function() {
            bgl.components.driverdetails.overnightparking.init(configuration, containerId);
        });
    }

    function onError(configuration) {
        bgl.components.editaddress.init(configuration);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    function postAddressChange(configuration, postUrl, formData) {
        bgl.common.datastore.removeSessionStorage(form);
        unSubscribeToEventDismissAddressPanel();
        bgl.common.datastore.removeSessionStorage(BACK_URL_STACK_KEY);
        bgl.common.datastore.removeSessionStorage(mileageForm);
        bgl.common.datastore.removeSessionStorage(overnightParkingForm);

        $.post(postUrl, formData, function(response) {
            if (response.errorRedirectUrl !== undefined) {
                bgl.common.utilities.errorRedirect(response.errorRedirectUrl);
                return;
            }
            if (configuration && configuration.IsService) {
                const mtaSuffix = bgl.common.utilities.getWindowLocation().href.toLowerCase().includes('makechanges') ?
                    'start' :
                    'additional change';

                bgl.common.telemetry.logEvent(`MTA ${mtaSuffix}`,
                    {mta_type: 'Edit Address', component: configuration.Id});

                if (configuration.IsInitialChange) {
                    if (response.needRaisingEvent) {
                        const params = {
                            callback: function() {
                                bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
                            },
                        };
                        bgl.common.pubsub.emit('PollBasket', params);
                    } else {
                        $('[data-dismiss="slide-panel"]').click();
                    }
                } else {
                    bgl.common.pubsub.emit('PollBasket');
                }
            } else {
                if (response.needRaisingEvent) {
                    bgl.common.pubsub.emit('PollBasket');
                }

                $('[data-dismiss="slide-panel"]').click();
            }
        });
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
        onSuccessConfirmation: onSuccessConfirmation,
        postAddressChange: postAddressChange,
        onError: onError,
    };
})();

bgl.components.ukresidentfiveyears = (function() {
    let form;
    let configuration;
    let residencyStartDateDropdowns;
    let fullYearMonthOptions;
    let currentYearMonthOptions;
    let firstYearMonthOptions;
    let monthDropdown;
    let yearDropdown;
    const HIDE_CLASS = 'hide';
    let hasPreselectedValues;

    function initComponent(componentConfiguration) {
        form = $('#uk-resident-five-years');

        bgl.common.datastore.init(form);

        initObject(componentConfiguration);
    }

    function initJourney(componentConfiguration) {
        form = $('#uk-resident-five-years');

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        initObject(componentConfiguration);

        bgl.components.additionaldriver.initJourneyStep();
    }

    function initObject(componentConfiguration) {
        const currentMonth = $('#CurrentMonth').val() * 1;

        configuration = componentConfiguration;

        residencyStartDateDropdowns = form.find('#residency-start-date-dropdowns');
        monthDropdown = form.find('#Resident-Since-Month');
        yearDropdown = form.find('#Resident-Since-Year');

        bgl.common.validator.init(form);

        fullYearMonthOptions = monthDropdown.find('option');
        currentYearMonthOptions = fullYearMonthOptions.slice(0, currentMonth + 1);
        firstYearMonthOptions = fullYearMonthOptions.slice(0);
        firstYearMonthOptions.splice(1, currentMonth - 1);

        subscribeForEvents();

        updateMonthDropdown();

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function subscribeForEvents() {
        hasPreselectedValues = form.find('input[type=radio]:checked').length !== 0;

        if (hasPreselectedValues) {
            showContinueButton();

            const selectedButton = $(form.find('input[type=radio]:checked')[0]);
            switch (selectedButton.val().toLowerCase()) {
            case 'false':
                if (residencyStartDateDropdowns.hasClass(HIDE_CLASS)) {
                    residencyStartDateDropdowns.removeClass(HIDE_CLASS);
                }
                break;
            }
        }

        form.find('input[type=radio]').off('click').on('click',
            function(event) {
                $(event.target).prop('checked', true);

                updateResidencyStartDateVisibility($(event.target));

                if (hasPreselectedValues !== true) {
                    continueHandler(event);
                }
            });

        yearDropdown.on('change', updateMonthDropdown);

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(this))) {
                        $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)) === true);

                        bgl.common.validator.submitForm($(this), configuration);
                    }
                });
    }

    function updateResidencyStartDateVisibility(element) {
        const value = element.val();

        if (value.toLowerCase() === 'false') {
            if (residencyStartDateDropdowns.hasClass(HIDE_CLASS)) {
                residencyStartDateDropdowns.removeClass(HIDE_CLASS);
            }

            hasPreselectedValues = true;
        } else {
            if (!residencyStartDateDropdowns.hasClass(HIDE_CLASS)) {
                residencyStartDateDropdowns.addClass(HIDE_CLASS);
            }
        }

        if (hasPreselectedValues === true) {
            showContinueButton();
        }
    }

    function showContinueButton() {
        const continueButton = $(form.find('[type=\'submit\']'));
        continueButton.removeClass('hide');
    }

    function continueHandler(event) {
        event.preventDefault();

        if ($(event.target).is(':checked')) {
            $(event.target).trigger('change');
        }

        form.submit();
    }

    function updateMonthDropdown() {
        const months = monthDropdown;
        const selectedMonthValue = months.val();
        const currentYear = $('#CurrentYear').val();
        const firstYear = (currentYear - 5).toString();

        switch (yearDropdown.val()) {
        case currentYear:
            months.html(currentYearMonthOptions);
            break;
        case firstYear:
            months.html(firstYearMonthOptions);
            break;
        default:
            months.html(fullYearMonthOptions);
            break;
        };

        months.val(selectedMonthValue);

        // select first value if value is not selected
        if (!months.val()) {
            months.find('option:eq(0)').prop('selected', true);
        }
    }

    function onSuccess(configuration, data) {
        if (data.nextStepUrl) {
            if (data.hasChanges === true && data.isUkResident === true) {
                bgl.common.datastore.deleteFields(form,
                    [
                        'UkResidentYear', 'UkResidentYearVal', 'UkResidentYearText',
                        'UkResidentMonth', 'UkResidentMonthVal', 'UkResidentMonthText',
                    ]);
                bgl.common.datastore.extendCollectedData(form, {isFormDirty: false});
            }

            bgl.components.additionaldriver.nextStep(configuration, data, form);
        } else {
            if (data.hasChanges === true) {
                bgl.common.pubsub.emit('PollBasket');
            }
            bgl.common.datastore.removeSessionStorage(form);
            $('[data-dismiss="slide-panel"]').click();
        }
    }

    function onError() {
        const journeyType = $('#JourneyType').val() - 0;

        switch (journeyType) {
        case 1:
            bgl.components.ukresidentfiveyears.initJourney(configuration);
            break;
        default:
            bgl.components.ukresidentfiveyears.init(configuration);
            break;
        }
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
        initJourney: initJourney,
    };
})();

bgl.components.typeoflicence = (function() {
    let form;
    let configuration;
    let licenceInputs;
    const containerId = 'SlidePanelContent';
    const internationalLabel = 'I';
    const provisionalLabel = 'P';
    let hasPreselectedValues;
    let continueButton;

    function ctor(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#type-of-licence');

        licenceInputs = form.find('#licence-section [type=radio]');
        continueButton = $(form.find('[type=\'submit\']'));

        bgl.common.validator.init(form);
    }

    function initComponent(componentConfiguration, resetDirtyFlag) {
        ctor(componentConfiguration);

        initObject();

        bgl.common.datastore.init(form, resetDirtyFlag);
    }

    function initJourney(componentConfiguration) {
        ctor(componentConfiguration);

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        initObject();

        bgl.components.additionaldriver.initJourneyStep();
    }

    function initObject() {
        hasPreselectedValues = form.find('input[type=radio]:checked').length !== 0 ||
            continueButton.hasClass('hide') === false;

        updateCountrySectionVisibility();

        subscribeOnEvents();
    }

    function subscribeOnEvents() {
        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(this))) {
                        $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)) === true);

                        bgl.common.validator.submitForm($(this), configuration);
                    }
                });

        licenceInputs.off('click').on('click',
            function(event) {
                updateCountrySectionVisibility();

                if (hasPreselectedValues !== true) {
                    continueHandler(event);
                }
            });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function updateCountrySectionVisibility() {
        const countriesSection = form.find('#licence-row');

        const checkedLicenceValue = findCheckedLicenceValue();

        if (checkedLicenceValue === internationalLabel) {
            hasPreselectedValues = true;
            countriesSection.removeClass('hide');
        } else {
            countriesSection.addClass('hide');
        }

        if (hasPreselectedValues === true) {
            showContinueButton();
        }
    }

    function showContinueButton() {
        const continueButton = $(form.find('[type=\'submit\']'));
        continueButton.removeClass('hide');
    }

    function continueHandler(event) {
        event.preventDefault();

        if ($(event.target).is(':checked')) {
            $(event.target).trigger('change');
        }

        form.submit();
    }

    function onSuccess(configuration, data) {
        const journeyType = $('#JourneyType').val() - 0;
        const content = JSON.parse(data.content);

        switch (journeyType) {
        case 1:
            bgl.common.loader.load(content,
                data.componentUrl,
                containerId,
                function() {
                    bgl.components.licenceheldsince.initJourney(configuration);
                });
            break;
        default:
            const checkedLicenceValue = findCheckedLicenceValue();

            if (checkedLicenceValue === provisionalLabel && data.hasChanges === true) {
                window.sessionStorage.removeItem('DaNAddons');
            }

            bgl.common.loader.load(content,
                data.componentUrl,
                containerId,
                function() {
                    bgl.components.licenceheldsince.init(configuration, false);
                });
            break;
        }
    }

    function onError() {
        const initFunc = getInitByJourneyType($('#JourneyType').val() - 0);

        initFunc(configuration);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    function findCheckedLicenceValue() {
        return form.find('#licence-section [type=radio]:checked').val();
    }

    function getInitByJourneyType(journeyType) {
        switch (journeyType) {
        case 1:
            return bgl.components.typeoflicence.initJourney;
        default:
            return bgl.components.typeoflicence.init;
        }
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
        initJourney: initJourney,
        getInitByJourneyType: getInitByJourneyType,
    };
})();

bgl.components.licenceheldsince = (function() {
    let form;
    let configuration;
    let monthDropdown;
    let yearDropdown;
    let yearsOfLicence;
    let fullYearMonthOptions;
    let fullYearOptions;
    let isSyncingFromHeldSinceYear;
    let isSyncingFromDateDropdowns;

    function initComponent(componentConfiguration, resetDirtyFlag) {
        initObject(componentConfiguration);

        bgl.common.datastore.init(form, resetDirtyFlag);
    }

    function initJourney(componentConfiguration) {
        form = $('#licence-held-since');
        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        initObject(componentConfiguration);

        bgl.components.additionaldriver.initJourneyStep();
    }

    function initObject(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#licence-held-since');
        isSyncingFromHeldSinceYear = false;
        isSyncingFromDateDropdowns = false;

        bgl.common.validator.init(form);

        subscribeOnEvents();

        updateMonthDropdown();
        isSyncingFromDateDropdowns = true;
        updateDateObtained();
        isSyncingFromDateDropdowns = false;
    }

    function subscribeOnEvents() {
        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(this))) {
                        $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)) === true);

                        storeUserChangesForTagManager();

                        bgl.common.validator.submitForm($(this), configuration);
                    }
                });

        $('a[data-step-type=\'previous-step\']').one('click', function(event) {
            event.preventDefault();

            const backUrl = $(this).attr('href');

            $(this).hide();

            const model = {
                componentConfiguration: configuration,
                country: $('#Country').val(),
                licence: $('#Licence').val(),
                firstStep: $('#FirstStep').val(),
                personId: $('#PersonId').val(),
                hasChanges: $('#HasChanges').val(),
                journeyType: $('#JourneyType').val(),
                firstName: $('#FirstName').val(),
            };

            const initFunc = bgl.components.typeoflicence.getInitByJourneyType(model.journeyType - 0);

            bgl.common.loader.load(model, backUrl, 'SlidePanelContent',
                function() {
                    initFunc(configuration, false);
                });
        });

        monthDropdown = form.find('#Since-Month');
        yearDropdown = form.find('#Since-Year');
        yearsOfLicence = form.find('#Held-Since-Year');

        fullYearMonthOptions = monthDropdown.find('option');
        fullYearOptions = yearDropdown.find('option').clone();

        monthDropdown.on('change', updateYearsOfLicenceFromDate);
        yearDropdown.on('change', onYearChanged);
        yearsOfLicence.on('change', updateDateObtained);
    }

    function storeUserChangesForTagManager() {
        const data = bgl.components.driverdetails.common.getPreviouslyStoredChangedUserData();
        if ($('#IsPolicyHolder').val() === 'True') {
            const monthDropdown = $('#Since-Month').val();
            const yearDropdown = $('#Since-Year').val();
            const dateHeldSince = monthDropdown + '/' + yearDropdown;
            data.push(['YearsLicenceHeld', bgl.components.driverdetails.common.getAmountOfYears(dateHeldSince)]);
            bgl.components.driverdetails.common.setPreviouslyStoredChangedUserData(data);
        } else {
            return data;
        }
    }

    function onYearChanged() {
        updateMonthDropdown();
        updateYearsOfLicenceFromDate();
    }

    function updateMonthDropdown() {
        const months = monthDropdown;
        const selectedMonthValue = months.val();
        const currentYear = $('#CurrentYear').val() * 1;
        const currentMonth = $('#CurrentMonth').val() * 1;
        const selectedYear = yearDropdown.val() * 1;
        const personBirthYear = $('#PersonBirthYear').val() * 1;
        const personBirthMonth = $('#PersonBirthMonth').val() * 1;
        const adulthood = personBirthYear + 17;

        if (selectedYear === currentYear) {
            months.html(fullYearMonthOptions.slice(0, currentMonth + 1));
        } else if (selectedYear === adulthood) {
            // merge months after birth month and please select...
            const dropdownOptions = fullYearMonthOptions.slice(personBirthMonth);
            months.html($.merge([fullYearMonthOptions[0]], dropdownOptions));
        } else {
            months.html(fullYearMonthOptions);
        }
        months.val(selectedMonthValue);

        // select first value if value is not selected
        if (!months.val()) {
            months.find('option:eq(0)').prop('selected', true);
        }
    }

    function updateYearsOfLicenceFromDate() {
        if (isSyncingFromHeldSinceYear) {
            return;
        }

        const selectedMonth = monthDropdown.val() * 1;
        const selectedYear = yearDropdown.val() * 1;

        if (selectedMonth <= 0 || selectedYear <= 0) {
            return;
        }

        const currentYear = $('#CurrentYear').val() * 1;
        const currentMonth = $('#CurrentMonth').val() * 1;

        let yearsOfLicenceValue = currentYear - selectedYear;

        if (selectedMonth > currentMonth) {
            yearsOfLicenceValue--;
        }

        const yearsOfLicence = form.find('#Held-Since-Year');
        const yearsOfLicenceOption = yearsOfLicence.find(`option[value="${yearsOfLicenceValue}"]`);

        if (yearsOfLicenceOption.length > 0) {
            isSyncingFromDateDropdowns = true;
            yearsOfLicence.val(yearsOfLicenceValue.toString()).trigger('change');
            isSyncingFromDateDropdowns = false;
        }
    }

    function shouldShowDateObtained(yearsOfLicenceValue) {
        return yearsOfLicenceValue !== null &&
               yearsOfLicenceValue !== '' &&
               Number(yearsOfLicenceValue) <= 4;
    }

    function resetDateObtainedData() {
        yearDropdown.val('');
        monthDropdown.val('');
        bgl.common.datastore.deleteFields(form, [
            'LicenceDateMonth',
            'LicenceDateYear',
            'LicenceDateMonthVal',
            'LicenceDateYearVal',
            'LicenceDateYearText',
            'LicenceDateMonthText',

        ]);
        bgl.common.datastore.extendCollectedData(form, {
            LicenceDateMonth: '',
            LicenceDateYear: '',
            LicenceDateMonthVal: '',
            LicenceDateYearVal: '',
            LicenceDateYearText: '',
            LicenceDateMonthText: '',
        });
    }

    function updateYearDropdownOptions(yearsOfLicenceValue) {
        const currentYear = $('#CurrentYear').val() * 1;

        if (yearsOfLicenceValue === '0') {
            const lastTwoYearsOptions = fullYearOptions.filter(function() {
                return this.value === '' || this.value * 1 >= currentYear - 1;
            });
            yearDropdown.html(lastTwoYearsOptions.clone().removeAttr('selected'));
            return;
        }

        const lastFiveYearsOptions = fullYearOptions.filter(function() {
            return this.value === '' || this.value * 1 >= currentYear - 5;
        });
        yearDropdown.html(lastFiveYearsOptions.clone().removeAttr('selected'));
    }

    function syncDateDropdownsFromYears(selectedYearsOfLicence) {
        if (selectedYearsOfLicence <= 4) {
            return;
        }

        isSyncingFromHeldSinceYear = true;

        const currentYear = $('#CurrentYear').val() * 1;
        const currentMonth = $('#CurrentMonth').val() * 1;

        const targetYear = (currentYear - selectedYearsOfLicence).toString();
        const targetMonth = currentMonth.toString();

        yearDropdown.val(targetYear);
        if (yearDropdown.val() !== targetYear) {
            yearDropdown.val(getOldestAvailableYearValue());
        }

        yearDropdown.trigger('change');

        monthDropdown.val(targetMonth);
        if (monthDropdown.val() !== targetMonth) {
            monthDropdown.find('option:eq(1)').prop('selected', true);
        }

        monthDropdown.trigger('change');
        isSyncingFromHeldSinceYear = false;
    }

    function updateDateObtained() {
        const yearsOfLicenceValue = yearsOfLicence.val();
        const selectedYearsOfLicence = yearsOfLicenceValue * 1;
        const dateLicenceObtained = form.find('#date-licence-obtained');
        const showDateObtained = shouldShowDateObtained(yearsOfLicenceValue);
        const savedYearValue = yearDropdown.val();
        const savedMonthValue = monthDropdown.val();

        form.find('[name="ShowDateObtained"]').val(showDateObtained.toString());

        if (showDateObtained) {
            dateLicenceObtained.removeClass('hide');

            if (!isSyncingFromDateDropdowns) {
                resetDateObtainedData();
            }

            updateYearDropdownOptions(yearsOfLicenceValue);

            if (isSyncingFromDateDropdowns) {
                yearDropdown.val(savedYearValue);
                monthDropdown.val(savedMonthValue);
            }
        } else {
            dateLicenceObtained.addClass('hide');
            yearDropdown.html(fullYearOptions.clone().removeAttr('selected'));
        }

        syncDateDropdownsFromYears(selectedYearsOfLicence);
    }

    function getOldestAvailableYearValue() {
        const yearOptions = yearDropdown.find('option').filter(function() {
            return this.value;
        });

        if (yearOptions.length === 0) {
            return '';
        }

        return yearOptions.last().val();
    }

    function updateNotification(houstonMessage) {
        const notification = JSON.stringify({
            cat: 'pricechange',
            msg: houstonMessage,
        });

        sessionStorage.setItem('notification', notification);

        window.location.reload(true);
    }

    function onSuccess(configuration, data) {
        if (data.nextStepUrl) {
            const licence = $('#Licence').val();

            if (data.hasChanges === true) {
                if (licence === 'I') {
                    bgl.common.datastore.deleteFields(form, ['HasDrivingLicenceNumber', 'DrivingLicenceNumber']);
                } else {
                    bgl.common.datastore.deleteFields(form, ['Country', 'CountryVal', 'CountryText']);
                }
            }

            bgl.common.datastore.extendCollectedData(form, {isFormDirty: false});

            bgl.components.additionaldriver.nextStep(configuration, data, form);
        } else {
            if (data.hasChanges === true) {
                if (data.houstonMessage) {
                    const params = {
                        callback: function() {
                            updateNotification(data.houstonMessage);
                        },
                    };

                    bgl.common.pubsub.emit('PollBasket', params);
                } else {
                    bgl.common.pubsub.emit('PollBasket');
                }
            }
            bgl.common.datastore.removeSessionStorage(form);
            $('[data-dismiss="slide-panel"]').click();
        }
    }

    function onError() {
        const journeyType = $('#JourneyType').val() - 0;

        switch (journeyType) {
        case 1:
            bgl.components.licenceheldsince.initJourney(configuration);
            break;
        default:
            bgl.components.licenceheldsince.init(configuration);
            break;
        }
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        storeUserChangesForTagManager: storeUserChangesForTagManager,
        onError: onError,
        initJourney: initJourney,
    };
})();

bgl.components.drivinglicencenumber = (function() {
    let configuration; let form; let continueButton; let hasPreselectedValues;

    function ctor(componentConfiguration) {
        configuration = componentConfiguration;

        form = $('[data-component-id=\'' + configuration.Id + '\'] form');

        continueButton = $(form.find('[type=\'submit\']'));

        bgl.common.validator.init(form);
    }

    function initComponent(componentConfiguration) {
        ctor(componentConfiguration);

        initObject();

        bgl.common.datastore.init(form);
    }

    function initJourney(componentConfiguration) {
        ctor(componentConfiguration);

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        initObject();
        bgl.components.additionaldriver.initJourneyStep();
    }

    function initObject() {
        initValidation();

        initRadioButtons();
    }

    function initValidation() {
        form.off('submit').on('submit',
            function(e) {
                e.preventDefault();
                e.stopPropagation();

                if (bgl.common.validator.isFormValid($(this))) {
                    $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)) === true);

                    bgl.common.validator.submitForm($(this), configuration);
                }
            });
    }

    function initRadioButtons() {
        if (continueButton.hasClass('hide') === false) {
            hasPreselectedValues = true;
        } else {
            hasPreselectedValues = form.find('input[type=radio]:checked').length !== 0;

            if (hasPreselectedValues === true) {
                showContinueButton();
                setDrivingLicenceRowVisibility(
                    form.find('input[type=\'radio\']:checked').val().toLowerCase() === 'true',
                );
            }
        }

        $('#has-driving-licence-number-yes').on('click',
            function() {
                setDrivingLicenceRowVisibility(true);

                hasPreselectedValues = true;
                showContinueButton();
            });

        $('#has-driving-licence-number-no').on('click',
            function(event) {
                setDrivingLicenceRowVisibility(false);

                if (hasPreselectedValues === false) {
                    $(event.target).prop('checked', 'checked');
                    continueHandler(event);
                }
            });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function showContinueButton() {
        continueButton.removeClass('hide');
    }

    function setDrivingLicenceRowVisibility(needToShow) {
        const drivingLicenceRow = form.find('#driving-licence-number-row');

        if (needToShow === true) {
            drivingLicenceRow.removeClass('hide');
        } else {
            drivingLicenceRow.addClass('hide');
        }
    }

    function continueHandler(event) {
        event.preventDefault();

        if ($(event.target).is(':checked')) {
            $(event.target).trigger('change');
        }

        form.submit();
    }

    function onSuccess(configuration, data) {
        if (data.nextStepUrl) {
            if (data.hasChanges === true && data.hasDrivingLicenceNumber === false) {
                bgl.common.datastore.deleteFields(form, ['DrivingLicenceNumber']);
            }

            bgl.common.datastore.extendCollectedData(form, {isFormDirty: false});

            bgl.components.additionaldriver.nextStep(configuration, data, form);
        } else {
            if (data.hasChanges === true) {
                bgl.common.pubsub.emit('PollBasket');
            }

            bgl.common.datastore.removeSessionStorage(form);
            $('[data-dismiss="slide-panel"]').click();
        }
    }

    function onError() {
        const journeyType = $('#JourneyType').val() - 0;

        switch (journeyType) {
        case 1:
            bgl.components.drivinglicencenumber.initJourney(configuration);
            break;
        default:
            bgl.components.drivinglicencenumber.init(configuration);
            break;
        }
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
        initJourney: initJourney,
    };
})();

bgl.components.declinedinsurance = (function() {
    let form;
    let configuration;
    let submitButton;

    function ctor(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#declined-insurance');
        submitButton = $(form.find('[type=\'submit\']'));

        bgl.common.validator.init(form);
    }

    function initComponent(componentConfiguration) {
        ctor(componentConfiguration);

        bgl.common.datastore.init(form);

        subscribeToEvents();
    }

    function initJourney(componentConfiguration) {
        ctor(componentConfiguration);

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        subscribeToEvents();
        bgl.components.additionaldriver.initJourneyStep();
    }

    function subscribeToEvents() {
        if (submitButton.hasClass('hide') !== false) {
            if (form.find('input[type=radio]:checked').length === 0) {
                form.find('input[type=radio]')
                    .off('keypress', generateClickOnKeypress)
                    .on('keypress', generateClickOnKeypress)
                    .off('click', continueHandler)
                    .on('click', continueHandler);
            } else {
                submitButton.removeClass('hide');
            }
        }

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(this))) {
                        $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)) === true);

                        bgl.common.validator.submitForm($(this), configuration);
                    }
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function generateClickOnKeypress(event) {
        const SPACE_KEYCODE = 32;
        const ENTER_KEYCODE = 13;
        const code = event.charCode || event.keyCode;

        if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
            $(event.target).prop('checked', true);
            $(event.target).click();
        }
    }

    function continueHandler(event) {
        event.preventDefault();

        if ($(event.target).is(':checked')) {
            $(event.target).trigger('change');
        }

        form.submit();
    }

    function onSuccess(configuration, data) {
        if (data.nextStepUrl) {
            bgl.common.datastore.extendCollectedData(form, {isFormDirty: false});

            bgl.components.additionaldriver.nextStep(configuration, data, form);
        } else {
            if (data.hasChanges === true) {
                bgl.common.pubsub.emit('PollBasket');
            }
            bgl.common.datastore.removeSessionStorage(form);
            $('[data-dismiss="slide-panel"]').click();
        }
    }

    function onError() {
        const journeyType = $('#JourneyType').val() - 0;

        switch (journeyType) {
        case 1:
            bgl.components.declinedinsurance.initJourney(configuration);
            break;
        default:
            bgl.components.declinedinsurance.init(configuration);
            break;
        }
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
        initJourney: initJourney,
    };
})();

bgl.components.homeowner = (function() {
    let form;
    let configuration;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#home-owner');

        bgl.common.validator.init(form);
        bgl.common.datastore.init(form);

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(this))) {
                        if (bgl.common.datastore.isDataChanged($(this)) === false) {
                            bgl.common.datastore.removeSessionStorage($(this));
                            $('[data-dismiss="slide-panel"]').click();
                            return;
                        }

                        bgl.common.validator.submitForm($(this), componentConfiguration);
                    }
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function onSuccess() {
        bgl.common.datastore.removeSessionStorage(form);
        bgl.common.pubsub.emit('PollBasket');
        $('[data-dismiss="slide-panel"]').click();
    }

    function onError() {
        bgl.components.homeowner.init(configuration);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

bgl.components.motorclaims = (function() {
    let configuration;
    let motorClaimList;
    let form;
    const HIDE_CLASS = 'hide';
    let haveMotorClaimsBeenChanged = false;
    let isJourneyType = false;
    let motorClaimItems;
    let hasPreselectedValues;

    function ctor(componentConfiguration) {
        configuration = componentConfiguration;
        isJourneyType = false;
        hasPreselectedValues = true;
        form = $('#' + componentConfiguration.Id + '-motor-claims-form');
        motorClaimList = $('#motor-claims-list');
        motorClaimItems = $('.step-form__summary-item');
    }

    function initComponent(componentConfiguration, hasChanges) {
        ctor(componentConfiguration);
        haveMotorClaimsBeenChanged = hasChanges !== undefined && hasChanges === true;
        subscribeForEvents();
    }

    function initJourney(componentConfiguration) {
        ctor(componentConfiguration);
        isJourneyType = true;
        bgl.components.additionaldriver.initJourneyStep();
        bgl.common.datastore.init(form, true, true);

        const noButton = $('#driver-has-claims-no');
        const isAnyClaims = motorClaimItems.length > 0;

        if (isAnyClaims === false) {
            hasPreselectedValues = false;
            const sessionStorageValue = readDataStoreValue(noButton);
            if (sessionStorageValue !== undefined) {
                noButton.prop('checked', true);
                hasPreselectedValues = true;
            }
        }

        bgl.common.datastore.setupWrite();
        subscribeForEvents();
    }

    function readDataStoreValue($element) {
        const journeyData = bgl.common.datastore.getData(form);
        const key = $element.attr('data-store');
        return journeyData[key];
    }

    function subscribeForEvents() {
        subscribeToEventShowMotorClaims();
        subscribeToEventDeleteMotorClaim();
        subscribeToEventRemoveAllMotorClaims();
        subscribeToEventAddMotorClaim();
        subscribeToEventDismissMotorClaimsPanel();
        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function subscribeToEventDismissMotorClaimsPanel() {
        $(document).off('click.motorclaims', '[data-dismiss="slide-panel"]')
            .on('click.motorclaims', '[data-dismiss="slide-panel"]', function() {
                unSubscribeToEventDismissMotorClaimsPanel();
                dismissSlidePanelHandler(haveMotorClaimsBeenChanged);
            });

        $(document).off('keyup.motorclaims').on('keyup.motorclaims', function(event) {
            if (event.key === 'Escape') {
                unSubscribeToEventDismissMotorClaimsPanel();
                dismissSlidePanelHandler(haveMotorClaimsBeenChanged);
            }
        });

        $('.overlay').off('click.motorclaims').on('click.motorclaims', function() {
            unSubscribeToEventDismissMotorClaimsPanel();
            dismissSlidePanelHandler(haveMotorClaimsBeenChanged);
        });
    }

    function unSubscribeToEventDismissMotorClaimsPanel() {
        $(document).off('click.motorclaims', '[data-dismiss="slide-panel"]');
        $(document).off('keyup.motorclaims');
        $('.overlay').off('click.motorclaims');
    }

    function dismissSlidePanelHandler(flag) {
        if (flag === true) {
            bgl.common.pubsub.emit('PollBasket');
        }
    }

    function subscribeToEventShowMotorClaims() {
        const radioButtons = $('input[type=\'radio\']');

        let clickFunction;

        if (hasPreselectedValues === true) {
            $('button[data-remove-all-url]').removeClass(HIDE_CLASS);

            clickFunction = function(key, item) {
                const button = $(item);

                button.off('change').on('change',
                    function(event) {
                        event.preventDefault();

                        switch ($(this).val()) {
                        case 'True':
                            if (motorClaimItems.length === 0) {
                                loadAddMotorClaims($(event.target).data('url'));
                            } else {
                                $('#driver-has-claims-no').attr('data-need-to-delete', 'false');
                                if (motorClaimList.hasClass(HIDE_CLASS)) {
                                    motorClaimList.removeClass(HIDE_CLASS);
                                }
                            }
                            break;
                        case 'False':
                            const isNeededToBeDelete = motorClaimItems.length !== 0;
                            $('#driver-has-claims-no').attr('data-need-to-delete', isNeededToBeDelete);

                            if (!motorClaimList.hasClass(HIDE_CLASS)) {
                                motorClaimList.addClass(HIDE_CLASS);
                            }
                            break;
                        }
                    });
            };
        } else {
            clickFunction = function(key, item) {
                const button = $(item);

                button.on('change',
                    function(event) {
                        event.preventDefault();

                        switch ($(this).val()) {
                        case 'True':
                            if (motorClaimItems.length === 0) {
                                loadAddMotorClaims($(event.target).data('url'));
                            }
                            break;
                        case 'False':
                            if (typeof bgl.common.pubsub !== 'undefined') {
                                bgl.common.pubsub.emit(
                                    'fakeFormSubmit',
                                    form.attr('id') || form.attr('action') || 'unknown',
                                );
                            }
                            redirectToNextJourneyStep();
                            break;
                        }
                    });
            };
        }

        $.each(radioButtons, clickFunction);
    }

    function subscribeToEventAddMotorClaim() {
        $('#add-new-motor-claim').off('click').on('click',
            function(event) {
                event.preventDefault();
                const url = $(event.target).attr('href');
                loadAddMotorClaims(url);
            });
    }

    function subscribeToEventRemoveAllMotorClaims() {
        const removeAllButton = $('#remove-all-motor-claims');
        const noButton = $('#driver-has-claims-no');
        const doneButton = $('button[data-remove-all-url]');

        removeAllButton.off('click');
        removeAllButton.on('click',
            function(event) {
                event.preventDefault();
                noButton.click();
            });

        doneButton.off('click').on('click',
            function() {
                unSubscribeToEventDismissMotorClaimsPanel();
                const isNeededToDelete = noButton.attr('data-need-to-delete') === 'true';
                const isNoButtonChecked = noButton.is(':checked');
                const patchUrl = $(this).data('remove-all-url');
                const journeyType = $('#JourneyType').val();

                if (isNeededToDelete && isNoButtonChecked) {
                    const dataToPost = $.param({
                        __RequestVerificationToken: $('input[name=\'__RequestVerificationToken\']').val(),
                        personId: $('#PersonId').val(),
                        journeyType: journeyType,
                    });

                    $.ajax({
                        url: patchUrl,
                        type: 'POST',
                        data: dataToPost,
                        success: function(data, textStatus, request) {
                            if (request.getResponseHeader('Content-Type') === 'application/json; charset=utf-8') {
                                if (!data.isSuccess && data.errorRedirectUrl !== null) {
                                    bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                                } else if (data.isSuccess) {
                                    (!isJourneyType) ?
                                        bgl.common.pubsub.emit('PollBasket') :
                                        redirectToNextJourneyStep(data);
                                }
                            }
                        },
                    });
                } else if (isJourneyType) {
                    redirectToNextJourneyStep();
                } else if (haveMotorClaimsBeenChanged === true) {
                    bgl.common.pubsub.emit('PollBasket');
                }

                if (!isJourneyType) {
                    sessionStorage.removeItem('drivers');
                }
            });
    }

    function redirectToNextJourneyStep(data) {
        const dataToPost = data || {};
        dataToPost.nextStepUrl = form.data('next-step-url');
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: false});
        bgl.components.additionaldriver.nextStep(configuration, dataToPost, form);
    }

    function subscribeToEventDeleteMotorClaim() {
        const deleteMotorClaimButtons = $('button[data-role=\'delete\']');

        $.each(deleteMotorClaimButtons,
            function(key, item) {
                $(item).off('click');
                $(item).on('click', function(event) {
                    event.preventDefault();
                    $(item).attr('disabled', 'disabled');

                    const target = $(event.target);
                    const link = target.is('button') ? target : target.parent();
                    const token = $('input[name=\'__RequestVerificationToken\']').val();
                    const patchUrl = link.attr('href');
                    const personId = $('#PersonId').val();
                    const journeyType = $('#JourneyType').val();

                    const dataToPost = $.param({
                        __RequestVerificationToken: token,
                        motorclaimId: link.data('claim-id'),
                        journeyType: journeyType,
                    });

                    const model = {
                        componentConfiguration: configuration,
                        personId: personId,
                        getPersons: false,
                        journeyType: journeyType,
                        firstName: $('#FirstName').val(),
                    };

                    $.ajax({
                        url: patchUrl,
                        type: 'POST',
                        data: dataToPost,
                        success: function(data, textStatus, request) {
                            if (request.getResponseHeader('Content-Type') === 'application/json; charset=utf-8') {
                                if (!data.isSuccess) {
                                    bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                                } else {
                                    bgl.common.loader.load(model,
                                        data.redirectUrl,
                                        'SlidePanelContent',
                                        function() {
                                            if (isJourneyType === true) {
                                                if (motorClaimItems.length === 1) {
                                                    const additionalDriver = JSON.parse(
                                                        sessionStorage.getItem('AdditionalDriver'),
                                                    );
                                                    additionalDriver['HasClaims'] = 'False';
                                                    sessionStorage.setItem(
                                                        'AdditionalDriver',
                                                        JSON.stringify(additionalDriver),
                                                    );
                                                }

                                                bgl.components.motorclaims.initJourney(configuration);
                                            } else {
                                                bgl.components.motorclaims.init(configuration, true);
                                            }
                                        });
                                }
                            }
                        },
                    });
                });
            });
    }

    function loadAddMotorClaims(url) {
        const model = {
            ComponentConfiguration: configuration,
            PersonId: $('#PersonId').val(),
            JourneyType: $('#JourneyType').val(),
            FirstName: $('#FirstName').val(),
        };

        bgl.common.loader.load(model,
            url,
            'SlidePanelContent',
            function() {
                bgl.components.motorclaimbuilder.init(configuration);
            });
    }

    function storeDrivers(value) {
        sessionStorage.setItem('drivers', value);
    }

    return {
        init: initComponent,
        initJourney: initJourney,
        storeDrivers: storeDrivers,
    };
})();

bgl.components.motorclaimbuilder = (function() {
    let form;
    let configuration;
    const HIDE_CLASS = 'hide';

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#add-motor-claim');

        if (form) {
            bgl.common.validator.init(form);
            bgl.common.validator.initNumberInputField($('#Claim-Amount'), 5);
        }

        subscribeForEvents();
    }

    function subscribeForEvents() {
        $('.step-form__button').off('click').on('click',
            function(event) {
                event.preventDefault();
                const link = $(event.target);
                selectNextStep(link);
            });

        $('.form-row__breadcrumb-link').off('click').on('click',
            function(event) {
                event.preventDefault();
                gotoBack($(event.target));
            });

        $('[data-step-type="previous-step"]').off('click').on('click',
            function(event) {
                event.preventDefault();
                gotoBack($(event.target));
            });

        const claimAmountRow = $('#claim-amount-row');

        $('#claim-has-amount-no').on('click',
            function() {
                if (!claimAmountRow.hasClass(HIDE_CLASS)) {
                    claimAmountRow.addClass(HIDE_CLASS);
                }
            });

        $('#claim-has-amount-yes').on('click',
            function() {
                if (claimAmountRow.hasClass(HIDE_CLASS)) {
                    claimAmountRow.removeClass(HIDE_CLASS);
                }
            });

        if (form) {
            form.off('submit')
                .on('submit',
                    function(event) {
                        event.preventDefault();
                        event.stopPropagation();

                        const submit = $(this).find(':submit');
                        submit.attr('disabled', 'disabled');

                        if (bgl.common.validator.validate(configuration, form) === false) {
                            submit.removeAttr('disabled');
                        }
                    });
        }
    }

    function gotoBack(link) {
        selectNextStep(link, true);
    }

    function selectNextStep(link, isBack) {
        const nextStep = link.data('next-step');

        const currentStep = $('#motor-claim-tiles').data('current-step');

        if (typeof bgl.common.pubsub !== 'undefined') {
            bgl.common.pubsub.emit('fakeFormSubmit', currentStep);
        }

        const url = link.attr('href');

        if (currentStep === 'Year' && isBack === true) {
            loadMotorClaims(url);
            return;
        }

        let currentValue = {
            Code: link.data('code'),
            Value: $.trim(link.text()),
            BuilderStep: currentStep,
        };

        const model = {
            ComponentConfiguration: configuration,
            PersonId: $('#PersonId').val(),
            CurrentStep: nextStep,
            JourneyType: $('#JourneyType').val(),
            FirstName: $('#FirstName').val(),
        };

        if (nextStep === 'Driving') {
            model.BuilderTileItems = JSON.parse(sessionStorage.getItem('drivers'));
        }

        if (isBack) {
            currentValue = undefined;
            model.IsBackButtonClicked = true;
        }

        model.SelectedValues = getSelectedValues(currentValue);

        bgl.common.loader.load(model,
            url,
            'SlidePanelContent',
            function() {
                bgl.components.motorclaimbuilder.init(configuration);
            });
    }

    function getSelectedValues(currentValue) {
        const result = [];

        const breadcrumbLinks = $('.form-row__breadcrumb-link') || [];

        $.each(breadcrumbLinks,
            function(idx, element) {
                const value = {
                    Code: $(element).data('code'),
                    Value: $.trim($(element).text()),
                    BuilderStep: $(element).data('next-step'),
                };

                result.push(value);
            });

        if (currentValue !== undefined) {
            result.push(currentValue);
        }

        return result;
    }

    function onSuccess(configuration, data) {
        loadMotorClaims(data.redirectUrl);
    }

    function loadMotorClaims(url) {
        const model = {
            ComponentConfiguration: configuration,
            PersonId: $('#PersonId').val(),
            getPersons: false,
            JourneyType: $('#JourneyType').val(),
            FirstName: $('#FirstName').val(),
        };

        const initFunc = getInitByJourneyType((model.journeyType || model.JourneyType) - 0);

        bgl.common.loader.load(model,
            url,
            'SlidePanelContent',
            function() {
                initFunc(configuration, true);
            });
    }

    function getInitByJourneyType(journeyType) {
        switch (journeyType) {
        case 1:
            return bgl.components.motorclaims.initJourney;
        default:
            return bgl.components.motorclaims.init;
        }
    }

    function onError() {
        bgl.components.motorclaimbuilder.init(configuration);
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

bgl.components.criminalconvictions = (function() {
    let form;
    let configuration;
    let criminalConvictionsContainer;
    let criminalConvictionAddAnotherButton;
    let criminalConvictionRemoveAllButton;
    let noButton;
    let yesButton;
    let fullYearMonthOptions;
    let monthDropdown;
    let yearDropdown;
    let isChanged = false;
    const HIDE_CLASS = 'hide';
    let journeyType = journeyTypes.singleEdit;
    let doneButton;

    function ctor(componentConfiguration, isChangedComponent) {
        configuration = componentConfiguration;
        isChanged = isChangedComponent;

        form = $('#criminal-convictions');
        criminalConvictionsContainer = $('#criminal-convictions-container');
        criminalConvictionAddAnotherButton = criminalConvictionsContainer.find('#criminal-conviction-add-another');
        criminalConvictionRemoveAllButton = criminalConvictionsContainer.find('#remove-all-criminal-convictions');

        doneButton = $('#criminal-conviction_done-button');
        noButton = $('#has-criminal-convictions-no');
        yesButton = $('#has-criminal-convictions-yes');

        bgl.common.validator.init(form, {ignore: ''});
    }

    function initComponent(componentConfiguration, isChangedComponent) {
        ctor(componentConfiguration, isChangedComponent);

        subscribeForEvents();
    }

    function initJourney(componentConfiguration, isChangedComponent) {
        ctor(componentConfiguration, isChangedComponent);

        bgl.components.additionaldriver.initJourneyStep();

        if (criminalConvictionsnCount() === 0) {
            const additionalDriver = bgl.common.datastore.getData(form);

            if (additionalDriver !== null && additionalDriver['HasCriminalConvictions'] === 'False') {
                noButton.prop('checked', true);
            }
        }

        bgl.common.datastore.init(form, true, true);
        bgl.common.datastore.setupWrite();

        subscribeForEvents();

        journeyType = journeyTypes.additionalDriver;
    }

    function generateClickOnKeypress(event) {
        const SPACE_KEYCODE = 32;
        const ENTER_KEYCODE = 13;
        const code = event.charCode || event.keyCode;

        if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
            const forAttr = $(event.target).attr('for');

            if (forAttr !== null) {
                $('#' + forAttr).click();
            } else {
                $(this).click();
            }
        }
    }

    function subscribeToEventShowCriminalConvictions() {
        yesButton.off('click').on('click',
            function() {
                const hasCriminalConviction =
                    criminalConvictionsContainer.find('.criminal-conviction-item').length > 0;
                if (!hasCriminalConviction) {
                    criminalConvictionAddAnotherButton.click();
                } else if (criminalConvictionsContainer.hasClass(HIDE_CLASS)) {
                    criminalConvictionsContainer.removeClass(HIDE_CLASS);
                }
            });

        noButton.off('click').on('click',
            function() {
                if (!criminalConvictionsContainer.hasClass(HIDE_CLASS)) {
                    criminalConvictionsContainer.addClass(HIDE_CLASS);
                }
            });
    }

    function subscribeForEvents() {
        subscribeToEventShowCriminalConvictions();

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);

        $('button[data-role=\'delete\']').off('click').on('click',
            function(event) {
                event.preventDefault();
                $(this).attr('disabled', 'disabled');

                const target = $(event.target);

                const object = target.is('button') ? target : target.parent();

                const token = $('input[name=\'__RequestVerificationToken\']').val();
                const patchUrl = object.data('url');

                const dataToPost = {
                    __RequestVerificationToken: token,
                    motorCriminalConvictionId: object.data('value'),
                    journeyType: journeyType,
                };

                const requestBodyData = {
                    componentConfiguration: configuration,
                    personId: $('#PersonId').val(),
                    firstName: $('#FirstName').val(),
                    journeyType: journeyType,
                };

                $.ajax({
                    url: patchUrl,
                    type: 'POST',
                    data: dataToPost,
                    success: function(data) {
                        if (!data.isSuccess) {
                            bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                        } else {
                            isChanged = true;
                            bgl.common.loader.load(requestBodyData,
                                data.redirectUrl,
                                'SlidePanelContent',
                                function() {
                                    switch (journeyType) {
                                    case 1:
                                        if (criminalConvictionsnCount() === 0) {
                                            const additionalDriver = JSON.parse(
                                                sessionStorage.getItem('AdditionalDriver'),
                                            );
                                            additionalDriver['HasCriminalConvictions'] = 'False';
                                            sessionStorage.setItem('AdditionalDriver',
                                                JSON.stringify(additionalDriver));
                                        }
                                        bgl.components.criminalconvictions.initJourney(configuration);
                                        break;
                                    default:
                                        bgl.components.criminalconvictions.init(configuration, true);
                                        break;
                                    }
                                });
                        }
                    },
                });
            }).off('keypress').on('keypress', generateClickOnKeypress);

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    isChanged = true;

                    bgl.common.validator.validate(configuration, form);
                });

        criminalConvictionAddAnotherButton.off('click').on('click', function(event) {
            event.preventDefault();

            bgl.components.criminalconvictions.goToWizardStep(1);
        }).off('keypress').on('keypress', generateClickOnKeypress);

        criminalConvictionRemoveAllButton.off('click').on('click', function(event) {
            event.preventDefault();
            noButton.click();
        }).off('keypress').on('keypress', generateClickOnKeypress);

        doneButton.off('click').on('click',
            function() {
                doneButton.attr('disabled', 'disabled');
                if (!bgl.common.validator.isFormValid(form)) {
                    doneButton.removeAttr('disabled');
                    return;
                }

                unSubscribeToEventDismissCriminalConvictionsPanel();
                const isNoButtonChecked = noButton.is(':checked');
                const hasCriminalConviction = criminalConvictionsContainer.find('.criminal-conviction-item').length > 0;

                if (isNoButtonChecked && hasCriminalConviction) {
                    isChanged = true;

                    bgl.common.validator.validate(configuration, form);
                } else if (bgl.components.additionaldriver.isAdditionalDriverJourney()) {
                    if ((isNoButtonChecked && !hasCriminalConviction) || yesButton.is(':checked')) {
                        isChanged = true;
                        bgl.components.additionaldriver.createDriver(
                            configuration,
                            $(this).data('createDriverUrl'),
                            form,
                        );
                    }
                } else {
                    $('[data-dismiss="slide-panel"]').click();
                    dismissSlidePanelHandler(isChanged);
                }
            }).off('keypress').on('keypress', generateClickOnKeypress);

        subscribeToEventDismissCriminalConvictionsPanel();
    }

    function subscribeToEventDismissCriminalConvictionsPanel() {
        $(document).off('click.criminalconvictions', '[data-dismiss="slide-panel"]')
            .on('click.criminalconvictions', '[data-dismiss="slide-panel"]', function() {
                unSubscribeToEventDismissCriminalConvictionsPanel();
                dismissSlidePanelHandler(isChanged);
            });

        $(document).off('keyup.criminalconvictions').on('keyup.criminalconvictions', function(event) {
            if (event.key === 'Escape') {
                unSubscribeToEventDismissCriminalConvictionsPanel();
                dismissSlidePanelHandler(isChanged);
            }
        });

        $('.overlay').off('click.criminalconvictions').on('click.criminalconvictions', function() {
            unSubscribeToEventDismissCriminalConvictionsPanel();
            dismissSlidePanelHandler(isChanged);
        });
    }

    function unSubscribeToEventDismissCriminalConvictionsPanel() {
        $(document).off('click.criminalconvictions', '[data-dismiss="slide-panel"]');
        $(document).off('keyup.criminalconvictions');
        $('.overlay').off('click.criminalconvictions');
    }

    function dismissSlidePanelHandler(flag) {
        if (flag === true) {
            bgl.common.pubsub.emit('PollBasket');
        }
    }

    function subscribeForEventsWizardStep1() {
        const formstep1 = $('#criminal-convictions-addanother-step1');
        bgl.common.validator.init(formstep1);

        formstep1.off('submit').on('submit', function(event) {
            event.preventDefault();

            $('#MonthText').val($('#Criminal-Conviction-Month option:selected').text());

            bgl.common.validator.validate(configuration, formstep1);
        });

        monthDropdown = formstep1.find('#Criminal-Conviction-Month');
        yearDropdown = formstep1.find('#Criminal-Conviction-Year');

        fullYearMonthOptions = monthDropdown.find('option');

        yearDropdown.on('change', updateMonthDropdown);

        $('a[data-step-type=\'previous-step\']').one('click', function(event) {
            event.preventDefault();

            $(this).hide();

            const backUrl = $(this).attr('href');
            const personId = $('#PersonId').val();

            const model = {
                componentConfiguration: configuration,
                personId: personId,
                firstName: $('#FirstName').val(),
                journeyType: journeyType,
            };

            switch (model.journeyType) {
            case 1:
                bgl.common.loader.load(model,
                    backUrl,
                    'SlidePanelContent',
                    function() {
                        bgl.components.criminalconvictions.initJourney(configuration);
                    });
                break;
            default:
                bgl.common.loader.load(model,
                    backUrl,
                    'SlidePanelContent',
                    function() {
                        bgl.components.criminalconvictions.init(configuration, true);
                    });
                break;
            }
        });
    }

    function subscribeForEventsWizardStep2() {
        const formStep2 = $('#criminal-convictions-addanother-step2');

        bgl.common.validator.init(formStep2);

        formStep2.off('submit').on('submit', function(event) {
            event.preventDefault();

            $('#ConvictionsTypeText').val($('#Conviction-type option:selected').text());

            bgl.common.validator.validate(configuration, formStep2);
        });

        subscribeBreadcrumbs();
    }

    function subscribeForEventsWizardStep3() {
        const formStep3 = $('#criminal-convictions-addanother-step3');

        bgl.common.validator.init(formStep3);

        formStep3.off('submit').on('submit', function(event) {
            event.preventDefault();
            const submit = $(this).find(':submit');
            submit.attr('disabled', 'disabled');

            if (bgl.common.validator.validate(configuration, formStep3) === false) {
                submit.removeAttr('disabled');
            }
        });

        subscribeBreadcrumbs();
    }

    function subscribeBreadcrumbs() {
        $('.criminal-conviction-back-to-first-step').off('click').on('click', function(event) {
            event.preventDefault();

            bgl.components.criminalconvictions.goToWizardStep(1);
        });

        $('.criminal-conviction-back-to-second-step').off('click').on('click', function(event) {
            event.preventDefault();

            bgl.components.criminalconvictions.goToWizardStep(
                2,
                {
                    Year: $('#Year').val(),
                    Month: $('#Month').val(),
                    MonthText: $('#MonthText').val(),
                },
            );
        });
    }

    function goToWizardStep(step, data) {
        const href = $('#UrlToWizard').val();

        const defaultData = getDefaultData(step);

        if (data !== null) {
            $.extend(defaultData, data);
        }

        isChanged = true;

        $.ajax({
            url: href,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(defaultData),
            success: function(data) {
                if (typeof data.isSuccess === 'undefined') {
                    bgl.components.criminalconvictions.updateSlidePanel(data);
                } else if (data.isSuccess === true) {
                    bgl.components.criminalconvictions.updateSlidePanel(data.html);
                } else {
                    bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                }

                switch (step) {
                case 1:
                    bgl.components.criminalconvictions.subscribeForEventsWizardStep1();
                    break;

                case 2:
                    bgl.components.criminalconvictions.subscribeForEventsWizardStep2();
                    break;

                case 3:
                    bgl.components.criminalconvictions.subscribeForEventsWizardStep3();
                    break;
                }
            },
        });
    }

    function getDefaultData(step) {
        const personId = $('#PersonId').val();
        const firstName = $('#FirstName').val();

        let additionalDriverData = bgl.components.additionaldriver.isAdditionalDriverJourney() ?
            JSON.parse(sessionStorage.getItem('AdditionalDriver')) :
            {};

        additionalDriverData = $.extend(additionalDriverData,
            {ComponentConfiguration: configuration, PersonId: personId, CriminalConvictionStep: step});

        if (firstName) {
            additionalDriverData.FirstName = firstName;
        }

        return additionalDriverData;
    }

    function onSuccess(configuration, data) {
        unSubscribeToEventDismissCriminalConvictionsPanel();
        if (data.nextStepUrl) {
            bgl.common.datastore.extendCollectedData(form, {isFormDirty: false});

            bgl.components.additionaldriver.createDriver(configuration, data.nextStepUrl, form);
        } else if (configuration.IsService) {
            if (configuration.IsInitialChange) {
                const params = {
                    callback: function() {
                        bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
                    },
                };
                bgl.common.pubsub.emit('PollBasket', params);
            } else {
                bgl.common.pubsub.emit('PollBasket');
            }
        } else if (configuration.HasPageRefresh) {
            bgl.common.utilities.refreshPage();
        } else {
            if (isChanged) {
                bgl.common.pubsub.emit('PollBasket');
            }
            $('[data-dismiss="slide-panel"]').click();
        }
    }

    function onError() {
        const journeyType = $('#JourneyType').val() - 0;

        switch (journeyType) {
        case 1:
            bgl.components.criminalconvictions.initJourney(configuration);
            break;
        default:
            bgl.components.criminalconvictions.init(configuration);
            break;
        }
    }

    function updateMonthDropdown() {
        const months = monthDropdown;
        const selectedMonthValue = months.val();
        const currentYear = $('#CurrentYear').val() * 1;
        const currentMonth = $('#CurrentMonth').val() * 1;
        const selectedYear = yearDropdown.val() * 1;
        const personBirthYear = $('#PersonBirthYear').val() * 1;
        const personBirthMonth = $('#PersonBirthMonth').val() * 1;

        if (selectedYear === currentYear) {
            months.html(fullYearMonthOptions.slice(0, currentMonth + 1));
        } else if (selectedYear === personBirthYear) {
            // merge months after birth month and please select...
            const dropdownOptions = fullYearMonthOptions.slice(personBirthMonth + 1);
            months.html($.merge([fullYearMonthOptions[0]], dropdownOptions));
        } else {
            months.html(fullYearMonthOptions);
        }
        months.val(selectedMonthValue);

        // select first value if value is not selected
        if (!months.val()) {
            months.find('option:eq(0)').prop('selected', true);
        }
    }

    function criminalconvictionsDateOnSuccess(configuration, data) {
        bgl.components.criminalconvictions.updateSlidePanel(data.html);
        bgl.components.criminalconvictions.subscribeForEventsWizardStep2();
    }

    function criminalconvictionsDateOnError() {
        bgl.components.criminalconvictions.subscribeForEventsWizardStep1();
    }

    function criminalconvictionsConvictionTypeOnSuccess(configuration, data) {
        bgl.components.criminalconvictions.updateSlidePanel(data.html);
        bgl.components.criminalconvictions.subscribeForEventsWizardStep3();
    }

    function criminalconvictionsConvictionTypeOnError() {
        bgl.components.criminalconvictions.subscribeForEventsWizardStep2();
    }

    function criminalconvictionsSentenceTypeOnSuccess(configuration, data) {
        bgl.components.criminalconvictions.updateSlidePanel(data.html);
        if (bgl.components.additionaldriver.isAdditionalDriverJourney()) {
            bgl.components.additionaldriver.initJourneyStep();
        }

        bgl.components.criminalconvictions.init(configuration, true);
    }

    function criminalconvictionsSentenceTypeOnError() {
        bgl.components.criminalconvictions.subscribeForEventsWizardStep3();
    }

    function updateSlidePanel(html) {
        $('#SlidePanelContent').html(html);
    }

    function criminalConvictionsnCount() {
        return $('#Criminal-Convictions-List .step-form__summary-item').length;
    }

    return {
        init: initComponent,
        initJourney: initJourney,
        onSuccess: onSuccess,
        onError: onError,
        goToWizardStep: goToWizardStep,
        updateSlidePanel: updateSlidePanel,
        criminalconvictionsDateOnSuccess: criminalconvictionsDateOnSuccess,
        criminalconvictionsDateOnError: criminalconvictionsDateOnError,
        criminalconvictionsConvictionTypeOnError: criminalconvictionsConvictionTypeOnError,
        criminalconvictionsConvictionTypeOnSuccess: criminalconvictionsConvictionTypeOnSuccess,
        criminalconvictionsSentenceTypeOnSuccess: criminalconvictionsSentenceTypeOnSuccess,
        criminalconvictionsSentenceTypeOnError: criminalconvictionsSentenceTypeOnError,
        subscribeForEventsWizardStep1: subscribeForEventsWizardStep1,
        subscribeForEventsWizardStep2: subscribeForEventsWizardStep2,
        subscribeForEventsWizardStep3: subscribeForEventsWizardStep3,
    };
})();

bgl.components.medicalcondition = (function() {
    let form;
    let configuration;
    const containerId = 'SlidePanelContent';
    let submitButton;

    function ctor(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#medical-condition');
        submitButton = $(form.find('[type=\'submit\']'));

        bgl.common.validator.init(form, configuration);
    }

    function initComponent(componentConfiguration, resetDirtyFlag) {
        ctor(componentConfiguration);

        initObject();

        bgl.common.datastore.init(form, resetDirtyFlag);
    }

    function initJourney(componentConfiguration) {
        ctor(componentConfiguration);

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        initObject();

        bgl.components.additionaldriver.initJourneyStep();
    }

    function initObject() {
        subscribeForEvents();
    }

    function subscribeForEvents() {
        if (submitButton.hasClass('hide') === false) {
            $('#medical-yes').off('click')
                .on('click',
                    function() {
                        submitButton.text('Continue');
                    });

            $('#medical-no').off('click')
                .on('click',
                    function() {
                        const journeyType = $('#JourneyType').val() - 0;

                        if (journeyType === 0) {
                            submitButton.text('Done');
                        }
                    });
        } else {
            if (form.find('input[type=radio]:checked').length === 0) {
                form.find('input[type=radio]')
                    .off('keypress', generateClickOnKeypress)
                    .on('keypress', generateClickOnKeypress)
                    .off('click', continueHandler)
                    .on('click', continueHandler);
            } else {
                submitButton.removeClass('hide');
            }
        }

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(this))) {
                        $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)) === true);

                        bgl.common.validator.submitForm($(this), configuration);
                    }
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function generateClickOnKeypress(event) {
        const SPACE_KEYCODE = 32;
        const ENTER_KEYCODE = 13;
        const code = event.charCode || event.keyCode;

        if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
            $(event.target).prop('checked', true);
            $(event.target).click();
        }
    }

    function continueHandler(event) {
        event.preventDefault();

        if ($(event.target).is(':checked')) {
            $(event.target).trigger('change');
        }

        form.submit();
    }

    function onSuccess(configuration, data) {
        if (data.content !== undefined) {
            const callbackFunc =
                bgl.components.medicalconditiondvlanotified.getInitByJourneyType($('#JourneyType').val() - 0);

            bgl.common.loader.load(data.content,
                data.componentUrl,
                containerId,
                function() {
                    callbackFunc(configuration, false);
                });
        } else if (data.nextStepUrl) {
            bgl.common.datastore.deleteFields(form, ['MedicalConditionDvlaNotified']);
            bgl.common.datastore.extendCollectedData(form, {isFormDirty: false});

            bgl.components.additionaldriver.nextStep(configuration, data, form);
        } else {
            if (data.hasChanges === true) {
                bgl.common.pubsub.emit('PollBasket');
            }

            bgl.common.datastore.removeSessionStorage(form);
            $('[data-dismiss="slide-panel"]').click();
        }
    }

    function onError() {
        const initFunc = getInitByJourneyType($('#JourneyType').val() - 0);

        initFunc(configuration);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    function getInitByJourneyType(journeyType) {
        switch (journeyType) {
        case 1:
            return bgl.components.medicalcondition.initJourney;
        default:
            return bgl.components.medicalcondition.init;
        }
    }

    return {
        init: initComponent,
        initJourney: initJourney,
        onSuccess: onSuccess,
        onError: onError,
        getInitByJourneyType: getInitByJourneyType,
    };
})();

bgl.components.medicalconditiondvlanotified = (function() {
    let form;
    let configuration;
    const containerId = 'SlidePanelContent';
    let continueButton;

    function ctor(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#medical-condition-dvla-notified');
        continueButton = $(form.find('[type=\'submit\']'));

        bgl.common.validator.init(form);
    }

    function initComponent(componentConfiguration) {
        ctor(componentConfiguration);

        bgl.common.datastore.init(form);

        subscribeForEvents();
    }

    function initJourney(componentConfiguration) {
        ctor(componentConfiguration);

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        subscribeForEvents();
        bgl.components.additionaldriver.initJourneyStep();
    }

    function subscribeForEvents() {
        if (form.find('input[type=radio]:checked').length === 0 || continueButton.hasClass('hide') === false) {
            form.find('input[type=radio]')
                .off('keypress', generateClickOnKeypress)
                .on('keypress', generateClickOnKeypress)
                .off('click', continueHandler)
                .on('click', continueHandler);
        } else {
            continueButton.removeClass('hide');
        }

        $('#' + configuration.Id + '-back-button')
            .off('click')
            .on('click',
                function(event) {
                    event.preventDefault();

                    const url = $(this).attr('href');

                    const journeyType = $('#JourneyType').val() - 0;

                    const model = {
                        componentConfiguration: configuration,
                        personId: $('#PersonId').val(),
                        medicalCondition: true,
                        firstName: $('#FirstName').val(),
                        journeyType: journeyType,
                        licence: $('#Licence').val(),
                    };

                    const callbackFunc = bgl.components.medicalcondition.getInitByJourneyType(journeyType);

                    bgl.common.loader.load(model,
                        url,
                        containerId,
                        function() {
                            callbackFunc(configuration, false);
                        });
                });

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(this))) {
                        $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)) === true);

                        bgl.common.validator.submitForm($(this), configuration);
                    }
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function generateClickOnKeypress(event) {
        const SPACE_KEYCODE = 32;
        const ENTER_KEYCODE = 13;
        const code = event.charCode || event.keyCode;

        if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
            $(event.target).prop('checked', true);
            $(event.target).click();
        }
    }

    function continueHandler(event) {
        event.preventDefault();

        if ($(event.target).is(':checked')) {
            $(event.target).trigger('change');
        }

        form.submit();
    }

    function onSuccess(configuration, data) {
        if (data.nextStepUrl) {
            bgl.common.datastore.extendCollectedData(form, {isFormDirty: false});

            bgl.components.additionaldriver.nextStep(configuration, data, form);
        } else {
            if (data.hasChanges === true) {
                bgl.common.pubsub.emit('PollBasket');
            }
            bgl.common.datastore.removeSessionStorage(form);
            $('[data-dismiss="slide-panel"]').click();
        }
    }

    function onError() {
        const initFunc = getInitByJourneyType($('#JourneyType').val() - 0);

        initFunc(configuration);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    function getInitByJourneyType(journeyType) {
        switch (journeyType) {
        case 1:
            return bgl.components.medicalconditiondvlanotified.initJourney;
        default:
            return bgl.components.medicalconditiondvlanotified.init;
        }
    }

    return {
        init: initComponent,
        initJourney: initJourney,
        onSuccess: onSuccess,
        onError: onError,
        getInitByJourneyType: getInitByJourneyType,
    };
})();

bgl.components.contactinformation = (function() {
    let configuration;
    let form;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('[data-component-id="' + configuration.Id + '"] form');

        bgl.common.validator.init(form);
        bgl.common.datastore.init(form);

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(this))) {
                        if (bgl.common.datastore.isDataChanged($(this)) === false) {
                            bgl.common.datastore.removeSessionStorage($(this));
                            $('[data-dismiss="slide-panel"]').click();
                            return;
                        }
                        bgl.common.validator.submitForm($(this), configuration);
                    }
                });
    }

    function onSuccess() {
        bgl.common.datastore.removeSessionStorage(form);
        bgl.common.pubsub.emit('PollBasket', {hideNotification: true});
        $('[data-dismiss="slide-panel"]').click();
    }

    function onError() {
        bgl.components.contactinformation.init(configuration);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

bgl.components.contactinformationpolicy = (function() {
    let configuration;
    let form;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('[data-component-id="' + configuration.Id + '"] form');

        bgl.common.validator.init(form);
        bgl.common.datastore.init(form);

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(this))) {
                        if (bgl.common.datastore.isDataChanged($(this)) === false) {
                            bgl.common.datastore.removeSessionStorage($(this));
                            bgl.common.contentpanel.hideSlidePanel();
                            return;
                        }

                        bgl.common.validator.submitForm($(this), configuration);
                    }
                });
    }

    function onSuccess() {
        bgl.common.datastore.removeSessionStorage(form);
        bgl.common.pubsub.emit('PollBasket');
        window.location.reload(true);
    }

    function onError() {
        bgl.components.contactinformationpolicy.init(configuration);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }


    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

bgl.components.motorconvictions = (function() {
    let configuration;
    let motorConvictionList;
    let form;
    let noButton;
    const HIDE_CLASS = 'hide';
    let journeyType = 0;
    let haveMotorConvictionsBeenChanged = false;
    let hasPreselectedValues;
    const haveMotorConvictionsKey = 'HaveMotorConvictions';

    function ctor(componentConfiguration, hasChanges) {
        configuration = componentConfiguration;
        hasPreselectedValues = true;
        noButton = $('#motor-convictions-radio-no');
        form = $('div[id=' + configuration.Id + '-motor-convictions] form');
        motorConvictionList = $('#motor-convictions-list');
        haveMotorConvictionsBeenChanged = hasChanges !== undefined && hasChanges === true;
    }

    function initComponent(componentConfiguration, hasChanges) {
        ctor(componentConfiguration, hasChanges);
        subscribeForEvents();
    }

    function initJourney(componentConfiguration, hasChanges) {
        journeyType = 1;
        ctor(componentConfiguration, hasChanges);
        bgl.common.datastore.init(form, true, true);
        bgl.components.additionaldriver.initJourneyStep();

        if (getMotorConvictionCount() === 0) {
            hasPreselectedValues = false;
            const additionalDriver = bgl.common.datastore.getData(form);
            if (additionalDriver !== null && additionalDriver[haveMotorConvictionsKey] === 'False') {
                noButton.prop('checked', true);
                hasPreselectedValues = true;
            }
        }

        bgl.common.datastore.setupWrite();
        subscribeForEvents();
    }

    function subscribeForEvents() {
        subscribeToEventShowMotorConvictions();
        subscribeToEventDeleteMotorConviction();
        subscribeToEventRemoveAllMotorConvictions();
        subscribeToEventAddMotorConviction();
        subscribeToEventDismissMotorConvictionPanel();
        subscribeToEventDoneButtonMotorConvictions();
        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function subscribeToEventShowMotorConvictions() {
        const radioButtons = $('input[type=\'radio\']');
        let clickFunction;

        if (hasPreselectedValues === true) {
            $('button[data-remove-all-url]').removeClass(HIDE_CLASS);

            clickFunction = function(key, item) {
                const button = $(item);
                button.off('change').on('change',
                    function(event) {
                        event.preventDefault();
                        const itemCount = getMotorConvictionCount();

                        switch ($(this).val()) {
                        case 'True':
                            if (itemCount === 0) {
                                loadAddMotorConvictions($(event.target).data('url'));
                            } else {
                                $('#motor-convictions-radio-no').attr('data-need-to-delete', 'false');
                                if (motorConvictionList.hasClass(HIDE_CLASS)) {
                                    motorConvictionList.removeClass(HIDE_CLASS);
                                }
                            }
                            break;
                        case 'False':
                            const isNeedToBeDeleted = itemCount !== 0;
                            $('#motor-convictions-radio-no').attr('data-need-to-delete', isNeedToBeDeleted);

                            if (!motorConvictionList.hasClass(HIDE_CLASS)) {
                                motorConvictionList.addClass(HIDE_CLASS);
                            }
                            break;
                        }
                    });
            };
        } else {
            clickFunction = function(key, item) {
                const button = $(item);
                button.on('change',
                    function(event) {
                        event.preventDefault();
                        switch ($(this).val()) {
                        case 'True':
                            if (getMotorConvictionCount() === 0) {
                                loadAddMotorConvictions($(event.target).data('url'));
                            }
                            break;
                        case 'False':
                            if (typeof bgl.common.pubsub !== 'undefined') {
                                bgl.common.pubsub.emit(
                                    'fakeFormSubmit',
                                    form.attr('id') || form.attr('action') || 'unknown',
                                );
                            }
                            redirectToNextJourneyStep();
                            break;
                        }
                    });
            };
        }

        $.each(radioButtons, clickFunction);
    }

    function subscribeToEventAddMotorConviction() {
        $('#motor-convictions-add-another').off('click').on('click',
            function(event) {
                event.preventDefault();
                const url = $(event.target).attr('href');
                loadAddMotorConvictions(url);
            });
    }

    function subscribeToEventDismissMotorConvictionPanel() {
        $(document).off('click.motorconvictions', '[data-dismiss="slide-panel"]').on('click.motorconvictions',
            '[data-dismiss="slide-panel"]',
            function() {
                unSubscribeToEventDismissMotorConvictionPanel();
                dismissSlidePanelHandler(haveMotorConvictionsBeenChanged);
            });

        $(document).off('keyup.motorconvictions').on('keyup.motorconvictions',
            function(event) {
                if (event.key === 'Escape') {
                    unSubscribeToEventDismissMotorConvictionPanel();
                    dismissSlidePanelHandler(haveMotorConvictionsBeenChanged);
                }
            });

        $('.overlay').off('click.motorconvictions').on('click.motorconvictions',
            function() {
                unSubscribeToEventDismissMotorConvictionPanel();
                dismissSlidePanelHandler(haveMotorConvictionsBeenChanged);
            });
    }

    function unSubscribeToEventDismissMotorConvictionPanel() {
        $(document).off('click.motorconvictions', '[data-dismiss="slide-panel"]');
        $(document).off('keyup.motorconvictions');
        $('.overlay').off('click.motorconvictions');
    }

    function dismissSlidePanelHandler(flag) {
        if (flag === true) {
            bgl.common.pubsub.emit('PollBasket');
        }
    }

    function subscribeToEventRemoveAllMotorConvictions() {
        const removeAllButton = $('#remove-all-motor-convictions');
        removeAllButton.off('click').on('click',
            function(event) {
                event.preventDefault();
                noButton.click();
            });
    }

    function subscribeToEventDoneButtonMotorConvictions() {
        const doneButton = $('button[data-remove-all-url]');

        doneButton.off('click').on('click',
            function() {
                unSubscribeToEventDismissMotorConvictionPanel();
                const isNeededToDelete = noButton.attr('data-need-to-delete') === 'true';
                const isNoButtonChecked = noButton.is(':checked');
                const patchUrl = $(this).data('remove-all-url');

                if (isNeededToDelete && isNoButtonChecked) {
                    const dataToPost = $.param({
                        __RequestVerificationToken: $('input[name=\'__RequestVerificationToken\']').val(),
                        personId: $('#PersonId').val(),
                        JourneyType: $('#JourneyType').val(),
                        FirstName: $('#FirstName').val(),
                    });

                    $.ajax({
                        url: patchUrl,
                        type: 'POST',
                        data: dataToPost,
                        success: function(data, textStatus, request) {
                            if (request.getResponseHeader('Content-Type') === 'application/json; charset=utf-8') {
                                if (!data.isSuccess && data.errorRedirectUrl !== null) {
                                    bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                                } else if (data.isSuccess) {
                                    if (journeyType === 1) {
                                        redirectToNextJourneyStep();
                                    } else {
                                        bgl.common.pubsub.emit('PollBasket');
                                        $('.overlay').click();
                                    }
                                }
                            }
                        },
                    });
                } else if (haveMotorConvictionsBeenChanged === true && journeyType === journeyTypes.singleEdit) {
                    bgl.common.pubsub.emit('PollBasket');
                    $('.overlay').click();
                } else {
                    if (journeyType === journeyTypes.additionalDriver) {
                        redirectToNextJourneyStep();
                    } else {
                        $('.overlay').click();
                    }
                }
            });
    }

    function redirectToNextJourneyStep() {
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: false});
        bgl.components.additionaldriver.nextStep(configuration,
            {
                personId: $('#PersonId').val(),
                nextStepUrl: form.data('next-step-url'),
            },
            form);
    }

    function subscribeToEventDeleteMotorConviction() {
        const deleteMotorConvictionButtons = $('button[data-role=\'delete\']');

        $.each(deleteMotorConvictionButtons,
            function(key, item) {
                $(item).off('click').on('click',
                    function(event) {
                        event.preventDefault();
                        $(item).attr('disabled', 'disabled');

                        const target = $(event.target);
                        const link = target.is('button') ? target : target.parent();
                        const token = $('input[name=\'__RequestVerificationToken\']').val();
                        const journeyType = $('#JourneyType').val();
                        const patchUrl = link.attr('href');
                        const personId = $('#PersonId').val();

                        const dataToPost = {
                            __RequestVerificationToken: token,
                            motorConvictionId: link.data('conviction-id'),
                            journeyType: journeyType,
                        };

                        const model = {
                            componentConfiguration: configuration,
                            personId: personId,
                            JourneyType: $('#JourneyType').val(),
                            FirstName: $('#FirstName').val(),
                        };

                        const panelId = configuration.Id + '-motor-convictions';

                        $.ajax({
                            url: patchUrl,
                            type: 'POST',
                            data: dataToPost,
                            success: function(data, textStatus, request) {
                                if (request.getResponseHeader('Content-Type') === 'application/json; charset=utf-8') {
                                    if (!data.isSuccess) {
                                        bgl.common.utilities.errorRedirect(data.errorRedirectUrl);
                                    } else {
                                        bgl.common.loader.load(model,
                                            data.redirectUrl,
                                            panelId,
                                            function() {
                                                if (($('#JourneyType').val() * 1) === 1) {
                                                    if (getMotorConvictionCount() === 0) {
                                                        const additionalDriver = JSON.parse(
                                                            sessionStorage.getItem('AdditionalDriver'),
                                                        );
                                                        additionalDriver[haveMotorConvictionsKey] = 'False';
                                                        sessionStorage.setItem(
                                                            'AdditionalDriver',
                                                            JSON.stringify(additionalDriver),
                                                        );
                                                    }

                                                    bgl.components.motorconvictions.initJourney(configuration, true);
                                                } else {
                                                    bgl.components.motorconvictions.init(configuration, true);
                                                }
                                            });
                                    }
                                }
                            },
                        });
                    });
            });
    }

    function loadAddMotorConvictions(url) {
        const model = {
            ComponentConfiguration: configuration,
            PersonId: $('#PersonId').val(),
            JourneyType: $('#JourneyType').val(),
            FirstName: $('#FirstName').val(),
        };

        const panelId = configuration.Id + '-motor-convictions';
        bgl.common.loader.load(model,
            url,
            panelId,
            function() {
                bgl.components.motorconvictionsbuilder.init(configuration);
            });
    }

    function getMotorConvictionCount() {
        return $('#motor-convictions-list .step-form__summary-item').length;
    }

    return {
        init: initComponent,
        initJourney: initJourney,
    };
})();

bgl.components.motorconvictionsbuilder = (function() {
    let form;
    let configuration;
    const HIDE_CLASS = 'hide';

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#add-motor-conviction');

        if (form) {
            bgl.common.validator.init(form);
            bgl.common.validator.initNumberInputField($('#Months-Ban'), 2);
            bgl.common.validator.initNumberInputField($('#Fine-Amount'), 5);
        }

        subscribeForEvents();
    }

    function subscribeForEvents() {
        $('.step-form__button, .form-row__breadcrumb-link').off('click').on('click',
            function(event) {
                stepClick(event, false);
            });

        $('[data-step-type="previous-step"]').off('click').on('click',
            function(event) {
                stepClick(event, true);
            });

        function stepClick(event, isBackButtonClicked) {
            event.preventDefault();
            const link = $(event.currentTarget);
            selectNextStep(link, isBackButtonClicked);
        }

        const banLengthRow = $('#ban-length-row');

        $('#conviction-has-ban-no').on('click',
            function() {
                if (!banLengthRow.hasClass(HIDE_CLASS)) {
                    banLengthRow.addClass(HIDE_CLASS);
                }
                $('#Months-Ban').val('');
            });

        $('#conviction-has-ban-yes').on('click',
            function() {
                if (banLengthRow.hasClass(HIDE_CLASS)) {
                    banLengthRow.removeClass(HIDE_CLASS);
                }
            });

        if (form) {
            form.off('submit').on('submit',
                function(event) {
                    event.preventDefault();
                    event.stopPropagation();

                    const submit = $(this).find(':submit');
                    submit.attr('disabled', 'disabled');

                    if (bgl.common.validator.validate(configuration, form) === false) {
                        submit.removeAttr('disabled');
                    }
                });
        }
    }

    function selectNextStep(link, isBack) {
        const nextStep = link.data('next-step');
        const currentStep = $('#motor-conviction-tiles').data('current-step');
        const journeyType = $('#JourneyType').val() * 1;

        let currentValue = {
            Code: link.data('code'),
            Value: $.trim(link.text()),
            BuilderStep: currentStep,
        };

        const model = {
            ComponentConfiguration: configuration,
            PersonId: $('#PersonId').val(),
            JourneyType: journeyType,
            FirstName: $('#FirstName').val(),
            CurrentStep: nextStep,
        };

        if (isBack) {
            currentValue = undefined;
            model.IsBackButtonClicked = true;
        }

        model.SelectedValues = getSelectedValues(currentValue);

        const url = link.attr('href');
        const panelId = configuration.Id + '-motor-convictions';

        if (link.data('current-step') === 'Type' && isBack === true) {
            bgl.common.loader.load(model,
                link.attr('href'),
                panelId,
                function() {
                    if ($('#JourneyType').val() * 1 === 1) {
                        bgl.components.motorconvictions.initJourney(configuration, true);
                    } else {
                        bgl.components.motorconvictions.init(configuration, true);
                    }
                });
            return;
        }

        if (typeof bgl.common.pubsub !== 'undefined' && !isBack) {
            bgl.common.pubsub.emit('fakeFormSubmit', 'MotorConvictions' + currentStep);
        }

        bgl.common.loader.load(model,
            url,
            panelId,
            function() {
                bgl.components.motorconvictionsbuilder.init(configuration);
            });
    }

    function getSelectedValues(currentValue) {
        const result = [];
        const breadcrumbLinks = $('.form-row__breadcrumb-link') || [];

        $.each(breadcrumbLinks,
            function(idx, element) {
                const value = {
                    Code: $(element).data('code'),
                    Value: $.trim($(element).text()),
                    BuilderStep: $(element).data('next-step'),
                };

                result.push(value);
            });

        if (currentValue !== undefined) {
            result.push(currentValue);
        }

        return result;
    }

    function onSuccess(configuration, data) {
        const panelId = configuration.Id + '-motor-convictions';
        const journeyType = $('#JourneyType').val() * 1;

        if (data.lastStep === true) {
            const model = {
                ComponentConfiguration: configuration,
                PersonId: $('#PersonId').val(),
                JourneyType: journeyType,
                FirstName: $('#FirstName').val(),
            };

            bgl.common.loader.load(model,
                data.redirectUrl,
                panelId,
                function() {
                    if (journeyType === 1) {
                        bgl.components.motorconvictions.initJourney(configuration, true);
                    } else {
                        bgl.components.motorconvictions.init(configuration, true);
                    }
                });
        } else {
            const newModel = JSON.parse(data.content);

            configuration = newModel.ComponentConfiguration;

            bgl.common.loader.load(newModel,
                data.redirectUrl,
                panelId,
                function() {
                    bgl.components.motorconvictionsbuilder.init(configuration);
                });
        }
    }

    function onError() {
        bgl.components.motorconvictionsbuilder.init(configuration);
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

bgl.components.useofothervehicles = (function() {
    let form;
    let configuration;
    let submitButton;

    function ctor(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#' + configuration.Id + '__other-vehicles-form');
        submitButton = $(form.find('[type=\'submit\']'));

        bgl.common.validator.init(form);
    }

    function initComponent(componentConfiguration) {
        const isOtherVehiclesNcd = componentConfiguration.IsOtherVehiclesNcd;

        ctor(componentConfiguration);

        bgl.common.datastore.init(form);
        bgl.common.datastore.setupWrite();

        subscribeToEvents();

        if (isOtherVehiclesNcd) {
            initElements();
            subscribeToEventsForNcd();
        }
    }

    function initJourney(componentConfiguration) {
        ctor(componentConfiguration);

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        subscribeToEvents();
        bgl.components.additionaldriver.initJourneyStep();
    }

    function initElements() {
        form.find('#use-of-other-vehicles-radio-yes, #Other-Vehicle-Yes').each(function(index, element) {
            const sections = $(element).data('sections');

            if ($(element).prop('checked')) {
                $(sections).removeClass('hide');
            }
        });
    }

    function subscribeToEvents() {
        if (submitButton.hasClass('hide') !== false) {
            if (form.find('input[type=radio]:checked').length === 0) {
                form.find('input[type=radio]')
                    .off('keypress', generateClickOnKeypress)
                    .on('keypress', generateClickOnKeypress)
                    .off('click', continueHandler)
                    .on('click', continueHandler);
            } else {
                submitButton.removeClass('hide');
            }
        }

        subscribeForSubmit();
    }

    function subscribeToEventsForNcd() {
        form.find('#use-of-other-vehicles-radio-yes, #Other-Vehicle-Yes').on('click',
            function(e) {
                const sections = $(this).data('sections');

                $(sections).removeClass('hide');
            });

        form.find('#use-of-other-vehicles-radio-no, #Other-Vehicle-No').on('click',
            function(e) {
                const sections = $(this).data('sections');

                $(sections).addClass('hide');

                deleteFields(sections);
            });
    }

    function deleteFields(sections) {
        const elements = $(sections).removeClass('error').find('[data-store]');
        let dropdownKey;

        const fieldsToDelete = $.map(elements,
            function(element) {
                const elementName = $(element).attr('name');

                if ($(element).is('select')) {
                    $(element).val('');
                    dropdownKey = elementName;
                } else if ($(element).is('input')) {
                    $(element).prop('checked', false);
                }

                return elementName;
            });

        if (dropdownKey) {
            fieldsToDelete.push(dropdownKey + 'Text', dropdownKey + 'Val');
        }

        bgl.common.datastore.deleteFields(form, fieldsToDelete);
    }


    function subscribeForSubmit() {
        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid(form)) {
                        const journeyType = $('#JourneyType').val() - 0;

                        if (!bgl.common.datastore.isDataChanged(form) &&
                            journeyType !== journeyTypes.additionalDriver) {
                            bgl.common.datastore.removeSessionStorage(form);
                            $('[data-dismiss="slide-panel"]').click();
                        } else {
                            bgl.common.validator.submitForm(form, configuration);
                        }
                    }
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function generateClickOnKeypress(event) {
        const SPACE_KEYCODE = 32;
        const ENTER_KEYCODE = 13;
        const code = event.charCode || event.keyCode;

        if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
            $(event.target).prop('checked', true);
            $(event.target).click();
        }
    }

    function continueHandler(event) {
        event.preventDefault();

        if ($(event.target).is(':checked')) {
            $(event.target).trigger('change');
        }

        form.submit();
    }


    function onSuccess(configuration, data) {
        if (data.nextStepUrl) {
            bgl.common.datastore.extendCollectedData(form, {isFormDirty: false});

            bgl.components.additionaldriver.nextStep(configuration, data, form);
        } else {
            bgl.common.datastore.removeSessionStorage(form);
            bgl.common.pubsub.emit('PollBasket');
            $('[data-dismiss="slide-panel"]').click();
        }
    }

    function onError() {
        const journeyType = $('#JourneyType').val() - 0;

        switch (journeyType) {
        case (journeyTypes.additionalDriver):
            bgl.components.useofothervehicles.initJourney(configuration);
            break;
        default:
            bgl.components.useofothervehicles.init(configuration);
            break;
        }

        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
        initJourney: initJourney,
    };
})();

bgl.components.maritalstatus = (function() {
    let form;
    let configuration;
    let containerId;

    function initComponent(componentConfiguration, containerElementId) {
        containerId = containerElementId;
        initObject(componentConfiguration);

        bgl.common.datastore.init(form, false, true);

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(this))) {
                        $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)) === true);

                        if (configuration.IsService) {
                            const mtaSuffix = window.location.href.toLowerCase().includes('makechanges') ?
                                'start' :
                                'additional change';

                            bgl.common.telemetry.logEvent(`MTA ${mtaSuffix}`,
                                {
                                    mta_type: 'Driver details Relationship status, Surname, Title',
                                    component: configuration.Id,
                                });
                        }

                        bgl.common.validator.submitForm($(this), configuration);
                    }
                });
    }

    function initJourney(componentConfiguration) {
        initObject(componentConfiguration);

        bgl.components.additionaldriver.initJourneyStep();

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        if (form.find('input[type=radio]:checked').length === 0) {
            form.find('input[type=radio]')
                .off('keypress', generateClickOnKeypress)
                .on('keypress', generateClickOnKeypress)
                .off('click', postPerson)
                .on('click', postPerson);
        } else {
            const continueButton = $(form.find('[type=\'submit\']'));
            continueButton.removeClass('hide');
            continueButton.off('click').on('click', postPerson);
        }
    }

    function initSurnameStep(componentConfiguration) {
        initObject(componentConfiguration);

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();
    }

    function initObject(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('[data-component-id=\'' + configuration.Id + '\'] form');

        bgl.common.validator.init(form);

        $('.back-button-link').one('click', function(event) {
            event.preventDefault();

            const backUrl = $(this).attr('href');

            $(this).hide();

            const elementsArray = form.serializeArray();

            const model = {
                componentConfiguration: configuration,
            };

            $.map(elementsArray, function(item, i) {
                model[item['name']] = item['value'];
            });

            bgl.common.loader.load(model, backUrl, containerId,
                function() {
                    initComponent(configuration, containerId);
                });
        });

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(this))) {
                        $('#HasChanges').val(bgl.common.datastore.isDataChanged($(this)) === true);

                        bgl.common.validator.submitForm($(this), configuration);
                    }
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function postPerson(event) {
        event.preventDefault();

        if ($(event.target).is(':checked')) {
            $(event.target).trigger('change');
        }

        form.find('input[type=radio]').off();
        form.submit();
    }

    function generateClickOnKeypress(event) {
        const SPACE_KEYCODE = 32;
        const ENTER_KEYCODE = 13;
        const code = event.charCode || event.keyCode;

        if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
            $(this).click();
        }
    }

    function onSuccess(configuration, data) {
        if (data.journeyType === 'AdditionalDriver' || data.journeyType === 'MultiStepEdit') {
            if (data.nextStep) {
                bgl.common.datastore.extendCollectedData(form, {isFormDirty: false});
                bgl.components.additionaldriver.nextStep(configuration, data, form);
            } else {
                bgl.components.additionaldriver.createPerson(configuration, data.nextStepUrl, form);
            }
        } else {
            bgl.common.loader.load(data.content, data.nextStepUrl, containerId,
                function() {
                    bgl.components.maritalstatus.initNextStep(configuration, containerId);
                });
        }
    }

    function onSurnameSuccess(configuration, data) {
        bgl.common.datastore.removeSessionStorage(form);

        if (configuration.IsService) {
            if (data.hasChanges === true) {
                const params = {
                    callback: function() {
                        bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
                    },
                };
                bgl.common.pubsub.emit('PollBasket', params);
            } else {
                bgl.common.contentpanel.hideSlidePanel();
            }
        } else {
            if (data.hasChanges === true) {
                bgl.common.pubsub.emit('PollBasket');
            }

            $('[data-dismiss="slide-panel"]').click();
        }
    }

    function onError() {
        const journeyType = $('#JourneyType').val() - 0;

        switch (journeyType) {
        case 1:
            bgl.components.maritalstatus.initJourney(configuration);
            break;
        default:
            bgl.components.maritalstatus.init(configuration);
            break;
        }
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    function onSurnameError() {
        bgl.components.maritalstatus.initNextStep(configuration);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        initJourney: initJourney,
        initNextStep: initSurnameStep,
        init: initComponent,
        onSuccess: onSuccess,
        onSurnameSuccess: onSurnameSuccess,
        onError: onError,
        onSurnameError: onSurnameError,
    };
})();

bgl.components.relationshipstatus = (function() {
    let configuration;
    let form;

    function initJourney(componentConfiguration) {
        configuration = componentConfiguration;

        form = $('#relationship-status-form');

        bgl.common.validator.init(form);

        bgl.components.additionaldriver.initJourneyStep();

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        if (form.find('input[type=radio]:checked').length === 0) {
            form.find('input[type=radio]')
                .off('keypress', generateClickOnKeypress)
                .on('keypress', generateClickOnKeypress)
                .off('click', submitRelationshipStatusForm)
                .on('click', submitRelationshipStatusForm);
        } else {
            const continueButton = $(form.find('[type=\'submit\']'));
            continueButton.removeClass('hide');
            continueButton.off('click').on('click', submitRelationshipStatusForm);
        }

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid($(this))) {
                        bgl.common.validator.submitForm(form, configuration);
                    }
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function generateClickOnKeypress(event) {
        const SPACE_KEYCODE = 32;
        const ENTER_KEYCODE = 13;
        const code = event.charCode || event.keyCode;

        if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
            $(this).click();
        }
    }

    function submitRelationshipStatusForm(event) {
        event.preventDefault();

        if ($(event.target).is(':checked')) {
            $(event.target).trigger('change');
        }

        form.find('input[type=radio]').off();
        form.submit();
    }

    function onSuccess(configuration, data) {
        if (data.nextStepUrl) {
            bgl.components.additionaldriver.nextStep(configuration, data, form);
        }
    }

    function onError(configuration) {
        bgl.components.relationshipstatus.initJourney(configuration);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        initJourney: initJourney,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

bgl.components.additionaldriver = (function() {
    let configuration;
    const containerId = 'SlidePanelContent';

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;

        sessionStorage.removeItem('AdditionalDriver');

        subscribeToEventDismissPanel();

        bgl.components.relationshipstatus.initJourney(configuration);
    }

    function initJourneyStep() {
        const backButton = $('a[data-step-type="previous-step-journey"]');

        if (backButton.length !== 0) {
            backButton.off('click').one('click', function(event) {
                event.preventDefault();

                $(backButton).hide();

                let form = $(this).closest('form');

                if (!form.length) {
                    form = $('#' + containerId).find('form');
                }

                const componentName = $(this).data('component');

                let data = getDataToPost(form);

                if (componentName === 'relationshipstatus' || componentName === 'motorclaims') {
                    const drivers = {
                        Drivers: JSON.parse(sessionStorage.getItem('drivers')),
                        GetPersons: false,
                    };

                    data = $.extend(data, drivers);
                }

                const element = bgl.components[componentName];

                const callback = element.initJourney;

                bgl.common.loader.load(data,
                    $(this).attr('href'),
                    containerId,
                    function() {
                        callback(configuration, containerId);
                        initJourneyStep();
                    });
            });
        }
    }

    function getDataToPost(form) {
        let model = {
            ComponentConfiguration: configuration,
            JourneyType: journeyTypes.additionalDriver,
            PersonId: $('#PersonId').val(),
            FirstName: $('#FirstName').val(),
        };

        let key = 'AdditionalDriver';

        if (form && form.length) {
            key = form.data('store-key');
        }

        const collectedData = JSON.parse(sessionStorage.getItem(key));

        model = $.extend(model, collectedData);

        return model;
    }

    function expandSessionStorageWithPersonDriver(personId) {
        const driversData = JSON.parse(sessionStorage.getItem('AdditionalDriver'));
        const drivers = JSON.parse(sessionStorage.getItem('drivers'));

        const initials = driversData.FirstName + ' ' + driversData.LastName;
        const person = {Code: personId, Value: convertNameToTitleCase(initials), IsMainDriver: false};
        const smb = {Code: '', Value: 'Someone else driving', IsMainDriver: false};

        const newdrivers = drivers.filter(function(value) {
            return value.Code !== personId && value.Code !== '';
        });

        newdrivers.push(person);
        newdrivers.push(smb);

        sessionStorage.setItem('drivers', JSON.stringify(newdrivers));
    }

    function convertNameToTitleCase(inputStr) {
        if (inputStr) {
            inputStr = inputStr.trim().toLowerCase().split(' ');
            for (let i = 0; i < inputStr.length; i++) {
                inputStr[i] = inputStr[i].charAt(0).toUpperCase() + inputStr[i].slice(1);
            }
            return inputStr.join(' ');
        }

        return '';
    }

    function nextStep(configuration, data, form) {
        if (data.personId) {
            const dataToExtend = {PersonId: data.personId, isFormDirty: false};
            expandSessionStorageWithPersonDriver(data.personId);

            let formData = JSON.parse(sessionStorage.getItem('AdditionalDriver'));
            formData = $.extend(formData, dataToExtend);
            sessionStorage.setItem('AdditionalDriver', JSON.stringify(formData));
        }

        if (data.nextStepUrl && form) {
            const componentName = form.data('next-journey-component');

            let storedDate = getDataToPost(form);

            if (componentName === 'motorclaims') {
                const drivers = {
                    Drivers: JSON.parse(sessionStorage.getItem('drivers')),
                    GetPersons: false,
                };

                storedDate = $.extend(storedDate, drivers);
            }

            const element = bgl.components[componentName];

            const callback = element.initJourney;

            bgl.common.loader.load(storedDate,
                data.nextStepUrl,
                containerId,
                function() {
                    callback(configuration, containerId);
                });
        } else {
            $('[data-dismiss="slide-panel"]').click();
        }
    }

    function createPerson(configuration, nextUrl, form) {
        const dataToPost = getDataToPost();
        executeCreatingAction(configuration, nextUrl, form, dataToPost);
    }

    function createDriver(configuration, nextUrl, form) {
        const dataToPost = getDataToPost();
        const driverData = {
            ComponentConfiguration: dataToPost.ComponentConfiguration,
            PersonId: dataToPost.PersonId,
            CoverId: $('#CoverId').val(),
        };

        unSubscribeToEventDismissPanel();

        executeCreatingAction(configuration, nextUrl, form, driverData);
    }

    function executeCreatingAction(configuration, nextUrl, form, dataToPost) {
        dataToPost.__RequestVerificationToken = $('input[name="__RequestVerificationToken"]').val();

        form.attr('action', nextUrl);

        bgl.common.validator.submitForm(form, configuration, dataToPost);
    }

    function subscribeToEventDismissPanel() {
        $(document).off('click.additionaldriver', '[data-dismiss="slide-panel"]')
            .on('click.additionaldriver', '[data-dismiss="slide-panel"]', function() {
                unSubscribeToEventDismissPanel();
                dismissSlidePanelHandler();
            });

        $(document).off('keyup.additionaldriver').on('keyup.additionaldriver', function(event) {
            if (event.key === 'Escape') {
                unSubscribeToEventDismissPanel();
                dismissSlidePanelHandler();
            }
        });

        $('.overlay').off('click.additionaldriver').on('click.additionaldriver', function() {
            unSubscribeToEventDismissPanel();
            dismissSlidePanelHandler();
        });
    }

    function unSubscribeToEventDismissPanel() {
        $(document).off('click.additionaldriver', '[data-dismiss="slide-panel"]');
        $(document).off('keyup.additionaldriver');
        $('.overlay').off('click.additionaldriver');
    }

    function dismissSlidePanelHandler() {
        switch (configuration.JourneyType) {
        case journeyTypes.additionalDriver:
            break;

        case journeyTypes.multiStepEdit:
            bgl.common.utilities.refreshPage();
            break;
        }
    }

    function isAdditionalDriverJourney() {
        return $('#JourneyType').val() - 0 === journeyTypes.additionalDriver;
    }

    return {
        init: initComponent,
        initJourneyStep: initJourneyStep,
        nextStep: nextStep,
        createPerson: createPerson,
        createDriver: createDriver,
        isAdditionalDriverJourney: isAdditionalDriverJourney,
    };
})();

bgl.components.drivertabs = (function() {
    /* SELECTED ELEMENTS (CACHED)*/
    let leftArrow; let rightArrow; let tabScrollVisibleArea; let tabList; let tabContent;

    function init() {
        leftArrow = $('.named-driver-pagination__left');
        rightArrow = $('.named-driver-pagination__right');
        tabScrollVisibleArea = $('.named-driver-scroller__scroll-area');
        tabList = $('.named-driver-tab');
        tabContent = document.querySelectorAll('[data-named-driver-info]');

        /* ATTACH EVENT LISTENERS*/

        tabScrollVisibleArea.off('scroll').on('scroll',
            function() {
                bgl.components.drivertabs.showArrow();
            });

        rightArrow.off('click').on('click',
            function() {
                handleRightArrowClick();
                bgl.components.drivertabs.showArrow();
            });

        leftArrow.off('click').on('click',
            function() {
                handleLeftArrowClick();
                bgl.components.drivertabs.showArrow();
            });

        $(window).off('resize').on('resize',
            function() {
                bgl.components.drivertabs.showArrow();
            });

        tabList.each(function(index, tab) {
            $(tab).off('click').on('click',
                function() {
                    handleTabClick($(this));
                    bgl.components.drivertabs.showArrow();
                });
        });

        bgl.components.drivertabs.showArrow();
    }

    const settings = {
        ANIMIATE_DURATION: 300,
    };

    function deactivateTab() {
        const currentlyActiveTab = $('.named-driver-tab--active');
        $(currentlyActiveTab).removeClass('named-driver-tab--active');
        $(currentlyActiveTab).attr('aria-selected', 'false');
    }

    function activateTab(clickedTab) {
        deactivateTab();

        clickedTab.addClass('named-driver-tab--active');
        clickedTab.attr('aria-selected', 'true');
        clickedTab.focus();

        const contentIndex = $(tabList).index(clickedTab);

        tabContent.forEach((item) => {
            item.classList.add('hide');
        });

        tabContent[contentIndex].classList.remove('hide');
    }

    function getLeftmostTabIndex() {
        const hiddenAreaLeft = $(tabScrollVisibleArea)[0].scrollLeft;
        let widthAccumulator = 0;
        let closestToLeftIndex = 0;
        $(tabList).each(function(index) {
            if (widthAccumulator > hiddenAreaLeft) {
                /* return false (break) to exit .each()*/
                return false;
            }
            widthAccumulator += $(this)[0].offsetWidth;
            closestToLeftIndex = index;
        });

        return closestToLeftIndex;
    }

    function getRightmostTabIndex() {
        const totalScrollArea = $(tabScrollVisibleArea)[0].offsetWidth;
        const hiddenAreaLeft = $(tabScrollVisibleArea)[0].scrollLeft;
        const rootRight = totalScrollArea + hiddenAreaLeft;
        let widthAccumulator = 0;
        let closestToRightIndex = 0;
        $(tabList).each(function(index) {
            if (widthAccumulator > rootRight) {
                /* return false (break) to exit .each()*/
                return false;
            }
            widthAccumulator += $(this)[0].offsetWidth;
            closestToRightIndex = index;
        });
        return closestToRightIndex;
    }

    function getRightmostTabScrollPosition(tabIndex) {
        let accumulator = 0;
        $(tabList).each(function(index) {
            if (index > tabIndex) {
                /* return false (break) to exit .each()*/
                return false;
            }
            accumulator += $(this)[0].offsetWidth;
        });
        return accumulator;
    }

    function handleTabClick(clickedTab) {
        const previousActiveTabIndex = $(tabList).index($('.named-driver-tab--active'));
        const clickedTabIndex = $(tabList).index(clickedTab);
        const tabScrollerVisibleAreaWidth = $(tabScrollVisibleArea)[0].offsetWidth;
        const leftmostTabIndex = getLeftmostTabIndex();
        const rightmostTabIndex = getRightmostTabIndex();

        // If the tab is NOT already active
        if (previousActiveTabIndex !== clickedTabIndex) {
            activateTab(clickedTab);
        }

        // If the tab is already within the visible scroll area, nothing else to do so, exit
        if (clickedTabIndex > getLeftmostTabIndex && clickedTabIndex < getRightmostTabIndex) {
            return; // Early exit - no scroll required
        }

        let newScrollPosition;
        // If clicked tab is in the leftmost position, bring entire tab into view?
        if (clickedTabIndex === leftmostTabIndex) {
            newScrollPosition = $(tabList)[clickedTabIndex].offsetLeft;
            $(tabScrollVisibleArea).animate({scrollLeft: newScrollPosition}, settings.ANIMIATE_DURATION);
            return;
        }

        // If clicked tab is in the rightmost position, bring entire tab into view?
        if (clickedTabIndex === rightmostTabIndex) {
            newScrollPosition = getRightmostTabScrollPosition(rightmostTabIndex) - tabScrollerVisibleAreaWidth;
            $(tabScrollVisibleArea).animate({scrollLeft: newScrollPosition}, settings.ANIMIATE_DURATION);
            return;
        }
    }

    function handleLeftArrowClick() {
        const newIndex = getLeftmostTabIndex();
        const tabScrollerVisibleAreaWidth = $(tabScrollVisibleArea)[0].offsetWidth;
        const newPosition = getRightmostTabScrollPosition(newIndex) - tabScrollerVisibleAreaWidth;
        $(tabScrollVisibleArea).animate({scrollLeft: newPosition}, settings.ANIMIATE_DURATION, function() {
            /* offset may not change when name is too long*/
            if (newIndex === getLeftmostTabIndex()) {
                const position = getRightmostTabScrollPosition(newIndex - 1) - tabScrollerVisibleAreaWidth;
                $(tabScrollVisibleArea).animate({scrollLeft: position}, settings.ANIMIATE_DURATION);
            }
        });
    }

    function handleRightArrowClick() {
        const newIndex = getRightmostTabIndex();
        const tabScrollerVisibleAreaWidth = $(tabScrollVisibleArea)[0].offsetWidth;
        const newPosition = getRightmostTabScrollPosition(newIndex) - tabScrollerVisibleAreaWidth;
        $(tabScrollVisibleArea).animate({scrollLeft: newPosition}, settings.ANIMIATE_DURATION, function() {
            /* offset may not change when name is too long*/
            if (newIndex === 0 || newIndex === getRightmostTabIndex()) {
                const position = getRightmostTabScrollPosition(newIndex + 1) - tabScrollerVisibleAreaWidth;
                $(tabScrollVisibleArea).animate({scrollLeft: position}, settings.ANIMIATE_DURATION);
            }
        });
    }

    function showArrow() {
        const tabScrollerVisibleAreaScrollPosition = $('.named-driver-scroller__scroll-area:eq(0)').scrollLeft();
        const tabScrollerVisibleAreaWidth = $('.named-driver-scroller__scroll-area:eq(0)').width();
        const tabScrollerContentWidth = $('.named-driver-scroller__scroll-content:eq(0)').width();

        if (tabScrollerVisibleAreaScrollPosition > 0) {
            $(leftArrow).removeClass('hide');
        } else {
            $(leftArrow).addClass('hide');
        }

        if (tabScrollerVisibleAreaWidth < tabScrollerContentWidth - tabScrollerVisibleAreaScrollPosition) {
            $(rightArrow).removeClass('hide');
        } else {
            $(rightArrow).addClass('hide');
        }
    }

    function setActiveDriver(driverIndex) {
        $('.named-driver-tab[data-index=' + driverIndex + ']').click();
    }

    function getActiveDriver(thisObj) {
        return thisObj.data('index');
    }

    return {
        init: init,
        handleTabClick: handleTabClick,
        showArrow: showArrow,
        setActiveDriver: setActiveDriver,
        getActiveDriver: getActiveDriver,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.driverdetails.common;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.annualmileage = (function() {
    let form;
    let configuration;
    const backUrlStackKey = 'backUrlStack';
    let containerId;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        configuration = componentConfiguration;
        containerId = containerElementId;

        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
            });
    }

    function initComponent(componentConfiguration, containerElementId ) {
        configuration = componentConfiguration;
        containerId = containerElementId;

        form = $('#' + configuration.Id + '__annual-mileage-form');
        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();
        bgl.common.validator.enableMaxLength();
        bgl.common.validator.init(form);
        bgl.common.datastore.extendCollectedData(
            form,
            {AnnualMileage: $(`#${configuration.Id}__annual-mileage`).val()},
        );

        subscribeToEvents(configuration);
        initBackButtonLink();
    }

    function subscribeToEvents(configuration) {
        const numberBox = $('#' + configuration.Id + '__annual-mileage');

        calculateAverageMiles(numberBox.val());

        numberBox.off('keydown').on('keydown',
            function(e) {
                // 46 - DELETE
                // 8 - BACKSPACE
                // 9 - TAB
                // 27 - ESCAPE
                // 13 - ENTER
                if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
                    (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                    (e.keyCode >= 35 && e.keyCode <= 40)) {
                    return;
                }
                // Check to see if the shift key, or any other alpha character has been hit.
                if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105) ||
                    $(this).val().length === 5 ||
                    (e.keyCode === 96 && $(this).val().length === 0)) {
                    e.preventDefault();
                }
            });

        numberBox.on('keyup',
            function() {
                let val = $(this).val();
                while (val.substring(0, 1) === '0') {
                    val = val.substring(1);
                }
                $(this).val(val);
            });

        numberBox.off('input').on('input',
            function(e) {
                e.preventDefault();

                const value = $(e.target).val();

                calculateAverageMiles(value);
            });

        form.off('submit').on('submit',
            function(event) {
                event.preventDefault();
                if (bgl.common.validator.isFormValid($(this))) {
                    $('#HasChanges').val(bgl.common.datastore.isDataChanged($(event.target)) === true);
                    bgl.common.validator.submitForm($(this), configuration);
                }
            });
    }

    function initBackButtonLink() {
        $('.back-button-link')
            .off('click')
            .on('click',
                function(e) {
                    e.preventDefault();
                    $(this).hide();
                    const url = getBackButtonUrl();
                    loadView(url);
                });
    }

    function getBackButtonUrl() {
        const stack = JSON.parse(sessionStorage.getItem(backUrlStackKey));
        const url = stack.pop();

        sessionStorage.setItem(backUrlStackKey, JSON.stringify(stack));

        return url;
    }

    function loadView(url) {
        bgl.common.loader.load(configuration,
            url,
            containerId,
            function() {
                bgl.components.driverdetails.overnightparking.init(configuration, containerId);
            });
    }

    function calculateAverageMiles(value) {
        const label = $('#' + configuration.Id + '__annual-mileage-label');
        const labelTemplateValue = $('#labelTemplate').text();

        if (value !== undefined && value !== '') {
            const averageMiles = Math.round(value / 52, 0);

            if (averageMiles === 0) {
                label.hide();
            } else {
                label.show();
                const text = $.parseHTML(labelTemplateValue.replace('{mileage}', averageMiles));
                label.html(text);
            }
        }
    }

    function onSuccess(configuration, responseData) {
        bgl.common.datastore.extendCollectedData(
            form,
            {isFormDirty: responseData.hasChanges, HasChanges: responseData.hasChanges},
        );
        bgl.components.editaddress.postAddressChange(configuration, responseData.redirectUrl, getData(form));
    }

    function getData(form) {
        const token = form.find('input[name="__RequestVerificationToken"]').val();
        const data = bgl.common.datastore.getData(form) || {};

        data.Address = bgl.common.datastore.getData('Address');
        data.AnnualMileage = bgl.common.datastore.getData('AnnualMileage');
        data.VehicleOvernightParking = bgl.common.datastore.getData('OvernightParking');
        data.__RequestVerificationToken = token;
        data.ComponentConfiguration = configuration;

        return data;
    }

    function error(data) {
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
        onError: error,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.adddriver = (function() {
    function initComponent(componentConfiguration) {
        $('[data-add-driver-button]')
            .on('click', function() {
                const requestBodyData = {
                    ComponentConfiguration: componentConfiguration,
                    JourneyType: 1,
                };

                const actionUrl = $(this).data('action-url');

                bgl.common.loader.load(requestBodyData,
                    actionUrl,
                    'SlidePanelContent',
                    function() {
                        bgl.components.additionaldriver.init(componentConfiguration);
                    });
            });
    }

    return {
        init: initComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.driverdetails = bgl.components.driverdetails || {};

bgl.components.driverdetails.aboutyou = (function() {
    let form;
    let configuration;
    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(componentConfiguration, componentUrl, containerElementId, function() {
            initComponent(componentConfiguration);
        });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#about-you-form');
        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();
        bgl.common.validator.enableMaxLength();
        bgl.common.validator.init(form);
        bgl.common.date.initDateFormat($('#DateOfBirth'));
        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();
                    if (bgl.common.validator.isFormValid(form)) {
                        bgl.common.validator.submitForm(form, configuration);
                    }
                });
    }

    function onSuccess(configuration, data) {
        location.href = configuration.NextStepUrl;
    }

    function onError() {
        bgl.components.driverdetails.aboutyou.init(configuration);
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.demandsandneeds = bgl.components.demandsandneeds || {};

bgl.components.demandsandneeds.validation = (function($) {
    function validateAddons() {
        let addonsAreValid = true;
        [...document.querySelectorAll('form[data-addon-name]')].forEach((addonForm) => {
            const addonAnswered = addonForm.querySelectorAll(
                'input[data-type="addon-yes"]:checked, input[data-type="addon-no"]:checked',
            ).length > 0;
            if (!addonAnswered) {
                showErrorStyling(addonForm);
                addonsAreValid = false;
            }
        });

        return addonsAreValid;
    }

    function validateOpenAddon() {
        const openAccordionButton = document.querySelector(
            '[data-type="addon-content"] [data-accordion-button][aria-expanded="true"]');

        if (!openAccordionButton) {
            return true;
        }

        const addonForm = openAccordionButton.closest('form');
        if (!addonForm) {
            return true;
        }

        const addonAnswered = addonForm.querySelectorAll(
            'input[data-type="addon-yes"]:checked, input[data-type="addon-no"]:checked',
        ).length > 0;
        const addonAddedAtAggregator = addonForm.querySelector('[data-addon-preselected-at-agg]');
        const addonId = openAccordionButton.getAttribute('data-addon-id');
        const addonConfirmed = addonForm.dataset.addonConfirmed === 'true' ||
            sessionStorage.getItem(`${addonId}-confirmed`) === 'true';
        if (addonAnswered && (!addonAddedAtAggregator || addonConfirmed)) {
            return true;
        }

        const validationMessageType = addonAnswered ? 'confirm' : 'option';
        showInlineValidationMessage(addonForm, validationMessageType);
        scrollToVisibleValidationMessage(addonForm);
        return false;
    }

    function showInlineValidationMessage(addonForm, messageType) {
        const validationMessages = addonForm.querySelectorAll('[data-addon-validation-message]');
        validationMessages.forEach((validationMessage) => {
            const elementMessageType = validationMessage.dataset?.addonValidationMessage;
            if (!elementMessageType || elementMessageType === messageType) {
                validationMessage.classList.remove('hide');
            } else {
                validationMessage.classList.add('hide');
            }
        });
    }

    function scrollToVisibleValidationMessage(addonForm) {
        const validationMessages = [...addonForm.querySelectorAll('[data-addon-validation-message]')];
        const visibleValidationMessage = validationMessages.find((validationMessage) =>
            bgl.components.demandsandneeds.elements.isVisible(validationMessage));

        if (visibleValidationMessage) {
            visibleValidationMessage.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
    }

    function hideInlineValidationMessage(addonForm) {
        const validationMessages = addonForm.querySelectorAll('[data-addon-validation-message]');
        validationMessages.forEach((validationMessage) => {
            validationMessage.classList.add('hide');
        });
    }

    function areAllAddonsAnswered() {
        const addonForms = [...document.querySelectorAll('form[data-addon-name]')];

        return addonForms.length > 0 && addonForms.every((addonForm) => {
            const addonIsBreakdown = addonForm.id.toLocaleLowerCase() === 'breakdown';
            const isNotSingleTierBreakdown = !addonForm.hasAttribute('data-single-tier-breakdown');
            const addonId = addonIsBreakdown && isNotSingleTierBreakdown ?
                addonForm.id.toLocaleLowerCase() :
                addonForm.id;

            return sessionStorage.getItem(`${addonId}-yes`) !== null ||
                sessionStorage.getItem(`${addonId}-no`) !== null;
        });
    }

    function areAllAddonsSeen() {
        const addonForms = [...document.querySelectorAll('form[data-addon-name]')];

        return addonForms.length > 0 &&
            addonForms.every((addonForm) => sessionStorage.getItem(`${addonForm.id}-seen`) === 'true');
    }

    function showErrorStyling(addonForm) {
        const microCopy = document.getElementById('microCopy');
        const alert = addonForm.querySelector('#error-banner');
        const isSingleTierBreakdown = addonForm.hasAttribute('data-single-tier-breakdown');
        const breakdownCarousel = addonForm.querySelector('[data-uil-carousel]:not([hide])');

        if (!isSingleTierBreakdown && breakdownCarousel) {
            breakdownCarousel.querySelectorAll('[data-tier-select-btn]').forEach((label) => {
                label.classList.add('uil-radio-btn--error');
            });

            if (document.getElementById('breakdown-carousel-no-label')) {
                document.getElementById('breakdown-carousel-no-label').classList.add('uil-radio-btn--error');
            }
        }

        addonForm.classList.add('error');
        if (alert) {
            alert.classList.remove('hide');

            const errorheading = alert.querySelector('#error-heading');
            if (errorheading) {
                errorheading.textContent =
                    `Please select if you would like to add ${addonForm.dataset.addonName} to your policy`;
            }
        }

        if (microCopy) {
            microCopy.classList.add('micro-copy--error');
        }
    }

    function scrollToFirstAddonWithError() {
        const firstAddonWithError = document.querySelector('form.error');
        let addonSelection = firstAddonWithError;
        if (firstAddonWithError.id === 'Breakdown') {
            const carousel = document.querySelector('[data-uil-carousel-wrapper]');
            addonSelection = bgl.components.demandsandneeds.elements.isVisible(carousel) ?
                carousel :
                document.getElementById('breakdown-table');
        }

        const addonWithErrorYesBtn = addonSelection.querySelector('[data-type="addon-yes"]');
        const addonWithErrorYesBtnLabel =
            addonSelection.querySelector(`label[for="${addonWithErrorYesBtn.id}"]`);

        addonWithErrorYesBtnLabel.focus({preventScroll: true});
        addonWithErrorYesBtnLabel.scrollIntoView({behavior: 'smooth', block: 'center'});
    }

    return {
        validateAddons,
        validateOpenAddon,
        areAllAddonsAnswered,
        areAllAddonsSeen,
        hideInlineValidationMessage,
        scrollToFirstAddonWithError,
    };
})($);
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.demandsandneeds = bgl.components.demandsandneeds || {};

bgl.components.demandsandneeds.update = (function($) {
    let errorRedirectUrl;
    let popupTimeout;

    async function updateAddOn(addon, eventTarget, isMultiTierBreakdown, errorRedirect) {
        errorRedirectUrl = errorRedirect;
        const addonForm = eventTarget.closest('form');
        const addonSpinner = addon.querySelector(`[for="${eventTarget.id}"] [data-addon-spinner]`);
        addonSpinner.classList.remove('hide');

        if (typeof bgl.common.pubsub !== 'undefined') {
            bgl.common.pubsub.emit('fakeFormSubmit', addon.id || addonForm.action || 'unknown');
        }

        const select = addon.querySelector('select');
        if (select) {
            select.removeAttribute('disabled');
        }

        const originalFormData = new FormData(addonForm);
        let formData = new FormData();

        if (!isMultiTierBreakdown) {
            for (const [key, value] of originalFormData.entries()) {
                if (key == `${addonForm.id.toLowerCase()}-is-addon-selected`) {
                    formData.append('IsAddonSelected', value);
                } else {
                    formData.append(key, value);
                }
            }
        } else {
            formData = originalFormData;
        }
        formData.delete('radio-Tier');

        const dataToPost = new URLSearchParams(formData).toString();

        if (select) {
            select.setAttribute('disabled', '');
        }

        bgl.common.fetch.formPost(addonForm.action, {
            body: dataToPost,
        }).then(async (response) => {
            const responseBody = await response.json();
            if (!response.ok || !responseBody?.isSuccess) {
                updateAddonApiCallError(responseBody, responseBody, response.statusText, dataToPost);
            } else {
                pollBasket(eventTarget);
            }
        }).catch((error) =>
            updateAddonApiCallError(null, error, error.statusText, dataToPost),
        );
    }

    function updateAddonApiCallError(responseBody, responseError, responseStatusText, dataPosted) {
        bgl.common.telemetry.logEvent(
            'DemandsAndNeeds bgl.components.demandsandneeds.addons updateAddonError called',
            {
                status: responseStatusText,
                errorThrown: responseError,
                dataPosted: dataPosted,
                responseData: responseBody,
            });
        bgl.common.utilities.errorRedirect(errorRedirectUrl);
    }

    function pollBasket(eventTarget) {
        const params = {
            callback: function() {
                bgl.components.demandsandneeds.update.pollBasketCallback(eventTarget);
            },
            noSpinner: true,
        };
        bgl.common.pubsub.emit('PollBasket', params);
    }

    async function pollBasketCallback(eventTarget) {
        setTimeout(function() {
            bgl.components.demandsandneeds.elements.disableElements(false);
        }, 1000);
        const addonTick = document.querySelector(`[for="${eventTarget.id}"] [data-addon-tick]`);
        const addonSpinner = document.querySelector(`[for="${eventTarget.id}"] [data-addon-spinner]`);
        const addonButtonContent = document.querySelector(`[for="${eventTarget.id}"] [data-button-content]`);

        addonSpinner.classList.add('hide');

        if (addonTick) {
            addonTick.classList.remove('hide');
        }

        if (addonButtonContent) {
            addonButtonContent.classList.remove('hide');
        }

        bgl.components.demandsandneeds.accordion.setupAddonAccordionsAfterAnswer(
            eventTarget.closest('form'));
        await displayAddonNotification(eventTarget);
    }

    async function displayAddonNotification(eventTarget) {
        const dataAddonName = eventTarget.closest('form').getAttribute('data-addon-name');
        const dataType = eventTarget.getAttribute('data-type');
        const config = bgl.components.demandsandneeds.configuration ??
            bgl.components.demandsandneeds.common.getConfiguration();
        const addonWasAdded = dataType === 'addon-yes';
        const formData = new FormData();
        formData.append(
            '__RequestVerificationToken',
            document.querySelector('[name="__RequestVerificationToken"]').value);
        formData.append('addonName', dataAddonName);
        formData.append('addonWasAdded', addonWasAdded);

        if (config.StandardVariantCodes) {
            config.StandardVariantCodes.forEach((code) => formData.append('standardVariantCodes[]', code));
        }

        if (config.EnhancedVariantCode) {
            formData.append('enhancedVariantCode', config.EnhancedVariantCode);
        }

        formData.append('shouldDisplayUpsellMessage', config.ShouldDisplayUpsellMessage);
        formData.append('upsellThreshold', config.UpsellThreshold);

        const dataToPost = new URLSearchParams(formData).toString();

        bgl.common.fetch
            .formPost('demandsAndNeedsComponent/getEnhancedNotification', {body: dataToPost})
            .then(async (response) => {
                if (popupTimeout) {
                    clearTimeout(popupTimeout);
                }
                const responseBody = await response.json();
                const upsellModalSeen = sessionStorage.getItem('upsell-modal-seen-extras');

                if (config.BrandEnhancedMessage && responseBody.priceSaving != 0) {
                    if (!upsellModalSeen && responseBody.canDisplayBrandEnhancedMessage) {
                        sessionStorage.setItem('upsell-modal-seen-extras', 'true');
                        document
                            .getElementById(config.BrandEnhancedMessage.PriceSavingId)
                            .innerHTML = responseBody.priceSaving;
                        document
                            .getElementById(config.BrandEnhancedMessage.PriceSavingPeriodId)
                            .innerHTML = responseBody.priceSavingPeriod;
                        const listItems =
                            [...document.querySelectorAll(
                                `li[data-for-variants*="${responseBody.activeVariantCode}"]`)];
                        listItems.forEach((item) => {
                            item.classList.remove('hide');
                        });
                        document
                            .getElementById(config.BrandEnhancedMessage.ContainerId)
                            .classList.remove('hide');
                        document
                            .getElementById(config.BrandEnhancedMessage.NoThanksButtonId)
                            .addEventListener('click', function() {
                                document
                                    .getElementById(config.BrandEnhancedMessage.ContainerId)
                                    .classList.add('hide');
                                displayPopup(responseBody.newPriceMessage, '');
                            });
                    } else {
                        displayPopup(responseBody.newPriceMessage, '');
                    }
                } else {
                    displayPopup(responseBody.newPriceMessage, responseBody.upsellMessage);
                }

                bgl.common.pubsub.emit('UpdateBasket');
            });
    }

    function displayPopup(newPriceMessage, upsellMessage) {
        const messageContainer = document.getElementById('enhanced-message-container');
        document.getElementById('new-price-message').innerHTML = newPriceMessage;
        document.getElementById('upsell-message').innerHTML = upsellMessage;


        if (messageContainer && !upsellMessage) {
            popupTimeout = setTimeout(function() {
                messageContainer.classList.add('hide');
                messageContainer.style.display = 'none';
            }, 10000);
        }
    }

    return {
        updateAddOn,
        pollBasketCallback,
        displayAddonNotification,
        updateAddonApiCallError,
    };
})($);
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.demandsandneeds = bgl.components.demandsandneeds || {};

bgl.components.demandsandneeds.protectednoclaimsdiscount = (function($) {
    function setEventBindings() {
        const pncdAddButton = document.getElementById('NoClaimsDiscountProtection-yes');
        const pncdRemoveButton = document.getElementById('NoClaimsDiscountProtection-no');

        if (pncdAddButton && pncdRemoveButton) {
            pncdAddButton.addEventListener('click', () => {
                document.getElementById('NoClaimsDiscountProtection-fbels-not-selected').classList.add('hide');
                document.getElementById('NoClaimsDiscountProtection-fbels-selected').classList.remove('hide');
            });

            pncdRemoveButton.addEventListener('click', () => {
                document.getElementById('NoClaimsDiscountProtection-fbels-selected').classList.add('hide');
                document.getElementById('NoClaimsDiscountProtection-fbels-not-selected').classList.remove('hide');
            });
        }
    }

    return {
        setEventBindings,
    };
})($);
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.demandsandneeds = bgl.components.demandsandneeds || {};
bgl.components.demandsandneeds.optionalextras = bgl.components.demandsandneeds.optionalextras || {};

bgl.components.demandsandneeds.policymanagement = (function($) {
    let configuration;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        bgl.components.demandsandneeds.configuration = componentConfiguration;

        setEventBindings();
        populateSessionAnswers();

        bgl.components.demandsandneeds.update.pollBasketCallback = function(evt) {
            setTimeout(function() {
                bgl.common.utilities.refreshPage();
            }, 200);
        };

        bgl.common.pubsub.on('switchPaymentType', function(isMonthly) {
            bgl.components.demandsandneeds.elements.disableElements(true);
            setTimeout(function() {
                bgl.common.utilities.refreshPage();
            }, 200);
        });
    }

    function setEventBindings() {
        const addonButtons = [...document.querySelectorAll('[data-type="addon-yes"], [data-type="addon-no"]')];
        addonButtons.forEach((button) => button.addEventListener('click', (event) => {
            addonYesOrNoButtonClick(event, configuration.ErrorRedirectUrl);
        }));

        addonButtons.forEach((button) => {
            button.labels[0].addEventListener('keyup', (event) => {
                bgl.common.keyboardAccessibility.generateClickOnKeypress(event);
            });
        });

        document.getElementById('NextPageButton').addEventListener('click', (evt) => {
            if (bgl.components.demandsandneeds.validation.validateAddons()) {
                bgl.components.pagereloader.poller.reloadPage(null, true, configuration.NextPageUrl);
            } else {
                evt.preventDefault();
                bgl.components.demandsandneeds.validation.scrollToFirstAddonWithError();
            }
        });
    }

    function addonYesOrNoButtonClick(event, errorRedirectUrl) {
        const addonForm = event.target.closest('form');
        const addonId = addonForm.id;

        sessionStorage.setItem(`${addonId}-seen`, 'true');

        if (addonForm.querySelectorAll('input[type="radio"]:checked').length > 0) {
            addonForm.classList.remove('error');
            addonForm.querySelector('#error-banner').classList.add('hide');
        }

        let addonToAdd;
        let addonToRemove;

        if (event.target.dataset.type === 'addon-yes') {
            if ((sessionStorage.getItem(`${addonId}-yes`))) {
                return;
            }

            addonToAdd = `${addonId}-yes`;
            addonToRemove = `${addonId}-no`;
            bgl.components.demandsandneeds.buttons.hideTickOnNoButtonForAddon(addonId);
        }

        if (event.target.dataset.type === 'addon-no') {
            if (sessionStorage.getItem(`${addonId}-no`)) {
                return;
            }

            addonToAdd = `${addonId}-no`;
            addonToRemove = `${addonId}-yes`;
            bgl.components.demandsandneeds.buttons.hideTickOnYesButtonForAddon(addonId);
        }

        bgl.components.demandsandneeds.elements.disableElements(true);

        bgl.components.demandsandneeds.update
            .updateAddOn(addonForm, event.target, false, errorRedirectUrl)
            .then(() => {
                sessionStorage.setItem(addonToAdd, addonToAdd);
                sessionStorage.removeItem(addonToRemove);
            });
    }

    function populateSessionAnswers() {
        const allAddonForms = document.querySelectorAll('form');

        allAddonForms.forEach((addonForm) => {
            const addonId = addonForm.id;

            if (sessionStorage.getItem(`${addonId}-no`)) {
                addonForm.querySelector('[data-type="addon-no"]').checked = true;
                bgl.components.demandsandneeds.buttons.showTickOnNoButtonForAddon(addonId);
            }

            const addOnYesButtons = [...addonForm.querySelectorAll('[data-type="addon-yes"]')];

            if (addOnYesButtons.length == 1) {
                if (addOnYesButtons[0].checked) {
                    sessionStorage.setItem(`${addonId}-yes`, `${addonId}-yes`);
                }
            }
        });
    }

    function getConfiguration() {
        return configuration;
    }

    return {
        init: initComponent,
        getConfiguration: getConfiguration,
    };
})($);
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.demandsandneeds = bgl.components.demandsandneeds || {};

bgl.components.demandsandneeds.multitier = (function($) {
    function setMultiTierEventBindings(errorRedirectUrl) {
        [...document.getElementsByTagName('select')].forEach((select) => {
            select.addEventListener('change', (event) => {
                const addonForm = event.target.closest('form');

                if (sessionStorage.getItem(`${addonForm.id}-yes`)) {
                    bgl.components.demandsandneeds.update.updateAddOn(
                        addonForm,
                        addonForm.querySelector(`#${addonForm.id}-yes`),
                        false,
                        errorRedirectUrl);
                }

                bgl.components.demandsandneeds.multitier.handleMultiTierContent(addonForm);
            });
        });
    }

    function handleMultiTierContent(addonForm) {
        [...addonForm.getElementsByTagName('option')].forEach((option) => {
            const optionPrice = addonForm.querySelector(`#${option.value}`);
            const goodToKnowListContent = addonForm
                .querySelectorAll(`[data-multi-tier-content-${option.value}]`);
            const alertSelected = document.querySelectorAll(`[data-addon-alert-gr-${option.value}]`);

            if (option.selected) {
                optionPrice.classList.remove('hide');
            } else {
                optionPrice.classList.add('hide');
            }

            if (goodToKnowListContent) {
                if (option.selected) {
                    goodToKnowListContent.forEach((content) => {
                        content.classList.remove('hide');
                    });
                } else {
                    goodToKnowListContent.forEach((content) => {
                        content.classList.add('hide');
                    });
                }
            }

            if (alertSelected) {
                if (option.selected) {
                    alertSelected.forEach((content) => {
                        content.classList.remove('hide');
                    });
                } else {
                    alertSelected.forEach((content) => {
                        content.classList.add('hide');
                    });
                }
            }
        });
    }

    return {
        setMultiTierEventBindings,
        handleMultiTierContent,
    };
})($);
// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.demandsandneeds = bgl.components.demandsandneeds || {};

bgl.components.demandsandneeds.grcTierCards = (function($) {
    function setGRCTierCardsEventBindings(errorRedirectUrl) {
        [...document.querySelectorAll('input[type="radio"][name="SelectedCoverLevelCode"]')].forEach((radio) => {
            radio.addEventListener('change', (event) => {
                const addonForm = event.target.closest('form');

                if (sessionStorage.getItem(`${addonForm.id}-yes`)) {
                    bgl.components.demandsandneeds.update.updateAddOn(
                        addonForm,
                        addonForm.querySelector(`#${addonForm.id}-yes`),
                        false,
                        errorRedirectUrl);
                }

                bgl.components.demandsandneeds.grcTierCards.handleGRCTierCardsContent(addonForm);
            });
        });
    }

    function handleGRCTierCardsContent(addonForm) {
        [...addonForm.querySelectorAll('input[type="radio"][name="SelectedCoverLevelCode"]')].forEach((radio) => {
            const optionPrice = addonForm.querySelector(`#${radio.value}`);
            const goodToKnowListContent = addonForm
                .querySelectorAll(`[data-multi-tier-content-${radio.value}]`);
            const alertSelected = document.querySelectorAll(`[data-addon-alert-gr-${radio.value}]`);
            const cardLabel = addonForm.querySelector(`label[for="SelectedCoverLevelCode-${radio.value}"]`);
            const radioIndicator = cardLabel && cardLabel.querySelector('.grc-tier-card__radio-indicator');

            if (optionPrice) {
                if (radio.checked) {
                    optionPrice.classList.remove('hide');
                } else {
                    optionPrice.classList.add('hide');
                }
            }

            if (goodToKnowListContent) {
                if (radio.checked) {
                    goodToKnowListContent.forEach((content) => {
                        content.classList.remove('hide');
                    });
                } else {
                    goodToKnowListContent.forEach((content) => {
                        content.classList.add('hide');
                    });
                }
            }

            if (alertSelected) {
                if (radio.checked) {
                    alertSelected.forEach((content) => {
                        content.classList.remove('hide');
                    });
                } else {
                    alertSelected.forEach((content) => {
                        content.classList.add('hide');
                    });
                }
            }

            if (cardLabel) {
                cardLabel.classList.toggle('grc-tier-card__label--selected', radio.checked);
            }

            if (radioIndicator) {
                radioIndicator.classList.toggle('grc-tier-card__radio-indicator--selected', radio.checked);
            }
        });
    }

    return {
        setGRCTierCardsEventBindings,
        handleGRCTierCardsContent,
    };
})($);
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.demandsandneeds = bgl.components.demandsandneeds || {};

bgl.components.demandsandneeds.elements = (function($) {
    function disableElements(disable) {
        const elements = document.querySelectorAll(
            'button:not([data-tooltip-open]' +
            ', [data-tooltip-close])' +
            ', a' +
            ', select' +
            ', label'+
            ', [data-tier]' +
            ', .shopping-basket' +
            ', #Houston');

        if (disable === true) {
            elements.forEach((element) => {
                element.classList.add('disabled');
                element.setAttribute('disabled', disable);
            });
        } else {
            elements.forEach((element) => {
                element.classList.remove('disabled');
                element.removeAttribute('disabled');
            });
        };
    }

    function isVisible(element) {
        const style = window.getComputedStyle(element);
        return style.display !== 'none';
    }

    function scrollToElement(element) {
        if (element) {
            const headerHeight = document.querySelector('header').offsetHeight;
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
                top: elementPosition - headerHeight - 5,
                behavior: 'smooth',
            });
        }
    }

    return {
        disableElements,
        isVisible,
        scrollToElement,
    };
})($);
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.demandsandneeds = bgl.components.demandsandneeds || {};

bgl.components.demandsandneeds.common = (function($) {
    let configuration;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        setEventBindings();
        bgl.components.demandsandneeds.protectednoclaimsdiscount.setEventBindings();
        bgl.components.demandsandneeds.multitier.setMultiTierEventBindings();
        if (componentConfiguration.UseRadioTierCards) {
            bgl.components.demandsandneeds.grcTierCards.setGRCTierCardsEventBindings();
        }
        populateSessionAnswers();
        bgl.uil.accordion.init();
        bgl.common.tooltip.init();

        const grvAddon = document.querySelector('[data-guaranteed-replacement-vehicle]');
        const quoteRef = document.querySelector('.pquote-number__number').innerHTML;

        if (grvAddon) {
            if (componentConfiguration.UseRadioTierCards) {
                bgl.components.demandsandneeds.grcTierCards.handleGRCTierCardsContent(grvAddon);
            } else {
                bgl.components.demandsandneeds.multitier.handleMultiTierContent(grvAddon);
            }
        }

        bgl.components.demandsandneeds.accordion.setupAddonAccordions();
        showAddOnAsAddedAtAgg(quoteRef);
        checkIfFirstPageLoad(quoteRef);
        bgl.components.demandsandneeds.configuration = componentConfiguration;
    }

    function setEventBindings() {
        const addonButtons = [...document.querySelectorAll('[data-type="addon-yes"], [data-type="addon-no"]')];
        addonButtons.forEach((button) => button.addEventListener('click', (event) => {
            bgl.components.demandsandneeds.buttons.addonYesOrNoButtonClick(event, configuration.errorRedirectUrl);
        }));

        addonButtons.forEach((button) => {
            button.labels[0].addEventListener('keyup', (event) => {
                bgl.common.keyboardAccessibility.generateClickOnKeypress(event);
            });
        });

        document.getElementById('ContinueButton').addEventListener('click', () => {
            if (configuration.SoftValidation) {
                if (!bgl.components.demandsandneeds.validation.validateOpenAddon()) {
                    return;
                }

                if (bgl.components.demandsandneeds.validation.areAllAddonsAnswered() &&
                    bgl.components.demandsandneeds.validation.areAllAddonsSeen()) {
                    bgl.components.pagereloader.poller.reloadPage(null, true, configuration.NextPageUrl);
                } else {
                    const openAccordionButton = document.querySelector(
                        '[data-type="addon-content"] [data-accordion-button][aria-expanded="true"]');
                    const openAddon = openAccordionButton ?
                        openAccordionButton.closest('[data-type="addon-content"]') :
                        null;

                    bgl.components.demandsandneeds.accordion.setupAddonAccordions(true, openAddon);
                }
            } else if (bgl.components.demandsandneeds.validation.validateAddons()) {
                bgl.components.pagereloader.poller.reloadPage(null, true, configuration.NextPageUrl);
            } else {
                bgl.components.demandsandneeds.accordion.setupAddonAccordions();
                bgl.components.demandsandneeds.validation.scrollToFirstAddonWithError();
            }
        });

        const overlayButtonSelector = configuration.SoftValidation ?
            '[data-addon-learn-more], [data-overlay-close]' :
            '[data-addon-learn-more], [data-overlay-close], [data-overlay-add]';
        const overlayButtons = [...document.querySelectorAll(overlayButtonSelector)];
        overlayButtons.forEach((button) => button.addEventListener('click', (event) => {
            bgl.components.demandsandneeds.buttons.showOrHideAddOnOverlay(event.target);

            if (!configuration.SoftValidation && event.target.closest('[data-overlay-add]')) {
                const addonForm = event.target.closest('form');
                const addonYesButton = addonForm.querySelector('[data-type="addon-yes"]');
                if (addonYesButton) {
                    addonYesButton.click();
                }
            }
        }));

        const carousel = document.getElementById('breakdown-carousel');
        if (carousel) {
            bgl.components.demandsandneeds.breakdown.loadBreakdownCarouselLogic(carousel);
        }

        const breakdownAccordionButton = document.getElementById('Breakdown-accordion-button');
        if (breakdownAccordionButton) {
            breakdownAccordionButton.addEventListener('click', () => {
                setTimeout(bgl.uil.carousel.displayActiveTierInViewport, 500, carousel);
            });
        }

        const addonContinueButtons = [...document.querySelectorAll('[data-button-continue]')];
        addonContinueButtons.forEach((button) => button.addEventListener('click', (event) => {
            const addonForm = configuration.SoftValidation ? event.currentTarget.closest('form') : null;
            if (addonForm) {
                addonForm.dataset.addonConfirmed = 'true';
                const addonId = addonForm.querySelector('[data-accordion-button]')?.getAttribute('data-addon-id');
                if (addonId) {
                    sessionStorage.setItem(`${addonId}-confirmed`, 'true');
                }
                bgl.components.demandsandneeds.validation.hideInlineValidationMessage(addonForm);
            }
            bgl.components.demandsandneeds.accordion.setupAddonAccordions(true);
        }));

        const changeSelectionButton = document.querySelector('[data-button-change-selection]');
        if (changeSelectionButton) {
            changeSelectionButton.addEventListener('click', (event) => {
                const carousel = document.querySelector('[data-uil-carousel-wrapper]');
                const scrollToElement = bgl.components.demandsandneeds.elements.isVisible(carousel) ?
                    carousel :
                    document.getElementById('breakdown-table');

                scrollToElement.scrollIntoView({behavior: 'smooth', block: 'center'});
            });
        }

        document.getElementById('dismiss-button').addEventListener('click', () => dismissNotification());
        document.getElementById('got-it-button').addEventListener('click', () => dismissNotification());
    }

    function showAddOnAsAddedAtAgg(quoteRef) {
        if (document.querySelectorAll('[data-addon-added-at-agg]') != null) {
            if (sessionStorage.getItem(`${quoteRef}-AddonPagePreviouslyLoaded`) === null) {
                const addonAddedOnAgg = document.querySelectorAll('[data-addon-added-at-agg]');
                addonAddedOnAgg.forEach((element) => {
                    const addonAddedOnAggId = element.id;
                    sessionStorage.setItem(`${quoteRef}-${addonAddedOnAggId}`, 'true');
                });
            }
            const addonAddedOnAggLoaded = document.querySelectorAll('[data-addon-added-at-agg]');
            addonAddedOnAggLoaded.forEach((element) => {
                const addonAddedOnAggIdLoadedId = element.id;
                if (sessionStorage.getItem(`${quoteRef}-${addonAddedOnAggIdLoadedId}`) === 'true') {
                    element.classList.remove('hide');
                };
            });
        }
    }

    function checkIfFirstPageLoad(quoteRef) {
        if (sessionStorage.getItem(`${quoteRef}-AddonPagePreviouslyLoaded`) === null) {
            sessionStorage.setItem(`${quoteRef}-AddonPagePreviouslyLoaded`, 'true');
        }
    }

    function populateSessionAnswers() {
        const allAddonForms = document.querySelectorAll('form');

        allAddonForms.forEach((addonForm) => {
            const addonIsBreakdown = addonForm.id.toLocaleLowerCase() === 'breakdown';
            const isNotSingleTierBreakdown = !addonForm.hasAttribute('data-single-tier-breakdown');

            const addonId = (addonIsBreakdown && isNotSingleTierBreakdown) ?
                addonForm.id.toLocaleLowerCase() :
                addonForm.id;

            const isExcessProtection = addonId === 'ExcessProtection';

            if (isExcessProtection) {
                const yesButtons = [...addonForm.querySelectorAll('[data-type="addon-yes"]')];
                const noButton = addonForm.querySelector('[data-type="addon-no"]');

                const anyYesChecked = yesButtons.some((button) => button.checked);
                const noChecked = !!noButton?.checked;

                if (!anyYesChecked && !noChecked) {
                    sessionStorage.removeItem(`${addonId}-yes`);
                    sessionStorage.removeItem(`${addonId}-no`);
                }
            }

            if (sessionStorage.getItem(`${addonId}-no`)) {
                if (addonIsBreakdown && isNotSingleTierBreakdown) {
                    addonForm.querySelector('[data-type="addon-no"][data-breakdown-carousel]').checked = true;
                }

                addonForm.querySelector('[data-type="addon-no"]').checked = true;
                bgl.components.demandsandneeds.buttons.showTickOnNoButtonForAddon(addonId);
            }

            const addOnYesButtons = [...addonForm.querySelectorAll('[data-type="addon-yes"]')];

            if (addOnYesButtons.length == 1) {
                if (addOnYesButtons[0].checked) {
                    sessionStorage.setItem(`${addonId}-yes`, `${addonId}-yes`);
                }
            } else if (addOnYesButtons.length > 1) {
                addOnYesButtons.forEach((button) => {
                    if (button.checked) {
                        const breakdownTier = button.hasAttribute('data-breakdown-carousel') ?
                            button.parentElement.dataset.tier :
                            button.nextElementSibling.dataset.tier;

                        sessionStorage.setItem(`${addonId}-yes`, `${addonId}-${breakdownTier}`);
                    }
                });
            }
        });
    }

    function dismissNotification() {
        const messageContainer = document.getElementById('enhanced-message-container');
        if (messageContainer) {
            messageContainer.classList.add('hide');
            messageContainer.style.display = 'none';
        }
    }

    function getConfiguration() {
        return configuration;
    }

    return {
        init: initComponent,
        getConfiguration: getConfiguration,
    };
})($);
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.demandsandneeds = bgl.components.demandsandneeds || {};

bgl.components.demandsandneeds.buttons = (function($) {
    function showTickOnNoButtonForAddon(addonId) {
        const noTick = document.querySelector(`#${addonId}-no-label [data-addon-tick]`);
        if (noTick) {
            noTick.classList.remove('hide');
        }
    }

    function hideTickOnYesButtonForAddon(addonId) {
        const yesTick = document.querySelector(`#${addonId}-yes-label [data-addon-tick]`);
        if (yesTick) {
            yesTick.classList.add('hide');
        }
    }

    function hideTickOnNoButtonForAddon(addonId) {
        const noTick = document.querySelector(`#${addonId}-no-label [data-addon-tick]`);
        if (noTick) {
            noTick.classList.add('hide');
        }
    }

    function addonYesOrNoButtonClick(event, errorRedirectUrl) {
        const addonForm = event.target.closest('form');
        const addonId = addonForm.id;
        const useInlineValidation =
            bgl.components.demandsandneeds.common.getConfiguration().SoftValidation;

        if (useInlineValidation) {
            addonForm.dataset.addonConfirmed = 'true';
            sessionStorage.setItem(`${addonId}-confirmed`, 'true');
        }
        sessionStorage.setItem(`${addonId}-seen`, 'true');

        const breakdownTier = event.target.labels[0].dataset.tier;
        const isMultiTierBreakdown = breakdownTier &&
            !addonForm.hasAttribute('data-single-tier-breakdown');

        if (isMultiTierBreakdown) {
            bgl.components.demandsandneeds.breakdown.setTierBreakdownLogic(
                addonForm,
                breakdownTier,
                event.target,
                errorRedirectUrl);
        } else {
            if (addonForm.querySelectorAll('input[type="radio"]:checked').length > 0) {
                addonForm.classList.remove('error');
                addonForm.querySelector('#error-banner').classList.add('hide');
                bgl.components.demandsandneeds.validation.hideInlineValidationMessage(addonForm);
            }

            if (event.target.dataset.type === 'addon-yes') {
                if ((sessionStorage.getItem(`${addonId}-yes`))) {
                    if (useInlineValidation) {
                        bgl.components.demandsandneeds.accordion.setupAddonAccordionsAfterAnswer(addonForm);
                    }
                    return;
                }

                bgl.components.demandsandneeds.elements.disableElements(true);
                bgl.components.demandsandneeds.buttons.hideTickOnNoButtonForAddon(addonId);

                if (!useInlineValidation) {
                    addonForm.querySelector('[data-overlay-add]')?.classList?.add('hide');
                    if (!sessionStorage.getItem(`${addonId}-overlay-add`)) {
                        bgl.components.demandsandneeds.buttons.showOrHideAddOnOverlay(event.target);
                    }
                }

                bgl.components.demandsandneeds.update
                    .updateAddOn(addonForm, event.target, false, errorRedirectUrl)
                    .then(() => {
                        sessionStorage.setItem(`${addonId}-yes`, `${addonId}-yes`);
                        sessionStorage.removeItem(`${addonId}-no`);
                    });
            }

            if (event.target.dataset.type === 'addon-no') {
                if (sessionStorage.getItem(`${addonId}-no`)) {
                    if (useInlineValidation) {
                        bgl.components.demandsandneeds.accordion.setupAddonAccordionsAfterAnswer(addonForm);
                    }
                    return;
                }

                if (!useInlineValidation && sessionStorage.getItem(`${addonId}-overlay-add`)) {
                    sessionStorage.removeItem(`${addonId}-overlay-add`);
                }

                bgl.components.demandsandneeds.elements.disableElements(true);
                bgl.components.demandsandneeds.buttons.hideTickOnYesButtonForAddon(addonId);
                sessionStorage.setItem(`${addonId}-no`, `${addonId}-no`);

                if (sessionStorage.getItem(`${addonId}-yes`)) {
                    sessionStorage.removeItem(`${addonId}-yes`);
                    bgl.components.demandsandneeds.update.updateAddOn(
                        addonForm,
                        event.target,
                        false,
                        errorRedirectUrl);
                } else {
                    setTimeout(function() {
                        bgl.components.demandsandneeds.elements.disableElements(false);
                    }, 1000);
                    bgl.components.demandsandneeds.buttons.showTickOnNoButtonForAddon(addonId);
                    bgl.components.demandsandneeds.accordion.setupAddonAccordionsAfterAnswer(addonForm);
                }
            }
        }

        if (!document.querySelector('form.error')) {
            const microCopy = document.getElementById('microCopy');
            if (microCopy) {
                microCopy.classList.remove('micro-copy--error');
            }
        }
    }

    function showOrHideAddOnOverlay(eventTargetElement) {
        const addonForm = eventTargetElement.closest('form');
        const addonId = addonForm.id;
        const overlay = document.getElementById(`${addonId}-overlay`);
        if (addonForm && overlay) {
            if (eventTargetElement.closest('[data-overlay-close]') ||
                eventTargetElement.closest('[data-overlay-add]')
            ) {
                overlay.classList.add('hide');

                if (eventTargetElement.closest('[data-overlay-add]')) {
                    sessionStorage.setItem(`${addonId}-overlay-add`, 'true');
                }
            } else if (eventTargetElement.closest('[data-addon-learn-more]') ||
                       (!bgl.components.demandsandneeds.common.getConfiguration().SoftValidation &&
                        eventTargetElement.dataset.type === 'addon-yes')
            ) {
                overlay.classList.remove('hide');
                const overlayContent = overlay.querySelector('[data-overlay-content]');
                if (overlayContent) {
                    overlayContent.scrollTop = 0;
                }
            }
        }
    }

    return {
        showTickOnNoButtonForAddon,
        hideTickOnYesButtonForAddon,
        hideTickOnNoButtonForAddon,
        addonYesOrNoButtonClick,
        showOrHideAddOnOverlay,
    };
})($);
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.demandsandneeds = bgl.components.demandsandneeds || {};

bgl.components.demandsandneeds.bundledaddonpopup = (function() {
    let config;

    function initComponent(configuration) {
        config = Object.freeze(configuration);

        const continueButton = document.querySelector('[data-continue-button]');
        continueButton.addEventListener('click', handleContinueButtonClick);

        const popupHideLink = document.getElementById(config.popupHideLinkId);
        popupHideLink.addEventListener('click', hidePopup);

        const selectedVariant = document.querySelector('input[name="SelectedVariantCode"]').value;
        const listItems =
            [...document.querySelectorAll(`li[data-for-variants*="${selectedVariant}"]`)];
        listItems.forEach((item) => {
            item.classList.remove('hide');
        });
    }

    function handleContinueButtonClick() {
        const upsellModalSeen = sessionStorage.getItem('upsell-modal-seen-price-pres');

        if (config.hasPremier && !upsellModalSeen && !premierIsSelected() && getPriceSavingMessage()) {
            document.getElementById(config.popUpContainerId).classList.remove('hide');
            sessionStorage.setItem('upsell-modal-seen-price-pres', 'true');
        } else {
            bgl.common.utilities.redirectToUrl(config.nextPageUrl);
        }
    }

    function premierIsSelected() {
        return document.getElementById(config.premierSelectButtonId).innerText === 'Selected';
    }

    function getPriceSavingMessage() {
        return document.getElementById(config.messageContainerId).innerText;
    }

    function hidePopup() {
        document.getElementById(config.popUpContainerId).classList.add('hide');
    }

    return {
        init: initComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.demandsandneeds = bgl.components.demandsandneeds || {};
bgl.components.demandsandneeds.optionalextras = bgl.components.demandsandneeds.optionalextras || {};

bgl.components.demandsandneeds.breakdown = (function($) {
    function selectBreakdownTier(breakdownAddon, selectedTier, isBreakdownTable) {
        const code = selectedTier.dataset.coverLevelCode;
        const tierNumber = selectedTier.dataset.tier;

        updateUpgradeMessage(selectedTier.dataset.coverLevelCode);

        if (breakdownAddon.querySelector('[data-included-as-standard]')) {
            if (tierNumber > 1) {
                sessionStorage.setItem(`${breakdownAddon.id}IncludedAsStandard`, 'false');
                breakdownAddon.querySelector('[data-included-as-standard]').classList.add('hide');
            } else {
                sessionStorage.setItem(`${breakdownAddon.id}IncludedAsStandard`, 'true');
                breakdownAddon.querySelector('[data-included-as-standard]').classList.remove('hide');
            }
        }

        document.getElementById('breakdown-code').value = code;

        if (isBreakdownTable && tierNumber > 0) {
            setBreakdownTableTierStyling(breakdownAddon, tierNumber);
            mirrorBreakdownChanges(isBreakdownTable, tierNumber);
        } else if (tierNumber == 0) {
            const breakdownCarouselNoButton = document.getElementById('breakdown-carousel-no');
            bgl.uil.carousel.deselectAll(document.querySelector('[data-uil-carousel]'));

            if (isBreakdownTable) {
                setBreakdownTableTierStyling(breakdownAddon, tierNumber);
                breakdownAddon.querySelector('[data-tier="0"]').classList.add('active');

                if (breakdownCarouselNoButton) {
                    breakdownCarouselNoButton.checked = true;
                    document.getElementById('breakdown-carousel-no-label').classList.add('active');
                }
            } else {
                if (breakdownCarouselNoButton) {
                    breakdownCarouselNoButton.checked = true;
                    document.getElementById('breakdown-carousel-no-label').classList.add('active');
                }

                mirrorBreakdownChanges(isBreakdownTable, tierNumber);
            }
        } else {
            mirrorBreakdownChanges(isBreakdownTable, tierNumber);
        }
        showBreakdownBasket();
        updateBreakdownBasketTitle(tierNumber);
        updateBreakdownBasketItem('total-annual-amount', tierNumber);
        updateBreakdownBasketItem('deposit', tierNumber);
        updateBreakdownBasketItem('monthly-amount', tierNumber);
        updateBreakdownBasketItem('number-of-instalments', tierNumber);
        updateBreakdownBasketItem('total-amount-payable', tierNumber);
    };

    function updateUpgradeMessage(code) {
        const panel = document.getElementById('breakdown-upgrade-panel');

        if (!panel) {
            return;
        }

        const source = document.querySelector(
            `[data-upgrade-message-source][data-cover-code="${code}"]`);

        if (!source) {
            panel.classList.add('hide');
            return;
        }

        const extraTextContainer = document.querySelector(
            '[data-upgrade-extra-text-container]');

        const extraText = document.querySelector(
            '[data-upgrade-extra-text]');

        panel.classList.remove('hide');

        if (!source.innerText.trim()) {
            extraText.innerHTML = '';
            extraTextContainer.classList.add('hide');
            return;
        }

        extraText.innerHTML = source.innerHTML;
        extraTextContainer.classList.remove('hide');
    }

    function showBreakdownBasket() {
        document.querySelector('[data-breakdown-basket]').classList.remove('hide');
    }

    function updateBreakdownBasketTitle(tierNumber) {
        if (tierNumber == '0') {
            document.querySelector('[data-basket-tier-title]').innerText = 'Not Required';
            document.querySelector('[data-breakdown-basket-prices]').classList.add('hide');
            return;
        }

        document.querySelector('[data-breakdown-basket-prices]').classList.remove('hide');
        const element = document
            .querySelector(`[data-breakdown-tier='${tierNumber}'][data-breakdown-tier-title]`);
        if (element) {
            document.querySelector('[data-basket-tier-title]').innerText =
                element.getAttribute('data-breakdown-tier-title');
        }
    }

    function updateBreakdownBasketItem(dataAttributeName, tierNumber) {
        const element = document
            .querySelector(`[data-breakdown-tier='${tierNumber}'][data-breakdown-tier-${dataAttributeName}]`);
        if (element) {
            document.querySelector(`[data-basket-tier-${dataAttributeName}]`).innerText =
                element.innerText;
        }
    }

    function mirrorBreakdownChanges(isBreakdownTable, tierNumber) {
        if (isBreakdownTable) {
            const carousel = document.querySelector('[data-uil-carousel]');

            bgl.uil.carousel.deselectAll(carousel);
            bgl.uil.carousel.selectTier(carousel, tierNumber);
        } else {
            setBreakdownTableTierStyling(document.querySelector('#breakdown-table'), tierNumber);
        }
    };

    function setBreakdownTableTierStyling(breakdownAddon, tierNumber) {
        [...breakdownAddon.querySelectorAll('.active')].forEach((activeElement) => {
            activeElement.classList.remove('active');
        });

        [...breakdownAddon.querySelectorAll('label[data-tier]')].forEach((tier) => {
            const tierText = tier.querySelector('[data-breakdown-button-text]');
            const tierTick = tier.querySelector('[data-addon-tick]');
            if (tierText.innerText === 'Selected') {
                tierText.innerText = 'Select';
                tierTick.classList.add('hide');
            }
        });

        const selectedTier = breakdownAddon.querySelector(`[data-tier="${tierNumber}"]`);

        if (tierNumber > 0) {
            selectedTier.querySelector('[data-breakdown-button-text]').innerText = 'Selected';

            [...breakdownAddon.querySelectorAll('tbody tr')].forEach((tableRow) => {
                tableRow.querySelectorAll('td')[tierNumber - 1].classList.add('active');
            });
        }
        selectedTier.closest('th').classList.add('active');

        breakdownAddon.querySelector(`[data-tier-input="${tierNumber}"]`).checked = true;
    }

    function loadBreakdownCarouselLogic(carousel) {
        const breakdownInfoIcons = [...document.querySelectorAll('[data-breakdown-info-icon]')];
        breakdownInfoIcons.forEach((icon) => {
            icon.addEventListener('click', (event) => {
                event.preventDefault();
                const breakdownInfoTooltipId = event.currentTarget.dataset.targetTooltip;
                const tierCard = carousel.querySelector(`[data-tier="${event.currentTarget.dataset.iconTier}"]`);
                const isTooltipOpen = tierCard.querySelector('[data-breakdown-tooltip]:not(.hide)');
                if (isTooltipOpen) {
                    isTooltipOpen.classList.add('hide');
                }
                carousel.querySelector('#' + breakdownInfoTooltipId).classList.remove('hide');
            });
        });

        const breakdownInfoCloseButtons = [...document.querySelectorAll('[data-breakdown-tooltip-close]')];
        breakdownInfoCloseButtons.forEach((closeButton) => {
            closeButton.addEventListener('click', (event) => {
                event.preventDefault();
                const tooltip = event.currentTarget.closest('.uil-carousel-tooltip');
                tooltip.classList.add('hide');
            });
        });

        const breakdownCarouselNoButton = document.getElementById('breakdown-carousel-no');
        if (breakdownCarouselNoButton) {
            breakdownCarouselNoButton.addEventListener('click', (event) => {
                bgl.uil.carousel.deselectAll(carousel);

                if (document.getElementById('breakdown-basket-error')) {
                    document.getElementById('breakdown-basket-error').remove();
                }

                document.getElementById('breakdown-no-label').classList.add('active');
                document.getElementById('breakdown-no').checked = true;
            });
        }

        const selectedBreakdownTier = document.querySelector(
            'input[name="breakdown-basket"]:checked[data-type="addon-yes"]');

        if (selectedBreakdownTier) {
            updateUpgradeMessage(
                selectedBreakdownTier.labels[0].dataset.coverLevelCode);
        }
    }

    function setTierBreakdownLogic(addonForm, breakdownTier, eventTargetElement, errorRedirectUrl) {
        const breakdownAddon = eventTargetElement.closest('input');
        const addonId = addonForm.id.toLocaleLowerCase();
        const isBreakdownTable = breakdownAddon.getAttribute('data-breakdown-table') !== null;
        const isBreakdownCarousel = !isBreakdownTable;
        const breakdownCarouselAddonLabel = eventTargetElement.closest('label');
        const formattedAddonId = addonId.toLocaleLowerCase();

        if (addonForm.querySelectorAll('input[type="radio"]:checked').length > 0) {
            const carouselButtons =
                addonForm.querySelector('[data-uil-carousel]').querySelectorAll('[data-tier-select-btn]');
            carouselButtons.forEach((button) => {
                button.classList.remove('uil-radio-btn--error');
            });

            if (document.getElementById('breakdown-carousel-no-label')) {
                document.getElementById('breakdown-carousel-no-label')
                    .classList.remove('uil-radio-btn--error');
            }

            addonForm.classList.remove('error');
            addonForm.querySelector('#error-banner').classList.add('hide');
            bgl.components.demandsandneeds.validation.hideInlineValidationMessage(addonForm);
        }

        if (eventTargetElement.dataset.type === 'addon-yes') {
            if (sessionStorage.getItem(`${formattedAddonId}-yes`) == `${formattedAddonId}-${breakdownTier}`) {
                return;
            }

            bgl.components.demandsandneeds.elements.disableElements(true);

            let breakdownTierSelectionElement = addonForm.querySelector('[data-breakdown-addon-table]');
            if (isBreakdownCarousel) {
                breakdownTierSelectionElement = addonForm.querySelector('[data-uil-carousel]');
                breakdownCarouselAddonLabel.querySelector('[data-button-content]').classList.add('hide');
            }

            // given the if statement above, this code seems pointless
            if (isBreakdownCarousel && !breakdownCarouselAddonLabel.hasAttribute('data-active-button')) {
                breakdownCarouselAddonLabel.querySelector('[data-button-content]').classList.add('hide');
            }

            bgl.components.demandsandneeds.breakdown.selectBreakdownTier(
                breakdownTierSelectionElement,
                eventTargetElement.labels[0],
                isBreakdownTable);
            bgl.components.demandsandneeds.buttons.hideTickOnNoButtonForAddon(formattedAddonId);

            if (!bgl.components.demandsandneeds.common.getConfiguration().SoftValidation &&
                !sessionStorage.getItem(`${formattedAddonId}-yes`)) {
                bgl.components.demandsandneeds.buttons.showOrHideAddOnOverlay(eventTargetElement);
            }

            bgl.components.demandsandneeds.update
                .updateAddOn(addonForm, eventTargetElement, true, errorRedirectUrl)
                .then(() => {
                    sessionStorage.setItem(`${formattedAddonId}-yes`, `${formattedAddonId}-${breakdownTier}`);
                    sessionStorage.removeItem(`${formattedAddonId}-no`);
                });
        }

        if (eventTargetElement.dataset.type === 'addon-no') {
            if (sessionStorage.getItem(`${formattedAddonId}-no`)) {
                return;
            }

            bgl.components.demandsandneeds.elements.disableElements(true);

            let breakdownTierSelectionElement = addonForm.querySelector('[data-breakdown-addon-table]');
            if (isBreakdownCarousel) {
                breakdownTierSelectionElement = document.querySelector('[data-uil-carousel-not-required]');
            }

            bgl.components.demandsandneeds.breakdown.selectBreakdownTier(
                breakdownTierSelectionElement,
                eventTargetElement.labels[0],
                isBreakdownTable);

            sessionStorage.setItem(`${formattedAddonId}-no`, `${formattedAddonId}-no`);

            if (sessionStorage.getItem(`${formattedAddonId}-yes`)) {
                sessionStorage.removeItem(`${formattedAddonId}-yes`);
                if (breakdownTier > 0) {
                    breakdownCarouselAddonLabel.querySelector('[data-button-content]').classList.add('hide');
                }

                bgl.components.demandsandneeds.update.updateAddOn(
                    addonForm,
                    eventTargetElement,
                    true,
                    errorRedirectUrl);
            } else {
                setTimeout(function() {
                    bgl.components.demandsandneeds.elements.disableElements(false);
                }, 1000);
                bgl.components.demandsandneeds.accordion.setupAddonAccordionsAfterAnswer(addonForm);
            }
        }
    }

    return {
        loadBreakdownCarouselLogic,
        setTierBreakdownLogic,
        selectBreakdownTier,
    };
})($);
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.demandsandneeds = bgl.components.demandsandneeds || {};

bgl.components.demandsandneeds.accordion = (function($) {
    function setupAddonAccordions(scroll, scrollTargetElement) {
        const accordions = [...document.querySelectorAll('[data-type="addon-content"]')];
        let firstAddonHasBeenShown = false;
        let topElement;
        const suppressAccordionScroll = !!scrollTargetElement;

        accordions.forEach((accordion) => {
            const thisAccordionShown = configureAccordionAndShow(
                accordion,
                firstAddonHasBeenShown,
                suppressAccordionScroll);
            if (thisAccordionShown && !firstAddonHasBeenShown) {
                firstAddonHasBeenShown = true;
                topElement = accordion;
            }
        });

        syncPageContinueButtonState();

        if (scroll && !document.querySelector('form.error')) {
            bgl.components.demandsandneeds.elements.scrollToElement(
                scrollTargetElement || topElement);
        }
    }

    function setupAddonAccordionsAfterAnswer(addonForm) {
        const configuration = bgl.components.demandsandneeds.common.getConfiguration();
        let scrollTargetElement = null;

        if (configuration.SoftValidation) {
            scrollTargetElement = addonForm.querySelector('[data-type="addon-content"]');
            const addonAddedAtAggregator = addonForm.querySelector('[data-addon-preselected-at-agg]');
            const addonConfirmed = addonForm.dataset && addonForm.dataset.addonConfirmed === 'true';

            if (addonAddedAtAggregator && !addonConfirmed) {
                syncPageContinueButtonState();
                if (!document.querySelector('form.error')) {
                    bgl.components.demandsandneeds.elements.scrollToElement(scrollTargetElement);
                }
                return;
            }
        }

        setupAddonAccordions(true, scrollTargetElement);
    }

    function syncPageContinueButtonState() {
        const configuration = bgl.components.demandsandneeds.common.getConfiguration();

        if (!configuration || !configuration.SoftValidation) {
            return;
        }

        const continueButton = document.getElementById('ContinueButton');
        if (!continueButton) {
            return;
        }

        const validation = bgl.components.demandsandneeds.validation;
        if (validation.areAllAddonsAnswered() && validation.areAllAddonsSeen()) {
            continueButton.classList.remove('button--disabled');
        } else {
            continueButton.classList.add('button--disabled');
        }
    }

    function configureAccordionAndShow(accordion, firstAddonHasBeenShown, suppressAccordionScroll) {
        const accordionButton = accordion.querySelector('[data-accordion-button]');
        const addonId = accordionButton.getAttribute('data-addon-id');
        const addonSeen = sessionStorage.getItem(`${addonId}-seen`);
        const configuration = bgl.components.demandsandneeds.common.getConfiguration();
        const sequenceUnseenAddons = configuration && configuration.SoftValidation;

        const addonAnsweredYes = accordion.querySelector(
            `[data-addon-id='${addonId}'][data-type='addon-yes']:checked`);
        const addonAnsweredNo = accordion.querySelector(
            `[data-addon-id='${addonId}'][data-type='addon-no']:checked`);
        const addonUnanswered = !addonAnsweredYes && !addonAnsweredNo;
        const awaitingConfirmation = !!sequenceUnseenAddons &&
            !!accordion.querySelector('[data-addon-preselected-at-agg]') &&
            sessionStorage.getItem(`${addonId}-confirmed`) !== 'true' &&
            !(accordion.closest('form')?.dataset.addonConfirmed === 'true');

        setContinueButtonVisibility(accordion, addonId, addonAnsweredYes || addonAnsweredNo);
        setAddonSelectedIcon(accordion, addonId, addonAnsweredYes, addonAnsweredNo);
        setAddonEditIconVisibility(accordion, addonAnsweredYes, addonAnsweredNo, addonSeen);
        setAddonAlertVisibility(accordion, addonAnsweredYes, addonAnsweredNo, addonSeen);
        setOverlayAddButtonVisibility(accordion, addonAnsweredYes);

        if (((addonAnsweredYes && addonSeen) || (addonAnsweredNo && addonSeen)) && !awaitingConfirmation) {
            bgl.uil.accordion.collapseAccordion(accordionButton);
            bgl.uil.accordion.enableAccordion(accordionButton);
        }

        if ((addonUnanswered || !addonSeen || awaitingConfirmation) && !firstAddonHasBeenShown) {
            firstAddonHasBeenShown = true;
            bgl.uil.accordion.expandAccordion(accordionButton);
            bgl.uil.accordion.enableAccordion(accordionButton);
            if (!suppressAccordionScroll) {
                accordionButton.scrollIntoView({behavior: 'smooth', block: 'start'});
            }
            sessionStorage.setItem(`${addonId}-seen`, 'true');
            if (accordion.closest('form.error')) {
                bgl.components.demandsandneeds.validation.scrollToFirstAddonWithError();
            }
            return true;
        } else if (addonUnanswered || awaitingConfirmation || (sequenceUnseenAddons && !addonSeen)) {
            bgl.uil.accordion.collapseAccordion(accordionButton);
            bgl.uil.accordion.disableAccordion(accordionButton);
        }

        return false;
    }

    function setContinueButtonVisibility(accordion, addonId, addonAnswered) {
        const continueButtonContainer = accordion.querySelector(
            `[data-addon-id='${addonId}'][data-continue-button-container]`);

        if (addonAnswered) {
            continueButtonContainer.classList.remove('hide');
        } else {
            continueButtonContainer.classList.add('hide');
        }
    }

    function setAddonSelectedIcon(accordion, addonId, addonAnsweredYes, addonAnsweredNo) {
        if (addonAnsweredYes) {
            setIconClassesYes(accordion, addonId);
        } else if (addonAnsweredNo) {
            setIconClassesNo(accordion, addonId);
        } else {
            setIconClassesQuestion(accordion, addonId);
        }
    }

    function setAddonEditIconVisibility(accordionButton, addonAnsweredYes, addonAnsweredNo, addonSeen) {
        if ((addonAnsweredYes || addonAnsweredNo) && addonSeen) {
            showEditIcon(accordionButton);
        } else {
            hideEditIcon(accordionButton);
        }
    }

    function setAddonAlertVisibility(accordionAlert, addonAnsweredYes, addonAnsweredNo, addonSeen) {
        if (addonAnsweredYes && addonSeen) {
            showAlertSelected(accordionAlert);
        } else if (addonAnsweredNo && addonSeen) {
            showAlertUnselected(accordionAlert);
        } else {
            hideAlert(accordionAlert);
        }
    }

    function setOverlayAddButtonVisibility(accordion, addonAnsweredYes) {
        if (addonAnsweredYes) {
            hideOverlayAddButton(accordion);
        } else {
            showOverlayAddButton(accordion);
        }
    }

    function hideAlert(accordion) {
        accordion.querySelector('[data-addon-alert-selected]').classList.add('hide');
        accordion.querySelector('[data-addon-alert-unselected]').classList.add('hide');
    }

    function showAlertSelected(accordion) {
        accordion.querySelector('[data-addon-alert-selected]').classList.remove('hide');
        accordion.querySelector('[data-addon-alert-unselected]').classList.add('hide');
    }

    function showAlertUnselected(accordion) {
        accordion.querySelector('[data-addon-alert-unselected]').classList.remove('hide');
        accordion.querySelector('[data-addon-alert-selected]').classList.add('hide');
    }

    function hideEditIcon(accordion) {
        accordion.querySelector('[data-edit-icon]').classList.add('hide');
    }

    function showEditIcon(accordion) {
        accordion.querySelector('[data-edit-icon]').classList.remove('hide');
    }

    function hideOverlayAddButton(accordion) {
        accordion.querySelector('[data-overlay-add]')?.classList?.add('hide');
    }

    function showOverlayAddButton(accordion) {
        accordion.querySelector('[data-overlay-add]')?.classList?.remove('hide');
    }

    function setIconClassesYes(accordion, addonId) {
        setIconClasses(accordion, addonId, 'ui-icon--md ui-icon-confirm--filled ui-icon-filled--success');
    }

    function setIconClassesNo(accordion, addonId) {
        setIconClasses(accordion, addonId, 'ui-icon--md ui-icon-cross-circle--filled ui-icon-filled--error');
    }

    function setIconClassesQuestion(accordion, addonId) {
        setIconClasses(accordion, addonId, 'ui-icon--md ui-icon-question-circle addon__header-icon');
    }

    function setIconClasses(accordion, addonId, classes) {
        const icon = accordion.querySelector(`[data-addon-id='${addonId}'][data-accordion-button-icon]`);
        icon.className = classes;
    }

    return {
        setupAddonAccordions,
        setupAddonAccordionsAfterAnswer,
    };
})($);
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};

const bglDatePickerViewOption = 0;
const mvtBglDatePickerViewOption = 1;

bgl.components.coverrange = (function() {
    let configuration;

    function init(componentConfiguration) {
        configuration = componentConfiguration;

        if (configuration.JourneyType === 'MultiStepEdit') {
            if (configuration.ViewOptions.PartialDatePicker === bglDatePickerViewOption ||
                configuration.ViewOptions.PartialDatePicker === mvtBglDatePickerViewOption) {
                bgl.components.bgldatepicker.init(configuration);
            } else {
                bgl.components.datepicker.init(configuration);
            }
        } else {
            initEvents();
        }
    }

    function initEvents() {
        $('.cover-range__button, .start-date_edit-button, .cover-range-widget__button, [data-edit-icon]')
            .off()
            .on('click',
                function(e) {
                    e.preventDefault();

                    const $this = $(this);
                    const container = $this.data('container');
                    const url = $this.data('url');

                    bgl.common.loader.load(configuration,
                        url,
                        container,
                        function() {
                            if (configuration.ViewOptions.PartialDatePicker === 0) {
                                bgl.components.bgldatepicker.init(configuration);
                            } else {
                                bgl.components.datepicker.init(configuration);
                            }
                        });
                });
    }
    return {
        init: init,
    };
})();

bgl.components.policycoverrange = (function() {
    function init() {
        const progress = $('.cover-range__bar').data('bar-progress') + '%';
        $('.cover-range__bar').css('width', progress);
    }

    return {
        init: init,
    };
})();


bgl.components.datepicker = (function() {
    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];

    let datepicker;
    let selectedDate;
    let configuration;
    let form;
    let today;
    const dateFormat = 'dd/mm/yy';

    function init(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#' + configuration.Id + '_form-cover-range');
        bgl.common.datastore.init(form);

        bgl.common.validator.init(form);

        today = configuration.DateToday ? new Date(configuration.DateToday) : new Date();
        const tomorrow = new Date(today.getTime());
        tomorrow.setDate(tomorrow.getDate() + 1);

        $('.date-picker__sub-button--today').on('click',
            function(e) {
                e.preventDefault();
                datepicker.datepicker('setDate', today);
                updateSelectedDate(getFormattedValue(today), configuration.IsService);
            });

        $('.date-picker__sub-button--tomorrow').on('click',
            function(e) {
                e.preventDefault();
                datepicker.datepicker('setDate', tomorrow);
                updateSelectedDate(getFormattedValue(tomorrow), configuration.IsService);
            });

        datepicker = $('#datepicker');
        selectedDate = new Date(datepicker.data('selected-date'));
        const earliestDate = new Date(datepicker.data('earliest-date'));
        const latestDate = new Date(datepicker.data('latest-date'));

        datepicker.datepicker({
            selectOtherMonths: false,
            minDate: earliestDate,
            maxDate: latestDate,
            defaultDate: selectedDate,
            showOtherMonths: false,
            dateFormat: dateFormat,
            onChangeMonthYear: function(year, month, inst) {
                setTimeout(function() {
                    $(`.ui-datepicker-prev:not(.ui-state-disabled), 
                    .ui-datepicker-next:not(.ui-state-disabled)`).attr('href', '#');
                    $('.ui-datepicker-calendar tbody a').first().focus();
                    $('.ui-datepicker-calendar tbody a').each(function() {
                        $(this).attr(
                            'aria-label',
                            toOrdinalString(parseInt(this.text)) + ' ' + getMonthString(month - 1),
                        );
                    });
                });
            },
            onSelect: function(dateText, inst) {
                inst.inline = false;
                updateSelectedDate(dateText, configuration.IsService);
            },
        });

        $('#' + configuration.Id + '_form-cover-range button').prop('disabled', false);

        $('.ui-datepicker-calendar tbody a').each(function() {
            $(this).attr(
                'aria-label',
                toOrdinalString(parseInt(this.text)) +' ' + getMonthString(selectedDate.getMonth()),
            );
        });
        $('.ui-datepicker-prev:not(.ui-state-disabled), .ui-datepicker-next:not(.ui-state-disabled)').attr('href', '#');

        updateSelectedDate(getFormattedValue(selectedDate), configuration.IsService);
        setBackButtonUrl(configuration);

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (!bgl.common.datastore.isDataChanged(form)) {
                        if (configuration.JourneyType === 'MultiStepEdit') {
                            onSuccess();
                        } else {
                            $('[data-dismiss="slide-panel"]').click();
                            bgl.common.datastore.removeSessionStorage(form);
                            return;
                        }
                    }
                    bgl.common.validator.submitForm(form, configuration);
                });
    }

    function getMonthString(num) {
        const month = months[num];
        if (month) return month;

        return 'Invalid month';
    }

    function updateSelectedDate(dateText, isService) {
        $('#SelectedEffectiveDate').val(dateText + ' 00:00:00');

        const dateTime = $.datepicker.parseDate(dateFormat, dateText);
        const isFuture = dateTime > today;
        let text = '';

        if (isService === true) {
            text = isFuture ? 'Cover will start at 00:01 hours' : 'Cover will start with immediate effect';

            const selectedEffectiveDateMessage = isFuture ?
                `Your changes are effective from ${dateText} at 00:01 hours.` :
                'Your changes are effective immediately.';
            sessionStorage.setItem('selectedEffectiveDateMessage', selectedEffectiveDateMessage);
        } else {
            text = isFuture ?
                'Cover will start at 00:01 hours' :
                'Cover will start as soon as you purchase your policy';
        }

        $('#datePickerSubText').html(text);
        $('.date-picker__selected-day').html(dateTime.getDate());
        $('.date-picker__selected-month').html(getMonthString(dateTime.getMonth()) + ' ' + dateTime.getFullYear());

        $('.ui-datepicker-calendar .ui-datepicker-current-day a').removeAttr('aria-current');
        $('.ui-datepicker-calendar .ui-datepicker-current-day')
            .removeClass('ui-datepicker-current-day')
            .children()
            .removeClass('ui-state-active');
        $('.ui-datepicker-calendar tbody a').each(function() {
            if ($(this).text() == dateTime.getDate()) {
                $(this).addClass('ui-state-active');
                $(this).parent().addClass('ui-datepicker-current-day');
                $(this).attr('aria-current', 'date');
            }
        });
    }

    function getFormattedValue(date) {
        return $.datepicker.formatDate(dateFormat, date);
    }

    function toOrdinalString(n) {
        return n + (['st', 'nd', 'rd'][((n + 90) % 100 - 10) % 10 - 1] || 'th');
    }

    function setBackButtonUrl(configuration) {
        if (configuration.JourneyType === 'MultiStepEdit') {
            const sessionData = JSON.parse(sessionStorage.getItem(configuration.DataStoreKey));
            if (sessionData != null && sessionData.selectedCoverFlag === 'Comprehensive') {
                $('#back-button-link').attr('href', configuration.CoverExcessesBackUrl);
            }
        }
    }

    function onSuccess() {
        if (configuration.JourneyType === 'MultiStepEdit') {
            if (configuration.IsService) {
                const options = {
                    redirectUrl: configuration.NextStepUrl,
                    hideNotification: true,
                    spinnerName: 'serviceSpinner',
                };
                bgl.common.pubsub.emit('PollBasket', options);
            } else {
                bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
            }
        } else {
            $('[data-dismiss="slide-panel"]').click();
            bgl.common.pubsub.emit('PollBasket');
        }
        bgl.common.datastore.removeSessionStorage(form);
    }

    function onError(configuration) {
        bgl.components.datepicker.init(configuration);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        init: init,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

bgl.components.bgldatepicker = (function() {
    let configuration;
    let today;
    let tomorrow;
    let calendarSection;
    let form;
    const dateFormat = 'dd/mm/yy';
    let calendarTabsCount;

    function init(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#' + configuration.Id + '_form-cover-range');
        let selectedDate;

        calendarSection = $('#calendar-dates');
        calendarTabsCount = $('.calendar-v2-month-year').length;

        bgl.common.datastore.init(form);
        bgl.common.validator.init(form);

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (!bgl.common.datastore.isDataChanged(form)) {
                        if (configuration.JourneyType === 'MultiStepEdit') {
                            onSuccess();
                        } else {
                            $('[data-dismiss="slide-panel"]').click();
                            bgl.common.datastore.removeSessionStorage(form);
                            return;
                        }
                    }
                    bgl.common.validator.submitForm(form, configuration);
                });

        const datePickerUserSessionData = sessionStorage.getItem('selectedEffectiveDateByUser');
        if (datePickerUserSessionData) {
            selectedDate = new Date(datePickerUserSessionData);
        } else {
            selectedDate = new Date($('.date-picker-v2').data('selected-date'));
        }

        selectDate($('[data-date=\'' + getFormattedValue(selectedDate) + '\']')[0]);
        today = new Date(configuration.DateToday);
        tomorrow = new Date(today.getTime());
        tomorrow.setDate(tomorrow.getDate() + 1);

        $('.date-picker-v2__sub-button--today').on('click', function(e) {
            e.preventDefault();
            showMonthByIndex(0);
            selectDate($('[data-date=\'' + getFormattedValue(today) + '\']')[0]);
        });

        $('.date-picker-v2__sub-button--tomorrow').on('click', function(e) {
            e.preventDefault();
            const monthIndex = tomorrow.getDate() === 1 ? 1 : 0;
            showMonthByIndex(monthIndex);
            selectDate($('[data-date=\'' + getFormattedValue(tomorrow) + '\']')[0]);
        });

        updateSelectedDate(getFormattedValue(selectedDate), configuration.IsService);

        calendarSection.on('click', onClick);
        calendarSection.on('keydown', onKeydown);

        subscribeHeaderNavigationButtons();
        setBackButtonUrl(configuration);
    }

    function getMonthString(num) {
        const months = [
            'January', 'February', 'March', 'April',
            'May', 'June', 'July', 'August',
            'September', 'October', 'November', 'December',
        ];

        const month = months[num];
        if (month) return month;

        return 'Invalid month';
    }

    function updateSelectedDate(dateText, isService) {
        document.getElementById('SelectedEffectiveDate').value = `${dateText} 00:00:00`;
        const dateTime = $.datepicker.parseDate(dateFormat, dateText);
        const isFuture = dateTime > today;
        let text = '';

        if (isService === true) {
            text = isFuture ? 'Cover will start at 00:01 hours' : 'Cover will start with immediate effect';

            const selectedEffectiveDateMessage = isFuture ?
                `Your changes are effective from ${dateText} at 00:01 hours.` :
                'Your changes are effective immediately.';
            sessionStorage.setItem('selectedEffectiveDateMessage', selectedEffectiveDateMessage);

            if (isFuture) {
                sessionStorage.setItem('selectedEffectiveDateByUser', dateTime);
            }
        } else {
            text = isFuture ?
                'Cover will start at 00:01 hours' :
                'Cover will start as soon as you purchase your policy';
        }

        document.getElementById('datePickerSubText').innerHTML = text;
        $('.date-picker-v2__selected-day').html(dateTime.getDate());
        $('.date-picker-v2__selected-month').html(getMonthString(dateTime.getMonth()) + ' ' + dateTime.getFullYear());
    }

    function getFormattedValue(date) {
        return $.datepicker.formatDate(dateFormat, date);
    }

    function setBackButtonUrl(configuration) {
        if (configuration.JourneyType === 'MultiStepEdit') {
            const sessionData = JSON.parse(sessionStorage.getItem(configuration.DataStoreKey));
            if (sessionData != null && sessionData.selectedCoverFlag === 'Comprehensive') {
                $('#back-button-link').attr('href', configuration.CoverExcessesBackUrl);
            }
        }
    }

    function selectDate(date) {
        const selection = calendarSection.find('[aria-current="date"]');

        if (selection) {
            selection.removeAttr('aria-current');
            selection.removeClass('calendar-v2-item--active');
            selection.attr('tabindex', '-1');
        }

        const selectedDate = $(date);
        selectedDate.attr('aria-current', 'date');
        selectedDate.addClass('calendar-v2-item--active');
        selectedDate.removeAttr('tabindex');

        const selected = selectedDate.data('date');

        if (selected) {
            updateSelectedDate(selected, configuration.IsService);
        }
    }

    function onKeydown(event) {
        let parent;
        let next;
        let row;
        let index;

        const target = event.target;
        const key = event.key.replace('Arrow', '');

        if ($(target).hasClass('calendar-v2-item') && key.match(/Up|Down|Left|Right|Home|End|PageUp|PageDown/)) {
            switch (key) {
            case 'Right':
                if (target === getLastDate()) {
                    if (!showNextMonth()) return;
                    next = getFirstDate();
                } else {
                    next = target.nextElementSibling || target.parentElement.nextElementSibling.firstElementChild;
                }

                break;

            case 'Left':
                if (target === getFirstDate()) {
                    if (!showPreviousMonth()) return;
                    next = getLastDate();
                } else {
                    next = target.previousElementSibling ||
                        target.parentElement.previousElementSibling.lastElementChild;
                }

                break;

            case 'Up':
                if (target === getFirstDate()) {
                    showPreviousMonth();
                    next = getLastDate();
                } else {
                    parent = target.parentElement;
                    index = getIndexInCollection(parent.children, target);
                    row = parent.previousElementSibling;

                    if (row) {
                        next = row.children.item(index);
                    }
                }

                break;

            case 'Down':
                if (target === getLastDate()) {
                    showNextMonth();
                    next = getFirstDate();
                } else {
                    parent = target.parentElement;
                    index = getIndexInCollection(parent.children, target);
                    row = parent.nextElementSibling;

                    if (row) {
                        next = row.children.item(index);
                    }
                }

                break;

            case 'Home':
                next = getFirstDate();
                break;

            case 'End':
                next = getLastDate();
                break;

            case 'PageUp':
            case 'PageDown':
                if (key === 'PageUp') {
                    showPreviousMonth();
                    next = getFirstDate();
                } else {
                    showNextMonth();
                    next = getLastDate();
                }

                break;
            }

            event.preventDefault();

            if (next) {
                $(next).focus();
            }
        }
    }

    function getIndexInCollection(collection, element) {
        for (let i = 0; i < collection.length; i++) {
            if (collection[i] === element) {
                return i;
            }
        }

        return -1;
    }

    function getFirstDate() {
        return $('.calendar-month-dates').not('.hide').find('button').first()[0];
    }

    function getLastDate() {
        return $('.calendar-month-dates').not('.hide').find('button').last()[0];
    }

    function showMonthByIndex(index) {
        const monthsSections = $('[data-month-index]');
        monthsSections.not('.hide').addClass('hide');

        $('[data-month-index=\'' + index + '\']').removeClass('hide');
        subscribeHeaderNavigationButtons();
    }

    function showPreviousMonth() {
        let currentMonth = $('[data-month-index]').not('.hide').data('month-index');
        if (currentMonth === 0) {
            return false;
        }

        --currentMonth;
        showMonthByIndex(currentMonth);
        return true;
    }

    function showNextMonth() {
        let currentMonth = $('[data-month-index]').not('.hide').data('month-index');
        if (currentMonth + 1 >= calendarTabsCount) {
            return false;
        }

        ++currentMonth;
        showMonthByIndex(currentMonth);
        return true;
    }

    function subscribeHeaderNavigationButtons() {
        const currentMonth = $('[data-month-index]').not('.hide');

        const previousButton = currentMonth.find('.previous').not('.disabled');
        previousButton.off('click')
            .on('click',
                function(event) {
                    event.preventDefault();
                    if (!showPreviousMonth()) {
                        return;
                    }
                    const next = getLastDate();
                    $(next).focus();
                });

        const nextButton = currentMonth.find('.next').not('.disabled');
        nextButton.off('click')
            .on('click',
                function(event) {
                    event.preventDefault();
                    if (!showNextMonth()) {
                        return;
                    }
                    const next = getFirstDate();
                    $(next).focus();
                });
    }

    function onClick(event) {
        const target = event.target;

        if ($(target).hasClass('calendar-v2-item--unavailable')) {
            return;
        } else {
            selectDate(target);
        }
    }

    function onSuccess() {
        if (configuration.JourneyType === 'MultiStepEdit') {
            if (configuration.IsService) {
                const options = {
                    redirectUrl: configuration.NextStepUrl,
                    hideNotification: true,
                    spinnerName: 'serviceSpinner',
                };
                bgl.common.pubsub.emit('PollBasket', options);
            } else {
                bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
            }
        } else {
            $('[data-dismiss="slide-panel"]').click();
            bgl.common.pubsub.emit('PollBasket');
        }
        bgl.common.datastore.removeSessionStorage(form);
    }

    function onError(configuration) {
        bgl.components.bgldatepicker.init(configuration);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        init: init,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.coverrange;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.yearsbusinessestablished = (function() {
    let configuration;
    let container;
    let form;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        configuration = componentConfiguration;

        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration, containerElementId);
            });
    }

    function initComponent(componentConfiguration, containerId) {
        configuration = componentConfiguration;
        container = containerId;
        form = $('[data-component-id=\'' + configuration.Id + '\'] form');

        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();
        bgl.common.validator.enableMaxLength();
        bgl.common.validator.init(form);

        subscribeToEvents();
    }

    function subscribeToEvents() {
        const continueButton = $(form.find('[type=\'submit\']'));
        continueButton.off('click').on('click', continueHandler);

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    setDataHasChangedFlagForQuestionSet();

                    if (bgl.common.validator.isFormValid(form)) {
                        bgl.common.validator.submitForm(form, configuration);
                    }

                    bgl.components.coverdetails.carriageofdangerousgoods.load();
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);

        if (!isMultiStepEdit()) {
            form.find('#yearsBusinessEstablishedBackBtn').off('click').one('click',
                function(event) {
                    event.preventDefault();

                    const vehicleUseComponentActionUrl = $(this).attr('href');
                    const model = bgl.common.datastore.getData(form);
                    model.ComponentConfiguration = configuration;

                    bgl.components.vehicleusage.load(model, vehicleUseComponentActionUrl, container);
                });
        }
    }

    function continueHandler(event) {
        event.preventDefault();

        form.submit();
    }

    function isMultiStepEdit() {
        const coverDetailsCommon = bgl.components.coverdetails.common;
        return configuration.JourneyType === coverDetailsCommon.journeyTypes.multiStepEdit;
    }

    function onSuccess(result) {
        if (isMultiStepEdit()) {
            location.href = configuration.NextStepUrl;
        } else {
            const dangerousGoodsComponentActionUrl = $('#continueButton').data('action-url');

            bgl.components.coverdetails.carriageofdangerousgoods.load(
                configuration,
                dangerousGoodsComponentActionUrl,
                container,
            );
        }
    }

    function onError() {
        initComponent(configuration);
    }

    function setDataHasChangedFlagForQuestionSet() {
        const vehicleUseSessionData = JSON.parse(sessionStorage.getItem('CoverDetailsVehicleUse'));
        const dataHasChanged = vehicleUseSessionData['DataHasChanged'] === 'True';

        if (dataHasChanged || bgl.common.datastore.isDataChanged(form)) {
            vehicleUseSessionData.DataHasChanged = 'True';
            sessionStorage.setItem('CoverDetailsVehicleUse', JSON.stringify(vehicleUseSessionData));
        }
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.vehicleusage = (function() {
    let configuration;
    let isVan;
    let form;
    const carriageOfOwnGoods = '21';
    const haulage = '22';

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        configuration = componentConfiguration;

        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
            });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        isVan = $('#IsVan').val();
        form = $('[data-component-id="' + configuration.Id + '"] form');

        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();
        bgl.common.validator.init(form);

        subscribeToEvents();

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function subscribeToEvents() {
        if (form.find('input[type=radio]:checked').length === 0) {
            form.find('input[type=radio]')
                .off('keypress', generateClickOnKeypress)
                .on('keypress', generateClickOnKeypress)
                .off('click', continueHandler)
                .on('click', function(event) {
                    $(this).focusout();
                    submitForm();
                });
        } else {
            const continueButton = $(form.find('[type="submit"]'));
            continueButton.removeClass('hide');
            continueButton.off('click').on('click', continueHandler);
        }

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    setDataHasChangedFlagForQuestionSet();

                    if (isVan === 'True') {
                        vanNavigation();
                    } else {
                        if (bgl.common.validator.isFormValid(form)) {
                            bgl.common.validator.submitForm(form, configuration);
                        }
                    }
                });
    }

    function submitForm() {
        form.submit();
    }

    function onSuccess(componentConfiguration) {
        location.href = componentConfiguration.NextStepUrl;
    }

    function generateClickOnKeypress(event) {
        const code = event.charCode || event.keyCode;
        if (code === 13 || code === 32) {
            $(this).click();
        }
    }

    function continueHandler(event, element) {
        event.preventDefault();

        if (bgl.common.datastore.isDataChanged(form)) {
            submitForm();
        } else {
            if (isVan === 'True') {
                vanNavigation();
            } else {
                location.href = configuration.NextStepUrl;
            }
        }
    }

    function vanNavigation() {
        const vehicleUsage = $('input[name=ClassOfUseCode]:checked', '#vehicle-usage').val();
        if (typeof bgl.common.pubsub !== 'undefined') {
            bgl.common.pubsub.emit('fakeFormSubmit', 'VehicleUsage');
        }
        if (vehicleUsage === carriageOfOwnGoods || vehicleUsage === haulage) {
            bgl.common.utilities.redirectToUrl(configuration.YearsBusinessEstablishedUrl);
        } else {
            bgl.common.utilities.redirectToUrl(configuration.CarriageOfDangerousGoodsUrl);
        }
    }

    function setDataHasChangedFlagForQuestionSet() {
        const vehicleUseSessionData = JSON.parse(sessionStorage.getItem('CoverDetailsVehicleUse'));

        if (bgl.common.datastore.isDataChanged(form)) {
            vehicleUseSessionData.DataHasChanged = 'True';
            sessionStorage.setItem('CoverDetailsVehicleUse', JSON.stringify(vehicleUseSessionData));
        }
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.sameaddress = (function() {
    let form;
    let configuration;
    let container;
    let registerKeeper;
    let continueButton;
    const SPACE_KEYCODE = 32;
    const ENTER_KEYCODE = 13;

    function initComponent(componentConfiguration, containerId) {
        initElements(componentConfiguration, containerId);

        registerKeeper.redirectIfSessionStorageIsNotFound(form, componentConfiguration.ParentJourneyUrl);

        subscribeForEvents();

        registerKeeper.updateHeading(form);

        registerKeeper.displaySubmitButton(form);
    }

    function loadComponent(config, url, containerId) {
        bgl.common.loader.load(config,
            url,
            containerId,
            function() {
                initComponent(config, containerId);
            });
    }

    function onMultiStepEditSuccess(configuration, data) {
        registerKeeper.clearOtherOptionFields(form);

        const registeredKeeperData = {RegisteredKeeperId: data.registeredKeeperId};

        bgl.common.datastore.extendCollectedData(form, registeredKeeperData);
        bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
    }

    function onSuccess(configuration, data) {
        registerKeeper.clearOtherOptionFields(form);
        bgl.components.coverdetails.registeredkeeper.load(configuration, data.nextUrl, container, true);
    }

    function onError() {
        initComponent(configuration);
    }

    function initElements(componentConfiguration, containerId) {
        configuration = componentConfiguration;
        form = $('#same-address-form');
        continueButton = $('#continueButton');
        container = containerId;
        registerKeeper = bgl.components.coverdetails.registeredkeeper;
    }

    function subscribeForEvents() {
        bgl.common.validator.init(form);
        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();

        $('input[type="radio"]')
            .off('click')
            .off('keypress')
            .on({
                'keypress': function(e) {
                    if (e.keyCode === ENTER_KEYCODE || e.keyCode === SPACE_KEYCODE) {
                        $(this).click();
                    }
                },
                'click': function(event) {
                    registerKeeper.submitForm(form);
                },
            });

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    continueButton.attr('disabled', true);
                    if (bgl.common.validator.isFormValid(form)) {
                        const hasOwnData = form.data('hasOwnData');

                        bgl.common.validator.submitForm(form, configuration, hasOwnData ? getStoredData() : null);
                    } else {
                        continueButton.attr('disabled', false);
                    }
                });

        form.find('.back-button-link').off('click').one('click',
            function(event) {
                event.preventDefault();

                const url = $(this).attr('href');

                bgl.components.coverdetails.maritalstatus.load(configuration, url, container);
            });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function getStoredData() {
        const data = getDataToPost();
        const formData = form.serialize();

        return formData + '&' + $.param(data);
    }

    function getDataToPost() {
        const data = bgl.common.datastore.getData(form);
        const config = {ComponentConfiguration: configuration};

        $.extend(data, config);

        return data;
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
        onMultiStepEditSuccess: onMultiStepEditSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.relationshipstatus = (function() {
    let form;
    let configuration;
    let container;
    let registerKeeper;
    const SPACE_KEYCODE = 32;
    const ENTER_KEYCODE = 13;

    function initComponent(componentConfiguration, containerId) {
        initElements(componentConfiguration, containerId);

        subscribeForEvents();

        registerKeeper.displaySubmitButton(form);
    }

    function loadComponent(config, url, containerId) {
        bgl.common.loader.load(config,
            url,
            containerId,
            function() {
                initComponent(config, containerId);
            });
    }

    function initElements(componentConfiguration, containerId) {
        configuration = componentConfiguration;
        form = $('#relationship-status-form');
        container = containerId;
        registerKeeper = bgl.components.coverdetails.registeredkeeper;
    }

    function subscribeForEvents() {
        bgl.common.validator.init(form);
        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();

        form.find('input[type="radio"]')
            .off('click')
            .off('keypress')
            .on({
                'keypress': function(e) {
                    if (e.keyCode === ENTER_KEYCODE || e.keyCode === SPACE_KEYCODE) {
                        $(this).click();
                    }
                },
                'click': function(event) {
                    registerKeeper.submitForm(form);
                },
            });

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();
                    if (bgl.common.validator.isFormValid(form)) {
                        bgl.common.validator.submitForm(form, configuration);
                    }
                });

        form.find('.back-button-link').off('click').one('click',
            function(event) {
                event.preventDefault();

                const url = $(this).attr('href');

                bgl.components.coverdetails.registeredkeeper.load(configuration, url, container);
            });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function onMultiStepEditSuccess(configuration, data) {
        bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
    }

    function onSuccess(configuration, data) {
        bgl.components.coverdetails.aboutyou.load(configuration, data.nextUrl, container);
    }

    function onError() {
        initComponent(configuration, container);
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
        onMultiStepEditSuccess: onMultiStepEditSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.registeredkeeper = (function() {
    let form;
    let configuration;
    let container;
    let continueButton;
    let typeInput;
    let triggerPollBasket;
    let companyKeeper;
    let coverDetailsCommon;
    const HIDDEN_CLASS = 'hide';
    const SPACE_KEYCODE = 32;
    const ENTER_KEYCODE = 13;

    function initComponent(componentConfiguration, containerId, callPollBasket) {
        initElements(componentConfiguration, containerId, callPollBasket);

        showCompanyName();

        subscribeForEvents();

        displaySubmitButton(form);
    }

    function loadComponent(config, url, containerId, callPollBasket) {
        bgl.common.loader.load(configuration,
            url,
            container,
            function() {
                initComponent(config, containerId, callPollBasket);
            });
    }

    function onSuccess(configuration, data) {
        if (data.nextUrl) {
            bgl.components.coverdetails.relationshipstatus.load(configuration, data.nextUrl, container);
        } else {
            closeSlidePanelAndTriggerUnderwriting(true);
        }

        clearOtherOptionFields(form);
    }

    function onMultiStepEditSuccess(configuration, data) {
        const url = data.nextUrl || configuration.NextStepUrl;

        bgl.common.utilities.redirectToUrl(url);

        clearOtherOptionFields(form);
    }

    function onError() {
        continueButton.removeAttr('disabled');
        bgl.components.coverdetails.registeredkeeper.init(configuration);
    }

    function clearOtherOptionFields(componentForm) {
        const fieldsToRemove = [
            'Title', 'DateOfBirth', 'LastName', 'HasSameAddress',
            'FirstName', 'RelationshipStatusCode', 'MaritalStatusCode',
        ];

        bgl.common.datastore.deleteFields(componentForm, fieldsToRemove);
    }

    function redirectIfSessionStorageIsNotFound(componentForm, parentJourneyUrl) {
        const data = bgl.common.datastore.getData(componentForm);

        if (!data || !data['RelationshipStatusCode']) {
            bgl.common.utilities.redirectToUrl(parentJourneyUrl);
        }
    }

    function initElements(componentConfiguration, containerId, callPollBasket) {
        configuration = componentConfiguration;
        form = $('#' + configuration.Id + '_form-registered-keeper');
        continueButton = form.find('#ContinueButton');
        container = containerId;
        coverDetailsCommon = bgl.components.coverdetails.common;
        typeInput = form.find('#Type');
        companyKeeper = form.find('#company-keeper');
        triggerPollBasket = callPollBasket;
    }

    function subscribeForEvents() {
        bgl.common.validator.init(form);
        bgl.common.validator.enableMaxLength();
        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    continueButton.attr('disabled', true);

                    if (!bgl.common.validator.isFormValid(form)) {
                        continueButton.removeAttr('disabled');
                        return;
                    }

                    const isSingleEdit = configuration.JourneyType === coverDetailsCommon.journeyTypes.singleEdit;

                    if (isSingleEdit && !bgl.common.datastore.isDataChanged(form)) {
                        closeSlidePanelAndTriggerUnderwriting(triggerPollBasket);
                        return;
                    }

                    bgl.common.validator.submitForm(form, configuration);
                });

        form.find('input[type="radio"]')
            .off('click')
            .off('keypress')
            .on({
                'keypress': function(e) {
                    if (e.keyCode === ENTER_KEYCODE || e.keyCode === SPACE_KEYCODE) {
                        $(this).click();
                    }
                },
                'click': function(event) {
                    const keeperType = $(this).attr('data-keeper-type');
                    registerKeeperOptionClickHandler(keeperType);
                },
            });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function updateContinueButtonValue() {
        if (configuration.JourneyType !== coverDetailsCommon.journeyTypes.multiStepEdit) {
            continueButton.val('Done');
        }
    }

    function showCompanyName() {
        const data = bgl.common.datastore.getData(form);

        if (data) {
            switch (data.RegisteredKeeperId) {
            case 'company':
                companyKeeper.removeClass(HIDDEN_CLASS);
                typeInput.val('O');
                break;
            case 'soleTrader':
                companyKeeper.removeClass(HIDDEN_CLASS);
                typeInput.val('B');
                break;
            case 'partnership':
                companyKeeper.removeClass(HIDDEN_CLASS);
                typeInput.val('A');
                break;
            }
        }
    }

    function registerKeeperOptionClickHandler(keeperType) {
        const companyName = $('#CompanyName');

        switch (keeperType) {
        case 'P':
            companyKeeper.addClass(HIDDEN_CLASS);
            companyName.val('').focusout();
            typeInput.val('P');
            form.change();
            updateContinueButtonValue();
            submitForm(form);
            break;

        case 'O':
            companyKeeper.removeClass(HIDDEN_CLASS);
            typeInput.val('O');
            companyName.val('').focusout();
            continueButton.removeClass(HIDDEN_CLASS);
            updateContinueButtonValue();
            break;

        case 'B':
            companyKeeper.removeClass(HIDDEN_CLASS);
            typeInput.val('B');
            companyName.val('').focusout();
            continueButton.removeClass(HIDDEN_CLASS);
            updateContinueButtonValue();
            break;

        case 'A':
            companyKeeper.removeClass(HIDDEN_CLASS);
            typeInput.val('A');
            companyName.val('').focusout();
            continueButton.removeClass(HIDDEN_CLASS);
            updateContinueButtonValue();
            break;

        case 'Other':
            companyKeeper.addClass(HIDDEN_CLASS);
            companyName.val('');
            typeInput.val('Other');
            continueButton.val('Continue');
            submitForm(form);
            break;
        }
    }

    function submitForm(form) {
        const submitButton = form.find(':submit');

        if (submitButton.hasClass(HIDDEN_CLASS)) {
            form.change().submit();
        }
    }

    function displaySubmitButton(form) {
        if (form.find('[type=\'radio\']:checked').length) {
            form.find(':submit').removeClass(HIDDEN_CLASS);
        }
    }

    function updateHeading(form) {
        const data = bgl.common.datastore.getData(form);

        if (data) {
            const heading = form.find('#heading');
            const text = heading.html();

            heading.html(text.replace('{FirstName}', data.FirstName));
        }
    }

    function closeSlidePanelAndTriggerUnderwriting(triggerPollBasket) {
        bgl.common.datastore.removeSessionStorage(form);
        $('[data-dismiss="slide-panel"]').click();

        if (triggerPollBasket) {
            bgl.common.pubsub.emit('PollBasket');
        }
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
        onMultiStepEditSuccess: onMultiStepEditSuccess,
        onError: onError,
        displaySubmitButton: displaySubmitButton,
        submitForm: submitForm,
        updateHeading: updateHeading,
        clearOtherOptionFields: clearOtherOptionFields,
        redirectIfSessionStorageIsNotFound: redirectIfSessionStorageIsNotFound,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.productvariantswitch = (function() {
    let configuration;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        setupSwitchVariantButton();
    }

    function setupSwitchVariantButton() {
        const button = document.getElementById(configuration.ButtonId);
        button.addEventListener('click', function() {
            const form = document.getElementById(configuration.Id + '__form');
            bgl.common.validator.submitForm(form, configuration);
        });
    }

    function onSuccess() {
        const params = {
            callback: function() {
                if (configuration.SucessPageUrl) {
                    bgl.common.utilities.redirectToUrl(configuration.SucessPageUrl);
                } else {
                    bgl.common.utilities.refreshPage();
                }
            },
            spinnerName: 'addonSpinner',
        };

        bgl.common.pubsub.emit('PollBasket', params);
    }
    function onError() {
        bgl.common.utilities.errorRedirect(configuration.ErrorPageUrl);
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.productvariants = (function() {
    const SPACE_KEYCODE = 32;
    const ENTER_KEYCODE = 13;
    let configuration;
    let table;
    let componentContainer;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        componentContainer = document.getElementById(configuration.Id);

        handleNoVariantsAvailable();

        table = componentContainer.querySelector('table[data-product-variants-table]');

        addSelectVariantButtonClickEvent();
        addFeatureHelpButtonEvents();

        if (configuration.RowBuilder === 1) {
            updateAddonHelpButtonLinks();
        }

        addContinueButtonClickEvent();
        setInitialVariantCodeToSessionStorage();
        setupUpdateQuestionButtons();
        setupUpsellPopup();

        sessionStorage.setItem('ComparisonTablePageLoaded', 'true');
        sessionStorage.setItem('UpdateUpgradeQuestion', 'false');
    }

    function handleNoVariantsAvailable() {
        const noVariantsAvailable = componentContainer.querySelector('[data-no-variants-available]');
        if (noVariantsAvailable) {
            bgl.common.utilities.redirectToUrl(configuration.PreviousPageUrl);
        }
    }

    function setupUpsellPopup() {
        const selectedVariant = componentContainer.querySelector('input[data-selected-variant-code]').value;
        const listItems =
            [...componentContainer.querySelectorAll(`li[data-for-variants*="${selectedVariant}"]`)];
        listItems.forEach((item) => {
            item.classList.remove('hide');
        });

        const popupHideLink = componentContainer.querySelector('[id="popup-hide-link"]');
        if (popupHideLink) {
            popupHideLink.addEventListener('click', hidePopup);
        }
    }

    function hidePopup() {
        componentContainer.querySelector('[id="top-tier-saving-popup"]').classList.add('hide');
    }

    function addContinueButtonClickEvent() {
        const button = componentContainer.querySelector('[data-continue-button]');
        if (button) {
            button.addEventListener('click', function(e) {
                const questionAnswered = componentContainer
                    .querySelectorAll('[data-upgrade-question-radio-button]:checked')
                    .length === 1;
                if (questionAnswered) {
                    const upsellModalSeen = sessionStorage.getItem('upsell-modal-seen-comparison-table');
                    const showTopTierUpsellPopup =
                        componentContainer.querySelector('[id="ShowTopTierUpsellPopup"]').value === 'True';

                    if (configuration.ShowUpsellPopup && showTopTierUpsellPopup && !upsellModalSeen) {
                        componentContainer.querySelector('[id="top-tier-saving-popup"]').classList.remove('hide');
                        sessionStorage.setItem('upsell-modal-seen-comparison-table', 'true');
                    } else {
                        bgl.common.utilities.redirectToUrl(configuration.NextPageUrl);
                    }
                } else {
                    componentContainer.querySelector('[data-variant-upgrade-question-validation]')
                        .classList.remove('hide');
                    const upgradeQuestionPanel = componentContainer.querySelector('[data-upgrade-question-panel]');
                    if (upgradeQuestionPanel) {
                        upgradeQuestionPanel.classList.remove('border-white');
                        upgradeQuestionPanel.classList.add('border-error');
                    }
                }
            });
        }
    }

    function addFeatureHelpButtonEvents() {
        const container = document.querySelector(`#${configuration.Id}`);
        if (!container) return;

        container.querySelectorAll('[data-further-information-button]')
            .forEach((link) => {
                link.addEventListener('keyup', (event) => {
                    const code = event.charCode || event.keyCode;
                    if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
                        event.currentTarget.click();
                    }
                });

                link.addEventListener('click', (event) => {
                    const contenturl = event.currentTarget.getAttribute('data-content-url');
                    const targetContainer = event.currentTarget.getAttribute('data-container');

                    bgl.common.loader.load(configuration, contenturl, targetContainer);
                });
            });
    }
    function addSelectVariantButtonClickEvent() {
        document.querySelectorAll('[data-select-variant-button]')
            .forEach((button) => {
                button.addEventListener('click', function(e) {
                    if (!e.currentTarget.classList.contains('active')) {
                        const tier = e.currentTarget.getAttribute('data-tier');

                        setButtonText('Select');
                        table.querySelectorAll('.active')
                            .forEach((activeElement) => {
                                activeElement.classList.remove('active');
                            });

                        table.querySelectorAll('[data-tier="' + tier + '"]')
                            .forEach((selectedTierElement) => {
                                selectedTierElement.classList.add('active');
                            });

                        e.currentTarget.textContent = 'Selecting';

                        componentContainer.querySelector('[id="VariantCode"]').value =
                            e.currentTarget.getAttribute('data-variant-code');

                        componentContainer.querySelector('[id="Description"]').value =
                            e.currentTarget.getAttribute('data-variant-description');

                        const form = componentContainer.querySelector(`[id="${configuration.Id}__form"]`);
                        bgl.common.validator.submitForm(form, configuration);
                        toggleLinks(true);
                    }
                });
            });
        componentContainer.querySelectorAll('[data-upgrade-question-button]')
            .forEach((button) => {
                button.addEventListener('click', function(event) {
                    event.preventDefault();
                    sessionStorage.setItem('UpdateUpgradeQuestion', 'true');
                    componentContainer.querySelector(`[id="${button.getAttribute('for')}"]`).checked = true;
                    const code = event.currentTarget.getAttribute('data-variant-code');
                    if (code) {
                        const selectVariantButtonInTable = componentContainer.querySelector(
                            `[data-select-variant-button][data-variant-code="${code}"]`);
                        if (selectVariantButtonInTable) {
                            selectVariantButtonInTable.click();
                        }
                    }
                });
            });
    }

    function setButtonText(text) {
        table.querySelector('button.active').textContent = text;
    }

    function successCallback(houstonMessage) {
        const notification = JSON.stringify({
            cat: 'pricechange',
            msg: houstonMessage,
        });
        sessionStorage.setItem('notification', notification);
        bgl.common.utilities.refreshPage();
    }

    function onSuccess(configuration, data) {
        bgl.common.pubsub.emit('animateBasket');

        if (data.houstonMessage) {
            const params = {
                callback: function() {
                    successCallback(data.houstonMessage);
                },
                spinnerName: 'addonSpinner',
            };

            bgl.common.pubsub.emit('PollBasket', params);
        } else {
            bgl.common.pubsub.emit('PollBasket');
        }
    }

    function toggleLinks(disabled) {
        const elements = document.querySelectorAll(
            'button, a, select, input, label, [data-tier], .shopping-basket, #Houston');
        elements.forEach((element) => {
            if (!element.hasAttribute('data-further-information-button')) {
                if (disabled === true) {
                    element.classList.add('disabled');
                    element.setAttribute('disabled', disabled);
                } else {
                    element.classList.remove('disabled');
                    element.removeAttribute('disabled');
                };
            }
        });
    }

    function updateAddonHelpButtonLinks() {
        const isPremier = document.querySelector('[data-tier="2"]').classList.contains('active');
        const container = document.querySelector(`#${configuration.Id}`);
        if (!container) return;

        const addonHelpButtons = container.querySelectorAll('[data-further-information-button]');
        addonHelpButtons.forEach((button) => {
            const coverKey = button.getAttribute('data-cover-key');
            let contentUrl;
            if (isPremier) {
                contentUrl = configuration.CoverFeaturePriority[coverKey].ContentUrlPremier;
            } else {
                contentUrl = configuration.CoverFeaturePriority[coverKey].ContentUrl;
            }

            button.setAttribute('data-content-url', contentUrl);
        });
    }

    function setupUpdateQuestionButtons() {
        setUpgradeButtonSelection();
    }

    function setUpgradeButtonSelection() {
        getUpgradeQuestionButtons().forEach((button) => {
            const buttonVariantCode = button.getAttribute('data-variant-code');
            if (thisIsCurrentlySelectedVariant(buttonVariantCode)) {
                if ((thisIsVariantCodeInSessionStorage(buttonVariantCode) &&
                    thisButtonShouldDefaultIfVariantSelected(button)) ||
                    thisPageHasBeenLoadedAlready() &&
                    thisButtonShouldDefaultIfVariantSelected(button) ||
                    updateUpgradeQuestion()) {
                    componentContainer.querySelector(`[id="${button.getAttribute('for')}"]`).checked = true;
                }
            }
        });
    }

    function getUpgradeQuestionButtons() {
        return componentContainer.querySelectorAll('[data-upgrade-question-button]');
    }

    function updateUpgradeQuestion() {
        return sessionStorage.getItem('UpdateUpgradeQuestion') === 'true';
    }

    function thisPageHasBeenLoadedAlready() {
        const result = sessionStorage.getItem('ComparisonTablePageLoaded') === 'true';
        return result;
    }

    function thisIsVariantCodeInSessionStorage(variantCode) {
        return variantCode === getInitialVariantCodeFromSessionStorage();
    }

    function thisIsCurrentlySelectedVariant(variantCode) {
        return variantCode === componentContainer.querySelector('input[data-selected-variant-code]').value;
    }

    function thisButtonShouldDefaultIfVariantSelected(button) {
        return button.getAttribute('data-default-button') === 'True';
    }

    function setInitialVariantCodeToSessionStorage() {
        const variantCodeElement = componentContainer.querySelector('input[data-selected-variant-code]');
        const storedVariantCode = getInitialVariantCodeFromSessionStorage();
        if (variantCodeElement && storedVariantCode == null) {
            sessionStorage.setItem('selectedVariantCode', variantCodeElement.value);
        }
    }

    function getInitialVariantCodeFromSessionStorage() {
        return sessionStorage.getItem('selectedVariantCode');
    }

    function onError() {
        toggleLinks(false);
        bgl.components.coverdetails.productvariants.init(configuration);
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿/* eslint-disable indent */
// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.policybenefits = (function() {
    let configuration;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        subscribeToPolicyBenefitsEvents();
    }
    function subscribeToPolicyBenefitsEvents() {
        const container = document.querySelector(`#${configuration.Id}`);
        const expandableItems = container.querySelectorAll('[data-policy-benefit-expandable-item]');
        const seeMoreButton = document.querySelector(`#${configuration.Id}-see-more-button`);
        const seeMoreButtonTextElement = seeMoreButton.querySelector(`#${configuration.Id}-see-more-text`);
        const seeMoreIcon = document.querySelector(`#${configuration.Id}-see-more-icon`);

        if (seeMoreButton) {
            seeMoreButton.addEventListener('click', (e) => {
                if (container.getAttribute('data-expanded').toLowerCase() == 'true') {
                    container.setAttribute('data-expanded', 'false');
                    expandableItems.forEach((item) => {
                        item.classList.add('hide');
                        item.setAttribute('aria-expanded', 'false');
                    });
                    seeMoreButton.setAttribute('aria-expanded', 'false');
                    seeMoreButtonTextElement.textContent = 'See all benefits';
                    seeMoreIcon.style.transform = 'rotate(0deg)';
                } else {
                    container.setAttribute('data-expanded', 'true');
                    expandableItems.forEach((item) => {
                        item.classList.remove('hide');
                        item.setAttribute('aria-expanded', 'true');
                    });
                    seeMoreButton.setAttribute('aria-expanded', 'true');
                    seeMoreButtonTextElement.textContent = 'See less benefits';
                    seeMoreIcon.style.transform = 'rotate(180deg)';
                }
            });
        }
    }

    return {
        init: initComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.othervehicles = (function() {
    let form;
    let configuration;
    let continueButton;

    function initComponent(componentConfiguration) {
        const isNcdQuestionRemoved = componentConfiguration.IsNcdQuestionRemoved;

        configuration = componentConfiguration;
        form = $('#' + configuration.Id + '__other-vehicles-form');
        continueButton = $('#Continue-Button');

        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();
        bgl.common.validator.init(form);

        if (!isNcdQuestionRemoved) {
            subscribeForEvents();
            initElements();
        } else {
            initWithoutNcdQuestion();
        }

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function initWithoutNcdQuestion() {
        showContinue();

        form.find('#Vehicle-Use-Yes, #Vehicle-Use-No').on('click',
            function(e) {
                if (continueButton.hasClass('hide')) {
                    form.change().submit();
                }
            });

        subscribeForSubmit();
    }

    function initElements() {
        form.find('#Vehicle-Use-Yes, #Other-Vehicle-Yes').each(function(index, element) {
            const sections = $(element).data('sections');

            if ($(element).prop('checked')) {
                $(sections).removeClass('hide');
            }
        });

        showContinue();
    }

    function showContinue() {
        if (form.find('input[type=\'radio\']:checked').length) {
            continueButton.removeClass('hide');
        }
    }

    function subscribeForEvents() {
        form.find('#Vehicle-Use-Yes, #Other-Vehicle-Yes').on('click',
            function(e) {
                const sections = $(this).data('sections');

                $(sections).removeClass('hide');
            });

        form.find('#Vehicle-Use-No, #Other-Vehicle-No').on('click',
            function(e) {
                const sections = $(this).data('sections');

                $(sections).addClass('hide');

                deleteFields(sections);

                if (continueButton.hasClass('hide')) {
                    form.change().submit();
                }
            });

        subscribeForSubmit();
    }

    function subscribeForSubmit() {
        form.off('submit').on('submit',
            function(event) {
                event.preventDefault();

                if (bgl.common.validator.isFormValid(form)) {
                    if (bgl.common.datastore.isDataChanged(form)) {
                        const data = getStoredData();

                        bgl.common.validator.submitForm(form, configuration, data);
                    } else {
                        onSuccess();
                    }
                }
            });
    }

    function deleteFields(sections) {
        const elements = $(sections).removeClass('error').find('[data-store]');
        let dropdownKey;

        const fieldsToDelete = $.map(elements,
            function(element) {
                const elementName = $(element).attr('name');

                if ($(element).is('select')) {
                    $(element).val('');
                    dropdownKey = elementName;
                } else if ($(element).is('input')) {
                    $(element).prop('checked', false);
                }

                return elementName;
            });

        if (dropdownKey) {
            fieldsToDelete.push(dropdownKey + 'Text', dropdownKey + 'Val');
        }

        bgl.common.datastore.deleteFields(form, fieldsToDelete);
    }

    function getStoredData() {
        const data = bgl.common.datastore.getData(form) || {};
        const formData = form.serialize();

        return formData + '&' + $.param(data);
    }

    function onSuccess() {
        bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
    }

    function onError() {
        initComponent(configuration);
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.ncdyears = (function() {
    let configuration;
    let form;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        configuration = componentConfiguration;

        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
            });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('[data-component-id=\'' + configuration.Id + '\'] form');

        bgl.common.datastore.init(form, false);
        bgl.common.datastore.setupReadAndWrite();
        bgl.common.validator.init(form);

        subscribeToEvents();
    }

    function subscribeToEvents() {
        if (form.find('input[type=radio]:checked').length === 0) {
            form.find('input[type=radio]')
                .off('keypress', generateClickOnKeypress)
                .on('keypress', generateClickOnKeypress)
                .off('click', continueHandler)
                .on('click', function(event) {
                    $(this).focusout();
                    form.change();
                    continueHandler(event);
                });
        } else {
            const continueButton = $(form.find('[type=\'submit\']'));
            continueButton.removeClass('hide');
            continueButton.off('click').on('click', continueHandler);
        }

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);

        const ncdYearsSessionData = JSON.parse(sessionStorage.getItem('NcdYears'));
        const isVan = ncdYearsSessionData['IsVan'];

        if (isVan === 'True') {
            $('#noclaimsdiscountyearsbackbtn').attr('href', configuration.CarriageOfDangerousGoodsUrl);
        }
    }

    function generateClickOnKeypress(event) {
        const code = event.charCode || event.keyCode;
        if (code === 13 || code === 32) {
            $(this).click();
        }
    }

    function continueHandler(event, element) {
        event.preventDefault();
        const submitButton = form.find(':submit');
        submitButton.attr('disabled', 'disabled');

        if (bgl.common.validator.isFormValid(form)) {
            $('#HasChanges').val(bgl.common.datastore.isDataChanged(form) === true);
            bgl.common.validator.submitForm(form, configuration);
        } else {
            submitButton.removeAttr('disabled');
        }
    }

    function onSuccess(configuration, data) {
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: false});

        if (data.isNeedToDeleteNcdSource === true && configuration.DataStoreKeyForNcdSourcePage) {
            bgl.common.datastore.deleteFields(configuration.DataStoreKeyForNcdSourcePage, ['NcdSourceCode']);
        }

        bgl.common.utilities.redirectToUrl(data.nextPageUrl);
    }

    function onError() {
        bgl.components.coverdetails.ncdyears.init(configuration);
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.ncdsource = (function() {
    let configuration;
    let form;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#ncd-source-form');

        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();
        bgl.common.validator.init(form);

        subscribeToEvents();
    }

    function subscribeToEvents() {
        form.off('submit').on('submit',
            function(event) {
                event.preventDefault();

                if (bgl.common.validator.isFormValid(form)) {
                    if (bgl.common.datastore.isDataChanged(form)) {
                        bgl.common.validator.submitForm(form, configuration);
                    } else {
                        onSuccess();
                    }
                }
            });
    }

    function onSuccess() {
        bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
    }

    function onError() {
        bgl.components.coverdetails.ncdsource(configuration);
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.maritalstatus = (function() {
    let form;
    let configuration;
    let container;
    let registerKeeper;
    const SPACE_KEYCODE = 32;
    const ENTER_KEYCODE = 13;

    function initComponent(componentConfiguration, containerId) {
        initElements(componentConfiguration, containerId);

        registerKeeper.redirectIfSessionStorageIsNotFound(form, componentConfiguration.ParentJourneyUrl);

        subscribeForEvents();

        registerKeeper.updateHeading(form);

        registerKeeper.displaySubmitButton(form);
    }

    function loadComponent(config, url, containerId) {
        bgl.common.loader.load(config,
            url,
            containerId,
            function() {
                initComponent(config, containerId);
            });
    }

    function onMultiStepEditSuccess(configuration, data) {
        bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
    }

    function onSuccess(configuration, data) {
        bgl.components.coverdetails.sameaddress.load(configuration, data.nextUrl, container);
    }

    function onError() {
        initComponent(configuration, container);
    }

    function initElements(componentConfiguration, containerId) {
        configuration = componentConfiguration;
        container = containerId;
        form = $('#marital-status-form');
        registerKeeper = bgl.components.coverdetails.registeredkeeper;
    }

    function subscribeForEvents() {
        bgl.common.validator.init(form);
        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();
                    if (bgl.common.validator.isFormValid(form)) {
                        bgl.common.validator.submitForm(form, configuration);
                    }
                });

        $('[id$=marital-status]')
            .off('click')
            .off('keypress')
            .on({
                'keypress': function(e) {
                    if (e.keyCode === ENTER_KEYCODE || e.keyCode === SPACE_KEYCODE) {
                        $(this).click();
                    }
                },
                'click': function(event) {
                    registerKeeper.submitForm(form);
                },
            });

        form.find('.back-button-link').off('click').one('click',
            function(event) {
                event.preventDefault();

                const url = $(this).attr('href');

                bgl.components.coverdetails.aboutyou.load(configuration, url, container);
            });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
        onMultiStepEditSuccess: onMultiStepEditSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.maindriver = (function() {
    let configuration;
    let form;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        configuration = componentConfiguration;

        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
            });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#main-driver');

        bgl.common.validator.init(form);
        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();
        if (form.find('input[type=radio]:checked').length === 0) {
            form.find('input[type=radio]')
                .off('keypress', generateClickOnKeypress)
                .on('keypress', generateClickOnKeypress)
                .off('click', continueHandler)
                .on('click',
                    function(event) {
                        $(this).focusout();
                        submitForm();
                    });
        } else {
            const continueButton = $(form.find('[type=\'submit\']'));
            continueButton.removeClass('hide');
            continueButton.off('click').on('click', continueHandler);
        }

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();
                    if (bgl.common.validator.isFormValid(form)) {
                        bgl.common.validator.submitForm(form, configuration);
                    }
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function submitForm() {
        form.submit();
    }

    function generateClickOnKeypress(event) {
        const code = event.charCode || event.keyCode;
        if (code === 13 || code === 32) {
            $(this).click();
        }
    }

    function onSuccess(componentConfiguration) {
        location.href = componentConfiguration.NextStepUrl;
    }

    function continueHandler(event, element) {
        event.preventDefault();
        if (bgl.common.datastore.isDataChanged(form)) {
            submitForm();
        }
        location.href = configuration.NextStepUrl;
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.features = (function() {
    let configuration;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        subscribeToDesktopFeaturesEvents();
        subscribeToMobileFeaturesEvents();
    }

    function subscribeToDesktopFeaturesEvents() {
        const featureBannerButton = document.getElementById(`${configuration.Id}_feature-banner-button`);
        const featureCardContainer = document.getElementById(`${configuration.Id}-card-container`);

        featureBannerButton.onclick = function() {
            if (featureCardContainer.classList.contains('is-active')) {
                featureCardContainer.classList.remove('is-active');
                featureBannerButton.setAttribute('aria-expanded', 'false');
                featureBannerButton.innerText = 'View more features';
            } else {
                featureCardContainer.classList.add('is-active');
                featureBannerButton.setAttribute('aria-expanded', 'true');
                featureBannerButton.innerText = 'View less features';
            }
        };
    }

    function subscribeToMobileFeaturesEvents() {
        const featureListToggleButton = document.getElementById(`${configuration.Id}-toggle-button`);
        const featureList = document.getElementById('policy-feature-list');
        const featureListIcon = document.getElementById('policy-feature-list-icon');

        featureListToggleButton.onclick = function() {
            if (featureList.classList.contains('hide')) {
                featureListToggleButton.setAttribute('aria-expanded', 'true');
                featureList.classList.remove('hide');
                featureListIcon.style.transform = 'rotate(180deg)';
                featureListToggleButton.innerText = 'Show me less features';
            } else {
                featureListToggleButton.setAttribute('aria-expanded', 'false');
                featureList.classList.add('hide');
                featureListIcon.style.transform = 'rotate(0deg)';
                featureListToggleButton.innerText = 'Show me even more features';
            }
        };
    }

    return {
        init: initComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.coverpanelrenewal = (() => {
    const initComponent = () => {
        const featureButtons = document.querySelectorAll('[data-renewals-included-panel] button');
        const seeMoreButton = document.querySelector('[data-see-more-features]');

        if (featureButtons.length < 6) {
            seeMoreButton.classList.toggle('hide');
        }

        const excessFeatureButtonsArray = [...featureButtons].slice(6);
        excessFeatureButtonsArray.forEach((featureButton) => {
            featureButton.classList.toggle('hide');
        });

        seeMoreButton.addEventListener('click', () => {
            excessFeatureButtonsArray.forEach((featureButton) => {
                featureButton.classList.toggle('hide');
            });

            featureButtons[6].focus();
            seeMoreButton.querySelector('i').classList.toggle('cover-details-panel--open');
            const buttonText = seeMoreButton.querySelector('span');
            buttonText.innerText = buttonText.innerText.toLowerCase() === 'see more features' ?
                'show less features' :
                'see more features';
        });
    };

    return {
        init: initComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.coverlevel = (function() {
    let configuration; let form;
    let selectedCoverFlag;
    let sessionData;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;

        initValidation();

        toggleCoverLevelText();

        $('#BtnSubmit').off('click').on('click',
            function() {
                sessionData = bgl.common.datastore.getData(configuration.DataStoreKey);
                if (!sessionData.selectedCoverFlag && !sessionData.CoverLevelCode) {
                    $('#validation-message').show();
                    return false;
                } else {
                    submitForm();
                }
            });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function toggleCoverLevelText() {
        $('.cover-level').off('click').on('click',
            function() {
                $('#validation-message').hide();
                $('.cover-level').attr('checked', 'checked');
                selectedCoverFlag = $(this).data('coverlevel');
                $('#feature-header-cover-level').text(selectedCoverFlag);
                $('#feature-question-box-cover-level').text(selectedCoverFlag);
                sessionData = JSON.parse(sessionStorage.getItem(configuration.DataStoreKey));
                sessionData.selectedCoverFlag = selectedCoverFlag;
                sessionStorage.setItem(configuration.DataStoreKey, JSON.stringify(sessionData));
            });
    }

    function initValidation() {
        form = $('[data-component-id=\'' + configuration.Id + '\'] form');

        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();
        bgl.common.validator.init(form);

        form.off('submit').on('submit',
            function(e) {
                e.preventDefault();

                bgl.common.validator.validate(configuration, $(this));
            });
    }

    function submitForm() {
        form.submit();
    }

    function onSuccess() {
        if (sessionData.selectedCoverFlag === 'Comprehensive') {
            window.location.href = configuration.NextStepUrl;
        } else {
            window.location.href = configuration.CoverLevelUrl;
        }
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};
bgl.components.coverdetails.coverexcesses = (function() {
    let configuration;
    let form;

    function loadComponent(data, componentUrl, containerElementId) {
        configuration = data.ComponentConfiguration;

        bgl.common.loader.load(data,
            componentUrl,
            containerElementId,
            function() {
                initComponent(configuration);
            });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#CoverExcess');
        bgl.common.validator.init(form);
        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();
        if (form.find('input[type=radio]:checked').length === 0) {
            form.find('input[type=radio]')
                .off('keypress', generateClickOnKeypress)
                .on('keypress', generateClickOnKeypress)
                .off('click', continueHandler)
                .on('click', function(event) {
                    $(this).focusout();
                    submitForm();
                });
        } else {
            const continueButton = $(form.find('[type=\'submit\']'));
            continueButton.removeClass('hide');
            continueButton.off('click').on('click', continueHandler);
        }

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();
                    if (bgl.common.validator.isFormValid(form)) {
                        bgl.common.validator.submitForm(form, configuration);
                    }
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function submitForm() {
        form.submit();
    }

    function generateClickOnKeypress(event) {
        const code = event.charCode || event.keyCode;
        if (code === 13 || code === 32) {
            $(this).click();
        }
    }

    function onSuccess() {
        location.href = configuration.NextStepUrl;
    }

    function continueHandler(event, element) {
        event.preventDefault();
        if (bgl.common.datastore.isDataChanged(form)) {
            submitForm();
        }
        location.href = configuration.NextStepUrl;
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.cardcoverlevel = (function() {
    function initComponent(componentConfiguration) {
        const coverLevel = document.getElementById(`${componentConfiguration.Id}_cover-level_link`);
        const coverId = coverLevel.getAttribute('data-cover-id');
        const actionUrl = coverLevel.getAttribute('data-action-url');
        const containerId = coverLevel.getAttribute('data-container');

        coverLevel.addEventListener('click', () => {
            bgl.common.loader.load({componentConfiguration, CoverId: coverId},
                actionUrl,
                containerId,
                () => {
                    document.getElementById('BtnSubmit').addEventListener('click', () => {
                        document.querySelector('[data-dismiss="slide-panel"]').click();
                    });
                });
        });
    }

    return {
        init: initComponent,
    };
})();

bgl.components.coverdetails.cardcoverexcess = (function() {
    function initComponent(componentConfiguration) {
        const coverExcess = document.getElementById(`${componentConfiguration.Id}_cover-excess_link`);
        const coverId = coverExcess.getAttribute('data-cover-id');
        const actionUrl = coverExcess.getAttribute('data-action-url');
        const containerId = coverExcess.getAttribute('data-container');

        coverExcess.addEventListener('click', () => {
            bgl.common.loader.load({componentConfiguration, CoverId: coverId},
                actionUrl,
                containerId,
                () => {
                    const excessBar = document.getElementById(`${componentConfiguration.Id}__excess-bar-two`);
                    const compulsoryAmount = parseInt(
                        document.getElementById(`${componentConfiguration.Id}__compulsory-excess_amount`).textContent,
                    );
                    const totalAmount = parseInt(
                        document.getElementById(`${componentConfiguration.Id}__total-excess_amount`).textContent,
                    );
                    const totalAmountPercentage = calculateExcessBarPercentage(compulsoryAmount, totalAmount);
                    excessBar.setAttribute('style', `height:${totalAmountPercentage}`);
                    bgl.common.accordions.init();
                    document.getElementById(`${componentConfiguration.Id}_submit-button`)
                        .addEventListener('click', () => {
                            document.querySelector('[data-dismiss="slide-panel"]').click();
                        });
                });
        });
    }

    function calculateExcessBarPercentage(compulsoryAmount, totalAmount) {
        return ((totalAmount - compulsoryAmount) * 100 / totalAmount).toFixed(0) + '%';
    };

    return {
        init: initComponent,
        calculateExcessBar: calculateExcessBarPercentage,
    };
})();

bgl.components.coverdetails.cardcoverncd = (function() {
    function initComponent(componentConfiguration) {
        const coverNCD= document.getElementById(`${componentConfiguration.Id}_cover-ncd_link`);
        const coverId = coverNCD.getAttribute('data-cover-id');
        const actionUrl = coverNCD.getAttribute('data-action-url');
        const containerId = coverNCD.getAttribute('data-container');

        coverNCD.addEventListener('click', () => {
            bgl.common.loader.load({componentConfiguration, CoverId: coverId},
                actionUrl,
                containerId,
                () => {
                    bgl.common.accordions.init();
                    document.getElementById(`${componentConfiguration.Id}_submit-button`)
                        .addEventListener('click', () => {
                            document.querySelector('[data-dismiss="slide-panel"]').click();
                        });
                });
        });
    }

    return {
        init: initComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.conditionalbanner = (function() {
    function initComponent(componentConfiguration) {
        componentConfiguration.AccordionIds.forEach((accordionId) => {
            const accordion = document.getElementById(accordionId);
            if (accordion != null) {
                bgl.uil.accordion.init(accordionId);
            }
        });
    }

    return {
        init: initComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

const coverKeys = {
    totalExcess: 'total-excess',
    coverLevel: 'cover-level',
    courtesyVehicle: 'courtesy-vehicle',
    legalProtection: 'legal-protection',
    uninsuredDriverPromise: 'uninsured-driver-promise',
    vandalismPromise: 'vandalism-promise',
    windscreenCover: 'windscreen-cover',
    driveOtherVehicles: 'drive-other-vehicles',
    childSeatCover: 'child-seat-cover',
    personalAccident: 'personal-accident',
    personalBelongings: 'personal-belongings',
    emergencyTransportAndAccommodation: 'emergency-transport-and-accommodation',
    emergencyTransport: 'emergency-transport',
    transferHome: 'transfer-home',
    drivingAbroad: 'driving-abroad',
    medicalExpenses: 'medical-expenses',
    audioEquipment: 'audio-equipment',
    replacementLocks: 'replacement-locks',
    annualMileage: 'annual-mileage',
    noClaimsDiscount: 'ncd',
    vehicleUsage: 'vehicle-usage',
    mainDriver: 'main-driver',
    registeredKeeper: 'registered-keeper',
    breakdown: 'breakdown',
    guaranteedReplacementVehicle: 'guaranteed-replacement-vehicle',
    keyCover: 'key-cover',
    toolsCover: 'tools-cover',
    misfuellingCover: 'misfuelling-cover',
    claimsGuarantee: 'claims-guarantee',
    emissionsFree: 'emissions-free',
    digitalPolicy: 'digital-policy',
};

const sessionStorageConstants = {
    IsPncdTriggerPageRedirectionKey: 'PncdTriggerPageRedirection',
    IsPriceProtectionTriggerPageRedirectionKey: 'PriceProtectionTriggerPageRedirection',
    CoverDetailsPncdAddonIsYesClicked: 'CoverDetailsPncdAddonIsYesClicked',
    CoverDetailsPriceProtectionAddonIsYesClicked: 'CoverDetailsPriceProtectionAddonIsYesClicked',
};

const SPACE_KEYCODE = 32;
const ENTER_KEYCODE = 13;
const ESCAPE_KEYCODE = 27;

bgl.components.coverdetails.common = (function() {
    let component;

    const journeyTypes = {
        singleEdit: 0,
        additionalDriver: 1,
        multiStepEdit: 2,
    };

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                bgl.components.coverdetails.common.init(componentConfiguration);
            });
    }

    function initComponent(componentConfiguration) {
        component = $('#' + componentConfiguration.Id);
        const links = component.find('[data-action-url]');

        links.off();
        links.on({
            'keyup': function(event) {
                const code = event.charCode || event.keyCode;

                if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
                    $(this).click();
                }
            },
            'click': function(event) {
                event.preventDefault();
                const link = $(this);
                const actionUrl = link.data('action-url');

                if (componentConfiguration.IsService && componentConfiguration.LoadEditAsARedirect) {
                    bgl.common.utilities.redirectToUrl(actionUrl);
                } else {
                    loadComponentByCoverKey(link.data('cover-key'),
                        link.data('container'),
                        componentConfiguration,
                        actionUrl,
                        {
                            coverId: link.data('cover-id'),
                            coverText: link.data('cover-text'),
                            contentUrl: link.data('content-url'),
                        });
                }
            },
        });
    }

    function loadComponentByCoverKey(key, containerSelector, configuration, actionUrl, options) {
        if (configuration.CoverFeaturePriority !== undefined &&
            key in configuration.CoverFeaturePriority &&
            configuration.CoverFeaturePriority[key].ViewName &&
            configuration.CoverFeaturePriority[key].ViewName.toLowerCase() === 'none') {
            $('#' + containerSelector).empty();
            return;
        }

        switch (key) {
        case coverKeys.totalExcess:
            bgl.components.excesses.load(
                {ComponentConfiguration: configuration, CoverId: options.coverId},
                actionUrl,
                containerSelector);
            break;

        case coverKeys.coverLevel:
            bgl.components.coverlevel.load(
                {ComponentConfiguration: configuration, CoverId: options.coverId},
                actionUrl,
                containerSelector);
            break;

        case coverKeys.noClaimsDiscount:
            bgl.components.noclaimsdiscount.load(
                {ComponentConfiguration: configuration, CoverId: options.coverId},
                actionUrl,
                containerSelector);
            break;

        case coverKeys.vehicleUsage:
            bgl.components.vehicleusage.load(
                {ComponentConfiguration: configuration, CoverId: options.coverId, ClassOfUse: options.coverText},
                actionUrl,
                containerSelector);
            break;

        case coverKeys.annualMileage:
            bgl.components.annualmileage.load(
                {ComponentConfiguration: configuration, CoverId: options.coverId},
                actionUrl,
                containerSelector);
            break;

        case coverKeys.mainDriver:
            bgl.components.maindriver.load(
                {ComponentConfiguration: configuration, CoverId: options.coverId},
                actionUrl,
                containerSelector);
            break;
        case coverKeys.registeredKeeper:
            bgl.common.loader.load(configuration,
                actionUrl,
                containerSelector,
                function() {
                    bgl.components.coverdetails.registeredkeeper.init(configuration, containerSelector);
                });
            break;

        case coverKeys.legalProtection:
        case coverKeys.courtesyVehicle:
        case coverKeys.uninsuredDriverPromise:
        case coverKeys.vandalismPromise:
        case coverKeys.windscreenCover:
        case coverKeys.driveOtherVehicles:
        case coverKeys.childSeatCover:
        case coverKeys.personalAccident:
        case coverKeys.personalBelongings:
        case coverKeys.emergencyTransportAndAccommodation:
        case coverKeys.emergencyTransport:
        case coverKeys.transferHome:
        case coverKeys.drivingAbroad:
        case coverKeys.medicalExpenses:
        case coverKeys.audioEquipment:
        case coverKeys.replacementLocks:
        case coverKeys.breakdown:
        case coverKeys.keyCover:
        case coverKeys.toolsCover:
        case coverKeys.guaranteedReplacementVehicle:
        case coverKeys.misfuellingCover:
        case coverKeys.claimsGuarantee:
        case coverKeys.emissionsFree:
        case coverKeys.digitalPolicy:
            bgl.common.loader.load({}, options.contentUrl, containerSelector);
            break;
        default:
            $('#' + containerSelector).empty();
            break;
        }
    }

    function onAddonBackButtonClick() {
        onAddonBackButtonClickOrKeyUp();
    }

    function onAddonBackButtonClickOrKeyUp() {
        const component = $('[data-cover-details-addon-back-button]');

        component.off();
        component.on({
            'keyup': function(event) {
                const code = event.charCode || event.keyCode;
                if (code === ENTER_KEYCODE || code === SPACE_KEYCODE) {
                    $(this).click();
                }
            },
            'click': function(event) {
                event.preventDefault();
                if (this.getAttribute('data-cover-details-addon-back-button') === 'review') {
                    reviewBackButtonClickHandler($(this));
                } else {
                    backButtonClickHandler();
                }
            },
        });
    }

    function backButtonClickHandler() {
        const previousAddon = $('#previous-addon').val();
        if (previousAddon) {
            const previousAddonSelected = sessionStorage.getItem(('SelectedAddon').concat(previousAddon));
            if (previousAddonSelected !== null) {
                bgl.common.utilities.redirectToUrl(previousAddonSelected);
            } else {
                bgl.common.utilities.redirectToUrl(previousAddon);
            }
        } else {
            const previousStepUrl = $('#previous-stepUrl').val();
            bgl.common.utilities.redirectToUrl(previousStepUrl);
        }
    }

    function reviewBackButtonClickHandler($this) {
        const reviewBackBtnUrl = $this.attr('href');

        const index = reviewBackBtnUrl.lastIndexOf('/');

        const pageUrl = reviewBackBtnUrl.substring(index + 1, reviewBackBtnUrl.length);

        const previousAddonSelected = sessionStorage.getItem(('SelectedAddon').concat(pageUrl));

        if (previousAddonSelected) {
            const detailUrl = reviewBackBtnUrl.replace(pageUrl, previousAddonSelected);

            bgl.common.utilities.redirectToUrl(detailUrl);
        } else {
            bgl.common.utilities.redirectToUrl(reviewBackBtnUrl);
        }
    }

    function setNextAction(configuration, isDataChanges) {
        if (configuration.IsService) {
            if (configuration.IsInitialChange) {
                if (isDataChanges) {
                    mtaChange(configuration);
                } else {
                    bgl.common.contentpanel.hideSlidePanel();
                }
            } else if (isDataChanges) {
                bgl.common.pubsub.emit('PollBasket');
            } else {
                window.location.href = configuration.NextStepUrl;
            }
        } else {
            $('[data-dismiss="slide-panel"]').click();
        }
    }

    return {
        init: initComponent,
        load: loadComponent,
        journeyTypes: journeyTypes,
        onAddonBackButtonClick: onAddonBackButtonClick,
        setNextAction: setNextAction,
    };

    function mtaChange(configuration) {
        bgl.common.pubsub.emit('PollBasket', getParams(configuration));
    }

    function getParams(configuration) {
        return configuration.IsInitialChange ?
            {callback: () => bgl.common.utilities.redirectToUrl(configuration.NextStepUrl)} :
            null;
    }
})();

bgl.components.coverlevel = (function() {
    let configuration;
    let form;

    function loadComponent(data, componentUrl, containerElementId) {
        configuration = data.ComponentConfiguration;


        bgl.common.loader.load(data,
            componentUrl,
            containerElementId,
            function() {
                bgl.components.coverlevel.init(configuration);
            });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        if (configuration.IsSummary) {
            $('#BtnSubmit').off('click').on('click', this.onSuccess);
        } else {
            initValidation();
            initDynamicText();
        }
    }

    function initDynamicText() {
        $('.cover-level').on('click',
            function() {
                const text = $(this).text().trim();

                $('#feature-header-cover-level').text(text);
                $('#feature-question-box-cover-level').text(text);
            });
    }

    function initValidation() {
        form = $('[data-component-id=\'' + configuration.Id + '\'] form');

        bgl.common.datastore.init(form);

        bgl.common.validator.init(form);


        $('#BtnSubmit').off('click').on('click',
            function() {
                form.submit();
            });

        form.on('submit',
            function(e) {
                e.preventDefault();

                if (configuration.IsService) {
                    const mtaSuffix = bgl.common.utilities.getWindowLocation()
                        .href.toLowerCase().includes('makechanges') ?
                        'start' :
                        'additional change';

                    bgl.common.telemetry.logEvent(`MTA ${mtaSuffix}`,
                        {mta_type: 'Cover level', component: configuration.Id});
                }

                if (!bgl.common.datastore.isDataChanged(form)) {
                    bgl.components.coverdetails.common.setNextAction(configuration, false);
                    bgl.common.datastore.removeSessionStorage(form);
                    return;
                }

                storeCoverDetailsChangesForTagManager();

                bgl.common.validator.validate(configuration, $(this));
            });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function storeCoverDetailsChangesForTagManager() {
        const data = getPreviouslyStoredChangedCoverDetailsData();
        const coverLevel = getCoverLevelListValue();

        if (coverLevel) {
            data.push(['CoverLevel', coverLevel]);
            setPreviouslyStoredChangedCoverDetailsData(data);
        }
    }

    function getCoverLevelListValue() {
        const checkedCoverLevelButtonId = $('input[name=CoverLevelCode]:checked').attr('id');
        const valueForCheckedCoverLevelButton = $(`label[for="${checkedCoverLevelButtonId}"] p`).html();

        return valueForCheckedCoverLevelButton;
    }

    function getPreviouslyStoredChangedCoverDetailsData() {
        let data = [];

        if (sessionStorage.getItem('ChangedVehicleData') !== null) {
            data = JSON.parse(sessionStorage.getItem('ChangedVehicleData'));
        }

        return data;
    }

    function setPreviouslyStoredChangedCoverDetailsData(data) {
        sessionStorage.setItem('ChangedVehicleData', JSON.stringify(data));
    }

    function successCallback(message) {
        const notification = JSON.stringify({
            cat: 'pricechange',
            msg: message,
        });

        sessionStorage.setItem('notification', notification);
        window.location.reload(true);
    }

    function onSuccess(config, response) {
        if (configuration.IsSummary === true) {
            $('[data-dismiss="slide-panel"]').click();
            return;
        }
        const isDataChanges = bgl.common.datastore.isDataChanged(form);
        bgl.common.datastore.removeSessionStorage(form);

        bgl.components.coverdetails.common.setNextAction(configuration, isDataChanges);

        if (!configuration.IsService) {
            if (response.houstonMessage) {
                const params = {
                    callback: function() {
                        successCallback(response.houstonMessage);
                    },
                };

                bgl.common.pubsub.emit('PollBasket', params);
            } else {
                bgl.common.pubsub.emit('PollBasket');
            }

            if (isDataChanges === true) {
                bgl.common.pubsub.emit('PollBasket');
                if (configuration.NextStepUrl != null) {
                    bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
                }
            }
        }
    }

    return {
        init: initComponent,
        load: loadComponent,
        storeCoverDetailsChangesForTagManager: storeCoverDetailsChangesForTagManager,
        onSuccess: onSuccess,
    };
})();

bgl.components.excesses = (function() {
    let configuration;
    let container;
    let excessBar;
    let form;
    let customSelectControl;

    function loadComponent(data, componentUrl, containerElementId) {
        configuration = data.ComponentConfiguration;

        bgl.common.loader.load(data,
            componentUrl,
            containerElementId,
            function() {
                initComponent(configuration, containerElementId);
            });
    }

    function initComponent(componentConfiguration, containerElementId) {
        configuration = componentConfiguration;

        container = $('#' + containerElementId);
        excessBar = container.find('.bar-graph__bar--two');

        updateExcessesBar();

        initSubmitForm();

        bgl.common.accordions.init();

        initCustomSelect();
    }

    function initCustomSelect() {
        customSelectControl = $('.excess-bar__button-wrapper');

        $('.slide-panel').on('click', function() {
            bgl.common.customselect.closeOptions(customSelectControl, toggleCustomSelectButtonText);
        }); ;

        bgl.common.customselect.getButton(customSelectControl).on('click', function(event) {
            event.stopPropagation();
            bgl.common.customselect.toggleOptions(customSelectControl, toggleCustomSelectButtonText);
        });

        bgl.common.customselect.getContainer(customSelectControl).on('click keydown keypress keyup', function(event) {
            event.stopPropagation();
        });

        bgl.common.customselect.getItems(customSelectControl).each(function() {
            $(this).on('click', function(event) {
                const activeElement = $(event.target);
                bgl.common.customselect.selectItem(activeElement, selectExcess);
                bgl.common.customselect.closeOptions(customSelectControl, toggleCustomSelectButtonText);
            });

            $(this).on('keydown', function(event) {
                bgl.common.customselect.navigate(event, customSelectControl, toggleCustomSelectButtonText);
            });

            $(this).on('keyup', function(event) {
                if (event.keyCode === ESCAPE_KEYCODE) {
                    bgl.common.customselect.closeOptions(customSelectControl, toggleCustomSelectButtonText);
                }
            });
        });
    }

    function initSubmitForm() {
        const submitButton = $('#' + configuration.Id + '_submit-button');
        form = $('#' + configuration.Id + '__cover_excesses-form');
        bgl.common.datastore.init(form);

        submitButton
            .off('click')
            .on('click',
                function(e) {
                    e.preventDefault();

                    const isEditable = submitButton.data('isEditable') === 'True';

                    if (!isEditable || !bgl.common.datastore.isDataChanged(form)) {
                        $('[data-dismiss="slide-panel"]').click();
                        bgl.common.datastore.removeSessionStorage(form);
                    } else {
                        bgl.common.validator.submitForm($(form), configuration);
                    }
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function updateExcessesBar() {
        const compulsoryAmount = parseInt(container.find('.compulsory-excess-amount').data('value'));
        const totalAmount = parseInt(container.find('.total-excess-amount').data('value'));

        excessBar.css(
            'height',
            totalAmount ? (((totalAmount - compulsoryAmount) * 100 / totalAmount).toFixed(0) + '%') : '50%',
        );
    }

    function toggleCustomSelectButtonText() {
        const buttonText = bgl.common.customselect.isOpen(customSelectControl) ? 'Cancel' : 'Edit';
        bgl.common.customselect.getButton(customSelectControl).text(buttonText);
    }

    function selectExcess() {
        const selectedItem = bgl.common.customselect.getSelectedItem(customSelectControl);
        const voluntaryExcessAmount = parseInt(selectedItem.data('value'));
        const compulsoryExcessAmount = parseInt(container.find('.compulsory-excess-amount').text());
        const totalExcessAmount = voluntaryExcessAmount + compulsoryExcessAmount;
        const totalExcess = container.find('.total-excess-amount');

        totalExcess.data('value', totalExcessAmount).text(totalExcessAmount);

        container.find('.voluntary-excess-amount').text(voluntaryExcessAmount);
        container.find('#Amount').val(voluntaryExcessAmount);

        updateExcessesBar();
    }

    function onSuccess() {
        $('[data-dismiss="slide-panel"]').click();
        bgl.common.datastore.removeSessionStorage(form);

        bgl.common.utilities.startUnderwritingPolling();
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
    };
})();

bgl.components.noclaimsdiscount = (function() {
    let configuration;
    let ncdYears;
    let form;

    function initValidation() {
        form = $('[data-component-id=\'' + configuration.Id + '\'] form');

        bgl.common.validator.init(form);
        bgl.common.datastore.init(form);

        form.off('submit')
            .on('submit',
                function(e) {
                    e.preventDefault();

                    if (!bgl.common.datastore.isDataChanged(form)) {
                        $('[data-dismiss="slide-panel"]').click();
                        bgl.common.datastore.removeSessionStorage(form);
                        return;
                    }
                    storeUserChangesForTagManager();
                    bgl.common.validator.validate(configuration, $(this));
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function storeUserChangesForTagManager() {
        const data = getPreviouslyStoredChangedUserData();
        const ncdYearsRadioButtons = document.querySelectorAll('input[name="NcdYears"]');
        let ncdYearsValue;
        for (const radioButton of ncdYearsRadioButtons) {
            if (radioButton.checked) {
                ncdYearsValue = radioButton.value;
                break;
            }
        }
        data.push(['NcdYears', ncdYearsValue]);
        sessionStorage.setItem('ChangedUserData', JSON.stringify(data));
    }

    function getPreviouslyStoredChangedUserData() {
        let data = [];

        if (sessionStorage.getItem('ChangedUserData') !== null) {
            data = JSON.parse(sessionStorage.getItem('ChangedUserData'));
        }

        return data;
    }

    function subscribeForEvents() {
        if (!configuration.IsService) {
            initValidation();
        } else {
            document.querySelectorAll('input[type="submit"]').forEach((element) => {
                element.addEventListener('click', (event) => {
                    event.preventDefault();
                    document.querySelector('[data-dismiss="slide-panel"]').click();
                });
            });
        }
        bgl.hiddensubmit.init();
        bgl.common.accordions.init();
    }

    function load(data, componentUrl, containerElementId) {
        configuration = data.ComponentConfiguration;
        bgl.common.loader.load(data,
            componentUrl,
            containerElementId,
            function() {
                init(configuration);
            });
    }

    function init(componentConfiguration) {
        configuration = componentConfiguration;
        subscribeForEvents();
    }

    function successCallback(message) {
        const notification = JSON.stringify({
            cat: 'pricechange',
            msg: message,
        });

        sessionStorage.setItem('notification', notification);
        window.location.reload(true);
    }

    function onSuccess(configuration, data) {
        if (!configuration.IsService) {
            if (ncdYears <= 3) {
                sessionStorage.removeItem(sessionStorageConstants.CoverDetailsPncdAddonIsYesClicked);
                sessionStorage.removeItem(sessionStorageConstants.CoverDetailsPriceProtectionAddonIsYesClicked);
            }

            if (data.houstonMessage) {
                const params = {
                    callback: function() {
                        successCallback(data.houstonMessage);
                    },
                };

                bgl.common.pubsub.emit('PollBasket', params);
            } else {
                bgl.common.pubsub.emit('PollBasket');
            }

            bgl.common.datastore.removeSessionStorage(form);
        }
        document.querySelector('[data-dismiss="slide-panel"]').click();
    }

    function onError() {
        bgl.components.noclaimsdiscount.init(configuration);
        bgl.common.datastore.extendCollectedData(form, {isFormDirty: true});
    }

    return {
        init,
        load,
        storeUserChangesForTagManager,
        onSuccess,
        onError,
    };
})();

bgl.components.annualmileage = (function() {
    let configuration;
    let form;

    function loadComponent(model, componentUrl, containerElementId) {
        configuration = model.ComponentConfiguration;

        bgl.common.loader.load(model,
            componentUrl,
            containerElementId,
            function() {
                bgl.components.annualmileage.init(configuration);
            });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        subscribeToEvents(componentConfiguration);
    }

    function subscribeToEvents(configuration) {
        form = $('#' + configuration.Id + '__annual-mileage-form');

        bgl.common.validator.init(form);
        bgl.common.datastore.init(form);

        form.off('submit').on('submit',
            function(e) {
                e.preventDefault();

                if (configuration.IsService) {
                    const mtaSuffix = bgl.common.utilities.getWindowLocation()
                        .href.toLowerCase().includes('makechanges') ?
                        'start' :
                        'additional change';

                    bgl.common.telemetry.logEvent(`MTA ${mtaSuffix}`,
                        {mta_type: 'Annual mileage', component: configuration.Id});
                }

                if (!bgl.common.datastore.isDataChanged(form)) {
                    bgl.components.coverdetails.common.setNextAction(configuration, false);
                    bgl.common.datastore.removeSessionStorage(form);
                    return;
                }

                bgl.common.validator.validate(configuration, form);
            });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);

        const numberBox = $('#' + configuration.Id + '__annual-mileage');

        calculateAverageMiles(numberBox.val());

        numberBox.off('keydown').on('keydown',
            function(e) {
                if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
                    (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                    (e.keyCode >= 35 && e.keyCode <= 40)) {
                    return;
                }
                if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105) ||
                    $(this).val().length === 5 ||
                    (e.keyCode === 96 && $(this).val().length === 0)) {
                    e.preventDefault();
                }
            });

        numberBox.off('keyup').on('keyup',
            function() {
                let val = $(this).val();
                while (val.substring(0, 1) === '0') {
                    val = val.substring(1);
                }
                $(this).val(val);
            });

        numberBox.off('input').on('input',
            function(e) {
                e.preventDefault();

                const value = $(e.target).val();

                calculateAverageMiles(value);
            });
    }

    function calculateAverageMiles(value) {
        const label = $('#' + configuration.Id + '__annual-mileage-label');
        const labelTemplateValue = $('#labelTemplate').val();

        if (value !== undefined && value !== '') {
            const averageMiles = Math.round(value / 52, 0);

            if (averageMiles === 0) {
                label.hide();
            } else {
                label.show();
                const text = $.parseHTML(labelTemplateValue.replace('{mileage}', averageMiles));
                label.html(text);
            }
        }
    }

    function onSuccess() {
        const isDataChanges = bgl.common.datastore.isDataChanged(form);
        bgl.common.datastore.removeSessionStorage(form);

        bgl.components.coverdetails.common.setNextAction(configuration, isDataChanges);

        if (!configuration.IsService) {
            bgl.common.utilities.startUnderwritingPolling();
        }
    }

    function onError(componentConfiguration, error) {
        subscribeToEvents(componentConfiguration);
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

bgl.components.vehicleusage = (function() {
    let configuration;
    let containerId;
    let isVan;
    let form;
    const carriageOfOwnGoods = '21';
    const haulage = '22';

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        configuration = componentConfiguration;
        containerId = containerElementId;

        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
            });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        isVan = $('#IsVan').val();
        form = $('#vehicle-usage');

        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();
        bgl.common.validator.init(form);

        subscribeToEvents();
    }

    function subscribeToEvents() {
        form.off('submit')
            .on('submit',
                function(e) {
                    e.preventDefault();

                    if (configuration.IsService) {
                        const mtaSuffix = bgl.common.utilities.getWindowLocation()
                            .href.toLowerCase().includes('makechanges') ?
                            'start' :
                            'additional change';

                        bgl.common.telemetry.logEvent(`MTA ${mtaSuffix}`,
                            {mta_type: 'Vehicle usage', component: configuration.Id});
                    }
                    setDataHasChangedFlagForQuestionSet();

                    if (isVan === 'True') {
                        vanNavigation();
                        return;
                    } else {
                        if (!bgl.common.datastore.isDataChanged(form)) {
                            bgl.components.coverdetails.common.setNextAction(configuration.ComponentConfiguration,
                                false);
                            bgl.common.datastore.removeSessionStorage(form);
                            return;
                        } else {
                            bgl.common.validator.validate(configuration, form);
                        }
                    }
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function onSuccess(configuration, data) {
        const isDataChanges = bgl.common.datastore.isDataChanged(form);
        bgl.common.datastore.removeSessionStorage(form);

        bgl.components.coverdetails.common.setNextAction(configuration.ComponentConfiguration, isDataChanges);

        if (!configuration.ComponentConfiguration.IsService) {
            bgl.common.utilities.startUnderwritingPolling();
        }
    }

    function vanNavigation() {
        const vehicleUsage = $('input[name=ClassOfUseCode]:checked', '#vehicle-usage').val();
        if (typeof bgl.common.pubsub !== 'undefined') {
            bgl.common.pubsub.emit('fakeFormSubmit', 'VehicleUsage');
        }
        if (vehicleUsage === carriageOfOwnGoods || vehicleUsage === haulage) {
            const yearsEstablishedActionUrl = $('#vehicleUseSubmitBtn').data('years-established-action-url');
            bgl.components.coverdetails.yearsbusinessestablished.load(
                configuration.ComponentConfiguration,
                yearsEstablishedActionUrl,
                containerId,
            );
        } else {
            const dangerousGoodsActionUrl = $('#vehicleUseSubmitBtn').data('dangerous-goods-action-url');
            bgl.components.coverdetails.carriageofdangerousgoods.load(
                configuration.ComponentConfiguration,
                dangerousGoodsActionUrl,
                containerId,
            );
        }
    }

    function onError() {
        bgl.components.vehicleusage.init(configuration);
    }

    function setDataHasChangedFlagForQuestionSet() {
        const vehicleUseSessionData = JSON.parse(sessionStorage.getItem('CoverDetailsVehicleUse'));

        if (bgl.common.datastore.isDataChanged(form)) {
            vehicleUseSessionData.DataHasChanged = 'True';
            sessionStorage.setItem('CoverDetailsVehicleUse', JSON.stringify(vehicleUseSessionData));
        }
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

bgl.components.maindriver = (function() {
    let configuration;
    let form;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        configuration = componentConfiguration;

        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
            });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#main-driver');

        bgl.common.validator.init(form);
        bgl.common.datastore.init(form);

        subscribeToEvents();
    }

    function subscribeToEvents() {
        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (!bgl.common.datastore.isDataChanged(form)) {
                        $('[data-dismiss="slide-panel"]').click();
                        bgl.common.datastore.removeSessionStorage(form);
                        return;
                    }

                    bgl.common.validator.validate(configuration, form);
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function successCallback(houstonMessage) {
        const notification = JSON.stringify({
            cat: 'pricechange',
            msg: houstonMessage,
        });
        sessionStorage.setItem('notification', notification);
        window.location.reload(true);
    }

    function onSuccess(configuration, data) {
        bgl.common.utilities.setUrlHashValue('main');

        if (data.houstonMessage) {
            const params = {
                callback: function() {
                    successCallback(data.houstonMessage);
                },
            };

            bgl.common.pubsub.emit('PollBasket', params);
        } else {
            bgl.common.pubsub.emit('PollBasket');
        }

        $('[data-dismiss="slide-panel"]').click();
        bgl.common.datastore.removeSessionStorage(form);
    }

    function onError() {
        bgl.components.maindriver.init(configuration);
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.coverdetails.common;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.carriageofdangerousgoods = (function() {
    let form;
    let configuration;
    let container;
    const SPACE_KEYCODE = 32;
    const ENTER_KEYCODE = 13;

    const socialDpClassOfUseCode = '05';

    function loadComponent(config, url, containerId) {
        bgl.common.loader.load(config,
            url,
            containerId,
            function() {
                initComponent(config, containerId);
            });
    }

    function initComponent(componentConfiguration, containerId) {
        initElements(componentConfiguration, containerId);

        subscribeForEvents();
    }

    function onSuccess(componentConfiguration, data) {
        if (isMultiStepEdit()) {
            location.href = configuration.NextStepUrl;
        } else {
            bgl.common.datastore.removeSessionStorage(form);
            bgl.common.pubsub.emit('PollBasket');
        }
    }

    function onError() {
        initComponent(configuration);
    }

    function initElements(componentConfiguration, containerId) {
        configuration = componentConfiguration;
        form = $('#carriage-of-dangerous-goods-form');
        container = containerId;

        bgl.common.validator.init(form);
        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();
    }

    function subscribeForEvents() {
        let vehicleUseSessionData = JSON.parse(sessionStorage.getItem('CoverDetailsVehicleUse'));
        let continueButton = $('#continueButton');

        if (form.find('input[type=radio]:checked').length === 0) {
            form.find('input[type=radio]')
                .off('keypress')
                .off('click', continueHandler)
                .on({
                    'keypress': function(e) {
                        if (e.keyCode === ENTER_KEYCODE || e.keyCode === SPACE_KEYCODE) {
                            $(this).click();
                        }
                    },
                    'click': function(event) {
                        $(this).focusout();
                        submitForm(form);
                    },
                });
        } else {
            continueButton = $(form.find('[type=\'submit\']'));
            continueButton.removeClass('hide');
            continueButton.off('click').on('click', () => {
                submitForm(form);
            });
        }

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    setDataHasChangedFlagForQuestionSet(vehicleUseSessionData);

                    continueButton.attr('disabled', true);
                    if (bgl.common.validator.isFormValid(form)) {
                        let model = configuration;

                        if (!isMultiStepEdit()) {
                            vehicleUseSessionData = JSON.parse(sessionStorage.getItem('CoverDetailsVehicleUse'));

                            if (vehicleUseSessionData['DataHasChanged'] !== 'True') {
                                if (configuration.IsService) {
                                    bgl.common.contentpanel.hideSlidePanel();
                                } else {
                                    $('[data-dismiss="slide-panel"]').click();
                                }

                                bgl.common.datastore.removeSessionStorage(form);
                                return;
                            }

                            model = bgl.common.datastore.getData(form);
                            model.ComponentConfiguration = configuration;
                        }

                        const formData = getStoredData();

                        bgl.common.validator.submitForm(form, model, formData);
                    } else {
                        continueButton.attr('disabled', false);
                    }
                });

        form.find('label').on('keyup', bgl.common.keyboardAccessibility.generateClickOnKeypress);

        form.find('#carriageOfDangerousGoodsBackBtn').off('click').one('click',
            function(event) {
                event.preventDefault();
                const classOfUseCode = vehicleUseSessionData['ClassOfUseCode'];
                let componentActionUrl = $(this).attr('href');

                if (isMultiStepEdit()) {
                    if (classOfUseCode !== socialDpClassOfUseCode) {
                        componentActionUrl = $(this).data('years-business-established-action-url');
                    }

                    location.href = componentActionUrl;
                } else {
                    if (classOfUseCode !== socialDpClassOfUseCode) {
                        componentActionUrl = $(this).data('years-business-established-action-url');

                        bgl.components.coverdetails.yearsbusinessestablished.load(configuration,
                            componentActionUrl,
                            container);
                    } else {
                        const model = bgl.common.datastore.getData(form);
                        model.ComponentConfiguration = configuration;

                        bgl.components.vehicleusage.load(model,
                            componentActionUrl,
                            container);
                    }
                }
            });
    }

    function submitForm(form) {
        const submitButton = form.find(':submit');

        if (submitButton.hasClass('hide')) {
            form.change().submit();
        }
    }

    function continueHandler(event) {
        event.preventDefault();

        form.submit();
    }

    function isMultiStepEdit() {
        const coverDetailsCommon = bgl.components.coverdetails.common;
        return configuration.JourneyType === coverDetailsCommon.journeyTypes.multiStepEdit;
    }

    function getStoredData() {
        const data = getDataToPost();
        const formData = form.serialize();

        return formData + '&' + $.param(data);
    }

    function getDataToPost() {
        const data = bgl.common.datastore.getData(form);
        const config = {ComponentConfiguration: configuration};

        $.extend(data, config);

        return data;
    }

    function setDataHasChangedFlagForQuestionSet(vehicleUseSessionData) {
        const dataHasChanged = vehicleUseSessionData['DataHasChanged'] === 'True';

        if (dataHasChanged || bgl.common.datastore.isDataChanged(form)) {
            vehicleUseSessionData.DataHasChanged = 'True';
            sessionStorage.setItem('CoverDetailsVehicleUse', JSON.stringify(vehicleUseSessionData));
        }
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.annualmileage = (function() {
    let form;
    let configuration;

    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        configuration = componentConfiguration;

        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
            });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#' + configuration.Id + '__annual-mileage-form');
        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();
        bgl.common.validator.enableMaxLength();
        bgl.common.validator.init(form);
        subscribeToEvents(configuration);
    }

    function subscribeToEvents(configuration) {
        const numberBox = $('#' + configuration.Id + '__annual-mileage');
        const continueButtonLink = $('#ContinueButton');

        calculateAverageMiles(numberBox.val());

        numberBox.off('keydown').on('keydown',
            function(e) {
                if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
					(e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
					(e.keyCode >= 35 && e.keyCode <= 40)) {
                    return;
                }
                if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105) ||
					$(this).val().length === 5 ||
					(e.keyCode === 96 && $(this).val().length === 0)) {
                    e.preventDefault();
                }
            });

        numberBox.on('keyup',
            function() {
                let val = $(this).val();
                while (val.substring(0, 1) === '0') {
                    val = val.substring(1);
                }
                $(this).val(val);
            });

        numberBox.off('input').on('input',
            function(e) {
                e.preventDefault();

                const value = $(e.target).val();

                calculateAverageMiles(value);
            });

        continueButtonLink.off('click').on('click',
            function(e) {
                e.preventDefault();
                if (bgl.common.validator.isFormValid(form)) {
                    bgl.common.validator.submitForm(form, configuration);
                }
            });

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();
                    if (bgl.common.validator.isFormValid(form)) {
                        bgl.common.validator.submitForm(form, configuration);
                    }
                });
    }

    function calculateAverageMiles(value) {
        const label = $('#' + configuration.Id + '__annual-mileage-label');
        const labelTemplateValue = $('#labelTemplate').val();

        if (value !== undefined && value !== '') {
            const averageMiles = Math.round(value / 52, 0);

            if (averageMiles === 0) {
                label.hide();
            } else {
                label.show();
                const text = $.parseHTML(labelTemplateValue.replace('{mileage}', averageMiles));
                label.html(text);
            }
        }
    }

    function onSuccess(componentConfiguration) {
        location.href = componentConfiguration.NextStepUrl;
    }
    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.coverdetails = bgl.components.coverdetails || {};

bgl.components.coverdetails.aboutyou = (function() {
    let form;
    let configuration;
    let registerKeeper;
    let container;

    function initComponent(componentConfiguration, containerId) {
        initElements(componentConfiguration, containerId);

        registerKeeper.redirectIfSessionStorageIsNotFound(form, componentConfiguration.ParentJourneyUrl);

        subscribeForEvents();

        updateHeading();

        registerKeeper.displaySubmitButton(form);
    }

    function loadComponent(config, url, containerId) {
        bgl.common.loader.load(config,
            url,
            containerId,
            function() {
                initComponent(config, containerId);
            });
    }

    function onSuccess(configuration, data) {
        bgl.components.coverdetails.maritalstatus.load(configuration, data.nextUrl, container);
    }

    function onMultiStepEditSuccess() {
        bgl.common.utilities.redirectToUrl(configuration.NextStepUrl);
    }

    function onError() {
        initComponent(configuration, container);
    }

    function initElements(componentConfiguration, containerId) {
        configuration = componentConfiguration;
        form = $('#about-you-form');
        container = containerId;

        registerKeeper = bgl.components.coverdetails.registeredkeeper;
    }

    function subscribeForEvents() {
        bgl.common.datastore.init(form);
        bgl.common.datastore.setupReadAndWrite();
        bgl.common.validator.init(form);
        bgl.common.validator.enableMaxLength();
        bgl.common.date.initDateFormat($('#DateOfBirth'));

        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();
                    if (bgl.common.validator.isFormValid(form)) {
                        bgl.common.validator.submitForm(form, configuration);
                    }
                });

        form.find('.back-button-link').off('click').one('click',
            function(event) {
                event.preventDefault();

                const url = $(this).attr('href');

                bgl.components.coverdetails.relationshipstatus.load(configuration, url, container);
            });
    }

    function updateHeading() {
        const data = bgl.common.datastore.getData(form);

        if (data) {
            const heading = getHeading(data.RelationshipStatusCode);
            const header = form.find('#heading');

            header.html(header.html().replace('{FirstName}', heading));
        }
    }

    function getHeading(code) {
        switch (code) {
        case 'J':
        case 'W':
            return 'partner';
        case 'S':
            return 'spouse';
        }

        return 'registered keeper';
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
        onMultiStepEditSuccess: onMultiStepEditSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};

bgl.components.basketbutton = (function() {
    let configuration;
    let basketIcon;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        basketIcon = document.querySelector('[data-basketicon]');

        subscribeToUpdateBasketPubSubEvent();
        subscribeToSwitchPaymentTypePubSubEvent();

        setOpenBasketPanelEvent();
    }

    function setOpenBasketPanelEvent() {
        const shoppingBasketButton = document.getElementById('shopping-basket-mvt');

        shoppingBasketButton.addEventListener('click', function() {
            const basketPanel = document.getElementById('basket-panel');

            basketPanel.classList.add('active');
            basketPanel.classList.remove('hide-panel');
        });
    }

    function subscribeToSwitchPaymentTypePubSubEvent() {
        bgl.common.pubsub.on('switchPaymentType', function(isMonthly) {
            switchPaymentType(isMonthly);
            animateBasket();
        });
    }

    function switchPaymentType(isMonthly) {
        if (isMonthly === true) {
            $('#price-monthly').removeClass('hide');
            $('#price-annually').addClass('hide');
        }
        if (isMonthly === false) {
            $('#price-monthly').addClass('hide');
            $('#price-annually').removeClass('hide');
        }
    }

    function subscribeToUpdateBasketPubSubEvent() {
        bgl.common.pubsub.off('UpdateBasket', updateBasket);
        bgl.common.pubsub.on('UpdateBasket', updateBasket);
    }

    function updateBasket(callback) {
        bgl.common.loader.loadAndReplace(configuration,
            configuration.ComponentUrl,
            'shopping-basket-button',
            function() {
                initComponent(configuration);
                animateBasket();
            });
    }

    function animateBasket() {
        if (basketIcon) {
            basketIcon.classList.remove('basket__animation-bounce');
            void basketIcon.offsetWidth;
            basketIcon.classList.add('basket__animation-bounce');
        }
    }

    return {
        init: initComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};

bgl.components.basket = (function() {
    let configuration;
    let basketPanel;
    let slidePanel;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        basketPanel = $('#basket-panel');
        slidePanel = document.getElementById('SlidePanel');

        bgl.common.accordions.init();

        subscribeToUpdateBasketPubSubEvent();
        subscribeToSwitchPaymentTypePubSubEvent();

        setContinueButtonText();
        setCloseBasketPanelEvent();
        setSlidePanelClassChangeEventBinding();
    }

    function setSlidePanelClassChangeEventBinding() {
        const mutationObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function() {
                setPositionOfHoustonInSlider();
            });
        });

        mutationObserver.observe(slidePanel, {
            attributes: true,
            attributeFilter: ['class'],
        });
    }

    function setContinueButtonText() {
        $('#next-button, #next-page-button, #continue-button')
            .text(configuration.ContinueButtonText);
    }

    function setCloseBasketPanelEvent() {
        [...document.querySelectorAll('[data-basketclose]')].map((element) => {
            element.addEventListener('click', function(e) {
                closeBasketPanel.call(this);
            });
        });
    }

    function closeBasketPanel() {
        basketPanel.addClass('hide-panel').removeClass('active');
    }

    function subscribeToSwitchPaymentTypePubSubEvent() {
        bgl.common.pubsub.on('switchPaymentType', function(isMonthly) {
            switchPaymentType(isMonthly);
        });
    }

    function switchPaymentType(isMonthly) {
        const monthlyPrices = document.querySelectorAll('[data-pricemonthly]');
        const annualPrices = document.querySelectorAll('[data-priceannually]');
        if (isMonthly === true) {
            removeHideClassFrom(monthlyPrices);
            addHideClassTo(annualPrices);
        } else {
            addHideClassTo(monthlyPrices);
            removeHideClassFrom(annualPrices);
        }
    }

    function addHideClassTo(elements) {
        [].forEach.call(elements, (element) => {
            element.classList.add('hide');
        });
    }

    function removeHideClassFrom(elements) {
        [].forEach.call(elements, (element) => {
            element.classList.remove('hide');
        });
    }

    function subscribeToUpdateBasketPubSubEvent() {
        bgl.common.pubsub.off('UpdateBasket', updateBasket);
        bgl.common.pubsub.on('UpdateBasket', updateBasket);
    }

    function updateBasket() {
        bgl.common.loader.loadAndReplace(configuration,
            configuration.ComponentUrl,
            'basket-panel',
            function() {
                initComponent(configuration);
            });
    }

    function setPositionOfHoustonInSlider() {
        const houstonContainer = document.getElementById('HoustonContainer');

        if (slidePanel.classList.contains('active')) {
            houstonContainer.classList.remove('houston-container--outside-slider');
            houstonContainer.classList.add('houston-container--within-slider');
        } else if (slidePanel.classList.contains('hide-panel')) {
            houstonContainer.classList.remove('houston-container--within-slider');
            houstonContainer.classList.add('houston-container--outside-slider');
        }
    }

    return {
        init: initComponent,
        setPositionOfHoustonInSlider: setPositionOfHoustonInSlider,
    };
})();
// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.additionaldetails = bgl.components.additionaldetails || {};

bgl.components.additionaldetails.paymentsregularityhiddenemailtel = (() => {
    let configuration;
    let form;

    function initComponent(componentConfiguration) {
        setCommonVariables(componentConfiguration);
        updateHiddenInputsWithSessionValues(configuration.SecondaryDataStoreKey);
        setUpDataStore();
        setUpKeyboardNavigationForAccessibility();
        setUpFormValidation(form);
        setUpFormSubmissionEvents();
    }

    function setCommonVariables(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#payments-regularity-form');
    }

    function updateHiddenInputsWithSessionValues(dataStoreKey) {
        const sessionStorageData = getSessionStorageData(dataStoreKey);
        const hiddenInputs = getHiddenInputs();
        updateInputValues(hiddenInputs, sessionStorageData);
    }

    function getSessionStorageData(key) {
        return JSON.parse(sessionStorage.getItem(key));
    }

    function getHiddenInputs() {
        return $('.hidden-input');
    }

    function updateInputValues(inputs, data) {
        inputs.each(function() {
            const input = $(this);
            const key = getDataStoreAttribute(input);
            const newInputValue = data[key];
            updateInputValue(input, newInputValue);
        });
    }

    function getDataStoreAttribute(element) {
        return element.data('store');
    }

    function updateInputValue(inputElement, value) {
        inputElement.val(value);
    }

    function setUpDataStore() {
        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();
    }

    function setUpKeyboardNavigationForAccessibility() {
        form.find('label').on('keyup',
            bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function setUpFormValidation(form) {
        bgl.common.validator.init(form);
    }

    function setUpFormSubmissionEvents() {
        form.off('submit').on('submit', function(event) {
            event.preventDefault();
            logToAppInsights({message: 'Form submission requested'});
            if (bgl.common.validator.isFormValid(form)) {
                logToAppInsights({message: 'Form validation passed'});
                const data = getDataForFormSubmission();
                logToAppInsights({message: 'Submitting form'});
                bgl.common.validator.submitForm(form, configuration, data);
            } else {
                logToAppInsights({message: 'Form validation failed'});
                logToAppInsights({message: 'Form not submitted'});
            }
        });
    }

    function getDataForFormSubmission() {
        const data = bgl.common.datastore.getData(form);
        data.__RequestVerificationToken = getRequestVerificationTokenValue();
        data.ComponentConfiguration = configuration;

        return data;
    }

    function getRequestVerificationTokenValue() {
        return $('input[name="__RequestVerificationToken"]').val();
    }

    function onSuccess() {
        logToAppInsights({message: 'Form submission successful'});
        const options = {
            callback: function() {
                bgl.common.utilities.redirectToUrl(configuration.NextPageUrl);
            },
            hideNotification: true,
        };

        sessionStorage.clear();
        bgl.common.pubsub.emit('PollBasket', options);
    }

    function onError() {
        bgl.components.additionaldetails
            .paymentsregularityhiddenemailtel
            .init(configuration);
        logToAppInsights({message: 'Form submission error'});
    }

    function logToAppInsights(props) {
        bgl.common.telemetry.logEvent(
            'paymentsSchedule MVT Submission Event',
            {properties: JSON.stringify(props)});
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.additionaldetails = bgl.components.additionaldetails || {};

bgl.components.additionaldetails.paymentsregularity = (function() {
    function initComponent() {
        const formId = 'payments-regularity-form';
        const form = $('#' + formId);
        const radioButtons = $('#payments-preference-monthly,#payments-preference-annually');
        const continueButton = $('#payments-regularity-continue-button');

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        let redirectForwardSelector;
        if (radioButtons.is(':checked')) {
            continueButton.removeClass('hide');
            redirectForwardSelector = continueButton;
        } else {
            redirectForwardSelector = radioButtons;
        }

        redirectForwardSelector.on('click', function() {
            if (bgl.common.pubsub !== 'undefined') {
                bgl.common.pubsub.emit('fakeFormSubmit', formId);
            }
            bgl.common.utilities.redirectToUrl(continueButton.data('next-step-url'));
        });

        form.find('label').on('keyup',
            bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    return {
        init: initComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.additionaldetails = bgl.components.additionaldetails || {};

bgl.components.additionaldetails.common = (function() {
    let configuration;
    let form;
    let monthValidation;
    let yearValidation;
    let monthDropdown;
    let yearDropdown;
    let fullYearMonthOptions;
    let currentYearMonthOptions;
    let currentMonth;
    let sectionLabel;
    const errorClass = 'error';

    function loadComponent(componentConfiguration,
        componentUrl,
        containerElementId) {
        configuration = componentConfiguration;

        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                bgl.components.additionaldetails.common.init(componentConfiguration);
                bgl.components.additionaldetails.vehicleusage.init(componentConfiguration);
            });
    }

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#' + componentConfiguration.Id + '-form-additional-details');
        monthValidation = $('#Month-Section');
        yearValidation = $('#Year-Section');
        monthDropdown = form.find('#Month');
        yearDropdown = form.find('#Year');
        sectionLabel = $('#Additional-Input-Purchase-Section');

        bgl.common.validator.init(form, {
            onfocusout: resetValidation,
            onclick: resetValidation,
        });

        subscribeToEvents();
        almostThereButtonSubmit();
        handleEmailConfirmation();

        if (yearDropdown.length > 0) {
            const currentDate = new Date();
            currentMonth = currentDate.getMonth() + 1;
            fullYearMonthOptions = monthDropdown.find('option');
            currentYearMonthOptions = fullYearMonthOptions.slice(0, currentMonth + 1);
            updateMonthDropdown();
        }

        if (document.querySelector('[data-datepicker]') != null) {
            bgl.uil.datepicker.init();
        }
    }

    function resetValidation(element) {
        bgl.common.validator.resetValidationState($(element));
        purchaseSectionValidationMessage();
    }

    function almostThereButtonSubmit() {
        $('#almost-there-button').on('click',
            function() {
                form.submit();
            });
    }
    function makeEmailsLowerCase() {
        const emailToValidate = document.querySelector('[data-emailvalidate]');
        const emailConfirm = document.querySelector('[data-emailconfirm]');

        if (emailConfirm != null) {
            emailToValidate.value = emailToValidate.value.toLowerCase();
            emailConfirm.value = emailConfirm.value.toLowerCase();
        }
    }

    function subscribeToEvents() {
        form.off('submit').on('submit',
            function(event) {
                event.preventDefault();
                updateRegistrationValue($('#Additional-Input-Registration'));
                makeEmailsLowerCase();
                bgl.common.validator.validate(configuration, $(this));
                purchaseSectionValidationMessage();
            });

        $('#Additional-Input-Registration').off('input').on('input',
            function() {
                const start = this.selectionStart;
                const end = this.selectionEnd;

                this.value = this.value.toUpperCase();

                this.setSelectionRange(start, end);
            });

        $('#AdditionalBackButton').off('click').on('click',
            function() {
                const options = {
                    callback: function() {
                        window.location = configuration.PreviousPageUrl;
                    },
                };
                bgl.common.pubsub.emit('PollBasket', options);
            });

        const submitButton = document
            .getElementById(`${configuration.Id}SubmitButton`);
        if (submitButton != null) {
            submitButton.addEventListener('click', () => {
                sessionStorage.setItem('HasEdittedFieldsOnAdditionalDetails', 'true');
                sessionStorage.setItem('HasConfirmedEmail', 'true');
            });
        }

        yearDropdown.on('change', updateMonthDropdown);

        form.find('label').on('keyup',
            bgl.common.keyboardAccessibility.generateClickOnKeypress);
    }

    function purchaseSectionValidationMessage() {
        if (monthValidation.hasClass(errorClass) &&
            yearValidation.hasClass(errorClass)) {
            sectionLabel.addClass(errorClass);
        } else {
            sectionLabel.removeClass(errorClass);
        }
    }

    function updateRegistrationValue(inputField) {
        if (inputField.length !== 0) {
            inputField.val(inputField.val().replace(/\s+/gi, ''));
        }
    }

    function onSuccess(configuration, data) {
        bgl.common.pubsub.emit('PollBasket',
            {
                callback: function() {
                    bgl.components.pagereloader.poller.reloadPage(null, false, data.redirectUrl);
                },
            });
    }

    function onError(configuration) {
        const params = {
            callback: bgl.common.overlay.hide,
            spinnerName: 'addonSpinner',
        };

        bgl.common.pubsub.emit('PollBasket', params);
        bgl.components.additionaldetails.common.init(configuration);
    }

    function updateMonthDropdown() {
        const months = monthDropdown;
        const selectedMonthValue = months.val();
        const currentYear = $(yearDropdown).find('option:eq(1)').val();

        if (yearDropdown.val() == currentYear) {
            months.html(currentYearMonthOptions);
        } else {
            months.html(fullYearMonthOptions);
        }

        months.val(selectedMonthValue);

        // select first value if value is not selected
        if (!months.val()) {
            months.find('option:eq(0)').prop('selected', true);
        }
    }

    function handleEmailConfirmation() {
        const emailInput = document.getElementById('EmailAddressToValidate');
        const emailConfirmInput = document.getElementById('EmailConfirm');

        if (!emailInput || !emailConfirmInput) return;

        if (sessionStorage.getItem('HasConfirmedEmail') === 'true' && emailInput.value) {
            emailConfirmInput.value = emailInput.value;
        }

        emailInput.addEventListener('input', function() {
            if (sessionStorage.getItem('HasConfirmedEmail') === 'true' && emailConfirmInput.value !== this.value) {
                sessionStorage.removeItem('HasConfirmedEmail');
                emailConfirmInput.value = '';
            }
        });

        emailConfirmInput.addEventListener('blur', function() {
            if (this.value === emailInput.value && this.value.trim() !== '') {
                sessionStorage.setItem('HasConfirmedEmail', 'true');
            }
        });
    }

    return {
        init: initComponent,
        load: loadComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();

bgl.components.additionaldetails.vehicleusage = (function() {
    function initComponent() {
        const usageButtons = document.querySelectorAll('[data-usagebtn]');
        usageButtons.forEach(function(button) {
            button.addEventListener('change', function() {
                toggleHelpText(button.getAttribute('data-usagebtn'));
            });
        });

        const initialCheckedUsageButton = document.querySelector('[data-usagebtn]:checked');
        if (initialCheckedUsageButton) {
            toggleHelpText(initialCheckedUsageButton.getAttribute('data-usagebtn'));
        }
    }

    function toggleHelpText(selectedItemCode) {
        const usageHelpTexts = document.querySelectorAll('[data-usagehelptext]');
        usageHelpTexts.forEach(function(text) {
            text.classList.add('hide');
        });

        if (selectedItemCode) {
            const selectedHelpText = document.querySelector(`[data-usagehelptext="${selectedItemCode}"]`);
            if (selectedHelpText) {
                selectedHelpText.classList.remove('hide');
            }
        }
    }

    return {
        init: initComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.additionaldetails.common;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.additionaldetails = bgl.components.additionaldetails || {};

bgl.components.additionaldetails.andfinally = (function() {
    let form;
    let configuration;

    function initComponent(componentConfiguration) {
        configuration = componentConfiguration;
        form = $('#and-finally-form');

        bgl.common.validator.init(form);

        bgl.common.datastore.init(form, false, true);
        bgl.common.datastore.setupReadAndWrite();

        subscribeForEvents();
    }

    function subscribeForEvents() {
        form.off('submit')
            .on('submit',
                function(event) {
                    event.preventDefault();

                    if (bgl.common.validator.isFormValid(form)) {
                        const data = bgl.common.datastore.getData(form) || {};
                        data.__RequestVerificationToken = document
                            .querySelector('input[name="__RequestVerificationToken"]')
                            .value;
                        data.ComponentConfiguration = configuration;

                        bgl.common.validator.submitForm(form, configuration, data);
                    }
                });
    }

    function onSuccess() {
        const options = {
            callback: function() {
                window.location.href = configuration.NextPageUrl;
            },
            hideNotification: true,
        };

        sessionStorage.clear();
        bgl.common.pubsub.emit('PollBasket', options);
    }

    function onError() {
        bgl.components.additionaldetails.andfinally.init(configuration);
    }

    return {
        init: initComponent,
        onSuccess: onSuccess,
        onError: onError,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.singlepagepaymentsummary = (() => {
    let componentConfig;

    function initComponent(componentConfiguration) {
        sessionStorage.setItem('SinglePagePaymentJourney', 'True');
        const hasEdittedFieldsOnAdditionalDetails = 'HasEdittedFieldsOnAdditionalDetails';
        sessionStorage.setItem('SinglePagePaymentJourney', 'True');
        bgl.common.validator.enableMaxLength();
        componentConfig = componentConfiguration;
        setupImportantInformationLinks();

        if (sessionStorage.getItem(hasEdittedFieldsOnAdditionalDetails) &&
            sessionStorage.getItem(hasEdittedFieldsOnAdditionalDetails).toLowerCase() === 'true') {
            showHoustonNotification();
            sessionStorage.removeItem(hasEdittedFieldsOnAdditionalDetails);
        }

        bgl.components.takepayment.documentloader.init(componentConfig);

        if (document.querySelector('[payment-switch-link]') != null) {
            document.querySelector('[payment-switch-link]').addEventListener('click', switchPaymentType);
        }

        const trustpilotWidget = document.getElementById('trustpilot-widget');
        if (trustpilotWidget != null) {
            try {
                window.Trustpilot.loadFromElement(trustpilotWidget);
            } catch {
                onError(null, 'Failed to load trustpilot', 'Fail to load from element', null);
            }
        }

        const expandingPanelButtons = document.querySelectorAll('[data-expandingPanel-button]');

        expandingPanelButtons.forEach(function(button) {
            button.addEventListener('click', (e) => {
                expandingPanelButtonClicked(e.currentTarget);
            });
        });

        if (document.getElementById('IsMonthlyPayment').value.toLowerCase() == 'true') {
            bgl.uil.datepicker.init();
            bgl.components.takepayment.singlepagepaymentmonthlyinstalment.init(componentConfiguration);
        } else {
            bgl.components.takepayment.singlepagepaymentannual.init(componentConfiguration);
        }

        const previouslyCompletedExpandingPanelStep = sessionStorage
            .getItem('TakePaymentSinglePagePaymentCompletedExpandingPanelStep');

        for (let i = 1; i <= previouslyCompletedExpandingPanelStep; i++) {
            const currentExpandingPanel = document.querySelector('[data-expandingPanel-step="' + i + '"]');
            const currentExpandingPanelPill = currentExpandingPanel.querySelector('[data-step-pill]');

            if (!currentExpandingPanelPill.classList.contains('uil-pill--success')) {
                currentExpandingPanelPill.classList.add('uil-pill--success');
            }

            const currentHeaderStep = document.querySelector('[data-header-step="' + i + '"]');
            updateHeaderStep(currentHeaderStep);
        }

        document.getElementById('pay-now-button').addEventListener('click', () => {
            const readConfirmCheckbox = document.getElementById('read-confirm-checkbox');
            if (readConfirmCheckbox.checked) {
                if (document.getElementById('IsMonthlyPayment').value.toLowerCase() === 'true') {
                    bgl.components.takepayment.singlepagepaymentmonthlyinstalment
                        .commitInstalmentAndDepositPaymentsAndBasket(componentConfig);
                } else {
                    bgl.components.takepayment.singlepagepaymentannual.commitPaymentAndBasket(false, componentConfig);
                }
            } else {
                readConfirmCheckbox.classList.add('error');
                document.getElementById('read-confirm-error').classList.remove('hide');
            }
        });

        document.getElementById('read-confirm-checkbox').addEventListener('click', () => {
            const readConfirmCheckbox = document.getElementById('read-confirm-checkbox');
            if (readConfirmCheckbox.checked) {
                readConfirmCheckbox.classList.remove('error');
                document.getElementById('read-confirm-error').classList.add('hide');
            }
        });
    }

    function toggleExpandingPanelVisibility(button) {
        const isAriaExpanded = button.getAttribute('aria-expanded');
        const targetContentId= button.getAttribute('aria-controls');
        const selectedContent = document.getElementById(targetContentId);

        button.setAttribute(
            'aria-expanded',
            isAriaExpanded === 'true' ? 'false' : 'true');

        selectedContent.classList.toggle('hide');
        selectedContent.setAttribute(
            'aria-hidden',
            isAriaExpanded === 'true' ? 'true' : 'false');
    }

    function completePaymentStepAndContinue(currentExpandingPanel, nextExpandingPanel) {
        updateExpandingPanelNavigation(currentExpandingPanel);
        const currentExpandingPanelButton = currentExpandingPanel.querySelector('[data-expandingPanel-button]');
        const nextExpandingPanelButton = nextExpandingPanel.querySelector('[data-expandingPanel-button]');
        toggleExpandingPanelVisibility(currentExpandingPanelButton);
        toggleExpandingPanelVisibility(nextExpandingPanelButton);
        updateExpandingPanelAccessibilityText(currentExpandingPanel, nextExpandingPanel);

        sessionStorage
            .setItem('TakePaymentSinglePagePaymentCompletedExpandingPanelStep',
                currentExpandingPanel.dataset.expandingpanelStep);
    }

    function updateExpandingPanelAccessibilityText(currentExpandingPanel, nextExpandingPanel) {
        const currentPanelPill = currentExpandingPanel.querySelector('[data-step-pill]');
        const currentPanelPillSpan = currentPanelPill.querySelector('span');
        const currentPanelPillSpanContent = currentPanelPillSpan.textContent;
        const nextPanelPill = nextExpandingPanel.querySelector('[data-step-pill]');
        const nextPanelPillSpan = nextPanelPill.querySelector('span');
        const nextPanelPillContent = nextPanelPillSpan.textContent;


        if (currentPanelPillSpanContent.includes('Open')) {
            currentPanelPillSpan.textContent = currentPanelPillSpanContent.replace('Open', 'Closed and complete');
        }

        if (nextPanelPillContent.includes('Closed')) {
            const textToReplace = nextPanelPillContent.includes('Closed and complete') ?
                'Closed and complete' : 'Closed';
            nextPanelPillSpan.textContent = nextPanelPillContent.replace(textToReplace, 'Open');
        }
    }

    function updateExpandingPanelNavigation(currentExpandingPanel) {
        const currentExpandingPanelPill = currentExpandingPanel.querySelector('[data-step-pill]');
        const currentExpandingPanelButton = currentExpandingPanel.querySelector('[data-expandingPanel-button]');

        if (!currentExpandingPanelPill.classList.contains('uil-pill--success')) {
            currentExpandingPanelPill.classList.add('uil-pill--success');
        }

        currentExpandingPanelButton.classList.remove('hide');
    }

    function updateHeaderStep(currentHeaderStep) {
        currentHeaderStep.classList.add('uil-step-icon--success');
    }

    function expandingPanelButtonClicked(targetExpandingPanelButton) {
        const targetExpandingPanel = targetExpandingPanelButton.closest('[data-expandingPanel]');

        if (targetExpandingPanel.id === 'TakePaymentExpandingPanelCardPayment') {
            const isMonthlyPayment = document.getElementById('IsMonthlyPayment').value.toLowerCase() == 'true';
            if (isMonthlyPayment) {
                bgl.components.takepayment.singlepagepaymentmonthlydeposit.init(componentConfig);
            } else {
                bgl.components.takepayment.singlepagepaymentannual.init(componentConfig);
            }
        }

        const targetExpandingPanelButtonStep = targetExpandingPanel.dataset.expandingpanelStep;
        const visibleExpandingPanelButtons = document.querySelectorAll('[data-expandingPanel-button]:not(.hide)');

        for (let i = visibleExpandingPanelButtons.length; i >= targetExpandingPanelButtonStep; i--) {
            visibleExpandingPanelButtons[i - 1].classList.add('hide');
        }

        const currentExpandingPanelButton = document
            .querySelectorAll('[data-expandingPanel-button][aria-expanded="true"]')[0];
        const currentExpandingPanel = currentExpandingPanelButton.closest('[data-expandingPanel]');

        toggleExpandingPanelVisibility(currentExpandingPanelButton);
        toggleExpandingPanelVisibility(targetExpandingPanelButton);
        updateExpandingPanelAccessibilityText(currentExpandingPanel, targetExpandingPanel);
    }

    async function switchPaymentType() {
        const paymentSwitchLinkId = document.querySelector('[payment-switch-link]')
            .getAttribute('id');
        const data = {
            __RequestVerificationToken: document.querySelector('input[name="__RequestVerificationToken"]').value,
            paymentSwitchId: document.querySelector('[payment-switch-link]')
                .getAttribute('data-payment-switch-id'),
        };
        const dataToPost = new URLSearchParams(data).toString();

        bgl.common.fetch.formPost(
            componentConfig.TenantConfiguration.ApplicationPath + 'TakePaymentComponentSinglePage/PaymentSwitch',
            {body: dataToPost},
        ).then(async (response) => {
            const responseBody = await response.json();
            if (!response.ok || !responseBody?.isSuccess) {
                window.location.href = responseBody.errorRedirectUrl;
            } else {
                bgl.common.pubsub.emit('switchPaymentType', paymentSwitchLinkId === 'monthly-switch-link');
                sessionStorage.removeItem('TakePaymentSinglePagePaymentCompletedExpandingPanelStep');
                if (paymentSwitchLinkId === 'monthly-switch-link') {
                    document.getElementById('IsMonthlyPayment').value = 'True';
                    bgl.common.pubsub.emit('showNotification',
                        document.getElementById('monthly-notification-message').value);
                    window.location.reload(true);
                } else if (paymentSwitchLinkId === 'annual-switch-link') {
                    document.getElementById('IsMonthlyPayment').value = 'False';
                    bgl.common.pubsub.emit('showNotification',
                        document.getElementById('annual-notification-message').value);
                    window.location.reload(true);
                }
            }
        }).catch(() => {
            appInsights.trackTrace({message: 'Switch payment type failed'});
        });
    }
    function onError(responseBody, responseError, responseStatusText, dataPosted) {
        if (window.appInsights) {
            bgl.common.telemetry.logEvent(
                'SinglePagePaymentSummary bgl.components.takePayment.responseBody',
                {
                    status: responseStatusText,
                    errorThrown: responseError,
                    dataPosted: dataPosted,
                    responseData: responseBody,
                },
            );
        }
    }

    function showHoustonNotification() {
        const isMonthlyPayment = document.getElementById('IsMonthlyPayment').value;
        if (isMonthlyPayment.toLowerCase() === 'true') {
            bgl.common.pubsub.emit(
                'showNotification',
                'OK ##FIRSTNAME##, your new price is £##PRICE## a month with a deposit of £##DEPOSIT##. ' +
                'The underwriter for your policy is ##UNDERWRITER##.',
            );
        } else {
            bgl.common.pubsub.emit(
                'showNotification',
                'OK ##FIRSTNAME##, your new price is £##PRICE##. The underwriter for your policy is ##UNDERWRITER##.',
            );
        }
    }

    function setupImportantInformationLinks() {
        const legalInformationLinks = document.querySelectorAll('[data-legal-information]');
        legalInformationLinks.forEach(function(link) {
            link.addEventListener('click', function(event) {
                event.preventDefault();
                bgl.common.loader.load({}, this.dataset.actionUrl, this.dataset.container);
            });
        });
    }

    return {
        init: initComponent,
        completePaymentStepAndContinue: completePaymentStepAndContinue,
        updateHeaderStep: updateHeaderStep,
        onError: onError,
        switchPaymentType: switchPaymentType,
        expandingPanelButtonClicked: expandingPanelButtonClicked,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.singlepagepaymentsummary;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.singlepagepaymentmonthlyinstalment = (() => {
    let componentConfig;
    let redirectInterval;
    let redirectTick = 0;
    let isPaymentSuccessful = false;

    function loadComponent(componentConfiguration, componentUrl, containerElementId, callback) {
        componentConfiguration.CardSessionData = getSecureSessionData();
        componentConfiguration.CreditInformationUrl = sessionStorage.getItem('credit-information');
        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
                if (typeof callback === 'function') {
                    callback();
                }
            });
    }

    function initComponent(componentConfiguration) {
        componentConfig = componentConfiguration;

        sortCodeAutoTab();
        initDirectDebit();
        populateBankAccountDetails();
        initCommon(componentConfiguration);

        const datepicker = document.querySelector('[data-datepicker]');
        if (datepicker != null) {
            bgl.uil.datepicker.init();
            datepicker.addEventListener('change', (e) => {
                if (datepicker.checkValidity()) {
                    sessionStorage.setItem('MonthlyInstalmentPaymentDate', e.target.value);
                    postChangePaymentDateToApi(sessionStorage.getItem('MonthlyInstalmentPaymentDate'));
                }
            });
        }

        $('#direct-debit-details').on('click', function() {
            waitForSlidePanelToLoad();
        });

        $(`#importantInfo-payments-instalments,
            #importantInfo-bottom, 
            #intermediary-services-contract-summary-slider-link, 
            #intermediary-services-contract-summary-slider-link-read-confirm`).off('click').on('click', (event) => {
            event.preventDefault();
            const link = $(event.currentTarget);
            bgl.common.loader.load({}, link.data('action-url'), link.data('container'));
        });

        $('#Monthly-Pay-Now-Button').on('click',
            function() {
                if (!$('#Read-Confirm-Checkbox').prop('checked')) {
                    $('#Read-Confirm-Checkbox').addClass('error');
                    $('#Read-Confirm-Error').removeClass('hide');
                } else {
                    commitInstalmentAndDepositPaymentsAndBasket(componentConfig);
                }
            });

        $('#Read-Confirm-Checkbox').on('click',
            function() {
                if ($('#Read-Confirm-Checkbox').prop('checked')) {
                    $('#Read-Confirm-Checkbox').removeClass('error');
                    $('#Read-Confirm-Error').addClass('hide');
                }
            });
    }

    function checkAiComplete(componentConfig) {
        if (sessionStorage.getItem('AI_sentBuffer') === '[]' || redirectTick >= 25) {
            clearInterval(redirectInterval);
            if (isPaymentSuccessful) {
                bgl.common.utilities.redirectToUrl(componentConfig.PaymentSuccessfulUrl);
            } else {
                bgl.common.utilities.redirectToUrl(sessionStorage.getItem('PaymentProcessedRedirectUrl'));
            }
        }
        redirectTick += 1;
    }

    function commitInstalmentAndDepositPaymentsAndBasket(componentConfig) {
        const requestVerificationToken = $('input[name="__RequestVerificationToken"]').val();

        const dataToPost = {
            __RequestVerificationToken: requestVerificationToken,
            commitData: getCommitCardData(),
        };

        $('body').html(bgl.common.spinner.getSpinnerBody('Processing your payment!',
            'Please do not hit the back button or refresh the page'));

        const urlPrefix = componentConfig.TenantConfiguration.ApplicationPath !== null ?
            componentConfig.TenantConfiguration.ApplicationPath : '/';

        $.ajax({
            url: urlPrefix + 'TakePaymentComponentSinglePage/CommitMultiplePaymentBasket',
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (result.isSuccess === false) {
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                    return;
                }
                if (result.PaymentSuccessful === true) {
                    if (typeof bgl.common.pubsub !== 'undefined') {
                        bgl.common.pubsub.emit('fakeFormSubmit', 'PaymentSuccessful');
                    }
                    dataLayerPushPaymentSuccessful();
                    bgl.common.telemetry.logEvent(
                        'PaymentSuccessful',
                        {'PolicyId': result.PolicyId});
                    isPaymentSuccessful = true;
                }
                sessionStorage.setItem('PaymentProcessedRedirectUrl', result.RedirectUrl);
                if (result.PolicyId) {
                    const stringValue = result.PolicyId + '';
                    let length = stringValue.indexOf('-');
                    length = length > 0 ? length : stringValue.length;
                    sessionStorage.setItem('PaymentProcessedPolicyId', stringValue.substring(0, length));
                    sessionStorage.setItem('Authorization', result.Authorization);
                }
            },
            complete: function() {
                redirectInterval = setInterval(checkAiComplete, 200, componentConfig);
            },
        });
    }

    function getCommitCardData() {
        const model = {};
        const directDebitNumber = sessionStorage.getItem('MonthlyInstalmentDetails1');
        const directDebitCode = sessionStorage.getItem('MonthlyInstalmentDetails2');
        model.TodaysPaymentCard = getDepositCardData();
        model.ContinuousPaymentCard = getInstalmentCardData();
        model.ContinuousPaymentDirectDebit = getInstalmentDirectDebitData();
        model.PaymentType = sessionStorage.getItem('MonthlyInstalmentPaymentType');
        model.UseContinuousPaymentCardForTodaysPayment = sessionStorage.getItem('UseMonthlyInstalmentCard');
        if (!directDebitNumber && !directDebitCode) {
            bgl.common.telemetry.logEvent('MonthlyInstallmentDetails', {'Status': 'Not available'});
        } else {
            model.DirectDebitNumber = directDebitNumber;
            model.DirectDebitCode = directDebitCode;
        }
        model.PaymentDeclinedUrl = componentConfig.PaymentDeclinedUrl;
        model.ComponentConfiguration = componentConfig;
        return model;
    }

    function getDepositCardData() {
        const model = {};
        model.SelectedPersonIdText = sessionStorage.getItem('MonthlyDepositSelectedPersonIdText');
        model.CardCaptureUri = sessionStorage.getItem('MonthlyDepositCardCaptureUri');
        model.SecureSessionId = sessionStorage.getItem('MonthlyDepositSecureSessionId');
        model.SelectedPersonIdVal = sessionStorage.getItem('MonthlyDepositSelectedPersonIdVal');
        return model;
    }

    function getInstalmentCardData() {
        const model = {};
        model.SelectedPersonIdText = sessionStorage.getItem('MonthlyInstalmentCardSelectedPersonIdText');
        model.SecureSessionId = sessionStorage.getItem('MonthlyInstalmentSecureSessionId');
        model.SelectedPersonIdVal = sessionStorage.getItem('MonthlyInstalmentCardSelectedPersonIdVal');
        return model;
    }

    function getInstalmentDirectDebitData() {
        const model = {};
        model.SelectedPersonIdText = sessionStorage.getItem('MonthlyInstalmentDirectDebitSelectedPersonIdText');
        model.SelectedPersonIdVal = sessionStorage.getItem('MonthlyInstalmentDirectDebitSelectedPersonIdVal');
        return model;
    }

    function dataLayerPushPaymentSuccessful() {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                'event': 'TEVirtualPageview',
                'virtualPageURL': 'Payment/Successful',
                'virtualPageTitle': 'Payment Successful',
            });
        }
    }

    function waitForSlidePanelToLoad() {
        window.setTimeout(function() {
            if ($('#SlidePanel').hasClass('active')) {
                const directDebitDetails = $('#direct-debit-info').html();
                $('#SlidePanelContent').html(directDebitDetails);
            } else {
                waitForSlidePanelToLoad();
            }
        }, 100);
    }

    function initCommon(componentConfiguration) {
        const accessible = componentConfiguration.ViewOptions.MonthlyInstalment === 2;
        if (accessible) {
            setupAriaLabeltoDates();
        }
        bgl.common.datastore.setupReadAndWrite();
        forceMonthlyPaymentMethodStoreAndSetPaymentDate();
    }

    function initDirectDebit() {
        sessionStorage.setItem('MonthlyInstalmentPaymentType', 'DirectDebit');
        bgl.common.validator.enableMaxLength();
        bgl.common.validator.init($('#Direct-Debit-Form'),
            {
                onfocusout: function(element) {
                    checkSortcodeValidation(element);
                    checkAccountNumberValidation(element);
                },
                hasSubmit: false,
            });

        $('#Direct-Debit-Authorise-Row label').on('click',
            function() {
                $('#' + $(this).attr('for')).click().focusout();
            });

        $('#Direct-Debit-Continue-Button').on('click',
            function(event) {
                event.preventDefault();
                const formIsValid = $('#Direct-Debit-Form').valid();
                if (formIsValid) {
                    validateBankAccountAndSortCode(function() {
                        saveDataToSessionStorage();
                        completeDirectDebitStepAndContinue();
                    });
                } else {
                    checkSortcodeValidation($('#SortCodePart1'));
                    getValidationMessages();
                    scrollToFirstFieldWithErrorAndFocus();
                }

                return formIsValid;
            });

        $('input[type=radio][name=monthly-payment]').on('change', function() {
            if (this.value == 'DirectDebit') {
                $('#Direct-Debit-Continue-Button').removeClass('hide');
            } else {
                $('#Direct-Debit-Continue-Button').addClass('hide');
            }
        });
    }

    function getValidationMessages() {
        if ($('.form-row').hasClass('error')) {
            const data = {
                form_section: getFormSectionName($(this)),
                error_details: [],
            };

            $('.error').find('.form-row__validation-text').each(function() {
                addError(data, $(this).attr('data-valmsg-for'), $(this).text().trim());
            });

            const sortcodeValiationElement = $('#sortcode-validation-text');
            if (sortcodeValiationElement.length == 1 && !sortcodeValiationElement.hasClass('hide')) {
                addError(
                    data,
                    $('#form-row-sortcode1 fieldset legend').text().trim(),
                    $('#sortcode-validation-text').text().trim(),
                );
            }

            const sortcodeApiValidationElement = $('#sortcode-api-validation-message');
            if (sortcodeApiValidationElement.length == 1 && !sortcodeApiValidationElement.hasClass('hide')) {
                addError(
                    data,
                    $('#form-row-sortcode1 fieldset legend').text().trim(),
                    $('#sortcode-api-validation-message').text().trim(),
                );
            }

            bgl.common.pubsub.emit('formValidationFailed', data);
        }
    }

    function addError(data, field, message) {
        const errorDetail = {
            error_field: field,
            error_message: message,
        };
        data.error_details.push(errorDetail);
    }

    function getFormSectionName() {
        const formRow = '.form-row__validation-text';
        if ($(formRow).parents().find('.step-form__section-title').text().length === 0) {
            return $(formRow).closest('form').find('h1').text();
        } else {
            return $(formRow).closest('form').find('.step-form__section-title').text();
        }
    }

    function scrollToFirstFieldWithErrorAndFocus() {
        const firstRequiredField = $('.error,.sort-code__input--error').first();
        $('html,body').animate({scrollTop: firstRequiredField.offset().top}, 'slow');

        if (firstRequiredField.length) {
            const invalidInputElem = firstRequiredField.find('input, select, textarea')
                .addBack('input, select, textarea')[0];
            if (invalidInputElem !== undefined) {
                invalidInputElem.focus();
            }
        }
    }

    function checkAccountNumberValidation(element) {
        let isValid = false;

        if ($(element).hasClass('form-row__input account-number sort-code__input--error')) {
            $('#account-number-validation-message').addClass('hide');
        }
        if ($(element).hasClass('form-row__input account-number')) {
            isValid = $('#direct-debit-account-number').valid();
        }
        if (isValid) {
            removeAccountErrorStyle();
        }
    }

    function checkSortcodeValidation(element) {
        removeApiValidationErrorMessage(element);
        validateIndividualSortCodeInput(element);
        clearValidationErrorStylingWhenAllSortCodeInputsAreValid();
    }

    function removeApiValidationErrorMessage(element) {
        if ($(element).hasClass('form-row__input--sort-code') &&
            !$('#sortcode-api-validation-message').hasClass('hide')) {
            removeSortCodeErrorStyle();
        }
    }

    function validateIndividualSortCodeInput(element) {
        if ($(element).valid()) {
            removeIndividualSortCodeErrorStyle(element);
        } else {
            addIndividualSortCodeErrorStyle(element);
        }
        $('#form-row-sortcode1').removeClass('error');
    }

    function clearValidationErrorStylingWhenAllSortCodeInputsAreValid() {
        const allSortCodeInputsValid = checkAllSortCodeInputsAreValid();
        if (allSortCodeInputsValid) {
            $('#SortCodeLabel').removeClass('sort-code__label--error');
            $('#sortcode-validation-text').addClass('hide');
        }
    }

    function checkAllSortCodeInputsAreValid() {
        let allSortCodeInputsValid = true;

        $('.form-row__input--sort-code').each(function() {
            if ($(this).hasClass('sort-code__input--error')) {
                allSortCodeInputsValid = false;
            }
        });

        return allSortCodeInputsValid;
    }

    function setupAriaLabeltoDates() {
        const selectList = document.getElementById('Direct-Debit-Payment-Date-Label');
        const selectCreditCardList = document.getElementById('Credit-Card-Payment-Date-Label');
        selectList.setAttribute('aria-label', 'Please Select preferred first instalment date from given list');
        selectCreditCardList.setAttribute(
            'aria-label',
            'Please Select preferred first instalment date from given list',
        );
    }

    function sortCodeKeyUpEvent(event, currentSortCodePart, nextSortCodePart) {
        const TAB_KEYCODE = 9;
        const SHIFT_KEYCODE = 16;
        const LEFT_ARROW_KEYCODE = 37;
        const UP_ARROW_KEYCODE = 38;
        const RIGHT_ARROW_KEYCODE = 39;
        const DOWN_ARROW_KEYCODE = 40;

        const currentLength = $(currentSortCodePart).val().length;
        if (currentLength === 2 &&
            event.which !== TAB_KEYCODE &&
            event.which !== SHIFT_KEYCODE &&
            event.which !== LEFT_ARROW_KEYCODE &&
            event.which !== UP_ARROW_KEYCODE &&
            event.which !== RIGHT_ARROW_KEYCODE &&
            event.which !== DOWN_ARROW_KEYCODE) {
            $(nextSortCodePart).focus().select();
        }
    }

    function sortCodeAutoTab() {
        const container1 = document.getElementById('SortCodePart1');
        const container2 = document.getElementById('SortCodePart2');

        container1.onkeyup = function(e) {
            sortCodeKeyUpEvent(e, '#SortCodePart1', '#SortCodePart2');
        };

        container2.onkeyup = function(e) {
            sortCodeKeyUpEvent(e, '#SortCodePart2', '#SortCodePart3');
        };
    }

    function postChangePaymentDateToApi(nominatedDate) {
        const dataToPost = {
            __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val(),
            nominatedDate: formatDate(nominatedDate),
        };

        $.ajax({
            url: componentConfig.TenantConfiguration.ApplicationPath +
                'TakePaymentComponentSinglePage/ChangePaymentDate',
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (result.isSuccess === false) {
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                    return true;
                }
                return true;
            },
        });
    }

    function formatDate(nominatedDate) {
        const date = new Date(nominatedDate);

        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        const formattedDay = day < 10 ? '0' + day : day;
        const formattedMonth = month < 10 ? '0' + month : month;

        return `${formattedDay}-${formattedMonth}-${year}`;
    }

    function forceMonthlyPaymentMethodStoreAndSetPaymentDate() {
        $('.monthly-radio__label').on('click',
            function() {
                $('#' + $(this).attr('for')).click().focusout();
                $('#Direct-Debit-Payment-Date, #Credit-Card-Payment-Date')
                    .val(sessionStorage.getItem('MonthlyInstalmentPaymentDate'));
            });
    }


    function getSecureSessionData() {
        return {
            'Name': sessionStorage.getItem('MonthlyInstalmentCardSelectedPersonIdText'),
            'SecureSessionId': sessionStorage.getItem('MonthlyInstalmentSecureSessionId'),
            'SelectedPersonId': sessionStorage.getItem('MonthlyInstalmentCardSelectedPersonIdVal'),
            'ThreeDSecureUri': sessionStorage.getItem('MonthlyInstalmentThreeDSecureUri'),
        };
    }

    function saveDataToSessionStorage() {
        const model = {
            sortCode: document.getElementById('SortCodePart1').value +
                document.getElementById('SortCodePart2').value +
                document.getElementById('SortCodePart3').value,
            accountNumber: document.getElementById('direct-debit-account-number').value,
        };

        const dataToPost = {
            __RequestVerificationToken: document.querySelector('input[name="__RequestVerificationToken"]').value,
            BankAccountAndSortCodeModel: model,
            encryptData: true,
        };

        $.ajax({
            url: componentConfig.TenantConfiguration.ApplicationPath +
                'TakePaymentComponentSinglePage/AccountDetailsCryptography',
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (!result.isSuccess) {
                    bgl.common.telemetry.logEvent('MonthlyInstalmentDetails', {'Status': result.message});
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                    return false;
                }

                sessionStorage.setItem('MonthlyInstalmentDetails1', result.accountNumber);
                sessionStorage.setItem('MonthlyInstalmentDetails2', result.sortCode);

                if (sessionStorage.getItem('CardDetailsAlreadyEnteredMonthly') !== null &&
                    sessionStorage.getItem('CardDetailsAlreadyEnteredMonthly').toLowerCase() == 'true') {
                    bgl.components.takepayment.readonlycarddetails
                        .load(
                            componentConfig,
                            componentConfig.TenantConfiguration.ApplicationPath +
                            'TakePaymentComponentSinglePage/ReadOnlyCardDetails',
                            'TakePaymentExpandingPanelCardPaymentContent',
                        );
                } else {
                    bgl.components.takepayment.singlepagepaymentmonthlydeposit.init(componentConfig);
                }

                return true;
            },
        });
    }

    function completeDirectDebitStepAndContinue() {
        const currentExpandingPanel = document.getElementById('TakePaymentExpandingPanelDirectDebit');
        const nextExpandingPanel = document.getElementById('TakePaymentExpandingPanelCardPayment');
        const currentHeaderStep = document.getElementById('TakePaymentHeaderDirectDebit');

        bgl.components.takepayment.singlepagepaymentsummary.completePaymentStepAndContinue(
            currentExpandingPanel,
            nextExpandingPanel,
        );

        bgl.components.takepayment.singlepagepaymentsummary.updateHeaderStep(
            currentHeaderStep,
        );

        currentExpandingPanel.scrollIntoView(true);
    }

    function populateBankAccountDetails() {
        const bankAccountNumberEn = sessionStorage.getItem('MonthlyInstalmentDetails1');
        const sortCodeEn = sessionStorage.getItem('MonthlyInstalmentDetails2');
        if (bankAccountNumberEn != null || sortCodeEn != null) {
            const model = {
                sortCode: sortCodeEn,
                accountNumber: bankAccountNumberEn,
            };
            const dataToPost = {
                __RequestVerificationToken: document.querySelector('input[name="__RequestVerificationToken"]').value,
                BankAccountAndSortCodeModel: model,
                encryptData: false,
            };

            $.ajax({
                url: componentConfig.TenantConfiguration.ApplicationPath +
                    'TakePaymentComponentSinglePage/AccountDetailsCryptography',
                type: 'POST',
                cache: false,
                dataType: 'json',
                data: dataToPost,
                success: function(result) {
                    if (!result.isSuccess) {
                        bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                        return false;
                    }
                    document.getElementById('direct-debit-account-number').value = result.accountNumber;
                    const sortCode = result.sortCode;
                    document.getElementById('SortCodePart1').value = sortCode.substring(0, 2);
                    document.getElementById('SortCodePart2').value = sortCode.substring(2, 4);
                    document.getElementById('SortCodePart3').value = sortCode.substring(4, 6);
                    return true;
                },
            });
        }
        return false;
    }

    function validateBankAccountAndSortCode(saveDataToSessionStorageCallBack) {
        const dataToPost = {
            __RequestVerificationToken: document.querySelector('input[name="__RequestVerificationToken"]').value,
            sortCode: document.getElementById('SortCodePart1').value +
                document.getElementById('SortCodePart2').value +
                document.getElementById('SortCodePart3').value,
            accountNumber: document.getElementById('direct-debit-account-number').value,
        };
        $.ajax({
            url: componentConfig.TenantConfiguration.ApplicationPath +
                'TakePaymentComponentSinglePage/PostAccountNumberAndSortCode',
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (!result.isSuccess) {
                    bgl.common.telemetry.logEvent('MonthlyInstalmentDetailsStatus', {'message': result.message});
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                    return false;
                }

                switch (result.Result) {
                case 'Validated':
                    if (typeof bgl.common.pubsub !== 'undefined') {
                        bgl.common.pubsub.emit(
                            'fakeFormSubmit',
                            $('#Direct-Debit-Form').attr('id') ||
                            $('#Direct-Debit-Form').attr('action') ||
                            'unknown',
                        );
                    }
                    removeSortCodeErrorStyle();
                    removeAccountErrorStyle();
                    saveDataToSessionStorageCallBack();
                    return true;
                case 'no values submitted':
                case 'sort code or account number invalid':
                    addAccountErrorStyle();
                    addSortCodeErrorStyle();
                    break;
                case 'sortCode invalid':
                    addSortCodeErrorStyle();
                    break;
                case 'accountNumber invalid':
                    addAccountErrorStyle();
                    break;
                }

                scrollToFirstFieldWithErrorAndFocus();
                return false;
            },
        });
    }

    function removeSortCodeErrorStyle() {
        $('#sortcode-api-validation-message').addClass('hide');
        $('#SortCodeLabel').removeClass('sort-code__label--error');
        $('#sortcode-api-validation-message').removeClass('sort-code__span--error');
        $('#SortCodePart1,#SortCodePart2,#SortCodePart3').removeClass('sort-code__input--error');
        $('#sort-code-input-1, #sort-code-input-2, #sort-code-input-3').removeClass('error');
        cleanAriaDescribedBy('#sort-code-input-1');
    }

    function addSortCodeErrorStyle() {
        $('#sortcode-api-validation-message').removeClass('hide');
        $('#SortCodeLabel').addClass('sort-code__label--error');
        $('#sortcode-api-validation-message').addClass('sort-code__span--error');
        $('#SortCodePart1,#SortCodePart2,#SortCodePart3').addClass('sort-code__input--error');
        $('#sort-code-input-1, #sort-code-input-2, #sort-code-input-3').addClass('error');

        cleanAriaDescribedBy($('#SortCodePart1,#SortCodePart2,#SortCodePart3'));
        $('#SortCodePart1,#SortCodePart2,#SortCodePart3').attr('aria-describedby', 'sortcode-api-validation-message');
    }

    function removeIndividualSortCodeErrorStyle(element) {
        $(element).removeClass('sort-code__input--error');
        cleanAriaDescribedBy(element);
    }

    function addIndividualSortCodeErrorStyle(element) {
        $('#SortCodeLabel').addClass('sort-code__label--error');
        $('#sortcode-validation-text').removeClass('hide');
        $(element).addClass('sort-code__input--error');

        cleanAriaDescribedBy(element);

        if ($(element).hasClass('form-row__input account-number sort-code__input--error')) {
            element.setAttribute('aria-describedby', 'direct-debit-account-number-error');
        } else if ($(element)
            .hasClass('form-row__input form-row__input--radio form-row__input--hidden sort-code__input--error')) {
            element.setAttribute('aria-describedby', 'DirectDebitData.CanAuthorise-error');
        } else {
            $(element).attr('aria-describedby', 'sortcode-validation-text');
        }
    }

    function addAccountErrorStyle() {
        $('#account-number-validation-message').removeClass('hide');
        $('#AccountNumberLabel').addClass('sort-code__label--error');
        $('#account-number-validation-message').addClass('sort-code__span--error');
        $('#direct-debit-account-number').addClass('sort-code__input--error');
        $('#account-number-input').addClass('error');

        cleanAriaDescribedBy($('#account-number-input'));
        $('#direct-debit-account-number').attr('aria-describedby', 'account-number-validation-message');
    }

    function removeAccountErrorStyle() {
        $('#account-number-validation-message').addClass('hide');
        $('#AccountNumberLabel').removeClass('sort-code__label--error');
        $('#account-number-validation-message').removeClass('sort-code__span--error');
        $('#direct-debit-account-number').removeClass('sort-code__input--error');
        $('#account-number-input').removeClass('error');
        cleanAriaDescribedBy('#account-number-input');
    }

    function cleanAriaDescribedBy(element) {
        if ($(element).attr('aria-describedby')) {
            $(element).removeAttr('aria-describedby');
        }
    }

    return {
        init: initComponent,
        load: loadComponent,
        getValidationMessages: getValidationMessages,
        commitInstalmentAndDepositPaymentsAndBasket: commitInstalmentAndDepositPaymentsAndBasket,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.singlepagepaymentmonthlydeposit = (function() {
    let componentConfiguration;
    let hideElementsWhen3DSecureIsDisplayedTimeout;

    function loadComponent(componentConfiguration, componentUrl, containerElementId, requestedEditCard) {
        componentConfiguration.CardSessionData = getSecureSessionData();
        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration, requestedEditCard);
            });
    }

    function initComponent(configuration, requestedEditCard = false) {
        componentConfiguration = configuration;

        if (sessionStorage.getItem('CardDetailsAlreadyEnteredMonthly') !== null &&
            sessionStorage.getItem('CardDetailsAlreadyEnteredMonthly').toLowerCase() == 'true' &&
            !requestedEditCard) {
            componentConfiguration.CardSessionData = getSecureSessionData();

            bgl.components.takepayment.readonlycarddetails.load(
                componentConfiguration,
                componentConfiguration.TenantConfiguration.ApplicationPath +
                'TakePaymentComponentSinglePage/ReadOnlyCardDetails',
                'TakePaymentExpandingPanelCardPaymentContent',
            );
        } else {
            bgl.common.datastore.setupReadAndWrite();

            loadIframe();

            setVisibilityOfCardholderNameOther();

            setCardInformation();

            bgl.common.validator.enableMaxLength();

            bgl.common.validator.init($('#MonthlyDepositPaymentForm'),
                {
                    onkeyup: function(element) {
                        validateElementAndToggleIframe(element);
                    },
                    hasSubmit: false,
                });

            $('#PersonListData_SelectedPersonId').change(
                function() {
                    if ($('#PersonListData_SelectedPersonId').find(':selected').text() === 'Other') {
                        $('#CardholderNameRow').removeClass('hide');
                        $('#Card-Capture-Iframe').addClass('hide');
                        sessionStorage.setItem('MonthlyDepositSelectedPersonIdText', '');
                        $('#CardholderName').val('');
                        $('#CardholderName').focus();
                    } else {
                        $('#CardholderNameRow').addClass('hide');
                        $('#Card-Capture-Iframe').removeClass('hide');
                    }

                    initCardCapture();
                });

            if ($('#PersonListData_SelectedPersonId').find(':selected').text() === 'Other') {
                validateElementAndToggleIframe($('#MonthlyDepositPaymentForm'));
            }

            setupHowToPayButtons();

            $('#Card-Capture-Iframe').on('load', function() {
                hideElementsWhen3DSecureIsDisplayed();
            });
        }
    }


    function initCardCapture() {
        sessionStorage.removeItem('MonthlyDepositCardCaptureUri');
        sessionStorage.removeItem('MonthlyDepositSecureSessionId');
        sessionStorage.removeItem('MonthlyDepositThreeDSecureUri');

        if (hideElementsWhen3DSecureIsDisplayedTimeout) {
            clearTimeout(hideElementsWhen3DSecureIsDisplayedTimeout);
        }

        bgl.components.takepayment.cardcaptureiframe.clearIframe();

        componentConfiguration.CardSessionData = {'SelectedPersonId': $('#PersonListData_SelectedPersonId').val()};

        const dataToPost = {
            __RequestVerificationToken: $('input[name=\'__RequestVerificationToken\']').val(),
            configuration: componentConfiguration,
        };

        $.ajax({
            url: componentConfiguration.TenantConfiguration.ApplicationPath +
                'TakePaymentComponentSinglePage/InitialiseMonthlyCardCapture',
            type: 'POST',
            data: dataToPost,
            success: function(data) {
                sessionStorage.setItem('MonthlyDepositCardCaptureUri', data.cardCaptureUri);
                sessionStorage.setItem('MonthlyDepositSecureSessionId', data.secureSessionId);
                sessionStorage.setItem('MonthlyDepositThreeDSecureUri', data.threeDSecureUri);

                loadIframe();
            },
        });
    }

    function loadIframe() {
        const cardSessionData = getSecureSessionData();
        bgl.components.takepayment.cardcaptureiframe.loadIframe(
            'Card-Capture-Iframe',
            cardSessionData.CardCaptureUri,
            cardSessionData.SecureSessionId,
            cardSessionData.ThreeDSecureUri);
    }

    function validateElementAndToggleIframe(element) {
        const valid = $(element).valid();
        if (valid === true) {
            $('#Card-Capture-Iframe').removeClass('hide');
        } else {
            $('#Card-Capture-Iframe').addClass('hide');
        }
    }

    function hideElementsWhen3DSecureIsDisplayed() {
        if ($('#Card-Capture-Iframe').contents().find('#continue').length === 0) {
            $('#MonthlyDepositCardholderNameFormRow').hide();
            $('#CardholderNameRow').hide();
            $('#today-payment-section').hide();
            return;
        }

        hideElementsWhen3DSecureIsDisplayedTimeout = setTimeout(function() {
            hideElementsWhen3DSecureIsDisplayed();
        }, 1000);
    }

    function setupHowToPayButtons() {
        setUseMonthlyInstalmentCard('false');

        $('#deposit-new-card').on('click',
            function() {
                $('#deposit-iframe-section').removeClass('hide');
                if ($('#PersonListData_SelectedPersonId').find(':selected').text() === 'Other') {
                    validateElementAndToggleIframe($('#MonthlyDepositPaymentForm'));
                }
            });

        $('#deposit-instalment-card, #deposit-card-icons-instalment-card').on('click',
            function() {
                setUseMonthlyInstalmentCard('true');
                const actionUrl = $(this).data('action-url');
                bgl.common.utilities.redirectToUrl(actionUrl);
            });

        addCardTypeClassToCardBox();

        addCardTypeForCardIconsClassToCardBox();

        if (instalmentsPaidByDirectDebit()) {
            $('#today-payment-section, #deposit-new-card').addClass('hide');
            $('#deposit-iframe-section').removeClass('hide');
        }
    }

    function setUseMonthlyInstalmentCard(value) {
        sessionStorage.setItem('UseMonthlyInstalmentCard', value);
    }

    function addCardTypeClassToCardBox() {
        $('#deposit-instalment-card').addClass('payment-card--' + sessionStorage.getItem('MonthlyInstalmentCardType'));
    }

    function addCardTypeForCardIconsClassToCardBox() {
        $('#deposit-card-icons-instalment-card')
            .find('.payment-card__type')
            .addClass('payment-card-new--' + sessionStorage.getItem('MonthlyInstalmentCardType'));
    }

    function instalmentsPaidByDirectDebit() {
        return sessionStorage.getItem('MonthlyInstalmentPaymentType') === 'DirectDebit';
    }

    function getSecureSessionData() {
        return {
            'Name': sessionStorage.getItem('MonthlyDepositSelectedPersonIdText'),
            'CardCaptureUri': sessionStorage.getItem('MonthlyDepositCardCaptureUri'),
            'SecureSessionId': sessionStorage.getItem('MonthlyDepositSecureSessionId'),
            'SelectedPersonId': sessionStorage.getItem('MonthlyDepositSelectedPersonIdVal'),
            'ThreeDSecureUri': sessionStorage.getItem('MonthlyDepositThreeDSecureUri'),
        };
    }

    function setVisibilityOfCardholderNameOther() {
        if ($('#PersonListData_SelectedPersonId').find(':selected').text() === 'Other') {
            $('#CardholderNameRow').removeClass('hide');
            $('#CardholderName').focus();
        }
    }

    function setCardInformation() {
        $('#card-info-date').text('Expires: ' + sessionStorage.getItem('MonthlyInstalmentCardExpiry'));
        $('#card-info-name').text(sessionStorage.getItem('MonthlyDepositSelectedPersonIdText'));
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.singlepagepaymentcardcapturecompleted = (() => {
    function initComponent(redirectUrl) {
        if (redirectUrl.toLowerCase().includes('decline') || redirectUrl.toLowerCase().includes('unsuccessful')) {
            /* iframe stores monthly/annual sessions separately. Both are cleared in payment declined.
               CardDetailsAlreadyEntered must also be cleared for both */
            if (sessionStorage.getItem('CardDetailsAlreadyEnteredMonthly')) {
                sessionStorage.removeItem('CardDetailsAlreadyEnteredMonthly');
            }

            if (sessionStorage.getItem('CardDetailsAlreadyEnteredAnnual')) {
                sessionStorage.removeItem('CardDetailsAlreadyEnteredAnnual');
            }

            bgl.common.utilities.redirectToUrl(redirectUrl);
        } else {
            const paymentFrequency = document.getElementById('IsMonthlyPayment').value.toLowerCase() ==
                'true' ? 'Monthly' : 'Annual';
            sessionStorage.setItem(`CardDetailsAlreadyEntered${paymentFrequency}`, true);

            const currentExpandingPanel = document.getElementById('TakePaymentExpandingPanelCardPayment');
            const nextExpandingPanel = document.getElementById('TakePaymentExpandingPanelLegal');
            const currentHeaderStep = document.getElementById('TakePaymentHeaderCardPayment');

            bgl.components.takepayment.singlepagepaymentsummary.completePaymentStepAndContinue(
                currentExpandingPanel,
                nextExpandingPanel,
            );

            bgl.components.takepayment.singlepagepaymentsummary.updateHeaderStep(currentHeaderStep);
        }
    }

    return {
        init: initComponent,
    };
})();

if (typeof module !== 'undefined') {
    module.exports = bgl.components.takepayment.singlepagepaymentsummary;
}
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.singlepagepaymentannual = (() => {
    let componentConfiguration;
    let redirectInterval;
    let redirectTick = 0;
    let isPaymentSuccessful = false;
    let hideElementsWhen3DSecureIsDisplayedTimeout;

    function loadComponent(componentConfiguration, componentUrl, containerElementId, requestedEditCard) {
        componentConfiguration.CardSessionData = getSecureSessionData();

        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration, requestedEditCard);
            });
    }

    function initComponent(configuration, requestedEditCard = false) {
        componentConfiguration = configuration;

        if (sessionStorage.getItem('CardDetailsAlreadyEnteredAnnual') !== null &&
            sessionStorage.getItem('CardDetailsAlreadyEnteredAnnual').toLowerCase() == 'true' &&
            !requestedEditCard) {
            componentConfiguration.CardSessionData = getSecureSessionData();

            bgl.components.takepayment.readonlycarddetails.load(
                componentConfiguration,
                componentConfiguration.TenantConfiguration.ApplicationPath +
                'TakePaymentComponentSinglePage/ReadOnlyCardDetails',
                'TakePaymentExpandingPanelCardPaymentContent',
            );
        } else {
            bgl.common.datastore.setupReadAndWrite();

            loadIframe();

            setVisibilityOfCardholderNameOther();

            bgl.common.validator.enableMaxLength();

            $('#AnnualPaymentForm').off('submit').on('submit',
                function(e) {
                    e.preventDefault();
                });

            bgl.common.validator.init($('#AnnualPaymentForm'),
                {
                    onkeyup: function(element) {
                        validateElementAndToggleIframe(element);
                    },
                    hasSubmit: false,
                });

            $('#Card-Capture-Iframe').on('load',
                function() {
                    hideElementsWhen3DSecureIsDisplayed();
                });

            $('#PersonListData_SelectedPersonId').change(
                function() {
                    if (isOtherSelected()) {
                        $('#CardholderNameRow').removeClass('hide');
                        $('#Card-Capture-Iframe').addClass('hide');
                        sessionStorage.setItem('AnnualSelectedPersonIdText', '');
                        $('#CardholderName').val('');
                        $('#CardholderName').focus();
                    } else {
                        $('#CardholderNameRow').addClass('hide');
                        $('#Card-Capture-Iframe').removeClass('hide');
                    }

                    initCardCapture();
                });

            if (isOtherSelected()) {
                validateElementAndToggleIframe($('#AnnualPaymentForm'));
            }
        }
    }

    function initCardCapture() {
        sessionStorage.removeItem('AnnualCardCaptureUri');
        sessionStorage.removeItem('AnnualSecureSessionId');
        sessionStorage.removeItem('AnnualThreeDSecureUri');

        if (hideElementsWhen3DSecureIsDisplayedTimeout) {
            clearTimeout(hideElementsWhen3DSecureIsDisplayedTimeout);
        }

        bgl.components.takepayment.cardcaptureiframe.clearIframe();

        componentConfiguration.CardSessionData = {'SelectedPersonId': $('#PersonListData_SelectedPersonId').val()};

        const dataToPost = {
            __RequestVerificationToken: $('input[name=\'__RequestVerificationToken\']').val(),
            configuration: componentConfiguration,
        };

        $.ajax({
            url: componentConfiguration.TenantConfiguration.ApplicationPath +
            'TakePaymentComponentSinglePage/InitialiseAnnualCardCapture',
            type: 'POST',
            data: dataToPost,
            success: function(data) {
                sessionStorage.setItem('AnnualCardCaptureUri', data.cardCaptureUri);
                sessionStorage.setItem('AnnualSecureSessionId', data.secureSessionId);
                sessionStorage.setItem('AnnualThreeDSecureUri', data.threeDSecureUri);

                loadIframe();
            },
        });
    }

    function loadIframe() {
        const cardSessionData = getSecureSessionData();
        bgl.components.takepayment.cardcaptureiframe.loadIframe(
            'Card-Capture-Iframe',
            cardSessionData.CardCaptureUri,
            cardSessionData.SecureSessionId,
            cardSessionData.ThreeDSecureUri);
    }

    function validateElementAndToggleIframe(element) {
        const valid = $(element).valid();
        if (valid === true) {
            $('#Card-Capture-Iframe').removeClass('hide');
        } else {
            $('#Card-Capture-Iframe').addClass('hide');
        }
    }

    function isOtherSelected() {
        return $('#PersonListData_SelectedPersonId').find(':selected').text() === 'Other';
    }

    function getSecureSessionData() {
        return {
            'Name': sessionStorage.getItem('AnnualSelectedPersonIdText'),
            'CardCaptureUri': sessionStorage.getItem('AnnualCardCaptureUri'),
            'SecureSessionId': sessionStorage.getItem('AnnualSecureSessionId'),
            'SelectedPersonId': sessionStorage.getItem('AnnualSelectedPersonIdVal'),
            'ThreeDSecureUri': sessionStorage.getItem('AnnualThreeDSecureUri'),
        };
    }

    function setVisibilityOfCardholderNameOther() {
        if ($('#PersonListData_SelectedPersonId').find(':selected').text() === 'Other') {
            $('#CardholderNameRow').removeClass('hide');
            $('#CardholderName').focus();
        }
    }

    function hideElementsWhen3DSecureIsDisplayed() {
        if ($('#Card-Capture-Iframe').contents().find('#continue').length === 0) {
            $('#AnnualCardholderNameFormRow').hide();
            $('#CardholderNameRow').hide();
            return;
        }

        hideElementsWhen3DSecureIsDisplayedTimeout = setTimeout(function() {
            hideElementsWhen3DSecureIsDisplayed();
        }, 1000);
    }

    function checkAiComplete(componentConfig) {
        if (sessionStorage.getItem('AI_sentBuffer') === '[]' || redirectTick >= 25) {
            clearInterval(redirectInterval);
            if (isPaymentSuccessful) {
                bgl.common.utilities.redirectToUrl(componentConfig.PaymentSuccessfulUrl);
            } else {
                bgl.common.utilities.redirectToUrl(sessionStorage.getItem('PaymentProcessedRedirectUrl'));
            }
        }
        redirectTick += 1;
    }

    function commitPaymentAndBasket(commitMultiplePayment, componentConfig) {
        const postMethod = commitMultiplePayment ? 'CommitMultiplePaymentBasket' : 'CommitSinglePaymentBasket';

        const dataToPost = {
            __RequestVerificationToken: document.querySelector('input[name="__RequestVerificationToken"]').value,
            commitData: commitMultiplePayment ?
                getCommitMultiplePaymentData(componentConfig) :
                getCommitCardData(componentConfig),
        };

        $('body').html(bgl.common.spinner.getSpinnerBody('Processing your payment!',
            'Please do not hit the back button or refresh the page'));

        const urlPrefix = componentConfig.TenantConfiguration.ApplicationPath !== null ?
            componentConfig.TenantConfiguration.ApplicationPath :
            '/';

        $.ajax({
            url: urlPrefix + 'TakePaymentComponentSinglePage/' + postMethod,
            type: 'POST',
            cache: false,
            dataType: 'json',
            data: dataToPost,
            success: function(result) {
                if (result.isSuccess === false) {
                    bgl.common.utilities.redirectToUrl(result.errorRedirectUrl);
                    return;
                }
                if (result.PaymentSuccessful === true) {
                    if (typeof bgl.common.pubsub !== 'undefined') {
                        bgl.common.pubsub.emit('fakeFormSubmit', 'PaymentSuccessful');
                    }
                    dataLayerPushPaymentSuccessful();
                    bgl.common.telemetry.logEvent(
                        'PaymentSuccessful',
                        {'PolicyId': result.PolicyId});
                    isPaymentSuccessful = true;

                    if (result.PolicyId) {
                        const stringValue = result.PolicyId + '';
                        let length = stringValue.indexOf('-');
                        length = length > 0 ? length : stringValue.length;
                        sessionStorage.setItem('PaymentProcessedPolicyId', stringValue.substring(0, length));
                        sessionStorage.setItem('Authorization', result.Authorization);
                    }
                }
                sessionStorage.setItem('PaymentProcessedRedirectUrl', result.RedirectUrl);
            },
            complete: function() {
                redirectInterval = setInterval(checkAiComplete, 200, componentConfig);
            },
        });
    }

    function getCommitMultiplePaymentData(componentConfig) {
        const model = {};
        model.TodaysPaymentCard = getTodaysPaymentCardData();
        model.ContinuousPaymentCard = getContinuousPaymentCardData();
        model.ContinuousPaymentDirectDebit = getDirectDebitData();
        model.PaymentType = sessionStorage.getItem('ContinuousPaymentPaymentType');
        model.PaymentDeclinedUrl = componentConfig.PaymentDeclinedUrl;
        model.ComponentConfiguration = componentConfig;
        return model;
    }

    function getCommitCardData(componentConfig) {
        const model = {};
        model.TodaysPaymentCard = getTodaysPaymentCardData();
        model.PaymentDeclinedUrl = componentConfig.PaymentDeclinedUrl;
        model.ComponentConfiguration = componentConfig;
        return model;
    }

    function getTodaysPaymentCardData() {
        const model = {};
        model.SelectedPersonIdText = sessionStorage.getItem('AnnualSelectedPersonIdText');
        model.CardCaptureUri = sessionStorage.getItem('AnnualCardCaptureUri');
        model.SecureSessionId = sessionStorage.getItem('AnnualSecureSessionId');
        model.SelectedPersonIdVal = sessionStorage.getItem('AnnualSelectedPersonIdVal');
        return model;
    }

    function dataLayerPushPaymentSuccessful() {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                'event': 'TEVirtualPageview',
                'virtualPageURL': 'Payment/Successful',
                'virtualPageTitle': 'Payment Successful',
            });
        }
    }

    function getContinuousPaymentCardData() {
        const model = {};
        model.SelectedPersonIdText = sessionStorage.getItem('ContinuousPaymentCardSelectedPersonIdText');
        model.CardCaptureUri = sessionStorage.getItem('ContinuousPaymentCardCaptureUri');
        model.SecureSessionId = sessionStorage.getItem('ContinuousPaymentCardSecureSessionId');
        model.SelectedPersonIdVal = sessionStorage.getItem('ContinuousPaymentCardSelectedPersonIdVal');
        return model;
    }

    function getDirectDebitData() {
        const model = {};
        model.SelectedPersonIdText = sessionStorage.getItem('ContinuousPaymentDirectDebitSelectedPersonIdText');
        model.SelectedPersonIdVal = sessionStorage.getItem('ContinuousPaymentDirectDebitSelectedPersonIdVal');
        model.AccountNumber = sessionStorage.getItem('ContinuousPaymentDirectDebitAccountNumber');
        model.SortCode = buildSortCode();
        return model;
    }

    function buildSortCode() {
        if (sessionStorage.getItem('ContinuousPaymentDirectDebitSortCodePart1') !== null &&
        sessionStorage.getItem('ContinuousPaymentDirectDebitSortCodePart2') !== null &&
        sessionStorage.getItem('ContinuousPaymentDirectDebitSortCodePart3') !== null) {
            return sessionStorage.getItem('ContinuousPaymentDirectDebitSortCodePart1') +
            sessionStorage.getItem('ContinuousPaymentDirectDebitSortCodePart2') +
            sessionStorage.getItem('ContinuousPaymentDirectDebitSortCodePart3');
        }

        return null;
    }

    return {
        init: initComponent,
        load: loadComponent,
        commitPaymentAndBasket: commitPaymentAndBasket,
    };
})();
﻿// eslint-disable-next-line no-var
var bgl = window.bgl || {};
bgl.components = bgl.components || {};
bgl.components.takepayment = bgl.components.takepayment || {};

bgl.components.takepayment.readonlycarddetails = (() => {
    function loadComponent(componentConfiguration, componentUrl, containerElementId) {
        componentConfiguration.CardSessionData = getSecureSessionData();

        bgl.common.loader.load(componentConfiguration,
            componentUrl,
            containerElementId,
            function() {
                initComponent(componentConfiguration);
            });
    }

    function initComponent(componentConfiguration) {
        document.getElementById('EditCardDetailsLink').addEventListener('click', (event) => {
            event.preventDefault();

            if (document.getElementById('IsMonthlyPayment').value.toLowerCase() == 'true') {
                bgl.components.takepayment.singlepagepaymentmonthlydeposit.load(
                    componentConfiguration,
                    componentConfiguration.TenantConfiguration.ApplicationPath +
                        'TakePaymentComponentSinglePage/CardCapture',
                    'TakePaymentExpandingPanelCardPaymentContent',
                    true,
                );
            } else {
                bgl.components.takepayment.singlepagepaymentannual.load(
                    componentConfiguration,
                    componentConfiguration.TenantConfiguration.ApplicationPath +
                        'TakePaymentComponentSinglePage/CardCapture',
                    'TakePaymentExpandingPanelCardPaymentContent',
                    true,
                );
            }
        });

        document.getElementById('ConfirmCardDetailsButton').addEventListener('click', (e) => {
            e.preventDefault();
            const currentExpandingPanel = document.getElementById('TakePaymentExpandingPanelCardPayment');
            const nextExpandingPanel = document.getElementById('TakePaymentExpandingPanelLegal');
            const currentHeaderStep = document.getElementById('TakePaymentHeaderCardPayment');

            bgl.components.takepayment.singlepagepaymentsummary.completePaymentStepAndContinue(
                currentExpandingPanel,
                nextExpandingPanel,
            );

            bgl.components.takepayment.singlepagepaymentsummary.updateHeaderStep(
                currentHeaderStep,
            );
        });
    }

    function getSecureSessionData() {
        if (document.getElementById('IsMonthlyPayment').value.toLowerCase() == 'true') {
            if (sessionStorage.getItem('UseMonthlyInstalmentCard') !== null &&
                sessionStorage.getItem('UseMonthlyInstalmentCard').toLowerCase() == 'true') {
                return {
                    'Name': sessionStorage.getItem('MonthlyInstalmentCardSelectedPersonIdText'),
                    'SecureSessionId': sessionStorage.getItem('MonthlyInstalmentSecureSessionId'),
                };
            }
            return {
                'Name': sessionStorage.getItem('MonthlyDepositSelectedPersonIdText'),
                'CardCaptureUri': sessionStorage.getItem('MonthlyDepositCardCaptureUri'),
                'SecureSessionId': sessionStorage.getItem('MonthlyDepositSecureSessionId'),
            };
        } else {
            return {
                'Name': sessionStorage.getItem('AnnualSelectedPersonIdText'),
                'CardCaptureUri': sessionStorage.getItem('AnnualCardCaptureUri'),
                'SecureSessionId': sessionStorage.getItem('AnnualSecureSessionId'),
                'SelectedPersonId': sessionStorage.getItem('AnnualSelectedPersonIdVal'),
                'ThreeDSecureUri': sessionStorage.getItem('AnnualThreeDSecureUri'),
            };
        }
    }

    return {
        init: initComponent,
        load: loadComponent,
    };
})();
